'use strict';

require('semantic-ui-css/semantic.min.css');
var React$1 = require('react');
var semanticUiReact = require('semantic-ui-react');
var PropTypes = require('prop-types');
var ReactDOM$1 = require('react-dom');
var reactI18next = require('react-i18next');
var redux = require('redux');
var thunkMiddleware = require('redux-thunk');
var logger = require('redux-logger');
var reactCircleFlags = require('react-circle-flags');
var axios = require('axios');
var SemanticDatepicker = require('react-semantic-ui-datepickers');
require('react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);
var React__namespace = /*#__PURE__*/_interopNamespace(React$1);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var thunkMiddleware__default = /*#__PURE__*/_interopDefaultLegacy(thunkMiddleware);
var logger__default = /*#__PURE__*/_interopDefaultLegacy(logger);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var SemanticDatepicker__default = /*#__PURE__*/_interopDefaultLegacy(SemanticDatepicker);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".primary-color{color:#008b8f !important}.btn-primary{background-color:#008b8f !important;color:#fff !important}.btn-primary.primaryBtn{background-color:#fff !important;border:1px solid #008b8f !important;color:#008b8f !important}.bgBlue{background-color:#e8f5ff !important}.capitalize{text-transform:capitalize}.uppercase{text-transform:uppercase}.font-light{font-weight:400}.text-right{text-align:right}.bgWhite{background:#fff}label{text-transform:uppercase;max-width:100%;margin-bottom:5px;overflow:hidden;white-space:nowrap}.tabContainer .main-body .test-info .entry-summary{position:relative}.errorCircleUK:hover{display:block}.errorCircleUK{color:#fff;display:block;font-size:.7rem;margin:2px;padding:3px;border-radius:50px;background-color:red;width:17px;height:17px;padding-top:1px;float:right;position:absolute;top:11px;right:-2px}.tab-contentInvoice{padding:10px 10px 10px 10px;width:100%}.tab-contentInvoice .title{padding:3px;color:#1765ae;font-size:14px;font-weight:bold}.tab-contentInvoice .title i{padding-left:4px;padding-right:5px}.productHistoryTable{width:100%}.productHistoryTable:hover h5{background-color:#20b2aa}.productHistoryTable h5{background-color:#e6f3ff}.displaySelcted i{visibility:hidden}.displaySelcted:hover i{visibility:visible}.productHistory{background-color:#fff;z-index:20;padding:3px;border-radius:3px;border:1px solid #1765ae}.productHistory .dropdownlink{cursor:pointer}.productHistory .dropdownlink:hover{background-color:#def}.tab-contentInvoiceM{padding:10px 0px 0px 0px !important;width:100%}.tab-contentInvoiceM .title{padding:3px;color:#1765ae;font-size:14px;font-weight:bold}.tab-contentInvoiceM .title i{padding-left:4px;padding-right:5px}.C88 .invoiceLoader{text-align:center;margin-top:30px !important}.C88 .absolute{position:absolute}.C88 .disabled{opacity:.7 !important}.C88 .wp-85{width:85%}.C88.disableForm,.C88.disableAll{opacity:.7 !important}.C88.disableForm input,.C88.disableForm a,.C88.disableForm i,.C88.disableForm .dropdown100,.C88.disableForm .dropdown,.C88.disableForm button,.C88.disableAll input,.C88.disableAll a,.C88.disableAll i,.C88.disableAll .dropdown100,.C88.disableAll .dropdown,.C88.disableAll button{pointer-events:none !important;opacity:.5}.C88.disableForm .partiesSection,.C88.disableAll .partiesSection{cursor:pointer !important;pointer-events:all !important}.C88.disableForm .expandAllSection,.C88.disableAll .expandAllSection{cursor:pointer !important;pointer-events:all !important}.C88 .delete-info-loader{position:absolute;left:15px;top:15px}.C88 .left-icon{margin-top:2px !important}.C88 .dropdown#fecHeaderReason div[role=option] .description,.C88 .dropdown.fecLineReason div[role=option] .description{display:inline-block !important;width:100% !important;margin-bottom:7px !important;color:#6495ed !important}.C88 .divFormFeild{width:100% !important}.C88 .divFormFeild .ui.input{position:relative;width:-webkit-fill-available}.C88 .divFormFeild .ui.input .stat-value.form-control{padding-left:13px !important}.C88 .divFormFeild .dropdown.dropdown100.goodsLocation,.C88 .divFormFeild .ui.input input.officeOfExit{border-right:1px solid !important}.C88 .divFormFeild .dropdown100.addInfoCode .menu{width:170% !important}.C88 .divFormFeild .dropdown100.addInfoCode .menu div[role=option] .text{white-space:normal !important;word-break:break-word !important}.C88 .divFormFeild.kg .ui.input::before{content:\"KG\";position:absolute;right:13px;bottom:0px;opacity:.6}.C88 .divFormFeild .ui.disabled.dropdown{opacity:1 !important}.C88 .divFormFeild .ui.disabled.dropdown .text{opacity:.45 !important;pointer-events:none !important}.C88 .divFormFeild div input{border-radius:0px 0px 0px 0px !important;margin:0 0 0px 0 !important;font-weight:600;border-bottom-width:0 !important;height:40px !important}.C88 .divFormFeild .field.floating-select{height:40px !important;margin-bottom:-2px;margin-top:0}.C88 .divFormFeild .floating-select .dropdown,.C88 .divFormFeild .dropdown{color:#000 !important;font-size:13px !important;padding:0px 14px 0px !important;min-height:40px !important}.C88 .divFormFeild .dropdown100{border-radius:0 !important;min-width:1em !important;max-width:100% !important;border:1px solid #1765ae !important;background:#fff;width:100%;min-height:34px !important;padding:6px 12px !important;font-size:13px !important;color:#d1d1d1;border-bottom:0 !important;height:40px !important}.C88 .divFormFeild .dropdown100 input{width:100% !important}.C88 .divFormFeild .dropdown100.decl-part::before{content:\"\";border-left:1px solid #1765ae;position:absolute;bottom:0;height:16px;left:-2px}.C88 .divFormFeild .dropdown100 i{position:absolute !important;right:10px;top:10px}.C88 .divFormFeild .dropdown100 .menu{width:300px !important}.C88 .divFormFeild .dropdown100 .text,.C88 .divFormFeild .dropdown100 .description{white-space:normal;width:calc(100% - 10px);color:#000 !important;overflow:hidden;margin-right:10px !important;box-sizing:border-box;line-height:19px;font-weight:600}.C88 .divFormFeild .dropdown100 .description{white-space:normal}.C88 .divFormFeild .dropdown100 .divider.text{white-space:nowrap !important}.C88 .dropdown100.addInfoCode .menu{width:300px !important}.C88 .dropdown100.addInfoCode .menu div[role=option] .text{white-space:normal !important;word-break:break-word !important}.C88 .addressField{width:100% !important;border-radius:0 !important;margin:0px 0px 0px 0px;font-weight:600}.C88 .addressField .ui.input{position:relative;width:-webkit-fill-available}.C88 .addressField .ui.input input{background-clip:content-box !important;background-color:rgba(29,83,150,.1098039216) !important;height:46px !important}.C88 .addressField.b-br-5{border-bottom-left-radius:5px !important;border-bottom-right-radius:5px !important}.C88 .addressField .field{border:0px !important}.C88 .addressField .form-control{border:0px !important}.C88 .addressField2{width:100% !important;border-radius:0 !important;margin:0px 0px 0px 0px;font-weight:600}.C88 .addressField2 .ui.input{position:relative;width:-webkit-fill-available}.C88 .addressField2 .ui.input input{background-clip:content-box !important;background-color:rgba(29,83,150,.1098039216) !important;height:46px !important}.C88 .addressField2.b-br-5{border-bottom-left-radius:5px !important;border-bottom-right-radius:5px !important}.C88 .addressField2 .field{border:0px !important}.C88 .addressField2 .form-control{border:0px !important}.C88 .c88container{margin:15px 20px 15px 20px !important}.C88 .NctsContainer{margin-top:0px !important;padding-bottom:2rem !important}.C88 .formContentareaC88{overflow-y:scroll;overscroll-behavior:contain;overflow-x:hidden;position:relative}.C88 .formContentareaC88::-webkit-scrollbar{display:hidden}.C88 .test .ui.input input{max-width:94% !important}.C88 .mg-15{margin:15px !important}.C88 .field-bg{text-transform:uppercase}.C88 .label-footer{position:absolute !important;font-size:8px !important;z-index:1;bottom:-13px;left:10px;margin-top:2px;font-weight:bolder !important}.C88 .label-address{position:absolute !important;font-size:10px !important;z-index:1;top:1px;left:10px;margin-top:2px;font-weight:bolder !important}.C88 .ui.black.box-number{background-color:#4f545a !important}.C88 .ui.black.input-box-number{background-color:#4f545a !important}.C88 .box-number{color:#fff;z-index:3;padding:3px !important;margin:0 3px 3px 1px !important;border-radius:3px}.C88 .input-box-number{color:#fff;z-index:3;padding:2px !important;font-size:8px !important;margin:0 3px 3px 1px !important;border-radius:2px !important}.C88 .fields .divFormFeild label{max-width:90% !important}.C88 .fields .divFormFeild .field label{padding-top:2px !important;padding-left:0px !important;margin-top:0px !important;font-size:10px !important;font-weight:bolder !important}.C88 .ui.dropdown>i.clear{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-align:end;-moz-box-align:end;-ms-flex-align:end;-webkit-align-items:flex-end;align-items:flex-end;color:gray !important;font-size:1rem;padding-bottom:3px !important;padding-right:5px !important}.C88 .ui.dropdown .scrolling.menu,.C88 .ui.scrolling.dropdown .menu{max-height:17rem !important}.C88 .border-bottom.b-bw-1 div input,.C88 .border-bottom.b-bw-1 .dropdown100{border-bottom:1px #1765ae solid !important}.C88 .border-bottom.b-br-5 div input,.C88 .border-bottom.b-br-5 .dropdown100{border-bottom-left-radius:5px !important;border-bottom-right-radius:5px !important}.C88 .border-bottom.b-tr-5 div input,.C88 .border-bottom.b-tr-5 .dropdown100{border-top-left-radius:5px !important;border-top-right-radius:5px !important}.C88 .border-bottom.b-tlr-5 div input,.C88 .grid-container>:first-child>.border-bottom:first-child div input,.C88 .border-bottom.b-tlr-5 .dropdown100,.C88 .grid-container>:first-child>.border-bottom:first-child .dropdown100{border-top-left-radius:5px !important}.C88 .border-bottom.b-trr-5 div input,.C88 .grid-container>:first-child>.border-bottom:nth-last-child(2) div input,.C88 .border-bottom.b-trr-5 .dropdown100,.C88 .grid-container>:first-child>.border-bottom:nth-last-child(2) .dropdown100{border-top-right-radius:5px !important}.C88 .border-bottom.b-blr-5 div input,.C88 .grid-container>:last-child>.border-bottom:first-child div input,.C88 .border-bottom.b-blr-5 .dropdown100,.C88 .grid-container>:last-child>.border-bottom:first-child .dropdown100{border-bottom-left-radius:5px !important}.C88 .border-bottom.b-brr-5 div input,.C88 .grid-container>:last-child>.border-bottom:nth-last-child(2) div input,.C88 .border-bottom.b-brr-5 .dropdown100,.C88 .grid-container>:last-child>.border-bottom:nth-last-child(2) .dropdown100{border-bottom-right-radius:5px !important}.C88 .border-bottom.border-bottom div input{border-bottom-width:1px !important}.C88 .border-bottom.border-bottom .dropdown100{border:1px solid #1765ae !important}.C88 .border-bottom.b-rw-0 div input,.C88 .border-bottom.b-rw-0 .dropdown100{border-right:0px !important}.C88 .add-info-header div{font-size:10px;left:5px;bottom:-3px}.C88 .btn-add-item{padding:8px !important;margin-top:10px}.C88 .btn-add-item-header{margin:10px 0px 0px 0px !important;width:100%;text-align:start;box-shadow:0 0 0 1px rgba(29,83,150,.1098039216) !important;text-transform:uppercase !important}.C88 .btn-show-sup-add{margin-top:30px !important;width:100%;text-align:start;box-shadow:0 0 0 1px rgba(29,83,150,.1098039216) !important;text-transform:uppercase !important}.C88 .grid .ui.grid>.row>.column{margin-top:0;margin-bottom:0;border:1px solid;margin-left:-1px}.C88 .lbl-item-count{padding:3px !important;border-radius:10px !important;display:inline-block;position:relative}.C88 .lbl-item-count span{position:relative;font-size:2px;padding:1px;border:4px solid #64646e;top:-3px;left:-2px;width:3px;border-radius:40%;margin:3px}.C88 .icon-item-deleteing{margin-left:10px;margin-top:8px;position:absolute}.C88 .icon-item-delete{margin-left:-1em;margin-top:1.4em}.C88 .icon-item-delete i{margin-top:-10px;position:absolute}.C88 .icon-delete-add-info i{top:50%;left:50%;transform:translateX(-50%) translateY(-50%)}.C88 .btn-add,.C88 .kn__accordion .action-btns .action-btn,.kn__accordion .action-btns .C88 .action-btn{border:0px !important;background:rgba(0,0,0,0) !important;padding:5px 2px 2px 2px !important;font-size:12px;color:blue;cursor:pointer}.C88 .blue.button.btn-add,.C88 .kn__accordion .action-btns .blue.button.action-btn,.kn__accordion .action-btns .C88 .blue.button.action-btn{box-shadow:0 0 0 0px !important;color:#1765ae}.C88.disableAll{background-color:#fdfafa}.C88.disableAll input,.C88.disableAll a,.C88.disableAll i,.C88.disableAll .dropdown100,.C88.disableAll .dropdown,.C88.disableAll button{cursor:not-allowed !important;pointer-events:none !important}.C88.disableAll input .partiesSection,.C88.disableAll a .partiesSection,.C88.disableAll i .partiesSection,.C88.disableAll .dropdown100 .partiesSection,.C88.disableAll .dropdown .partiesSection,.C88.disableAll button .partiesSection{cursor:pointer !important;pointer-events:all !important}.C88.disableAll input .expandAllSection,.C88.disableAll a .expandAllSection,.C88.disableAll i .expandAllSection,.C88.disableAll .dropdown100 .expandAllSection,.C88.disableAll .dropdown .expandAllSection,.C88.disableAll button .expandAllSection{cursor:pointer !important;pointer-events:all !important}.C88.disableAll .fields .ui.input input,.C88.disableAll .dropdown100 .text{color:#b5b4b4 !important}.C88.disableAll i.delete-text{cursor:not-allowed !important;pointer-events:none}.float-container{position:relative;margin:0px}.float-container .row{padding:0px !important}.float-container .row .column{padding:0px !important}.float-container.actor{margin:9px 0 15px 0 !important}.tabContainer .addressField{height:55px !important;border:1px solid #1765ae !important;display:inline-block;position:relative}.tabContainer .addressField>.column:not(.first-column) .ui.input input{padding-left:4px !important}.tabContainer .addressField2{height:55px !important;border:1px solid #1765ae !important;border-bottom:0px !important;display:inline-block;position:relative}.tabContainer .addressField2>.column:not(.first-column) .ui.input input{padding-left:4px !important}.tabContainer .ui.grid .row:not(:first-child) .divFormFeild .floating-select .dropdown100{top:0px !important}.tabContainer .divFormFeild.icon-gbp .ui.input input{padding-left:18px !important}.tabContainer .divFormFeild.icon-gbp .ui.input::before{left:10px}.tabContainer .divFormFeild .ui.input input{height:40px !important;font-size:13px !important}.tabContainer .divFormFeild .ui.search.dropdown>input.search{border-width:0px !important}.tabContainer .divFormFeild .dropdown100.decl-part{border-left:0px !important}.tabContainer .divFormFeild .floating-select .dropdown{min-height:40px !important}.mg-t-15{margin-top:15px !important}.mb-2,.float-container.mb-2{margin-bottom:.5rem !important}.icon-gbp .ui.input::before{content:\"€\";position:absolute;bottom:-1px;z-index:4}.icon-percent .ui.input::before{content:\"%\";position:absolute;bottom:-1px;z-index:4;margin-left:45px}.icon-percent2 .ui.input::before{content:\"%\";position:absolute;margin-top:12px;z-index:4;margin-left:65px}.itemsTextDecor .ui.input input{padding:15px 0px 10px 21px !important}.dropdownCarrotPosition .ui.selection.dropdown{border:0px !important}.dropdownCarrotPosition .ui.selection.dropdown>.dropdown.icon{top:23px !important;color:#000 !important}.dropdownCarrotPosition .dropdown100 .text,.dropdownCarrotPosition .dropdown100 .description{top:22px;left:5px;padding:0px 0px 0px 0px !important;margin-left:-1px;background-color:rgba(29,83,150,.1098039216) !important;color:#000 !important}.dropdownCarrotPosition .ui.disabled.dropdown{opacity:.5 !important}.dropdownCarrot .ui.selection.dropdown>.dropdown.icon{top:23px !important;margin-right:21px !important}.dropdownCarrot .dropdown100 .text,.dropdownCarrot .dropdown100 .description{top:12px;padding:0px 0px 0px 0px !important;margin-left:2px !important}.dropdownCarrot .ui.search.dropdown>.text{left:8px;color:#000 !important}.dropdownVatRate .floating-select{height:20px !important}.dropdownVatRate .floating-select .ui.selection.dropdown{min-width:11rem !important;min-height:1.714286em !important;padding:0px !important;height:20px !important;border-radius:.2px;border:1px solid #1765ae}.dropdownVatRate .floating-select .ui.search.selection.dropdown input.search{padding-top:10px !important;font-size:12px}.dropdownVatRate .floating-select .dropdown.icon{padding-top:4px !important;color:#000 !important}.dropdownVatRate .floating-select .ui.scrolling.dropdown .menu{max-width:12px}.dropdownVatRate .ui.search.dropdown>.text{left:8px;top:5px;color:#000 !important}.redBackground .floating-select{height:20px !important}.redBackground .floating-select .ui.selection.dropdown{min-width:11rem !important;min-height:1.714286em !important;padding:0px !important;height:20px !important;border-radius:.2px;border:1px solid #db2828}.redBackground .floating-select .ui.search.selection.dropdown input.search{padding-top:10px !important;font-size:12px;background:red !important;opacity:.2}.redBackground .floating-select .dropdown.icon{padding-top:4px !important;color:#000 !important}.redBackground .floating-select .ui.scrolling.dropdown .menu{max-width:12px}.redBackground .ui.search.dropdown>.text{left:8px;top:5px;color:#000 !important}.checkBoxStyle .ui.checkbox{margin-top:-10px;font-size:11px;padding-bottom:4px;margin-left:23px}.checkBoxStyle .ui.checkbox>label{max-width:100% !important}.datepicker1{position:relative !important}.datepicker1.wide.column{padding-left:0px !important}.datepicker1.wide.column .field .field{display:block}.datepicker1 .field{width:100%}.datepicker1 .field input{border-color:#1765ae !important;border:1px}.datepicker1 i{position:absolute !important;right:10px !important;top:15px;z-index:4}.datepicker1 .infoIConToolTipDatePicker{top:4px !important;left:73px}.datepicker1 div input{border-radius:0 !important;border-color:#1765ae !important;border-bottom:1px solid #1765ae !important;border-top:1px solid #1765ae !important;border-left:1px solid #1766b0 !important}.datepicker1 .entry-container .datepicker .field .field .field .ui.icon.input input,.datepicker1 .entry-container .datepicker>.field>.field .ui.icon.input input{height:40px !important}.divFormFeildZipNCTS div input{border-radius:0 !important;border-color:#1765ae !important;font-weight:600;border-bottom:1px solid #1765ae !important;border-top:1px solid #1765ae !important;border-left:1px solid #1766b0 !important}.divFormFeildZipNCTS div label{padding-top:0px !important;padding-left:0px !important}.divFormFeildZipNCTS .ui.input{width:100%}.divFormFeildZipNCTS i{position:absolute;margin-top:39px;left:-89px;margin-top:21px !important}.divFormFeildZipNCTS div .ui.icon.input input{height:40px !important}.no-field-margin .field{margin:0px !important}#total-footer{z-index:10 !important}.total-footer{position:fixed;bottom:36px;right:0px;width:100%;height:auto;background-color:#f6f3f3}.total-footer .icon-gbp{margin-left:30px;position:relative}.total-footer .icon-gbp::before{content:\"£\";position:absolute;left:-15px;z-index:40}.total-footer .box-number{background-color:#4f545a !important;font-size:7px;position:absolute;border:1px;color:#fff;position:absolute;top:-1px;left:-1px;padding:1px 2px 1px 2px !important;border:1px solid #fff;box-shadow:2px #fff}.total-footer>div{float:right;padding:0 important;background-color:rgba(0,0,0,0) !important;margin-top:20px;margin-right:30px;width:fit-content}.total-footer>div div{position:relative;display:inline-block;border-radius:3px;border:1px solid #fff;padding:4px;background-color:#1765ae !important;font-size:11px;font-weight:bold;color:#fff;bottom:8px}.total-footer>div :not(:first-child){padding-left:14px}.react-datepicker-wrapper{width:100% !important}#etd,#eta{padding-top:13px !important;width:100% !important;border:1px solid #1765ae}i.disabled{pointer-events:none;opacity:.8;cursor:not-allowed}.merch-accordian{width:7vw;min-width:100px;overflow:hidden;white-space:nowrap;margin-right:5px}.merch-accordian-valuebuildup{width:25vw;overflow:hidden !important;white-space:nowrap;margin-right:1em !important}.kn__grid{border:1px solid #1765ae}.kn__grid input[type=text],.kn__grid [type=number]{border:none !important}.kn__grid .ui search selection scrolling dropdown field-bg dropdown100{border:none !important}.kn__grid:first-child{padding:.1rem}.kn__grid:last-child{padding:.1rem}.kn__grid>.row{border-bottom:1px solid #1765ae}.kn__grid>.row div.dropdown{border:none !important}.kn__grid>.row:last-child{border-bottom:none !important}.kn__grid>.row .floating-select{margin-bottom:0rem !important}.kn__grid>.row>div{border-right:1px solid #1765ae}.kn__grid>.row>div:last-child{border-right:none}.theme-input .ui.input{width:95% !important}.theme-input .ui.input input{background-clip:content-box !important;background-color:rgba(29,83,150,.1098039216) !important;height:46px !important}.theme-input .ui.input.disabled{opacity:1 !important}.theme-dropdown{top:.1rem;background-color:rgba(0,0,0,0) !important}.theme-dropdown .icon{position:relative;top:50% !important}.theme-dropdown::before{content:\"\";position:absolute;left:0px;height:50%;width:100%;top:40%;background-color:rgba(29,83,150,.1098039216) !important;background-clip:content-box !important}.theme-textbox{width:100% !important;padding-left:.2rem;padding-right:.2rem;font-weight:600;border:none !important}.theme-textbox:not(.border-b-0){border-bottom:1px solid #1765ae !important}.theme-textbox>div{border-right:0px !important}.theme-textbox .title{position:relative;top:55%;white-space:nowrap;padding-top:0px !important;background-color:rgba(0,0,0,0) !important;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;overflow:auto;font-weight:inherit;width:max-content;min-width:max-content;font-size:10px;opacity:.8}.theme-textbox .field{flex:1;display:contents}.theme-textbox .ui.input{width:100% !important}.theme-textbox .ui.input input{background-clip:content-box !important;background-color:rgba(29,83,150,.1098039216) !important;height:46px !important}.theme-textbox .ui.input.disabled{opacity:1 !important}.row{display:flex !important}.moneyDisplayOverlay{position:absolute;z-index:1;bottom:3px;padding-right:1rem;left:15px;background-color:#fff;font-weight:bold;pointer-events:none;font-size:.95rem}.moneyDisplayOverlay.length2{left:5px;bottom:0rem}.moneyDisplayOverlay:hover{display:none}:focus~.moneyDisplayOverlay{display:none}.total-box-row .moneyDisplayOverlay{bottom:6px}.moneyDisplayOverlay .description{white-space:normal;width:calc(100% - 10px);color:#000 !important;overflow:hidden;margin-right:10px !important;box-sizing:border-box;line-height:19px;font-weight:600}.moneyDisplayOverlay .description{white-space:normal}.moneyDisplayOverlay .divider.text{white-space:nowrap !important}.half-border{border-left:0 !important;border-left:1px solid;border-image:linear-gradient(to top, #000 50%, transparent 50%) 100% 1}.taricCode:after{content:\"\";border-left:1px solid #1765ae !important;position:absolute;bottom:0px;height:50%}.mg-bottom{margin-bottom:7px !important}.opacity-50{opacity:.5}.border-none,.exchangeRatePopup .ui.input input[type=text],.exchangeRatePopup .ui.input input[type=number]{border-style:none !important}.dropdown-checkbox{background-color:#fff}.dropdown-checkbox__menu{width:100%}.dropdown-checkbox__menu--item{display:block;width:100%}.dropdown-checkbox__menu--item label{font-size:.8em;margin:auto}.dropdown-checkbox__menu--item label:before{border-color:#334d4d;transform:scale(0.8)}.dropdown-checkbox__menu--item label:after{border-color:#334d4d;transform:scale(0.8)}.dropdown-checkbox__icon>.icon{display:inline-block;z-index:1;padding:0em 1em 3em 12em}.ui.popup.containerModal{width:300px}.ui.popup.containerModal .headerStyle{display:flex;justify-content:space-between;align-items:center;font-size:15px !important;background:#000 !important;color:#fff;height:40px;padding:10px;padding-bottom:5px;border-radius:.2rem}.ui.popup.containerModal .popupHeader{height:30px}.ui.popup.containerModal .dropdownList{max-height:200px;overflow:scroll;padding-bottom:10px;background-color:rgba(136,133,133,.0392156863)}.ui.popup.containerModal .dropdownItem{display:inline-block;width:89%;margin-bottom:3px}.ui.popup.containerModal .dropdownItem .routingCountryDropdown .divider.text{height:20px !important;width:150px !important;white-space:nowrap !important;overflow:hidden !important;text-overflow:ellipsis !important;margin-top:12px !important}.ui.popup.containerModal .routingFormContainer{position:relative}.ui.popup.containerModal .routingFormContainer .routingForm{display:flex;align-items:center;position:relative}.ui.popup.containerModal .routingFormContainer .routingForm .routingForm-items{margin:0 3px;font-size:1.3em;display:inline-block;width:10%}.ui.popup.containerModal .routingFormContainer .routingForm-input{padding:2px 8px !important;height:30px;border-radius:2px !important;font-size:13px !important}.ui.popup.containerModal .routingFormContainer .insertRowIcon{position:absolute;cursor:pointer;right:5px;bottom:-6px}.col{-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-box-direction:normal;-moz-box-orient:vertical;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.wrap{-webkit-flex-wrap:wrap;flex-wrap:wrap}.nowrap{-webkit-flex-wrap:nowrap;flex-wrap:nowrap}.grow{flex-grow:1}.border-0{border-width:0 !important}.self-end{align-self:flex-end}.responsiveGridCss .formTitle{font-size:10px;vertical-align:top}.responsiveGridCss>div.formContainer{width:100%;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;padding:0px !important}.responsiveGridCss>div.formContainer>.actionbtns{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-align:center;-moz-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;margin-left:.5rem}.responsiveGridCss>div.formContainer>.actionbtns>.ui.button{white-space:nowrap}.responsiveGridCss .row{padding:0px !important;align-self:flex-start;flex-wrap:wrap;border:1px solid #1765ae}.responsiveGridCss .row>.column{padding:0px !important;flex-grow:1 !important;width:160px !important;border:1px solid #1765ae !important;margin:-1px !important;position:relative}.responsiveGridCss .row>.column>.date-field>.field{display:initial !important}.responsiveGridCss .row>.column .autoComplete-search{border-radius:initial !important;border:none !important}.responsiveGridCss .row>.column .dropdown100{border-radius:initial !important;border:none !important}.responsiveGridCss .row>.column .dropdown100>.dropdown.icon{top:50%}.responsiveGridCss .row>.column .dropdown100 .divider.text{background-clip:content-box;background-color:rgba(29,83,150,.1098039216);text-overflow:ellipsis;padding-right:5px !important}.responsiveGridCss .row>.column .ui.input{width:100%;background-color:#fff}.responsiveGridCss .row>.column .ui.input .icon{top:25%;font-size:.9rem !important}.responsiveGridCss .row>.column .ui.input input[type=text],.responsiveGridCss .row>.column .ui.input input[type=number]{border-radius:initial !important;border:none !important;background-clip:content-box;background-color:rgba(29,83,150,.1098039216);padding-right:.5rem !important;font-weight:bold}.responsiveGridCss .row>.column label{top:0px;color:#606060 !important;margin:0px}.addrepeatBtn{min-width:3.5rem;height:1.3rem;margin-top:1.4rem !important;padding:0 !important}#borderLeftNone{border-left:none !important}.popupCustomPackaging .content{width:100% !important}.popupCustomPackaging .btn-add-item{margin-top:20px !important;margin-left:-14px !important}.popupCustomPackaging .responsiveGridCss .row .column .ui input{padding:20px 6px;margin-bottom:2px !important}.borderRight{border-right:0px !important}html{--duration: 0.2s;--dark: #7a7a7a;--accent: #005c7b;scroll-behavior:smooth}.common-nav .menu{display:flex;position:relative;padding:.75rem 1rem}.common-nav .menu_items{display:flex;flex-direction:row;position:relative;left:-1.01rem}.common-nav .menu_item{padding:.1rem .3rem;margin-right:.5rem !important;font-weight:600;font-size:.8rem;transition:color .06s linear;user-select:none;color:var(--dark) !important;border-bottom:1px solid;margin:0;border-radius:0;border-left:0 !important;margin-top:-1rem !important}.common-nav .menu_item:hover{cursor:pointer;color:var(--accent) !important}.common-nav .menu-item--selected{color:var(--accent) !important}.common-nav .menu-dash{height:2px;width:40px;border-radius:50%;background:var(--accent) !important;position:absolute;bottom:0;transition:transform var(--duration),width .3s ease-in-out}.multiSelect_DropDown{display:flex !important;background:#fff !important}.dropDown-width{width:100% !important}.search__position{position:initial}.multi_search___label{display:none !important}.gb_and_eu{padding-top:10px}.packagingPopup .content{width:100% !important}.dimmer.modals.active{z-index:2000 !important}.marked-deleted input:checked~label:after{background-color:#ed3333 !important;border-radius:3px !important}.ui.checkbox.marked-deleted-label-hidden label,.ui.checkbox.marked-deleted-label-hidden input:checked~label{color:rgba(0,0,0,0) !important}.kn__tabstrip{position:relative}.kn__tabstrip__header .kn__tabstrip__items{border-right:20px solid rgba(0,0,0,0);border-left:0px solid rgba(0,0,0,0);display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;list-style:none;margin:0;padding:0;font-size:12px}.kn__tabstrip__header .kn__item{padding:.4rem 1.5rem .3rem .4rem;cursor:pointer;font-weight:bold;border-top-left-radius:.4rem;min-width:5.5rem;text-align:center;clip-path:polygon(30% 0%, 70% 0%, 72% 0, 100% 90%, 100% 100%, 30% 100%, 0 99%, 0 1%);height:26px;margin-left:3px;margin-right:-5px}.kn__tabstrip__header .kn__item:hover:not(.active) .kn__item-title{transform:translateY(50px) !important}.kn__tabstrip__header .kn__item__create{background-color:#fff;font-size:10px;padding-right:5px;margin-left:10px;margin-right:10px}.kn__tabstrip__Content{background-color:#fff;padding:.5rem;margin:5px 15px 15px 0px !important}.headerDetails{height:calc(100vh - 329px)}.headerDetails>div{margin-bottom:1rem !important}.headerDetails .errorIcon{position:initial !important}.headerDetails #postalCode{text-transform:initial !important}.transportContainer{height:calc(100vh - 329px)}.transportContainer>div{margin-bottom:.5rem !important}.transportContainer>.transportation>div{margin-bottom:.5rem !important}.additionalInfo .actionIcon{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;align-self:center}.additionalInfo .actionIcon .info.circle{margin-left:20px}.nl-date__label{position:relative !important;padding-left:14px !important}.nl-date__label-error{position:absolute !important;top:0 !important;left:0 !important}.notes{margin-top:1rem}.notes table th{top:0;position:sticky;z-index:8}.notesTab .notesHeader{margin-top:20px;margin-left:10px}.notesTab .userInfo{margin-left:5px;font-weight:bold}.notesTab .filled{padding:0 !important;outline:none !important;border:1px solid #5b9cce !important}.notesTab .empty{padding:0 !important;outline:none !important;border:1px solid red !important}.notesTab .markHot label{font-size:.8em;margin:auto}.notesTab .markHot .checkbox label:before{border-color:#334d4d;transform:scale(0.8)}.notesTab .markHot .checkbox label:after{border-color:#334d4d;transform:scale(0.8)}.notesTab .notesTable{margin-top:20px;height:300px;overflow:auto}.notesTab .notesTable .ui.table thead tr:first-child>th{position:sticky !important;top:0;z-index:2}.kn__accordion{position:relative}.kn__accordion .action-btns{margin-bottom:.3rem}.kn__accordion .action-btns>#expandCollapseAll{padding-left:.6rem}.kn__accordion__header{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-pack:justify;-moz-box-pack:justify;-ms-flex-pack:justify;-webkit-justify-content:space-between;justify-content:space-between;-webkit-box-align:start;-moz-box-align:start;-ms-flex-align:start;-webkit-align-items:flex-start;align-items:flex-start;padding:.3rem}.kn__accordion__header>.titleContainer{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex}.kn__accordion__header>.titleContainer>.toggleIcon{cursor:pointer}.kn__accordion__item{margin-bottom:.5rem}.kn__accordion__item.inactive{border-radius:.2rem;border:1px solid #1765ae;background-color:#f6f6f6}.parties{height:calc(100vh - 329px)}.parties>div{margin-bottom:1rem !important}.parties .kn__accordion__item .action-btns{position:relative}.parties .kn__accordion__item .action-btns .action-btn:not(:first-child)::before{content:\"|\";position:relative;left:-4px}.copyToContainer{padding-right:2rem}.copyToContainer div.checkbox{display:block !important}.container{margin-top:1rem}.container-title{text-align:center;align-items:center;text-transform:uppercase;margin-bottom:1rem}.container-box{width:100%;min-height:3rem;border-radius:5px}div[role=option].disabled{display:none !important}.lineContainer{width:100%;background-color:#fff;border:1px solid #1765ae;border-radius:0 0 5px 5px}.lineContainer .label-no{color:#fff;background-color:#4f545a;height:14px;width:14px;font-size:8px !important;margin-top:4px !important;margin-right:4px;align-items:center;justify-content:center;text-align:center;align-self:center;padding:2px !important;white-space:pre}.lineContainer .lineContainer-label{font-size:10px;padding-left:8px;background-color:#fff;color:#000}.lineContainer .lineContainer-btn{color:#1765ae;font-size:9px;padding:.5rem !important;border:1px solid #1765ae;text-align:center;position:relative;background-color:rgba(0,0,0,0);margin-bottom:5px !important}.lineContainer .container-no-list{width:400px;min-width:20px;overflow:scroll}#htsMetadataModal.ui.modal.htsMetadataModal .ui .checkbox label,#htsMetadataModal.ui.modal.htsMetadataModal .ui .radio label{font-size:12px !important}#htsMetadataModal.ui.modal.htsMetadataModal .row{margin:0px !important}.duty-total{width:60.5vw !important;margin-top:5px;margin-bottom:15px}.datePicker .field{display:block !important}.billable-label{border:1px solid #1765ae;border-radius:0 5px 5px 0;height:40px !important;font-size:10px !important;z-index:1;padding-left:5px;padding-top:2px;font-weight:bolder !important;word-wrap:break-word !important;text-transform:uppercase !important}.valueBuildUp{height:calc(100vh - 329px)}.valueBuildUp .float-container>div{margin-bottom:1rem}.valueBuildUp .proprateBtn{margin-top:5rem;margin-bottom:1rem}.valueBuildUp .prorateForm{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;gap:.3rem}.valueBuildUp .prorateForm>.kn__grid{flex:1}.valueBuildUp .prorateForm .proratedApplied{margin:.5rem !important}.valueBuildUp .partiesInfo>div{margin-bottom:1rem !important}.valueBuildUp .defaultValues .kn__grid .radio{width:50px !important}.valueBuildUp .defaultValues .kn__grid .radio input[type=radio]+label{padding-left:20px !important;font-size:.8em}.valueBuildUp .dependencies>.checkbox>label{white-space:pre-wrap;max-width:fit-content}.valueBuildUp .ProrateWeight__content{margin-top:0px !important}.valueBuildUp .ProrateWeight__checkList{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-box-direction:normal;-moz-box-orient:vertical;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}#htsMetadataModal.ui.modal.htsMetadataModal .ui .checkbox label,#htsMetadataModal.ui.modal.htsMetadataModal .ui .radio label{white-space:pre-line}.vbu .negative-input-value{background-color:#ee0606 !important;color:#fff !important}.vbu .label{color:#fff !important}.vbu .label .vbu-input{color:#fff !important}.vbu .positive-input-value{background-color:#089403 !important;color:#fff !important}.vbu .positive-input-value.ui.input>input{background-color:rgba(0,0,0,0) !important;color:#fff !important}.vbu .negative-input-value.ui.input>input{background-color:rgba(0,0,0,0) !important;color:#fff !important}.greenBg{background-color:green !important;background-clip:unset !important;opacity:1 !important}.greenBg.column .ui.input input[type=text],.greenBg.column .ui.input input[type=number],.redBg.column .ui.input input[type=text],.redBg.column .ui.input input[type=number]{color:#fff !important;font-weight:400}.redBg{background-color:red !important;background-clip:unset !important;opacity:1 !important}.responsiveGridCss .row>.column.greenBg label,.responsiveGridCss .row>.column.redBg label{top:0px;color:#fff !important;margin:0px}.ProrateWeight__checkList>.grid>.row>.checkbox>label{text-wrap:inherit}.pl-2{padding-left:20px}.text-align-start{text-align:start}#exchangeRatesContainer>.exchangeRates,#refreshData>.exchangeRates{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;gap:1rem}#exchangeRatesContainer>.exchangeRates>.ui.label,#refreshData>.exchangeRates>.ui.label{width:max-content;border:1px solid rgba(151,151,151,.34)}#exchangeRatesContainer>.exchangeRates>.button,#refreshData>.exchangeRates>.button{width:max-content}#exchangeRatesContainer div.ui.red,#refreshData div.ui.red{border:none !important;background-color:rgba(0,0,0,0) !important}.exchangeRatePopup{max-width:90%;width:max-content !important;top:30px}.exchangeRatePopup .content{width:100% !important}.exchangeRatePopup .ui.table thead tr:first-child>th{z-index:2}.exchangeRatePopup .ui.loader::before{border:.2em solid rgba(0,0,0,.1) !important}.exchangeRatePopup .container__table{height:300px;overflow:auto}.exchangeRatePopup .container__table div.ui.red{border:none !important;background-color:rgba(0,0,0,0) !important}.exchangeRatePopup .field{display:block !important}.exchangeRatePopup .field>.floating-date-label{left:initial !important;top:0px !important}.exchangeRatePopup .field>.dropdown{background-color:rgba(0,0,0,0)}.exchangeRatePopup .ui.input{display:block !important}.exchangeRatePopup .ui.input input[type=text],.exchangeRatePopup .ui.input input[type=number]{background-color:rgba(0,0,0,0)}.exchangeRatePopup .icon{cursor:pointer}.errors-server{bottom:10px;width:100%}.errors-server span{color:red;cursor:pointer}.errors-server__button{display:inline-block;width:75%;background-color:red;height:3px;margin-top:3px;margin-bottom:3px;margin-left:10px}.errors-server__button--icon{display:\"inline\"}.errors-server__display--box h5{text-transform:uppercase;font-size:12px;margin-top:10px;margin-bottom:4px}.errors-server__display--box div{margin-left:10px}.errors-server__display--box div a{display:block;font-size:11px;color:var(--color-server-err)}.errors-server__display--box div a:hover{color:blue !important;text-decoration:underline}.fileUploadPopup{width:80% !important;top:30px}.fileUploadPopup .content{width:100% !important}.fileUploadPopup .ui.text.loader{color:#000 !important}.fileUploadPopup .ui.loader::before{border:.2em solid rgba(0,0,0,.1) !important}.fileUploadPopup .parentDiv{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;justify-content:space-between}.fileUploadPopup .parentDiv .documentList{width:50%}.fileUploadPopup .parentDiv .documentList .renderList{height:420px;overflow-y:scroll;padding:5px}.fileUploadPopup .parentDiv .documentList .renderList .listView{cursor:pointer;padding:10px}.fileUploadPopup .parentDiv .documentList .renderList .selectedDoc{background-color:#b3ffb3}.fileUploadPopup .parentDiv .documentList .renderList .documentOptions{background-color:#f0f5f5}.fileUploadPopup .parentDiv .documentList .renderList .documentOptions:hover{background-color:#ffffb3 !important}.fileUploadPopup .parentDiv .zoom-buttons{height:20%;width:65px !important;padding-top:7%;margin-top:16%}.fileUploadPopup .parentDiv .zoom-buttons input[type=range][orient=vertical]{writing-mode:bt-lr;-webkit-appearance:slider-vertical;width:8px;height:100%;padding:0 1px;cursor:pointer;margin-right:4%;margin:25% 4% 10% 0;box-shadow:none}.fileUploadPopup .parentDiv .zoom-buttons .zoom-slider-container{height:65%}.fileUploadPopup .parentDiv .zoom-buttons .slider-container{display:flex;justify-content:center;align-items:center;padding:2px 0 2px 0;height:100%;position:relative}.fileUploadPopup .parentDiv .zoom-buttons .slider-container i{position:absolute;right:0;top:40%;cursor:pointer}.fileUploadPopup .parentDiv .zoom-buttons .zoom-slider-btn{width:100%;display:flex;justify-content:center;align-items:center;cursor:pointer}.fileUploadPopup .parentDiv .imagePreview{width:48%;height:420px;text-align:center;border:1px solid #026c6f;border-radius:4px;margin:5px;padding:10px}.fileUploadPopup .parentDiv .imagePreview .zoomable{height:100%;overflow:scroll}.fileUploadPopup .parentDiv .imagePreview .pagination{margin-top:20px}.fileUploadPopup .parentDiv .imagePreview img{width:100%;transform-origin:left top}.fileUploadHistoryPopup{width:70% !important;top:50px}.fileUploadHistoryPopup .content{width:100% !important}.fileUploadHistoryPopup .historyTable{height:300px;overflow:auto}.fileUploadHistoryPopup .historyTable div.ui.red{border:none !important;background-color:rgba(0,0,0,0) !important}.fileUploadHistoryPopup .historyTable .ui.table thead tr:first-child>th{position:sticky !important;top:0;z-index:2}#emergencyDocumentContainer{position:absolute;top:50px;right:10px;z-index:1}#emergencyDocumentContainer div.ui.red{border:none !important;background-color:rgba(0,0,0,0) !important}#emergencyDocumentContainer>.emergencyDocument>.button{border:1px solid #267678 !important;color:#267678 !important}.emergencyDocumentPopup{max-width:90% !important;width:1260px !important;top:10%}.emergencyDocumentPopup .content{width:100% !important}.emergencyDocumentPopup .container__table{height:360px;overflow:auto}.emergencyDocumentPopup .container__table div.ui.red{border:none !important;background-color:rgba(0,0,0,0) !important}.emergencyDocumentPopup .ui.table thead tr:first-child>th{z-index:2}.emergencyDocumentPopup input:checked~label:after{border-radius:3px !important}.emergencyDocumentPopup .ui.checkbox label,.emergencyDocumentPopup .ui.checkbox input:checked~label{color:rgba(0,0,0,0) !important}.ccs-air-container__popup{width:90% !important;height:80vh !important;top:20px}.ccs-air-container__popup .content{width:100% !important}.ccs-air-container__popup .content .description{max-height:75vh;overflow-y:auto}.ccs-air-container>button{padding:9px 20px !important}.bg-color-lighgray{background-color:#d3d3d3 !important}.cursor-pointer-default{cursor:default}.cursor-pointer{cursor:pointer}.pointer-events-none{pointer-events:none}.table-wrapper{max-height:80vh !important;overflow-x:auto;border:1px solid rgba(34,36,38,.15);border-radius:5px;padding:0px;max-height:500px;font-size:12px;position:relative}.table-wrapper .icon-header-sort{display:inline;padding:0px !important;color:#008b8b}.table-wrapper::-webkit-scrollbar{-webkit-appearance:auto;display:block !important}.table-wrapper .table-filters{display:flex;flex-direction:row;align-items:center;gap:5px;cursor:pointer}.table-wrapper table{border:none !important;margin:0 !important;width:100% !important}.table-wrapper table>thead{z-index:2;position:sticky;top:0px}.table-wrapper table>tbody>tr{cursor:pointer}.table-wrapper table>tfoot{position:sticky;bottom:0px}.table-wrapper table thead tr th,.table-wrapper table tbody tr td{padding:5px 10px !important}.ccs-air_response{margin-top:24px}.ccs-air_response .res-table-wrap .res-table thead th{z-index:1;padding:0px !important}.ccs-custom-loader{position:absolute;width:100%;height:100%;left:0px;top:0px;display:flex;justify-content:center;opacity:.2;align-items:center;font-size:18px;background-color:#d3d3d3 !important}\n";
styleInject(css_248z$2);

function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});
var lodash_1 = lodash.isEqual;
var lodash_2 = lodash.get;
var lodash_3 = lodash.uniq;
lodash.map;

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _defineProperty$1(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toArray(r) {
  return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest();
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Logger);
    this.init(concreteLogger, options);
  }
  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.observers = {};
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
    obj = _getLastOfPath.obj,
    k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
    obj = _getLastOfPath2.obj,
    k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
    obj = _getLastOfPath3.obj,
    k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);
  var _super = _createSuper$3(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    _classCallCheck(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);
  var _super = _createSuper$2(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (_typeof(options) === 'object') options = _objectSpread$4({}, options);
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _this$extractFromKey.key,
        namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: "".concat(namespace).concat(nsSeparator).concat(key),
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace
            };
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function deepFindWithDefaults(data, defaultData, key) {
  var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
          _opt$split2 = _toArray(_opt$split),
          key = _opt$split2[0],
          rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val, opt.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
          formatName = _parseFormatStr.formatName,
          formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);
  var _super = _createSuper$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (n) {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(function (data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
          isUpdate: isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);

function get$3() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function noop() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get$3();
      this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function (k) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = options.lng || this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get$3());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
_defineProperty$1(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

const ValidateError$1 = ({
  serverErrors
}) => {
  const [hideError, hideErrorList] = React$1.useState(false);
  let lang = instance.language || window.localStorage.i18nextLng || 'en';
  let serverWarningList = serverErrors.filter(item => {
    return item.fieldmessagetype === 'WARNING' || item.fieldMessageType === 'WARNING';
  });
  let zeroServerErrors = serverErrors.filter(item => {
    return item.fieldmessagetype === 'SUCCESS' || item.fieldMessageType === 'SUCCESS';
  });
  let failServerError = serverErrors.filter(item => {
    return item.fieldmessagetype === 'FAIL' || item.fieldMessageType === 'FAIL';
  });
  let errorName = failServerError.length && serverWarningList.length ? 'Warnings and Errors' : failServerError.length ? 'Errors' : 'Warnings';
  (serverWarningList === null || serverWarningList === void 0 ? void 0 : serverWarningList.length) && !failServerError.length;
  if (zeroServerErrors.length && !serverWarningList.length) {
    return /*#__PURE__*/React__default["default"].createElement("div", null);
  }
  if (serverWarningList.length || failServerError.length || []) {
    return serverErrors.length > 0 && /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        bottom: '10px',
        width: "100%"
      }
    }, hideError === true ? /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: 'red',
        cursor: 'pointer'
      },
      onClick: () => {
        hideErrorList(false);
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        display: 'inline-block',
        width: '75%',
        backgroundColor: '#ff0000',
        height: '3px',
        marginTop: '3px',
        marginBottom: '3px',
        marginleft: '10px'
      }
    }), "\xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus circle",
      style: {
        display: 'inline'
      }
    }), "Expand Error") : /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: 'red',
        cursor: 'pointer'
      },
      onClick: () => {
        hideErrorList(true);
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        display: 'inline-block',
        width: '75%',
        backgroundColor: '#ff0000',
        height: '3px',
        marginTop: '3px',
        marginBottom: '3px',
        marginleft: '10px'
      }
    }), "\xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "minus circle",
      style: {
        display: 'inline'
      }
    }), "Collapse Error"), serverErrors && hideError === false && /*#__PURE__*/React__default["default"].createElement("div", {
      className: 'todo-validation-error'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, {
      negative: true
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Header, null, "There were some ", errorName, " with your submission:", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("br", null)), serverErrors.map((errorItem, index) => {
      if (['FAIL', 'WARNING'].includes(errorItem.fieldmessagetype) || ['FAIL', 'WARNING'].includes(errorItem.fieldMessageType)) {
        let messageKeyType = 'fieldMessage';
        let fieldMsgType = 'fieldMessageType';
        if (errorItem.fieldmessagetype) {
          messageKeyType = "fieldmessage";
          fieldMsgType = "fieldmessagetype";
        }
        let messageKey = lang !== 'en' ? `fieldmessage_${lang}` : `${messageKeyType}`;
        let invoiceIndex = errorItem['invoiceNumber'] === '0' || errorItem['invoiceNumber'] && errorItem['invoiceNumber'] > -1 ? `Invoice 00${parseInt(errorItem['invoiceNumber']) + 1} :: ` : '';
        let lineIndex = errorItem['merchandiseNumber'] === '0' || errorItem['merchandiseNumber'] && errorItem['merchandiseNumber'] > -1 ? `Line 00${parseInt(errorItem['merchandiseNumber']) + 1} :: ` : '';
        let number = invoiceIndex + lineIndex;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: `${errorItem[fieldMsgType].toLowerCase()}-msg`,
          key: index + '-server-error',
          style: {
            marginBottom: '5px'
          }
        }, errorItem[fieldMsgType] === 'WARNING' ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning sign",
          size: "small",
          color: "orange"
        }) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning circle",
          size: "small",
          color: "red"
        }), number + errorItem[messageKey]);
      }
    })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      className: "todo-error-close",
      name: "close",
      onClick: () => hideErrorList(true)
    })));
  }
};

var validateError = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ValidateError: ValidateError$1
});

var ReactReduxContext = /*#__PURE__*/React__default["default"].createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React$1.useLayoutEffect : React$1.useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = React$1.useMemo(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = React$1.useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default["default"].createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: PropTypes__default["default"].shape({
      subscribe: PropTypes__default["default"].func.isRequired,
      dispatch: PropTypes__default["default"].func.isRequired,
      getState: PropTypes__default["default"].func.isRequired
    }),
    context: PropTypes__default["default"].object,
    children: PropTypes__default["default"].any
  };
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$2=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$1=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$2=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$2=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$2=b$2?Symbol.for("react.memo"):60115,t$1=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$2=b$2?Symbol.for("react.fundamental"):60117,x$2=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$2:case e$1:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$2:case t$1:case r$2:case h$2:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$2(a)===m$2}var AsyncMode=l$2;var ConcurrentMode=m$2;var ContextConsumer$1=k$2;var ContextProvider$1=h$2;var Element$1=c$2;var ForwardRef$1=n$2;var Fragment$1=e$1;var Lazy$1=t$1;var Memo$1=r$2;var Portal$1=d$2;
var Profiler$1=g$2;var StrictMode$1=f$2;var Suspense$1=p$2;var isAsyncMode$1=function(a){return A$2(a)||z$2(a)===l$2};var isConcurrentMode$1=A$2;var isContextConsumer$1=function(a){return z$2(a)===k$2};var isContextProvider$1=function(a){return z$2(a)===h$2};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};var isForwardRef$1=function(a){return z$2(a)===n$2};var isFragment$1=function(a){return z$2(a)===e$1};var isLazy$1=function(a){return z$2(a)===t$1};
var isMemo$1=function(a){return z$2(a)===r$2};var isPortal$1=function(a){return z$2(a)===d$2};var isProfiler$1=function(a){return z$2(a)===g$2};var isStrictMode$1=function(a){return z$2(a)===f$2};var isSuspense$1=function(a){return z$2(a)===p$2};
var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$2||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$2||a.$$typeof===n$2||a.$$typeof===w$2||a.$$typeof===x$2||a.$$typeof===y$2||a.$$typeof===v$2)};var typeOf$1=z$2;

var reactIs_production_min$1 = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$1,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$1,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

var reactIs_development$1 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development$1.AsyncMode;
reactIs_development$1.ConcurrentMode;
reactIs_development$1.ContextConsumer;
reactIs_development$1.ContextProvider;
reactIs_development$1.Element;
reactIs_development$1.ForwardRef;
reactIs_development$1.Fragment;
reactIs_development$1.Lazy;
reactIs_development$1.Memo;
reactIs_development$1.Portal;
reactIs_development$1.Profiler;
reactIs_development$1.StrictMode;
reactIs_development$1.Suspense;
reactIs_development$1.isAsyncMode;
reactIs_development$1.isConcurrentMode;
reactIs_development$1.isContextConsumer;
reactIs_development$1.isContextProvider;
reactIs_development$1.isElement;
reactIs_development$1.isForwardRef;
reactIs_development$1.isFragment;
reactIs_development$1.isLazy;
reactIs_development$1.isMemo;
reactIs_development$1.isPortal;
reactIs_development$1.isProfiler;
reactIs_development$1.isStrictMode;
reactIs_development$1.isSuspense;
reactIs_development$1.isValidElementType;
reactIs_development$1.typeOf;

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1=60103,c$1=60106,d$1=60107,e=60108,f$1=60114,g$1=60109,h$1=60110,k$1=60112,l$1=60113,m$1=60120,n$1=60115,p$1=60116,q$1=60121,r$1=60122,u$1=60117,v$1=60129,w$1=60131;
if("function"===typeof Symbol&&Symbol.for){var x$1=Symbol.for;b$1=x$1("react.element");c$1=x$1("react.portal");d$1=x$1("react.fragment");e=x$1("react.strict_mode");f$1=x$1("react.profiler");g$1=x$1("react.provider");h$1=x$1("react.context");k$1=x$1("react.forward_ref");l$1=x$1("react.suspense");m$1=x$1("react.suspense_list");n$1=x$1("react.memo");p$1=x$1("react.lazy");q$1=x$1("react.block");r$1=x$1("react.server.block");u$1=x$1("react.fundamental");v$1=x$1("react.debug_trace_mode");w$1=x$1("react.legacy_hidden");}
function y$1(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$1:switch(a=a.type,a){case d$1:case f$1:case e:case l$1:case m$1:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$1:case p$1:case n$1:case g$1:return a;default:return t}}case c$1:return t}}}var z$1=g$1,A$1=b$1,B$1=k$1,C=d$1,D$1=p$1,E$1=n$1,F$1=c$1,G$1=f$1,H$1=e,I$1=l$1;var ContextConsumer=h$1;var ContextProvider=z$1;var Element=A$1;var ForwardRef=B$1;var Fragment=C;var Lazy=D$1;var Memo=E$1;var Portal=F$1;var Profiler=G$1;var StrictMode=H$1;
var Suspense=I$1;var isAsyncMode=function(){return !1};var isConcurrentMode=function(){return !1};var isContextConsumer=function(a){return y$1(a)===h$1};var isContextProvider=function(a){return y$1(a)===g$1};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$1};var isForwardRef=function(a){return y$1(a)===k$1};var isFragment=function(a){return y$1(a)===d$1};var isLazy=function(a){return y$1(a)===p$1};var isMemo=function(a){return y$1(a)===n$1};
var isPortal=function(a){return y$1(a)===c$1};var isProfiler=function(a){return y$1(a)===f$1};var isStrictMode=function(a){return y$1(a)===e};var isSuspense=function(a){return y$1(a)===l$1};var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$1||a===e||a===l$1||a===m$1||a===w$1||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===u$1||a.$$typeof===q$1||a[0]===r$1)?!0:!1};
var typeOf=y$1;

var reactIs_production_min = {
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
var reactIs_1 = reactIs.isValidElementType;
var reactIs_2 = reactIs.isContextConsumer;

var _excluded$2 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, _excluded$2);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !reactIs_1(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? React$1.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = React$1.useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = React$1.useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs_2( /*#__PURE__*/React__default["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = React$1.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = React$1.useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = React$1.useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = React$1.useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = React$1.useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = React$1.useRef();
      var lastWrapperProps = React$1.useRef(wrapperProps);
      var childPropsFromStoreUpdate = React$1.useRef();
      var renderIsScheduled = React$1.useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = React$1.useMemo(function () {
        return /*#__PURE__*/React__default["default"].createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = React$1.useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React__default["default"].createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React__default["default"].memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React__default["default"].forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React__default["default"].createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$2(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$2(value)) {
    warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

var _excluded$1 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, _excluded$1);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/createConnect();

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = React$1.useContext(ReactReduxContext);

  if (process.env.NODE_ENV !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return React$1.useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore$1 = context === ReactReduxContext ? useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore$1();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = React$1.useReducer(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = React$1.useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = React$1.useRef();
  var latestSelector = React$1.useRef();
  var latestStoreState = React$1.useRef();
  var latestSelectedState = React$1.useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return React$1.useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    React$1.useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

// with standard React renderers (ReactDOM, React Native)

setBatch(ReactDOM$1.unstable_batchedUpdates);

const getDomElementId = (tab, error) => {
  if (tab === 'header' && error !== null && error !== void 0 && error.listType) return `#header-${error === null || error === void 0 ? void 0 : error.listType}`;
  if (tab === 'transport' && error !== null && error !== void 0 && error.listType) return `#${error === null || error === void 0 ? void 0 : error.listType}`;
  if (tab === 'items' && (error === null || error === void 0 ? void 0 : error.listType) === "packagesList" && !(error !== null && error !== void 0 && error.fieldId)) return `#${error === null || error === void 0 ? void 0 : error.listType}.toBeHighlight-${error === null || error === void 0 ? void 0 : error.invoiceId}-${error === null || error === void 0 ? void 0 : error.merchandiseId}`;
  if (tab === 'items' && error !== null && error !== void 0 && error.listType) return `#${error === null || error === void 0 ? void 0 : error.invoiceId}-${error === null || error === void 0 ? void 0 : error.merchandiseId}-${error === null || error === void 0 ? void 0 : error.listType}`;
  if (tab === 'items' && !(error !== null && error !== void 0 && error.merchandiseId)) return `#expandCollapseInvoice-${error === null || error === void 0 ? void 0 : error.invoiceId}`;
  if (tab === 'items' && error !== null && error !== void 0 && error.merchandiseId) return `#expandCollapseMerch-${error === null || error === void 0 ? void 0 : error.merchandiseId}`;
  return `#${error === null || error === void 0 ? void 0 : error.fieldName}`;
};
const DisplayErrorServer = ({
  serverErrors,
  handleErrorFocus
}) => {
  var _Object$entries;
  let lang = instance.language || window.localStorage.i18nextLng || 'en';
  const [displayError, setDisplayError] = React$1.useState(true);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "errors-server"
  }, displayError ? /*#__PURE__*/React__default["default"].createElement("span", {
    onClick: () => setDisplayError(false)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "errors-server__button"
  }), " \xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "minus circle",
    className: "errors-server__button--icon"
  }), " Collapse Error") : /*#__PURE__*/React__default["default"].createElement("span", {
    onClick: () => setDisplayError(true)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "errors-server__button"
  }), " \xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "plus circle",
    className: "server-error__button--icon"
  }), " Expand Error"), displayError && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "errors-server__display todo-validation-error"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, {
    negative: true,
    style: {
      paddingTop: '5px',
      height: '200px'
    }
  }, (_Object$entries = Object.entries(serverErrors)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(([tab, errorList], index) => {
    if ((errorList === null || errorList === void 0 ? void 0 : errorList.length) > 0) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: index,
        className: "errors-server__display--box"
      }, /*#__PURE__*/React__default["default"].createElement("h5", null, tab), /*#__PURE__*/React__default["default"].createElement("div", null, errorList === null || errorList === void 0 ? void 0 : errorList.map((error, idx) => {
        const domElementId = getDomElementId(tab, error) || '';
        return /*#__PURE__*/React__default["default"].createElement("a", {
          key: idx,
          href: `${domElementId}`,
          onClick: () => {
            const tabs = document.getElementById(`${tab}Tab`);
            tabs && (tabs === null || tabs === void 0 ? void 0 : tabs.click());
            handleErrorFocus(tab, error);
          },
          style: {
            '--color-server-err': (error === null || error === void 0 ? void 0 : error.fieldmessageType) === 'WARNING' ? '#CC5500' : '#ff0000'
          }
        }, idx + 1, ".  ", (error === null || error === void 0 ? void 0 : error.fieldmessageType) === 'WARNING' ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning sign",
          size: "small",
          color: "orange"
        }) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning circle",
          size: "small",
          color: "red"
        }), lang !== 'en' ? error === null || error === void 0 ? void 0 : error.translation : error === null || error === void 0 ? void 0 : error.fieldmessage);
      })));
    }
  }))));
};

const configuration = {
  "GB": {
    "SKIP_PDF": true
  },
  "NL": {
    "SKIP_PDF": false
  },
  "ES": {
    "shouldGeneratePDF": ({
      version,
      transmissionType
    }) => {
      if (version === 'AES') {
        return version !== 'AES' || transmissionType === 'NEW' || transmissionType === 'MOD';
      }
      return true;
    }
  }
};

const EUAcknowledgementPage = ({
  translate,
  handleLegalAcknowledgement,
  loadShipment,
  euPdf,
  handleGeneratePdf,
  countryCheck,
  transmissionType,
  version
}) => {
  var _serverErrorsCommon$h, _serverErrorsCommon$p, _serverErrorsCommon$i, _serverErrorsCommon$t;
  React$1.useState(true);
  React$1.useState(1);
  const [accepted, setAccepted] = React$1.useState(false);
  React$1.useState(false);
  React$1.useState(false);
  configuration[countryCheck]['SKIP_PDF'];
  const countryConfig = configuration[window.shipmentCountry];
  const serverErrors = useSelector(state => {
    var _state$ServerErrorRed;
    return state === null || state === void 0 ? void 0 : (_state$ServerErrorRed = state.ServerErrorReducer) === null || _state$ServerErrorRed === void 0 ? void 0 : _state$ServerErrorRed.serverErrors;
  });
  const serverErrorsCommon = useSelector(state => state === null || state === void 0 ? void 0 : state.serverErrorReducerCommon);
  const isServerErrorsCommon = !!(serverErrorsCommon !== null && serverErrorsCommon !== void 0 && (_serverErrorsCommon$h = serverErrorsCommon.header) !== null && _serverErrorsCommon$h !== void 0 && _serverErrorsCommon$h.length) || !!(serverErrorsCommon !== null && serverErrorsCommon !== void 0 && (_serverErrorsCommon$p = serverErrorsCommon.parties) !== null && _serverErrorsCommon$p !== void 0 && _serverErrorsCommon$p.length) || !!(serverErrorsCommon !== null && serverErrorsCommon !== void 0 && (_serverErrorsCommon$i = serverErrorsCommon.items) !== null && _serverErrorsCommon$i !== void 0 && _serverErrorsCommon$i.length) || !!(serverErrorsCommon !== null && serverErrorsCommon !== void 0 && (_serverErrorsCommon$t = serverErrorsCommon.transport) !== null && _serverErrorsCommon$t !== void 0 && _serverErrorsCommon$t.length);
  React$1.useEffect(() => {
    var scrollComponent = window;
    document.addEventListener('scroll', function (e) {
      scrollComponent.toggleVisibility();
    });
  }, []);
  const handleAcceptAcknowledgement = () => {
    setAccepted(true);
    handleLegalAcknowledgement();
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    id: "tabContainer",
    className: "tabContainer",
    style: {
      width: '100% !important'
    }
  }, serverErrors && window.shipmentCountry !== 'GB' && /*#__PURE__*/React__default["default"].createElement(ValidateError$1, {
    serverErrors: serverErrors
  }), isServerErrorsCommon && window.shipmentCountry === 'GB' && /*#__PURE__*/React__default["default"].createElement(DisplayErrorServer, {
    serverErrors: serverErrorsCommon,
    handleErrorFocus: () => {}
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "main-body acknowledgement-form"
  }, !countryConfig.SKIP_PDF && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "legal-text"
  }, translate('ACKNOWLEDGEMENT_TEXT'), /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    color: !accepted ? 'blue' : 'green',
    compact: true,
    right: "true",
    onClick: handleAcceptAcknowledgement,
    floated: "right"
  }, !accepted ? translate('ACCEPT') : translate('ACCEPTED'), accepted && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "check"
  }))), /*#__PURE__*/React__default["default"].createElement("center", null, (!countryConfig.shouldGeneratePDF || countryConfig.shouldGeneratePDF({
    version,
    transmissionType
  })) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "pdf-7501"
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("h3", {
    style: {
      float: 'left',
      marginLeft: '20px'
    }
  }, "PDF Form: "), euPdf && handleGeneratePdf !== '1' ? /*#__PURE__*/React__default["default"].createElement("iframe", {
    scrolling: 'yes',
    src: euPdf,
    height: "800",
    width: "100%"
  }) : /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      color: 'red'
    }
  }, "Failed to generate PDF..."))))));
};
var EUAcknowledgementPage$1 = /*#__PURE__*/React__default["default"].memo(EUAcknowledgementPage);

const LongText = ({
  content,
  limit,
  showTooltip
}) => {
  const [showAll, setShowAll] = React$1.useState(false);
  const showMore = () => setShowAll(true);
  const showLess = () => setShowAll(false);
  if (content.length <= limit) {
    // there is nothing more to show
    return /*#__PURE__*/React__default["default"].createElement("div", null, content);
  }
  if (showAll) {
    // We show the extended text and a link to reduce it
    return /*#__PURE__*/React__default["default"].createElement("div", null, content, /*#__PURE__*/React__default["default"].createElement("a", {
      href: "#",
      onClick: showLess
    }, "Read less"));
  }
  // In the final case, we show a text with ellipsis and a `Read more` button
  const toShow = content ? content.substring(0, limit) + "..." : "";
  return /*#__PURE__*/React__default["default"].createElement("div", {
    title: showTooltip ? content : ''
  }, toShow, !showTooltip && /*#__PURE__*/React__default["default"].createElement("a", {
    href: "#",
    onClick: showMore
  }, "Read more"));
};

function DynamicTable(props) {
  const TableData = props.TableData;

  // get table column
  const column = TableData.length ? TableData[0] ? Object.keys(TableData[0]) : [] : [];
  //console.log('column', column)
  // get table heading data
  const ThData = () => {
    return column.map(data => {
      return /*#__PURE__*/React__default["default"].createElement("th", {
        key: data,
        style: {
          fontSize: '10px',
          width: 'none',
          border: "1px solid #000",
          "background": "#ccc",
          "position": "inherit"
        }
      }, /*#__PURE__*/React__default["default"].createElement("b", null, decamelize(data)));
    });
  };

  // get table row data
  const tdData = () => {
    return TableData.map((data, index) => {
      return /*#__PURE__*/React__default["default"].createElement("tr", {
        key: `${index}-TR`
      }, column.map(v => {
        console.log(data[v]);
        return /*#__PURE__*/React__default["default"].createElement("td", {
          style: {
            textAlign: 'center',
            width: 'fit-content',
            overflowWrap: "anywhere",
            padding: '10px',
            border: "1px solid #000"
          }
        }, Array.isArray(data[v]) && typeof data[v][0] === "object" ? /*#__PURE__*/React__default["default"].createElement(DynamicTable, {
          TableData: data[v]
        }) : data[v] && JSONDisplayer(data[v]));
      }));
    });
  };
  return /*#__PURE__*/React__default["default"].createElement("table", {
    className: "table",
    style: {
      border: '1px solid',
      width: '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement("thead", null, /*#__PURE__*/React__default["default"].createElement("tr", null, ThData())), /*#__PURE__*/React__default["default"].createElement("tbody", null, tdData()));
}

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

const isShipmentDisabled = (entryState, customState, circuitState, brokerHouseState, isRFI = false) => {
  if (!entryState || window.typeOfUser === 'BROKER_KN_ADMIN') {
    return true;
  } else if ((entryState.includes('IN_PROCESS') || entryState.includes('READY')) && brokerHouseState === "STATE_BH_BROKER_DONE") {
    // if(customState.includes("TYPE_NOT")) return true;
    return false;
  } else if (brokerHouseState === "STATE_BH_BROKER_IN_PROCESS" && entryState && (entryState.includes('IN_PROCESS') || entryState.includes('READY')) && customState && customState.includes('TYPE_NOT')) {
    return false;
  } else if (brokerHouseState !== "STATE_BH_BROKER_IN_PROCESS" || customState && (customState.includes("PDI_AMEND") || customState.includes("BOX") && !customState.includes("BOX_40_FAILED") && !customState.includes("BOX_44_FAILED")) || circuitState && circuitState.includes("GREEN") && !customState.includes("TYPE_X") && !customState.includes("TYPE_Y")) {
    return true;
  } else if (entryState && (entryState.includes('IN_PROCESS') || entryState.includes('READY')) && brokerHouseState === "STATE_BH_BROKER_IN_PROCESS") {
    if (entryState !== null && entryState !== void 0 && entryState.includes('RFI') && !isRFI || entryState !== null && entryState !== void 0 && entryState.includes('EXT_IN_PROCESS') || entryState !== null && entryState !== void 0 && entryState.includes('EXT_READY')) {
      return true;
    }
    return false;
  } else {
    return true;
  }
};
const JSONDisplayer = (children, showErrors) => {
  let copyobject = children;
  if (copyobject && typeof copyobject !== "string" && typeof copyobject !== "number") {
    return Object.keys(copyobject).map((kkkkeeey, ix) => {
      if ((kkkkeeey == 'payload' || kkkkeeey == 'error') && !showErrors) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
        key: kkkkeeey + 'rhkea' + ix
      });
      return /*#__PURE__*/React__default["default"].createElement("section", {
        className: "row widthRow clickableJSONobj",
        key: kkkkeeey + 'rhea' + ix,
        style: {
          border: '1px solid #ccc',
          display: 'block'
        }
      }, Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey][0] === "object" ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          paddingLeft: '2px',
          width: 'fit-content',
          marginTop: '15px',
          display: 'block',
          color: kkkkeeey.toLowerCase().includes("error") ? 'red' : "black"
        }
      }, /*#__PURE__*/React__default["default"].createElement("b", null, kkkkeeey.toLowerCase().includes("error") && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "warning circle",
        color: "red",
        style: {
          "display": "inline"
        }
      }), /*#__PURE__*/React__default["default"].createElement("u", null, decamelize(kkkkeeey)))), /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          paddingLeft: '2px',
          width: '100%',
          marginTop: '15px',
          display: 'block'
        }
      }, /*#__PURE__*/React__default["default"].createElement(DynamicTable, {
        TableData: copyobject[kkkkeeey]
      }))) : Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey][0] !== 'object' ? copyobject[kkkkeeey].join(", ") : !Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey] == 'object' ? /*#__PURE__*/React__default["default"].createElement("div", {
        className: "width-16",
        width: 16,
        style: {
          paddingLeft: '2px',
          width: '100%'
        }
      }, /*#__PURE__*/React__default["default"].createElement("b", null, !kkkkeeey.match(/^[0-9]+$/g) && decamelize(kkkkeeey)), /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "width-16",
        width: 16
      }, copyobject[kkkkeeey] && JSONDisplayer(copyobject[kkkkeeey]))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "width-4",
        width: 4,
        style: {
          paddingLeft: '2px'
        }
      }, /*#__PURE__*/React__default["default"].createElement("b", null, decamelize(kkkkeeey)), ":\xA0"), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "width-12",
        width: 12,
        style: {
          paddingLeft: '2px'
        }
      }, typeof copyobject[kkkkeeey] === 'string' ? /*#__PURE__*/React__default["default"].createElement(LongText, {
        content: copyobject[kkkkeeey].replaceAll("/", "/ "),
        limit: 100
      }) : copyobject[kkkkeeey])));
    });
  } else {
    return /*#__PURE__*/React__default["default"].createElement("section", {
      className: "row widthRow clickableJSONobj",
      style: {
        display: 'block'
      }
    }, typeof copyobject === 'string' ? /*#__PURE__*/React__default["default"].createElement(LongText, {
      content: copyobject.replaceAll("/", "/ "),
      limit: 100
    }) : copyobject);
  }
};
const decamelize = (str, separator) => {
  separator = typeof separator === 'undefined' ? ' ' : separator;
  return lodash.startCase(str).replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2');
};
const selectedCircuit = state => {
  switch (state) {
    case "green":
      return {
        color: "green",
        icon: "check circle",
        text: state
      };
    case "red":
      return {
        color: "red",
        icon: " times circle",
        text: state
      };
    case "yellow":
      return {
        color: "#d8ca07",
        icon: "exclamation triangle",
        text: state
      };
    case "orange":
      return {
        color: "orange",
        icon: "exclamation triangle",
        text: state
      };
    default:
      return {
        color: "grey",
        icon: "check circle",
        text: state
      };
  }
};
const selectedStatusTag = state => {
  if (state.includes('CANCEL FILED')) {
    return {
      color: '#d8ca07',
      icon: 'exclamation triangle',
      text: state
    };
  } else if (state.includes('FAILED') || state.includes('STUCK') || state.includes('REJECTED') || state.includes('FILED FAILED')) {
    return {
      color: 'red',
      icon: 'times circle',
      text: state
    };
  } else if (state.includes('CLEAR') || state.includes('FILED') || state.includes('RELEASE') || state.includes('ACCEPTED')) {
    return {
      color: 'green',
      icon: 'check circle',
      text: state
    };
  } else {
    return {
      color: 'grey',
      icon: 'check circle',
      text: state
    };
  }
};
const roundToTwo = (num, precision = 2) => Number(Math.round(num + 'e+' + precision) + 'e-' + precision);
const cancelReasonValues = [{
  text: "Declaration is no longer required",
  value: "1",
  key: "1"
}, {
  text: "Duplicate declaration (MRN of new declaration provided)",
  value: "2",
  key: "2"
}, {
  text: "Other reason for cancellation",
  value: "3",
  key: "3"
}];
const amendReasonValues = [{
  text: "Amend commodity code",
  value: "21",
  key: "21"
}, {
  text: "Amend value",
  value: "22",
  key: "22"
}, {
  text: "Amend tax line(s)",
  value: "23",
  key: "23"
}, {
  text: "Amend quota",
  value: "24",
  key: "24"
}, {
  text: "Amend license",
  value: "25",
  key: "25"
}, {
  text: "Amend currency",
  value: "26",
  key: "26"
}, {
  text: "Amend CPC",
  value: "27",
  key: "27"
}, {
  text: "Amend weight or quantity",
  value: "28",
  key: "28"
}, {
  text: "Amend consignee/consignor",
  value: "29",
  key: "29"
}, {
  text: "Delete Item",
  value: "30",
  key: "30"
}, {
  text: "Nil amendment - please state reason",
  value: "31",
  key: "31"
}, {
  text: "Other - please state reason",
  value: "32",
  key: "32"
}, {
  text: "Amend security - undervaluation",
  value: "33",
  key: "33"
}];
const isOperator = [{
  text: "YES",
  text_es: "SI",
  value: "P",
  key: "P"
}];
const canUserFile = (kxUser, kxEngineUserInfo) => {
  const knUsrData = kxUser.hasOwnProperty("userBasicInfo") ? kxUser.userBasicInfo : kxUser;
  const userRole = lodash_2(knUsrData, `role`, null);
  const isEngineUserPriviledgedForFiling = (kxEngineUserInfo === null || kxEngineUserInfo === void 0 ? void 0 : kxEngineUserInfo.isEngineUser) == 'true';
  return Boolean(userRole === 'USER_ADMIN' || lodash_2(knUsrData, 'userPrivileges.userPrivilege[0].write', null) === 'TRUE' || isEngineUserPriviledgedForFiling);
};
const dateString = (epochs, tz) => {
  const date = new Date(epochs);
  let options = {
    timeZone: tz,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  };
  if (tz) {
    const formattedDate = date.toLocaleDateString('en-GB', options);
    return formattedDate;
  } else {
    return moment.utc(epochs).format('DD-MM-YYYY HH:mm:ss');
  }
};
const chooseDateAndTime = (timeStamp, showDateAndTime = false) => {
  const optimizedDate = showDateAndTime === true ? moment.utc(timeStamp).format('DD-MM-YYYY HH:mm:ss') : moment.utc(timeStamp).format('DD-MM-YYYY');
  return optimizedDate;
};
const millisecondsToTime = millis => {
  let past = millis < 0;
  millis = Math.abs(millis);
  let days = Math.floor(millis / 1000 / 60 / 60 / 24);
  millis = millis - days * 1000 * 60 * 60 * 24;
  let hours = Math.floor(millis / 1000 / 60 / 60);
  millis = millis - hours * 1000 * 60 * 60;
  let minutes = Math.floor(millis / 1000 / 60);
  millis = millis - minutes * 1000 * 60;
  let daysAsString = days == 1 ? " day" : " days";
  let hoursAsString = hours == 1 ? " hour" : " hours";
  let minutesAsString = minutes == 1 ? " minute" : " minutes";
  let ashex = Number(80 + Math.floor(Math.sqrt(Math.min(days, 1000)) * 2)).toString(16);
  ashex = "#" + ashex + ashex + ashex;
  if (days > 4) {
    return {
      days: days + daysAsString + (past ? " ago" : " remaining"),
      daysColor: past ? ashex : "#006600"
    };
  }
  if (days >= 1) {
    return {
      days: days + daysAsString + ", " + hours + hoursAsString + (past ? " ago" : " remaining!"),
      daysColor: past ? ashex : "#ffc107"
    };
  }
  if (minutes > 10 && hours > 0) {
    let exclamations = "!!" + (hours < 12 ? "!" : "") + (hours < 6 ? "!" : "");
    return {
      days: hours + hoursAsString + ", " + minutes + minutesAsString + (past ? " ago" : "  remaining" + exclamations),
      daysColor: past ? "#cc0000" : "#FF4000"
    };
  }
  return {
    days: "NOW",
    daysColor: "#FF0000"
  };
};
const getSum = (data, key) => {
  let sum = data.reduce((c, d) => c + (+d[key].reduce((a, b) => +a + (+b.convertedUnitValue || 0), 0) || 0), 0);
  return sum.toFixed(2);
};
const statusMap = {
  "DMSSENT": {
    "code": "144DEC",
    "text_en": "Declaration sent to Customs",
    "text_nl": "Aangifte verzonden"
  },
  "ALTSENT": {
    "code": "144ADD-ALT",
    "text_en": "Alternative Proof sent to Customs",
    "text_nl": "Aanvullend bewijs verzonden"
  },
  "CORSENT": {
    "code": "144ADD-COR",
    "text_en": "Correction request sent to Customs",
    "text_nl": "Correctieverzoek verzonden"
  },
  "SUPSENT": {
    "code": "144ADD-SUP",
    "text_en": "Supplement sent",
    "text_nl": "Supplement verzonden"
  },
  "INVSENT": {
    "code": "144ADD-INV",
    "text_en": "Cancellation request sent",
    "text_nl": "Cancel verzoek verzonden"
  }
};
const DutyMenuItems = [{
  name: 'PROVISIONAL DUTIES (999.99 EUR)',
  // slug: 'provisionalDuties',
  slug: 'merchandiseDuty' // tobe removed
}, {
  name: 'CONFIRMED DUTIES (999.99 EUR)',
  slug: 'confirmedDuties'
}, {
  name: 'CORRECTED DUTIES (999.99 EUR)',
  slug: 'correctedDuties'
}];
const Choices = [{
  label: 'RELATIONSHIP',
  value: 'H1'
}, {
  label: 'RESTRICTION',
  value: 'H4'
}, {
  label: 'CONDITIONAL',
  value: 'H5'
}, {
  label: 'ARRANGEMENT',
  value: 'I1'
}];
const AesStatusMappings = {
  NA: {
    text: 'NA',
    text_es: 'NA'
  },
  AW: {
    text: 'Awaiting PCO Decision',
    text_es: 'Espererando Decisión de la PCO'
  },
  CA: {
    text: 'PreDUA Cancelled',
    text_es: 'PreDUA Cancelado'
  },
  DE: {
    text: 'Dispatched Indirect',
    text_es: 'Despachada Indirecta'
  },
  DS: {
    text: 'Dispatched Direct',
    text_es: 'Despachada Directa'
  },
  GO: {
    text: 'Managed Elsewhere',
    text_es: 'Gestionada en Otro Lugar'
  },
  GT: {
    text: 'Managed by Transit',
    text_es: 'Gestionada por Tránsito'
  },
  IV: {
    text: 'Invalidated - Not exported',
    text_es: 'Invalidada - No exportada'
  },
  NL: {
    text: 'No Levante',
    text_es: 'No Levante'
  },
  PA: {
    text: 'PreDua Registered',
    text_es: 'PreDua Registrado'
  },
  PI: {
    text: 'PreDua Invalidado',
    text_es: 'PreDua Invalidated'
  },
  PL: {
    text: 'Pending Levante',
    text_es: 'Pendiente Levante'
  },
  PS: {
    text: 'Pending Outgoing',
    text_es: 'Pendiente de Salida'
  },
  RE: {
    text: 'Received',
    text_es: 'Recibido'
  },
  RO: {
    text: 'Received in another country',
    text_es: 'Recibida en otro País'
  },
  RQ: {
    text: 'Requested from EU',
    text_es: 'Solicitada a la UE'
  },
  RZ: {
    text: 'Diversion Rejected',
    text_es: 'Desvío rechazado'
  },
  SA: {
    text: 'Exit Effectively Carried Out',
    text_es: 'Salida Efectiva Efectuada'
  },
  SP: {
    text: 'BCO Role Only',
    text_es: 'Solo Rol PCO'
  },
  ST: {
    text: 'Stopped at Customs Office of Exit',
    text_es: 'Parada en Aduana de Salida'
  },
  TP: {
    text: 'On Request for Evidence by Transit',
    text_es: 'En Petición de Pruebas por Tránsito'
  }
};
const BolGenerator = modeOfTransport => {
  const motArray = ['AIR', 'OCEAN', 'TRUCK'];
  const motmotArrayCheck = motArray.includes(modeOfTransport);
  const typeOfBolValues = {
    'AIR': ['MAWB', 'HAWB'],
    'OCEAN': ['MBOL', 'HBOL'],
    'TRUCK': ['CMR']
  };
  if (motmotArrayCheck) {
    return typeOfBolValues[modeOfTransport] || [];
  }
};
const getJobWheels = currentJobData => {
  if (!lodash_2(currentJobData, 'states.states')) ;
  const BROKER_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_BROKER_PROCESS`;
  });
  const CUSTOM_RELEASE_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `CUSTOM_RELEASE_PROCESS`;
  });
  const SHIPMENT_BROKER_HOUSE_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_BROKER_HOUSE_PROCESS`;
  });
  const SHIPMENT_ENTRY_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_ENTRY_PROCESS`;
  });
  const SHIPMENT_ES_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_ES_PROCESS`;
  });
  const SHIPMENT_GB_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_UK_CDS_PROCESS`;
  });
  const SHIPMENT_NL_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    const formType = currentJobData === null || currentJobData === void 0 ? void 0 : currentJobData.formType;
    const key = formType === 'DMS' ? 'SHIPMENT_NL_DMS_PROCESS' : 'SHIPMENT_NL_AGS_PROCESS';
    return item.key === key;
  });
  const NL_DMS_CUSTOM_SUB_PROCESS = !lodash.isEmpty(currentJobData) && lodash_2(currentJobData, 'states.states', []).find(item => {
    return item.key === `SHIPMENT_NL_SUB_PROCESS`;
  });
  return {
    BROKER_PROCESS: BROKER_PROCESS,
    CUSTOM_RELEASE_PROCESS: CUSTOM_RELEASE_PROCESS,
    SHIPMENT_BROKER_HOUSE_PROCESS: SHIPMENT_BROKER_HOUSE_PROCESS,
    ES_ENTRY_JOB_WHEEL: SHIPMENT_ENTRY_PROCESS,
    ES_CUSTOM_JOB_WHEEL: SHIPMENT_ES_PROCESS,
    GB_CUSTOM_JOB_WHEEL: SHIPMENT_GB_PROCESS,
    NL_CUSTOM_JOB_WHEEL: SHIPMENT_NL_PROCESS,
    NL_DMS_CUSTOM_SUB_PROCES_WHEEL: NL_DMS_CUSTOM_SUB_PROCESS // DMS Subprocess
  };
};
const extractFileNameFromUrl = url => {
  const urlObj = new URL(url);
  const path = urlObj.pathname;
  const segments = path.split('/');
  const fileName = segments[segments.length - 1].split('-').slice(6, -1);
  const docName = fileName.slice(0, -1).join('-');
  const docType = fileName.slice(-1).join('');
  return [docName, docType];
};
const groupDocumentsByType = (documentsArray, docType) => {
  const folderMap = new Map();
  documentsArray.forEach(doc => {
    const {
      parentDocumentId,
      documentType = 'MISC'
    } = doc;
    if (documentType !== docType) {
      return;
    }
    const updatedDoc = {
      ...doc,
      isChecked: false
    };
    const folderDocs = folderMap.get(documentType) || {
      documents: new Map()
    };
    const parentDocsArray = folderDocs.documents.get(parentDocumentId) || [];
    folderDocs.documents.set(parentDocumentId, [...parentDocsArray, updatedDoc]);
    folderMap.set(documentType, folderDocs);
  });
  return folderMap;
};

// it takes jobWheels as argument which is privided by getJobWheels function
const getJobStates = jobWheels => wheelName => {
  var _jobWheels$wheelName, _jobWheels$wheelName$;
  return (jobWheels === null || jobWheels === void 0 ? void 0 : (_jobWheels$wheelName = jobWheels[wheelName]) === null || _jobWheels$wheelName === void 0 ? void 0 : (_jobWheels$wheelName$ = _jobWheels$wheelName.value) === null || _jobWheels$wheelName$ === void 0 ? void 0 : _jobWheels$wheelName$.state) || '';
};
const getEntryStateChecks = (entryState, customState) => ({
  isEntryOrCustomStateNone: entryState.includes('NONE') || customState.includes('NONE'),
  isEntryNewJob: entryState.includes('NONE'),
  isEntryEditable: entryState.includes('IN_PROCESS') || entryState.includes('READY'),
  isEntryInProcess: entryState.includes('STATE_ENTRY_IN_PROCESS'),
  isEntryFileReady: entryState.includes('READY'),
  isEntryReady: entryState.includes('STATE_ENTRY_READY'),
  isEntryFiled: entryState === 'STATE_ENTRY_FILED',
  isEntryCancelFiled: entryState === 'STATE_ENTRY_CANCELLED_FILED',
  isEntryCancelFailed: entryState === 'STATE_ENTRY_CANCELLED_FAILED',
  isSupFiled: entryState === 'STATE_ENTRY_SUP_FILED',
  isSupAccepted: entryState === 'STATE_ENTRY_SUP_ACCEPTED',
  isExtFiled: entryState === 'STATE_ENTRY_EXT_FILED',
  isExtAccepted: entryState === 'STATE_ENTRY_EXT_ACCEPTED',
  isExtRejected: entryState === 'STATE_ENTRY_EXT_REJECTED',
  isSupRejected: entryState === 'STATE_ENTRY_SUP_REJECTED',
  isEntryOnHold: entryState === 'STATE_ENTRY_ON_HOLD',
  isEntryRejected: entryState === 'STATE_ENTRY_REJECTED',
  isEntryAccepted: entryState === 'STATE_ENTRY_ACCEPTED',
  isEntryCompleted: entryState === 'STATE_ENTRY_COMPLETED',
  isEntryReleased: entryState === 'STATE_ENTRY_RELEASED',
  isEntryAmendInProcess: entryState.includes('STATE_ENTRY_AMEND_IN_PROCESS'),
  isEntryAmendFileReady: entryState.includes('STATE_ENTRY_AMEND_READY'),
  isEntryAmendFiled: entryState === 'STATE_ENTRY_AMEND_FILED',
  isCancelledFiled: entryState === 'STATE_ENTRY_CANCELLED_FILED',
  isCancelAccepted: entryState === 'STATE_ENTRY_CANCELLED',
  isCancelledFailed: entryState === 'STATE_ENTRY_CANCELLED_FAILED',
  isEntryAmendFailed: entryState === 'STATE_ENTRY_AMEND_FAILED',
  isEntryAmendRejected: entryState === 'STATE_ENTRY_AMEND_REJECTED',
  isEntryAmendAccepted: entryState === 'STATE_ENTRY_AMEND_ACCEPTED',
  isRFIRejected: entryState === 'STATE_ENTRY_RFI_REJECTED'
});

// import store from './store'
// import ESApp from "./components/ES_App"
// import NLApp from "./components/NL_App"
// import GBApp from "./components/GB_App"
// import AESApp from "./components/AES_App"
// import DMSApp from "./components/DMS_App"

const ESApp$1 = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return index; });
});
const AESApp = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./index-a7d5a99b.js'); }).then(function (n) { return n.index; });
});
const NLApp = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./index-0e0d3f89.js'); }).then(function (n) { return n.index; });
});
const DMSApp = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./index-0903632b.js'); });
});
const GBApp = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./index-49905724.js'); });
});
function EUForms(props) {
  const {
    countryCode,
    EUData,
    setEUData,
    activeBrokerJob,
    rubberBindingInfo,
    handleLegalAcknowledgement,
    euPdf,
    finalReview,
    commonMetaData,
    commonJobData,
    kxUser,
    headerProps,
    version,
    serviceType,
    allDocs,
    customStateMapper,
    kxEngineUserInfo,
    showSendToBillingButton
  } = props;
  const {
    t
  } = reactI18next.useTranslation(['default', 'header', "lineItem", "notes", "parties", "valueBuildUp"]);
  let jobWheels = getJobWheels(commonJobData.currentJobData);
  if (countryCode === "ES" && (!version || version === "ECS")) {
    return /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "Loading...")
    }, /*#__PURE__*/React__default["default"].createElement(ESApp$1, _extends$1({
      key: "entrySummaryC88AppComponent",
      EUData: EUData,
      setEUData: setEUData,
      translate: t,
      jobWheels: jobWheels,
      serviceType: serviceType,
      rubberBindingInfo: rubberBindingInfo,
      handleLegalAcknowledgement: handleLegalAcknowledgement,
      euPdf: euPdf,
      finalReview: finalReview
    }, commonMetaData, commonJobData, {
      formType: `ECS`,
      headerProps: headerProps,
      kxEngineUserInfo: kxEngineUserInfo
    })));
  }
  if (countryCode === "ES" && version === "AES") {
    return /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "Loading...")
    }, /*#__PURE__*/React__default["default"].createElement(AESApp, _extends$1({
      key: "entrySummaryC88AppComponent",
      EUData: EUData,
      allDocs: allDocs,
      setEUData: setEUData,
      translate: t,
      serviceType: serviceType,
      rubberBindingInfo: rubberBindingInfo,
      handleLegalAcknowledgement: handleLegalAcknowledgement,
      euPdf: euPdf,
      finalReview: finalReview,
      version: version
    }, commonJobData, commonMetaData, {
      formType: `AES`,
      kxUser: kxUser,
      headerProps: headerProps,
      kxEngineUserInfo: kxEngineUserInfo
    })));
  }
  if (countryCode === "NL" && (!version || version === "DMS")) {
    return /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, "Loading..."))
    }, /*#__PURE__*/React__default["default"].createElement(DMSApp, _extends$1({
      key: "entrySummaryC88AppComponent",
      EUData: EUData,
      setEUData: setEUData,
      translate: t,
      serviceType: serviceType,
      rubberBindingInfo: rubberBindingInfo,
      handleLegalAcknowledgement: handleLegalAcknowledgement,
      euPdf: euPdf,
      finalReview: finalReview
    }, commonJobData, commonMetaData, {
      formType: `DMS`,
      version: "DMS",
      kxUser: kxUser,
      headerProps: headerProps,
      customStateMapper: customStateMapper,
      kxEngineUserInfo: kxEngineUserInfo
    })));
  }
  if (countryCode === "NL" && version === "AGS") {
    return /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, "Loading..."))
    }, /*#__PURE__*/React__default["default"].createElement(NLApp, _extends$1({
      key: "entrySummaryC88AppComponent",
      EUData: EUData,
      setEUData: setEUData,
      translate: t,
      serviceType: serviceType,
      rubberBindingInfo: rubberBindingInfo,
      handleLegalAcknowledgement: handleLegalAcknowledgement,
      euPdf: euPdf,
      finalReview: finalReview
    }, commonMetaData, commonJobData, {
      formType: `AGS`,
      version: "AGS",
      headerProps: headerProps,
      kxEngineUserInfo: kxEngineUserInfo
    })));
  }
  if (countryCode === "GB" && version === "CDS") {
    return /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "Loading...")
    }, /*#__PURE__*/React__default["default"].createElement(GBApp, _extends$1({
      key: "entrySummaryC88AppComponent",
      translate: t,
      serviceType: serviceType,
      rubberBindingInfo: rubberBindingInfo,
      handleLegalAcknowledgement: handleLegalAcknowledgement,
      euPdf: euPdf,
      finalReview: finalReview,
      version: version
    }, commonJobData, commonMetaData, {
      formType: `CDS`,
      kxUser: kxUser,
      headerProps: headerProps,
      lowerEnv: window._env_.REACT_APP_BROKER_API_URL.match(/(staging|dev|prod)/g),
      kxEngineUserInfo: kxEngineUserInfo,
      showSendToBillingButton: showSendToBillingButton
    })));
  }
  return null;
}
function EUApp(props) {
  return /*#__PURE__*/React__default["default"].createElement(EUForms, props);
}
var EUApp$1 = /*#__PURE__*/React__default["default"].memo(EUApp);

const INITIALIZE_VALUE_CONSIGNEE = 'INITIALIZE_VALUE_CONSIGNEE';
const INITIALIZE_VALUE_BROKER = 'INITIALIZE_VALUE_BROKER';
const INITIALIZE_VALUE_CONSIGNOR = 'INITIALIZE_VALUE_CONSIGNOR';
const INITIALIZE_VALUE_BUYER = 'INITIALIZE_VALUE_BUYER';
const INITIALIZE_VALUE_SELLER = 'INITIALIZE_VALUE_SELLER';
const INITIALIZE_VALUE_SHIPMENT = 'INITIALIZE_VALUE_SHIPMENT';
const INITIALIZE_DROPDOWNS$3 = 'INITIALIZE_DROPDOWNS';
const UPDATE_DROPDOWNS = 'UPDATE_DROPDOWNS';
const UPDATE_ACTOR_FIELD_VALUE$2 = 'UPDATE_ACTOR_FIELD_VALUE';
const SET_ERROR_MESSAGE$2 = "SET_ERROR_MESSAGE";
const DELETE_GUARANTEE_INFO = "DELETE_GUARANTEE_INFO";
const ADD_GUARANTEE_INFO = "ADD_GUARANTEE_INFO";
const ADD_CARGO_DOCUMENT_INFO = "ADD_CARGO_DOCUMENT_INFO";
const UPDATE_SHIPMENT_FIELD_VALUE$3 = 'UPDATE_SHIPMENT_FIELD_VALUE';
const UPDATE_SHIPMENT_COUNTRY_VALUE = 'UPDATE_SHIPMENT_COUNTRY_VALUE';
const UPDATE_GUARANTEE_INFO_FIELD = "UPDATE_GUARANTEE_INFO_FIELD";
const UPDATE_SHIP_DUTY_FIELD$3 = 'UPDATE_SHIP_DUTY_FIELD';
const UPDATE_MERCH_LINE_ITEM_FIELD$2 = 'UPDATE_MERCH_LINE_ITEM_FIELD';
const REMOVE_MERCHANDISE_LINE_ITEM$2 = 'REMOVE_MERCHANDISE_LINE_ITEM';
const ADD_MERCH_DUTY$2 = 'ADD_MERCH_DUTY';
const REMOVE_DUTY_ITEM$3 = 'REMOVE_DUTY_ITEM';
const UPDATE_INVOICE_LINE_ITEM_FIELD$3 = 'UPDATE_INVOICE_LINE_ITEM_FIELD';
const ADD_SPECIAL_MENTION_INFO = 'ADD_SPECIAL_MENTION_INFO';
const ADD_SUPPORTING_DOC_INFO = 'ADD_SUPPORTING_DOC_INFO';
const FORM_LOADED = 'FORM_LOADED';
const FORM_VALUES$3 = 'FORM_VALUES';
const SET_ANY_FORM_VALUES$3 = 'SET_ANY_FORM_VALUES';
const INITIALIZE_VALUES_INVOICE = "INITIALIZE_VALUES_INVOICE";
const REMOVE_INVOICE_LINE_ITEM$2 = "REMOVE_INVOICE_LINE_ITEM";
const CREATE_MERCHANDISE_LINE_ITEM$2 = "CREATE_MERCHANDISE_LINE_ITEM";
const ADD_INVOICE_ITEM$2 = "ADD_INVOICE_ITEM";
const UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$3 = "UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD";
const REMOVE_CONTAINER$3 = "REMOVE_CONTAINER";
const INITIALIZE_VALUES_NOTES$3 = "INITIALIZE_VALUES_NOTES";
const UPDATE_NOTES_ITEM_STATUS$3 = "UPDATE_NOTES_ITEM_STATUS";
const ADD_NOTES_ITEM$3 = "ADD_NOTES_ITEM";
const COLLAPSE_LINE_ITEMS$3 = "COLLAPSE_LINE_ITEMS";
const EXPAND_LINE_ITEMS$3 = "EXPAND_LINE_ITEMS";
const UPDATE_MERCHANDISE_COUNT$3 = "UPDATE_MERCHANDISE_COUNT";
const EXPAND_ALL_LINE_ITEMS$3 = "EXPAND_ALL_LINE_ITEMS";
const EXPAND_LINE_ITEM$3 = "EXPAND_LINE_ITEM";
const ADD_CONTAINER = "ADD_CONTAINER";
const UPDATE_CONTAINER = "UPDATE_CONTAINER";
const DELETE_CONTAINER = "DELETE_CONTAINER";
const INITIALIZE_HEADER_CONTAINER = "INITIALIZE_HEADER_CONTAINER";
const CREATE_CONATINER_ITEM_LEVEL = "CREATE_CONATINER_ITEM_LEVEL";
const CREATE_SEAL_INFO = "CREATE_SEAL_INFO";
const UPDATE_SEAL_INFO_FIELD = "UPDATE_SEAL_INFO_FIELD";
const DELETE_SEAL_ITEM = "DELETE_SEAL_ITEM";
const UPDATE_ITEM_VALUES = "UPDATE_ITEM_VALUES";

// for merchandise 

const UPDATE_MERCHANDISE_DOC_BY_ID$2 = "UPDATE_MERCHANDISE_DOC_BY_ID";
const ADD_MERCHANDISE_DOC_BY_ID$2 = "ADD_MERCHANDISE_DOC_BY_ID";
const DELETE_MERCHANDISE_DOC_BY_ID$2 = "DELETE_MERCHANDISE_DOC_BY_ID";
const UPDATE_MERCHANDISE_AFTER_SAVE = "UPDATE_MERCHANDISE_AFTER_SAVE";

// mass update 
const MASS_UPDATE_REPEATABLE_ELEMENTS$1 = "MASS_UPDATE_REPEATABLE_ELEMENTS";

const getCookie$1 = cname => {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join('-');
}
const getModifiedPayload = payload => {
  var _get$concat;
  payload.addressLine1 = (_get$concat = lodash_2(payload, 'streetNumber', '').concat(" ", lodash_2(payload, 'streetName', ''))) === null || _get$concat === void 0 ? void 0 : _get$concat.trim();
  //  console.log(payload,"payload")
  return payload;
};

const initialState$H = {
  consignee: {},
  broker: {},
  consignor: {},
  seller: {},
  buyer: {}
};
function ActorReducer$2(state = initialState$H, action) {
  switch (action.type) {
    case INITIALIZE_VALUE_CONSIGNEE:
      {
        return Object.assign({}, state, {
          consignee: getModifiedPayload(action.payload)
        });
      }
    case INITIALIZE_VALUE_CONSIGNOR:
      {
        return Object.assign({}, state, {
          consignor: getModifiedPayload(action.payload)
        });
      }
    case INITIALIZE_VALUE_BROKER:
      {
        return Object.assign({}, state, {
          broker: getModifiedPayload(action.payload)
        });
      }
    case INITIALIZE_VALUE_SELLER:
      {
        return Object.assign({}, state, {
          seller: getModifiedPayload(action.payload)
        });
      }
    case INITIALIZE_VALUE_BUYER:
      {
        return Object.assign({}, state, {
          buyer: getModifiedPayload(action.payload)
        });
      }
    case UPDATE_ACTOR_FIELD_VALUE$2:
      {
        const {
          actorType,
          payload
        } = action;
        console.log(payload);
        return {
          ...state,
          [`${actorType}`]: {
            ...state[actorType],
            ...payload
          }
        };
      }
    default:
      return state;
  }
}

const initialState$G = {};
function ShipmentReducer$2(state = initialState$G, action) {
  switch (action.type) {
    case INITIALIZE_VALUE_SHIPMENT:
      {
        return Object.assign({}, state, {
          ...action.payload
        });
      }
    case UPDATE_SHIPMENT_FIELD_VALUE$3:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_SHIPMENT_COUNTRY_VALUE:
      {
        let country = Object.assign({}, state[action.countryType]);
        country[action.countryField] = action.payload;
        return Object.assign({}, state, {
          [action.countryType]: country
        });
      }
    case DELETE_GUARANTEE_INFO:
      {
        const {
          id
        } = action;
        return {
          ...state,
          [`warranties`]: state['warranties'].filter(c => c.warrantyId != id)
        };
      }
    case ADD_GUARANTEE_INFO:
      {
        const {
          newInfo
        } = action;
        return {
          ...state,
          [`warranties`]: [...state['warranties'], newInfo]
        };
      }
    case UPDATE_MERCHANDISE_COUNT$3:
      {
        //change the name
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_GUARANTEE_INFO_FIELD:
      {
        const warrantiesInfosTemp = [...state.warranties];
        warrantiesInfosTemp[action.infoIndex] = {
          ...warrantiesInfosTemp[action.infoIndex],
          ...action.payload
        };
        return {
          ...state,
          warranties: warrantiesInfosTemp
        };
      }
    case CREATE_SEAL_INFO:
      {
        let newState = {
          ...state
        };
        newState.seals.push(action.payload);
        return newState;
      }
    case UPDATE_SEAL_INFO_FIELD:
      {
        let newState = {
          ...state
        };
        newState.seals[action.infoIndex][action.infoField] = action.payload;
        return newState;
      }
    case DELETE_SEAL_ITEM:
      {
        let newState = {
          ...state
        };
        let seals = newState.seals.filter(seal => seal.sealId !== action.sealId);
        newState.seals = seals;
        return newState;
      }
    default:
      return state;
  }
}

const merchandiseDuty = (merchandiseId = '', merchandiseDutyId = '') => {
  return {
    merchandiseDutyIndex: 0,
    taxType: "",
    taxBase: 0 .toFixed(2),
    taxRate: "0",
    taxAmount: 0 .toFixed(2),
    quotaAmount: 0 .toFixed(2),
    mopCode: "",
    merchandiseId: merchandiseId,
    merchandiseDutyId: merchandiseDutyId
  };
};
const ShipmentContainerMapper = (id = "") => {
  return {
    infoIndex: 0,
    containerId: "",
    containerNumber: "",
    shipmentId: ""
  };
};
const SealData = (id = "") => {
  return {
    index: 0,
    id: id,
    sealId: "",
    sealNumber: ""
  };
};
const merchandisConatiner = (merchandiseId = '', merchandiseDutyId = '') => {
  return {
    infoIndex: 0,
    containerId: '',
    containerNumber: "",
    shipmentId: '',
    merchandiseId: "",
    invoiceId: ''
  };
};
const itemContainerMapper = (id = "") => {
  return {
    infoIndex: 0,
    containerId: "",
    containerNumber: "",
    shipmentId: "",
    containerAssociationId: "",
    merchandiseId: "",
    invoiceId: ""
  };
};
const invoiceItemData = () => ({
  invoiceId: "",
  shipmentId: "",
  invoiceNumber: "",
  invoiceDate: {
    epochs: new Date().getTime()
  },
  poNo: "",
  invoiceTotal: 0 .toFixed(2),
  currency: "",
  deliveryZoneIndicator: "",
  descriptionOfPlaceOfDelivery: "",
  incoTermsConditionsCode: "",
  grassWeight: "",
  netWeight: ""
});
const shipmentDuty = (shipmentId = '', dutyId = '') => {
  return {
    dutyIndex: 0,
    shipmentId: shipmentId,
    dutyExtUkId: dutyId,
    freightChargesCurrency: "",
    freightChargesAmount: 0 .toFixed(2),
    insuranceUpliftValue: 0 .toFixed(2),
    insuranceUpliftType: "",
    insuranceAmount: 0 .toFixed(2),
    insuranceAmountCurrency: "",
    vatValueAmount: 0 .toFixed(2),
    vatValueCurrency: "",
    discountAmount: 0 .toFixed(2),
    discountAmountCurrency: "",
    discountAmountPct: 0 .toFixed(2),
    airportOfLoading: "",
    airTransportCost: 0 .toFixed(2),
    airTransportCostCurrency: "",
    airTransportCost: 0 .toFixed(2),
    otherChargesCurrency: "",
    otherChargesAmount: 0 .toFixed(2),
    airportOfLoading: "",
    transportChargeMOP: "",
    totalDuty: 0 .toFixed(2),
    deferredDuty: 0 .toFixed(2),
    immDuty: 0 .toFixed(2),
    dutyPayable: 0 .toFixed(2)
  };
};
const specialMentionsObj = (merchandiseId = '', infoId = '') => {
  return {
    infoIndex: 0,
    merchandiseId: merchandiseId,
    infoId: infoId,
    code: ""
  };
};
const cargoDocsDocs = (infoId = '') => {
  return {
    infoIndex: 0,
    infoId: infoId,
    ref: "",
    code: "",
    class: ""
  };
};
const supportingDocsObj = (infoId = '') => {
  return {
    infoIndex: 0,
    infoId: infoId,
    ref: "",
    code: "",
    documentDate: {
      epochs: new Date().getTime()
    }
  };
};
const warrantyObj = (warrantyId = '') => {
  return {
    infoIndex: 0,
    warrantyId: warrantyId,
    shipmentId: "",
    warrantyReferences: ""
  };
};
const merchandiseLineItems = (merchandiseId = '') => {
  return {
    lineItemIndex: 0,
    lineflag: false,
    tariffRegimeSuffix: '',
    merchandiseId: merchandiseId,
    shipmentId: '',
    commercialDescription: '',
    sku: '',
    countryOfOrigin: '',
    originProvince: '',
    commodityCode: '',
    taricCode: '',
    htsCode: '',
    exciseCode: '',
    additionalCode1: '',
    additionalCode2: '',
    supUnitsQuantity: '',
    supUnits: '',
    procedure: '',
    tariffRegime: '',
    //temp
    box37_1a_regimeCode: '',
    box37_1b_regimeCode: '',
    regimeAdditionalCode: '',
    packageCount: '',
    packageType: '',
    unitCount: '',
    unitType: '',
    unitPrice: 0 .toFixed(2),
    unitValue: '',
    customValue: '',
    statValue: '',
    convertedUnitValue: '',
    netMass: 0 .toFixed(2),
    grossMass: 0 .toFixed(2),
    quotaNumber: '',
    invoiceId: '',
    additionalInfo: [],
    previousDocumentInfo: [],
    specialMentions: [],
    itemDuties: [],
    containers: [],
    totalAmount: 0 .toFixed(2)
    // unitTypeList: [],
    // reductionTypeList: [],
    // preferenceTypeList: [],
    // docList: [],
    // dutyList: [],
  };
};
const shipmentCountry$1 = () => {
  return {
    code: "",
    name: ""
  };
};
const actorDetail = () => {
  return {
    actorType: '',
    actorTypeID: '',
    address2: '',
    addressId: '',
    city: '',
    country: '',
    countryCode: '',
    externalIdentification: '',
    id: '',
    name: '',
    postalCode: '',
    state: '',
    streetName: '',
    streetNumber: '',
    addressLine1: '',
    formOfRepresentation: '',
    privateIndicatorFlag: ''
  };
};
const esShipment = (shipmentId = '') => {
  return {
    shipmentId: shipmentId,
    declarationType: '',
    declarationEntryType: '',
    mrn: '',
    inlandTransportMode: '',
    officeOfDestination: '',
    transportIdAtBorder: '',
    destinationState: '',
    transportNationalityCrossBorder: '',
    transportTypeBorder: '',
    consignee: actorDetail(),
    consignor: actorDetail(),
    broker: actorDetail(),
    seller: actorDetail(),
    buyer: actorDetail(),
    destinationCountry: shipmentCountry$1(),
    locationOfGoods: '',
    natureOfTranscation: '',
    invoices: [invoiceItemData()],
    containerIndicator: '',
    arrivalDate: {
      epochs: new Date().getTime()
    },
    acceptanceDate: {
      epochs: new Date().getTime()
    },
    releaseDate: {
      epochs: new Date().getTime()
    },
    exitDate: {
      epochs: new Date().getTime()
    },
    natureOfTransaction: '',
    entryOffice: '',
    exitOffice: '',
    placeOfLadding: '',
    placeOfUnLadding: '',
    carrierName: '',
    transportMode: '',
    transmissionType: '',
    carrierId: '',
    totalShipmentPackages: '',
    totalItem: '',
    totalInvoice: '',
    totalGrassWeight: '',
    totalNetWeight: '',
    totalInvoiceAmount: '',
    totalInvoiceAmountInCurrency: '',
    cancelReason: '',
    mopCode: '',
    valueBuildUp: shipmentDuty(shipmentId),
    warranties: [],
    seals: []
  };
};

const initialState$F = {
  invoices: [],
  showLoader: false
};
function InvoicesReducer$2(state = initialState$F, action) {
  switch (action.type) {
    case INITIALIZE_VALUES_INVOICE:
      {
        let newState = {
          ...state
        };
        newState.invoices = action.invoices;
        return newState;
      }
    case UPDATE_INVOICE_LINE_ITEM_FIELD$3:
      {
        let invoicesInfosTemp = [...state.invoices];
        let invoiceIndex = invoicesInfosTemp.findIndex(invoice => invoice.invoiceId == action.invoiceId);
        let newInvoice = {
          ...invoicesInfosTemp[invoiceIndex],
          ...action.payload
        };
        invoicesInfosTemp.splice(invoiceIndex, 1, newInvoice);
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case COLLAPSE_LINE_ITEMS$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.index] = {
          ...invoicesInfosTemp[action.index],
          ['flag']: false
        };
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case EXPAND_ALL_LINE_ITEMS$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        for (let line of invoicesInfosTemp[action.index].merchandiseList) {
          line.lineflag = action.value;
        }
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case EXPAND_LINE_ITEM$3:
      {
        let newState = {
          ...state
        };
        if (newState.invoices[action.invoiceIndex].merchandiseList[action.lineItemIndex]) {
          newState.invoices[action.invoiceIndex].merchandiseList[action.lineItemIndex].lineflag = action.lineflag;
        }
        return newState;
      }
    case EXPAND_LINE_ITEMS$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.index] = {
          ...invoicesInfosTemp[action.index],
          ['flag']: true
        };
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case UPDATE_MERCH_LINE_ITEM_FIELD$2:
      {
        let invoicesInfosTemp = [...state.invoices];
        let invoiceIndex = invoicesInfosTemp.findIndex(invoice => invoice.invoiceId === action.invoiceId);
        let invoice = invoicesInfosTemp[invoiceIndex];
        let merchIndex = invoice.merchandiseList.findIndex(merch => merch.merchandiseId === action.merchandiseId);
        let merchandise = invoice.merchandiseList[merchIndex];
        let newMerchandise = {
          ...merchandise,
          ...action.payload
        };
        invoice.merchandiseList.splice(merchIndex, 1, newMerchandise);
        invoicesInfosTemp.splice(invoiceIndex, 1, invoice);
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case CREATE_CONATINER_ITEM_LEVEL:
      {
        const invoicesInfosTemp = [...state.invoices];
        const invoiceWithIndex = {
          ...invoicesInfosTemp[action.invoiceItemIndex]
        };
        const merchList = [...invoiceWithIndex.merchandiseList];
        const merchListWithIndex = {
          ...merchList[action.index]
        };
        const containers = [...merchListWithIndex.containers];
        const newContainers = [...containers, action.payload];
        invoicesInfosTemp[action.invoiceItemIndex].merchandiseList[action.index].containers = newContainers;
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.index].containers[action.containerIndex] = {
          ...invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.index].containers[action.containerIndex],
          [action.field]: action.payload
        };
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case REMOVE_DUTY_ITEM$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        let invoiceIndex = invoicesInfosTemp.findIndex(invoice => invoice.invoiceId == action.invoiceId);
        let invoice = invoicesInfosTemp[invoiceIndex];
        let merchIndex = invoice.merchandiseList.findIndex(merch => merch.merchandiseId === action.merchandiseId);
        let merchandise = invoice.merchandiseList[merchIndex];
        merchandise.itemDuties = merchandise.itemDuties.filter(item => item.merchandiseDutyId !== action.merchandiseDutyId);
        invoice.merchandiseList.splice(merchIndex, 1, merchandise);
        invoicesInfosTemp.splice(invoiceIndex, 1, invoice);
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case REMOVE_CONTAINER$3:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.lineItemIndex].containers = [...invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.lineItemIndex].containers.filter(item => item.containerId !== action.containerId)];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case ADD_MERCH_DUTY$2:
      {
        const invoicesInfosTemp = [...state.invoices];
        let invoiceIndex = invoicesInfosTemp.findIndex(invoice => invoice.invoiceId == action.invoiceId);
        let invoice = invoicesInfosTemp[invoiceIndex];
        let merchIndex = invoice.merchandiseList.findIndex(merch => merch.merchandiseId === action.merchandiseId);
        let merchandise = invoice.merchandiseList[merchIndex];
        merchandise.itemDuties = [...merchandise.itemDuties, action.payload];
        invoice.merchandiseList.splice(merchIndex, 1, merchandise);
        invoicesInfosTemp.splice(invoiceIndex, 1, invoice);
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case ADD_SPECIAL_MENTION_INFO:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.index].specialMentions = [...state.invoices[action.invoiceIndex].merchandiseList[action.index].specialMentions, action.newInfo];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case ADD_SUPPORTING_DOC_INFO:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.index].additionalInfo = [...state.invoices[action.invoiceIndex].merchandiseList[action.index].additionalInfo, action.newInfo];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case ADD_CARGO_DOCUMENT_INFO:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList[action.index].previousDocumentInfo = [...state.invoices[action.invoiceIndex].merchandiseList[action.index].previousDocumentInfo, action.newInfo];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case REMOVE_INVOICE_LINE_ITEM$2:
      {
        const {
          invoiceId
        } = action;
        return {
          ...state,
          [`invoices`]: state['invoices'].filter(c => c.invoiceId != invoiceId)
        };
      }
    case ADD_INVOICE_ITEM$2:
      {
        const {
          newInvoiceItem
        } = action;
        return {
          ...state,
          [`invoices`]: [...state['invoices'], newInvoiceItem]
        };
      }
    case CREATE_MERCHANDISE_LINE_ITEM$2:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList = [...state.invoices[action.invoiceIndex].merchandiseList, action.newLineItem];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case REMOVE_MERCHANDISE_LINE_ITEM$2:
      {
        const invoicesInfosTemp = [...state.invoices];
        invoicesInfosTemp[action.invoiceIndex].merchandiseList = [...invoicesInfosTemp[action.invoiceIndex].merchandiseList.filter(item => item.merchandiseId !== action.merchandiseId)];
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case UPDATE_ITEM_VALUES:
      {
        const {
          invoices
        } = state;
        const invoicesInfosTemp = invoices.map(invoice => {
          var _action$payload;
          const {
            invoiceId,
            merchandiseList
          } = invoice;
          const matchingInvoice = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.find(inv => inv.invoiceId === invoiceId);
          if (matchingInvoice) {
            const updatedMerchandiseList = merchandiseList === null || merchandiseList === void 0 ? void 0 : merchandiseList.map(merch => {
              const matchingMerchandise = matchingInvoice.merchandises.find(inv => inv.merchandiseId === merch.merchandiseId);
              if (matchingMerchandise) {
                return {
                  ...merch,
                  convertedUnitValue: matchingMerchandise.convertedUnitValue
                };
              }
              return merch;
            });
            return {
              ...invoice,
              merchandiseList: updatedMerchandiseList
            };
          }
          return invoice;
        });
        return {
          ...state,
          invoices: invoicesInfosTemp
        };
      }
    case ADD_MERCHANDISE_DOC_BY_ID$2:
      {
        const {
          payload: {
            merchandiseId,
            invoiceId,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoices: [...state.invoices.map(item => item.invoiceId == invoiceId ? {
            ...item,
            merchandiseList: [...item.merchandiseList.map(merchItem => merchItem.merchandiseId == merchandiseId ? {
              ...merchItem,
              [`${tableName}`]: [...merchItem[`${tableName}`], rest]
            } : merchItem)]
          } : item)]
        };
      }
    case DELETE_MERCHANDISE_DOC_BY_ID$2:
      {
        const {
          id,
          fieldIdName,
          payload: {
            merchandiseId,
            invoiceId
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoices: [...state.invoices.map(item => item.invoiceId == invoiceId ? {
            ...item,
            merchandiseList: [...item.merchandiseList.map(merchItem => merchItem.merchandiseId == merchandiseId ? {
              ...merchItem,
              [`${tableName}`]: [...merchItem[`${tableName}`].filter(item => item[`${fieldIdName}`] != id)]
            } : merchItem)]
          } : item)]
        };
      }
    case UPDATE_MERCHANDISE_DOC_BY_ID$2:
      {
        const {
          id,
          fieldIdName,
          payload: {
            merchandiseId,
            invoiceId,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoices: [...state.invoices.map(item => item.invoiceId == invoiceId ? {
            ...item,
            merchandiseList: [...item.merchandiseList.map(merchItem => merchItem.merchandiseId == merchandiseId ? {
              ...merchItem,
              [`${tableName}`]: [...merchItem[`${tableName}`].map(tableItem => tableItem[`${fieldIdName}`] == id ? {
                ...tableItem,
                ...rest
              } : tableItem)]
            } : merchItem)]
          } : item)]
        };
      }
    case UPDATE_MERCHANDISE_AFTER_SAVE:
      {
        const {
          payload: {
            merchandiseId,
            invoiceId,
            totalAmount
          }
        } = action;
        return {
          ...state,
          invoices: [...state.invoices.map(item => item.invoiceId == invoiceId ? {
            ...item,
            merchandiseList: [...item.merchandiseList.map(merchItem => merchItem.merchandiseId == merchandiseId ? {
              ...merchItem,
              totalAmount: totalAmount ? totalAmount : merchItem.totalAmount
            } : merchItem)]
          } : item)]
        };
      }
    case MASS_UPDATE_REPEATABLE_ELEMENTS$1:
      {
        var _state$invoices;
        const {
          ids,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoices: state === null || state === void 0 ? void 0 : (_state$invoices = state.invoices) === null || _state$invoices === void 0 ? void 0 : _state$invoices.map(inv => {
            var _inv$merchandiseList;
            return {
              ...inv,
              merchandiseList: inv === null || inv === void 0 ? void 0 : (_inv$merchandiseList = inv.merchandiseList) === null || _inv$merchandiseList === void 0 ? void 0 : _inv$merchandiseList.map(merch => {
                const currMerch = ids === null || ids === void 0 ? void 0 : ids.find(item => (item === null || item === void 0 ? void 0 : item.merchandiseId) === (merch === null || merch === void 0 ? void 0 : merch.merchandiseId));
                if (currMerch) {
                  return {
                    ...merch,
                    [tableName]: merch !== null && merch !== void 0 && merch[tableName] ? [...(merch === null || merch === void 0 ? void 0 : merch[tableName]), currMerch] : [currMerch]
                  };
                } else {
                  return merch;
                }
              })
            };
          })
        };
      }
    default:
      return state;
  }
}

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */
const initialState$E = {
  formLoaded: false,
  shipmentId: null,
  userType: null,
  newValue: null,
  setINPUTID: null,
  penClicked: null,
  fieldName: null,
  errorMessage: null
};
function FormReducer$2(state = initialState$E, action) {
  switch (action.type) {
    case FORM_LOADED:
      {
        return Object.assign({}, state, {
          formLoaded: action.formLoaded,
          shipmentId: action.shipmentId,
          shipmentCountry: action.shipmentCountry,
          userType: action.userType,
          error: action.error
        });
      }
    case FORM_VALUES$3:
      {
        return Object.assign({}, state, {
          newValue: action.newValue,
          setINPUTID: action.setINPUTID,
          penClicked: action.penClicked,
          fieldName: action.fieldName,
          rbCounterID: action.rbCounterID
        });
      }
    case SET_ANY_FORM_VALUES$3:
      {
        return Object.assign({}, state, {
          [action.valueName]: action.value
        });
      }
    case SET_ERROR_MESSAGE$2:
      {
        return Object.assign({}, state, {
          errorMessage: action.errorMessage
        });
      }
    default:
      return state;
  }
}

const initialState$D = {};
function DropDownReducer$2(state = initialState$D, action) {
  switch (action.type) {
    case INITIALIZE_DROPDOWNS$3:
      {
        return Object.assign({}, state, {
          ...action.payload
        });
      }
    case UPDATE_DROPDOWNS:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    default:
      return state;
  }
}

const initialState$C = {
  shipmentNotesNodes: []
};
function NotesReducer$2(state = initialState$C, action) {
  switch (action.type) {
    case INITIALIZE_VALUES_NOTES$3:
      let newState = {
        ...state
      };
      newState.shipmentNotesNodes = action.payload.hasOwnProperty("shipmentNotesNodes") === true ? action.payload.shipmentNotesNodes : [];
      newState.notesLoaded = action.notesLoaded;
      return newState;
    case UPDATE_NOTES_ITEM_STATUS$3:
      {
        let newState = {
          ...state
        };
        newState.shipmentNotesNodes[action.index][action.field] = action.payload;
        return newState;
      }
    case "DONT_SHOW_NOTES_ITEM":
      {
        let newState = {
          ...state
        };
        newState.notesLoaded = action.value;
        return newState;
      }
    case ADD_NOTES_ITEM$3:
      {
        let newshipmentNotesNodes = state.shipmentNotesNodes.slice();
        if (action.payload) {
          newshipmentNotesNodes.unshift(action.payload);
        }
        return Object.assign({}, state, {
          shipmentNotesNodes: newshipmentNotesNodes
        });
      }
    default:
      return state;
  }
}

const newCostTypeRow = (costTypeId = '') => {
  return {
    costTypeId,
    costTypeIndex: 0,
    costType: '',
    amount: 0 .toFixed(2),
    currency: '',
    exchangeRate: 0 .toFixed(8),
    euroValue: 0 .toFixed(2),
    custValue: 0 .toFixed(2),
    statValue: 0 .toFixed(2)
  };
};
const actorNames = {
  brokerName: "DECLARANT_NAME",
  buyerName: "BUYER_NAME",
  consigneeName: "CONSIGNEE_NAME",
  consignorName: "CONSIGNOR_NAME",
  sellerName: "SELLER_NAME"
};
const convertedProratedData = data => {
  var _data$map;
  const newData = data === null || data === void 0 ? void 0 : (_data$map = data.map(itm => {
    const {
      merchandise: prorateMerchandiseResponse,
      ...rest
    } = itm;
    return {
      prorateMerchandiseResponse,
      ...rest
    };
  })) === null || _data$map === void 0 ? void 0 : _data$map.map(itmNext => {
    return {
      ...itmNext,
      prorateMerchandiseResponse: itmNext.prorateMerchandiseResponse.map(elem => {
        const {
          merchandiseCostType: merchandiseCostTypeResponse,
          ...restElem
        } = elem;
        return {
          merchandiseCostTypeResponse,
          ...restElem
        };
      })
    };
  });
  return newData;
};
const convertedData = inputData => {
  return inputData.reduce((transformedData, entry) => {
    var _entry$items;
    const existingEntry = transformedData.find(item => item.codeDescription === entry.codeDescription);
    const transformedItem = {
      conditionDescription: entry.conditionDescription,
      items: (_entry$items = entry.items) === null || _entry$items === void 0 ? void 0 : _entry$items.map(item => ({
        action: {
          description: item.action.description,
          certificate: item.certificate || null,
          amount: item.amount
        }
      }))
    };
    if (existingEntry) {
      existingEntry.conditions.push(transformedItem);
    } else {
      const newEntry = {
        codeDescription: entry.codeDescription,
        conditions: [transformedItem]
      };
      transformedData.push(newEntry);
    }
    return transformedData;
  }, []);
};

const ADD_VALUE_BUILD_UP$1 = "ADD_VALUE_BUILD_UP";
const UPDATE_VALUE_BUILD_UP$1 = "UPDATE_VALUE_BUILD_UP";
const UPDATE_VALUE_BUILD_UP_COST_TYPE$1 = "UPDATE_VALUE_BUILD_UP_COST_TYPE";
const DELETE_VALUE_BUILD_UP$1 = "DELETE_VALUE_BUILD_UP";
const INITIALIZE_VALUE_BUILD_UP = "INITIALIZE_VALUE_BUILD_UP";
const CLEAR_FORM$3 = "CLEAR_FORM";

const initialState$B = {
  insurancePercentage: '0.00',
  insuranceIncludesFreightCharges: '0',
  upliftPercentage: '0.00',
  upliftIncludeFreightCharges: '0',
  totalFreightCharges: '0.00',
  prorateStrategy: 'DoNotProrate',
  totalAdditionDeductionCustomsValue: '0.00',
  totalAdditionDeductionCustomsValue: '0.00',
  invoiceValue: '0.00',
  shipmentCostType: [],
  shipmentInvoice: [],
  partyDependency: []
};
const ValueBuildUpReducer = (state = initialState$B, action) => {
  switch (action.type) {
    case ADD_VALUE_BUILD_UP$1:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        let newState = {
          ...state
        };
        let costList = newState.shipmentCostType;
        costList = [...costList, payload];
        return {
          ...newState,
          shipmentCostType: costList
        };
      }
    case INITIALIZE_VALUE_BUILD_UP:
      {
        var _action$payload, _action$payload2, _action$payload2$part;
        let newState = {
          ...state
        };
        newState.proratedData = convertedProratedData((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.shipmentInvoice);
        // console.log("Action",action)
        return {
          ...newState,
          ...action.payload,
          partyDependency: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$part = _action$payload2.partyDependency) === null || _action$payload2$part === void 0 ? void 0 : _action$payload2$part.split(',')) || []
        };
      }
    case UPDATE_VALUE_BUILD_UP$1:
      {
        let newState = {
          ...state
        };
        newState = {
          ...newState,
          ...action.payload
        };
        return newState;
      }
    case UPDATE_VALUE_BUILD_UP_COST_TYPE$1:
      {
        const {
          id,
          payload,
          meta: {
            tableName
          }
        } = action;
        let temp = [...state[tableName]];
        const index = temp.findIndex(c => c.costTypeId == id);
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case DELETE_VALUE_BUILD_UP$1:
      {
        const {
          id,
          meta: {
            tableName
          }
        } = action;
        let temp = [...state[tableName]];
        temp = temp.filter(c => c.costTypeId != id);
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case 'UPDATE_PARTY_DEPENDENCIES':
      {
        const {
          value,
          isChecked
        } = action.payload;
        return {
          ...state,
          partyDependency: isChecked ? [...state.partyDependency, value] : state.partyDependency.filter(itm => itm !== value)
        };
      }
    case CLEAR_FORM$3:
      {
        return initialState$B;
      }
    default:
      return state;
  }
};

const initialState$A = {};
function ContainerReducer(state = initialState$A, action) {
  switch (action.type) {
    case INITIALIZE_HEADER_CONTAINER:
      {
        return Object.assign({}, state, {
          containers: action.containers
        });
      }
    case UPDATE_CONTAINER:
      {
        const containersTemp = [...state.containers];
        containersTemp[action.index] = {
          ...containersTemp[action.index],
          ["containerNumber"]: action.containerNumber
        };
        return {
          ...state,
          containers: containersTemp
        };
      }
    case ADD_CONTAINER:
      {
        return {
          ...state,
          [`containers`]: [...state["containers"], action.payload]
        };
      }
    case DELETE_CONTAINER:
      {
        const {
          containerId
        } = action;
        return {
          ...state,
          [`containers`]: state["containers"].filter(c => c.containerId != containerId)
        };
      }
    default:
      {
        return state;
      }
  }
}

const initialState$z = {
  serverErrors: [],
  headerTab: [],
  partiestab: [],
  itemsTab: [],
  valueBuildUpTab: []
};
function ServerErrorReducer(state = initialState$z, action) {
  switch (action.type) {
    case "INITIALIZE_SERVER_ERRORS":
      {
        let newState = {
          ...state
        };
        return newState;
      }
    case "SET_SERVER_ERRORS":
      {
        let newState = {
          ...state
        };
        newState["serverErrors"] = action.payload;
        return newState;
      }
    case "RESET_SERVER_ERRORS":
      {
        let newState = {
          serverErrors: []
        };
        return newState;
      }
    // Header Tab
    case "ES_INIT_HEADER_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        newState[`${action.level}`] = action.payload;
        return newState;
      }
    case "ES_ADD_HEADER_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState ? currentState.filter(item => item.fieldName !== currentFieldName) : [];
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case "ES_DELETE_HEADER_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    //Parties Tab

    case "ES_INIT_PARTIES_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        newState[`${action.level}`] = action.payload;
        return newState;
      }
    case "ES_ADD_PARTIES_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState.filter(item => item.fieldName !== currentFieldName);
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case "ES_DELETE_PARTIES_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    // itemsTab

    case "ES_INIT_ITEMS_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        newState[`${action.level}`] = action.payload;
        return newState;
      }
    case "ES_ADD_ITEMS_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState.filter(item => item.fieldName !== currentFieldName);
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case "ES_DELETE_ITEMS_TAB_WARNINGS":
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    default:
      return state;
  }
}

function createReducer$3(asyncReducers) {
  return redux.combineReducers({
    Actor: ActorReducer$2,
    Shipment: ShipmentReducer$2,
    FormValues: FormReducer$2,
    DropDownValues: DropDownReducer$2,
    InvoicesReducer: InvoicesReducer$2,
    NotesReducer: NotesReducer$2,
    ValueBuildUpReducer,
    ContainerReducer,
    ServerErrorReducer,
    ...asyncReducers
  });
}

const composeEnhancers$2 = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : redux.compose;
const middleware$2 = [thunkMiddleware__default["default"]];

// process.env.NODE_ENV !== 'production' && middleware.push(logger)

const enhancer$2 = composeEnhancers$2(redux.applyMiddleware(...middleware$2)
// other store enhancers if any
);
// const store = createStore(rootReducer, enhancer)

function configureStore$3() {
  const store = redux.createStore(createReducer$3(), enhancer$2);
  store.asyncReducers = {};
  return store;
}
var store$4 = configureStore$3();

// Header Start

// Header End

const DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$2 = "DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER";
const ADD_ADDITONAL_INFO$2 = "ADD_ADDITONAL_INFO";
const UPDATE_SHIPMENT_FIELD_VALUE$2 = 'UPDATE_SHIPMENT_FIELD_VALUE';
const UPDATE_AI_STATEMENT_INFO_FIELDS$2 = "UPDATE_AI_STATEMENT_INFO_FIELDS";
const ADD_AI_CODES_AND_STATEMENT_INFO$2 = "ADD_AI_CODES_AND_STATEMENT_INFO";
const UPDATE_ITEM_AI_INFO_FIELD$2 = "UPDATE_ITEM_AI_INFO_FIELD";
const ADD_AI_CODES_AND_STATEMENT_INFO_M$2 = "ADD_AI_CODES_AND_STATEMENT_INFO_M";
const REMOVE_AI_ITEM_INFO$1 = "REMOVE_AI_ITEM_INFO";
const UPDATE_SHIP_DUTY_FIELD$2 = 'UPDATE_SHIP_DUTY_FIELD';
const SAVE_MERCHANDISE_FIELD$1 = 'SAVE_MERCHANDISE_FIELD';
const SAVE_MERCHANDISE_LINE_ITEM$1 = 'SAVE_MERCHANDISE_LINE_ITEM';
const UPDATE_MERCH_LINE_ITEM_FIELD$1 = 'UPDATE_MERCH_LINE_ITEM_FIELD';
const REMOVE_MERCHANDISE_LINE_ITEM$1 = 'REMOVE_MERCHANDISE_LINE_ITEM';
const ADD_MERCH_DUTY$1 = 'ADD_MERCH_DUTY';
const ADD_MERCH_SUMMARY$1 = 'ADD_MERCH_SUMMARY';
const UPDATE_MERCH_DUTY_FIELD$2 = 'UPDATE_MERCH_DUTY_FIELD';
const REMOVE_DUTY_ITEM$2 = 'REMOVE_DUTY_ITEM';
const UPDATE_INVOICE_LINE_ITEM_FIELD$2 = 'UPDATE_INVOICE_LINE_ITEM_FIELD';
const UPDATE_ITEM_SUMMARY_INFO_FIELD$2 = 'UPDATE_ITEM_SUMMARY_INFO_FIELD';
const ADD_ITEM_INFO$1 = 'ADD_ITEM_INFO';
const UPDATE_ITEM_INFO_FIELD$2 = 'UPDATE_ITEM_INFO_FIELD';
const REMOVE_ITEM_INFO$2 = 'REMOVE_ITEM_INFO';
const FORM_VALUES$2 = 'FORM_VALUES';
const SET_ANY_FORM_VALUES$2 = 'SET_ANY_FORM_VALUES';
const DELETE_SUMMARY$2 = "DELETE_SUMMARY";
const UPDATE_INVOICE_DATE$1 = "UPDATE_INVOICE_DATE";
const REMOVE_INVOICE_LINE_ITEM$1 = "REMOVE_INVOICE_LINE_ITEM";
const CREATE_MERCHANDISE_LINE_ITEM$1 = "CREATE_MERCHANDISE_LINE_ITEM";
const ADD_INVOICE_ITEM$1 = "ADD_INVOICE_ITEM";
const UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$2 = "UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD";
const REMOVE_CONTAINER$2 = "REMOVE_CONTAINER";
const ADD_NEW_CONTAINER$2 = "ADD_NEW_CONTAINER";
const ADD_DOC_CODE_STATEMENT$2 = "ADD_DOC_CODE_STATEMENT";
const UPDATE_ITEM_DOC_CODE_STMT_FIELD$2 = "UPDATE_ITEM_DOC_CODE_STMT_FIELD";
const REMOVE_DOC_CODE_STMT_ITEM_INFO$2 = "REMOVE_DOC_CODE_STMT_ITEM_INFO";
const INITIALIZE_VALUES_NOTES$2 = "INITIALIZE_VALUES_NOTES";
const UPDATE_NOTES_ITEM_STATUS$2 = "UPDATE_NOTES_ITEM_STATUS";
const ADD_NOTES_ITEM$2 = "ADD_NOTES_ITEM";
const WHEN_SHIPMENT_CHANGED$2 = "WHEN_SHIPMENT_CHANGED";
const COLLAPSE_LINE_ITEMS$2 = "COLLAPSE_LINE_ITEMS";
const EXPAND_LINE_ITEMS$2 = "EXPAND_LINE_ITEMS";
const UPDATE_MERCHANDISE_COUNT$2 = "UPDATE_MERCHANDISE_COUNT";
const EXPAND_ALL_LINE_ITEMS$2 = "EXPAND_ALL_LINE_ITEMS";
const EXPAND_LINE_ITEM$2 = "EXPAND_LINE_ITEM";
const ADD_ITEM = "ADD_ITEM";
const DELETE_ITEM = "DELETE_ITEM";
const UPDATE_ITEM = "UPDATE_ITEM";
const UPDATE_TRANSPORT_DETAILS$2 = "UPDATE_TRANSPORT_DETAILS";
const UPDATE_TRANSPORT_HEADER_INFO$2 = "UPDATE_TRANSPORT_HEADER_INFO";
const ADD_VALUE_BUILD_UP = "ADD_VALUE_BUILD_UP";
const UPDATE_VALUE_BUILD_UP = "UPDATE_VALUE_BUILD_UP";
const UPDATE_VALUE_BUILD_UP_COST_TYPE = 'UPDATE_VALUE_BUILD_UP_COST_TYPE';
const DELETE_VALUE_BUILD_UP = "DELETE_VALUE_BUILD_UP";
const INITIALIZE_PARTIES_FORM$2 = 'INITIALIZE_PARTIES_FORM';
const INITIALIZE_HEADER_FORM$2 = 'INITIALIZE_HEADER_FORM';
const INITIALIZE_TRANSPORT_FORM = 'INITIALIZE_TRANSPORT_FORM';
const CLEAR_FORM$2 = 'CLEAR_FORM';
const ES_INIT_ITEMS_TAB_WARNINGS = "ES_INIT_ITEMS_TAB_WARNINGS";
const ES_ADD_ITEMS_TAB_WARNINGS = "ES_ADD_ITEMS_TAB_WARNINGS";
const ES_DELETE_ITEMS_TAB_WARNINGS = "ES_DELETE_ITEMS_TAB_WARNINGS";

// action types for billings start

const ADD_ITEM_BILLINGS = 'ADD_ITEM_BILLINGS';
const DELETE_ITEM_BILLINGS = 'DELETE_ITEM_BILLINGS';
const UPDATE_ITEM_BILLINGS = 'UPDATE_ITEM_BILLINGS';
const INITIALIZE_DROPDOWNS$2 = 'INITIALIZE_DROPDOWNS';
const GET_BILLINGS_LIST = 'GET_BILLINGS_LIST';
const DISABLE_NEW_ROW = 'DISABLE_NEW_ROW';
const UPDATE_ITEM_BILLINGS_TOTAL = 'UPDATE_ITEM_BILLINGS_TOTAL';
const HANDLE_BILLABLE = 'HANDLE_BILLABLE';
const REFRESH_BILLINGS_LIST = 'REFRESH_BILLINGS_LIST';
const HANDLE_ISLOADING = 'HANDLE_ISLOADING';
const INITIALIZE_ISBILLABLE = "INITIALIZE_ISBILLABLE";
// action types for biling end

const ES_INIT_HEADER_TAB_WARNINGS = "ES_INIT_HEADER_TAB_WARNINGS";
const ES_ADD_HEADER_TAB_WARNINGS = "ES_ADD_HEADER_TAB_WARNINGS";
const ES_DELETE_HEADER_TAB_WARNINGS = "ES_DELETE_HEADER_TAB_WARNINGS";
const INITIALIZE_SERVER_ERRORS = "INITIALIZE_SERVER_ERRORS";
const SET_SERVER_ERRORS = "SET_SERVER_ERRORS";
const RESET_SERVER_ERRORS = "RESET_SERVER_ERRORS";
const ES_INIT_PARTIES_TAB_WARNINGS = "ES_INIT_PARTIES_TAB_WARNINGS";
const ES_ADD_PARTIES_TAB_WARNINGS = "ES_ADD_PARTIES_TAB_WARNINGS";
const ES_DELETE_PARTIES_TAB_WARNINGS = "ES_DELETE_PARTIES_TAB_WARNINGS";

// for container tab
const ADD_ITEM_CONTAINER_TAB$2 = "ADD_ITEM_CONTAINER_TAB";
const DELETE_ITEM_CONTAINER_TAB$2 = "DELETE_ITEM_CONTAINER_TAB";
const UPDATE_ITEM_CONTAINER_TAB$2 = "UPDATE_ITEM_CONTAINER_TAB";
const GET_ITEM_CONTAINER_TAB$2 = "GET_ITEM_CONTAINER_TAB";
const HANDLE_LOADING_CONTAINER_TAB$1 = "HANDLE_LOADING_CONTAINER_TAB";
const SAVE_FORM_CDS$1 = "SAVE_FORM_CDS";

// for value build up 
const ADD_ITEM_VALUE_BUILD_UP$2 = "ADD_ITEM_VALUE_BUILD_UP";
const ES_INIT_VALUE_BUILD_UP_TAB_WARNINGS = "ES_INIT_VALUE_BUILD_UP_TAB_WARNINGS";
const ES_ADD_VALUE_BUILD_UP_TAB_WARNINGS = "ES_ADD_VALUE_BUILD_UP_TAB_WARNINGS";
const ES_DELETE_VALUE_BUILD_UP_TAB_WARNINGS = "ES_DELETE_VALUE_BUILD_UP_TAB_WARNINGS";

// ui error constants
const INIT_VALIDATION_ERRORS$1 = 'INIT_VALIDATION_ERRORS';
const UPDATE_VALIDATION_ERRORS$1 = 'UPDATE_VALIDATION_ERRORS';

// transport tab AES AND DMS

const ADD_ITEM_TRANSPORT = 'ADD_ITEM_TRANSPORT';
const UPDATE_ITEM_TRANSPORT = 'UPDATE_ITEM_TRANSPORT';
const DELETE_ITEM_TRANSPORT = 'DELETE_ITEM_TRANSPORT';

// Parties
const ADD_ITEM_PARTIES$2 = "ADD_ITEM_PARTIES";
const UPDATE_ITEM_PARTIES$2 = "UPDATE_ITEM_PARTIES";
const DELETE_ITEM_PARTIES$2 = "DELETE_ITEM_PARTIES";
const UPDATE_CONTACT_INFO_PARTIES = "UPDATE_CONTACT_INFO_PARTIES";

// Container

const ADD_ITEM_CONTAINER = "ADD_ITEM_CONTAINER";
const UPDATE_ITEM_CONTAINER = "UPDATE_ITEM_CONTAINER";
const DELETE_ITEM_CONTAINER$1 = "DELETE_ITEM_CONTAINER";
const INITIALIZE_CONTAINER_FORM = "INITIALIZE_CONTAINER_FORM";

//  intialize dropdown

const CLEAR_DROPDOWN = 'CLEAR_DROPDOWN';

var ActionTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER: DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$2,
  ADD_ADDITONAL_INFO: ADD_ADDITONAL_INFO$2,
  UPDATE_SHIPMENT_FIELD_VALUE: UPDATE_SHIPMENT_FIELD_VALUE$2,
  UPDATE_AI_STATEMENT_INFO_FIELDS: UPDATE_AI_STATEMENT_INFO_FIELDS$2,
  ADD_AI_CODES_AND_STATEMENT_INFO: ADD_AI_CODES_AND_STATEMENT_INFO$2,
  UPDATE_ITEM_AI_INFO_FIELD: UPDATE_ITEM_AI_INFO_FIELD$2,
  ADD_AI_CODES_AND_STATEMENT_INFO_M: ADD_AI_CODES_AND_STATEMENT_INFO_M$2,
  REMOVE_AI_ITEM_INFO: REMOVE_AI_ITEM_INFO$1,
  UPDATE_SHIP_DUTY_FIELD: UPDATE_SHIP_DUTY_FIELD$2,
  SAVE_MERCHANDISE_FIELD: SAVE_MERCHANDISE_FIELD$1,
  SAVE_MERCHANDISE_LINE_ITEM: SAVE_MERCHANDISE_LINE_ITEM$1,
  UPDATE_MERCH_LINE_ITEM_FIELD: UPDATE_MERCH_LINE_ITEM_FIELD$1,
  REMOVE_MERCHANDISE_LINE_ITEM: REMOVE_MERCHANDISE_LINE_ITEM$1,
  ADD_MERCH_DUTY: ADD_MERCH_DUTY$1,
  ADD_MERCH_SUMMARY: ADD_MERCH_SUMMARY$1,
  UPDATE_MERCH_DUTY_FIELD: UPDATE_MERCH_DUTY_FIELD$2,
  REMOVE_DUTY_ITEM: REMOVE_DUTY_ITEM$2,
  UPDATE_INVOICE_LINE_ITEM_FIELD: UPDATE_INVOICE_LINE_ITEM_FIELD$2,
  UPDATE_ITEM_SUMMARY_INFO_FIELD: UPDATE_ITEM_SUMMARY_INFO_FIELD$2,
  ADD_ITEM_INFO: ADD_ITEM_INFO$1,
  UPDATE_ITEM_INFO_FIELD: UPDATE_ITEM_INFO_FIELD$2,
  REMOVE_ITEM_INFO: REMOVE_ITEM_INFO$2,
  FORM_VALUES: FORM_VALUES$2,
  SET_ANY_FORM_VALUES: SET_ANY_FORM_VALUES$2,
  DELETE_SUMMARY: DELETE_SUMMARY$2,
  UPDATE_INVOICE_DATE: UPDATE_INVOICE_DATE$1,
  REMOVE_INVOICE_LINE_ITEM: REMOVE_INVOICE_LINE_ITEM$1,
  CREATE_MERCHANDISE_LINE_ITEM: CREATE_MERCHANDISE_LINE_ITEM$1,
  ADD_INVOICE_ITEM: ADD_INVOICE_ITEM$1,
  UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD: UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$2,
  REMOVE_CONTAINER: REMOVE_CONTAINER$2,
  ADD_NEW_CONTAINER: ADD_NEW_CONTAINER$2,
  ADD_DOC_CODE_STATEMENT: ADD_DOC_CODE_STATEMENT$2,
  UPDATE_ITEM_DOC_CODE_STMT_FIELD: UPDATE_ITEM_DOC_CODE_STMT_FIELD$2,
  REMOVE_DOC_CODE_STMT_ITEM_INFO: REMOVE_DOC_CODE_STMT_ITEM_INFO$2,
  INITIALIZE_VALUES_NOTES: INITIALIZE_VALUES_NOTES$2,
  UPDATE_NOTES_ITEM_STATUS: UPDATE_NOTES_ITEM_STATUS$2,
  ADD_NOTES_ITEM: ADD_NOTES_ITEM$2,
  WHEN_SHIPMENT_CHANGED: WHEN_SHIPMENT_CHANGED$2,
  COLLAPSE_LINE_ITEMS: COLLAPSE_LINE_ITEMS$2,
  EXPAND_LINE_ITEMS: EXPAND_LINE_ITEMS$2,
  UPDATE_MERCHANDISE_COUNT: UPDATE_MERCHANDISE_COUNT$2,
  EXPAND_ALL_LINE_ITEMS: EXPAND_ALL_LINE_ITEMS$2,
  EXPAND_LINE_ITEM: EXPAND_LINE_ITEM$2,
  ADD_ITEM: ADD_ITEM,
  DELETE_ITEM: DELETE_ITEM,
  UPDATE_ITEM: UPDATE_ITEM,
  UPDATE_TRANSPORT_DETAILS: UPDATE_TRANSPORT_DETAILS$2,
  UPDATE_TRANSPORT_HEADER_INFO: UPDATE_TRANSPORT_HEADER_INFO$2,
  ADD_VALUE_BUILD_UP: ADD_VALUE_BUILD_UP,
  UPDATE_VALUE_BUILD_UP: UPDATE_VALUE_BUILD_UP,
  UPDATE_VALUE_BUILD_UP_COST_TYPE: UPDATE_VALUE_BUILD_UP_COST_TYPE,
  DELETE_VALUE_BUILD_UP: DELETE_VALUE_BUILD_UP,
  INITIALIZE_PARTIES_FORM: INITIALIZE_PARTIES_FORM$2,
  INITIALIZE_HEADER_FORM: INITIALIZE_HEADER_FORM$2,
  INITIALIZE_TRANSPORT_FORM: INITIALIZE_TRANSPORT_FORM,
  CLEAR_FORM: CLEAR_FORM$2,
  ES_INIT_ITEMS_TAB_WARNINGS: ES_INIT_ITEMS_TAB_WARNINGS,
  ES_ADD_ITEMS_TAB_WARNINGS: ES_ADD_ITEMS_TAB_WARNINGS,
  ES_DELETE_ITEMS_TAB_WARNINGS: ES_DELETE_ITEMS_TAB_WARNINGS,
  ADD_ITEM_BILLINGS: ADD_ITEM_BILLINGS,
  DELETE_ITEM_BILLINGS: DELETE_ITEM_BILLINGS,
  UPDATE_ITEM_BILLINGS: UPDATE_ITEM_BILLINGS,
  INITIALIZE_DROPDOWNS: INITIALIZE_DROPDOWNS$2,
  GET_BILLINGS_LIST: GET_BILLINGS_LIST,
  DISABLE_NEW_ROW: DISABLE_NEW_ROW,
  UPDATE_ITEM_BILLINGS_TOTAL: UPDATE_ITEM_BILLINGS_TOTAL,
  HANDLE_BILLABLE: HANDLE_BILLABLE,
  REFRESH_BILLINGS_LIST: REFRESH_BILLINGS_LIST,
  HANDLE_ISLOADING: HANDLE_ISLOADING,
  INITIALIZE_ISBILLABLE: INITIALIZE_ISBILLABLE,
  ES_INIT_HEADER_TAB_WARNINGS: ES_INIT_HEADER_TAB_WARNINGS,
  ES_ADD_HEADER_TAB_WARNINGS: ES_ADD_HEADER_TAB_WARNINGS,
  ES_DELETE_HEADER_TAB_WARNINGS: ES_DELETE_HEADER_TAB_WARNINGS,
  INITIALIZE_SERVER_ERRORS: INITIALIZE_SERVER_ERRORS,
  SET_SERVER_ERRORS: SET_SERVER_ERRORS,
  RESET_SERVER_ERRORS: RESET_SERVER_ERRORS,
  ES_INIT_PARTIES_TAB_WARNINGS: ES_INIT_PARTIES_TAB_WARNINGS,
  ES_ADD_PARTIES_TAB_WARNINGS: ES_ADD_PARTIES_TAB_WARNINGS,
  ES_DELETE_PARTIES_TAB_WARNINGS: ES_DELETE_PARTIES_TAB_WARNINGS,
  ADD_ITEM_CONTAINER_TAB: ADD_ITEM_CONTAINER_TAB$2,
  DELETE_ITEM_CONTAINER_TAB: DELETE_ITEM_CONTAINER_TAB$2,
  UPDATE_ITEM_CONTAINER_TAB: UPDATE_ITEM_CONTAINER_TAB$2,
  GET_ITEM_CONTAINER_TAB: GET_ITEM_CONTAINER_TAB$2,
  HANDLE_LOADING_CONTAINER_TAB: HANDLE_LOADING_CONTAINER_TAB$1,
  SAVE_FORM_CDS: SAVE_FORM_CDS$1,
  ADD_ITEM_VALUE_BUILD_UP: ADD_ITEM_VALUE_BUILD_UP$2,
  ES_INIT_VALUE_BUILD_UP_TAB_WARNINGS: ES_INIT_VALUE_BUILD_UP_TAB_WARNINGS,
  ES_ADD_VALUE_BUILD_UP_TAB_WARNINGS: ES_ADD_VALUE_BUILD_UP_TAB_WARNINGS,
  ES_DELETE_VALUE_BUILD_UP_TAB_WARNINGS: ES_DELETE_VALUE_BUILD_UP_TAB_WARNINGS,
  INIT_VALIDATION_ERRORS: INIT_VALIDATION_ERRORS$1,
  UPDATE_VALIDATION_ERRORS: UPDATE_VALIDATION_ERRORS$1,
  ADD_ITEM_TRANSPORT: ADD_ITEM_TRANSPORT,
  UPDATE_ITEM_TRANSPORT: UPDATE_ITEM_TRANSPORT,
  DELETE_ITEM_TRANSPORT: DELETE_ITEM_TRANSPORT,
  ADD_ITEM_PARTIES: ADD_ITEM_PARTIES$2,
  UPDATE_ITEM_PARTIES: UPDATE_ITEM_PARTIES$2,
  DELETE_ITEM_PARTIES: DELETE_ITEM_PARTIES$2,
  UPDATE_CONTACT_INFO_PARTIES: UPDATE_CONTACT_INFO_PARTIES,
  ADD_ITEM_CONTAINER: ADD_ITEM_CONTAINER,
  UPDATE_ITEM_CONTAINER: UPDATE_ITEM_CONTAINER,
  DELETE_ITEM_CONTAINER: DELETE_ITEM_CONTAINER$1,
  INITIALIZE_CONTAINER_FORM: INITIALIZE_CONTAINER_FORM,
  CLEAR_DROPDOWN: CLEAR_DROPDOWN
});

function initServerErrors() {
  return {
    type: 'INITIALIZE_SERVER_ERRORS'
  };
}
function setServerErrors(payload) {
  return {
    type: "SET_SERVER_ERRORS",
    payload
  };
}
function resetServerErrors() {
  return {
    type: "RESET_SERVER_ERRORS"
  };
}

// Header Tab Actions

function intializeHeaderTabWarnings(level, payload) {
  return {
    type: ES_INIT_HEADER_TAB_WARNINGS,
    level,
    payload
  };
}
function addHeaderTabWarnings(level, value, fieldName) {
  return {
    type: ES_ADD_HEADER_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}
function deleteHeaderTabWarnings(level, value, fieldName) {
  return {
    type: ES_DELETE_HEADER_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}

// Parties Tab Actions

function intializePartiesTabWarnings(level, payload) {
  return {
    type: ES_INIT_PARTIES_TAB_WARNINGS,
    level,
    payload
  };
}
function addPartiesTabWarnings(level, value, fieldName) {
  return {
    type: ES_ADD_PARTIES_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}
function deletePartiesTabWarnings(level, value, fieldName) {
  return {
    type: ES_DELETE_PARTIES_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}

// Items Tab Actions

function intializeItemsTabWarnings(level, payload) {
  return {
    type: ES_INIT_ITEMS_TAB_WARNINGS,
    level,
    payload
  };
}
function addItemsTabWarnings(level, value, fieldName) {
  return {
    type: ES_ADD_ITEMS_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}
function deleteItemsTabWarnings(level, value, fieldName) {
  return {
    type: ES_DELETE_ITEMS_TAB_WARNINGS,
    value,
    fieldName,
    level
  };
}

const ShipmentInfoContext = /*#__PURE__*/React__default["default"].createContext();
const ShipmentInfoProvider = props => {
  const {
    exitInfoStatus,
    serviceType,
    declarationStatus,
    saveEvent,
    deleteEvent,
    isDMS,
    isDisabled,
    customJobState,
    currentJobState,
    children,
    shipmentId,
    updateShipmentId,
    updateShipmentMode,
    isRFI = false,
    isRFIDisabled = false,
    countryCode,
    version,
    kxUser,
    currentJobData,
    jobWheels,
    allDocs,
    kxEngineUserInfo
  } = props;
  const values = React$1.useMemo(() => {
    return {
      isImportShipment: serviceType == "IM",
      declarationStatus,
      exitInfoStatus,
      saveEvent,
      deleteEvent,
      isDMS: version == 'DMS',
      serviceType,
      isDisabled,
      currentJobState,
      customJobState,
      shipmentId,
      updateShipmentId,
      updateShipmentMode,
      isRFI,
      isRFIDisabled,
      countryCode,
      version,
      kxUser,
      currentJobData,
      jobWheels,
      allDocs,
      kxEngineUserInfo
    };
  }, [serviceType, declarationStatus, exitInfoStatus, saveEvent, deleteEvent, isDisabled, currentJobState, customJobState, shipmentId, updateShipmentId, updateShipmentMode, isRFI, isRFIDisabled, version, countryCode, kxUser, currentJobData, jobWheels, allDocs, kxEngineUserInfo]);
  return /*#__PURE__*/React__default["default"].createElement(ShipmentInfoContext.Provider, {
    value: values
  }, children);
};

const useCurrentShipmentType = () => {
  const shipmentInfo = React$1.useContext(ShipmentInfoContext);
  return shipmentInfo;
};

const ShipmentDataHOC$1 = Component => ({
  ...props
}) => {
  const currShipData = useCurrentShipmentType();
  const {
    isDisabled
  } = currShipData || {};
  return /*#__PURE__*/React__default["default"].createElement(Component, _extends$1({}, props, {
    isDisabled: props.isDisabled != null || props.isDisabled != undefined || props.isDisabled === false ? props.isDisabled : isDisabled
  }));
};

const errorPopup = errors => {
  var _errors;
  errors = Array.isArray(errors) ? errors : errors ? [errors] : [];
  if (!((_errors = errors) !== null && _errors !== void 0 && _errors.length)) return '';
  const error = errors.map((info, index) => {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "error",
      key: index
    }, "* ", info);
  });
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "warning sign",
      color: "red"
    }),
    content: error || ""
  });
};
const getDropDownText = (option, lang, displayType) => {
  let displayText = "";
  // if (option.stringVal) {
  //   // If there is a stringVal, use that
  //   displayText = option.stringVal;
  // } else {
  let textKey = lang !== "en" ? `text_${lang}` : `text`;
  if (option.value && option[textKey]) {
    displayText = option.value + ' - ' + option[textKey];
  } else if (option.id && option['description']) {
    displayText = option.id + ' - ' + option['description'];
    return displayText;
  } else if (option[textKey]) {
    displayText = option[textKey];
  }
  // }
  if (option.type && displayType) displayText = [`${displayText}-${option.type}`];
  if (typeof displayText === "string") {
    return displayText.replace(/_/g, " ");
  }
  return displayText;
};

const CopyLabelWithIcon$1 = ({
  label,
  fieldInfo
}) => {
  const [textCopied, setTextCopiedVal] = React$1.useState(false);
  return /*#__PURE__*/React__default["default"].createElement("span", null, label, fieldInfo && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    content: textCopied ? 'Copied!' : 'Click to copy',
    position: "top center",
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: textCopied ? 'check circle' : 'copy',
      className: "copyToClipboard",
      style: {
        color: textCopied ? '#008B8F' : '#867474'
      },
      onClick: () => {
        navigator.clipboard.writeText(fieldInfo);
        setTextCopiedVal(true);
        setTimeout(() => {
          setTextCopiedVal(false);
        }, 2000);
      }
    })
  }));
};

const TranslateContext = /*#__PURE__*/React__default["default"].createContext({
  translate: value => value
});
const TranslateContextProvider = ({
  translate = item => item,
  children
}) => {
  const values = React__default["default"].useMemo(() => {
    return {
      translate
    };
  }, [translate]);
  return /*#__PURE__*/React__default["default"].createElement(TranslateContext.Provider, {
    value: values
  }, children);
};

const useTranslation = () => React__default["default"].useContext(TranslateContext).translate;

const CustomLabel = ({
  id = "",
  label,
  labelIcon,
  className,
  errors,
  boxNumber,
  value,
  title = "",
  copyToFeature
}) => {
  const translate = useTranslation();
  return /*#__PURE__*/React__default["default"].createElement("label", {
    id: id,
    title: title,
    className: className
  }, errors && errorPopup(errors), boxNumber && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ui black label input-box-number"
  }, boxNumber), translate(label), copyToFeature && /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    fieldInfo: value
  }), labelIcon && labelIcon);
};

const initialState$y = {
  value: ''
};
function searchReducer(state, action) {
  switch (action.type) {
    case 'SEARCH_FILTER':
      return {
        ...state,
        value: action.value
      };
    default:
      return state;
  }
}
const AutoComplete = /*#__PURE__*/React__default["default"].forwardRef(({
  containerClass = '',
  onBlur,
  selectedValue,
  minCharacters,
  isFooterLabel,
  labelIcon,
  boxNumber,
  errors,
  labelClassName = "",
  width,
  centerSelect,
  columnClassName = "",
  disabled,
  label = "SEARCH",
  onSearchChange,
  onSelect,
  renderItem,
  dataSource,
  debounceTime = 300,
  id,
  isDisabled
}, ref) => {
  const idText = React__default["default"].useMemo(() => Date.now(), []);
  const timeoutRef = React__default["default"].useRef();
  const [state, dispatch] = React$1.useReducer(searchReducer, initialState$y);
  const {
    value
  } = state;
  const prevDisplayText = React$1.useRef();
  React$1.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  React$1.useEffect(() => {
    // const displayText = getDropDownInputText(
    //   selectedValue,
    //   dataSource
    // )
    prevDisplayText.current = selectedValue;
    dispatch({
      type: 'SEARCH_FILTER',
      value: selectedValue
    });
  }, [selectedValue]);
  React__default["default"].useMemo(() => {
    var _errors;
    errors = Array.isArray(errors) ? errors : errors ? [errors] : [];
    if (!((_errors = errors) !== null && _errors !== void 0 && _errors.length)) return null;
    const error = errors.map((info, index) => {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "error",
        key: index
      }, "* ", info);
    });
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "warning sign",
        color: "red"
      }),
      content: error || ""
    });
  }, [errors]);
  const handleSearchChange = React__default["default"].useCallback((e, {
    value
  }) => {
    clearTimeout(timeoutRef.current);
    dispatch({
      type: 'SEARCH_FILTER',
      value: value
    });
    if (value.length < minCharacters) return;
    timeoutRef.current = setTimeout(() => {
      onSearchChange(value);
    }, debounceTime);
  }, [value]);
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    width: width,
    className: `autoComplete-search ${!columnClassName && 'floating-select'} ${centerSelect && 'floating-select-center'} ${columnClassName}`
  }, /*#__PURE__*/React__default["default"].createElement(CustomLabel, {
    id: `${idText}label`,
    style: {
      bottom: isFooterLabel ? '-17px' : '0px',
      display: 'table'
    },
    className: `${isFooterLabel ? 'label-footer' : 'label-dropdown name-label es '} ${labelClassName} ${containerClass}`,
    boxNumber: boxNumber,
    label: label,
    labelIcon: labelIcon,
    errors: errors
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Search, {
    disabled: isDisabled || disabled,
    id: id,
    fluid: true,
    input: {
      fluid: true
    },
    onSearchChange: handleSearchChange,
    icon: "search",
    onResultSelect: (e, data) => onSelect && onSelect(data.result),
    resultRenderer: renderItem,
    results: dataSource,
    value: value,
    minCharacters: minCharacters,
    onBlur: () => {
      if (prevDisplayText.current != value) {
        onBlur({
          value
        });
      }
    }
  }));
});
AutoComplete.defaultProps = {
  minCharacters: 3
};
var AutoComplete$1 = /*#__PURE__*/React__default["default"].memo(ShipmentDataHOC$1(AutoComplete));

const PopUpIcon = ({
  icon,
  popupText,
  className,
  color,
  style,
  onMount,
  position = 'top left',
  popupStyle,
  countryFlag,
  ...rest
}) => {
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, _extends$1({
    trigger: countryFlag ? /*#__PURE__*/React__default["default"].createElement(reactCircleFlags.CircleFlag, {
      countryCode: countryFlag.toLowerCase(),
      height: "14",
      style: {
        "marginLeft": "3px"
      }
    }) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      style: style,
      className: className,
      name: icon,
      color: color
    }),
    hideOnScroll: true,
    on: "hover",
    onMount: onMount,
    position: position,
    content: popupText,
    style: popupStyle
  }, rest));
};
PopUpIcon.defaultProps = {
  color: 'blue'
};
var PopUpIcon$1 = /*#__PURE__*/React__default["default"].memo(PopUpIcon);

axios__default["default"].defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
axios__default["default"].defaults.headers.common['Accept'] = 'application/json';
axios__default["default"].defaults.headers.common['Content-Type'] = 'application/json';
if (window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken') axios__default["default"].defaults.headers.common['kxToken'] = getCookie$1(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);else axios__default["default"].defaults.headers.common['kxToken'] = getCookie$1('kxBrokerToken');
axios__default["default"].defaults.method = 'post';
const custom$1 = (config = {}) => {
  config.url = axios__default["default"].defaults.baseURL + "?axd=" + config.data.eventType;
  return axios__default["default"](config);
};
const post$1 = data => {
  let config = {};
  config.data = data;
  return axios__default["default"](config);
};
const get$2 = (url = '', data = '', config = {}) => {
  config.params = data;
  config.method = 'get';
  return axios__default["default"].get(url, config);
};
const put$1 = (url = '', data = '', config = {}) => {
  return axios__default["default"].put(url, data, config);
};
const del$1 = (url = '', config = {}) => {
  return axios__default["default"].delete(url, config);
};
const HttpClient$1 = {
  custom: custom$1,
  post: post$1,
  get: get$2,
  put: put$1,
  delete: del$1
};

const GET_DROPDOWN_VALUES_ES = "GET_DROPDOWN_VALUES_ES";
const GET_FORM_ES = "GET_FORM_ES";
const SEARCH_DROPDOWN_VALUES_ES = "SEARCH_DROPDOWN_VALUES_ES";
const SAVE_FORM_ES = "SAVE_FORM_ES";
const SAVE_ITEM_ES = "SAVE_ITEM_ES";
const GET_SEARCH_BASED_OFFICE_DROPDOWN = "GET_SEARCH_BASED_OFFICE_DROPDOWN";
const DELETE_ENTITY_ES = "DELETE_ENTITY_ES";
const GET_SHIPMENT_NOTES$2 = "GET_SHIPMENT_NOTES";
const SAVE_SHIPMENT_NOTES$2 = "SAVE_SHIPMENT_NOTES";
// export const SEARCH_UNLADING_VALUE_ES = "SEARCH_UNLADING_VALUE_ES"

const MOCK_PDC = "MOCK_PDC";
const MOCK_BOX_40 = "MOCK_BOX_40";
const MOCK_BOX_44 = "MOCK_BOX_44";
const MOCK_CANCEL = "MOCK_CANCEL";
const MOCK_PDC_AMEND = "MOCK_PDC_AMEND";
const MOCK_FULL_SAD = "MOCK_FULL_SAD";
const MOCK_EXPORT_TYPE = "MOCK_EXPORT_TYPE";
const MOCK_AES = "MOCK_AES";
const GENERATE_PDF = "GENERATE_PDF";

const getESForm = (shipmentId, callback) => {
  const data = {
    eventMessage: {
      shipmentId,
      "language": "es"
    },
    eventType: GET_FORM_ES,
    eventTime: Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};
const getDropdownValues$1 = callback => {
  const data = {
    eventMessage: {
      "countryCode": "es"
    },
    eventType: GET_DROPDOWN_VALUES_ES,
    eventTime: Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};
const getsearchcDropdownValues = (dropdownType, searchFilter) => {
  const data = {
    eventMessage: {
      "dropdownType": dropdownType,
      "searchText": searchFilter,
      "countryCode": "es"
    },
    eventType: SEARCH_DROPDOWN_VALUES_ES,
    eventTime: Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};
const getShipmentNotes$1 = shipmentId => {
  const data = {
    eventMessage: {
      shipmentId
    },
    eventType: GET_SHIPMENT_NOTES$2,
    eventTime: Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};
const getCustomOfficeList = searchFilter => {
  const data = {
    "eventMessage": {
      "dropdownType": "CUSTOM_OFFICE_DETAILS",
      "searchText": searchFilter
    },
    "eventType": GET_SEARCH_BASED_OFFICE_DROPDOWN,
    "eventTime": Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};
const genrateDV1FormPDF = () => {
  const data = {
    eventMessage: {
      "shipmentId": window.shipmentId,
      "pdfType": "CLIENT_PDF_DV1_ES"
    },
    eventType: GENERATE_PDF,
    eventTime: Date.now()
  };
  return HttpClient$1.custom({
    data
  });
};

const CustomOffice = props => {
  const [officeList, setOfficeList] = React$1.useState([]);
  const getOfficeList = React$1.useCallback(async value => {
    var _response, _response$data, _response$data$eventM;
    let response = await getCustomOfficeList(value);
    response = ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM = _response$data.eventMessage) === null || _response$data$eventM === void 0 ? void 0 : _response$data$eventM.customOfficeList) || [];
    setOfficeList(response);
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(AutoComplete$1, _extends$1({
    errors: props.errors,
    labelIcon: /*#__PURE__*/React__default["default"].createElement(PopUpIcon$1, {
      icon: "info circle",
      popupText: 'enter at least 3 characters'
    })
  }, props, {
    renderItem: ({
      value,
      description
    }) => {
      return /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        },
        className: "text"
      }, `${value} - ${description.slice(1)}`);
    },
    dataSource: officeList,
    onSearchChange: getOfficeList
  }));
};

const SetSaveEvent = (eventType, eventMessage) => ({
  eventType,
  eventTime: Date.now(),
  eventMessage
});
const SetDeleteEvent = (eventType, eventMessage) => ({
  eventType: eventType,
  eventTime: Date.now(),
  eventMessage
});

const getCookie = cname => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
axios__default["default"].defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
axios__default["default"].defaults.headers.common['Accept'] = 'application/json';
axios__default["default"].defaults.headers.common['Content-Type'] = 'application/json';
if (window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken') axios__default["default"].defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);else axios__default["default"].defaults.headers.common['kxToken'] = getCookie('kxBrokerToken');
axios__default["default"].defaults.method = 'post';
const custom = (config = {}) => {
  config.url = axios__default["default"].defaults.baseURL + "?axd=" + config.data.eventType;
  if (config.data.eventType == "GENERATE_PDF") {
    let chartoAdd = config.url.indexOf('?') >= 0 ? '&' : '?';
    config.url += `${chartoAdd}timeout=100000`;
  }
  return axios__default["default"](config);
};
const post = data => {
  let config = {};
  config.data = data;
  config.url = axios__default["default"].defaults.baseURL + "?axd=" + config.data.eventType;
  return axios__default["default"](config).catch(err => err);
};
const get$1 = (url = '', data = '', config = {}) => {
  config.params = data;
  config.method = 'get';
  return axios__default["default"].get(url, config).catch(err => err);
};
const put = (url = '', data = '', config = {}) => {
  return axios__default["default"].put(url, data, config).catch(err => err);
};
const del = (url = '', config = {}) => {
  return axios__default["default"].delete(url, config).catch(err => err);
};
const HttpClient = {
  custom,
  post,
  get: get$1,
  put,
  delete: del
};

const showToast$1 = (msg = 'Something went wrong !', duration = '3000', className = 'toast') => {
  let toast = document.getElementsByClassName(className);
  if (toast[0]) {
    toast[0].style.display = 'block';
    toast[0].innerText = msg;
  }
  if (window.toastTimeOut) {
    clearTimeout(window.toastTimeOut);
  }
  window.toastTimeOut = setTimeout(() => {
    try {
      toast[0].style.display = 'none';
    } catch (e) {}
  }, duration);
};

const useHttp = () => {
  const [isLoading, setLoader] = React$1.useState(false);
  const [error, setError] = React$1.useState(false);
  const post = React$1.useCallback(async (params, isLoading = true) => {
    setLoader(isLoading);
    setError('');
    try {
      var _response$data, _response$data$eventM, _response$data2, _response$data2$event, _response$data3, _response$data3$event, _response$data4, _response$data4$event;
      const response = await HttpClient.post(params);
      setLoader(false);
      if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$eventM = _response$data.eventMessage) !== null && _response$data$eventM !== void 0 && _response$data$eventM.responseCode && (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$event = _response$data2.eventMessage) === null || _response$data2$event === void 0 ? void 0 : _response$data2$event.responseCode) != 200) {
        throw response.data.eventMessage.responseMessage;
      } else if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && (_response$data3$event = _response$data3.eventMessage) !== null && _response$data3$event !== void 0 && _response$data3$event.code && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$event = _response$data4.eventMessage) === null || _response$data4$event === void 0 ? void 0 : _response$data4$event.code) != 200) {
        if (response.data.eventMessage.code === 400) showToast$1(response.data.eventMessage.msg);else throw response.data.eventMessage.msg;
      } else return response.data.eventMessage;
    } catch (err) {
      showToast$1("Something went wrong, Check your network connection!");
      console.log(err);
      setLoader(false);
      setError(err);
    }
  }, []);
  return React__default["default"].useMemo(() => ({
    isLoading,
    post,
    error
  }), [isLoading, post, error]);
};

const useForm = containerKey => {
  const {
    isLoading,
    post,
    error
  } = useHttp();
  const {
    shipmentId,
    isImportShipment,
    saveEvent,
    deleteEvent
  } = useCurrentShipmentType();
  const saveForm = React$1.useCallback((params, isLoading = true, event = '') => {
    const request = containerKey ? {
      [`${containerKey}`]: {
        shipmentId: window.shipmentId,
        ...params
      }
    } : {
      shipmentId: window.shipmentId,
      ...params
    };
    try {
      let dataSent = SetSaveEvent(event || saveEvent, {
        ...request,
        intentExport: {
          value: !isImportShipment
        },
        shipmentId: {
          id: shipmentId || window.shipmentId
        }
      });
      return post(dataSent, isLoading);
    } catch {}
  }, [post, isImportShipment]);
  const deleteForm = React$1.useCallback(params => {
    const request = containerKey ? {
      [`${containerKey}`]: params
    } : {
      ...params
    };
    try {
      let dataSent = SetDeleteEvent(deleteEvent, {
        ...request,
        intentExport: {
          value: !isImportShipment
        },
        shipmentId: {
          id: shipmentId || window.shipmentId
        }
      });
      return post(dataSent);
    } catch {}
  }, [post, isImportShipment]);
  return {
    isLoading,
    deleteForm,
    saveForm,
    error
  };
};

const useIsFirstRender = () => {
  const isFirst = React$1.useRef(true);
  if (isFirst.current) {
    isFirst.current = false;
    return true;
  }
  return isFirst.current;
};

const useUpdateEffect = (effect, deps) => {
  const isFirst = useIsFirstRender();
  React$1.useEffect(() => {
    if (!isFirst) {
      return effect();
    }
  }, deps);
};

var validate = createCommonjsModule(function (module, exports) {
/*!
 * validate.js 0.13.1
 *
 * (c) 2013-2019 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      ;

    if (results.some(function(r) { return v.isPromise(r.error); })) {
      throw new Error("Use validate.async if you want support for promises");
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 13,
      patch: 1,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        if (!v.isDefined(str.toString)) {
          return JSON.stringify(str);
        }

        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value, options) {
      var prettify = options && options.prettify || v.prettify;
      return prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        var name = input.name.replace(/\./g, "\\\\.");
        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[name] || null;
          }
        }
        values[name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
             if (option && option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : /* istanbul ignore next */ '';
          value = v.sanitizeFormValue(_val, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = []
        , prettify = options.prettify || v.prettify;
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {
          value: v.stringifyValue(errorInfo.value, options)
        });
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options, attribute, attributes, globalOptions) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^-?(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of milliseconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      if (v.isString(options.within[value])) {
        value = options.within[value];
      }
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
    }),
    equality: function(value, options, attribute, attributes, globalOptions) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: prettify(options.attribute)});
      }
    },
    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false
        , allowDataUrl = options.allowDataUrl || this.allowDataUrl || false;
      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      if (allowDataUrl) {
        // RFC 2397
        var mediaType = "\\w+\\/[-+.\\w]+(?:;[\\w=]+)*";
        var urlchar = "[A-Za-z0-9-_.!~\\*'();\\/?:@&=+$,%]*";
        var dataurl = "data:(?:"+mediaType+")?(?:;base64)?,"+urlchar;
        regex = "(?:"+regex+")|(?:^"+dataurl+"$)";
      }

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    },
    type: v.extend(function(value, originalOptions, attribute, attributes, globalOptions) {
      if (v.isString(originalOptions)) {
        originalOptions = {type: originalOptions};
      }

      if (!v.isDefined(value)) {
        return;
      }

      var options = v.extend({}, this.options, originalOptions);

      var type = options.type;
      if (!v.isDefined(type)) {
        throw new Error("No type was specified");
      }

      var check;
      if (v.isFunction(type)) {
        check = type;
      } else {
        check = this.types[type];
      }

      if (!v.isFunction(check)) {
        throw new Error("validate.validators.type.types." + type + " must be a function.");
      }

      if (!check(value, options, attribute, attributes, globalOptions)) {
        var message = originalOptions.message ||
          this.messages[type] ||
          this.message ||
          options.message ||
          (v.isFunction(type) ? "must be of the correct type" : "must be of type %{type}");

        if (v.isFunction(message)) {
          message = message(value, originalOptions, attribute, attributes, globalOptions);
        }

        return v.format(message, {attribute: v.prettify(attribute), type: type});
      }
    }, {
      types: {
        object: function(value) {
          return v.isObject(value) && !v.isArray(value);
        },
        array: v.isArray,
        integer: v.isInteger,
        number: v.isNumber,
        string: v.isString,
        date: v.isDate,
        boolean: v.isBoolean
      },
      messages: {}
    })
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, define);
}).call(commonjsGlobal,
        /* istanbul ignore next */ exports ,
        /* istanbul ignore next */ module ,
        null);
});

const getDropDownInputText = (value, masterList) => {
  let result = value;
  let item;
  if (masterList) {
    item = masterList.find(obj => obj.value == value);
    if (item) {
      let lang = instance.language || "en";
      let textKey = lang !== "en" ? `text_${lang}` : `text`;
      let txt = item[textKey];
      if (item.value && txt && item.description) {
        result = result + " " + txt;
      } else if (item.value && txt) {
        result = result + " - " + txt;
      }
    }
  }
  return result;
};
const createValidationStructure = errors => {
  var _Object$entries;
  return (Object === null || Object === void 0 ? void 0 : (_Object$entries = Object.entries(errors)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.reduce((prev, [key, value]) => {
    return {
      ...prev,
      [key]: {
        msg: value[0]
      }
    };
  }, {})) || {};
};
const validateArray = (array, callback = () => ({})) => {
  let errors = {};
  array.forEach(item => {
    const error = callback(item) || {};
    errors = {
      ...errors,
      ...error
    };
  });
  return createValidationStructure(errors);
};
const createErrorMsgStructure = key => (error, idx) => {
  var _Object$entries2;
  return Object === null || Object === void 0 ? void 0 : (_Object$entries2 = Object.entries(error)) === null || _Object$entries2 === void 0 ? void 0 : _Object$entries2.reduce((prev, [errKey, errVal]) => {
    return {
      ...prev,
      [`${key}${idx + 1}_${errKey}`]: errVal[0] ? {
        msg: `${key} 00${idx + 1} :: ${errVal[0]}`
      } : ""
    };
  }, {});
};
const validateArrayCustom = (itemList, pattern, callback = () => ({})) => {
  let errorList = itemList === null || itemList === void 0 ? void 0 : itemList.reduce((prevErrs, item, idx) => {
    let error = validate(item, pattern) || {};
    error = callback(error, idx);
    return {
      ...prevErrs,
      ...error
    };
  }, {});
  return lodash.isEmpty(errorList) ? {} : errorList;
};
const customFunction = (options, query) => {
  const queries = query.toUpperCase();
  let result;
  result = options.filter(opt => opt.value === queries);
  return result;
};
const ESTextMapper = {
  ENTRY_NONE: "ENTRY NONE",
  ENTRY_IN_PROCESS: "ENTRY IN PROCESS",
  ENTRY_STUCK: "ENTRY STUCK",
  ENTRY_ON_HOLD: "ENTRY ON HOLD",
  ENTRY_READY: "ENTRY READY",
  ENTRY_FILED: "ENTRY FILED",
  ENTRY_ACCEPTED: "ENTRY ACCEPTED",
  ENTRY_REJECTED: "ENTRY REJECTED",
  ENTRY_AMEND_IN_PROCESS: "ENTRY AMEND IN PROCESS",
  ENTRY_AMEND_FILED: "ENTRY AMEND FILED",
  ENTRY_AMEND_ACCEPTED: "ENTRY AMEND ACCEPTED",
  ENTRY_AMEND_REJECTED: "ENTRY AMEND REJECTED"
};
const ESCustomsTextMapper = {
  CUSTOMS_NONE: "CUSTOMS NONE",
  PDI_NEW: "PDI NEW",
  PDI_FILED: "PDI FILED",
  PDI_FILED_FAILED: "PDI FILED FAILED",
  PDI_CANCELLED_FILED: "PDI CANCELLED FILED",
  PDI_CANCELLED_FILED_FAILED: "PDI CANCELLED FILED FAILED",
  PDI_ACCEPTED: "PDI ACCEPTED",
  PDI_AMEND_FILED: "PDI AMEND FILED",
  PDC_NEW: "PDC NEW",
  PDC_FILED: "PDC FILED",
  PDC_FILED_FAILED: "PDC FILED FAILED",
  PDC_CANCELLED_FILED: "PDI CANCELLED FILED",
  PDC_CANCELLED_FILED_FAILED: "PDI CANCELLED FILED FAILED",
  PDC_ACCEPTED: "PDC ACCEPTED",
  PDC_AMEND_FILED: "PDC AMEND FILED",
  FULL_SAD_FILED: "FULL SAD FILED",
  FULL_SAD_ACCEPTED: "FULL SAD ACCEPTED",
  FULL_SAD_AMEND_FILED: "FULL SAD AMEND FILED",
  FULL_SAD_FAILED: "FULL SAD FAILED",
  FULL_SAD_CANCELLED_FILED: "FULL SAD CANCELLED FILED",
  FULL_SAD_CANCELLED_FILED_FAILED: "FULL SAD CANCELLED FILED FAILED",
  COMP_C44_OR_C40_REQUIRED: "COMP C44 OR C40 REQUIRED",
  COMP_C44_OR_C40_FILED: "COMP C44 OR C40 FILED",
  COMP_C44_OR_C40_FAILED: "COMP C44 OR C40 FAILED",
  RELEASED: "RELEASED"
};
const esEntryStatusMap = description => {
  if (ESTextMapper[description]) return ESTextMapper[description];
  return description;
};
const esCustomStatusMap = description => {
  if (ESCustomsTextMapper[description]) return ESCustomsTextMapper[description];
  return description;
};
const restrictDecimal = (value, decimalCount = 2) => {
  if (!value) return true;
  const regexp = /^(?:\d*\.\d{1,2}|\d+)$/;
  return regexp.test(value);
};
const blockDecimal = e => ['.'].includes(e.key) && e.preventDefault(); //user will not be able to type dot if pass this on event onKeyDown

const INITIALIZE_ALL_VALUES$1 = 'INITIALIZE_ALL_VALUES';
const INITIALIZE_DROPDOWNS$1 = 'INITIALIZE_DROPDOWNS';
const UPDATE_ACTOR_FIELD_VALUE$1 = 'UPDATE_ACTOR_FIELD_VALUE';
const SET_ERROR_MESSAGE$1 = 'SET_ERROR_MESSAGE';
const DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$1 = 'DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER';
const ADD_ADDITONAL_INFO$1 = 'ADD_ADDITONAL_INFO';
const UPDATE_SHIPMENT_FIELD_VALUE$1 = 'UPDATE_SHIPMENT_FIELD_VALUE';
const UPDATE_AI_STATEMENT_INFO_FIELDS$1 = 'UPDATE_AI_STATEMENT_INFO_FIELDS';
const ADD_AI_CODES_AND_STATEMENT_INFO$1 = 'ADD_AI_CODES_AND_STATEMENT_INFO';
const UPDATE_ITEM_AI_INFO_FIELD$1 = 'UPDATE_ITEM_AI_INFO_FIELD';
const ADD_AI_CODES_AND_STATEMENT_INFO_M$1 = 'ADD_AI_CODES_AND_STATEMENT_INFO_M';
const REMOVE_AI_ITEM_INFO = 'REMOVE_AI_ITEM_INFO';
const UPDATE_SHIP_DUTY_FIELD$1 = 'UPDATE_SHIP_DUTY_FIELD';
const SAVE_MERCHANDISE_FIELD = 'SAVE_MERCHANDISE_FIELD';
const SAVE_MERCHANDISE_LINE_ITEM = 'SAVE_MERCHANDISE_LINE_ITEM';
const UPDATE_MERCH_LINE_ITEM_FIELD = 'UPDATE_MERCH_LINE_ITEM_FIELD';
const REMOVE_MERCHANDISE_LINE_ITEM = 'REMOVE_MERCHANDISE_LINE_ITEM';
const ADD_MERCH_DUTY = 'ADD_MERCH_DUTY';
const ADD_MERCH_SUMMARY = 'ADD_MERCH_SUMMARY';
const UPDATE_MERCH_DUTY_FIELD$1 = 'UPDATE_MERCH_DUTY_FIELD';
const REMOVE_DUTY_ITEM$1 = 'REMOVE_DUTY_ITEM';
const UPDATE_INVOICE_LINE_ITEM_FIELD$1 = 'UPDATE_INVOICE_LINE_ITEM_FIELD';
const UPDATE_ITEM_SUMMARY_INFO_FIELD$1 = 'UPDATE_ITEM_SUMMARY_INFO_FIELD';
const ADD_ITEM_INFO = 'ADD_ITEM_INFO';
const UPDATE_ITEM_INFO_FIELD$1 = 'UPDATE_ITEM_INFO_FIELD';
const REMOVE_ITEM_INFO$1 = 'REMOVE_ITEM_INFO';
const FORM_VALUES$1 = 'FORM_VALUES';
const SET_ANY_FORM_VALUES$1 = 'SET_ANY_FORM_VALUES';
const DELETE_SUMMARY$1 = 'DELETE_SUMMARY';
const UPDATE_INVOICE_DATE = 'UPDATE_INVOICE_DATE';
const REMOVE_INVOICE_LINE_ITEM = 'REMOVE_INVOICE_LINE_ITEM';
const CREATE_MERCHANDISE_LINE_ITEM = 'CREATE_MERCHANDISE_LINE_ITEM';
const ADD_INVOICE_ITEM = 'ADD_INVOICE_ITEM';
const UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$1 = 'UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD';
const REMOVE_CONTAINER$1 = 'REMOVE_CONTAINER';
const ADD_NEW_CONTAINER$1 = 'ADD_NEW_CONTAINER';
const ADD_DOC_CODE_STATEMENT$1 = 'ADD_DOC_CODE_STATEMENT';
const UPDATE_ITEM_DOC_CODE_STMT_FIELD$1 = 'UPDATE_ITEM_DOC_CODE_STMT_FIELD';
const REMOVE_DOC_CODE_STMT_ITEM_INFO$1 = 'REMOVE_DOC_CODE_STMT_ITEM_INFO';
const INITIALIZE_VALUES_NOTES$1 = 'INITIALIZE_VALUES_NOTES';
const UPDATE_NOTES_ITEM_STATUS$1 = 'UPDATE_NOTES_ITEM_STATUS';
const ADD_NOTES_ITEM$1 = 'ADD_NOTES_ITEM';
const WHEN_SHIPMENT_CHANGED$1 = 'WHEN_SHIPMENT_CHANGED';
const COLLAPSE_LINE_ITEMS$1 = 'COLLAPSE_LINE_ITEMS';
const EXPAND_LINE_ITEMS$1 = 'EXPAND_LINE_ITEMS';
const UPDATE_MERCHANDISE_COUNT$1 = 'UPDATE_MERCHANDISE_COUNT';
const EXPAND_ALL_LINE_ITEMS$1 = 'EXPAND_ALL_LINE_ITEMS';
const EXPAND_LINE_ITEM$1 = 'EXPAND_LINE_ITEM';
const ADD_ITEM_HEADER = 'ADD_ITEM_HEADER';
const DELETE_ITEM_HEADER$1 = 'DELETE_ITEM_HEADER';
const UPDATE_ITEM_HEADER$1 = 'UPDATE_ITEM_HEADER';
const ADD_ITEM_PARTIES$1 = 'ADD_ITEM_PARTIES';
const UPDATE_ITEM_PARTIES$1 = 'UPDATE_ITEM_PARTIES';
const DELETE_ITEM_PARTIES$1 = 'DELETE_ITEM_PARTIES';
const UPDATE_TRANSPORT_DETAILS$1 = 'UPDATE_TRANSPORT_DETAILS';
const UPDATE_TRANSPORT_HEADER_INFO$1 = 'UPDATE_TRANSPORT_HEADER_INFO';
const INITIALIZE_PARTIES_FORM$1 = 'INITIALIZE_PARTIES_FORM';
const INITIALIZE_HEADER_FORM$1 = 'INITIALIZE_HEADER_FORM';
const CLEAR_FORM$1 = 'CLEAR_FORM';
const UPDATE_ACTOR_CONTACT_INFO$1 = 'UPDATE_ACTOR_CONTACT_INFO';
const INITIALIZE_ITEMS_FORM$1 = 'INITIALIZE_ITEMS_FORM';
const COPY_ACTOR_INFO$1 = 'COPY_ACTOR_INFO';
const ACTOR_COPIED_STATUS$1 = 'ACTOR_COPIED_STATUS';
const DELETE_INVOICE$1 = 'DELETE_INVOICE';
const UPDATE_INVOICE_DATA = 'UPDATE_INVOICE_DATA';
const SAVE_INVOICE_DATA$1 = 'SAVE_INVOICE_DATA';
const UPDATE_MERCH_DATA = 'UPDATE_MERCH_DATA';
const UPDATE_MULTIPLE_TAB_VALUE$1 = 'UPDATE_MULTIPLE_TAB_VALUE';
const ADD_MULTIPLE_TAB$1 = 'ADD_MULTIPLE_TAB';
const DELETE_MULTIPLE_TAB$1 = 'DELETE_MULTIPLE_TAB';
const ADD_HEADER_CONTAINER = 'ADD_HEADER_CONTAINER';
const UPDATE_HEADER_CONTAINER = 'UPDATE_HEADER_CONTAINER';
const DELETE_HEADER_CONTAINER = 'DELETE_HEADER_CONTAINER';
const UPDATE_ALL_ITEMS_HEADER = 'UPDATE_ALL_ITEMS_HEADER';
const ADD_MERCHANDISE_DOC_BY_ID$1 = "ADD_MERCHANDISE_DOC_BY_ID";
const DELETE_MERCHANDISE_DOC_BY_ID$1 = 'DELETE_MERCHANDISE_DOC_BY_ID';
const UPDATE_MERCHANDISE_DOC_BY_ID$1 = 'UPDATE_MERCHANDISE_DOC_BY_ID';
const DELETE_MERCHANDISE_ITEM$1 = "DELETE_MERCHANDISE_ITEM";
const CREATE_MERCHANDISE_ITEM$1 = "CREATE_MERCHANDISE_ITEM";
const CREATE_INVOICE$1 = "CREATE_INVOICE";
const UPDATE_INVOICE_HEADER_VALUE = "UPDATE_INVOICE_HEADER_VALUE";
const INIT_VALIDATION_ERRORS = "INIT_VALIDATION_ERRORS";
const UPDATE_VALIDATION_ERRORS = "UPDATE_VALIDATION_ERRORS";
const UPDATE_EXCHANGE_RATE_AND_EUR_VAL = "UPDATE_EXCHANGE_RATE_AND_EUR_VAL";
const MASS_UPDATE_AT_INVOICE_LEVEL = "MASS_UPDATE_AT_INVOICE_LEVEL";
const MASS_UPDATE_FOR_MULTIPLE_INVOICE = "MASS_UPDATE_FOR_MULTIPLE_INVOICE";
const MASS_UPDATE_REPEATABLE_ELEMENTS = 'MASS_UPDATE_REPEATABLE_ELEMENTS';

var ActionTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  INITIALIZE_ALL_VALUES: INITIALIZE_ALL_VALUES$1,
  INITIALIZE_DROPDOWNS: INITIALIZE_DROPDOWNS$1,
  UPDATE_ACTOR_FIELD_VALUE: UPDATE_ACTOR_FIELD_VALUE$1,
  SET_ERROR_MESSAGE: SET_ERROR_MESSAGE$1,
  DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER: DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$1,
  ADD_ADDITONAL_INFO: ADD_ADDITONAL_INFO$1,
  UPDATE_SHIPMENT_FIELD_VALUE: UPDATE_SHIPMENT_FIELD_VALUE$1,
  UPDATE_AI_STATEMENT_INFO_FIELDS: UPDATE_AI_STATEMENT_INFO_FIELDS$1,
  ADD_AI_CODES_AND_STATEMENT_INFO: ADD_AI_CODES_AND_STATEMENT_INFO$1,
  UPDATE_ITEM_AI_INFO_FIELD: UPDATE_ITEM_AI_INFO_FIELD$1,
  ADD_AI_CODES_AND_STATEMENT_INFO_M: ADD_AI_CODES_AND_STATEMENT_INFO_M$1,
  REMOVE_AI_ITEM_INFO: REMOVE_AI_ITEM_INFO,
  UPDATE_SHIP_DUTY_FIELD: UPDATE_SHIP_DUTY_FIELD$1,
  SAVE_MERCHANDISE_FIELD: SAVE_MERCHANDISE_FIELD,
  SAVE_MERCHANDISE_LINE_ITEM: SAVE_MERCHANDISE_LINE_ITEM,
  UPDATE_MERCH_LINE_ITEM_FIELD: UPDATE_MERCH_LINE_ITEM_FIELD,
  REMOVE_MERCHANDISE_LINE_ITEM: REMOVE_MERCHANDISE_LINE_ITEM,
  ADD_MERCH_DUTY: ADD_MERCH_DUTY,
  ADD_MERCH_SUMMARY: ADD_MERCH_SUMMARY,
  UPDATE_MERCH_DUTY_FIELD: UPDATE_MERCH_DUTY_FIELD$1,
  REMOVE_DUTY_ITEM: REMOVE_DUTY_ITEM$1,
  UPDATE_INVOICE_LINE_ITEM_FIELD: UPDATE_INVOICE_LINE_ITEM_FIELD$1,
  UPDATE_ITEM_SUMMARY_INFO_FIELD: UPDATE_ITEM_SUMMARY_INFO_FIELD$1,
  ADD_ITEM_INFO: ADD_ITEM_INFO,
  UPDATE_ITEM_INFO_FIELD: UPDATE_ITEM_INFO_FIELD$1,
  REMOVE_ITEM_INFO: REMOVE_ITEM_INFO$1,
  FORM_VALUES: FORM_VALUES$1,
  SET_ANY_FORM_VALUES: SET_ANY_FORM_VALUES$1,
  DELETE_SUMMARY: DELETE_SUMMARY$1,
  UPDATE_INVOICE_DATE: UPDATE_INVOICE_DATE,
  REMOVE_INVOICE_LINE_ITEM: REMOVE_INVOICE_LINE_ITEM,
  CREATE_MERCHANDISE_LINE_ITEM: CREATE_MERCHANDISE_LINE_ITEM,
  ADD_INVOICE_ITEM: ADD_INVOICE_ITEM,
  UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD: UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$1,
  REMOVE_CONTAINER: REMOVE_CONTAINER$1,
  ADD_NEW_CONTAINER: ADD_NEW_CONTAINER$1,
  ADD_DOC_CODE_STATEMENT: ADD_DOC_CODE_STATEMENT$1,
  UPDATE_ITEM_DOC_CODE_STMT_FIELD: UPDATE_ITEM_DOC_CODE_STMT_FIELD$1,
  REMOVE_DOC_CODE_STMT_ITEM_INFO: REMOVE_DOC_CODE_STMT_ITEM_INFO$1,
  INITIALIZE_VALUES_NOTES: INITIALIZE_VALUES_NOTES$1,
  UPDATE_NOTES_ITEM_STATUS: UPDATE_NOTES_ITEM_STATUS$1,
  ADD_NOTES_ITEM: ADD_NOTES_ITEM$1,
  WHEN_SHIPMENT_CHANGED: WHEN_SHIPMENT_CHANGED$1,
  COLLAPSE_LINE_ITEMS: COLLAPSE_LINE_ITEMS$1,
  EXPAND_LINE_ITEMS: EXPAND_LINE_ITEMS$1,
  UPDATE_MERCHANDISE_COUNT: UPDATE_MERCHANDISE_COUNT$1,
  EXPAND_ALL_LINE_ITEMS: EXPAND_ALL_LINE_ITEMS$1,
  EXPAND_LINE_ITEM: EXPAND_LINE_ITEM$1,
  ADD_ITEM_HEADER: ADD_ITEM_HEADER,
  DELETE_ITEM_HEADER: DELETE_ITEM_HEADER$1,
  UPDATE_ITEM_HEADER: UPDATE_ITEM_HEADER$1,
  ADD_ITEM_PARTIES: ADD_ITEM_PARTIES$1,
  UPDATE_ITEM_PARTIES: UPDATE_ITEM_PARTIES$1,
  DELETE_ITEM_PARTIES: DELETE_ITEM_PARTIES$1,
  UPDATE_TRANSPORT_DETAILS: UPDATE_TRANSPORT_DETAILS$1,
  UPDATE_TRANSPORT_HEADER_INFO: UPDATE_TRANSPORT_HEADER_INFO$1,
  INITIALIZE_PARTIES_FORM: INITIALIZE_PARTIES_FORM$1,
  INITIALIZE_HEADER_FORM: INITIALIZE_HEADER_FORM$1,
  CLEAR_FORM: CLEAR_FORM$1,
  UPDATE_ACTOR_CONTACT_INFO: UPDATE_ACTOR_CONTACT_INFO$1,
  INITIALIZE_ITEMS_FORM: INITIALIZE_ITEMS_FORM$1,
  COPY_ACTOR_INFO: COPY_ACTOR_INFO$1,
  ACTOR_COPIED_STATUS: ACTOR_COPIED_STATUS$1,
  DELETE_INVOICE: DELETE_INVOICE$1,
  UPDATE_INVOICE_DATA: UPDATE_INVOICE_DATA,
  SAVE_INVOICE_DATA: SAVE_INVOICE_DATA$1,
  UPDATE_MERCH_DATA: UPDATE_MERCH_DATA,
  UPDATE_MULTIPLE_TAB_VALUE: UPDATE_MULTIPLE_TAB_VALUE$1,
  ADD_MULTIPLE_TAB: ADD_MULTIPLE_TAB$1,
  DELETE_MULTIPLE_TAB: DELETE_MULTIPLE_TAB$1,
  ADD_HEADER_CONTAINER: ADD_HEADER_CONTAINER,
  UPDATE_HEADER_CONTAINER: UPDATE_HEADER_CONTAINER,
  DELETE_HEADER_CONTAINER: DELETE_HEADER_CONTAINER,
  UPDATE_ALL_ITEMS_HEADER: UPDATE_ALL_ITEMS_HEADER,
  ADD_MERCHANDISE_DOC_BY_ID: ADD_MERCHANDISE_DOC_BY_ID$1,
  DELETE_MERCHANDISE_DOC_BY_ID: DELETE_MERCHANDISE_DOC_BY_ID$1,
  UPDATE_MERCHANDISE_DOC_BY_ID: UPDATE_MERCHANDISE_DOC_BY_ID$1,
  DELETE_MERCHANDISE_ITEM: DELETE_MERCHANDISE_ITEM$1,
  CREATE_MERCHANDISE_ITEM: CREATE_MERCHANDISE_ITEM$1,
  CREATE_INVOICE: CREATE_INVOICE$1,
  UPDATE_INVOICE_HEADER_VALUE: UPDATE_INVOICE_HEADER_VALUE,
  INIT_VALIDATION_ERRORS: INIT_VALIDATION_ERRORS,
  UPDATE_VALIDATION_ERRORS: UPDATE_VALIDATION_ERRORS,
  UPDATE_EXCHANGE_RATE_AND_EUR_VAL: UPDATE_EXCHANGE_RATE_AND_EUR_VAL,
  MASS_UPDATE_AT_INVOICE_LEVEL: MASS_UPDATE_AT_INVOICE_LEVEL,
  MASS_UPDATE_FOR_MULTIPLE_INVOICE: MASS_UPDATE_FOR_MULTIPLE_INVOICE,
  MASS_UPDATE_REPEATABLE_ELEMENTS: MASS_UPDATE_REPEATABLE_ELEMENTS
});

const ShipmentDataHOC = Component => props => {
  const currShipData = useCurrentShipmentType();
  const {
    isDisabled
  } = currShipData || {};
  return /*#__PURE__*/React__default["default"].createElement(Component, _extends$1({}, props, {
    isDisabled: props.isDisabled != null || props.isDisabled != undefined || props.isDisabled === false ? props.isDisabled : isDisabled
  }));
};

const AmountSeparator = /*#__PURE__*/React$1.memo(({
  value,
  className,
  string
}) => !!parseFloat(value) && /*#__PURE__*/React__default["default"].createElement("div", {
  type: "text",
  className: `${className} length2`
}, string ? string + " " : "", parseFloat(value).toLocaleString('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 20
}).replaceAll("£", "")));

const RubberBindingInfoContext = /*#__PURE__*/React__default["default"].createContext();
const RubberBindingInfoProvider = ({
  rubberBindingInfo = {},
  children
}) => {
  const {
    newValue,
    currentFieldId,
    penClicked
  } = rubberBindingInfo;
  const onMouseDown = React$1.useCallback(event => {
    event.stopPropagation();
    penClicked(event);
  }, [penClicked]);
  React$1.useEffect(() => {
    let input = document.getElementById(currentFieldId);
    if (input !== null) {
      let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
      nativeInputValueSetter.call(input, newValue);
      let inputEvent = new Event("input", {
        bubbles: true
      });
      input.dispatchEvent(inputEvent);
    }
  }, [newValue]);
  return /*#__PURE__*/React__default["default"].createElement(RubberBindingInfoContext.Provider, {
    value: {
      onMouseDown,
      ...rubberBindingInfo
    }
  }, children);
};

const RubberBindingInfoHOC$1 = Component => props => {
  const rubberBindingInfo = React$1.useContext(RubberBindingInfoContext);
  return /*#__PURE__*/React__default["default"].createElement(Component, _extends$1({}, props, {
    onMouseDown: rubberBindingInfo === null || rubberBindingInfo === void 0 ? void 0 : rubberBindingInfo.onMouseDown
  }));
};

const CustomInputField = props => {
  const {
    id,
    label,
    className = "",
    type,
    onChange,
    icon,
    onBlur,
    value,
    labelClassName = "",
    labelIcon,
    maxlength,
    errors,
    boxNumber,
    string,
    innerRef,
    isDisabled,
    onKeyDown,
    onFocus,
    name,
    addThousandsSeperator = false,
    copyToFeature = false,
    onMouseDown
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(CustomLabel, {
    title: errors && errors.length > 0 ? '' : label,
    className: `name-label es ${labelClassName}`,
    boxNumber: boxNumber,
    label: label,
    copyToFeature: copyToFeature && /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon, {
      fieldInfo: value
    }),
    labelIcon: labelIcon,
    errors: errors
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    className: " input-field-container"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
    value: value,
    error: errors && errors.length > 0,
    id: id,
    name: name,
    type: type,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    disabled: isDisabled,
    onFocus: onFocus,
    onMouseDown: onMouseDown
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    maxLength: maxlength,
    className: `field-bg ${className} form-control`,
    ref: innerRef
  }), addThousandsSeperator && /*#__PURE__*/React__default["default"].createElement(AmountSeparator, {
    value: value,
    string: string,
    className: "moneyDisplayOverlay"
  }), icon)));
};
CustomInputField.propTypes = {};
var InputField$2 = ShipmentDataHOC(RubberBindingInfoHOC$1(CustomInputField));

class DropDown$1 extends React$1.Component {
  constructor() {
    super();
    _defineProperty$2(this, "errorPopup", errors => {
      var _errors;
      errors = Array.isArray(errors) ? errors : errors ? [errors] : [];
      if (!((_errors = errors) !== null && _errors !== void 0 && _errors.length)) return '';
      const error = errors.map((info, index) => {
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: "error",
          key: index
        }, "* ", info);
      });
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
        trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning sign",
          color: "red"
        }),
        content: error || ""
      });
    });
    _defineProperty$2(this, "getDropDownText2", option => {
      let displayText = option;
      if (option.stringVal) {
        // If there is a stringVal, use that
        displayText = option.stringVal;
      } else {
        let lang = instance.language || window.localStorage.i18nextLng || "en";
        let textKey = lang !== "en" ? `text_${lang}` : `text`;
        if (option.value && option[textKey] && option.description) {
          displayText = option.value + ' - ' + option[textKey];
        } else if (option.value && option[textKey]) {
          displayText = option.value + ' - ' + option[textKey];
        } else if (option[textKey]) {
          displayText = option[textKey];
        }
      }
      if (option.type && this.props.displayType) displayText = [`${displayText}-${option.type}`];
      if (typeof displayText === "string") {
        return displayText.replace(/_/g, " ");
      }
      return displayText;
    });
    _defineProperty$2(this, "handleChange", (e, {
      value
    }) => {
      e.stopPropagation();
      this.props.onChange(value || value === 0 ? value : " ", this.props.name);
      document.getElementsByClassName("active-label")[0] && document.getElementsByClassName("active-label")[0].classList.remove("active-label");
    });
    this.state = {};
  }
  shouldComponentUpdate(nextProps, nextState) {
    let rerender = JSON.stringify(nextProps.value) != JSON.stringify(this.props.value) || JSON.stringify(nextProps.disabled) != JSON.stringify(this.props.disabled) || !lodash.isEqual(nextProps.errors, this.props.errors) || !lodash.isEqual(nextProps.data, this.props.data) || !lodash.isEqual(nextProps.label, this.props.label) || !lodash.isEqual(nextProps.isDisabled, this.props.isDisabled);
    return rerender;
  }
  render() {
    const {
      label,
      className,
      columnClassName,
      width,
      data,
      disabled,
      direction,
      labelClassName,
      centerSelect,
      onChange,
      text,
      onBlur,
      id,
      onButtonClick,
      button,
      labelIcon,
      errors,
      multiple,
      boxNumber,
      isFooterLabel,
      mandatory,
      icon,
      onSearchChange,
      clearable,
      isDisabled,
      value,
      title,
      descriptionRequired = true,
      search,
      autoFocus = false
    } = this.props;
    if (errors && errors.length) ;
    let drop_data = data === undefined ? [] : data;
    let dpText = this.getDropDownText2;
    let options = lodash.map(drop_data, (item, index) => ({
      key: index,
      text: dpText(item),
      value: item.value,
      description: descriptionRequired && item.description,
      disabled: item.disabled
    }));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
      width: width,
      className: `floating-select ${centerSelect && "floating-select-center"} ${columnClassName || ""}`
    }, isFooterLabel === true ? /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: "floatField",
      style: {
        bottom: "-17px"
      },
      className: labelClassName ? "label-footer " + labelClassName : "label-footer"
    }, this.errorPopup(errors), label, labelIcon && labelIcon) : /*#__PURE__*/React__default["default"].createElement("label", {
      id: `${id}label`,
      htmlFor: "floatField",
      className: "label-dropdown name-label es " + labelClassName || ""
    }, this.errorPopup(errors), boxNumber && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ui black label input-box-number"
    }, boxNumber), label, labelIcon && labelIcon), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
      closeOnChange: true,
      selectOnBlur: false,
      icon: icon || "dropdown",
      scrolling: true,
      search: search ? search : true,
      clearable: value !== null && value !== void 0 && value.trim() ? clearable : false,
      style: errors && errors.length > 0 ? {
        backgroundColor: "#fff6f6"
      } : null,
      multiple: multiple,
      selection: true,
      options: options,
      onChange: onChange && this.handleChange,
      onSearchChange: onSearchChange,
      value: value,
      text: text,
      placeholder: "Select",
      wrapSelection: true,
      id: id,
      name: name,
      direction: direction,
      disabled: isDisabled || disabled,
      small: "true",
      className: `${className} addInfoCode`,
      title: title,
      searchInput: {
        autoFocus
      },
      onBlur: () => {
        onBlur && onBlur();
        document.getElementsByClassName("active-label")[0] && document.getElementsByClassName("active-label")[0].classList.remove("active-label");
      },
      onFocus: event => {
        var _document$getElementB, _document$getElementB2;
        event.target && event.target.setAttribute("autocomplete", "nope");
        let previousSibling = (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.previousSibling;
        document.getElementsByClassName("active-label")[0] && document.getElementsByClassName("active-label")[0].classList.remove("active-label");
        previousSibling && previousSibling.classList && ((_document$getElementB2 = document.getElementById(id)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.previousSibling.classList.add("active-label"));
      }
    }), mandatory === true && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "asterisk",
      style: {
        position: "absolute",
        right: "-3px"
      }
    }), button && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      basic: true,
      color: "blue",
      className: "openButton",
      onClick: e => onButtonClick(e)
    }, button)));
  }
}
DropDown$1.defaultProps = {
  clearable: false,
  displayType: true,
  errors: []
};
var DropDown$2 = ShipmentDataHOC$1(DropDown$1);

const RubberBindingInfoHOC = Component => props => {
  let rubberBindingInfo = React$1.useContext(RubberBindingInfoContext);
  return /*#__PURE__*/React__default["default"].createElement(Component, _extends$1({}, props, rubberBindingInfo));
};

class InputField extends React$1.Component {
  constructor() {
    super();
    _defineProperty$2(this, "errorPopup", errors => {
      var _errors;
      errors = Array.isArray(errors) ? errors : errors ? [errors] : [];
      if (!((_errors = errors) !== null && _errors !== void 0 && _errors.length)) return '';
      const error = errors.map((info, index) => {
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: "error",
          key: index
        }, "* ", info);
      });
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
        trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: "warning sign",
          color: "red"
        }),
        content: error || ""
      });
    });
    _defineProperty$2(this, "emptyField", id => {
      !this.props.isInteger && this.props.onChange("", this.props.name);
      let element = document.getElementById(id);
      element === null || element === void 0 ? void 0 : element.focus();
    });
    _defineProperty$2(this, "handleChange", (event, {
      name,
      value
    }) => {
      if (this.state.hasOwnProperty(name)) {
        // this.props.value = value
        this.setState({
          [name]: value
        });
      }
      this.props.onChange(value);
    });
    this.state = {
      time: "",
      wasFocused: false
    };
    this.handleChange.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if ((nextProps.newValue !== this.state.newValue || nextProps.rbCounterId !== this.state.rbCounterId) && this.props.fieldName) {
      this.setState({
        newValue: nextProps.newValue,
        rbCounterId: nextProps.rbCounterId
      }, () => {
        this.props.fieldName === this.props.id && this.props.onChange(this.props.isInteger ? parseFloat(this.state.newValue.replace(/[^\d.-]/g, "")).toFixed(2) : this.state.newValue, this.props.name);
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !lodash_1(nextProps.value, this.props.value) || !lodash_1(nextProps.label, this.props.label) || !lodash_1(nextProps.labelIcon, this.props.labelIcon) || !lodash_1(nextProps.errors, this.props.errors) || !lodash_1(nextProps.disabled, this.props.disabled) || !lodash_1(nextProps.string, this.props.string) || !lodash_1(nextProps.extraParams, this.props.extraParams) || !lodash_1(nextProps.isDisabled, this.props.isDisabled);
  }
  render() {
    const {
      id,
      dateClass,
      subLabelText,
      iconPosition,
      label,
      width,
      isLabel,
      className,
      type,
      onChange,
      icon,
      subLabelClass,
      onBlur,
      disabled,
      value,
      labelClassName,
      inputClassName,
      setINPUTID,
      penClicked,
      isInteger,
      shipmentId,
      handleFocus,
      labelIcon,
      clearInput,
      maxlength,
      errors,
      boxNumber,
      isFooterLabel,
      mandatory,
      addThousandsSeperator,
      string,
      component,
      innerRef,
      isDisabled,
      onKeyDown,
      name,
      minDate,
      maxDate,
      copyToFeature = false
    } = this.props;
    let redBgColor = "";
    if (errors && errors.length) {
      redBgColor = "redBgColor";
    }
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, type !== 'date' && !isFooterLabel && /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: "floatField",
      title: errors && errors.length > 0 ? '' : label,
      className: labelClassName ? 'name-label es ' + labelClassName : 'name-label es'
    }, this.errorPopup(errors), boxNumber && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ui black label input-box-number"
    }, boxNumber), label, copyToFeature && /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
      fieldInfo: value
    }), labelIcon && labelIcon), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
      className: dateClass + ' date-field',
      width: width
    }, isLabel && /*#__PURE__*/React__default["default"].createElement("label", {
      size: "small"
    }, " ", label, " "), type === 'date' ? /*#__PURE__*/React__default["default"].createElement(SemanticDatepicker__default["default"], {
      name: name,
      id: id,
      clearable: this.state.wasFocused,
      minDate: minDate,
      maxDate: maxDate,
      onDateChange: value => {
        onChange && onChange(value, name);
      },
      selected: value !== -999 && value > 0 && value !== undefined ? new Date(new Date(value)) : false,
      onFocus: () => {
        this.setState({
          wasFocused: true
        });
      },
      onBlur: event => onBlur && onBlur(new Date(event.target.value)),
      pointing: 'left',
      className: className + ' ' + redBgColor,
      label: /*#__PURE__*/React__default["default"].createElement("label", {
        className: "floating-date-label",
        title: label
      }, ' ', this.errorPopup(errors), " ", label),
      icon: "calendar outline",
      format: "DD-MMM-YYYY",
      disabled: isDisabled || disabled,
      clearOnSameDateClick: false
    }) : type === 'radio' ? /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        height: '40px',
        position: 'relative',
        top: '20px'
      }
    }, component) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
      className: window.shipmentCountry === 'US' ? redBgColor : inputClassName,
      value: value,
      error: errors && errors.length > 0,
      width: width,
      iconPosition: iconPosition,
      id: id,
      name: name,
      type: type,
      title: value,
      onChange: event => {
        onChange(event.target.value, event.target.name);
      },
      onWheel: e => e.target.blur() // prevents input value change while scrolling when input type is number. 
      ,
      onBlur: event => {
        if (isInteger && !event.target.value) {
          onChange('0.00');
        }
        onBlur && onBlur(event.target.value, event.target.name);
      },
      onKeyDown: onKeyDown,
      disabled: isDisabled || disabled,
      onMouseDown: e => {
        e.stopPropagation();
        penClicked && penClicked(e);
      },
      onFocus: event => {
        handleFocus && handleFocus(event);
        setINPUTID && setINPUTID(id);
      }
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      maxLength: maxlength,
      className: className + ' form-control',
      ref: innerRef
    }), addThousandsSeperator && /*#__PURE__*/React__default["default"].createElement(AmountSeparator, {
      value: value,
      string: string,
      className: "moneyDisplayOverlay"
    }), icon, subLabelText && /*#__PURE__*/React__default["default"].createElement("p", {
      className: subLabelClass
    }, subLabelText), clearInput && value && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      className: "delete-field-icon",
      name: "close",
      inverted: true,
      link: true,
      id: "delete-text",
      onClick: () => !this.props.disabled && this.emptyField(id)
    }), mandatory === true && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "asterisk",
      style: {
        position: 'absolute',
        right: '-3px'
      }
    })), isFooterLabel && /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: "floatField",
      className: labelClassName ? 'label-footer ' + labelClassName : 'label-footer'
    }, this.errorPopup(errors), label, labelIcon && labelIcon)));
  }
}
InputField.defaultProps = {
  errors: []
};
var InputField$1 = ShipmentDataHOC$1(RubberBindingInfoHOC(InputField));

const convertDateToUTC = value => {
  return value ? new Date(new Date(Number(value)).getUTCMonth() + 1 + '/' + new Date(Number(value)).getUTCDate() + '/' + new Date(Number(value)).getUTCFullYear()).getTime() : -999;
};
const convertDateToUTCEpoch = value => {
  if (value && !isNaN(value.getTime())) {
    value = value.getTime();
    value = new Date(Date.UTC(new Date(value).getFullYear(), new Date(value).getMonth(), new Date(value).getDate()));
    value = value.getTime();
  } else {
    value = '';
  }
  return value;
};
const convertEpochToUTC = value => {
  const utcDate = new Date(value);
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayOfWeek = daysOfWeek[utcDate.getUTCDay()];
  const dayOfMonth = utcDate.getUTCDate();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[utcDate.getUTCMonth()];
  const year = utcDate.getUTCFullYear();
  const hours = utcDate.getUTCHours();
  const minutes = utcDate.getUTCMinutes();
  const seconds = utcDate.getUTCSeconds();
  const formattedUTCDate = `${dayOfWeek}, ${dayOfMonth} ${month} ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} GMT`;
  return formattedUTCDate;
};

const GET_CHARGES_FINANCE = "GET_CHARGES_FINANCE";
const GET_CHARGES_LIST = "GET_CHARGES_LIST";
const UPSERT_CHARGE_LIST = "UPSERT_CHARGE_LIST";
const GET_EMAIL_GROUP = "GET_EMAIL_GROUP";
const REMOVE_CHARGE_FROM_LIST = "REMOVE_CHARGE_FROM_LIST";
const GET_ENTITY_LIST = "GET_ENTITY_LIST";
const GET_VALUE_BUILD_UP_EU = "GET_VALUE_BUILD_UP_EU";
const SET_VALUE_BUILD_UP_EU = "SET_VALUE_BUILD_UP_EU";
const DELETE_VALUE_BUILD_UP_EU = "DELETE_VALUE_BUILD_UP_EU";
const GET_HTS_METADATA_EU = 'GET_HTS_METADATA_EU';
const GET_HTS_METADATA_ES = 'GET_HTS_METADATA_ES';
const PRORATE = 'PRORATE';
const CALCULATE_EU_DUTIES = 'CALCULATE_EU_DUTIES';
const GET_SHIPMENT_NOTES$1 = 'GET_SHIPMENT_NOTES';
const SAVE_SHIPMENT_NOTES$1 = 'SAVE_SHIPMENT_NOTES';

const bhSurrender = shipmentId => {
  let body = {
    eventMessage: {
      entity: {
        entityId: shipmentId,
        entityType: 'WORKFLOW_ENTITY_TYPE_SHIPMENT'
      },
      event: 'BH_BROKER_SURRENDER',
      assignedBHCode: '300',
      receivingTime: Date.now()
    },
    eventType: 'UPDATE_WORKFLOW',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const sendMsgToRocketChat = (shipmentId, klearEventType, userGuid) => {
  // KLEAR_CHAT_BROKER_PICKED = 13;  //Start Job
  // KLEAR_CHAT_BROKER_RETURN_TO_QUEUE = 14; //Back to pool

  let reqParams = {
    eventMessage: {
      shipmentId: shipmentId,
      klearEventType: klearEventType,
      userGuid: userGuid
    },
    eventType: 'SEND_MESSAGE_TO_ROCKET_CHAT',
    eventTime: Date.now() / 1000
  };
  return HttpClient.custom({
    data: reqParams
  });
};
const generatePDF = (shipmentID, type = 'CLIENT_PDF_SAD_EU', signDate, countryCode) => {
  if (!type) {
    return;
  }
  const data = {
    eventMessage: {
      shipmentId: shipmentID,
      pdfType: type,
      countryCode: countryCode
    },
    eventType: 'GENERATE_PDF',
    eventTime: Date.now()
  };
  if (signDate) {
    data.eventMessage.signDate = signDate;
  }
  return HttpClient.custom({
    data
  });
};
const generatePdfManually = payload => {
  if (!payload.pdfType) {
    return;
  }
  const data = {
    eventMessage: {
      ...payload
    },
    eventType: 'GENERATE_PDF',
    eventTime: Date.now()
  };
  data.eventMessage.extraData = JSON.stringify(payload.extraData);
  return HttpClient.custom({
    data
  });
};
const updateWorkFlow = (shipmentId, statusType, brokerGuid, extraParams = {}) => {
  var _window, _window2;
  console.log("__Window.countryCode.updateWorkFlow__", (_window = window) === null || _window === void 0 ? void 0 : _window.shipmentCountry);
  let body = {
    eventMessage: {
      entity: {
        entityId: shipmentId,
        entityType: 'WORKFLOW_ENTITY_TYPE_SHIPMENT'
      },
      event: statusType,
      comment: 'Updated from UI',
      brokerAssigned: brokerGuid,
      receivingTime: Date.now(),
      country: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.shipmentCountry
      // ...extraParams
    },
    eventType: 'UPDATE_WORKFLOW',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const startBhHouseJob = (shipmentId, bhHouse, kxId, comment = 'Updated from UI') => {
  var _window3;
  let body = {
    eventMessage: {
      entity: {
        entityId: shipmentId,
        entityType: 'WORKFLOW_ENTITY_TYPE_SHIPMENT'
      },
      event: bhHouse,
      comment: comment,
      brokerAssigned: kxId,
      receivingTime: Date.now(),
      country: (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.shipmentCountry
    },
    eventType: 'UPDATE_WORKFLOW',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const startJob = (shipmentId, type, eventType, brokerGuid, extraParams = {}) => {
  var _window4, _window5;
  console.log("__Window.countryCode.startJob__", (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.shipmentCountry);
  let body = {
    eventMessage: {
      entity: {
        entityId: shipmentId,
        entityType: 'WORKFLOW_ENTITY_TYPE_SHIPMENT'
      },
      event: eventType,
      formType: type,
      comment: 'Updated from UI',
      brokerAssigned: brokerGuid,
      country: (_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.shipmentCountry
      // ...extraParams
    },
    eventType: 'UPDATE_WORKFLOW',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const fileJob = payload => {
  //FILE_FORM_ES
  const {
    shipmentId,
    countryCode,
    mockRequest,
    formType,
    eventType,
    reason,
    reasonDesc,
    cds,
    version
  } = payload;
  let body = {
    eventMessage: {
      shipmentId: shipmentId,
      formType: formType,
      language: countryCode,
      // optional language from i18n nexus
      countryCode: countryCode,
      mockRequest: mockRequest,
      version: version
    },
    eventType: eventType,
    eventTime: Date.now()
  };
  if (reason) {
    body.eventMessage.cancelReason = reason;
    body.eventMessage.reasonDescription = reasonDesc;
  }
  if (cds) {
    body.eventMessage.cds = cds;
  }
  if (payload.import) {
    body.eventMessage.import = payload.import;
  }
  return HttpClient.custom({
    data: body
  });
};
const reviewJob = (eventType, params) => {
  let body = {
    eventMessage: {
      ...params
    },
    eventType: eventType,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const statusDetailapi = (shipmentId, countryCode, eventName) => {
  let body = {
    eventMessage: {
      shipmentId: shipmentId,
      countryCode: countryCode
    },
    eventType: eventName,
    eventTime: Date.now()
  };
  if (countryCode == 'nl') {
    body.eventMessage.partitionCriteria = countryCode;
  }
  return HttpClient.custom({
    data: body
  });
};
const getSearchDropdownValues = payload => {
  const {
    eventType,
    searchFilter,
    entityType = "PORT",
    condition,
    type
  } = payload;
  const data = {
    eventMessage: {
      condition: condition,
      "countryOfDestination": window.shipmentCountry,
      "entityType": entityType,
      "searchValue": searchFilter
    },
    eventType: eventType,
    eventTime: Date.now()
  };
  if (type) {
    data.eventMessage.type = type;
  }
  return HttpClient.custom({
    data
  });
};
const getHtsMetaData = (hts, serviceType, fromCountry, toCountry, country, language) => {
  const data = {
    eventMessage: {
      shipmentType: serviceType,
      fromCountry: fromCountry,
      toCountry: toCountry,
      inputCode: hts,
      shipmentType: serviceType === 'IM' ? 'import' : 'export',
      nomenclatureType: serviceType === 'IM' ? 'TARIC' : 'CN',
      language
    },
    eventType: country === 'ES' ? GET_HTS_METADATA_ES : GET_HTS_METADATA_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const prorate = ({
  shipmentType,
  incoterm
}) => {
  const data = {
    eventMessage: {
      shipmentId: window.shipmentId,
      shipmentType,
      language: 'en',
      incoterm,
      countryCode: window.shipmentCountry
    },
    eventType: PRORATE,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getValueBuildUpData = shipmentId => {
  const data = {
    eventMessage: {
      shipmentId,
      countryCode: window.shipmentCountry
    },
    eventType: GET_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const saveValueBuildUp = payload => {
  const data = {
    eventMessage: {
      ...payload,
      shipmentId: window.shipmentId,
      countryCode: window.shipmentCountry
    },
    eventType: SET_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const taricDuty = payload => {
  const {
    shipmentType,
    destinationCountry,
    countryOfOrigin,
    commodityCode,
    customValue,
    unitCount
  } = payload;
  const data = {
    eventMessage: {
      shipmentType: shipmentType,
      fromCountry: countryOfOrigin,
      toCountry: destinationCountry,
      inputCode: commodityCode,
      customsValue: customValue,
      quantities: `${unitCount} NAR`
    },
    eventType: CALCULATE_EU_DUTIES,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const saveCostType = (costTypeId, costTypeData) => {
  const data = {
    eventMessage: {
      shipmentCostType: [{
        costTypeId: costTypeId,
        ...costTypeData,
        shipmentId: window.shipmentId
      }],
      shipmentId: window.shipmentId,
      countryCode: window.shipmentCountry
    },
    eventType: SET_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const savePartyDependencyValueBuildUp = partyDependency => {
  const data = {
    eventMessage: {
      shipmentId: window.shipmentId,
      countryCode: window.shipmentCountry,
      partyDependency: partyDependency
    },
    eventType: SET_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const createNewCostType = costTypeData => {
  const data = {
    eventMessage: {
      shipmentCostType: [{
        costTypeId: '',
        ...costTypeData,
        shipmentId: window.shipmentId
      }],
      shipmentId: window.shipmentId,
      countryCode: window.shipmentCountry
    },
    eventType: SET_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const deleteCostTypeField = costTypeId => {
  const data = {
    eventMessage: {
      shipmentCostType: [{
        costTypeId,
        shipmentId: window.shipmentId
      }],
      shipmentId: window.shipmentId,
      countryCode: window.shipmentCountry
    },
    eventType: DELETE_VALUE_BUILD_UP_EU,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const holdTheShipment = shipId => {
  let body = {
    "eventMessage": {
      "entity": {
        "entityId": shipId,
        "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
      },
      "event": "ENTRY_ON_HOLD"
    },
    "eventType": "UPDATE_WORKFLOW",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data: body
  });
};
const getTransactionByResponseId = (countryCode, responseId) => {
  let data = {
    eventMessage: {
      "countryCode": countryCode,
      "responseFormat": "JSON",
      "responseId": responseId
    },
    eventType: "GET_TRANSACTION_RESPONSE_EU_BY_ID",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getTransactionByRequestId = (countryCode, requestId) => {
  let data = {
    eventMessage: {
      "countryCode": countryCode,
      "responseFormat": "JSON",
      "requestId": requestId
    },
    eventType: "GET_TRANSACTION_REQUEST_EU_BY_ID",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const fetchAuditTrail = (shipId, countryCode) => {
  let data = {
    eventMessage: {
      "countryCode": countryCode,
      "shipmentId": shipId
    },
    eventType: "GET_ALL_TRANSACTIONS_EU",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getWarehouseDetails = payload => {
  let eventMessage = {
    eventType: "GET_SHIP_FROM_DELIVERY",
    eventMessage: payload,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: eventMessage
  });
};

const createCostType = (data, updateAddStatus) => {
  return (dispatch, getState) => {
    createNewCostType(data).then(res => {
      var _res$data;
      let eventMessage = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.eventMessage;
      if (eventMessage) {
        updateAddStatus();
        let costTypeId = eventMessage.shipmentCostType[0].costTypeId;
        let payload = newCostTypeRow(costTypeId);
        dispatch({
          type: ADD_VALUE_BUILD_UP$1,
          payload,
          meta: {
            tableName: 'valueBuildUpData'
          }
        });
      }
    });
  };
};
const clearForm$2 = () => {
  return {
    type: CLEAR_FORM$3
  };
};
const deleteCostType = (id, updateRemovingStatus) => {
  return (dispatch, getState) => {
    deleteCostTypeField(id).then(res => {
      var _res$data2, _res$data2$eventMessa;
      if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$eventMessa = _res$data2.eventMessage) === null || _res$data2$eventMessa === void 0 ? void 0 : _res$data2$eventMessa.code) === 200) updateRemovingStatus();
      dispatch({
        type: DELETE_VALUE_BUILD_UP$1,
        id,
        meta: {
          tableName: 'shipmentCostType'
        }
      });
    }).catch(err => {
      console.log(err);
    });
  };
};
const updateValueBuildUp = payload => {
  return {
    type: UPDATE_VALUE_BUILD_UP$1,
    payload
  };
};
const saveValueBuildUpField = fields => {
  return (dispatch, getState) => {
    let valueBuildUp = getState().ValueBuildUpReducer;
    let fieldSet = {};
    fields.map(item => {
      if (item === 'proratedData') ; else {
        let fieldValue = valueBuildUp[item] === '' ? ' ' : valueBuildUp[item];
        fieldSet[item] = fieldValue;
      }
    });
    Object.keys(fieldSet).length > 0 && saveValueBuildUp(fieldSet).then(() => console.log('Data saved')).catch(err => {
      console.log('Error', err);
    });
  };
};
const prorateCostType = (payload, updateProrateStatus, updateItemTab) => {
  return (dispatch, getState) => {
    try {
      prorate(payload).then(res => {
        var _res$data3;
        let response = res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.eventMessage;
        if (response.code === 400) {
          updateProrateStatus();
          showToast$1(response.msg);
        } else {
          dispatch(updateValueBuildUp({
            totalAdditionDeductionCustomsValue: response === null || response === void 0 ? void 0 : response.totalAdditionDeductionCustomsValue,
            totalAdditionDeductionStatValue: response === null || response === void 0 ? void 0 : response.totalAdditionDeductionStatValue,
            shipmentInvoice: response === null || response === void 0 ? void 0 : response.shipmentInvoice,
            shipmentCostType: response === null || response === void 0 ? void 0 : response.shipmentCostType
          }));
          // updateMerchData()
          updateItemTab(response === null || response === void 0 ? void 0 : response.shipmentInvoice);
          updateProrateStatus();
          showToast$1('CostTypes prorated and Data updated!!');
        }
      });
    } catch (err) {
      updateProrateStatus();
      showToast$1('Erorr in prorating the Data!!');
      console.log(err.message);
    }
  };
};
const updateCostType = (id, payload) => {
  return {
    type: UPDATE_VALUE_BUILD_UP_COST_TYPE$1,
    id,
    payload,
    meta: {
      tableName: 'shipmentCostType'
    }
  };
};
const saveCostTypeField = (id, fields) => {
  return (dispatch, getState) => {
    let costRow = getState().ValueBuildUpReducer.shipmentCostType.find(c => c.costTypeId == id);
    let payload = {};
    fields.map(item => {
      let fieldValue = costRow[item] === '' ? ' ' : costRow[item];
      payload[item] = fieldValue;
    });
    saveCostType(id, payload).then(res => {
      var _res$data4, _res$data4$eventMessa;
      let data = res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$eventMessa = _res$data4.eventMessage) === null || _res$data4$eventMessa === void 0 ? void 0 : _res$data4$eventMessa.shipmentCostType[0];
      dispatch(updateCostType(id, data));
    }).catch(err => console.log(err));
  };
};
const initializeValueBuildUp = shipmentId => {
  return (dispatch, getState) => {
    getValueBuildUpData(shipmentId).then(res => {
      var _res$data5;
      dispatch({
        type: INITIALIZE_VALUE_BUILD_UP,
        payload: res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.eventMessage
      });
    }).catch(err => console.log(err));
  };
};
const savePartyDependency = () => {
  return (dispatch, getState) => {
    const partyDependency = getState().ValueBuildUpReducer.partyDependency.join(',') || ' ';
    savePartyDependencyValueBuildUp(partyDependency);
  };
};

function initializeValuesConsignee(payload) {
  return {
    type: INITIALIZE_VALUE_CONSIGNEE,
    payload
  };
}
function initializeValuesConsignor(payload) {
  return {
    type: INITIALIZE_VALUE_CONSIGNOR,
    payload
  };
}
function initializeValuesBroker(payload) {
  return {
    type: INITIALIZE_VALUE_BROKER,
    payload
  };
}
function initializeValuesBuyer(payload) {
  return {
    type: INITIALIZE_VALUE_BUYER,
    payload
  };
}
function initializeValuesSeller(payload) {
  return {
    type: INITIALIZE_VALUE_SELLER,
    payload
  };
}
function initializeValuesShipment(payload) {
  return {
    type: INITIALIZE_VALUE_SHIPMENT,
    payload
  };
}
function initializeDropDownValues$1(payload) {
  return {
    type: INITIALIZE_DROPDOWNS$3,
    payload
  };
}
function initializeShipmentNotes(payload, notesLoaded) {
  return {
    type: INITIALIZE_VALUES_NOTES$3,
    payload,
    notesLoaded
  };
}
function initializeFormValues(newValue, setINPUTID, penClicked, fieldName, rbCounterID) {
  return {
    type: FORM_VALUES$3,
    newValue,
    setINPUTID,
    penClicked,
    fieldName,
    rbCounterID
  };
}
function initializeFormLoaded(formLoaded, shipmentId, shipmentCountry, userType, error) {
  return {
    type: FORM_LOADED,
    formLoaded,
    shipmentId,
    shipmentCountry,
    userType,
    error
  };
}
function initializeValuesInvoice(invoices, declarationType) {
  return {
    type: INITIALIZE_VALUES_INVOICE,
    invoices,
    declarationType
  };
}
function initializeHeaderContainer(containers) {
  return {
    type: INITIALIZE_HEADER_CONTAINER,
    containers
  };
}
function initializeAllValues(payload, declarationType) {
  return (dispatch, getState) => {
    dispatch(initializeValuesConsignee(payload.consignee));
    dispatch(initializeValuesConsignor(payload.consignor));
    dispatch(initializeValuesBroker(payload.broker));
    dispatch(initializeValuesBuyer(payload.buyer));
    dispatch(initializeValuesSeller(payload.seller));
    dispatch(initializeValuesShipment(payload));
    dispatch(initializeValuesInvoice(payload.invoices, declarationType));
    dispatch(initializeHeaderContainer(payload.containers));
    dispatch(initializeValueBuildUp(payload.shipmentId));
  };
}
function setErrorMessage(errorMessage) {
  return {
    type: SET_ERROR_MESSAGE$2,
    errorMessage
  };
}

const showToast = (msg, duration = '3000') => {
  store$4.dispatch(setErrorMessage(msg));
  let toast = document.getElementsByClassName('toast');
  if (toast[0]) {
    toast[0].style.display = 'block';
  }
  if (window.toastTimeOut) {
    clearTimeout(window.toastTimeOut);
  }
  window.toastTimeOut = setTimeout(() => {
    try {
      toast[0].style.display = 'none';
    } catch (e) {}
  }, duration);
};

const saveEvent = eventMessage => ({
  eventType: SAVE_FORM_ES,
  eventTime: Date.now(),
  eventMessage
});
const saveItemEvent = eventMessage => ({
  eventType: SAVE_ITEM_ES,
  eventTime: Date.now(),
  eventMessage
});
const HttpPostRequest = (requestParams, fieldName = "") => {
  return HttpClient$1.post(requestParams).then(res => {
    if (fieldName !== "procedure" && res.data.eventMessage.code !== 200 && res.data.eventMessage.hasOwnProperty("code") === true) {
      console.error("errorCode :" + res.data.eventMessage.code, "eventMessage :" + res.data.eventMessage.msg);
      console.log("eventMessage :" + res.data.eventMessage.msg);
      store$4.dispatch(setErrorMessage("Data not saved, try again after sometime!"));
      showToast("Data not saved, try again after sometime!");
    } else {
      //   store.dispatch(setErrorMessage("Data saved successfully."))
      //  showToast("Data saved successfully.");
      res = res.data.eventMessage;
    }
    return res;
  }).catch(error => {
    console.log("ERROR:: " + error);
    showToast("Something went wrong, Check your network connection!");
    return "";
  });
};
const saveShipmentDetail = (fieldName, value) => {
  let dataSent = saveEvent({
    [fieldName]: value,
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const saveShipmentDuty = (fieldName, value, dutyExtUkId) => {
  let dataSent = saveEvent({
    shipmentId: window.shipmentId,
    valueBuildUp: {
      [fieldName]: value,
      dutyExtUkId,
      shipmentId: window.shipmentId
    }
  });
  return HttpPostRequest(dataSent);
};
const saveMerchandiseMultiLineItem = (merchandiseId, fieldSet, invoiceId) => {
  let payload = {
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        ...fieldSet,
        invoiceId,
        shipmentId: window.shipmentId
      }]
    }],
    shipmentId: window.shipmentId
  };
  if (fieldSet['currency']) {
    payload.invoices[0]['currency'] = fieldSet['currency'];
  }
  let dataSent = saveItemEvent(payload);
  return HttpPostRequest(dataSent);
};
const saveMerchandiseLineItem = (merchandiseId, fieldName, value, merchandise) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId: merchandise.invoiceId,
      merchandises: [{
        merchandiseId,
        [fieldName]: value,
        invoiceId: merchandise.invoiceId,
        shipmentId: window.shipmentId
      }]
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent, fieldName);
};
const saveInvoiceItem = (invoiceId, fieldName, value) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId,
      [fieldName]: value,
      shipmentId: window.shipmentId
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const saveNotes = (noteId, fieldName, value) => {
  let dataSent = {
    eventType: SAVE_SHIPMENT_NOTES$2,
    eventTime: Date.now(),
    eventMessage: {
      noteId,
      [fieldName]: value,
      shipmentId: window.shipmentId
    }
  };
  return HttpPostRequest(dataSent);
};
const addMerchandiseLineItem = invoiceId => {
  let dataSent = saveItemEvent({
    shipmentId: window.shipmentId,
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId: "",
        invoiceId,
        shipmentId: window.shipmentId
      }]
    }]
  });
  return dataSent;
};
const createInvoice = () => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId: "",
      shipmentId: window.shipmentId
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
// export const saveMerchandiseLineItemDuty = (
//     merchandiseId,
//     merchandiseDutyId,
//     fieldName,
//     value,
//     fieldName2 = '',
//     value2 = ''
//   ) => {
//     let dataSent = {}
//     if (fieldName2 !== '' && value2 !== '') {
//       dataSent = saveItemEvent({
//         descriptionOfMerchandise: {
//           merchandiseLineItems: [
//             {
//               merchandiseId,
//               C88MerchandiseDuty: [
//                 {
//                   [fieldName]: value,
//                   [fieldName2]: value2,
//                   merchandiseId,
//                   merchandiseDutyId,
//                 },
//               ],
//             },
//           ],
//         },
//         shipmentId: window.shipmentId,
//       })
//     } else {
//       dataSent = saveItemEvent({
//         descriptionOfMerchandise: {
//           merchandiseLineItems: [
//             {
//               merchandiseId,
//               C88MerchandiseDuty: [
//                 {
//                   [fieldName]: value,
//                   merchandiseId,
//                   merchandiseDutyId,
//                 },
//               ],
//             },
//           ],
//         },
//         shipmentId: window.shipmentId,
//       })
//     }

//     return HttpPostRequest(dataSent)
//   }

const saveGuaranteeInfo = (warrantyId, fieldName, value) => {
  let dataSent = saveEvent({
    warranties: [{
      [fieldName]: value,
      warrantyId,
      shipmentId: window.shipmentId
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const saveLineItemContainer = (merchandiseId, invoiceId, containerId, fieldName, value) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        invoiceId,
        containers: [{
          containerId,
          [fieldName]: value
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const addMerchandiseLineItemDuty = (merchandiseId, invoiceId, payload) => {
  console.log(payload);
  //debugger
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId: invoiceId,
      merchandises: [{
        merchandiseId: merchandiseId,
        invoiceId: invoiceId,
        shipmentId: window.shipmentId,
        itemDuties: [{
          merchandiseId: merchandiseId,
          merchandiseDutyId: '',
          ...payload
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const addNotesItem = (description, createdBy, hotCheckBox) => {
  let dataSent = {
    eventType: SAVE_SHIPMENT_NOTES$2,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      status: "0",
      description,
      "hot": hotCheckBox === true ? "1" : "0",
      userName: createdBy,
      dateOfNote: {
        epochs: new Date().getTime()
      }
    }
  };
  return dataSent;
};
const addLineItemSupportingDocs = (merchandiseId, invoiceId, code) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        invoiceId,
        additionalInfo: [{
          merchandiseId,
          infoId: "",
          code,
          shipmentId: window.shipmentId
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const addLineItemSpecialMention = (merchandiseId, invoiceId) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        invoiceId,
        specialMentions: [{
          merchandiseId,
          infoId: "",
          shipmentId: window.shipmentId
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const addGuaranteeInfo = () => {
  let dataSent = saveEvent({
    warranties: [{
      shipmentId: window.shipmentId,
      warrantyId: ""
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const saveActorDetail = payload => {
  const {
    actorType,
    ...rest
  } = payload;
  let dataSent = saveEvent({
    [actorType]: {
      actorType: actorType.toUpperCase(),
      ...rest
    },
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const saveContainer = (containerId, fieldName, value) => {
  let dataSent = saveEvent({
    containers: [{
      [fieldName]: value,
      containerId
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const addContainerInfo = () => {
  let dataSent = saveEvent({
    containers: [{
      containerId: "",
      shipmentId: window.shipmentId
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const associateContainerItem = (merchandiseId, invoiceId, containerId, containerNumber) => {
  let dataSent = saveItemEvent({
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId: merchandiseId,
        invoiceId: invoiceId,
        containers: [{
          containerId: containerId,
          shipmentId: window.shipmentId,
          containerNumber
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};
const addSealInfo = () => {
  let dataSent = saveEvent({
    seals: [{
      shipmentId: window.shipmentId,
      sealId: ""
    }],
    shipmentId: window.shipmentId
  });
  return dataSent;
};
const saveSealInfo = (sealId, fieldName, value) => {
  let dataSent = saveEvent({
    seals: [{
      [fieldName]: value,
      sealId,
      shipmentId: window.shipmentId
    }],
    shipmentId: window.shipmentId
  });
  return HttpPostRequest(dataSent);
};

const updateActorFieldValue = (actorType, payload) => {
  return {
    type: UPDATE_ACTOR_FIELD_VALUE$2,
    actorType,
    payload
  };
};
// export function updateActorAddressValue(actorType, fieldName, payload) {
//     return {
//         type: ActionTypes.UPDATE_ACTOR_ADDRESS_VALUE,
//         payload,
//         actorType,
//         fieldName
//     }
// }

const saveActorDetails = payload => {
  const {
    id,
    actorType
  } = payload;
  // let fields = Object.keys(payload).slice(0, -2)
  return (dispatch, getState) => {
    saveActorDetail(payload).then(response => {
      if (!id) dispatch(updateActorFieldValue(actorType, {
        id: response[actorType].id
      }));

      //     if(actor.id ==="" && actorType){
      //         if(response.hasOwnProperty(`${action.actorTpe}`) === true &&  response[action.actorTpe].hasOwnProperty(`id`) === true ){
      //             dispatch(updateActorFieldValue(action.actorTpe, "id", response[action.actorTpe].id))
      //         }
      //     }
    });
  };
};

// export function saveActorAddressValue(actorType, fieldName) {

//     return (dispatch, getState) => {
//         let actor = getState().Actor[actorType]

//         saveActorAddress(actorType, actor.id,  actor.addressId , fieldName , actor[fieldName])
//         .then(response => {
//             // if(actor.id ==="" && actorType){
//             //     if(response.hasOwnProperty(`${actorType}`) === true &&  response[actorType].hasOwnProperty(`id`) === true ){
//             //         dispatch(updateActorFieldValue(actorType, "id", response[actorType].id))
//             //     }                    
//             // }
//         })
//     }
// }

const deleteEvent = eventMessage => ({
  eventType: DELETE_ENTITY_ES,
  eventTime: Date.now(),
  eventMessage
});
const deleteMerchandise = (merchandiseId, invoiceId) => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        invoiceId,
        shipmentId: window.shipmentId
      }]
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error from axios on deleteMerchandise : `, error);
  });
};
const deleteInvoiceLineItem = invoiceId => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    invoices: [{
      shipmentId: window.shipmentId,
      invoiceId: invoiceId
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error from deleteInvoiceLineItem delete: `, error);
  });
};
const deleteMerchandiseDuty = (merchandiseId, merchandiseDutyId, invoiceId) => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    invoices: [{
      invoiceId,
      merchandises: [{
        invoiceId,
        merchandiseId,
        itemDuties: [{
          merchandiseId,
          merchandiseDutyId
        }]
      }]
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error from deleteMerchandiseDuty : `, error);
  });
};
const deleteSupportingDoc = (merchandiseId, infoId, invoiceId) => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    invoices: [{
      invoiceId,
      merchandises: [{
        invoiceId,
        merchandiseId,
        additionalInfo: [{
          merchandiseId,
          infoId
        }]
      }]
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error in delete deleteSupportingDoc : `, error);
  });
};
const deleteGuarantee = warrantyId => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    warranties: [{
      shipmentId: window.shipmentId,
      warrantyId: warrantyId
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error in delete deleteMerchandiseInfo : `, error);
  });
};
const deleteContainer = containerId => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    containers: [{
      shipmentId: window.shipmentId,
      containerId
    }]
  });
  return HttpClient$1.post(dataSent).catch(error => {
    console.error(`Error in delete customs office : `, error);
  });
};
const diassociateContainerNumber = (merchandiseId, invoiceId, containerId, containerAssociationId) => {
  let dataSent = deleteEvent({
    invoices: [{
      invoiceId,
      merchandises: [{
        merchandiseId,
        containers: [{
          containerAssociationId
        }]
      }]
    }],
    shipmentId: window.shipmentId
  });
  return HttpClient$1.post(dataSent);
};
const deleteSealItem = async sealId => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    seals: [{
      shipmentId: window.shipmentId,
      sealId
    }]
  });
  try {
    return await HttpClient$1.post(dataSent);
  } catch (error) {
    console.error(`Error in delete deleting Seal Info : `, error);
  }
};

function createLineItem(invoiceId, invoiceIndex, totalItem, updateStatus) {
  return (dispatch, getState) => {
    let dataSent = addMerchandiseLineItem(invoiceId);
    HttpClient$1.post(dataSent).then(response => {
      let newLineItem = merchandiseLineItems();
      newLineItem.shipmentId = response.data.eventMessage.invoices[0]["merchandises"][0]["shipmentId"] || "";
      newLineItem.merchandiseId = response.data.eventMessage.invoices[0]["merchandises"][0]["merchandiseId"] || "";
      newLineItem.procedure = response.data.eventMessage.invoices[0]["merchandises"][0]["procedure"] || "";
      newLineItem.preference = response.data.eventMessage.invoices[0]["merchandises"][0]["preference"] || "";
      newLineItem.unitCount = "";
      newLineItem.unitPrice = "";
      newLineItem.unitValue = "";
      newLineItem.supUnitsQuantity = response.data.eventMessage.invoices[0]["merchandises"][0]["supUnitsQuantity"] || "";
      newLineItem.supUnits = response.data.eventMessage.invoices[0]["merchandises"][0]["supUnits"] || "";
      newLineItem.netMass = "";
      newLineItem.grossMass = "";
      newLineItem.invoiceId = response.data.eventMessage.invoices[0]["merchandises"][0]["invoiceId"] || "";
      dispatch(createMerchandiseLineItem(newLineItem, invoiceIndex));
      dispatch(updateMerchandisesCount({
        totalItem: totalItem + 1
      }));
      updateStatus();
    }).catch(error => {
      console.log("ERROR:: " + error);
      showToast("Something went while create merchandise");
      updateStatus();
    });
  };
}
function removeLineItem(merchandiseId, invoiceId, invoiceIndex, invoiceItemIndex, totalLineItems, updateStatus) {
  return (dispatch, getState) => {
    deleteMerchandise(merchandiseId, invoiceId).then(response => {
      if (response.data.eventMessage.invoices) {
        var _response$data, _response$data$eventM, _response$data$eventM2, _response$data2, _response$data2$event, _response$data2$event2;
        dispatch({
          type: REMOVE_MERCHANDISE_LINE_ITEM$2,
          merchandiseId,
          invoiceIndex
        });
        let payload = response.data.eventMessage.invoices[0];
        dispatch({
          type: UPDATE_INVOICE_LINE_ITEM_FIELD$3,
          payload,
          invoiceId
        });
        let invoices = getState().InvoicesReducer.invoices;
        let shipmentPayload = {
          totalGrassWeight: invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.grossMass === '' ? 0 : curr.grossMass), 0),
          totalNetWeight: invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.netMass === '' ? 0 : curr.netMass), 0),
          totalInvoiceAmount: (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM = _response$data.eventMessage) === null || _response$data$eventM === void 0 ? void 0 : (_response$data$eventM2 = _response$data$eventM.totalInvoiceAmount) === null || _response$data$eventM2 === void 0 ? void 0 : _response$data$eventM2.toString()) || '0',
          totalInvoiceAmountInCurrency: (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$event = _response$data2.eventMessage) === null || _response$data2$event === void 0 ? void 0 : (_response$data2$event2 = _response$data2$event.totalInvoiceAmountInCurrency) === null || _response$data2$event2 === void 0 ? void 0 : _response$data2$event2.toString()) || '0',
          totalShipmentPackages: invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.packageCount === '' ? 0 : curr.packageCount), 0)
        };
        dispatch(updateShipmentFieldValue$2(shipmentPayload));
        let updatedCount = totalLineItems - 1;
        dispatch(updateMerchandisesCount({
          totalItem: updatedCount
        }));
      }
      updateStatus();
    }).catch(error => {
      console.error(`Error from removeLineItem: `, error);
      showToast("Something went wrong, Check your network connection!");
      updateStatus();
    });
  };
}
function updateMerchandisesCount(payload) {
  return {
    type: UPDATE_MERCHANDISE_COUNT$3,
    payload
  };
}
function createMerchandiseLineItem(newLineItem, invoiceIndex) {
  return {
    type: CREATE_MERCHANDISE_LINE_ITEM$2,
    newLineItem,
    invoiceIndex
  };
}

function createInvoiceItem(totalItem, totalInvoice, addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = createInvoice();
    HttpClient$1.post(dataSent).then(response => {
      let newInvoiceItem = invoiceItemData();
      let newLineItem = merchandiseLineItems();
      newInvoiceItem.shipmentId = response.data.eventMessage.invoices[0]['shipmentId'] || '';
      newInvoiceItem.invoiceId = response.data.eventMessage.invoices[0]['invoiceId'] || '';
      newInvoiceItem.invoiceDate = response.data.eventMessage.invoices[0]['invoiceDate'] || {
        epochs: ''
      };
      newInvoiceItem.invoiceTotal = response.data.eventMessage.invoices[0]['invoiceTotal'] || '';
      newInvoiceItem.shipmentId = response.data.eventMessage.invoices[0]['shipmentId'] || '';
      newInvoiceItem.merchandiseList = [newLineItem];
      dispatch(addInvoiceItem(newInvoiceItem));
      let datasent = addMerchandiseLineItem(response.data.eventMessage.invoices[0]['invoiceId']);
      HttpClient$1.post(datasent).then(response => {
        newLineItem.merchandiseId = lodash_2(response, 'data.eventMessage.invoices[0]["merchandises"][0]["merchandiseId"]', '');
        newLineItem.invoiceId = response.data.eventMessage.invoices[0]['invoiceId'] || '';
        dispatch(updateMerchandisesCount({
          totalItem: totalItem + 1,
          totalInvoice: totalInvoice + 1
        }));
      });
      addInfoStatus();
    }).catch(error => {
      console.log('ERROR:: ' + error);
      showToast('Something went wrong, while  creating new invoice');
      addInfoStatus();
    });
  };
}
function createSpecialMentionLineItemInfo(invoiceIndex, index, lineItemId, invoiceId, addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addLineItemSpecialMention(lineItemId, invoiceId);
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.invoices[0].merchandises[0].specialMentions[0].hasOwnProperty('infoId') === true) {
        let newInfo = {};
        newInfo.merchandiseId = lineItemId;
        newInfo.infoId = response.data.eventMessage.invoices[0].merchandises[0].specialMentions[0].infoId || '';
        newInfo.code = response.data.eventMessage.invoices[0].merchandises[0].specialMentions[0].code || '';
        dispatch({
          type: ADD_SPECIAL_MENTION_INFO,
          index,
          invoiceIndex,
          newInfo
        });
      }
      addInfoStatus();
    }).catch(error => {
      console.log('ERROR:: ' + error);
      showToast('Something went wrong, Check your network connection!');
      addInfoStatus();
    });
  };
}
function createSupportingDocsInfo(invoiceIndex, index, lineItemId, invoiceId, addInfoStatus, code) {
  return (dispatch, getState) => {
    let dataSent = addLineItemSupportingDocs(lineItemId, invoiceId, code);
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.invoices[0].merchandises[0].additionalInfo[0].hasOwnProperty('infoId') === true) {
        let payload = response.data.eventMessage.invoices[0].merchandises[0].additionalInfo[0];
        payload.merchandiseId = lineItemId;
        let newInfo = {};
        newInfo.infoId = payload.infoId || '';
        newInfo.code = payload.code || '';
        newInfo.ref = payload.ref || '';
        dispatch({
          type: ADD_SUPPORTING_DOC_INFO,
          index,
          invoiceIndex,
          newInfo
        });
      }
      addInfoStatus();
    }).catch(error => {
      console.log('ERROR:: ' + error);
      showToast('Something went wrong, Check your network connection!');
      addInfoStatus();
    });
  };
}
function createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, payload) {
  return (dispatch, getState) => {
    let dataSent = addMerchandiseLineItemDuty(merchandiseId, invoiceId, payload);
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].hasOwnProperty('merchandiseDutyId') === true) {
        var _response$data$eventM, _response$data$eventM2;
        let payload = {};
        payload.merchandiseDutyId = response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].merchandiseDutyId || '';
        payload.taxRate = response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].taxRate || '';
        payload.taxAmount = response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].taxAmount || '';
        payload.taxType = response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].taxType || '';
        payload.taxBase = response.data.eventMessage.invoices[0].merchandises[0].itemDuties[0].taxBase || '';
        payload.merchandiseId = merchandiseId;
        let totalAmount = (_response$data$eventM = response.data.eventMessage.invoices[0]) === null || _response$data$eventM === void 0 ? void 0 : (_response$data$eventM2 = _response$data$eventM.merchandises[0]) === null || _response$data$eventM2 === void 0 ? void 0 : _response$data$eventM2.totalAmount;
        dispatch({
          type: UPDATE_MERCH_LINE_ITEM_FIELD$2,
          invoiceId,
          payload: {
            totalAmount
          },
          merchandiseId
        });
        dispatch({
          type: ADD_MERCH_DUTY$2,
          merchandiseId,
          payload,
          invoiceId
        });
      }
      updateAddDutyStatus();
    });
    // .catch((error) => {
    //   console.log('ERROR:: ' + error)
    //   showToast('Something went wrong,while creating merchandise duty!')
    //   updateAddDutyStatus()
    // })
  };
}
const collapseLineItems = index => {
  return {
    type: COLLAPSE_LINE_ITEMS$3,
    index
  };
};
const expandLineItems = index => {
  return {
    type: EXPAND_LINE_ITEMS$3,
    index
  };
};
const expandAllLineItem = (index, value) => {
  return {
    type: EXPAND_ALL_LINE_ITEMS$3,
    index,
    value
  };
};
const expandLineItem = (invoiceIndex, lineItemIndex, lineflag) => {
  return {
    type: EXPAND_LINE_ITEM$3,
    invoiceIndex,
    lineItemIndex,
    lineflag
  };
};
function updateInvoiceLineItemFeild(invoiceId, payload) {
  return {
    type: UPDATE_INVOICE_LINE_ITEM_FIELD$3,
    payload,
    invoiceId
  };
}
function updateLineItemFeild(invoiceId, merchandiseId, payload) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_MERCH_LINE_ITEM_FIELD$2,
      invoiceId,
      payload,
      merchandiseId
    });
  };
}
function updateMultipleLineItems(invoiceId, payload) {
  return {
    type: UPDATE_ITEM_VALUES,
    payload
  };
}
function saveInvoiceLineItemFeild(invoiceId, fieldName) {
  return (dispatch, getState) => {
    let invoice = getState().InvoicesReducer.invoices.find(invoice => invoice.invoiceId === invoiceId);
    let fieldValue = invoice[fieldName] === '' ? ' ' : invoice[fieldName];
    //console.log(fieldValue, 'fieldValue')
    saveInvoiceItem(invoiceId, fieldName, fieldValue).then(response => {
      if (response !== null && response !== void 0 && response.invoices) {
        if (fieldName === 'shipmentCurrency') {
          var _response$totalInvoic;
          dispatch(updateMultipleLineItems(invoiceId, response.invoices));
          let shipmentPayload = {
            totalInvoiceAmount: ((_response$totalInvoic = response.totalInvoiceAmount) === null || _response$totalInvoic === void 0 ? void 0 : _response$totalInvoic.toString()) || '0'
          };
          dispatch(updateShipmentFieldValue$2(shipmentPayload));
        }
      } else {
        var _response$data, _response$data$eventM3;
        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM3 = _response$data.eventMessage) === null || _response$data$eventM3 === void 0 ? void 0 : _response$data$eventM3.code) === 400) {
          var _response$data2, _response$data2$event;
          showToast(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$event = _response$data2.eventMessage) === null || _response$data2$event === void 0 ? void 0 : _response$data2$event.msg);
        }
      }
    });
  };
}
function saveLineItemFeild(merchandiseId, fieldName, invoiceId, counter = '', declarationTypeValue = '') {
  return (dispatch, getState) => {
    let invoiceData = getState().InvoicesReducer.invoices.find(invoice => invoice.invoiceId === invoiceId);
    let currencyData = getState().Shipment.shipmentCurrency;
    let merchandise = invoiceData.merchandiseList.find(merch => merch.merchandiseId === merchandiseId);
    let fieldSet = {};
    let fieldValue = merchandise[fieldName] === '' ? ' ' : merchandise[fieldName];
    if (Array.isArray(fieldName)) {
      fieldName.map(item => {
        fieldValue = merchandise[item] === '' ? ' ' : merchandise[item];
        fieldSet[item] = fieldValue;
      });
      if (fieldName.includes('unitValue')) {
        fieldSet['currency'] = currencyData;
      }
      saveMerchandiseMultiLineItem(merchandiseId, fieldSet, invoiceId).then(response => {
        if (response && response.invoices) {
          var _response$totalInvoic2, _response$totalInvoic3;
          let payload = response === null || response === void 0 ? void 0 : response.invoices[0];
          console.log(payload);
          let shipmentPayload = {
            totalInvoiceAmount: ((_response$totalInvoic2 = response.totalInvoiceAmount) === null || _response$totalInvoic2 === void 0 ? void 0 : _response$totalInvoic2.toString()) || '0.00',
            totalInvoiceAmountInCurrency: ((_response$totalInvoic3 = response.totalInvoiceAmountInCurrency) === null || _response$totalInvoic3 === void 0 ? void 0 : _response$totalInvoic3.toString()) || '0.00'
          };
          dispatch({
            type: UPDATE_INVOICE_LINE_ITEM_FIELD$3,
            payload,
            invoiceId
          });
          dispatch({
            type: UPDATE_SHIPMENT_FIELD_VALUE$3,
            payload: shipmentPayload
          });
          if (fieldSet.hasOwnProperty('unitValue') && response !== null && response !== void 0 && response.invoices) {
            dispatch(updateMultipleLineItems(invoiceId, response.invoices));
          }
        }
      });
    } else {
      saveMerchandiseLineItem(merchandise.merchandiseId, fieldName, fieldName === 'commodityCode' ? fieldValue.replace(/\./g, '') : fieldValue, merchandise).then(response => {
        let payload = response === null || response === void 0 ? void 0 : response.invoices[0];
        console.log(payload);
        dispatch({
          type: UPDATE_INVOICE_LINE_ITEM_FIELD$3,
          payload,
          invoiceId
        });
        if (fieldName === 'grossMass' || fieldName === 'netMass' || fieldName === 'packageCount') {
          let shipmentPayload = {};
          switch (fieldName) {
            case 'grossMass':
              shipmentPayload = {
                totalGrassWeight: getState().InvoicesReducer.invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.grossMass === '' ? 0 : curr.grossMass), 0)
              };
              break;
            case 'netMass':
              shipmentPayload = {
                totalNetWeight: getState().InvoicesReducer.invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.netMass === '' ? 0 : curr.netMass), 0)
              };
              break;
            case 'packageCount':
              shipmentPayload = {
                totalShipmentPackages: getState().InvoicesReducer.invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.packageCount === '' ? 0 : curr.packageCount), 0)
              };
              break;
            default:
              shipmentPayload = {};
          }
          dispatch(updateShipmentFieldValue$2(shipmentPayload));
        }
      }).catch(err => console.log(err));
    }
  };
}
const createContainerAtLineLevel = (containerId, containerNumber, merchandiseId, invoiceId, invoiceItemIndex, lineItemIndex) => {
  return (dispatch, getState) => {
    associateContainerItem(merchandiseId, invoiceId, containerId, containerNumber).then(response => {
      if (response.invoices[0].merchandises[0].containers[0].containerAssociationId) {
        let payload = itemContainerMapper();
        payload.containerId = lodash_2(response, 'invoices[0].merchandises[0].containers[0].containerId', '');
        payload.shipmentId = lodash_2(response, 'invoices[0].merchandises[0].containers[0].shipmentId', '');
        payload.merchandiseId = lodash_2(response, 'invoices[0].merchandises[0].containers[0].merchandiseId', '');
        payload.containerAssociationId = lodash_2(response, 'invoices[0].merchandises[0].containers[0].containerAssociationId', '');
        payload.invoiceId = lodash_2(response, 'invoices[0].merchandises[0].containers[0].invoiceId', '');
        payload.containerNumber = containerNumber;
        dispatch({
          type: CREATE_CONATINER_ITEM_LEVEL,
          index: lineItemIndex,
          invoiceItemIndex,
          payload
        });
      }
    }).catch(error => {
      console.log('ERROR:: ' + error);
      showToast('Error occurred in associating container with Merchandise ');
    });
  };
};
function removeContainerItem(invoiceIndex, lineItemIndex, index, merchandiseId, invoiceId, containerId, containerAssociationId) {
  return (dispatch, getState) => {
    diassociateContainerNumber(merchandiseId, invoiceId, containerId, containerAssociationId).then(response => {
      if (response.data.eventMessage.hasOwnProperty('code') === true && response.data.eventMessage.code === 200) {
        dispatch({
          type: REMOVE_CONTAINER$3,
          lineItemIndex,
          index,
          invoiceIndex,
          containerId
        });
        console.log(response);
      }
    }).then(showToast('Container dissociated successfully!')).catch(error => {
      console.error(`Error from axios on FIELD set: `, error);
      showToast('Error occurred in dissociating container with Merchandise! ');
      // deleteDutyStatus();
    });
  };
}
function removeSupportingDocLineInfo({
  tableName,
  fieldIdName,
  invoiceId,
  merchandiseId,
  id
}) {
  return (dispatch, getState) => {
    deleteSupportingDoc(merchandiseId, id, invoiceId).then(response => {
      if (response.data.eventMessage.hasOwnProperty('code') === true && response.data.eventMessage.code === 200) {
        dispatch({
          type: DELETE_MERCHANDISE_DOC_BY_ID$2,
          id,
          fieldIdName,
          payload: {
            invoiceId,
            merchandiseId
          },
          meta: {
            tableName: tableName
          }
        });
        console.log(response);
      }
      // deleteInfoStatus()
    }).catch(error => {
      console.error(`Error in removeSupportingDocLineInfo : `, error);
      showToast('Something went wrong, Check your network connection!');
      // deleteInfoStatus()
    });
  };
}
function removeLineItemDuty(merchandiseId, merchandiseDutyId, invoiceId, deleteDutyStatus) {
  return (dispatch, getState) => {
    deleteMerchandiseDuty(merchandiseId, merchandiseDutyId, invoiceId).then(response => {
      if (response.status === 200 && response.data.eventMessage.invoices) {
        let payload = response.data.eventMessage.invoices[0].merchandises[0].totalAmount;
        payload = {
          totalAmount: payload
        };
        dispatch({
          type: REMOVE_DUTY_ITEM$3,
          merchandiseId,
          invoiceId,
          merchandiseDutyId
        });
        dispatch({
          type: UPDATE_MERCH_LINE_ITEM_FIELD$2,
          invoiceId,
          payload,
          merchandiseId
        });
      }
      deleteDutyStatus();
    }).catch(error => {
      console.error(`Error from axios on FIELD set: `, error);
      showToast('Something went wrong while deleting merchandise duty!');
      deleteDutyStatus();
    });
  };
}
function updateContainerLineItemFeild(invoiceIndex, index, field, containerIndex, payload) {
  return {
    type: UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD$3,
    invoiceIndex,
    payload,
    field,
    containerIndex,
    index
  };
}
function saveContainerLineItemFeild(invoiceIndex, index, infoIndex, fieldName) {
  return (dispatch, getState) => {
    let lineItem = getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList[index];
    let lineItemInfo = lineItem.containers[infoIndex];
    let response = saveLineItemContainer(lineItem.merchandiseId, lineItem.invoiceId, lineItemInfo.containerId, fieldName, lineItemInfo[fieldName] === '' ? ' ' : lineItemInfo[fieldName]);
    console.log(response);
  };
}
function removeInvoiceLineItem(invoiceId, invoiceTotal, invoiceIndex, updateStatus, totalItem) {
  return (dispatch, getState) => {
    deleteInvoiceLineItem(invoiceId).then(response => {
      if (response.data.eventMessage && response.data.eventMessage.invoices) {
        var _response$data3, _response$data3$event, _response$data3$event2;
        let payload = {
          totalGrassWeight: getState().InvoicesReducer.invoices.reduce((acc, curr) => acc + parseFloat(curr.grassWeight === '' ? 0 : curr.grassWeight), 0) - getState().InvoicesReducer.invoices[invoiceIndex].grassWeight,
          totalNetWeight: getState().InvoicesReducer.invoices.reduce((acc, curr) => acc + parseFloat(curr.netWeight === '' ? 0 : curr.netWeight), 0) - getState().InvoicesReducer.invoices[invoiceIndex].netWeight,
          totalShipmentPackages: getState().InvoicesReducer.invoices.map(e => e.merchandiseList).flat(1).reduce((acc, curr) => acc + parseFloat(curr.packageCount === '' ? 0 : curr.packageCount), 0) - getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList.reduce((acc, curr) => acc + parseFloat(curr.packageCount === '' ? 0 : curr.packageCount), 0),
          totalInvoice: getState().InvoicesReducer.invoices.length - 1,
          totalItem: getState().InvoicesReducer.invoices.map(e => e.merchandiseList).flat(1).length - getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList.length,
          totalInvoiceAmount: (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$event = _response$data3.eventMessage) === null || _response$data3$event === void 0 ? void 0 : (_response$data3$event2 = _response$data3$event.totalInvoiceAmount) === null || _response$data3$event2 === void 0 ? void 0 : _response$data3$event2.toString()) || '0'
        };
        dispatch({
          type: REMOVE_INVOICE_LINE_ITEM$2,
          invoiceId: invoiceId
        });
        dispatch({
          type: UPDATE_SHIPMENT_FIELD_VALUE$3,
          payload
        });
      }
      updateStatus();
    }).catch(error => {
      console.error(`Error from axios on FIELD set: `, error);
      showToast('Something went wrong, Check your network connection!');
      updateStatus();
    });
  };
}
function addInvoiceItem(newInvoiceItem) {
  return {
    type: ADD_INVOICE_ITEM$2,
    newInvoiceItem
  };
}

function updateShipmentFieldValue$2(payload) {
  return {
    type: UPDATE_SHIPMENT_FIELD_VALUE$3,
    payload
  };
}
function updateGuaranteeInfoFeild(id, infoIndex, payload) {
  return {
    type: UPDATE_GUARANTEE_INFO_FIELD,
    payload,
    id,
    infoIndex
  };
}
function updateShipmentCountry(countryType, countryField, payload) {
  return {
    type: UPDATE_SHIPMENT_COUNTRY_VALUE,
    countryType,
    countryField,
    payload
  };
}
function saveShipmentFieldValue(fieldName, val = "") {
  return (dispatch, getState) => {
    let fieldValue = getState().Shipment[fieldName] === "" ? " " : getState().Shipment[fieldName];
    saveShipmentDetail(fieldName, fieldValue).then(response => {
      if (fieldName === "shipmentCurrency") {
        if (response.hasOwnProperty("invoices") === true) {
          dispatch(updateMultipleLineItems(_, response.invoices));
        } else if (response.data.eventMessage.hasOwnProperty("code") === true) {
          showToast(response.data.eventMessage.msg);
        }
      }
    }).catch(err => console.log(err));
  };
}
function deleteGuaranteeInfo(id, infoIndex, deleteInfoStatus) {
  return (dispatch, getState) => {
    deleteGuarantee(id).then(response => {
      dispatch({
        type: DELETE_GUARANTEE_INFO,
        id
      });
      deleteInfoStatus();
      console.log(response);
    }).catch(error => {
      console.error(`Error in deleteGuaranteeInfo : `, error);
      showToast("Something went wrong, Check your network connection!");
      deleteInfoStatus();
    });
  };
}
function createGauranteeInfo(addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addGuaranteeInfo();
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.hasOwnProperty("warranties") && response.data.eventMessage.warranties[0].hasOwnProperty("warrantyId")) {
        let payload = response.data.eventMessage.warranties[0];
        let newInfo = warrantyObj();
        newInfo.warrantyId = payload.warrantyId || "";
        newInfo.warrantyReferences = payload.warrantyReferences || "";
        dispatch({
          type: ADD_GUARANTEE_INFO,
          newInfo
        });
      }
      addInfoStatus();
    }).catch(error => {
      console.log("ERROR:: " + error);
      showToast("Something went wrong, while create guarntee");
      addInfoStatus();
    });
  };
}
function updateShipmentDuty(dutyField, payload) {
  return {
    type: UPDATE_SHIP_DUTY_FIELD$3,
    dutyField,
    payload
  };
}
function saveShipmentDutyValue(fieldName) {
  return (dispatch, getState) => {
    let shipmentDuty = getState().Shipment.valueBuildUp;
    saveShipmentDuty(fieldName, shipmentDuty[fieldName] === "" ? " " : shipmentDuty[fieldName], shipmentDuty.dutyExtUkId);
  };
}
function saveGuaranteeInfoFeild(warrantyId, fieldName) {
  return (dispatch, getState) => {
    let lineItemInfo = getState().Shipment.warranties.find(c => c.warrantyId === warrantyId);
    let fieldValue = lineItemInfo[fieldName] === "" ? " " : lineItemInfo[fieldName];
    let response = saveGuaranteeInfo(lineItemInfo.warrantyId, fieldName, fieldValue);
    console.log(response);
  };
}

//container Actions
function saveContainerHeader(infoIndex, fieldName) {
  return (dispatch, getState) => {
    let lineItemInfo = getState().ContainerReducer.containers[infoIndex];
    let fieldValue = lineItemInfo[fieldName] === "" ? " " : lineItemInfo[fieldName];
    let response = saveContainer(lineItemInfo.containerId, fieldName, fieldValue);
    console.log(response);
  };
}
function updateContainer(containerNumber, index) {
  return {
    type: UPDATE_CONTAINER,
    index,
    containerNumber
  };
}
function removeContainer(containerId) {
  return (dispatch, getState) => {
    deleteContainer(containerId).then(response => {
      if (response.data.eventMessage.hasOwnProperty("code") === true && response.data.eventMessage.code === 200) {
        dispatch({
          type: DELETE_CONTAINER,
          containerId
        });
      }
    }).catch(error => {
      console.error(`Error in removeLineItemInfo : `, error);
      showToast("Error in removeLineItemInfo");
    });
  };
}
function createContainerHeaderInfo(containerNumber) {
  return (dispatch, getState) => {
    let dataSent = addContainerInfo();
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.containers[0].containerId) {
        let payload = ShipmentContainerMapper();
        payload.containerId = _.get(response, "data.eventMessage.containers[0].containerId", "");
        payload.shipmentId = _.get(response, "data.eventMessage.containers[0].shipmentId", "");
        dispatch({
          type: ADD_CONTAINER,
          payload
        });
      }
    }).catch(error => {
      console.log("ERROR:: " + error);
      showToast("Something went wrong");
    });
  };
}
function createSealInfo(addInfoStatus) {
  return (dispatch, getState) => {
    let dataSent = addSealInfo();
    HttpClient$1.post(dataSent).then(response => {
      if (response.data.eventMessage.seals[0].sealId) {
        let payload = response.data.eventMessage.seals[0];
        dispatch({
          type: CREATE_SEAL_INFO,
          payload
        });
      }
      addInfoStatus();
    }).catch(error => {
      console.log("ERROR:: " + error);
      showToast("Something went wrong n adding Seal Info!!");
      addInfoStatus();
    });
  };
}
function updateSealInfoFeild(infoIndex, infoField, payload) {
  return {
    type: UPDATE_SEAL_INFO_FIELD,
    payload,
    infoIndex,
    infoField
  };
}
function saveSealInfoFeilds(infoIndex, fieldName, sealId) {
  return (dispatch, getState) => {
    let lineItemInfo = getState().Shipment.seals[infoIndex];
    let fieldValue = lineItemInfo[fieldName];
    fieldValue = fieldValue || fieldValue === 0 ? fieldValue : " ";
    let response = saveSealInfo(sealId, fieldName, fieldValue);
    console.log(response);
  };
}
function deleteSealInfo(sealId, infoIndex, deleteInfoStatus) {
  return (dispatch, getState) => {
    deleteSealItem(sealId).then(response => {
      if (response.data.eventMessage.code === 200) {
        dispatch({
          type: DELETE_SEAL_ITEM,
          sealId
        });
      }
      deleteInfoStatus();
      console.log(response);
    }).catch(error => {
      console.error(`Error in removeLineItemInfo : `, error);
      showToast('Something went wrong, Check your network connection!');
      deleteInfoStatus();
    });
  };
}

// headerTab
const GOODS_LOCATION = "GOODS_LOCATION";
const TRANSACTION_NATURE = "TRANSACTION_NATURE";
const COUNTRY_OF_EXPORT = "COUNTRY_OF_EXPORT";
const CTR = "CTR";
const DEC_TYPE = "DEC_TYPE";
const DECLARATION = "DECLARATION";
const TRANSPORT_MODE = "TRANSPORT_MODE";
const CUSTOMS_OFFICE = "CUSTOMS_OFFICE";
const ENTRY_OFFICE = "ENTRY_OFFICE";
const EXIT_OFFICE = "EXIT_OFFICE";
const CANCELLATION_REASON = "CANCELLATION_REASON";
const DESTINATION_COUNTRY = "DESTINATION_COUNTRY";

// partiesTab
const CONSIGNOR = "CONSIGNOR";
const CONSIGNEE = "CONSIGNEE";
const DECLARANT = "DECLARANT";
const BUYER = "BUYER";
const SELLER = "SELLER";
const NAME = "NAME";
const EORI_NUM = "EORI_NUM";
const ADDRESS_LINE_1 = "ADDRESS_LINE_1";
const ADDRESS_LINE_2 = "ADDRESS_LINE_2";
const CITY = "CITY";
const STATE = "STATE";
const ZIP_CODE = "ZIP_CODE";
const COUNTRY = "COUNTRY";
const PRIVATE_OPERATOR = 'PRIVATE_OPERATOR';
const BROKER = 'BROKER';

// itemsTab

const INVOICE_NUMBER = "INVOICE_NUMBER";
const CURRENCY_CODE = "CURRENCY_CODE";
const INCO_TERMS = "INCO_TERMS";
const TRADE_TERMS = "TRADE_TERMS";
const LOCATION = "LOCATION";
const CODE = "CODE";
const GOODS_DESCRIPTION = "GOODS_DESCRIPTION";
const SUP_UNIT_COUNT = "SUP_UNIT_COUNT";
const COUNTRY_ORIGIN = "COUNTRY_ORIGIN";
const PREFERENCE = "PREFERENCE";
const REDUCTION = "REDUCTION";
const REGIME_CODE = "REGIME_CODE";
const COMP_REGIME_CODES = "COMP_REGIME_CODES";
const PKG_COUNT = "PKG_COUNT";
const PKG_TYPE = "PKG_TYPE";
const CONVERTED_VALUE = "CONVERTED_VALUE";
const CUSTOMS_VALUE = "CUSTOMS_VALUE";
const STAT_VALUE = "STAT_VALUE";
const GROSS_WEIGHT = "GROSS_WEIGHT";
const NET_MASS = "NET_MASS";
const QUOTA = "QUOTA";
const TAX_TYPE = "TAX_TYPE";
const TAXABLE_BASE = "TAXABLE_BASE";
const RATE = "RATE";
const ADD_CODES_1 = "ADD_CODES_1";
const ADD_CODES_2 = "ADD_CODES_2";
const PREV_DOC_INFO = "PREV_DOC_INFO";
const PREV_DOC_INFO_CLASS = "PREV_DOC_INFO_CLASS";
const PREV_DOC_INFO_REF = "PREV_DOC_INFO_REF";
const SPECIAL_MENTIONS = "SPECIAL_MENTIONS";
const ADD_INFO = "ADD_INFO";
const DOC_DATE = "DOC_DATE";
const REFERENCE = "REFERENCE";
const COMMODITY_CODE = "COMMODITY_CODE";
const PROVINCE_ORIGIN = "PROVINCE_ORIGIN";
const TOTAL_INVOICE_AMT = "TOTAL_INVOICE_AMT";

const Alpha_Numeric_SH = "Alpha Numeric, space and hyphen";
const validationPatterns = {
  A: {
    pattern: /^[a-zA-Z]*$/,
    description: "alphabetical"
  },
  N: {
    pattern: /^[0-9]*$/,
    description: "numerical"
  },
  D: {
    pattern: /^[0-9]*(.[0-9]+)?$/,
    description: "decimal"
  },
  ND: {
    pattern: /^[0-9]{1,11}(?:\.[0-9]{1,3})?$/,
    description: "number with 3 decimal places"
  },
  ND2: {
    pattern: /^[0-9]{1,10}(?:\.[0-9]{1,2})?$/,
    description: "number with 10 digits before decimal and 2  digits after decimal"
  },
  ND7: {
    pattern: /^[0-9]{1,10}(?:\.[0-9]{0,7})?$/,
    description: "number with 10 digits before decimal and 7  digits after decimal"
  },
  ND6: {
    pattern: /^[0-9]{1,6}(?:\.[0-9]{0,6})?$/,
    description: "number with 6 digits before decimal and 6  digits"
  },
  N11D3: {
    pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
    description: "number with 11 digits before decimal and 3 digits after decimal"
  },
  N13D3: {
    pattern: /^[0-9]{0,13}(?:\.[0-9]{0,3})?$/,
    description: "number with 13 digits before decimal and 3 digits after decimal"
  },
  N11D7: {
    pattern: /^[0-9]{0,11}(?:\.[0-9]{0,7})?$/,
    description: "number with 11 digits before decimal and 7 digits after decimal"
  },
  N12D3: {
    pattern: /^[0-9]{0,12}(?:\.[0-9]{0,3})?$/,
    description: "non negative numbers with 12 digits before decimal and 3 digits after decimal"
  },
  GT0N12D2: {
    pattern: /^(?=.*[1-9])\d{0,12}(?:\.\d{1,2})?$/,
    description: "numbers greater than 0 with 12 digits before decimal and 2 digits after decimal"
  },
  N15D2: {
    pattern: /^[0-9]{0,15}(?:\.[0-9]{0,2})?$/,
    description: "number with 15 digits before decimal and 2 digits after decimal"
  },
  N16D2: {
    pattern: /^[0-9]{0,16}(?:\.[0-9]{0,2})?$/,
    description: "number with 16 digits before decimal and 2 digits after decimal"
  },
  N16D6: {
    pattern: /^[0-9]{0,16}(?:\.[0-9]{0,6})?$/,
    description: "number with 16 digits before decimal and 6 digits after decimal"
  },
  AN: {
    pattern: /^[a-zA-Z0-9]*$/,
    description: "Alpha Numeric"
  },
  Alpha: {
    pattern: /^[a-zA-Z0-9 -]*$/,
    description: "Alpha Numeric, space and hyphen"
  },
  P: {
    pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?!\"%&*;<>]*$/,
    description: "A - Z, a - z, 0 – 9, space, " + " full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, <  and >"
  },
  NeverBeZero: {
    pattern: /^\s*$/,
    description: "can never be zero"
  },
  GreaterThanZero: {
    pattern: /0*[1-9][0-9]*(\.[0-9]+)?/,
    description: "is always greater than zero"
  },
  Q: {
    pattern: /^[a-zA-Z0-9 ]*$/,
    description: "A - Z, 0 - 9 and space"
  },
  R: {
    pattern: /^[a-zA-Z ]*$/,
    description: "A - Z and space"
  },
  S: {
    pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?!\"%&*;<>£$@\\^_{}/[/]~|`]*$/,
    description: "This consists of upper and lower case alphas, " + "numeric digits, spaces and special characters"
  },
  T: {
    pattern: /^[a-zA-Z0-9- ]*$/,
    description: "A - Z, 0 - 9, hyphen and space"
  },
  Address: {
    pattern: /^[a-zA-Z0-9., ]*$/,
    description: "A - Z,  comma, dot and space"
  },
  SealID: {
    pattern: /^[a-zA-Z0-9-_]*$/,
    description: "A - Z, 0 - 9, hyphen and underscore"
  },
  U: {
    pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?!\"%&*;<>]*$/,
    description: "A - Z, 0 - 9, space, " + "full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, < and >"
  },
  V: {
    pattern: /^[a-zA-Z0-9-]*$/,
    description: "A - Z, 0 - 9 and hyphen"
  },
  eoriNumber: {
    pattern: /^[{G}{B}]{2}[0-9]+$/,
    pattern1: /^[{X}{I}]{2}[0-9]+$/,
    pattern2: /^[{G}{B}{P}{R}]{4}$/,
    pattern3: /^[{a-zA-Z}{a-zA-Z}]{2}[0-9]+$/,
    description: "first 2 characters as  GB or XI and rest should be numbers.In Special cases it can be GBPR"
  },
  gbp: {
    pattern: /^[{G}{B}{P}]{3}$/,
    description: "only be GBP"
  },
  CITY: {
    pattern: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
    description: "alphabetical"
  },
  POSTAL_CODE: {
    pattern: /^[\w\-\s]+$/,
    description: "Alpha Numeric"
  },
  PROCEDURE: {
    pattern: /^[a-z0-9]+$/i,
    description: "Alpha Numeric"
  },
  ATN: {
    pattern: /^[a-zA-Z0-9- /]*$/,
    description: "Alpha Numeric,hyphen,space and /"
  },
  // support for dutch/spanish characters

  ASC: {
    pattern: /^[a-zA-Z\u00C0-\u00FF]*$/,
    description: "alphabetical"
    // alphabets+ (ES+NL Characters)
  },
  ANSC: {
    pattern: /^[a-zA-Z\u00C0-\u00FF0-9]*$/,
    description: "Alpha Numeric"
    // alphabets+ (ES+NL Characters) + Numbers
  },
  AlphaSC: {
    pattern: /^[a-zA-Z\u00C0-\u00FF0-9 -]*$/,
    description: Alpha_Numeric_SH
    // alphabets+ (ES+NL Characters) + Numbers + space + hyphen
  },
  PSC: {
    pattern: /^[a-zA-Z0-9\u00C0-\u00FF .,-/(/)/'+:=?!\"%&*;<>]*$/,
    description: "A - Z, a - z, 0 – 9, space, " + " full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon,|, <  and >"
    // alphabets+ (ES+NL Characters) + Numbers + space + hyphen +"+" full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon,|, <  and >
  },
  AddressSC: {
    pattern: /^[a-zA-Z0-9\u00C0-\u00FF., ]*$/,
    description: "A - Z,  comma, dot and space"
    // alphabets+ (ES+NL Characters) + Numbers +comma +dot +space
  },
  RSC: {
    pattern: /^[a-zA-Z\u00C0-\u00FF ]*$/,
    description: "A - Z and space"
    // alphabets+ (ES+NL Characters)+space
  }
};

const ES_fieldPatterns = {
  headerTab: {
    declarationEntryType: {
      ...validationPatterns.A,
      optional: false,
      minLength: 3,
      maxLength: 3,
      fieldName: DEC_TYPE
    },
    //DROPDOWN

    transmissionType: {
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: 'TRANSMISSION TYPE'
    },
    //DROPDOWN

    mrn: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 18,
      fieldName: 'MRN'
    },
    declarationType: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: DECLARATION
    },
    //DROPDOWN

    arrivalDate: {
      optional: true,
      minLength: 1,
      maxLength: 18,
      fieldName: 'ARRIVAL DATE'
    },
    acceptanceDate: {
      optional: true,
      minLength: 1,
      maxLength: 18,
      fieldName: 'ACCEPTANCE DATE'
    },
    releaseDate: {
      optional: true,
      minLength: 1,
      maxLength: 18,
      fieldName: 'RELEASE DATE'
    },
    cancelReason: {
      ...validationPatterns.AlphaSC,
      optional: true,
      minLength: 1,
      maxLength: 50,
      fieldName: CANCELLATION_REASON
    },
    // TRANSACTION NATURE is not mandatory for (PDI)

    natureOfTransaction: {
      ...validationPatterns.N,
      optional: true,
      // conditionaly handled 
      minLength: 2,
      maxLength: 2,
      fieldName: TRANSACTION_NATURE
    },
    transportMode: {
      ...validationPatterns.N,
      optional: false,
      minLength: 1,
      maxLength: 2,
      fieldName: TRANSPORT_MODE
      //  DROPDOWN and optional
    },
    entryOffice: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 8,
      fieldName: ENTRY_OFFICE
    },
    officeOfDestination: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 1,
      maxLength: 8,
      fieldName: CUSTOMS_OFFICE
    },
    exitOffice: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 8,
      fieldName: EXIT_OFFICE
    },
    locationOfGoods: {
      optional: false,
      minLength: 1,
      maxLength: 14,
      fieldName: GOODS_LOCATION
      // SEARCHABLE DROPDOWN
    },
    inlandTransportMode: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: 'INTERNAL TRANSPORT MODE'
      // DROPDOWN and optional
    },
    countryOfDispatch: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: COUNTRY_OF_EXPORT
      // DROPDOWN
    },
    placeOfLadding: {
      optional: true,
      minLength: 1,
      maxLength: 2,
      fieldName: 'PLACE OF LOADING'
    },
    placeOfUnLadding: {
      optional: true,
      minLength: 1,
      maxLength: 2,
      fieldName: 'PLACE OF UNLOADING'
    },
    destinationCountry: {
      optional: false,
      minLength: 1,
      maxLength: 2,
      fieldName: DESTINATION_COUNTRY
      //DROPDOWN and optional
    },
    carrierName: {
      optional: true,
      minLength: 1,
      maxLength: 2,
      fieldName: 'CARRIER'
    },
    carrierId: {
      optional: true,
      minLength: 1,
      maxLength: 2,
      fieldName: 'VOYG/FLT/TRK.ID'
    },
    transportNationalityCrossBorder: {
      optional: true,
      minLength: 1,
      maxLength: 2,
      fieldName: 'TRANSPORT NATIONALITY'
    },
    // DROPDOWN and optional

    containerIndicator: {
      ...validationPatterns.N,
      optional: false,
      minLength: 1,
      maxLength: 1,
      fieldName: CTR
    } // DROPDOWN
  },
  partiesTab: {
    consignorname: {
      ...validationPatterns.PSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNOR, NAME]
    },
    consignorexternalIdentification: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [CONSIGNOR, EORI_NUM]
    },
    consignoraddressLine1: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNOR, ADDRESS_LINE_1]
    },
    consignoraddress2: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNOR, ADDRESS_LINE_2]
    },
    consignorcity: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNOR, CITY]
    },
    consignorstate: {
      ...validationPatterns.RSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNOR, STATE]
    },
    consignorpostalCode: {
      ...validationPatterns.POSTAL_CODE,
      optional: true,
      minLength: 1,
      maxLength: 9,
      fieldName: [CONSIGNOR, ZIP_CODE]
    },
    consignorcountryCode: {
      ...validationPatterns.A,
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: [CONSIGNOR, COUNTRY]
    },
    consigneename: {
      ...validationPatterns.PSC,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNEE, NAME]
    },
    consigneeexternalIdentification: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [CONSIGNEE, EORI_NUM]
    },
    consignorprivateIndicatorFlag: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: [CONSIGNOR, PRIVATE_OPERATOR]
    },
    consigneeprivateIndicatorFlag: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: [CONSIGNEE, PRIVATE_OPERATOR]
    },
    brokerprivateIndicatorFlag: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: [BROKER, PRIVATE_OPERATOR]
    },
    buyerprivateIndicatorFlag: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: [BUYER, PRIVATE_OPERATOR]
    },
    sellerprivateIndicatorFlag: {
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: [SELLER, PRIVATE_OPERATOR]
    },
    consigneeaddressLine1: {
      ...validationPatterns.AddressSC,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNEE, ADDRESS_LINE_1]
    },
    consigneeaddress2: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNEE, ADDRESS_LINE_2]
    },
    consigneecity: {
      ...validationPatterns.AddressSC,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNEE, CITY]
    },
    consigneestate: {
      ...validationPatterns.RSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [CONSIGNEE, STATE]
    },
    consigneepostalCode: {
      ...validationPatterns.POSTAL_CODE,
      optional: false,
      minLength: 1,
      maxLength: 9,
      fieldName: [CONSIGNEE, ZIP_CODE]
    },
    consigneecountryCode: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: [CONSIGNEE, COUNTRY]
    },
    brokername: {
      ...validationPatterns.PSC,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: [DECLARANT, NAME]
    },
    brokerexternalIdentification: {
      ...validationPatterns.ANSC,
      optional: false,
      minLength: 1,
      maxLength: 17,
      fieldName: [DECLARANT, EORI_NUM]
    },
    brokeraddressLine1: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [DECLARANT, ADDRESS_LINE_1]
    },
    brokeraddress2: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [DECLARANT, ADDRESS_LINE_2]
    },
    brokercity: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [DECLARANT, CITY]
    },
    brokerstate: {
      ...validationPatterns.RSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [DECLARANT, STATE]
    },
    brokerpostalCode: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 9,
      fieldName: [DECLARANT, ZIP_CODE]
    },
    brokercountryCode: {
      ...validationPatterns.A,
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: [DECLARANT, COUNTRY]
    },
    warrantyReferences: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 17,
      maxLength: 17,
      fieldName: 'GRN'
    },
    buyername: {
      ...validationPatterns.PSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [BUYER, NAME]
    },
    buyerexternalIdentification: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [BUYER, EORI_NUM]
    },
    buyeraddressLine1: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [BUYER, ADDRESS_LINE_1]
    },
    buyeraddress2: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [BUYER, ADDRESS_LINE_2]
    },
    buyercity: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [BUYER, CITY]
    },
    buyerstate: {
      ...validationPatterns.RSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [BUYER, STATE]
    },
    buyerpostalCode: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 9,
      fieldName: [BUYER, ZIP_CODE]
    },
    buyercountryCode: {
      ...validationPatterns.A,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [BUYER, COUNTRY]
    },
    sellername: {
      ...validationPatterns.PSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [SELLER, NAME]
    },
    sellerexternalIdentification: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [SELLER, EORI_NUM]
    },
    selleraddressLine1: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [SELLER, ADDRESS_LINE_1]
    },
    selleraddress2: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [SELLER, ADDRESS_LINE_2]
    },
    sellercity: {
      ...validationPatterns.AddressSC,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: [SELLER, CITY]
    },
    sellerstate: {
      ...validationPatterns.RSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [SELLER, STATE]
    },
    sellerpostalCode: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 9,
      fieldName: [SELLER, ZIP_CODE]
    },
    sellercountryCode: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: [SELLER, COUNTRY]
    }
  },
  itemsTab: {
    invoiceTotal: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'GRN'
    },
    code: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'code'
    },
    totalItem: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'TOTAL ITEMS'
    },
    totalInvoiceAmount: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'TOTAL INVOICE AMT.'
    },
    totalShipmentPackages: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'TOTAL PACKAGES'
    },
    totalNetWeight: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'TOTAL NET WEIGHT'
    },
    totalGrossWeight: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'TOTAL GROSS WEIGHT'
    },
    invoiceNumber: {
      ...validationPatterns.AlphaSC,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: INVOICE_NUMBER
    },
    invoiceDate: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'INVOICE DATE'
    },
    poNo: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'PO NUMBER'
    },
    currency: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 1,
      maxLength: 17,
      fieldName: CURRENCY_CODE
    },
    // DROPDOWN

    invoiceTotal: {
      ...validationPatterns.N13D3,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'INVOICE AMOUNT'
    },
    totalInvoiceAmount: {
      ...validationPatterns.N11D3,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: TOTAL_INVOICE_AMT
    },
    incoTermsConditionsCode: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 1,
      maxLength: 17,
      fieldName: INCO_TERMS
    },
    descriptionOfPlaceOfDelivery: {
      ...validationPatterns.AddressSC,
      optional: false,
      minLength: 1,
      maxLength: 17,
      fieldName: [TRADE_TERMS, LOCATION]
    },
    deliveryZoneIndicator: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 1,
      maxLength: 17,
      fieldName: [TRADE_TERMS, CODE]
    },
    commercialDescription: {
      ...validationPatterns.PSC,
      optional: false,
      minLength: 1,
      maxLength: 250,
      fieldName: GOODS_DESCRIPTION
    },
    sku: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'SKU/PRODUCT TAG'
    },
    supUnits: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'SUP UNITS'
    },
    supUnitsQuantity: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: SUP_UNIT_COUNT
    },
    countryOfOrigin: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: COUNTRY_ORIGIN
    },
    // DROPDOWN
    originProvince: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: PROVINCE_ORIGIN
    },
    // DROPDOWN

    commodityCode: {
      ...validationPatterns.ANSC,
      optional: false,
      minLength: 1,
      maxLength: 10,
      fieldName: COMMODITY_CODE
    },
    additionalCode1: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 4,
      fieldName: ADD_CODES_1
    },
    additionalCode2: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 4,
      fieldName: ADD_CODES_2
    },
    tariffRegime: {
      ...validationPatterns.A,
      optional: true,
      minLength: 1,
      maxLength: 1,
      fieldName: PREFERENCE
    },
    tariffRegimeSuffix: {
      ...validationPatterns.A,
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: REDUCTION
    },
    procedure: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: REGIME_CODE
    },
    procedureSuffix: {
      ...validationPatterns.A,
      optional: false,
      minLength: 1,
      maxLength: 4,
      fieldName: COMP_REGIME_CODES
    },
    packageCount: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 5,
      fieldName: PKG_COUNT
    },
    packageType: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: PKG_TYPE
    },
    unitType: {
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: 'UNIT TYPE'
    },
    unitCount: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: 'UNIT COUNT'
    },
    unitPrice: {
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'UNIT PRICE'
    },
    unitValue: {
      optional: true,
      minLength: 2,
      maxLength: 2,
      fieldName: 'UNIT VALUE'
    },
    convertedUnitValue: {
      ...validationPatterns.N11D3,
      optional: false,
      minLength: 1,
      maxLength: 15,
      fieldName: CONVERTED_VALUE
    },
    customValue: {
      ...validationPatterns.N12D3,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: CUSTOMS_VALUE
    },
    statValue: {
      ...validationPatterns.GT0N12D2,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: STAT_VALUE
    },
    grossMass: {
      ...validationPatterns.N12D3,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: GROSS_WEIGHT
    },
    netMass: {
      ...validationPatterns.N12D3,
      optional: true,
      minLength: 1,
      maxLength: 16,
      fieldName: NET_MASS
    },
    quotaNumber: {
      ...validationPatterns.ANSC,
      optional: true,
      minLength: 1,
      maxLength: 6,
      fieldName: QUOTA
    },
    taxType: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 1,
      maxLength: 6,
      fieldName: TAX_TYPE
    },
    taxBase: {
      ...validationPatterns.N11D3,
      optional: true,
      minLength: 1,
      maxLength: 15,
      fieldName: TAXABLE_BASE
    },
    taxRate: {
      ...validationPatterns.ND6,
      optional: true,
      minLength: 1,
      maxLength: 13,
      fieldName: RATE
    },
    prevcode: {
      optional: false,
      minLength: 1,
      maxLength: 13,
      fieldName: PREV_DOC_INFO
    },
    prevclass: {
      optional: false,
      minLength: 1,
      maxLength: 13,
      fieldName: PREV_DOC_INFO_CLASS
    },
    prevref: {
      optional: true,
      minLength: 1,
      maxLength: 50,
      fieldName: PREV_DOC_INFO_REF
    },
    specialmentionscode: {
      optional: true,
      minLength: 1,
      maxLength: 50,
      fieldName: [SPECIAL_MENTIONS, CODE]
    },
    addinfocode: {
      optional: false,
      minLength: 1,
      maxLength: 150,
      fieldName: [ADD_INFO, CODE]
    },
    addinfodocumentDate: {
      optional: false,
      minLength: 1,
      maxLength: 50,
      fieldName: [ADD_INFO, DOC_DATE]
    },
    addinforef: {
      optional: false,
      minLength: 1,
      maxLength: 50,
      fieldName: [ADD_INFO, REFERENCE]
    }
  }
};

const convertedDataHeaderTab$1 = value => {
  let obj = {
    declarationEntryType: lodash_2(value, 'declarationEntryType', ''),
    mrn: lodash_2(value, 'mrn', ''),
    declarationType: lodash_2(value, 'declarationType', ''),
    cancelReason: lodash_2(value, 'cancelReason', ''),
    natureOfTransaction: lodash_2(value, 'natureOfTransaction', ''),
    entryOffice: lodash_2(value, 'entryOffice', ''),
    officeOfDestination: lodash_2(value, 'officeOfDestination', ''),
    exitOffice: lodash_2(value, 'exitOffice', ''),
    locationOfGoods: lodash_2(value, 'locationOfGoods', ''),
    transportMode: lodash_2(value, 'transportMode', ''),
    countryOfDispatch: lodash_2(value, 'countryOfDispatch', ''),
    containerIndicator: lodash_2(value, 'containerIndicator', ''),
    destinationCountry: lodash_2(value, 'destinationCountry', '')
  };
  return obj;
};
const createHeaderWarningsList = (headerElements, level, translateFunc, serviceType, pdiValidationCheck) => {
  let errors = [];
  if (!headerElements) {
    return [];
  }
  let headerPattern = Object.entries(ES_fieldPatterns[`${level}`]);
  let onlyMandatoryValues = ['declarationEntryType', 'declarationType', 'transportMode', 'locationOfGoods', 'countryOfDispatch', 'containerIndicator', 'officeOfDestination', 'destinationCountry', 'natureOfTransaction'];
  headerPattern.map(item => {
    let fieldName = item[0]; //lrn*/
    let err = onlyMandatoryValues.includes(fieldName) ? getValidationError$1(fieldName, headerElements[fieldName], level, true, '', translateFunc, pdiValidationCheck) : getValidationError$1(fieldName, headerElements[fieldName], level, false, '', translateFunc, pdiValidationCheck);
    if (err[0]) {
      errors.push({
        fieldName: fieldName,
        msg: err + ' ' + '.'
      });
    }
  });
  return errors;
};
const convertedDataPartiesTab$1 = value => {
  let obj = {
    consigneename: lodash_2(value, 'consignee.name', ''),
    consignorname: lodash_2(value, 'consignor.name', ''),
    brokername: lodash_2(value, 'broker.name', ''),
    consigneeexternalIdentification: lodash_2(value, 'consignee.externalIdentification', ''),
    consignorexternalIdentification: lodash_2(value, 'consignor.externalIdentification', ''),
    brokerexternalIdentification: lodash_2(value, 'broker.externalIdentification', ''),
    consigneeaddressLine1: lodash_2(value, 'consignee.streetNumber', ''),
    consignoraddressLine1: lodash_2(value, 'consignor.streetNumber', ''),
    brokeraddressLine1: lodash_2(value, 'broker.streetNumber', ''),
    consignoraddress2: lodash_2(value, 'consignor.address2', ''),
    consigneeaddress2: lodash_2(value, 'consignee.address2', ''),
    brokeraddress2: lodash_2(value, 'broker.address2', ''),
    consignorcity: lodash_2(value, 'consignor.city', ''),
    consigneecity: lodash_2(value, 'consignee.city', ''),
    brokercity: lodash_2(value, 'broker.city', ''),
    consignorstate: lodash_2(value, 'consignor.state', ''),
    consigneestate: lodash_2(value, 'consignee.state', ''),
    brokerstate: lodash_2(value, 'broker.state', ''),
    consignorpostalCode: lodash_2(value, 'consignor.postalCode', ''),
    consigneepostalCode: lodash_2(value, 'consignee.postalCode', ''),
    brokerpostalCode: lodash_2(value, 'broker.postalCode', ''),
    consignorcountryCode: lodash_2(value, 'consignor.countryCode', ''),
    consigneecountryCode: lodash_2(value, 'consignee.countryCode', ''),
    brokercountryCode: lodash_2(value, 'broker.countryCode', ''),
    warrantyReferences: lodash_2(value, 'warranties.warrantyReferences', ''),
    buyername: lodash_2(value, 'buyer.name', ''),
    sellername: lodash_2(value, 'seller.name', ''),
    buyerexternalIdentification: lodash_2(value, 'buyer.externalIdentification', ''),
    sellerexternalIdentification: lodash_2(value, 'seller.externalIdentification', ''),
    buyeraddressLine1: lodash_2(value, 'buyer.streetNumber', ''),
    selleraddressLine1: lodash_2(value, 'seller.streetNumber', ''),
    buyeraddress2: lodash_2(value, 'buyer.address2', ''),
    selleraddress2: lodash_2(value, 'seller.address2', ''),
    buyercity: lodash_2(value, 'buyer.city', ''),
    sellercity: lodash_2(value, 'seller.city', ''),
    sellerstate: lodash_2(value, 'seller.state', ''),
    buyerstate: lodash_2(value, 'buyer.state', ''),
    buyerpostalCode: lodash_2(value, 'buyer.postalCode', ''),
    sellerpostalCode: lodash_2(value, 'seller.postalCode', ''),
    buyercountryCode: lodash_2(value, 'buyer.countryCode', ''),
    sellercountryCode: lodash_2(value, 'seller.countryCode', ''),
    brokerFormOfRepresentation: lodash_2(value, 'broker.formOfRepresentation', ''),
    consigneeprivateIndicatorFlag: lodash_2(value, 'consignee.privateIndicatorFlag', '')
  };
  return obj;
};
const createPartiesWarningsList = (headerElements, level, translateFunc, serviceType, pdiValidationCheck) => {
  let errors = [];
  if (!headerElements) {
    return [];
  }
  let headerPattern = Object.entries(ES_fieldPatterns[`${level}`]);
  let onlyMandatoryValues = [];
  headerPattern === null || headerPattern === void 0 ? void 0 : headerPattern.map(item => {
    let fieldName = item[0]; //lrn*/
    let err = onlyMandatoryValues !== null && onlyMandatoryValues !== void 0 && onlyMandatoryValues.includes(fieldName) ? getValidationError$1(fieldName, headerElements[fieldName], level, true, serviceType, translateFunc, pdiValidationCheck) : getValidationError$1(fieldName, headerElements[fieldName], level, false, serviceType, translateFunc, pdiValidationCheck);
    if (err[0]) {
      errors.push({
        fieldName: fieldName,
        msg: err + ' ' + '.'
      });
    }
  });
  return errors;
};

// ITEMS TAB

const invoiceFields = ['invoiceNumber', 'poNo',
//'currency',
'invoiceTotal', 'incoTermsConditionsCode', 'descriptionOfPlaceOfDelivery', 'deliveryZoneIndicator'];
const lineItemFields = ['commercialDescription', 'sku', 'tariffRegime', 'tariffRegimeSuffix', 'procedureSuffix', 'procedure', 'convertedUnitValue', 'supUnitsQuantity', 'countryOfOrigin',
// 'originProvince',
'supUnits', 'commodityCode', 'additionalCode1', 'packageCount', 'packageType', 'unitType', 'netMass', 'grossMass', 'customValue', 'statValue', 'quotaNumber', 'unitCount', 'unitPrice'];
const multipleFieldName = ['itemDuties', 'previousDocumentInfo', 'additionalInfo', 'specialMentions'];
const keyEnums = {
  prevcode: 'code',
  prevclass: 'class',
  prevref: 'ref',
  addinfocode: 'code',
  addinfodocumentDate: 'documentDate',
  addinforef: 'ref'
};
const multipleKeysObject = {
  itemDuties: ['taxType', 'taxBase', 'taxRate'],
  previousDocumentInfo: ['prevcode', 'prevclass', 'prevref'],
  specialMentions: ['specialmentionscode'],
  additionalInfo: ['addinfocode', 'addinfodocumentDate', 'addinforef']
};
const onlyMandatoryValues$1 = ['unitType', 'procedure', 'procedureSuffix', 'tariffRegimeSuffix', 'tariffRegime'];
const convertedDataItemsTab$1 = (value, level, translateFunc, languageConverted = false, serviceType, pdiValidationCheck) => {
  var _value$invoices;
  let merchandiseKeyName = languageConverted ? 'merchandiseList' : 'merchandises';
  let errors = [];
  if (value.code == 400) return;
  value && (value === null || value === void 0 ? void 0 : (_value$invoices = value.invoices) === null || _value$invoices === void 0 ? void 0 : _value$invoices.map((items, index) => {
    invoiceFields === null || invoiceFields === void 0 ? void 0 : invoiceFields.map(item => {
      let err = getValidationError$1(`${item}`, items[`${item}`] || '', 'itemsTab', false, serviceType, translateFunc, pdiValidationCheck) || [];
      (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
        fieldName: `${item}-${items.invoiceId}`,
        msg: `invoice -00${index + 1}.` + ' :: ' + err[0]
      });
    });
    items && items[merchandiseKeyName] && items[merchandiseKeyName].map((lineitems, ind) => {
      Object.keys(lineitems).map(lineValues => {
        if (multipleFieldName.includes(lineValues)) {
          let currentFieldVal = [...items[merchandiseKeyName][ind][lineValues]];
          currentFieldVal.map((itm, indd) => {
            let currentValues = multipleKeysObject[lineValues] || [];
            currentValues === null || currentValues === void 0 ? void 0 : currentValues.map((currentField, iii) => {
              const keyName = keyEnums[currentField] ? keyEnums[currentField] : currentField;
              let err = getValidationError$1(`${currentField}`, itm[keyName] || '', 'itemsTab', false, serviceType, translateFunc, pdiValidationCheck) || [];
              (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
                fieldName: `${currentField}-${lineitems.merchandiseId}-${indd}`,
                msg: `invoice -00${index + 1} :: line ${ind + 1}` + ' :: ' + err[0]
              });
            });
          });
        }
      });
      lineItemFields.map(lineItem => {
        if (onlyMandatoryValues$1.includes(lineItem)) {
          let err = getValidationError$1(`${lineItem}`, items[merchandiseKeyName][ind][lineItem] || '', 'itemsTab', true, serviceType, translateFunc, pdiValidationCheck) || [];
          (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
            fieldName: `${lineItem}-${lineitems.merchandiseId}`,
            msg: `invoice -00${index + 1} :: line ${ind + 1}.` + ' :: ' + err[0]
          });
          return;
        }
        let err = getValidationError$1(`${lineItem}`, items[merchandiseKeyName][ind][lineItem] || '', 'itemsTab', false, serviceType, translateFunc, pdiValidationCheck) || [];
        (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
          fieldName: `${lineItem}-${lineitems.merchandiseId}`,
          msg: `invoice -00${index + 1} :: line ${ind + 1}` + ' :: ' + err[0]
        });
      });
    });
  }));
  return errors;
};
const translatedArray = (fieldNames, level, translate, tabEnum, messageType, description = '', ...rest) => {
  let translatedFinalValue = '';
  fieldNames.map((fieldName, index) => {
    if (index + 1 == fieldNames.length) {
      let translateValue = messageType === 'mandatoryMsg' ? translate('mandatory_fieldName', {
        fieldName: translate(fieldName, {
          ns: ['default', tabEnum[level]]
        })
      }) : messageType === 'lengthMsg' ? translate('range_fieldName', {
        fieldName: translate(fieldName, {
          ns: ['default', tabEnum[level]]
        }),
        ...rest
      }) : translate('pattern_fieldName', {
        fieldName: translate(fieldName, {
          ns: ['default', tabEnum[level]]
        }),
        description: translate(lngKeys[description] || description, {
          ns: ['default', tabEnum[level]]
        })
      });
      translatedFinalValue = translatedFinalValue ? translatedFinalValue + ' ' + translateValue : translateValue;
    } else {
      const translatedFieldName = translate(fieldName, {
        ns: ['default', tabEnum[level]]
      });
      translatedFinalValue = translatedFinalValue ? translatedFinalValue + ' ' + translatedFieldName : translatedFieldName;
    }
  });
  return translatedFinalValue;
};

const lngKeys = {
  "Alpha Numeric": "Alpha_Numeric",
  [`${Alpha_Numeric_SH}`]: "Alpha_Numeric_SH"
};
const tabEnum = {
  "headerTab": "header",
  "itemsTab": "lineItem",
  "partiesTab": "parties"
};
const isMandatoryMessage = (fieldName, level, translate) => Array.isArray(fieldName) ? translatedArray(fieldName, level, translate, tabEnum, "mandatoryMsg") : translate('mandatory_fieldName', {
  fieldName: translate(fieldName, {
    ns: ["default", tabEnum[level]]
  })
});
const lengthMessage = ({
  fieldName,
  ...rest
}, level, translate) => Array.isArray(fieldName) ? translatedArray(fieldName, level, translate, tabEnum, "lengthMsg") : translate('range_fieldName', {
  fieldName: translate(fieldName, {
    ns: ["default", tabEnum[level]]
  }),
  ...rest
});
const patternMessage = ({
  fieldName,
  description
}, level, translate) => Array.isArray(fieldName) ? translatedArray(fieldName, level, translate, tabEnum, "patternMsg", description) : translate('pattern_fieldName', {
  fieldName: translate(fieldName, {
    ns: ["default", tabEnum[level]]
  }),
  description: translate(lngKeys[description] || description, {
    ns: ["default", tabEnum[level]]
  })
});
const getValidationError$1 = (field, value, Level, onlyMandatoryCheck = false, serviceType, translationFunc, pdiValidationCheck) => {
  if (value === "_BLANK_" || value == "-999" || value == " ") {
    value = "";
  }
  let fieldPatterns = ES_fieldPatterns;
  let fieldDetails = fieldPatterns[Level][field];
  let errors = [];
  const pdiFIELDS = ['consignorname', 'consignoraddressLine1', 'consignorcity', 'consignorpostalCode', 'consignorcountryCode', 'packageCount', 'customValue', 'statValue', 'grossMass', 'netMass'];
  if (onlyMandatoryCheck) {
    if (!value && !(fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional)) {
      errors.push(translationFunc ? isMandatoryMessage(fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName, Level, translationFunc) : `${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
      return errors;
    }
    if ((field === 'tariffRegime' && serviceType === 'IM' || field === 'tariffRegimeSuffix' && serviceType === 'IM' || (field === 'natureOfTransaction' || field === 'packageType') && pdiValidationCheck === false) && !value && fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional) {
      errors.push(translationFunc ? isMandatoryMessage(fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName, Level, translationFunc) : `${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
      return errors;
    }
    return false;
  }
  if (!value && !(fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional)) {
    errors.push(translationFunc ? isMandatoryMessage(fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName, Level, translationFunc) : `${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
    return errors;
  }
  if ((field === 'consignorexternalIdentification' && serviceType === 'EX' || field === 'consigneeexternalIdentification' && serviceType === 'IM' && pdiValidationCheck === false || (field === 'taxType' || field === 'taxBase' || field === 'taxRate') && serviceType === 'IM' || pdiFIELDS.includes(field) && pdiValidationCheck === false) && !value && fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional) {
    errors.push(translationFunc ? isMandatoryMessage(fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName, Level, translationFunc) : `${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
    return errors;
  }
  if (fieldDetails && fieldDetails.pattern && !!value && !fieldDetails.pattern.test(value)) {
    translationFunc ? errors.push(patternMessage({
      fieldName: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName,
      description: fieldDetails.description
    }, Level, translationFunc)) : errors.push((fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName) + " can only contain " + fieldDetails.description + " characters");
  } else {
    if (value && value.length > 0 && !(value.replace(/\./g, "").length >= (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.minLength) && value.replace(/\./g, "").length <= (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.maxLength))) {
      const isMinMaxSame = (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.minLength) === (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.maxLength);
      const numberOdChars = isMinMaxSame ? fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.minLength : (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.minLength) + " to " + (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.maxLength);
      translationFunc && !isMinMaxSame ? errors.push(lengthMessage({
        fieldName: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName,
        min: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.minLength,
        max: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.maxLength
      }, Level, translationFunc)) : errors.push("Length of " + (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName) + " should be " + numberOdChars + ".");
    }
  }
  return errors;
};

function ErrorMessagesWindow(props) {
  const {
    errors
  } = props;
  const [errorList, showErrorList] = React$1.useState(true);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: "0 10px 10px 10px"
    }
  }, errorList == false ? /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: "red",
      cursor: "pointer"
    },
    onClick: () => {
      showErrorList(true);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: "inline-block",
      width: "75%",
      backgroundColor: "#fda1a1",
      height: "3px",
      marginTop: "3px",
      marginBottom: "3px",
      marginleft: "10px"
    }
  }), "\xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    onClick: () => showErrorList(true),
    name: "plus circle",
    style: {
      display: "inline"
    }
  }), "Expand Error") : /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: "red",
      cursor: "pointer"
    },
    onClick: () => {
      showErrorList(false);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: "inline-block",
      width: "75%",
      backgroundColor: "#fda1a1",
      height: "3px",
      marginTop: "3px",
      marginBottom: "3px",
      marginleft: "10px"
    }
  }), "\xA0", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    onClick: () => showErrorList(false),
    name: "minus circle",
    style: {
      display: "inline"
    }
  }), "Collapse Error"), errorList && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, {
    negative: true
  }, errors && errors.length > 0 && errors.map((item, index) => {
    return /*#__PURE__*/React__default["default"].createElement("p", {
      key: index + item.msg + index
    }, item.msg);
  })));
}

class ErrorBoundary extends React__default["default"].Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return /*#__PURE__*/React__default["default"].createElement("center", {
        style: {
          position: "relative",
          top: "50vh"
        }
      }, `Something Crashed on Broker`, /*#__PURE__*/React__default["default"].createElement("i", {
        className: "frown outline icon"
      }));
    }
    return this.props.children;
  }
}

// export const getDropDownInputText = (
//   id,
//   valueList,
//   key = "value",
//   value = "text"
// ) => {
//   let filterValue = valueList  && valueList.length > 0  && valueList.filter((val) => val[key] == id);

//   if (filterValue && Array.isArray(filterValue) && filterValue.length > 0) {
//     return (
//       filterValue[0][key] +
//       (( filterValue[0][value]) || "")
//     );
//   }

//   return id;
// };

const containerValidationMsg = "Valid format of container number is : 4 alpha + 7 Num, (ex. LIFU0005085) ";
const ModeOfPayment = [{
  id: "A",
  value: "A",
  text: "Payment prior to lifting.",
  text_es: "Pago antes del levantamiento."
}, {
  id: "R",
  value: "R",
  text: "Deferred payment with provision of gurantee.",
  text_es: "Pago aplazado con prestación de garantía."
}, {
  id: "J",
  value: "J",
  text: "Deferred payment without provision of gurantee by Public Entities and other specisal cases expressly provided for in current legislation.",
  text_es: "Pago aplazado sin prestación de garantía por parte de las Entidades Públicas y demás casos especiales previstos expresamente en la legislación vigente."
}];
const decTypeDropdownValues = (declarationEntryType, ESCustomState, isEX, isGreenCircuit) => [{
  value: ' ',
  text: 'Select',
  text_es: 'select',
  id: 26089
}, {
  value: 'FULL_SAD',
  text: 'Standard customs declaration',
  text_es: 'Estandar',
  id: 26079,
  disabled: isEX || ['STATE_FULL_SAD_NEW', 'STATE_FULL_SAD_FILED'
  // 'STATE_PDI_NEW',
  // 'STATE_PDI_FILED',
  // 'STATE_PDI_ACCEPTED',
  // 'STATE_PDI_FILED_FAILED',
  // 'STATE_PDI_CANCELLED_FILED',
  // 'STATE_PDI_CANCELLED_FILED_FAILED',
  ].includes(ESCustomState)
}, {
  value: 'PDC',
  text: 'Prelodge',
  text_es: 'Predeclaracion',
  id: 26080,
  disabled: isEX || ['STATE_PDC_NEW', 'STATE_PDC_FILED'].includes(ESCustomState)
}, {
  value: 'PDI',
  text: 'Incomplete prelodge',
  text_es: 'Predeclaracion Incompleta',
  id: 26081,
  // disabled: true,
  disabled: isEX || ['STATE_PDI_NEW', 'STATE_PDI_FILED', 'STATE_PDI_ACCEPTED', 'STATE_PDC_FILED', 'STATE_PDC_ACCEPTED', 'STATE_PDC_FILED_FAILED', 'STATE_PDC_CANCELLED_FILED', 'STATE_PDC_CANCELLED_FILED_FAILED', 'STATE_FULL_SAD_FILED', 'STATE_FULL_SAD_ACCEPTED', 'STATE_FULL_SAD_FILED_FAILED', 'STATE_FULL_SAD_CANCELLED_FILED', 'STATE_FULL_SAD_CANCELLED_FILED_FAILED'].includes(ESCustomState)
}, {
  value: 'SAPL',
  text: 'Positioning',
  text_es: 'Posicionamiento',
  id: 12693,
  disabled: true
}, {
  value: 'ExportTypeA',
  text: 'Standard customs declaration',
  text_es: 'Estandar',
  id: 26080,
  disabled: !isEX || ['STATE_TYPE_A_NEW', 'STATE_TYPE_A_FILED'].includes(ESCustomState)
}, {
  value: 'ExportTypeB',
  text: 'Simplified lack of doc',
  text_es: 'Simplificada falta doc',
  id: 26081,
  disabled: !isEX || ['STATE_TYPE_B_NEW', 'STATE_TYPE_B_FILED'].includes(ESCustomState)
}, {
  value: 'ExportTypeC',
  text: 'Simplified lack of value',
  text_es: 'Simplificada falta doc',
  id: 26082,
  disabled: !isEX || ['STATE_TYPE_C_NEW', 'STATE_TYPE_C_FILED'].includes(ESCustomState)
}, {
  value: 'ExportTypeX',
  text: 'Complementary X',
  text_es: 'Complementaria a X',
  id: 26082,
  disabled: !isEX || !['STATE_CLEAR', 'STATE_RELEASED'].includes(ESCustomState)
}, {
  value: 'ExportTypeY',
  text: 'Complementary Y',
  text_es: 'Complementaria a Y',
  id: 26082,
  disabled: !isEX || !['STATE_CLEAR', 'STATE_RELEASED'].includes(ESCustomState)
}];
const transmissionTypeDropdownValues = (declarationEntryType, ESCustomState, isEX) => [{
  value: ' ',
  text: 'Select',
  text_es: 'select',
  id: 12690
}, {
  value: 'NEW',
  text: 'New declaration or Update',
  text_es: 'Nueva declaración or Update',
  id: 12694,
  disabled: ['STATE_CANCEL_FILED_FAILED',
  // 'STATE_ENTRY_AMEND',
  'STATE_PDC_FILED',
  // 'STATE_PDC_ACCEPTED',
  'STATE_PDI_FILED',
  // 'STATE_PDI_ACCEPTED',
  'STATE_FULL_SAD_FILED', 'STATE_TYPE_A_FIELD', 'STATE_TYPE_A_ACCEPTED', 'STATE_TYPE_B_FIELD', 'STATE_TYPE_B_ACCEPTED', 'STATE_TYPE_C_FIELD', 'STATE_TYPE_C_ACCEPTED', 'STATE_TYPE_X_FIELD', 'STATE_TYPE_X_ACCEPTED', 'STATE_TYPE_Y_FIELD', 'STATE_TYPE_Y_ACCEPTED'].includes(ESCustomState)
}, {
  value: 'MOD',
  text: 'Modification',
  text_es: 'Modificación declaración',
  id: 12695,
  disabled: declarationEntryType && declarationEntryType.includes("FULL_SAD") && declarationEntryType !== "TYPE_X" && declarationEntryType !== "TYPE_Y" || !['STATE_BOX_40_FAILED', 'STATE_BOX_44_FAILED', 'STATE_BOX_40_REQUIRED', 'STATE_BOX_44_REQUIRED', "STATE_PDC_ACCEPTED", 'STATE_CANCEL_FILED_FAILED', "STATE_PDI_ACCEPTED", "STATE_TYPE_A_ACCEPTED", "STATE_TYPE_B_ACCEPTED", "STATE_TYPE_C_ACCEPTED"].includes(ESCustomState)
}, {
  value: 'CAN',
  text: 'Cancellation',
  text_es: 'Anulación',
  id: 12696,
  disabled: declarationEntryType && declarationEntryType.includes("FULL_SAD") || !['STATE_PDC_ACCEPTED', 'STATE_PDC_FILED_FAILED', 'STATE_PDI_ACCEPTED', 'STATE_ENTRY_AMEND', 'STATE_PDI_FILED_FAILED', 'STATE_FULL_SAD_FAILED', 'STATE_BOX_40_REQUIRED', 'STATE_BOX_40_ACCEPTED', 'STATE_BOX_40_FAILED', 'STATE_BOX_44_REQUIRED', 'STATE_BOX_44_ACCEPTED', 'STATE_BOX_44_FAILED', 'STATE_TYPE_A_ACCEPTED', 'STATE_TYPE_A_FILED_FAILED', 'STATE_TYPE_B_ACCEPTED', 'STATE_TYPE_B_FILED_FAILED', 'STATE_TYPE_C_ACCEPTED', 'STATE_TYPE_C_FILED_FAILED'].includes(ESCustomState)
}, {
  value: 'BOX 40',
  text: 'Update BOX 40',
  text_es: 'Modificar casilla 40',
  id: 12600,
  disabled: isEX || !['STATE_BOX_40_REQUIRED', 'STATE_BOX_40_FAILED'].includes(ESCustomState)
}, {
  value: 'BOX 44',
  text: 'Update BOX 44',
  text_es: 'Modificar casilla 44',
  id: 12601,
  disabled: isEX || !['STATE_BOX_44_REQUIRED', 'STATE_BOX_44_FAILED'].includes(ESCustomState)
}];
const repTypeList = [{
  id: `1`,
  text: `In case of self-dispatch.`,
  text_es: `En caso de autodespacho`,
  value: `1`
}, {
  id: `2`,
  text: `When the representation is direct: if the representative acts on behalf and on behalf of his principal.`,
  text_es: `Cuando la representación sea directa: si el representante actúa en nombrey por cuenta de su comitente.`,
  value: `2`
}, {
  id: `3`,
  text: `When the representation is indirect, that is, if the representative acts in his own name and on behalf of his principal.`,
  text_es: `Cuando la representación sea indirecta, es decir, si el representante actúaen nombre propio y por cuenta de su comitente.`,
  value: `3`
}, {
  id: `4`,
  text: `(Only for the Canary Islands) When the representation is indirect before the Tax Agency and directly before the Tax Administration Canary.`,
  text_es: `(Únicamente para Canarias) Cuando la representación sea indirectaante la Agencia Tributaria y directa ante la Administración Tributaria Canaria.`,
  value: `4`
}, {
  id: `5`,
  text: `(Only for the Canary Islands) When the representation is direct before the Tax Agency and indirectly before the Tax Administration Canary`,
  text_es: `(Únicamente para Canarias) Cuando la representación sea directaante la Agencia Tributaria e indirecta ante la Administración Tributaria Canaria`,
  value: `5`
}];

var ContainerItem = /*#__PURE__*/React__default["default"].memo(function ContainerItem(props) {
  let [isDeleting, setIsDeleting] = React$1.useState(false);
  let dispatch = useDispatch();
  const updateContainerValue = value => {
    dispatch(updateContainer(value, props.containerIndex));
  };
  const containerNumber = useSelector(state => {
    var _state$ContainerReduc;
    return ((_state$ContainerReduc = state.ContainerReducer.containers[props.containerIndex]) === null || _state$ContainerReduc === void 0 ? void 0 : _state$ContainerReduc.containerNumber) || [];
  });
  let displaySave = containerNumber ? 'none' : 'inline-block';
  let displayDel = containerNumber ? 'inline-block' : 'none';
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "containerItem"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${props.containerId}-containerInput`,
    name: `${props.containerId}-containerInput`,
    isLabel: false
    // id={`cbsa-container-number${containerIndex}`}
    ,
    type: "text",
    label: '',
    className: 'field-bg cbsa-container-number',
    value: containerNumber,
    onChange: value => updateContainerValue(value.toUpperCase()),
    onBlur: () => {
      dispatch(saveContainerHeader(props.containerIndex, 'containerNumber'));
    }
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "cbsa-save-container",
    style: {
      display: displaySave
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    className: "save",
    color: "blue",
    name: "save"
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: displayDel
    },
    className: "cbsa-delete-container"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    id: `${props.containerId}-deleteContainerInner`,
    className: "trash",
    color: "blue",
    name: "trash",
    disabled: props.isFormDisabled,
    onClick: () => {
      setIsDeleting(true);
      dispatch(removeContainer(props.containerId));
    }
  })));
});

var ContainerList = /*#__PURE__*/React__default["default"].memo(function ContainerList({
  isFormDisabled
}) {
  const containers = useSelector(state => state.ContainerReducer.containers || []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: "containerList",
    className: "containerList"
  }, containers && containers.map((item, index) => {
    return /*#__PURE__*/React__default["default"].createElement(ContainerItem, {
      key: "container" + index,
      isFormDisabled: isFormDisabled,
      containerIndex: index,
      containerId: item.containerId
    });
  }));
});

// import store from "../../store";
// import { createContainerHeaderInfo } from "../../store/action"

const containerHeading = dispatch => /*#__PURE__*/React__default["default"].createElement("div", {
  className: "header"
}, /*#__PURE__*/React__default["default"].createElement("span", {
  className: "title"
}, "CONTAINER", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
  id: "addContainerInner",
  icon: true,
  labelPosition: "right",
  onClick: () => addNewContainer(dispatch)
}, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
  name: "add"
}), "ADD")));
const addNewContainer = dispatch => {
  dispatch(createContainerHeaderInfo());
};
const ContainerModal = props => {
  const dispatch = useDispatch();
  const {
    isFormDisabled
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    on: "click",
    pinned: true,
    className: props.modalClass,
    disabled: isFormDisabled,
    trigger: /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      id: "addContainerOuter",
      style: {
        height: "20px",
        width: "41px",
        marginTop: "5px",
        color: "#2185d0",
        fontSize: "9px",
        border: "1px solid #2185d0",
        backgroundColor: "white",
        textAlign: "center",
        padding: "1px 0px 0px 0px",
        position: "relative",
        marginLeft: "4px",
        marginBottom: "5px"
      },
      disabled: isFormDisabled
    }, props.translate('ADD'))),
    header: containerHeading(dispatch),
    position: "top right",
    content: /*#__PURE__*/React__default["default"].createElement(ContainerList, {
      isFormDisabled: isFormDisabled
    })
  });
};
var ContainerModal$1 = /*#__PURE__*/React__default["default"].memo(ContainerModal);

const Containers = props => {
  const [deleteContainer, setDeleteContainer] = React$1.useState(false);
  const dispatch = useDispatch();
  const containers = useSelector(state => state.ContainerReducer.containers || []);
  const {
    isFormDisabled,
    translate
  } = props;
  const setDisplayContainerNumbers = valueList => {
    let list = [];
    if (valueList && valueList.length > 0) {
      valueList.map((item, index) => {
        return list.push(/*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
          key: index,
          isFormDisabled: isFormDisabled
        }, item === null || item === void 0 ? void 0 : item.containerNumber, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          id: `${index}-deleteContainerOuter`,
          disabled: isFormDisabled,
          name: "delete",
          onClick: () => {
            setDeleteContainer(true);
            dispatch(removeContainer(item.containerId));
          }
        })));
      });
    }
    return list;
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "container-title"
  }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('CONTAINERS', {
    ns: ["default", "header"]
  })), /*#__PURE__*/React__default["default"].createElement(PopUpIcon$1, {
    icon: "info circle",
    popupText: containerValidationMsg
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    className: "container-box"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "16",
    className: "divFormFeild  border-bottom   b-rw-0  b-blr-5 ",
    style: {
      border: "1px solid #1765AE",
      borderRadius: "5px",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label.Group, {
    style: {
      marginLeft: "5px",
      marginTop: "5px"
    }
  }, setDisplayContainerNumbers(containers), /*#__PURE__*/React__default["default"].createElement(ContainerModal$1, _extends$1({}, props, {
    containers: containers,
    modalClass: `containerModal`,
    isFormDisabled: isFormDisabled
  }))))));
};
var Containers$1 = /*#__PURE__*/React__default["default"].memo(Containers);

const CustomDropDown = props => {
  const {
    label,
    className = "",
    width,
    data = [],
    direction,
    labelClass = "",
    centerSelect,
    fieldClassName = '',
    onChange,
    text,
    onBlur,
    id,
    labelIcon,
    errors,
    multiple,
    boxNumber,
    mandatory,
    icon,
    onSearchChange,
    clearable,
    isDisabled,
    value,
    title,
    descriptionRequired = false,
    displayType,
    name,
    selectedValue = "value" // added for US because data format is different in each dropdown
  } = props;
  let drop_data = data === undefined ? [] : data;
  let options = lodash.map(drop_data, (item, index) => ({
    key: index,
    text: getDropDownText(item, instance.language || window.localStorage.i18nextLng || "en", displayType),
    value: item[selectedValue],
    description: descriptionRequired && item.description,
    disabled: item.disabled
  }));
  let customLabelClassName = `label-dropdown name-label es ${labelClass}`;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    width: width,
    className: `floating-select ${fieldClassName} ${centerSelect && "floating-select-center"}`
  }, /*#__PURE__*/React__default["default"].createElement(CustomLabel, {
    id: `${id}label`,
    className: customLabelClassName,
    boxNumber: boxNumber,
    label: label,
    labelIcon: labelIcon,
    errors: errors
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
    closeOnChange: true,
    selectOnBlur: false,
    icon: icon || "dropdown",
    scrolling: true,
    search: true,
    clearable: value !== null && value !== void 0 && value.trim() ? clearable : false,
    multiple: multiple,
    selection: true,
    options: options,
    onChange: onChange,
    onSearchChange: onSearchChange,
    value: value,
    text: text,
    placeholder: "Select",
    wrapSelection: true,
    id: id,
    name: name,
    direction: direction,
    disabled: isDisabled,
    small: "true",
    className: `field-bg dropdown100 ${className} addInfoCode`,
    title: title,
    onBlur: onBlur
  }), mandatory === true && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "asterisk",
    style: {
      position: "absolute",
      right: "-3px"
    }
  })));
};
CustomDropDown.propTypes = {};
var DropDown = ShipmentDataHOC(CustomDropDown);

function CancelEntryModal(props) {
  const {
    shipmentId,
    language,
    countryCode,
    serviceType,
    version,
    cancelReason,
    formType = 'Cancel',
    cancelReasonList,
    trigger,
    showModal,
    setShowModal,
    lowerEnv,
    searchByID = () => {},
    ...rest
  } = props;
  const [reason, setReason] = React$1.useState(cancelReason);
  const [loading, setLoadingState] = React$1.useState(false);
  const [fileWithGateway, setFileWithGateway] = React$1.useState(false);
  const [cancelCode, setCancelCode] = React$1.useState("");
  React$1.useEffect(() => {
    setFileWithGateway(false);
    setReason("");
  }, []);
  const handleSubmit = async () => {
    setLoadingState(true);
    try {
      let payload = {
        shipmentId: shipmentId,
        langauge: language,
        countryCode: countryCode,
        mockRequest: !fileWithGateway,
        formType: formType,
        eventType: `FILE_FORM_${countryCode}`,
        reason: cancelCode ? cancelCode + '-' + reason : reason,
        import: serviceType === "IM"
      };
      if (version) {
        payload.version = version;
      }
      if ((lowerEnv === null || lowerEnv === void 0 ? void 0 : lowerEnv[0]) === 'prod') {
        payload.mockRequest = false;
      }
      await fileJob(payload);
      await searchByID(shipmentId);
      await setShowModal(false);
    } catch (err) {
      console.error(err);
      setShowModal(false);
      setLoadingState(false);
    } finally {
      setLoadingState(false);
      setShowModal(false);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
    id: "cancelNCTS",
    className: "cancelNcts",
    trigger: trigger,
    open: showModal,
    onOpen: () => {
      setFileWithGateway(false);
      setReason("");
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, null, "Are you sure to cancel the Shipment: ", shipmentId, "?"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, cancelReasonList && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(DropDown, {
    id: "cancelcode",
    name: "cancelcode",
    label: "Cancellation type / code",
    isLabel: true,
    data: cancelReasonList,
    clearable: true,
    value: cancelCode,
    text: cancelCode,
    isDisabled: false,
    onChange: (e, {
      name,
      value
    }) => {
      setCancelCode(value);
    }
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
    style: {
      width: '100%'
    },
    label: `Reason:`,
    placeholder: "Please Provide Reason",
    selection: true,
    text: reason,
    value: reason,
    onChange: (e, {
      value
    }) => {
      setReason(value);
    }
  }))), (lowerEnv === null || lowerEnv === void 0 ? void 0 : lowerEnv[0]) !== 'prod' && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    className: "input-labels"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
    key: "uatFiling",
    id: "fileWithHmrc",
    className: "fileWithHmrc",
    checked: fileWithGateway === true,
    label: `Cancel with ${countryCode} gateway`,
    onChange: event => {
      let chk = event.target.checked ? true : false;
      setFileWithGateway(chk);
    }
  }))))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    basic: true,
    color: "blue",
    onClick: () => {
      setShowModal(false);
      setFileWithGateway(false);
      setReason("");
    }
  }, "Cancel"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    primary: true,
    loading: loading,
    disabled: reason.trim() === '',
    onClick: () => {
      handleSubmit();
    }
  }, "Submit")));
}

const DecTypeForm = ({
  saveShipmentFieldValue,
  currentJobCircuitState,
  translate,
  updateData,
  declarationEntryType,
  transmissionType,
  cancelReason,
  ESCustomState,
  mrn,
  setEUData,
  addErrors,
  deleteErrors,
  searchByID,
  serviceType,
  getValidationError,
  brokerHouseStatus
}) => {
  const [disableStartBtn, setDisableStartBtn] = React$1.useState(!!declarationEntryType && !!transmissionType && !ESCustomState.includes("NONE"));
  const [fileWithGateway, setFileWithGateway] = React$1.useState('1');
  const [showModal, setShowModal] = React$1.useState(false);
  const dispatch = useDispatch();

  // const validate = (decType, transmissionType, currentCustomState) => {
  //     return true
  //   }

  const saveDecAndTransmissionType = React$1.useCallback((key1, key2) => {
    dispatch(saveShipmentFieldValue(key1));
    dispatch(saveShipmentFieldValue(key2));
  }, []);
  const startOver = async (decType, transmissionType) => {
    if (decType && transmissionType) {
      // let isValid = validate(decType, transmissionType)
      // if (isValid) {
      await setEUData({
        declarationEntryType: decType,
        transmissionType: transmissionType,
        START_JOB: true
      });
      setTimeout(async () => {
        await saveDecAndTransmissionType('transmissionType', 'declarationEntryType');
        await setDisableStartBtn(true);
      }, 1000);
      //}
    }
  };
  useUpdateEffect(() => {
    setDisableStartBtn(false);
  }, [declarationEntryType, transmissionType]);
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "6",
    className: "divFormFeild border-bottom  b-rw-0 b-tlr-5 b-blr-5"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'declarationEntryType',
    label: translate(DEC_TYPE, {
      ns: ['header']
    }),
    className: "field-bg dropdown100",
    labelClass: "text-none",
    mandatory: false,
    direction: 'right',
    isLabel: true,
    data: decTypeDropdownValues(declarationEntryType, ESCustomState, serviceType === "EX"),
    disabled: currentJobCircuitState === 'STATE_RELEASE_GREEN' || ESCustomState.includes("CANCEL") || window.typeOfUser === 'BROKER_KN_ADMIN',
    errors: getValidationError('declarationEntryType', declarationEntryType, 'headerTab', true),
    value: declarationEntryType,
    onChange: value => {
      updateData({
        'declarationEntryType': value === null || value === void 0 ? void 0 : value.trim()
      });
    },
    onBlur: value => {
      let err = getValidationError('declarationEntryType', declarationEntryType, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'declarationEntryType') : deleteErrors('headerTab', '', 'declarationEntryType');
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "6",
    className: "divFormFeild border-bottom b-trr-5 b-brr-5"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: `transmissionType`,
    label: translate('TRANSMISSION_TYPE', {
      ns: ['default', 'header']
    }),
    className: "field-bg dropdown100",
    labelClass: "text-none",
    isLabel: false,
    data: transmissionTypeDropdownValues(declarationEntryType, ESCustomState, serviceType === "EX"),
    direction: 'right',
    clearable: true,
    disabled: currentJobCircuitState === 'STATE_RELEASE_GREEN' || ESCustomState.includes("CANCEL") || window.typeOfUser === 'BROKER_KN_ADMIN',
    value: transmissionType,
    onChange: value => {
      updateData({
        'transmissionType': value === null || value === void 0 ? void 0 : value.trim()
      });
    }
  })),
  /*#__PURE__*/
  // brokerHouseStatus === "STATE_BH_BROKER_IN_PROCESS" && 
  React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom b-trr-5"
  }, ['ExportTypeA', 'ExportTypeB', 'ExportTypeC', 'PDC', 'PDI'].includes(declarationEntryType) && transmissionType === "CAN" && mrn && /*#__PURE__*/React__default["default"].createElement(CancelEntryModal, {
    key: "updateResponseBtn",
    shipmentId: window.shipmentId,
    language: "es",
    countryCode: "ES",
    fileWithGateway: fileWithGateway,
    showModal: showModal,
    setShowModal: setShowModal,
    cancelReason: cancelReason || "",
    serviceType: serviceType,
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      size: "mini",
      key: "CANCEL_ES",
      disabled: false,
      className: "sv todo-button primaryBtn",
      onClick: () => {
        setShowModal(true);
      }
    }, "CANCEL"),
    searchByID: searchByID
  }), (transmissionType == 'NEW' || transmissionType == 'BOX 40' || transmissionType == 'BOX 44' || transmissionType == "MOD") && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    style: {
      border: '1px solid #267678',
      color: '#267678',
      background: '#fff',
      marginLeft: '1em'
    },
    disabled: currentJobCircuitState === 'STATE_RELEASE_GREEN' || disableStartBtn,
    className: 'ui mini button primaryBtn',
    onClick: () => {
      startOver(declarationEntryType, transmissionType);
    }
  }, ['BOX 40', 'BOX 44', 'NEW'].includes(transmissionType) ? translate('START', {
    ns: ['default', 'header']
  }) : ['MOD'].includes(transmissionType) ? translate('AMEND', {
    ns: ['default', 'header']
  }) : ""))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: 16
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: `errorMsg`
  })))));
};

function SealItem(props) {
  const dispatch = useDispatch();
  const [isRemoving, setIsRemoving] = React$1.useState(false);
  const updateRemoveFlag = () => {
    setIsRemoving(false);
  };
  const {
    infoIndex,
    isFormDisabled,
    totalInfo,
    translate
  } = props;
  const infoItem = useSelector(state => state.Shipment.seals[props.infoIndex]);
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "15",
    className: `divFormFeild
        ${infoIndex === 0 ? 'b-trr-5 b-tlr-5' : ''}
        ${totalInfo === 1 || infoIndex == totalInfo - 1 ? 'b-blr-5 b-brr-5 border-bottom' : ''}
        `
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: `sealId-${infoIndex}-headeradditionalInfo`,
    type: "text",
    label: translate('SEAL_ID', {
      ns: ['default', 'header']
    }),
    boxNumber: "D",
    value: infoItem.id,
    className: 'field-bg',
    clearInput: false,
    disabled: isFormDisabled,
    onChange: value => {
      dispatch(updateSealInfoFeild(infoIndex, 'id', value));
    },
    onBlur: value => {
      dispatch(saveSealInfoFeilds(infoIndex, 'id', infoItem.sealId));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "1",
    className: "icon-delete-add-info"
  }, !isRemoving ? /*#__PURE__*/React__default["default"].createElement("span", null, totalInfo > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "trash alternate outline",
    onClick: () => {
      setIsRemoving(true);
      dispatch(deleteSealInfo(infoItem.sealId, infoIndex, updateRemoveFlag));
    },
    disabled: isFormDisabled || isRemoving
  })) : /*#__PURE__*/React__default["default"].createElement("span", {
    className: "delete-info-loader"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, {
    active: true,
    inline: true,
    size: "mini",
    style: {
      marginRight: '10px'
    }
  }))));
}

function SealDetails(props) {
  const dispatch = useDispatch();
  const [AddingAIInfo, setAddingAIInfo] = React$1.useState(false);
  const updateAIStatus = () => {
    setAddingAIInfo(false);
  };
  const {
    isFormDisabled,
    translate
  } = props;
  const sealInfo = useSelector(state => state.Shipment.seals) || {};
  let infoLength = sealInfo && sealInfo.length || 0;
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      textTransform: 'uppercase',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('SEAL_INFO', {
    ns: ['default', 'header']
  })))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, infoLength > 0 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, Array.from(Array(infoLength).keys()).map((_, infoIndex) => {
    return /*#__PURE__*/React__default["default"].createElement(SealItem, {
      totalInfo: infoLength,
      infoIndex: infoIndex,
      key: infoIndex,
      translate: translate,
      isFormDisabled: isFormDisabled
    });
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    basic: true,
    color: "blue",
    className: "btn-add",
    onClick: () => {
      setAddingAIInfo(true);
      dispatch(createSealInfo(updateAIStatus));
    },
    disabled: isFormDisabled || AddingAIInfo
  }, !AddingAIInfo ? /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "plus square alternate outline",
    disabled: false
  }), " Add") : /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, {
    active: true,
    inline: true,
    size: "mini",
    style: {
      marginRight: '10px'
    }
  }), "Adding.."))));
}

const LocationOfGoods = props => {
  const [officeList, setOfficeList] = React$1.useState([]);
  let lang = instance.language || 'en';
  const getOfficeList = React$1.useCallback(async value => {
    var _response, _response$data, _response$data$eventM;
    let response = await getsearchcDropdownValues('box30Locations', value);
    response = ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM = _response$data.eventMessage) === null || _response$data$eventM === void 0 ? void 0 : _response$data$eventM.box30Locations) || [];
    setOfficeList(response);
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(AutoComplete$1, _extends$1({
    labelIcon: /*#__PURE__*/React__default["default"].createElement(PopUpIcon$1, {
      icon: "info circle",
      popupText: 'enter at least 3 characters'
    })
  }, props, {
    renderItem: ({
      value,
      text,
      text_es,
      text_nl
    }) => {
      return /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        },
        className: "text"
      }, `${value} - ${lang === 'es' ? text_es : lang === 'nl' ? text_nl : text}`);
    },
    dataSource: officeList,
    onSearchChange: getOfficeList
  }));
};

const SearchPort = props => {
  const {
    entityType,
    condition
  } = props;
  const apiEvent = GET_ENTITY_LIST;
  const [list, setList] = React$1.useState([]);
  const getList = React$1.useCallback(async value => {
    var _response, _response$data, _response$data$eventM, _response$data$eventM2;
    let payload = {
      eventType: apiEvent,
      searchFilter: value,
      entityType: entityType,
      condition: condition
    };
    let response = await getSearchDropdownValues(payload);
    response = ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM = _response$data.eventMessage) === null || _response$data$eventM === void 0 ? void 0 : (_response$data$eventM2 = _response$data$eventM.ports) === null || _response$data$eventM2 === void 0 ? void 0 : _response$data$eventM2.list) || [];
    setList(response);
  }, [condition]);
  return /*#__PURE__*/React__default["default"].createElement(AutoComplete$1, _extends$1({
    labelIcon: /*#__PURE__*/React__default["default"].createElement(PopUpIcon$1, {
      icon: "info circle",
      popupText: "enter at least 2 characters"
    })
  }, props, {
    minCharacters: 2,
    renderItem: ({
      portUnloc,
      payload
    }) => {
      return /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        },
        className: "text"
      }, payload);
    },
    dataSource: list,
    onSearchChange: getList
  }));
};

const usePdiEnable = () => {
  const {
    customJobState,
    currentJobState
  } = useCurrentShipmentType();
  return React__default["default"].useMemo(() => {
    return customJobState.includes('PDI') && (currentJobState.includes("IN_PROCESS") || currentJobState.includes("READY")) ? {
      disabled: false
    } : {};
  }, [customJobState, currentJobState]);
};

const containerisedINdicatorList = [{
  id: 12664,
  value: "0",
  text: "No",
  text_es: "No"
}, {
  id: 12666,
  value: "1",
  text: "Yes",
  text_es: "Sí"
}];
function TransportationForm({
  isFormDisabled,
  translate,
  isImportShipment,
  getValidationError,
  jobWheels
}) {
  const dispatch = useDispatch();
  const transportMode = useSelector(state => state.DropDownValues.transportMode);
  const officeType = isImportShipment ? 'entryOffice' : 'exitOffice';
  const countryCodes = useSelector(state => state.DropDownValues.countryCodes);
  const specialCountryKeys = useSelector(state => state.DropDownValues.specialCountryKeys);
  const destinationProvinceKeys = useSelector(state => state.DropDownValues.destinationProvince);
  const addErrors = (level, value, fieldName) => {
    dispatch(addHeaderTabWarnings(level, value, fieldName));
  };
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteHeaderTabWarnings(level, value, fieldName));
  };
  const formData = useSelector(state => state.Shipment);
  const pdiDisabled = usePdiEnable();
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      textTransform: 'uppercase',
      marginTop: '10px',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('TRANSPORTATION', {
    ns: ['default', 'header']
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    style: {
      marginTop: '10px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "8",
    className: "divFormFeild b-rw-0 b-tlr-5"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'transportMode ',
    label: translate(TRANSPORT_MODE, {
      ns: ['header']
    }),
    disabled: true,
    className: "field-bg dropdown100",
    labelClass: "text-none",
    boxNumber: "25",
    errors: getValidationError('transportMode', formData.transportMode, 'headerTab', true),
    mandatory: false,
    isLabel: true,
    data: transportMode,
    clerarable: true,
    value: formData.transportMode,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        transportMode: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('transportMode'));
      let err = getValidationError('transportMode', value, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'transportMode') : deleteErrors('headerTab', '', 'transportMode');
    },
    onBlur: event => {}
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "8",
    className: "divFormFeild  b-trr-5"
  }, /*#__PURE__*/React__default["default"].createElement(CustomOffice, {
    idText: officeType,
    boxNumber: "29",
    errors: getValidationError(officeType, formData[officeType], 'headerTab', true),
    disabled: isFormDisabled,
    label: translate(isImportShipment ? ENTRY_OFFICE : EXIT_OFFICE, {
      ns: ['default', 'header']
    }),
    onSelect: ({
      id
    }) => {
      dispatch(updateShipmentFieldValue$2({
        [officeType]: id
      }));
      dispatch(saveShipmentFieldValue(officeType));
      let err = getValidationError(officeType, id, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], officeType) : deleteErrors('headerTab', '', officeType);
    },
    onBlur: ({
      value
    }) => {
      dispatch(updateShipmentFieldValue$2({
        [officeType]: value
      }));
      dispatch(saveShipmentFieldValue(officeType));
      let err = getValidationError(officeType, formData[officeType], 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], officeType) : deleteErrors('headerTab', '', officeType);
    },
    selectedValue: formData[officeType]
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "6",
    className: `divFormFeild b-rw-0`
  }, /*#__PURE__*/React__default["default"].createElement(LocationOfGoods, {
    idText: 'locationOfGoods',
    boxNumber: "30",
    disabled: isFormDisabled,
    label: translate(GOODS_LOCATION, {
      ns: ['default', 'header']
    }),
    errors: getValidationError('locationOfGoods', formData.locationOfGoods, 'headerTab', true),
    onSelect: ({
      value
    }) => {
      dispatch(updateShipmentFieldValue$2({
        locationOfGoods: value
      }));
      dispatch(saveShipmentFieldValue('locationOfGoods'));
      let err = getValidationError('locationOfGoods', value, 'headerTab', false);
      err.length ? addErrors('headerTab', err[0], 'locationOfGoods') : deleteErrors('headerTab', '', 'locationOfGoods');
    },
    onBlur: ({
      value
    }) => {
      dispatch(updateShipmentFieldValue$2({
        locationOfGoods: value
      }));
      dispatch(saveShipmentFieldValue('locationOfGoods'));
      let err = getValidationError('locationOfGoods', formData.locationOfGoods, 'headerTab', false);
      err.length ? addErrors('headerTab', err[0], 'locationOfGoods') : deleteErrors('headerTab', '', 'locationOfGoods');
    },
    selectedValue: formData.locationOfGoods
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "5",
    className: "divFormFeild  border-bottom b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'countryOfDispatch',
    label: translate(COUNTRY_OF_EXPORT, {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "15",
    mandatory: false,
    direction: 'left',
    labelClass: "text-none",
    isLabel: true,
    data: countryCodes,
    clearable: true,
    errors: getValidationError('countryOfDispatch', formData.countryOfDispatch, 'headerTab', true),
    value: formData.countryOfDispatch,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        countryOfDispatch: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('countryOfDispatch'));
      let err = getValidationError('countryOfDispatch', value, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'countryOfDispatch') : deleteErrors('headerTab', '', 'countryOfDispatch');
      formData.countryOfDispatch !== value && dispatch(updateShipmentFieldValue$2({
        placeOfLadding: ''
      })) && dispatch(saveShipmentFieldValue('placeOfLadding'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "5",
    className: `divFormFeild  b-rw-1 
           
            `
  }, /*#__PURE__*/React__default["default"].createElement(SearchPort, {
    isLabel: false,
    idText: `placeOfLadding`,
    type: "text",
    mandatory: false,
    condition: formData.countryOfDispatch,
    label: translate('PORT_OF_LADING', {
      ns: ['default', 'header']
    }),
    value: formData.placeOfLadding,
    className: 'field-bg',
    selectedValue: formData.placeOfLadding,
    clearInput: false,
    disabled: isFormDisabled,
    onBlur: event => {
      dispatch(saveShipmentFieldValue('placeOfLadding'));
    },
    onSelect: ({
      portUnloc,
      payload
    }, data) => {
      dispatch(updateShipmentFieldValue$2({
        placeOfLadding: portUnloc
      }));
      dispatch(saveShipmentFieldValue('placeOfLadding'));
    }
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'inlandTransportMode',
    label: translate('INTERNAL_TRANSPORT_MODE', {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "26",
    mandatory: false,
    direction: 'right',
    labelClass: "text-none",
    isLabel: true,
    clearable: true,
    data: transportMode,
    value: formData.inlandTransportMode,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        inlandTransportMode: value
      }));
      dispatch(saveShipmentFieldValue('inlandTransportMode'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'destinationCountry',
    label: translate('DESTINATION_COUNTRY', {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "17A",
    mandatory: false,
    direction: 'left',
    labelClass: "text-none",
    isLabel: true,
    clearable: true,
    data: specialCountryKeys,
    value: formData.destinationCountry,
    errors: getValidationError('destinationCountry', formData.destinationCountry, 'headerTab', true),
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        destinationCountry: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('destinationCountry'));
      formData.destinationCountry !== value && dispatch(updateShipmentFieldValue$2({
        placeOfUnLadding: ''
      }));
      dispatch(saveShipmentFieldValue('placeOfUnLadding'));
      let err = getValidationError('destinationCountry', value, 'headerTab', true);
      console.log("err:", err);
      err.length ? addErrors('headerTab', err[0], 'destinationCountry') : deleteErrors('headerTab', '', 'destinationCountry');
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'destinationProvinceKeys',
    label: translate('DESTINATION_PROVINCE', {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "17B",
    mandatory: false,
    direction: 'left',
    labelClass: "text-none",
    isLabel: true,
    clearable: true,
    data: destinationProvinceKeys,
    value: formData.destinationState,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        destinationState: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('destinationState'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild   b-rw-1"
  }, /*#__PURE__*/React__default["default"].createElement(SearchPort, {
    isLabel: false,
    idText: `placeOfUnLadding`,
    type: "text",
    mandatory: false,
    condition: formData.destinationCountry,
    label: translate('PORT_OF_UNLADING', {
      ns: ['default', 'header']
    }),
    selectedValue: formData.placeOfUnLadding,
    className: 'field-bg',
    clearInput: false,
    disabled: isFormDisabled,
    onBlur: event => {
      dispatch(saveShipmentFieldValue('placeOfUnLadding'));
    },
    onSelect: ({
      payload,
      portUnloc
    }, data) => {
      dispatch(updateShipmentFieldValue$2({
        placeOfUnLadding: portUnloc
      }));
      dispatch(saveShipmentFieldValue('placeOfUnLadding'));
    }
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom b-blr-5 b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: `carrierName`,
    type: "text",
    mandatory: false,
    label: translate('CARRIER', {
      ns: ['default', 'header']
    }),
    value: formData.carrierName,
    className: 'field-bg',
    clearInput: false,
    disabled: isFormDisabled,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        carrierName: value
      }));
    },
    onBlur: value => {
      dispatch(saveShipmentFieldValue('carrierName'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild border-bottom b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: 'transportIdAtBorder',
    label: translate('INT_TRANSPORT_ID', {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "18",
    mandatory: false,
    value: formData.transportIdAtBorder,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        transportIdAtBorder: value
      }));
    },
    onBlur: event => {
      dispatch(saveShipmentFieldValue('transportIdAtBorder'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: `carrierId`,
    type: "text",
    mandatory: false,
    boxNumber: "21.1",
    label: "Voyg/flt/trk.id",
    value: formData.carrierId,
    className: 'field-bg',
    clearInput: false,
    disabled: isFormDisabled,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        carrierId: value
      }));
    },
    onBlur: value => {
      dispatch(saveShipmentFieldValue('carrierId'));
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom b-rw-0"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'transportNationalityCrossBorder',
    label: translate('TRANSPORT_NATIONALITY', {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    boxNumber: "21.2",
    mandatory: false,
    direction: 'left',
    labelClass: "text-none",
    isLabel: true,
    clearable: true,
    data: countryCodes,
    value: formData.transportNationalityCrossBorder,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        transportNationalityCrossBorder: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('transportNationalityCrossBorder'));
    },
    onBlur: event => {}
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom b-brr-5"
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, _extends$1({
    id: 'containerIndicator',
    label: translate(CTR, {
      ns: ['default', 'header']
    }),
    disabled: isFormDisabled
  }, pdiDisabled, {
    className: "field-bg dropdown100",
    boxNumber: "19",
    mandatory: false,
    direction: 'left',
    errors: getValidationError('containerIndicator', formData.containerIndicator, 'headerTab'),
    labelClass: "text-none",
    isLabel: true,
    clerarable: true,
    data: containerisedINdicatorList,
    value: formData.containerIndicator,
    onChange: value => {
      dispatch(updateShipmentFieldValue$2({
        containerIndicator: value === null || value === void 0 ? void 0 : value.trim()
      }));
      dispatch(saveShipmentFieldValue('containerIndicator'));
      let err = getValidationError('containerIndicator', formData.containerIndicator, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'containerIndicator') : deleteErrors('headerTab', '', 'containerIndicator');
    }
  }))))));
}
var TransportationForm$1 = /*#__PURE__*/React__default["default"].memo(TransportationForm);

function HeaderForm(props) {
  var _props$jobWheels$ES_C, _props$jobWheels$ES_C2, _props$jobWheels$SHIP, _props$jobWheels$SHIP2, _formData$arrivalDate, _formData$acceptanceD, _formData$releaseDate, _formData$exitDate;
  const dispatch = useDispatch();
  const {
    isFormDisabled,
    translate,
    jobWheels,
    serviceType
  } = props;
  const ESCustomState = ((_props$jobWheels$ES_C = props.jobWheels['ES_CUSTOM_JOB_WHEEL']) === null || _props$jobWheels$ES_C === void 0 ? void 0 : (_props$jobWheels$ES_C2 = _props$jobWheels$ES_C.value) === null || _props$jobWheels$ES_C2 === void 0 ? void 0 : _props$jobWheels$ES_C2.state) || '';
  const {
    isImportShipment,
    customJobState
  } = useCurrentShipmentType();
  const pdiValidationCheck = customJobState === null || customJobState === void 0 ? void 0 : customJobState.includes("PDI");
  const declarationList = useSelector(state => state.DropDownValues[isImportShipment ? "box011GoodsStatus" : "box011GoodsStatusExport"]);
  const transactionNature = useSelector(state => state.DropDownValues.transactionNature);
  const currentJobCircuitState = props.currentJobCircuitState;
  const ErrorWarningsList = useSelector(state => {
    var _state$ServerErrorRed;
    return (_state$ServerErrorRed = state.ServerErrorReducer) === null || _state$ServerErrorRed === void 0 ? void 0 : _state$ServerErrorRed.headerTab;
  }) || [];
  const bhHouse = ((_props$jobWheels$SHIP = props.jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']) === null || _props$jobWheels$SHIP === void 0 ? void 0 : (_props$jobWheels$SHIP2 = _props$jobWheels$SHIP.value) === null || _props$jobWheels$SHIP2 === void 0 ? void 0 : _props$jobWheels$SHIP2.state) || null;
  const formData = useSelector(state => state.Shipment);
  React$1.useEffect(() => {
    const completeData = convertedDataHeaderTab$1(formData);
    let headerErrors = createHeaderWarningsList(completeData, 'headerTab', translate, serviceType, pdiValidationCheck); //
    dispatch(intializeHeaderTabWarnings('headerTab', headerErrors));
  }, [translate]);
  const getValidationError = (field, value, Level, onlyMandatoryCheck = false) => getValidationError$1(field, value, Level, onlyMandatoryCheck, '', translate, pdiValidationCheck);
  const updateData = React$1.useCallback(payload => {
    dispatch(updateShipmentFieldValue$2(payload));
  }, []);
  const savedata = React$1.useCallback(key => {
    dispatch(saveShipmentFieldValue(key));
  }, []);
  const addErrors = (level, value, fieldName) => {
    dispatch(addHeaderTabWarnings(level, value, fieldName));
  };
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteHeaderTabWarnings(level, value, fieldName));
  };
  const officeType = "officeOfDestination";
  return /*#__PURE__*/React__default["default"].createElement(ErrorBoundary, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "formContentareaC88 headerDetails"
  }, (ErrorWarningsList === null || ErrorWarningsList === void 0 ? void 0 : ErrorWarningsList.length) > 0 && !props.disabled && /*#__PURE__*/React__default["default"].createElement(ErrorMessagesWindow, {
    errors: ErrorWarningsList
  }), /*#__PURE__*/React__default["default"].createElement(DecTypeForm, {
    saveShipmentFieldValue: saveShipmentFieldValue,
    currentJobCircuitState: currentJobCircuitState,
    translate: translate,
    updateData: updateData,
    serviceType: props.serviceType,
    declarationEntryType: formData.declarationEntryType,
    transmissionType: formData.transmissionType,
    cancelReason: formData.cancelReason,
    transmissionTypeDropdownValues: transmissionTypeDropdownValues,
    ESCustomState: ESCustomState,
    mrn: formData.mrn,
    setEUData: props.setEUData,
    addErrors: addErrors,
    deleteErrors: deleteErrors,
    searchByID: props.searchByID,
    getValidationError: getValidationError,
    brokerHouseStatus: bhHouse
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "6",
    className: "divFormFeild  b-rw-0 b-tlr-5"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: `mrn`,
    type: "text",
    label: 'MRN',
    value: formData.mrn,
    errors: getValidationError('mrn', formData.mrn, 'headerTab'),
    boxNumber: "7",
    className: 'field-bg',
    clearInput: false,
    onChange: value => {
      updateData({
        mrn: value
      });
    },
    onBlur: value => {
      savedata('mrn');
      let err = getValidationError('mrn', formData.mrn, 'headerTab');
      err.length ? addErrors('headerTab', err[0], 'mrn') : deleteErrors('headerTab', '', 'mrn');
    },
    disabled: isFormDisabled
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: 'declarationType',
    label: translate(DECLARATION, {
      ns: ['header']
    }),
    className: "field-bg dropdown100",
    labelClass: "text-none",
    isLabel: true,
    disabled: isFormDisabled,
    data: declarationList,
    errors: getValidationError('declarationType', formData.declarationType, 'headerTab', true),
    value: formData.declarationType,
    boxNumber: "1",
    onChange: value => {
      updateData({
        declarationType: value
      });
      savedata('declarationType');
      let err = getValidationError('declarationType', formData.declarationType, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'declarationType') : deleteErrors('headerTab', '', 'declarationType');
    },
    onBlur: value => {}
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "6",
    className: "divFormFeild  b-trr-5"
  }, /*#__PURE__*/React__default["default"].createElement(CustomOffice, {
    idText: officeType,
    boxNumber: "A ",
    errors: getValidationError(officeType, formData[officeType], 'headerTab', true),
    disabled: isFormDisabled,
    label: translate(CUSTOMS_OFFICE, {
      ns: ['header']
    }),
    onSelect: ({
      value
    }) => {
      dispatch(updateShipmentFieldValue$2({
        [officeType]: value
      }));
      dispatch(saveShipmentFieldValue(officeType));
      let err = getValidationError(officeType, value, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], officeType) : deleteErrors('headerTab', '', officeType);
    },
    onBlur: ({
      value
    }) => {
      dispatch(updateShipmentFieldValue$2({
        [officeType]: value
      }));
      dispatch(saveShipmentFieldValue(officeType));
      let err = getValidationError(officeType, value, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], officeType) : deleteErrors('headerTab', '', officeType);
    },
    selectedValue: formData[officeType]
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: isImportShipment ? '4' : '3',
    className: "divFormFeild  datepicker1 b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "arrivalDate",
    type: "date",
    label: translate('ARRIVAL_DATE', {
      ns: ['default', 'header']
    }),
    className: "field-bg",
    value: convertDateToUTC(formData === null || formData === void 0 ? void 0 : (_formData$arrivalDate = formData.arrivalDate) === null || _formData$arrivalDate === void 0 ? void 0 : _formData$arrivalDate.epochs),
    disabled: isFormDisabled,
    onChange: value => {
      value = convertDateToUTCEpoch(value);
      updateData({
        arrivalDate: {
          epochs: value
        }
      });
      savedata('arrivalDate');
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: isImportShipment ? '4' : '3',
    className: "divFormFeild  datepicker1 b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "acceptanceDate",
    type: "date",
    disabled: true,
    label: translate('ACCEPTANCE_DATE', {
      ns: ['default', 'header']
    }),
    className: "field-bg",
    value: convertDateToUTC(formData === null || formData === void 0 ? void 0 : (_formData$acceptanceD = formData.acceptanceDate) === null || _formData$acceptanceD === void 0 ? void 0 : _formData$acceptanceD.epochs),
    onChange: value => {
      value = convertDateToUTCEpoch(value);
      updateData({
        acceptanceDate: {
          epochs: value
        }
      });
      savedata('acceptanceDate');
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: isImportShipment ? '4' : '3',
    className: "divFormFeild  datepicker1 b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "releaseDate",
    type: "date",
    label: translate('RELEASE_DATE', {
      ns: ['default', 'header']
    }),
    className: "field-bg",
    value: convertDateToUTC(formData === null || formData === void 0 ? void 0 : (_formData$releaseDate = formData.releaseDate) === null || _formData$releaseDate === void 0 ? void 0 : _formData$releaseDate.epochs),
    disabled: true,
    onChange: value => {
      value = convertDateToUTCEpoch(value);
      updateData({
        releaseDate: {
          epochs: value
        }
      });
      savedata('releaseDate');
    }
  })), !isImportShipment && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild  b-rw-0 datepicker1  "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "exitEuDate",
    type: "date",
    label: translate('EXIT_EU_DATE', {
      ns: ['default', 'header']
    }),
    className: "field-bg",
    value: convertDateToUTC(formData === null || formData === void 0 ? void 0 : (_formData$exitDate = formData.exitDate) === null || _formData$exitDate === void 0 ? void 0 : _formData$exitDate.epochs),
    disabled: true,
    onChange: value => {
      value = convertDateToUTCEpoch(value);
      updateData({
        exitDate: {
          epochs: value
        }
      });
      savedata('exitDate');
    }
  })), isImportShipment ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild  "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "exitDate",
    type: "text",
    label: '',
    className: "field-bg",
    value: '',
    disabled: true
  })) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4",
    className: "divFormFeild datepicker1",
    style: {
      borderRight: '1px solid #1765ae'
    }
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: "customDestinationDate",
    type: "date",
    label: translate('CUSTOM_DESTINATION_DATE', {
      ns: ['default', 'header']
    }),
    className: "field-bg b-rw-1",
    value: '',
    disabled: true,
    onChange: value => {
      value = convertDateToUTCEpoch(value);
      updateData({
        releaseDate: {
          epochs: value
        }
      });
      savedata('releaseDate');
    }
  }))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: 10,
    className: "divFormFeild border-bottom  b-blr-5 b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: `cancelReason`,
    type: "text",
    label: translate(CANCELLATION_REASON, {
      ns: ['default', 'header']
    }),
    className: 'field-bg',
    value: formData.cancelReason,
    errors: getValidationError('cancelReason', formData.cancelReason, 'headerTab'),
    clearInput: false,
    onChange: value => {
      updateData({
        cancelReason: value
      });
    },
    onBlur: value => {
      savedata('cancelReason');
      let err = getValidationError('cancelReason', formData.cancelReason, 'headerTab');
      err.length ? addErrors('headerTab', err[0], 'cancelReason') : deleteErrors('headerTab', '', 'cancelReason');
    },
    disabled: true
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: 6,
    className: "divFormFeild border-bottom   b-brr-5 "
  }, /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    isLabel: false,
    id: `natureOfTransaction`,
    label: translate(TRANSACTION_NATURE, {
      ns: ['default', 'header']
    }),
    data: transactionNature,
    errors: getValidationError('natureOfTransaction', formData.natureOfTransaction, 'headerTab', true),
    boxNumber: "24",
    clearInput: false,
    clearable: true,
    onChange: value => {
      updateData({
        natureOfTransaction: value === null || value === void 0 ? void 0 : value.trim()
      });
      savedata('natureOfTransaction');
      let err = getValidationError('natureOfTransaction', value, 'headerTab', true);
      err.length ? addErrors('headerTab', err[0], 'natureOfTransaction') : deleteErrors('headerTab', '', 'natureOfTransaction');
    },
    onBlur: value => {},
    disabled: isFormDisabled,
    className: "field-bg dropdown100",
    labelClass: "text-none",
    direction: 'right',
    value: formData.natureOfTransaction
  }))))), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(TransportationForm$1, {
    isFormDisabled: isFormDisabled,
    translate: translate,
    isImportShipment: isImportShipment,
    getValidationError: getValidationError,
    jobWheels: jobWheels
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Containers$1, {
    translate: translate,
    isFormDisabled: isFormDisabled
  })), !isImportShipment && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginTop: '10px',
      marginBottom: '10px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(SealDetails, {
    translate: translate,
    isFormDisabled: isFormDisabled
  }))));
}
var HeaderForm$1 = /*#__PURE__*/React__default["default"].memo(HeaderForm);

const assignESValues = response => {
  var _$get$concat;
  let shipment = esShipment(response.shipmentId);
  // new json ressponse  
  shipment.shipmentId = lodash.get(response, "shipmentId", "");
  shipment.mrn = lodash.get(response, "mrn", "");
  shipment.declarationType = lodash.get(response, "declarationType", "");
  shipment.declarationEntryType = lodash.get(response, "declarationEntryType", "");
  shipment.transmissionType = lodash.get(response, "transmissionType", "");
  shipment.inlandTransportMode = lodash.get(response, "inlandTransportMode", "") === "-1" ? "" : lodash.get(response, 'inlandTransportMode', "");
  shipment.officeOfDestination = lodash.get(response, "officeOfDestination", "");
  shipment.entryOffice = lodash.get(response, "entryOffice", "");
  shipment.exitOffice = lodash.get(response, "exitOffice", "");
  shipment.countryOfDispatch = lodash.get(response, "countryOfDispatch", "");
  shipment.transportIdAtBorder = lodash.get(response, 'transportIdAtBorder', '');
  shipment.transportNationalityCrossBorder = lodash.get(response, "transportNationalityCrossBorder", "");
  shipment.transportTypeBorder = lodash.get(response, "transportTypeBorder", "");
  shipment.locationOfGoods = lodash.get(response, "locationOfGoods", "");
  shipment.containerIndicator = lodash.get(response, "containerIndicator", "");
  shipment.destinationCountry = lodash.get(response, "destinationCountry", "");
  shipment.destinationState = lodash.get(response, 'destinationState', '');
  shipment.arrivalDate.epochs = parseInt(lodash.get(response, "arrivalDate.epochs") || -999);
  shipment.acceptanceDate.epochs = parseInt(lodash.get(response, "acceptanceDate.epochs") || -999);
  shipment.releaseDate.epochs = parseInt(lodash.get(response, "releaseDate.epochs") || -999);
  shipment.exitDate.epochs = parseInt(lodash.get(response, "exitDate.epochs") || -999);
  shipment.carrierName = lodash.get(response, "carrierName", "");
  shipment.carrierId = lodash.get(response, "carrierId", "");
  shipment.placeOfLadding = lodash.get(response, "placeOfLadding", "");
  shipment.placeOfUnLadding = lodash.get(response, "placeOfUnLadding", "");
  shipment.transportMode = lodash.get(response, "transportMode", "") === "-1" ? "" : lodash.get(response, 'transportMode', "");
  shipment.natureOfTransaction = lodash.get(response, "natureOfTransaction", "");
  shipment.transmissionType = lodash.get(response, "transmissionType", "");
  shipment.cancelReason = lodash.get(response, "cancelReason", "");
  shipment.mopCode = lodash.get(response, 'mopCode', '');

  //parties
  shipment.consignee.name = lodash.get(response, 'consignee.name', '');
  shipment.consignee.id = lodash.get(response, 'consignee.id', '');
  shipment.consignee.actorType = lodash.get(response, 'consignee.actorType', '');
  shipment.consignee.actorTypeID = lodash.get(response, 'consignee.actorTypeID', '');
  shipment.consignee.privateIndicatorFlag = lodash.get(response, 'consignee.privateIndicatorFlag', '');
  shipment.consignee.externalIdentification = lodash.get(response, 'consignee.externalIdentification', '').toUpperCase();
  shipment.consignee.address2 = lodash.get(response, 'consignee.address2', '');
  shipment.consignee.addressId = lodash.get(response, 'consignee.addressId', '');
  shipment.consignee.city = lodash.get(response, 'consignee.city', '');
  shipment.consignee.country = lodash.get(response, 'consignee.country', '');
  shipment.consignee.countryCode = lodash.get(response, 'consignee.countryCode', '');
  shipment.consignee.postalCode = lodash.get(response, 'consignee.postalCode', '');
  shipment.consignee.state = lodash.get(response, 'consignee.state', '');
  shipment.consignee.streetName = lodash.get(response, 'consignee.streetName', '');
  shipment.consignee.streetNumber = lodash.get(response, 'consignee.streetNumber', '');
  //  shipment.consignee.addressLine1=_.get(response,'streetNumber', '').concat(" ",_.get(response, 'streetName', ''))?.trim()
  shipment.consignor.name = lodash.get(response, 'consignor.name', '');
  shipment.consignor.id = lodash.get(response, 'consignor.id', '');
  shipment.consignor.actorType = lodash.get(response, 'consignor.actorType', '');
  shipment.consignor.actorTypeID = lodash.get(response, 'consignor.actorTypeID', '');
  shipment.consignor.externalIdentification = lodash.get(response, 'consignor.externalIdentification', '').toUpperCase();
  shipment.consignor.address2 = lodash.get(response, 'consignor.address2', '');
  shipment.consignor.addressId = lodash.get(response, 'consignor.addressId', '');
  shipment.consignor.city = lodash.get(response, 'consignor.city', '');
  shipment.consignor.country = lodash.get(response, 'consignor.country', '');
  shipment.consignor.countryCode = lodash.get(response, 'consignor.countryCode', '');
  shipment.consignor.postalCode = lodash.get(response, 'consignor.postalCode', '');
  shipment.consignor.state = lodash.get(response, 'consignor.state', '');
  shipment.consignor.streetName = lodash.get(response, 'consignor.streetName', '');
  shipment.consignor.streetNumber = lodash.get(response, 'consignor.streetNumber', '');
  //  shipment.consignor.addressLine1=_.get(response,'consignor.streetNumber', '').concat(" ",_.get(response, 'consignor.streetName', ''))?.trim()
  shipment.broker.name = lodash.get(response, 'broker.name', '');
  shipment.broker.id = lodash.get(response, 'broker.id', '');
  shipment.broker.actorType = lodash.get(response, 'broker.actorType', '');
  shipment.broker.actorTypeID = lodash.get(response, 'broker.actorTypeID', '');
  shipment.broker.externalIdentification = lodash.get(response, 'broker.externalIdentification', '').toUpperCase();
  shipment.broker.formOfRepresentation = lodash.get(response, 'broker.formOfRepresentation', '').toUpperCase();
  shipment.broker.address2 = lodash.get(response, 'broker.address2', '');
  shipment.broker.addressId = lodash.get(response, 'broker.addressId', '');
  shipment.broker.city = lodash.get(response, 'broker.city', '');
  shipment.broker.country = lodash.get(response, 'broker.country', '');
  shipment.broker.countryCode = lodash.get(response, 'broker.countryCode', '');
  shipment.broker.postalCode = lodash.get(response, 'broker.postalCode', '');
  shipment.broker.state = lodash.get(response, 'broker.state', '');
  shipment.broker.streetName = lodash.get(response, 'broker.streetName', '');
  shipment.broker.streetNumber = lodash.get(response, 'broker.streetNumber', '');
  shipment.broker.addressLine1 = (_$get$concat = lodash.get(response, 'broker.streetNumber', '').concat(" ", lodash.get(response, 'broker.streetName', ''))) === null || _$get$concat === void 0 ? void 0 : _$get$concat.trim();
  shipment.seller.name = lodash.get(response, 'seller.name', '');
  shipment.seller.id = lodash.get(response, 'seller.id', '');
  shipment.seller.actorType = lodash.get(response, 'seller.actorType', '');
  shipment.seller.actorTypeID = lodash.get(response, 'seller.actorTypeID', '');
  shipment.seller.externalIdentification = lodash.get(response, 'seller.externalIdentification', '').toUpperCase();
  shipment.seller.address2 = lodash.get(response, 'seller.address2', '');
  shipment.seller.addressId = lodash.get(response, 'seller.addressId', '');
  shipment.seller.city = lodash.get(response, 'seller.city', '');
  shipment.seller.country = lodash.get(response, 'seller.country', '');
  shipment.seller.countryCode = lodash.get(response, 'seller.countryCode', '');
  shipment.seller.postalCode = lodash.get(response, 'seller.postalCode', '');
  shipment.seller.state = lodash.get(response, 'seller.state', '');
  shipment.seller.streetName = lodash.get(response, 'seller.streetName', '');
  shipment.seller.streetNumber = lodash.get(response, 'seller.streetNumber', '');
  //  shipment.seller.addressLine1=_.get(response,'streetNumber', '').concat(" ",_.get(response, 'streetName', ''))?.trim()
  shipment.buyer.name = lodash.get(response, 'buyer.name', '');
  shipment.buyer.id = lodash.get(response, 'buyer.id', '');
  shipment.buyer.actorType = lodash.get(response, 'buyer.actorType', '');
  shipment.buyer.actorTypeID = lodash.get(response, 'buyer.actorTypeID', '');
  shipment.buyer.externalIdentification = lodash.get(response, 'buyer.externalIdentification', '').toUpperCase();
  shipment.buyer.address2 = lodash.get(response, 'buyer.address2', '');
  shipment.buyer.addressId = lodash.get(response, 'buyer.addressId', '');
  shipment.buyer.city = lodash.get(response, 'buyer.city', '');
  shipment.buyer.country = lodash.get(response, 'buyer.country', '');
  shipment.buyer.countryCode = lodash.get(response, 'buyer.countryCode', '');
  shipment.buyer.postalCode = lodash.get(response, 'buyer.postalCode', '');
  shipment.buyer.state = lodash.get(response, 'buyer.state', '');
  shipment.buyer.streetName = lodash.get(response, 'buyer.streetName', '');
  shipment.buyer.streetNumber = lodash.get(response, 'buyer.streetNumber', '');
  //  shipment.buyer.addressLine1=_.get(response,'streetNumber', '').concat(" ",_.get(response, 'streetName', ''))?.trim()

  //Items
  shipment.totalInvoice = lodash.get(response, "totalInvoice", "");
  shipment.totalItem = lodash.get(response, "totalItem", "");
  shipment.totalShipmentPackages = lodash.get(response, 'totalShipmentPackages', "") === "-999" ? "" : lodash.get(response, 'totalShipmentPackages', "");
  shipment.totalGrassWeight = lodash.get(response, "totalGrassWeight", 0.00);
  shipment.totalInvoiceAmount = lodash.get(response, "totalInvoiceAmount", "");
  shipment.totalInvoiceAmountInCurrency = lodash.get(response, 'totalInvoiceAmountInCurrency', '');
  shipment.totalNetWeight = lodash.get(response, "totalNetWeight", "");
  shipment.shipmentCurrency = lodash.get(response, "shipmentCurrency", "");
  let warranties = [];
  if (response.warranties) {
    warranties = response.warranties.map(mapWarranteeInfo);
  }
  shipment.warranties = warranties || [];
  let containerData = [];
  if (response.containers) {
    containerData = response.containers.map(mapContainerShipmentData);
    shipment.containers = containerData || [];
  }
  shipment.containers = containerData;

  //Fields for Values Build Up Tab 
  //   function getValueBuildupdata(obj) {
  //     for (const [key, value] of Object.entries(obj)) {
  //       shipment.valueBuildUp[key] = _.get(response, 'value', '')
  // }
  //   }
  // for Object.entries(valueBuildUp)
  shipment.valueBuildUp.dutyExtUkId = lodash.get(response, 'valueBuildUp.dutyExtUkId', '');
  shipment.valueBuildUp.freightChargesCurrency = lodash.get(response, 'valueBuildUp.freightChargesCurrency', '');
  shipment.valueBuildUp.freightChargesAmount = parseFloat(lodash.get(response, 'valueBuildUp.freightChargesAmount', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.freightChargesAmount') === "-999" ? "" : lodash.get(response, 'valueBuildUp.freightChargesAmount', "");
  shipment.valueBuildUp.insuranceUpliftType = lodash.get(response, 'valueBuildUp.insuranceUpliftType', '');
  shipment.valueBuildUp.insuranceUpliftValue = parseFloat(lodash.get(response, 'valueBuildUp.insuranceUpliftValue', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.insuranceUpliftValue') === "-999" ? "" : lodash.get(response, 'valueBuildUp.insuranceUpliftValue', "");
  shipment.valueBuildUp.insuranceAmount = parseFloat(lodash.get(response, 'valueBuildUp.insuranceAmount', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.insuranceAmount') === "-999" ? "" : lodash.get(response, 'valueBuildUp.insuranceAmount', "");
  shipment.valueBuildUp.insuranceAmountCurrency = lodash.get(response, 'valueBuildUp.insuranceAmountCurrency', '');
  shipment.valueBuildUp.vatValueAmount = parseFloat(lodash.get(response, 'valueBuildUp.vatValueAmount', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.vatValueAmount') === "-999" ? "" : lodash.get(response, 'valueBuildUp.vatValueAmount', "");
  shipment.valueBuildUp.vatValueCurrency = lodash.get(response, 'valueBuildUp.vatValueCurrency', '');
  shipment.valueBuildUp.discountAmountCurrency = lodash.get(response, 'valueBuildUp.discountAmountCurrency', '');
  shipment.valueBuildUp.discountAmount = parseFloat(lodash.get(response, 'valueBuildUp.discountAmount', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.discountAmount') === "-999" ? "" : lodash.get(response, 'valueBuildUp.discountAmount', "");
  shipment.valueBuildUp.discountAmountPct = parseFloat(lodash.get(response, 'valueBuildUp.discountAmountPct', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.discountAmountPct') === "-999" ? "" : lodash.get(response, 'valueBuildUp.discountAmountPct', "");
  shipment.valueBuildUp.airportOfLoading = lodash.get(response, 'valueBuildUp.airportOfLoading', '');
  shipment.valueBuildUp.airTransportCost = parseFloat(lodash.get(response, 'valueBuildUp.airTransportCost', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.airTransportCost') === "-999" ? "" : lodash.get(response, 'valueBuildUp.airTransportCost', "");
  shipment.valueBuildUp.airTransportCostCurrency = lodash.get(response, 'valueBuildUp.airTransportCostCurrency', '');
  shipment.valueBuildUp.otherChargesAmount = parseFloat(lodash.get(response, 'valueBuildUp.otherChargesAmount', 0.00)).toFixed(2) === "0.00" || lodash.get(response, 'valueBuildUp.otherChargesAmount') === "-999" ? "" : lodash.get(response, 'valueBuildUp.otherChargesAmount', "");
  shipment.valueBuildUp.otherChargesCurrency = lodash.get(response, 'valueBuildUp.otherChargesCurrency', '');
  shipment.valueBuildUp.totalDuty = lodash.get(response, 'valueBuildUp.totalDuty', 0.00);
  shipment.valueBuildUp.transportChargeMOP = lodash.get(response, 'valueBuildUp.transportChargeMOP', '');
  shipment.valueBuildUp.deferredDuty = lodash.get(response, 'valueBuildUp.deferredDuty', '');
  shipment.valueBuildUp.immDuty = lodash.get(response, 'valueBuildUp.immDuty', '');
  shipment.valueBuildUp.dutyPayable = lodash.get(response, 'valueBuildUp.dutyPayable', '');
  let sealData = [];
  if (response.seals) {
    sealData = response.seals.map(mapSealData);
    shipment.seals = sealData || [];
  }
  shipment.seals = sealData;

  // INVOICE
  try {
    let data = response.invoices && response.invoices.filter(x => {
      return x.hasOwnProperty("invoiceId") === true && x.invoiceId !== "";
    });
    let newInvoiceItems = data && data.map((invoiceItem, index) => {
      let newInvoiceItem = invoiceItemData();
      newInvoiceItem.invoiceItemIndex = index;
      newInvoiceItem.invoiceId = invoiceItem.invoiceId || '';
      newInvoiceItem.shipmentId = invoiceItem.shipmentId || '';
      newInvoiceItem.invoiceNumber = invoiceItem.invoiceNumber || '';
      newInvoiceItem.grassWeight = invoiceItem.grassWeight || '';
      newInvoiceItem.netWeight = invoiceItem.netWeight || '';
      newInvoiceItem.invoiceDate.epochs = invoiceItem.invoiceDate && invoiceItem.invoiceDate.epochs || '-999';
      newInvoiceItem.poNo = invoiceItem.poNo || '';
      newInvoiceItem.incoTermsConditionsCode = invoiceItem.incoTermsConditionsCode || "";
      newInvoiceItem.descriptionOfPlaceOfDelivery = invoiceItem.descriptionOfPlaceOfDelivery || "";
      newInvoiceItem.deliveryZoneIndicator = invoiceItem.deliveryZoneIndicator || "";
      newInvoiceItem.flag = null;
      newInvoiceItem.invoiceTotal = invoiceItem.invoiceTotal === "0.0" || invoiceItem.invoiceTotal === "-999.0" ? "" : invoiceItem.invoiceTotal || '';
      newInvoiceItem.merchandiseList = [];
      if (invoiceItem.hasOwnProperty("merchandises") === true) {
        let merchandiseLineItemsList = invoiceItem.merchandises.map(mapLineItem);
        newInvoiceItem.merchandiseList = merchandiseLineItemsList;
      } else {
        newInvoiceItem.merchandiseList = [];
      }
      return newInvoiceItem;
    });
    shipment.invoices = newInvoiceItems || [];
  } catch (e) {
    console.log(e);
    shipment.invoices = [];
  }
  return shipment;
};
const mapLineItem = (lineItem, index) => {
  var _lineItem$commodityCo, _lineItem$commodityCo2, _lineItem$commodityCo3, _lineItem$commodityCo4;
  let newLineItem = merchandiseLineItems();
  newLineItem.lineItemIndex = index;
  newLineItem.lineflag = false;
  newLineItem.shipmentId = lineItem.shipmentId || '';
  newLineItem.merchandiseId = lineItem.merchandiseId || '';
  newLineItem.invoiceId = lineItem.invoiceId || '';
  newLineItem.sku = lineItem.sku || '';
  newLineItem.commercialDescription = lineItem.commercialDescription || '';
  newLineItem.countryOfOrigin = lineItem.countryOfOrigin || '';
  newLineItem.originProvince = lineItem.originProvince || '';
  newLineItem.commodityCode = lineItem.commodityCode || '';
  newLineItem.htsCode = (((_lineItem$commodityCo = lineItem.commodityCode) === null || _lineItem$commodityCo === void 0 ? void 0 : _lineItem$commodityCo.length) > 8 ? (_lineItem$commodityCo2 = lineItem.commodityCode) === null || _lineItem$commodityCo2 === void 0 ? void 0 : _lineItem$commodityCo2.slice(0, 8) : lineItem.commodityCode) || '';
  newLineItem.taricCode = ((_lineItem$commodityCo3 = lineItem.commodityCode) === null || _lineItem$commodityCo3 === void 0 ? void 0 : _lineItem$commodityCo3.length) > 8 && ((_lineItem$commodityCo4 = lineItem.commodityCode) === null || _lineItem$commodityCo4 === void 0 ? void 0 : _lineItem$commodityCo4.slice(8)) || '';
  newLineItem.additionalCode1 = lineItem.additionalCode1 || '';
  newLineItem.additionalCode2 = lineItem.additionalCode2 || '';
  newLineItem.procedure = lineItem.procedure || '';
  newLineItem.exciseCode = lineItem.exciseCode || '';
  newLineItem.tariffRegime = lineItem.tariffRegime || '';
  newLineItem.unitCount = lineItem.unitCount || '';
  newLineItem.unitType = lineItem.unitType || '';
  newLineItem.packageType = lineItem.packageType || '';
  newLineItem.unitPrice = lineItem.unitPrice || '';
  newLineItem.unitValue = lineItem.unitValue || '';
  newLineItem.customValue = lineItem.customValue || '';
  newLineItem.statValue = lineItem.statValue || '';
  newLineItem.convertedUnitValue = lineItem.convertedUnitValue || '';
  newLineItem.tariffRegimeSuffix = lineItem.tariffRegimeSuffix || ''; //temporary
  newLineItem.regimeAdditionalCode = lineItem.regimeAdditionalCode || '';
  newLineItem.procedureSuffix = lineItem.procedureSuffix || "";
  newLineItem.packageCount = lineItem.packageCount || '';
  newLineItem.supUnitsQuantity = lineItem.supUnitsQuantity === "_BLANK_" ? "" : lineItem.supUnitsQuantity || '';
  newLineItem.supUnits = lineItem.supUnits === "_BLANK_" ? "" : lineItem.supUnits || '';
  newLineItem.netMass = lineItem.netMass === "0.0" || lineItem.netMass === "-999" ? "" : lineItem.netMass || '';
  newLineItem.grossMass = lineItem.grossMass === "0.0" || lineItem.grossMass === "-999" ? "" : lineItem.grossMass || '';
  newLineItem.quotaNumber = lineItem.quotaNumber === "0.0" || lineItem.quotaNumber === "-999" ? "" : lineItem.quotaNumber || '';
  newLineItem.totalAmount = lineItem.totalAmount === "0.0" || lineItem.totalAmount === "-999" ? "0.00" : lineItem.totalAmount || '0.00';
  let containers = [];
  if (lineItem.containers) {
    containers = lineItem.containers.map(mapItemConatiners);
  }
  let previousDocumentInfo = [];
  if (lineItem.previousDocumentInfo) {
    previousDocumentInfo = lineItem.previousDocumentInfo.map(mapCargoDocuments);
  }
  let lineItemDuty = [];
  if (lineItem.itemDuties) {
    lineItemDuty = lineItem.itemDuties.map(mapItemDuty);
  }
  let additionalInfo = [];
  if (lineItem.additionalInfo) {
    additionalInfo = lineItem.additionalInfo.map(mapAdditionalLineItem);
  }
  let specialMentions = [];
  if (lineItem.specialMentions) {
    specialMentions = lineItem.specialMentions.map(mapSpecialMentionInfo);
  }
  newLineItem.itemDuties = lineItemDuty;
  newLineItem.additionalInfo = additionalInfo;
  newLineItem.specialMentions = specialMentions;
  newLineItem.previousDocumentInfo = previousDocumentInfo;
  newLineItem.containers = containers;
  return newLineItem;
};
const mapItemDuty = (itemDuty, dutyIndex) => {
  let newItemDuty = merchandiseDuty();
  newItemDuty.merchandiseDutyIndex = dutyIndex;
  newItemDuty.taxType = itemDuty.taxType || '';
  newItemDuty.mopCode = itemDuty.mopCode || '';
  newItemDuty.quotaAmount = itemDuty.quotaAmount || '';
  newItemDuty.taxBase = itemDuty.taxBase === "0.0" || itemDuty.taxBase === "-999" ? "" : itemDuty.taxBase;
  newItemDuty.taxRate = itemDuty.taxRate || '';
  newItemDuty.taxAmount = itemDuty.taxAmount === "0.0" || itemDuty.taxAmount === "-999" ? "" : itemDuty.taxAmount;
  newItemDuty.merchandiseId = itemDuty.merchandiseId || '';
  newItemDuty.merchandiseDutyId = itemDuty.merchandiseDutyId || '';
  return newItemDuty;
};
const mapItemConatiners = (itemDuty, infoIndex) => {
  let newItemContainer = merchandisConatiner();
  newItemContainer.infoIndex = infoIndex;
  newItemContainer.containerId = itemDuty.containerId || '';
  newItemContainer.containerNumber = itemDuty.containerNumber;
  newItemContainer.shipmentId = itemDuty.shipmentId || '';
  newItemContainer.merchandiseId = itemDuty.merchandiseId || "";
  newItemContainer.invoiceId = itemDuty.invoiceId || '';
  return newItemContainer;
};
const mapCargoDocuments = (addinfo, infoIndex) => {
  let newInfo = cargoDocsDocs(addinfo.infoId);
  newInfo.infoIndex = infoIndex;
  newInfo.merchandiseId = addinfo.merchandiseId || '';
  newInfo.infoId = addinfo.infoId || '';
  newInfo.code = addinfo.code || '';
  newInfo.ref = addinfo.ref || '';
  newInfo.class = addinfo.class || "";
  return newInfo;
};
const mapWarranteeInfo = (addinfo, infoIndex) => {
  let newInfo = warrantyObj(addinfo.warrantyId);
  newInfo.infoIndex = infoIndex;
  newInfo.warrantyId = addinfo.warrantyId || '';
  newInfo.shipmentId = addinfo.shipmentId || '';
  newInfo.warrantyReferences = addinfo.warrantyReferences || '';
  return newInfo;
};
const mapSpecialMentionInfo = (addinfo, infoIndex) => {
  let newInfo = specialMentionsObj(addinfo.merchandiseId);
  newInfo.infoIndex = infoIndex;
  newInfo.merchandiseId = addinfo.merchandiseId || '';
  newInfo.infoId = addinfo.infoId || '';
  newInfo.code = addinfo.code || '';
  return newInfo;
};
const mapAdditionalLineItem = (addinfo, infoIndex) => {
  let lineItem = supportingDocsObj();
  lineItem.infoIndex = infoIndex;
  lineItem.merchandiseId = addinfo.merchandiseId || '';
  lineItem.infoId = addinfo.infoId || '';
  lineItem.code = addinfo.code === "_BLANK_" ? "" : addinfo.code || '';
  lineItem.ref = addinfo.ref || '';
  lineItem.documentDate = addinfo.documentDate && addinfo.documentDate || ' ';
  return lineItem;
};
const mapContainerShipmentData = (addinfo, infoIndex) => {
  let newInfo = ShipmentContainerMapper();
  newInfo.infoIndex = infoIndex;
  newInfo.containerId = addinfo.containerId || "";
  newInfo.containerNumber = addinfo.containerNumber || "";
  newInfo.shipmentId = addinfo.shipmentId || "";
  return newInfo;
};
const mapSealData = (addinfo, infoIndex) => {
  let newInfo = SealData(addinfo.id);
  newInfo.infoIndex = infoIndex;
  newInfo.id = addinfo.id || "";
  newInfo.sealId = addinfo.sealId || "";
  newInfo.sealNumber = addinfo.sealNumber || "";
  return newInfo;
};

class TotalValue extends React$1.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {
      totalInvoiceAmount,
      totalItem,
      totalShipmentPackages,
      translate
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      id: "total-footer",
      className: "total-footer"
    }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", null, translate("TOTAL_INVOICE_AMT", {
      ns: ["default", "lineItem"]
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: ""
    }, " € ", totalInvoiceAmount ? parseFloat(totalInvoiceAmount).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: 20
    }).replaceAll("£", "") : '0.00')), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "box-number"
    }, "5"), totalItem !== undefined && totalItem + " " + translate("ITEMS")), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "box-number"
    }, "6"), " ", totalShipmentPackages !== undefined && totalShipmentPackages + " " + "PKGS")));
  }
}
const mapStateToProps = (state, ownProps) => ({
  totalInvoiceAmount: state.Shipment.totalInvoiceAmount,
  totalItem: state.Shipment.totalItem,
  totalShipmentPackages: state.Shipment.totalShipmentPackages
});
const mapDispatchToProps = {};
var TotalValue$1 = connect(mapStateToProps, mapDispatchToProps)(TotalValue);

class Toast extends React__default["default"].Component {
  constructor(props) {
    super(props);
  }
  render() {
    const errorMessage = this.props;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toast"
    }, errorMessage.errorMessage);
  }
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

const TabItem = ({
  title
}) => {
  return /*#__PURE__*/React.createElement("div", null, title);
};

const Tab = ({
  activeTabIndex,
  children,
  tabHeaderClass,
  tabStripContentClass,
  translate = value => value
}) => {
  var _children$activeIndex, _children$activeIndex2;
  const [activeIndex, setActiveTabIndex] = React$1.useState(activeTabIndex || 0);
  React$1.useEffect(() => {
    if (activeTabIndex && activeTabIndex != activeIndex) {
      setActiveTabIndex(activeTabIndex);
    }
  }, [activeTabIndex]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "kn__tabstrip"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: `kn__tabstrip__header ${tabHeaderClass}`
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "kn__tabstrip__items"
  }, React__default["default"].Children.map(children, (element, index) => {
    if ((element === null || element === void 0 ? void 0 : element.type) != TabItem) return null;
    const {
      title,
      clickEvent,
      id,
      rightComp
    } = element.props;
    return /*#__PURE__*/React__default["default"].createElement("li", {
      id: id,
      className: `kn__item ${activeIndex === index ? "active" : ""}`,
      onClick: () => {
        setActiveTabIndex(index);
        clickEvent && clickEvent();
      },
      style: {
        color: activeIndex === index ? "white" : "",
        fontWeight: "bold",
        backgroundColor: activeIndex === index ? "#318192" : "rgb(200 222 226)"
      }
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "kn__item-title"
    }, translate(title.toUpperCase())), rightComp);
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: `kn__tabstrip__Content ${tabStripContentClass}`
  }, (_children$activeIndex = children[activeIndex]) === null || _children$activeIndex === void 0 ? void 0 : (_children$activeIndex2 = _children$activeIndex.props) === null || _children$activeIndex2 === void 0 ? void 0 : _children$activeIndex2.children));
};

const ActorContext = /*#__PURE__*/React__default["default"].createContext();
const ActorProvider = ({
  children
}) => {
  const CountryList = useSelector(state => state.DropDownValues.countryCodes);
  const dispatch = useDispatch();
  const actions = React$1.useMemo(() => ({
    representations: repTypeList,
    CountryList,
    saveActorDetails: payload => dispatch(saveActorDetails(payload)),
    updateActorFieldValue: (actorType, payload) => dispatch(updateActorFieldValue(actorType, payload))
  }), [repTypeList, CountryList, saveActorDetails, updateActorFieldValue]);
  return /*#__PURE__*/React__default["default"].createElement(ActorContext.Provider, {
    value: actions
  }, children);
};

const ErrorMessage = ({
  children
}) => {
  return /*#__PURE__*/React__default["default"].createElement("center", {
    style: {
      position: "relative",
      top: "50vh"
    }
  }, children, /*#__PURE__*/React__default["default"].createElement("i", {
    className: "frown outline icon"
  }));
};

const CustomLoader = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, _extends$1({
    indeterminate: true,
    active: true,
    size: "medium"
  }, rest), children);
};

const InvoiceForm = /*#__PURE__*/React__default["default"].lazy(() => Promise.resolve().then(function () { return require('./index-4cb05922.js'); }));
const PartiesForm = /*#__PURE__*/React__default["default"].lazy(() => Promise.resolve().then(function () { return require('./index-b97a31b7.js'); }));
const ValueBuildUpTab = /*#__PURE__*/React__default["default"].lazy(() => Promise.resolve().then(function () { return require('./index-3e35a4e5.js'); }));
const ValidateError = /*#__PURE__*/React__default["default"].lazy(() => Promise.resolve().then(function () { return validateError; }).then(module => ({
  default: module.ValidateError
})));
const NotesTab = /*#__PURE__*/React__default["default"].lazy(() => Promise.resolve().then(function () { return require('./NotesTab-390a478d.js'); }));
const ESForm = props => {
  var _props$jobWheels$ES_E, _props$jobWheels$ES_E2, _props$jobWheels$ES_C, _props$jobWheels$ES_C2, _props$jobWheels$CUST, _props$jobWheels$CUST2, _props$jobWheels$SHIP, _props$jobWheels$SHIP2;
  const isdrodpownAlreadyFilled = React$1.useRef(false);
  const [loader, setLoader] = React$1.useState(false);
  const [error, setError] = React$1.useState(false);
  const errorMessage = useSelector(state => state.FormValues.errorMessage);
  const {
    declarationType,
    serviceType,
    translate,
    shipId
  } = props;
  const dispatch = useDispatch();
  React$1.useEffect(() => {
    if (!isdrodpownAlreadyFilled.current) {
      const intiliazeDropDowns = async () => {
        try {
          const response = await getDropdownValues$1().catch(err => console.log(err));
          dispatch(initializeDropDownValues$1(response.data.eventMessage));
          isdrodpownAlreadyFilled.current = true;
        } catch (err) {}
      };
      intiliazeDropDowns();
    }
  }, []);
  React$1.useEffect(() => {
    const getData = async () => {
      setLoader(true);
      setError('');
      try {
        const response = await getESForm(shipId);
        const {
          eventMessage
        } = response.data;
        window.shipmentId = shipId;
        let values = assignESValues(eventMessage);
        let completeData = convertedDataHeaderTab$1(eventMessage);
        let Errors = createHeaderWarningsList(completeData, 'headerTab', translate, serviceType, pdiValidationCheck); //
        dispatch(intializeHeaderTabWarnings('headerTab', Errors));
        completeData = convertedDataPartiesTab$1(eventMessage);
        Errors = createPartiesWarningsList(completeData, "partiesTab", translate, serviceType, pdiValidationCheck);
        dispatch(intializePartiesTabWarnings('partiesTab', Errors));
        completeData = convertedDataItemsTab$1(eventMessage, 'itemsTab', translate, false, serviceType, pdiValidationCheck);
        dispatch(intializeItemsTabWarnings('itemsTab', completeData));

        // error handling End

        dispatch(initializeAllValues(values, declarationType));
        setLoader(false);
      } catch (e) {
        console.log(e);
        setLoader(false);
        setError(e);
      }
    };
    getData();
    return () => {
      dispatch(resetServerErrors());
      dispatch(clearForm$2());
    };
  }, [shipId]);
  const kxUserBasicInfo = get_1(props, 'kxUserBasicInfo', {});
  let currentJobState = ((_props$jobWheels$ES_E = props.jobWheels['ES_ENTRY_JOB_WHEEL']) === null || _props$jobWheels$ES_E === void 0 ? void 0 : (_props$jobWheels$ES_E2 = _props$jobWheels$ES_E.value) === null || _props$jobWheels$ES_E2 === void 0 ? void 0 : _props$jobWheels$ES_E2.state) || '';
  let customJobState = ((_props$jobWheels$ES_C = props.jobWheels['ES_CUSTOM_JOB_WHEEL']) === null || _props$jobWheels$ES_C === void 0 ? void 0 : (_props$jobWheels$ES_C2 = _props$jobWheels$ES_C.value) === null || _props$jobWheels$ES_C2 === void 0 ? void 0 : _props$jobWheels$ES_C2.state) || '';
  let currentJobCircuitState = ((_props$jobWheels$CUST = props.jobWheels['CUSTOM_RELEASE_WHEEL']) === null || _props$jobWheels$CUST === void 0 ? void 0 : (_props$jobWheels$CUST2 = _props$jobWheels$CUST.value) === null || _props$jobWheels$CUST2 === void 0 ? void 0 : _props$jobWheels$CUST2.state) || '';
  let brokerHouseState = props.jobWheels ? (_props$jobWheels$SHIP = props.jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']) === null || _props$jobWheels$SHIP === void 0 ? void 0 : (_props$jobWheels$SHIP2 = _props$jobWheels$SHIP.value) === null || _props$jobWheels$SHIP2 === void 0 ? void 0 : _props$jobWheels$SHIP2.state : '';
  const isFormDisabled = isShipmentDisabled(currentJobState, customJobState, currentJobCircuitState, brokerHouseState);
  const serverErrors = useSelector(state => state.ServerErrorReducer.serverErrors);
  const pdiValidationCheck = customJobState === null || customJobState === void 0 ? void 0 : customJobState.includes('PDI');
  let content;
  if (error) content = /*#__PURE__*/React__default["default"].createElement(ErrorMessage, null, "An Error Occured In Loading ES Form`");else if (loader) content = /*#__PURE__*/React__default["default"].createElement(CustomLoader, null, translate('PREPARING_ENTRY_RELEASE'), " & ", translate('SUMMARY'), ' ');else {
    content = /*#__PURE__*/React__default["default"].createElement(ErrorBoundary, null, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        marginTop: '5px'
      },
      className: "tabContainer C88"
    }, /*#__PURE__*/React__default["default"].createElement(TranslateContextProvider, {
      translate: translate
    }, /*#__PURE__*/React__default["default"].createElement(ShipmentInfoProvider, {
      shipmentId: props.shipId,
      jobWheels: props.jobWheels,
      customJobState: customJobState,
      currentJobState: currentJobState,
      deleteEvent: DELETE_ENTITY_ES,
      saveEvent: SAVE_FORM_ES,
      serviceType: serviceType
    }, /*#__PURE__*/React__default["default"].createElement(RubberBindingInfoProvider, {
      rubberBindingInfo: props.rubberBindingInfo
    }, /*#__PURE__*/React__default["default"].createElement(ActorProvider, null, /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
      fallback: /*#__PURE__*/React__default["default"].createElement("div", null, "Loading...")
    }, serverErrors && /*#__PURE__*/React__default["default"].createElement(ValidateError, {
      serverErrors: serverErrors
    }), /*#__PURE__*/React__default["default"].createElement(Tab, {
      className: "euForm",
      translate: translate
    }, /*#__PURE__*/React__default["default"].createElement(TabItem, {
      id: "headerTab",
      title: "Header"
    }, /*#__PURE__*/React__default["default"].createElement(HeaderForm$1, _extends$1({}, props, {
      currentJobCircuitState: currentJobCircuitState,
      isFormDisabled: isFormDisabled
    }))), /*#__PURE__*/React__default["default"].createElement(TabItem, {
      id: "partiesTab",
      title: "Parties"
    }, /*#__PURE__*/React__default["default"].createElement(PartiesForm, _extends$1({}, props, {
      isFormDisabled: isFormDisabled
    }))), /*#__PURE__*/React__default["default"].createElement(TabItem, {
      id: "ValueBuildUpTab",
      title: "Value Build Up"
    }, /*#__PURE__*/React__default["default"].createElement(ValueBuildUpTab, props)), /*#__PURE__*/React__default["default"].createElement(TabItem, {
      id: "itemsTab",
      title: "Items"
    }, /*#__PURE__*/React__default["default"].createElement(InvoiceForm, _extends$1({}, props, {
      isFormDisabled: isFormDisabled
    }))), /*#__PURE__*/React__default["default"].createElement(TabItem, {
      id: "notesTab",
      title: "Notes"
    }, /*#__PURE__*/React__default["default"].createElement(NotesTab, {
      kxUserBasicInfo: kxUserBasicInfo,
      isFormDisabled: isFormDisabled,
      shipId: shipId,
      fullName: get_1(kxUserBasicInfo, 'fullName', ''),
      translate: translate
    })))), /*#__PURE__*/React__default["default"].createElement(Toast, {
      errorMessage: errorMessage
    }), /*#__PURE__*/React__default["default"].createElement(TotalValue$1, {
      declarationTypeValue: declarationType,
      translate: translate
    })))))));
  }
  return content;
};
var ESForm$1 = /*#__PURE__*/React__default["default"].memo(ESForm);

var pulseCircle = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22512%22%20height%3D%22512%22%20viewBox%3D%220%200%20510%20510%22%3E%3Cpath%20d%3D%22M255%200C114.75%200%200%20114.75%200%20255s114.75%20255%20255%20255%20255-114.75%20255-255S395.25%200%20255%200z%22%20fill%3D%22%234e9bf8%22%2F%3E%3Cg%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M229.5%20127.5h51v255h-51z%22%2F%3E%3Cpath%20d%3D%22M127.5%20280.5v-51h255v51z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var pluseWhite = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon-Expand%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-1021.000000%2C%20-1996.000000%29%22%20fill%3D%22%23379BFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29%22%20transform%3D%22translate%28996.000000%2C%201723.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22BOL-%2F-AWB%22%20transform%3D%22translate%28-8.000000%2C%20255.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M41.000125%2C18%20C38.8631584%2C18%2036.8541898%2C18.832487%2035.3434634%2C20.3434634%20C33.832237%2C21.8544398%2033%2C23.8631584%2033%2C25.999875%20C33%2C28.1368416%2033.832237%2C30.1455602%2035.3434634%2C31.6562866%20C36.8541898%2C33.167513%2038.8631584%2C34%2041.000125%2C34%20C43.1365916%2C34%2045.1455602%2C33.167513%2046.6565366%2C31.6565366%20C48.167763%2C30.1455602%2049%2C28.1368416%2049%2C25.999875%20C49%2C23.8631584%2048.167763%2C21.8544398%2046.6565366%2C20.3437134%20C45.1455602%2C18.832487%2043.1365916%2C18%2041.000125%2C18%20L41.000125%2C18%20Z%20M45.9495477%2C30.9492977%20C44.6273183%2C32.271777%2042.8695958%2C33.0000156%2041.000125%2C33.0000156%20C39.1301542%2C33.0000156%2037.3724317%2C32.271777%2036.0504523%2C30.9492977%20C34.728223%2C29.6273183%2033.9999844%2C27.8695958%2033.9999844%2C25.999875%20C33.9999844%2C24.1304042%2034.728223%2C22.3726817%2036.0504523%2C21.0507023%20C37.3724317%2C19.728223%2039.1301542%2C18.9999844%2041.000125%2C18.9999844%20C42.8695958%2C18.9999844%2044.6273183%2C19.728223%2045.9495477%2C21.0507023%20C47.271777%2C22.3726817%2048.0000156%2C24.1304042%2048.0000156%2C25.999875%20C48.0000156%2C27.8695958%2047.271777%2C29.6273183%2045.9495477%2C30.9492977%20L45.9495477%2C30.9492977%20Z%20M45.4998047%2C25.4998828%20L41.5001172%2C25.4998828%20L41.5001172%2C21.5001953%20C41.5001172%2C21.2239496%2041.2761207%2C21.0002031%2041.000125%2C21.0002031%20C40.7238793%2C21.0002031%2040.5001328%2C21.2239496%2040.5001328%2C21.5001953%20L40.5001328%2C25.4998828%20L36.5001953%2C25.4998828%20C36.2239496%2C25.4998828%2036.0002031%2C25.7238793%2036.0002031%2C25.999875%20C36.0002031%2C26.2761207%2036.2239496%2C26.4998672%2036.5001953%2C26.4998672%20L40.5001328%2C26.4998672%20L40.5001328%2C30.4998047%20C40.5001328%2C30.7760504%2040.7238793%2C30.9997969%2041.000125%2C30.9997969%20C41.2761207%2C30.9997969%2041.5001172%2C30.7760504%2041.5001172%2C30.4998047%20L41.5001172%2C26.4998672%20L45.4998047%2C26.4998672%20C45.7760504%2C26.4998672%2045.9997969%2C26.2761207%2045.9997969%2C25.999875%20C45.9997969%2C25.7238793%2045.7760504%2C25.4998828%2045.4998047%2C25.4998828%20L45.4998047%2C25.4998828%20Z%22%20id%3D%22Icon-Expand%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var whiteChecked = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22512%22%20height%3D%22512%22%20viewBox%3D%220%200%20442.533%20442.533%22%3E%3Cpath%20d%3D%22M434.539%2098.499l-38.828-38.828c-5.324-5.328-11.799-7.993-19.41-7.993-7.618%200-14.093%202.665-19.417%207.993L169.59%20247.248l-83.939-84.225c-5.33-5.33-11.801-7.992-19.412-7.992-7.616%200-14.087%202.662-19.417%207.992L7.994%20201.852C2.664%20207.181%200%20213.654%200%20221.269c0%207.609%202.664%2014.088%207.994%2019.416l103.351%20103.349%2038.831%2038.828c5.327%205.332%2011.8%207.994%2019.414%207.994%207.611%200%2014.084-2.669%2019.414-7.994l38.83-38.828L434.539%20137.33c5.325-5.33%207.994-11.802%207.994-19.417.004-7.611-2.669-14.084-7.994-19.414z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E";

var close = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon-Cancel%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20fill-opacity%3D%220.33%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-1660.000000%2C%20-1750.000000%29%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29%22%20transform%3D%22translate%28996.000000%2C%201723.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Header%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M672.88%2C34%20L678.6%2C28.28%20C678.853333%2C28.04%20679%2C27.7066667%20679%2C27.3333333%20C679%2C26.6%20678.4%2C26%20677.666667%2C26%20C677.293333%2C26%20676.96%2C26.1466667%20676.72%2C26.3866667%20L671%2C32.12%20L665.28%2C26.3866667%20C665.04%2C26.1466667%20664.706667%2C26%20664.333333%2C26%20C663.6%2C26%20663%2C26.6%20663%2C27.3333333%20C663%2C27.7066667%20663.146667%2C28.04%20663.386667%2C28.28%20L669.12%2C34%20L663.4%2C39.72%20C663.146667%2C39.96%20663%2C40.2933333%20663%2C40.6666667%20C663%2C41.4%20663.6%2C42%20664.333333%2C42%20C664.706667%2C42%20665.04%2C41.8533333%20665.28%2C41.6133333%20L671%2C35.88%20L676.72%2C41.6%20C676.96%2C41.8533333%20677.293333%2C42%20677.666667%2C42%20C678.4%2C42%20679%2C41.4%20679%2C40.6666667%20C679%2C40.2933333%20678.853333%2C39.96%20678.613333%2C39.72%20L672.88%2C34%20Z%22%20id%3D%22Icon-Cancel%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var search = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2217px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2017%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EShape%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-1348.000000%2C%20-1753.000000%29%22%20fill%3D%22%239B9B9B%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29%22%20transform%3D%22translate%28996.000000%2C%201723.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Header%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22search%22%20transform%3D%22translate%28338.000000%2C%2019.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M29.0338316%2C23.952%20L25.0286061%2C20%20C25.7339798%2C18.968%2026.1474747%2C17.736%2026.1474747%2C16.4%20C26.1474747%2C12.864%2023.2449024%2C10%2019.6612795%2C10%20C16.0776566%2C10%2013.1750842%2C12.864%2013.1750842%2C16.4%20C13.1750842%2C19.936%2016.0776566%2C22.8%2019.6612795%2C22.8%20C21.0152727%2C22.8%2022.2638653%2C22.392%2023.3097643%2C21.696%20L27.3149899%2C25.648%20C27.533899%2C25.864%2027.8419933%2C26%2028.1744108%2C26%20C28.8473535%2C26%2029.3905724%2C25.464%2029.3905724%2C24.8%20C29.3905724%2C24.472%2029.2527407%2C24.168%2029.0338316%2C23.952%20Z%20M19.6612795%2C21.2%20C16.9776162%2C21.2%2014.796633%2C19.048%2014.796633%2C16.4%20C14.796633%2C13.752%2016.9776162%2C11.6%2019.6612795%2C11.6%20C22.3449428%2C11.6%2024.5259259%2C13.752%2024.5259259%2C16.4%20C24.5259259%2C19.048%2022.3449428%2C21.2%2019.6612795%2C21.2%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var info_icon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2212px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2012%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon_info%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-1641.000000%2C%20-2100.000000%29%22%20fill%3D%22%2310161A%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29%22%20transform%3D%22translate%28996.000000%2C%201723.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Description%22%20transform%3D%22translate%28-10.000000%2C%20299.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Importer%22%20transform%3D%22translate%28416.000000%2C%2047.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Name%22%20transform%3D%22translate%280.000000%2C%2016.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M245%2C27%20C241.686292%2C27%20239%2C24.3137085%20239%2C21%20C239%2C17.6862915%20241.686292%2C15%20245%2C15%20C248.313708%2C15%20251%2C17.6862915%20251%2C21%20C251%2C24.3137085%20248.313708%2C27%20245%2C27%20Z%20M245%2C25.8%20C247.650967%2C25.8%20249.8%2C23.6509668%20249.8%2C21%20C249.8%2C18.3490332%20247.650967%2C16.2%20245%2C16.2%20C242.349033%2C16.2%20240.2%2C18.3490332%20240.2%2C21%20C240.2%2C23.6509668%20242.349033%2C25.8%20245%2C25.8%20Z%20M245.6%2C24.6%20L244.4%2C24.6%20L244.4%2C23.4%20L245.6%2C23.4%20L245.6%2C24.6%20Z%20M245.6%2C22.8%20L244.4%2C22.8%20L244.4%2C17.4%20L245.6%2C17.4%20L245.6%2C22.8%20Z%22%20id%3D%22Icon_info%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var info_more_icon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2225px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2025%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon_More_info%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-2473.000000%2C%20-3586.000000%29%22%20fill%3D%22%239B9B9B%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29---1%22%20transform%3D%22translate%281827.000000%2C%2095.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Description%22%20transform%3D%22translate%286.000000%2C%202848.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Goods-2%22%20transform%3D%22translate%2831.000000%2C%20322.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Goods-1%22%20transform%3D%22translate%2835.000000%2C%20110.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22More-Details%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Free-Trade-Aggrement%22%20transform%3D%22translate%2821.000000%2C%20204.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Learn-more%22%20transform%3D%22translate%28544.000000%2C%207.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2C2.60439306%20C9%2C2.05895796%209.44662583%2C1.61233213%209.99206092%2C1.61233213%20L14.357625%2C1.61233213%20C14.9030601%2C1.61233213%2015.3496859%2C2.05895796%2015.3496859%2C2.60439306%20C15.3496859%2C3.14982815%2014.9030601%2C3.59645398%2014.357625%2C3.59645398%20L9.99206092%2C3.59645398%20C9.44662583%2C3.59645398%209%2C3.14982815%209%2C2.60439306%20Z%20M9.99206092%2C7.54039217%20L14.357625%2C7.54039217%20C14.9030601%2C7.54039217%2015.3496859%2C7.09376635%2015.3496859%2C6.54833125%20C15.3496859%2C6.00289616%2014.9030601%2C5.55627033%2014.357625%2C5.55627033%20L9.99206092%2C5.55627033%20C9.44662583%2C5.55627033%209%2C6.00289616%209%2C6.54833125%20C9%2C7.09376635%209.44662583%2C7.54039217%209.99206092%2C7.54039217%20Z%20M9.99206092%2C11.4833383%20L14.357625%2C11.4833383%20C14.9030601%2C11.4833383%2015.3496859%2C11.0367125%2015.3496859%2C10.4912774%20C15.3496859%2C9.94584229%2014.9030601%2C9.49921647%2014.357625%2C9.49921647%20L9.99206092%2C9.49921647%20C9.44662583%2C9.49921647%209%2C9.94584229%209%2C10.4912774%20C9%2C11.0367125%209.44662583%2C11.4833383%209.99206092%2C11.4833383%20Z%20M33.1078245%2C2.15746961%20L33.1078245%2C10.9367127%20C33.1078245%2C12.1273843%2032.1409619%2C13.0942468%2030.9502904%2C13.0942468%20L25.0222303%2C13.0952141%20C25.0222303%2C13.0952141%2025.0222303%2C13.1204025%2024.9970419%2C13.1204025%20L22.2445689%2C15.8728756%20C21.9713553%2C16.1460891%2021.5005232%2C15.9474736%2021.5005232%2C15.5754557%20L21.5005232%2C13.0953034%20L19.3177907%2C13.0953034%20C18.1271192%2C13.0953034%2017.1602566%2C12.1284408%2017.1602566%2C10.9377693%20L17.1602566%2C2.15753409%20C17.1602566%2C0.966862575%2018.1271192%2C0%2019.3177907%2C0%20L30.9745066%2C0%20C32.1399797%2C0%2033.1078344%2C0.967829834%2033.1078344%2C2.15753409%20L33.1078245%2C2.15746961%20Z%20M24.1289291%2C3.86934514%20C24.1289291%2C4.3653756%2024.5261503%2C4.73739844%2024.9969824%2C4.73739844%20C25.4930128%2C4.73739844%2025.8650357%2C4.34017725%2025.8650357%2C3.86934514%20C25.8650357%2C3.37331467%2025.4678145%2C3.00129183%2024.9969824%2C3.00129183%20C24.5261503%2C3.00129183%2024.1289291%2C3.37331467%2024.1289291%2C3.86934514%20Z%20M26.3368351%2C8.90430233%20L25.8902092%2C8.90430233%20L25.8902092%2C5.35743652%20L23.9060874%2C5.35743652%20L23.9060874%2C6.52290969%20L24.3527132%2C6.52290969%20L24.3527132%2C8.90425273%20L23.9060874%2C8.90425273%20L23.9060874%2C10.0697259%20L26.3368351%2C10.0697259%20L26.3368351%2C8.90430233%20Z%22%20id%3D%22Icon_More_info%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var calender_icon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EFill%201%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-2168.000000%2C%20-1578.000000%29%22%20fill%3D%22%23A2A2A2%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29---1%22%20transform%3D%22translate%281827.000000%2C%2095.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Type%22%20transform%3D%22translate%282.000000%2C%201223.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Form%22%20transform%3D%22translate%2852.000000%2C%2057.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Number%22%20transform%3D%22translate%280.000000%2C%20191.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M291.2%2C14.5666667%20C291.2%2C14.9555556%20290.888889%2C15.2666667%20290.5%2C15.2666667%20C290.111111%2C15.2666667%20289.8%2C14.9555556%20289.8%2C14.5666667%20L289.8%2C12.7%20C289.8%2C12.3111111%20290.111111%2C12%20290.5%2C12%20C290.888889%2C12%20291.2%2C12.3111111%20291.2%2C12.7%20L291.2%2C14.5666667%20Z%20M298.044444%2C12.7%20C298.044444%2C12.3111111%20297.733333%2C12%20297.344444%2C12%20C296.955556%2C12%20296.644444%2C12.3111111%20296.644444%2C12.7%20L296.644444%2C14.5666667%20C296.644444%2C14.9555556%20296.955556%2C15.2666667%20297.344444%2C15.2666667%20C297.733333%2C15.2666667%20298.044444%2C14.9555556%20298.044444%2C14.5666667%20L298.044444%2C12.7%20Z%20M301%2C14.4730222%20L301%2C25.2222222%20C301%2C25.6420973%20300.657902%2C25.9841951%20300.222222%2C25.9841951%20L287.777778%2C25.9841951%20C287.342098%2C25.9841951%20287%2C25.6420973%20287%2C25.2222222%20L287%2C14.4730222%20C287%2C14.0531467%20287.342098%2C13.7110489%20287.777778%2C13.7110489%20L289.333333%2C13.7110489%20L289.333333%2C14.5666044%20C289.333333%2C15.2356178%20289.830987%2C15.7642578%20290.5%2C15.7642578%20C291.169013%2C15.7642578%20291.666667%2C15.2198133%20291.666667%2C14.5666044%20L291.666667%2C13.7110489%20L296.177778%2C13.7110489%20L296.177778%2C14.5666044%20C296.177778%2C15.2356178%20296.675431%2C15.7642578%20297.344444%2C15.7642578%20C298.013458%2C15.7642578%20298.511111%2C15.2198133%20298.511111%2C14.5666044%20L298.511111%2C13.7110489%20L300.206356%2C13.7110489%20C300.626838%2C13.7110489%20300.999938%2C14.0531467%20300.999938%2C14.4730222%20L301%2C14.4730222%20Z%20M299.755556%2C17.2730222%20C299.755556%2C17.1174667%20299.615798%2C16.9777156%20299.444444%2C16.9777156%20L288.555556%2C16.9777156%20C288.384196%2C16.9777156%20288.244444%2C17.1022813%20288.244444%2C17.2730222%20L288.244444%2C24.4595333%20C288.244444%2C24.6150889%20288.384202%2C24.75484%20288.555556%2C24.75484%20L299.444444%2C24.75484%20C299.615804%2C24.75484%20299.755556%2C24.6302742%20299.755556%2C24.4595333%20L299.755556%2C17.2730222%20Z%22%20id%3D%22Fill-1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var external_link = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2212px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2012%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3ELink%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Details%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-Release-%26amp%3B-Summary%22%20transform%3D%22translate%28-2113.000000%2C%20-3644.000000%29%22%20fill%3D%22%23379BFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Entry-%26amp%3B-Release-Summary-%28Full%29---1%22%20transform%3D%22translate%281827.000000%2C%2095.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Description%22%20transform%3D%22translate%286.000000%2C%202848.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Goods-2%22%20transform%3D%22translate%2831.000000%2C%20322.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Goods-1%22%20transform%3D%22translate%2835.000000%2C%20110.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22More-Details%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Rulings%22%20transform%3D%22translate%2821.000000%2C%20264.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Link%22%20transform%3D%22translate%28193.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.6279091%2C6.20509091%20L10.6279091%2C7.31038636%20L10.6279091%2C8.98029545%20C10.6279091%2C9.16566818%2010.6332368%2C9.35049545%2010.6092655%2C9.53427273%20C10.6172564%2C9.47567864%2010.6252459%2C9.41601955%2010.6332355%2C9.35742273%20C10.6076673%2C9.53586818%2010.5613255%2C9.70791818%2010.4920718%2C9.87411818%20C10.5144436%2C9.82085182%2010.5373486%2C9.76758409%2010.5586555%2C9.71537727%20C10.4894086%2C9.87624545%2010.4015236%2C10.0285909%2010.2949827%2C10.1670818%20C10.3296068%2C10.121805%2010.3642295%2C10.0775932%2010.3988536%2C10.0328482%20C10.2923195%2C10.1702755%2010.16874%2C10.2938618%2010.0313127%2C10.4003891%20C10.0765895%2C10.365765%2010.1208014%2C10.3311423%2010.1655464%2C10.2965182%20C10.0259918%2C10.4030523%209.87524182%2C10.4925409%209.71384182%2C10.5601909%20C9.76710818%2C10.5378191%209.82037591%2C10.5149141%209.87258273%2C10.4936073%20C9.70746%2C10.5628541%209.53433273%2C10.6091973%209.35588727%2C10.6347709%20C9.41448136%2C10.6267814%209.47414045%2C10.6187905%209.53273727%2C10.6108009%20C9.25467818%2C10.6470218%208.96384182%2C10.6294445%208.68471909%2C10.6294445%20L7.09199182%2C10.6294445%20L5.13708273%2C10.6294445%20L3.46976455%2C10.6294445%20C3.22740545%2C10.6294445%202.98503273%2C10.6305095%202.74426909%2C10.6294445%20C2.65105227%2C10.6294445%202.55889636%2C10.6230532%202.46728727%2C10.6108009%20C2.52588136%2C10.6187918%202.58554045%2C10.6267814%202.64413727%2C10.6347709%20C2.46569182%2C10.6092027%202.29364182%2C10.5628609%202.12744182%2C10.4936073%20C2.18070955%2C10.5159791%202.23397591%2C10.5388841%202.28618273%2C10.5601909%20C2.12531455%2C10.4909441%201.97296909%2C10.4030591%201.83447818%2C10.2965182%20C1.879755%2C10.3311423%201.92396682%2C10.365765%201.96871182%2C10.4003891%20C1.83128455%2C10.293855%201.70769818%2C10.1702755%201.60117091%2C10.0328482%20C1.635795%2C10.078125%201.67041773%2C10.1223368%201.70504182%2C10.1670818%20C1.59850773%2C10.0275273%201.50901909%2C9.87677727%201.44136909%2C9.71537727%20C1.46374091%2C9.76864364%201.48664591%2C9.82191136%201.50795273%2C9.87411818%20C1.43870591%2C9.70899545%201.39236273%2C9.53586818%201.36678909%2C9.35742273%20C1.37478%2C9.41601682%201.38276955%2C9.47567591%201.39075909%2C9.53427273%20C1.35453818%2C9.25621364%201.37211545%2C8.96537727%201.37211545%2C8.68625455%20L1.37211545%2C7.09352727%20L1.37211545%2C5.13861818%20L1.37211545%2C3.4713%20C1.37211545%2C3.22894091%201.37105045%2C2.98656818%201.37211545%2C2.74580455%20C1.37211545%2C2.65258773%201.37850818%2C2.56043182%201.39075909%2C2.46882273%20C1.38276955%2C2.52741682%201.37477864%2C2.58707591%201.36678909%2C2.64567273%20C1.39235727%2C2.46722727%201.43869909%2C2.29517727%201.50795273%2C2.12897727%20C1.48558091%2C2.18224364%201.46267591%2C2.23551136%201.44136909%2C2.28771818%20C1.51061591%2C2.12685%201.59850091%2C1.97450455%201.70504182%2C1.83601364%20C1.67041773%2C1.88129045%201.635795%2C1.92550227%201.60117091%2C1.97024727%20C1.707705%2C1.83282%201.83128455%2C1.70923364%201.96871182%2C1.60270636%20C1.923435%2C1.63733045%201.87922318%2C1.67195318%201.83447818%2C1.70657727%20C1.97403273%2C1.60004318%202.12478273%2C1.51055455%202.28618273%2C1.44290455%20C2.23291636%2C1.46527636%202.17964864%2C1.48818136%202.12744182%2C1.50948818%20C2.29256455%2C1.44024136%202.46569182%2C1.39389818%202.64413727%2C1.36832455%20C2.58554318%2C1.37631545%202.52588409%2C1.384305%202.46728727%2C1.39229455%20C2.62815545%2C1.37098773%202.79115091%2C1.37365091%202.95308273%2C1.37365091%20L3.66046909%2C1.37365091%20L5.38737818%2C1.37365091%20L5.79646909%2C1.37365091%20C5.96692364%2C1.37365091%206.14696455%2C1.29907636%206.26787818%2C1.17922364%20C6.38346818%2C1.06363364%206.47029636%2C0.874532727%206.46230545%2C0.707814545%20C6.45431591%2C0.536296364%206.398385%2C0.357319091%206.26787818%2C0.236405455%20C6.13737409%2C0.116554091%205.97757364%2C0.0419781818%205.79646909%2C0.0419781818%20L4.78706455%2C0.0419781818%20L3.15288273%2C0.0419781818%20L2.75603727%2C0.0419781818%20C2.31925091%2C0.0419781818%201.90270091%2C0.148512273%201.51225091%2C0.340273636%20C1.07546455%2C0.554937273%200.70686%2C0.911296364%200.447973909%2C1.32038727%20C0.181642091%2C1.74119182%200.0442148182%2C2.24723727%200.0431375455%2C2.74375091%20C0.0420722727%2C2.93018727%200.0431375455%2C3.11662364%200.0431375455%2C3.30412364%20L0.0431375455%2C4.67839636%20L0.0431375455%2C6.40694182%20L0.0431375455%2C8.02898727%20L0.0431375455%2C9.08474182%20L0.0431375455%2C9.25785545%20C0.0442029545%2C9.72766909%200.168315273%2C10.19961%200.402687409%2C10.6065736%20C0.879428182%2C11.4375464%201.79032364%2C11.9568874%202.74650545%2C11.9595601%20C2.95317818%2C11.9606255%203.15931909%2C11.9595601%203.36547364%2C11.9595601%20L4.77165545%2C11.9595601%20L6.50551909%2C11.9595601%20L8.10779182%2C11.9595601%20L9.11880545%2C11.9595601%20C9.17739955%2C11.9595601%209.23705864%2C11.9606255%209.29565545%2C11.9595601%20C9.79210091%2C11.949972%2010.3024009%2C11.806151%2010.7179282%2C11.5307647%20C11.1216873%2C11.2628373%2011.4743236%2C10.8926236%2011.6809964%2C10.4510373%20C11.8594418%2C10.0664509%2011.9606509%2C9.66801%2011.9606509%2C9.24187364%20L11.9606509%2C8.05668273%20L11.9606509%2C6.48427364%20L11.9606509%2C6.20621455%20C11.9606509%2C6.03576%2011.8860764%2C5.85571909%2011.7662236%2C5.73480545%20C11.6506336%2C5.61921545%2011.4615327%2C5.53238727%2011.2948145%2C5.54037818%20C11.1232964%2C5.54836909%2010.9443191%2C5.60429864%2010.8234055%2C5.73480545%20C10.7035541%2C5.86424455%2010.6279145%2C6.02404636%2010.6279145%2C6.20515091%20L10.6279091%2C6.20509091%20Z%22%20id%3D%22Fill-1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.33740909%2C1.37209091%20L9.33722727%2C1.37209091%20L10.9299545%2C1.37209091%20L11.2932409%2C1.37209091%20C11.4636955%2C1.37209091%2011.6437364%2C1.29751636%2011.76465%2C1.17766364%20C11.88024%2C1.06207364%2011.9670682%2C0.872972727%2011.9590773%2C0.706254545%20C11.9510864%2C0.534736364%2011.8951568%2C0.355759091%2011.76465%2C0.234845455%20C11.6341459%2C0.114994091%2011.4743455%2C0.0404181818%2011.2932409%2C0.0404181818%20L10.2934227%2C0.0404181818%20L8.70069545%2C0.0404181818%20L8.33740909%2C0.0404181818%20C8.16695455%2C0.0404181818%207.98691364%2C0.114992727%207.866%2C0.234845455%20C7.75041%2C0.350435455%207.66358182%2C0.539536364%207.67157273%2C0.706254545%20C7.67956227%2C0.877772727%207.73549318%2C1.05675%207.866%2C1.17766364%20C7.99650409%2C1.29644864%208.15736818%2C1.37209091%208.33740909%2C1.37209091%20Z%22%20id%3D%22Fill-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.9595%2C3.66259091%20L11.9595%2C2.66277273%20L11.9595%2C1.07004545%20L11.9595%2C0.706759091%20C11.9595%2C0.536304545%2011.8849255%2C0.356263636%2011.7650727%2C0.23535%20C11.6494827%2C0.11976%2011.4603818%2C0.0329318182%2011.2936636%2C0.0409227273%20C11.1221455%2C0.0489136364%2010.9431682%2C0.104843182%2010.8222545%2C0.23535%20C10.7024032%2C0.365854091%2010.6278273%2C0.525654545%2010.6278273%2C0.706759091%20L10.6278273%2C1.70657727%20L10.6278273%2C3.29930455%20L10.6278273%2C3.66259091%20C10.6278273%2C3.83304545%2010.7024018%2C4.01308636%2010.8222545%2C4.134%20C10.9378445%2C4.24959%2011.1269455%2C4.33641818%2011.2936636%2C4.32842727%20C11.4651818%2C4.32043773%2011.6441591%2C4.26450682%2011.7650727%2C4.134%20C11.8833259%2C4.00349591%2011.9595%2C3.84263182%2011.9595%2C3.66259091%20Z%22%20id%3D%22Fill-3%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M6.48204545%2C6.45913636%20C6.65783182%2C6.28335%206.83466818%2C6.10651364%207.01098636%2C5.93019545%20C7.43072727%2C5.51045455%207.85154545%2C5.08963636%208.27075455%2C4.67042727%20L11.1151636%2C1.82601818%20C11.3282318%2C1.61295%2011.5450227%2C1.40094545%2011.7554318%2C1.18575%20C11.758095%2C1.18308682%2011.7607582%2C1.18042364%2011.7650195%2C1.17616227%20C11.8864677%2C1.05471409%2011.9594468%2C0.876803182%2011.9594468%2C0.704753182%20C11.9594468%2C0.540694091%2011.8875368%2C0.346798636%2011.7650195%2C0.233344091%20C11.6382436%2C0.117754091%2011.4720559%2C0.0309259091%2011.2936105%2C0.0389168182%20C11.1167605%2C0.0469063636%2010.9500423%2C0.106565455%2010.8222014%2C0.233344091%20L10.2932605%2C0.762285%20C9.87351955%2C1.18202591%209.45270136%2C1.60284409%209.03349227%2C2.02205318%20L6.18908318%2C4.86646227%20C5.976015%2C5.07953045%205.75922409%2C5.291535%205.548815%2C5.50673045%20C5.54615182%2C5.50939364%205.54348864%2C5.51205682%205.53922727%2C5.51631818%20C5.41777909%2C5.63776636%205.3448%2C5.81567727%205.3448%2C5.98772727%20C5.3448%2C6.15178636%205.41671%2C6.34568182%205.53922727%2C6.45913636%20C5.66600318%2C6.57472636%205.83219091%2C6.66155455%206.01063636%2C6.65356364%20C6.18748636%2C6.64717227%206.35420455%2C6.58698%206.48204545%2C6.45913636%20Z%22%20id%3D%22Fill-4%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var print = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2225px%22%20height%3D%2225px%22%20viewBox%3D%220%200%2025%2025%22%20version%3D%221.1%22%3E%20%20%20%20%3Ctitle%3E51B98E1C-D204-45C3-AABE-4080CA3EDDB8%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22%23295F84%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20opacity%3D%221%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%228.-NCTS-Submit-%22%20transform%3D%22translate%28-424.000000%2C%20-81.000000%29%22%20fill%3D%22%23008B8F%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-12%22%20transform%3D%22translate%28407.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22printer%22%20transform%3D%22translate%2817.000000%2C%2081.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M24.2675781%2C7.421875%20L22.0214844%2C7.421875%20L22.0214844%2C5.22460938%20C22.0214844%2C4.82011719%2021.6935547%2C4.4921875%2021.2890625%2C4.4921875%20L18.6674805%2C4.4921875%20L14.4884277%2C0.220263672%20C14.3546387%2C0.0835449219%2014.1633301%2C0%2013.9648438%2C0%20L6.640625%2C0%20C6.23613281%2C0%205.90820312%2C0.327929688%205.90820312%2C0.732421875%20L5.90820312%2C4.4921875%20L3.7109375%2C4.4921875%20C3.30644531%2C4.4921875%202.97851562%2C4.82011719%202.97851562%2C5.22460938%20L2.97851562%2C7.421875%20L0.732421875%2C7.421875%20C0.327929687%2C7.421875%200%2C7.74980469%200%2C8.15429688%20L0%2C21.3378906%20C0%2C21.7423828%200.327929688%2C22.0703125%200.732421875%2C22.0703125%20L5.90820312%2C22.0703125%20L5.90820312%2C24.2675781%20C5.90820312%2C24.6720703%206.23613281%2C25%206.640625%2C25%20L18.359375%2C25%20C18.7638672%2C25%2019.0917969%2C24.6720703%2019.0917969%2C24.2675781%20L19.0917969%2C22.0703125%20L24.2675781%2C22.0703125%20C24.6720703%2C22.0703125%2025%2C21.7423828%2025%2C21.3378906%20L25%2C8.15429688%20C25%2C7.74980469%2024.6720703%2C7.421875%2024.2675781%2C7.421875%20Z%20M20.5566406%2C7.421875%20L19.0917969%2C7.421875%20L19.0917969%2C5.95703125%20L20.5566406%2C5.95703125%20L20.5566406%2C7.421875%20Z%20M14.6972656%2C2.52851562%20L16.6182617%2C4.4921875%20L14.6972656%2C4.4921875%20L14.6972656%2C2.52851562%20Z%20M7.37304688%2C1.46484375%20L13.2324219%2C1.46484375%20L13.2324219%2C5.22460937%20C13.2324219%2C5.62910156%2013.5603516%2C5.95703125%2013.9648437%2C5.95703125%20L17.6269531%2C5.95703125%20L17.6269531%2C10.3515625%20L7.37304688%2C10.3515625%20L7.37304688%2C1.46484375%20Z%20M4.44335937%2C5.95703125%20L5.90820312%2C5.95703125%20L5.90820312%2C7.421875%20L4.44335937%2C7.421875%20L4.44335937%2C5.95703125%20Z%20M17.6269531%2C23.5351563%20L7.37304688%2C23.5351563%20L7.37304688%2C17.6757812%20L17.6269531%2C17.6757812%20L17.6269531%2C23.5351563%20Z%20M23.5351562%2C20.6054687%20L19.0917969%2C20.6054687%20L19.0917969%2C17.6757812%20L20.5566406%2C17.6757812%20L20.5566406%2C18.4082031%20C20.5566406%2C18.8126953%2020.8845703%2C19.140625%2021.2890625%2C19.140625%20C21.6935547%2C19.140625%2022.0214844%2C18.8126953%2022.0214844%2C18.4082031%20L22.0214844%2C16.9433594%20C22.0214844%2C16.5388672%2021.6935547%2C16.2109375%2021.2890625%2C16.2109375%20L3.7109375%2C16.2109375%20C3.30644531%2C16.2109375%202.97851562%2C16.5388672%202.97851562%2C16.9433594%20L2.97851562%2C18.4082031%20C2.97851562%2C18.8126953%203.30644531%2C19.140625%203.7109375%2C19.140625%20C4.11542969%2C19.140625%204.44335938%2C18.8126953%204.44335938%2C18.4082031%20L4.44335938%2C17.6757812%20L5.90820312%2C17.6757812%20L5.90820312%2C20.6054687%20L1.46484375%2C20.6054687%20L1.46484375%2C8.88671875%20L5.90820312%2C8.88671875%20L5.90820312%2C10.3515625%20L3.7109375%2C10.3515625%20C3.30644531%2C10.3515625%202.97851562%2C10.6794922%202.97851562%2C11.0839844%20C2.97851562%2C11.4884766%203.30644531%2C11.8164062%203.7109375%2C11.8164062%20L21.2890625%2C11.8164062%20C21.6935547%2C11.8164062%2022.0214844%2C11.4884766%2022.0214844%2C11.0839844%20C22.0214844%2C10.6794922%2021.6935547%2C10.3515625%2021.2890625%2C10.3515625%20L19.0917969%2C10.3515625%20L19.0917969%2C8.88671875%20L23.5351562%2C8.88671875%20L23.5351562%2C20.6054687%20Z%22%20id%3D%22Shape%22%2F%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20cx%3D%224%22%20cy%3D%2214%22%20r%3D%221%22%2F%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20cx%3D%227%22%20cy%3D%2214%22%20r%3D%221%22%2F%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var checkCircle = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22rgb%2843%2C%20175%2C%2057%29%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20class%3D%22feather%20feather-check-circle%22%3E%3Cpath%20d%3D%22M22%2011.08V12a10%2010%200%201%201-5.93-9.14%22%2F%3E%3Cpolyline%20points%3D%2222%204%2012%2014.01%209%2011.01%22%2F%3E%3C%2Fsvg%3E";

const CreateMovement = props => /*#__PURE__*/React__namespace.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M0.559982 36.9173C0.559982 38.8416 9.71248 40.4026 21 40.4026C32.2875 40.4026 41.44 38.8416 41.44 36.9173C41.44 34.993 32.2882 33.4313 21 33.4313C9.71178 33.4313 0.559982 34.9916 0.559982 36.9173Z",
  fill: "#FFF4EA"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M32.2 26.873C33.3396 23.8 37.6467 11.5052 37.0727 2.6285C37.0321 1.9985 36.2376 1.5785 35.8022 2.037C33.2752 4.69 25.06 12.7778 31.5742 26.9045C31.6036 26.9644 31.6498 27.0144 31.7073 27.0482C31.7647 27.0821 31.8309 27.0984 31.8975 27.095C31.9641 27.0917 32.0283 27.0688 32.082 27.0294C32.1358 26.9899 32.1768 26.9355 32.2 26.873V26.873Z",
  fill: "#B4D9B6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M31.7002 26.6448C31.6793 26.6157 31.6672 26.5812 31.6652 26.5454C31.3026 19.712 32.1958 14.5432 33.0085 11.4107C33.8919 8.00731 34.8481 6.24891 34.888 6.17611C34.9123 6.13183 34.9532 6.09903 35.0017 6.08491C35.0503 6.0708 35.1024 6.07654 35.1467 6.10086C35.1909 6.12518 35.2237 6.16609 35.2378 6.2146C35.252 6.2631 35.2462 6.31523 35.2219 6.35951C35.1827 6.42951 31.3572 13.5597 32.0453 26.5251C32.0478 26.5664 32.0367 26.6074 32.0137 26.6418C31.9908 26.6762 31.9572 26.7022 31.9181 26.7157C31.879 26.7293 31.8366 26.7297 31.7972 26.7169C31.7579 26.7041 31.7238 26.6788 31.7002 26.6448V26.6448Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M34.0963 22.3909C34.1178 22.4634 34.1567 22.5295 34.2097 22.5834C34.2627 22.6373 34.3281 22.6773 34.4002 22.7C34.4724 22.7227 34.5489 22.7273 34.6233 22.7134C34.6976 22.6996 34.7673 22.6677 34.8264 22.6205C36.239 21.4942 39.9434 17.948 40.0015 11.7075C40.0505 6.4379 40.5769 3.5875 40.9059 2.3072C40.9211 2.24823 40.9173 2.18597 40.895 2.1293C40.8727 2.07263 40.8331 2.02445 40.7818 1.99162C40.7305 1.9588 40.6701 1.94301 40.6093 1.94651C40.5485 1.95 40.4904 1.97261 40.4432 2.0111C38.0569 3.9536 30.7797 10.99 34.0963 22.3909Z",
  fill: "#8AC58D"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M34.5142 22.4084C34.4969 22.3883 34.4859 22.3636 34.4826 22.3374C34.4792 22.3111 34.4836 22.2845 34.4953 22.2607C34.5303 22.1907 38.0065 15.0395 38.402 7.77069C38.4055 7.73614 38.4222 7.70427 38.4486 7.68171C38.475 7.65914 38.5091 7.6476 38.5438 7.64949C38.5784 7.65138 38.6111 7.66656 38.6348 7.69186C38.6586 7.71717 38.6718 7.75066 38.6715 7.78539C38.2725 15.1109 34.7725 22.3083 34.7368 22.3804C34.727 22.4004 34.7125 22.4176 34.6944 22.4306C34.6763 22.4436 34.6553 22.4518 34.6332 22.4547C34.6112 22.4575 34.5887 22.4549 34.568 22.4469C34.5472 22.4389 34.5287 22.426 34.5142 22.4091V22.4084Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M36.897 14.6748H6.44209V35.7609H36.897V14.6748Z",
  fill: "#EEEBE9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.24629 18.4709H20.8033C20.8503 18.4709 20.8953 18.4896 20.9285 18.5228C20.9617 18.556 20.9804 18.601 20.9804 18.648V27.608H9.12239V18.5955C9.12239 18.5626 9.13542 18.531 9.15864 18.5076C9.18185 18.4843 9.21337 18.4711 9.24629 18.4709V18.4709Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  opacity: "0.29",
  d: "M21.4788 18.4709H9.02368C8.92201 18.4709 8.83958 18.5533 8.83958 18.655V19.7911C8.83958 19.8928 8.92201 19.9752 9.02368 19.9752H21.4788C21.5805 19.9752 21.6629 19.8928 21.6629 19.7911V18.655C21.6629 18.5533 21.5805 18.4709 21.4788 18.4709Z",
  fill: "#BEB7B0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  opacity: "0.54",
  d: "M24.4111 18.5787H33.9633C34.0222 18.5787 34.0786 18.6021 34.1202 18.6437C34.1618 18.6853 34.1852 18.7418 34.1852 18.8006V35.7805H24.2543V18.7348C24.2543 18.7142 24.2584 18.6939 24.2663 18.6749C24.2741 18.6559 24.2857 18.6387 24.3003 18.6242C24.3148 18.6097 24.3321 18.5982 24.3512 18.5904C24.3702 18.5826 24.3905 18.5786 24.4111 18.5787Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M36.897 14.6748H6.44209V15.3958H36.897V14.6748Z",
  fill: "#DBD6D3"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M37.73 14.8869H5.88001C5.60001 14.8869 5.43901 14.5369 5.60001 14.2772L8.66531 9.2869C8.70727 9.21839 8.76613 9.16182 8.83624 9.12259C8.90636 9.08337 8.98537 9.06281 9.0657 9.0629H35.4144C35.5435 9.06298 35.6696 9.10098 35.7773 9.17216C35.8849 9.24334 35.9693 9.34458 36.0199 9.4633L38.0709 14.2695C38.1927 14.5551 38.01 14.8869 37.73 14.8869Z",
  fill: "#BEB7B0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.4991 40.9374C15.253 40.9535 15.8718 40.2808 15.8718 39.4457V32.8062C15.8718 31.934 15.2418 31.2242 14.4515 31.2151C12.089 31.1864 7.21629 31.185 3.22979 31.5574C2.68589 31.6078 2.26239 32.102 2.24279 32.7068L1.86969 39.1258C1.84239 39.9742 2.44789 40.684 3.21439 40.7001L14.4991 40.9374Z",
  fill: "#F8B272"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.3591 40.5825C15.113 40.5986 15.7318 39.9259 15.7318 39.0908V32.4513C15.7318 31.5791 15.1018 30.8693 14.3115 30.8602C11.949 30.8315 7.07631 30.8301 3.08981 31.2025C2.54521 31.2529 2.12241 31.7471 2.10281 32.3519L1.72971 38.7702C1.70241 39.62 2.31001 40.3284 3.07441 40.3445L14.3591 40.5825Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.3633 33.1695C14.3731 33.7344 14.3584 34.6311 14.3458 35.21C14.3395 35.5117 14.1008 35.7413 13.8306 35.7056L11.886 35.4536C11.627 35.42 11.4443 35.1554 11.4835 34.8698L11.7222 33.1051C11.7326 32.9896 11.7846 32.8817 11.8686 32.8016C11.9525 32.7215 12.0627 32.6747 12.1786 32.6697H13.9013C14.1526 32.6697 14.3584 32.8916 14.3633 33.1695Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.28201 36.5127L8.43221 36.0353L7.66221 36.7066C7.43541 36.7339 7.24221 36.5267 7.25831 36.274L7.61321 30.9281C8.29291 30.9043 8.96351 30.8868 9.61031 30.8749V36.1102C9.61428 36.2058 9.58307 36.2996 9.52257 36.3738C9.46207 36.448 9.37649 36.4974 9.28201 36.5127Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.61701 35.5866C8.61688 35.6304 8.59996 35.6724 8.56974 35.7041C8.53953 35.7357 8.49831 35.7546 8.45461 35.7567H8.44481C8.39946 35.7513 8.35804 35.7283 8.3294 35.6927C8.30076 35.6571 8.28716 35.6118 8.29151 35.5663L8.53651 30.9008L8.86341 30.8924L8.61701 35.5866Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.4638 34.8537C13.4784 34.853 13.4922 34.8467 13.5024 34.8362C13.5125 34.8256 13.5182 34.8116 13.5184 34.797L13.6024 33.327C13.604 33.3118 13.5995 33.2966 13.5899 33.2847C13.5804 33.2727 13.5665 33.2651 13.5513 33.2633C13.5438 33.263 13.5363 33.2643 13.5293 33.267C13.5223 33.2696 13.5159 33.2737 13.5106 33.279C13.5052 33.2842 13.501 33.2905 13.4981 33.2974C13.4952 33.3044 13.4938 33.3118 13.4939 33.3193L13.4099 34.7893C13.4083 34.8045 13.4128 34.8197 13.4224 34.8316C13.4319 34.8436 13.4458 34.8512 13.461 34.853L13.4638 34.8537Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.2909 34.8537C13.3058 34.853 13.3198 34.8465 13.3299 34.8357C13.3401 34.8248 13.3457 34.8105 13.3455 34.7956L13.3896 33.2976C13.3906 33.2824 13.3857 33.2675 13.3759 33.2559C13.3661 33.2443 13.3522 33.2369 13.3371 33.2353C13.3294 33.2351 13.3218 33.2365 13.3147 33.2394C13.3075 33.2423 13.3011 33.2467 13.2958 33.2522C13.2904 33.2577 13.2863 33.2643 13.2837 33.2715C13.281 33.2787 13.2799 33.2864 13.2804 33.2941L13.2363 34.79C13.2351 34.8052 13.24 34.8202 13.2498 34.8319C13.2596 34.8435 13.2736 34.8509 13.2888 34.8523L13.2909 34.8537Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.0564 34.8537C13.0412 34.8521 13.0273 34.8446 13.0176 34.8328C13.0079 34.821 13.0032 34.8059 13.0046 34.7907C13.0263 34.2874 13.0669 33.3277 13.0676 33.2955C13.0676 33.281 13.0734 33.2671 13.0836 33.2569C13.0938 33.2467 13.1077 33.2409 13.1222 33.2409C13.1367 33.2409 13.1506 33.2467 13.1608 33.2569C13.171 33.2671 13.1768 33.281 13.1768 33.2955C13.1768 33.32 13.1236 34.5492 13.1131 34.7956C13.1131 34.8104 13.1075 34.8245 13.0973 34.8352C13.0871 34.8459 13.0732 34.8523 13.0585 34.853L13.0564 34.8537Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.6959 34.9139C12.7256 34.9125 12.7536 34.8996 12.774 34.8779C12.7943 34.8562 12.8055 34.8275 12.8051 34.7977C12.8506 33.3466 12.8429 33.3137 12.8373 33.292C12.8345 33.2775 12.8288 33.2636 12.8204 33.2514C12.8121 33.2392 12.8013 33.2288 12.7888 33.2209C12.7762 33.213 12.7622 33.2078 12.7475 33.2056C12.7329 33.2034 12.7179 33.2042 12.7036 33.208C12.6771 33.2175 12.6547 33.2358 12.6403 33.26C12.6259 33.2841 12.6203 33.3125 12.6245 33.3403C12.628 33.4271 12.6035 34.2713 12.5874 34.7893C12.5851 34.8197 12.5948 34.8498 12.6144 34.8731C12.6341 34.8964 12.6621 34.9111 12.6924 34.9139H12.6959Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.46 34.8537C12.4675 34.8533 12.4749 34.8515 12.4817 34.8483C12.4885 34.845 12.4945 34.8405 12.4996 34.8349C12.5046 34.8293 12.5084 34.8227 12.5109 34.8156C12.5134 34.8085 12.5144 34.801 12.5139 34.7935V33.3235C12.5148 33.3159 12.514 33.3081 12.5117 33.3008C12.5094 33.2935 12.5055 33.2867 12.5004 33.281C12.4953 33.2752 12.489 33.2706 12.482 33.2675C12.475 33.2644 12.4674 33.2627 12.4597 33.2627C12.452 33.2627 12.4444 33.2644 12.4373 33.2675C12.4303 33.2706 12.424 33.2752 12.4189 33.281C12.4138 33.2867 12.41 33.2935 12.4076 33.3008C12.4053 33.3081 12.4045 33.3159 12.4054 33.3235V34.7935C12.405 34.801 12.4061 34.8086 12.4087 34.8157C12.4112 34.8228 12.4151 34.8293 12.4202 34.8349C12.4253 34.8405 12.4314 34.8451 12.4382 34.8483C12.4451 34.8515 12.4525 34.8533 12.46 34.8537V34.8537Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.2703 34.8537C12.2853 34.853 12.2994 34.8464 12.3096 34.8354C12.3198 34.8244 12.3253 34.8099 12.3249 34.7949C12.3347 34.2846 12.3592 33.4502 12.3809 33.3501C12.3862 33.3406 12.389 33.3299 12.389 33.319C12.389 33.308 12.3862 33.2973 12.3809 33.2878C12.3775 33.2813 12.3728 33.2756 12.3671 33.2711C12.3613 33.2666 12.3546 33.2634 12.3475 33.2617C12.3404 33.26 12.333 33.2599 12.3258 33.2614C12.3186 33.2629 12.3119 33.2659 12.306 33.2703C12.2766 33.292 12.2479 33.3123 12.2178 34.7921C12.2172 34.7996 12.2181 34.8072 12.2205 34.8144C12.2229 34.8216 12.2266 34.8282 12.2316 34.834C12.2365 34.8397 12.2426 34.8444 12.2493 34.8478C12.2561 34.8512 12.2634 34.8532 12.271 34.8537H12.2703Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.7564 34.9874C13.7857 34.986 13.8133 34.9733 13.8335 34.9521C13.8537 34.9308 13.8649 34.9026 13.8649 34.8733L13.9349 33.3333C13.9378 33.3029 13.9287 33.2726 13.9094 33.2488C13.8902 33.2251 13.8624 33.21 13.832 33.2066C13.8022 33.2072 13.7738 33.2193 13.7529 33.2405C13.732 33.2617 13.7202 33.2902 13.72 33.32L13.65 34.86C13.6472 34.8904 13.6565 34.9206 13.6757 34.9443C13.6949 34.968 13.7226 34.9832 13.7529 34.9867L13.7564 34.9874Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.2058 30.478V24.5133C14.2058 23.7293 13.6619 23.0923 12.9843 23.0832C10.9543 23.058 6.75991 23.0566 3.32991 23.3912C2.86231 23.4367 2.49761 23.8812 2.48081 24.4237L2.16021 30.1903C2.13641 30.9533 2.65791 31.5903 3.31731 31.605L13.0256 31.8185C13.6738 31.8325 14.2058 31.2284 14.2058 30.478Z",
  fill: "#F8B272"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.2058 30.0776V24.1129C14.2058 23.3289 13.6619 22.6912 12.9843 22.6828C10.9543 22.6569 6.75991 22.6562 3.32991 22.9901C2.86231 23.0363 2.49761 23.4801 2.48081 24.0233L2.16021 29.7899C2.13641 30.5522 2.65791 31.1899 3.31731 31.2039L13.0256 31.4174C13.6738 31.43 14.2058 30.8273 14.2058 30.0776Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.0284 24.7583C13.0375 25.2658 13.0242 26.0708 13.0137 26.5909C13.0081 26.8618 12.8037 27.0683 12.5706 27.0368L10.8976 26.81C10.675 26.7792 10.5175 26.5419 10.5476 26.285L10.7527 24.7002C10.7821 24.4755 10.9494 24.3089 11.1454 24.3089H12.628C12.8478 24.3089 13.0242 24.5084 13.0284 24.7583Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.65759 27.7613L7.92609 27.3L7.26179 27.9391C7.06649 27.9636 6.89989 27.7774 6.91179 27.5506L7.21699 22.7479C7.80149 22.7262 8.37899 22.7108 8.93549 22.6996V27.4029C8.93925 27.4859 8.91336 27.5675 8.86245 27.6332C8.81153 27.6989 8.73892 27.7443 8.65759 27.7613V27.7613Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.08571 26.929C8.08635 26.9676 8.07221 27.005 8.04618 27.0335C8.02015 27.062 7.9842 27.0794 7.94571 27.0823H7.93731C7.89728 27.0766 7.86106 27.0554 7.83636 27.0234C7.81165 26.9914 7.80041 26.951 7.80501 26.9108L8.01501 22.7192L8.29501 22.7115L8.08571 26.929Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.2549 26.271C12.2678 26.2701 12.2798 26.2643 12.2885 26.2548C12.2973 26.2453 12.302 26.2328 12.3018 26.2199L12.3718 24.8997C12.3734 24.8864 12.3698 24.8729 12.3617 24.8622C12.3536 24.8515 12.3417 24.8444 12.3284 24.8423C12.3217 24.8422 12.3151 24.8435 12.3089 24.846C12.3028 24.8486 12.2972 24.8524 12.2925 24.8571C12.2879 24.8619 12.2843 24.8676 12.2819 24.8738C12.2795 24.8801 12.2784 24.8867 12.2787 24.8934L12.2087 26.2136C12.2071 26.2269 12.2107 26.2404 12.2188 26.2511C12.2269 26.2618 12.2388 26.2689 12.2521 26.271H12.2549Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.11 26.271C12.123 26.2699 12.1351 26.2639 12.1437 26.2541C12.1523 26.2443 12.1568 26.2315 12.1562 26.2185L12.1947 24.8731C12.1959 24.8597 12.1918 24.8463 12.1833 24.8359C12.1748 24.8254 12.1626 24.8187 12.1492 24.8171C12.1425 24.817 12.1358 24.8183 12.1296 24.8209C12.1234 24.8236 12.1178 24.8275 12.1132 24.8325C12.1087 24.8374 12.1052 24.8433 12.1031 24.8497C12.1009 24.8561 12.1002 24.8629 12.1009 24.8696L12.0631 26.215C12.0619 26.2283 12.0659 26.2416 12.0742 26.252C12.0826 26.2624 12.0947 26.2692 12.1079 26.271H12.11Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.9042 26.271C11.8908 26.2693 11.8786 26.2624 11.8703 26.2518C11.8619 26.2412 11.858 26.2277 11.8594 26.2143C11.8783 25.7621 11.914 24.9004 11.914 24.871C11.9128 24.8642 11.9131 24.8572 11.9149 24.8505C11.9168 24.8438 11.92 24.8375 11.9245 24.8322C11.9289 24.8269 11.9345 24.8227 11.9408 24.8197C11.9471 24.8168 11.954 24.8153 11.9609 24.8153C11.9678 24.8153 11.9747 24.8168 11.981 24.8197C11.9873 24.8227 11.9928 24.8269 11.9973 24.8322C12.0018 24.8375 12.005 24.8438 12.0068 24.8505C12.0087 24.8572 12.009 24.8642 12.0078 24.871C12.0078 24.8934 11.9623 25.998 11.9532 26.2192C11.9536 26.2322 11.9489 26.2449 11.9402 26.2546C11.9314 26.2642 11.9193 26.2701 11.9063 26.271H11.9042Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.5948 26.3249C11.6208 26.3229 11.645 26.311 11.6624 26.2915C11.6797 26.2721 11.6889 26.2466 11.6879 26.2206C11.7278 24.9172 11.7208 24.8906 11.7159 24.8682C11.7139 24.8554 11.7093 24.8431 11.7024 24.8321C11.6954 24.8212 11.6862 24.8118 11.6754 24.8046C11.6646 24.7975 11.6524 24.7926 11.6396 24.7904C11.6268 24.7882 11.6137 24.7887 11.6011 24.7919C11.5775 24.8006 11.5576 24.8173 11.5449 24.8389C11.5321 24.8606 11.5273 24.886 11.5311 24.9109C11.5311 24.9893 11.5129 25.7509 11.4989 26.2129C11.4961 26.2397 11.5041 26.2665 11.521 26.2875C11.5379 26.3085 11.5624 26.3219 11.5892 26.3249H11.5948Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.3918 26.271C11.4051 26.2699 11.4175 26.2637 11.4262 26.2536C11.435 26.2435 11.4395 26.2304 11.4387 26.2171V24.8969C11.4399 24.8901 11.4396 24.8831 11.4378 24.8764C11.4359 24.8697 11.4327 24.8634 11.4282 24.8581C11.4238 24.8528 11.4182 24.8485 11.4119 24.8456C11.4056 24.8427 11.3987 24.8412 11.3918 24.8412C11.3849 24.8412 11.378 24.8427 11.3717 24.8456C11.3654 24.8485 11.3599 24.8528 11.3554 24.8581C11.3509 24.8634 11.3477 24.8697 11.3459 24.8764C11.344 24.8831 11.3437 24.8901 11.3449 24.8969V26.2171C11.3441 26.2304 11.3486 26.2435 11.3574 26.2536C11.3661 26.2637 11.3785 26.2699 11.3918 26.271V26.271Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.228 26.271C11.2412 26.2699 11.2534 26.2638 11.2622 26.2539C11.2709 26.2439 11.2755 26.231 11.2749 26.2178C11.284 25.7593 11.305 25.0103 11.3232 24.92C11.3277 24.9113 11.33 24.9017 11.33 24.892C11.33 24.8823 11.3277 24.8727 11.3232 24.864C11.3205 24.8582 11.3165 24.853 11.3115 24.849C11.3065 24.8449 11.3006 24.8421 11.2944 24.8406C11.2881 24.8391 11.2816 24.8391 11.2753 24.8404C11.269 24.8418 11.2632 24.8446 11.2581 24.8486C11.2329 24.8675 11.2084 24.8857 11.1825 26.2157C11.1813 26.2292 11.1855 26.2425 11.1942 26.2529C11.2029 26.2632 11.2153 26.2698 11.2287 26.271H11.228Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.5069 26.39C12.5327 26.3882 12.5568 26.3765 12.5742 26.3573C12.5915 26.3381 12.6008 26.3129 12.6 26.2871L12.663 24.9011C12.6658 24.8743 12.6581 24.8474 12.6415 24.8261C12.625 24.8048 12.6008 24.7908 12.5741 24.787C12.5474 24.7877 12.5221 24.7989 12.5036 24.8182C12.4852 24.8374 12.475 24.8632 12.4754 24.8899L12.4131 26.2759C12.4105 26.3027 12.4182 26.3295 12.4348 26.3507C12.4513 26.3719 12.4754 26.386 12.502 26.39H12.5069Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M24.8934 34.4463C23.5746 39.4275 16.4724 40.7988 13.4337 36.5498",
  stroke: "#006466",
  "stroke-width": "0.8631",
  "stroke-miterlimit": "10"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.1467 35.7532L12.8723 38.0807",
  stroke: "#006466",
  "stroke-width": "0.8631",
  "stroke-miterlimit": "10"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.6679 36.1312L14.9947 36.4056",
  stroke: "#006466",
  "stroke-width": "0.8631",
  "stroke-miterlimit": "10"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.2737 18.2203H8.81861C8.71693 18.2203 8.63451 18.3027 8.63451 18.4044V19.5405C8.63451 19.6422 8.71693 19.7246 8.81861 19.7246H21.2737C21.3754 19.7246 21.4578 19.6422 21.4578 19.5405V18.4044C21.4578 18.3027 21.3754 18.2203 21.2737 18.2203Z",
  fill: "#DBD6D3"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M24.1248 18.5787H33.677C33.7359 18.5787 33.7923 18.6021 33.8339 18.6437C33.8755 18.6853 33.8989 18.7418 33.8989 18.8006V35.7805H23.968V18.7348C23.968 18.7142 23.9721 18.6939 23.98 18.6749C23.9878 18.6559 23.9994 18.6387 24.014 18.6242C24.0285 18.6097 24.0458 18.5982 24.0649 18.5904C24.0839 18.5826 24.1042 18.5786 24.1248 18.5787Z",
  fill: "#BEB7B0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  opacity: "0.54",
  d: "M34.6367 20.0403H23.597C23.2743 19.9108 23.0125 19.6364 23.0125 19.2969V19.0204C23.0097 18.8621 23.0695 18.7091 23.179 18.5948C23.2885 18.4805 23.4387 18.414 23.597 18.41H34.6367C34.7956 18.414 34.9464 18.4809 35.0559 18.596C35.1655 18.7111 35.225 18.865 35.2212 19.0239V19.3004C35.2212 19.6364 34.9594 19.9108 34.6367 20.0403Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M34.4316 19.88H23.3919C23.0692 19.7505 22.8074 19.4754 22.8074 19.1359V18.8601C22.8035 18.7011 22.8628 18.547 22.9724 18.4318C23.082 18.3165 23.2329 18.2495 23.3919 18.2455H34.4316C34.5906 18.2495 34.7415 18.3165 34.8511 18.4318C34.9607 18.547 35.0201 18.7011 35.0161 18.8601V19.1359C35.0161 19.4761 34.7543 19.7512 34.4316 19.88Z",
  fill: "#DBD6D3"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.0005 22.47V17.9627C11.0005 17.3712 10.5889 16.8896 10.0779 16.8833C8.5428 16.8637 5.3767 16.863 2.7867 17.115C2.4332 17.15 2.1567 17.4853 2.1455 17.8955L1.9033 22.2502C1.8851 22.8263 2.2792 23.3072 2.7769 23.1784L10.1087 23.3394C10.598 23.4906 11.0005 23.0342 11.0005 22.47Z",
  fill: "#F8B272"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.0005 21.7931V17.29C11.0005 16.6985 10.5889 16.2169 10.0779 16.2106C8.5428 16.191 5.3767 16.1903 2.7867 16.443C2.4332 16.4773 2.1567 16.8126 2.1455 17.2228L1.9033 21.5775C1.8851 22.1536 2.2792 22.6345 2.7769 22.6457L10.1087 22.8067C10.598 22.82 11.0005 22.3601 11.0005 21.7931Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.1115 17.78C10.1178 18.1629 10.1115 18.7712 10.0996 19.1639C10.0954 19.3683 9.94069 19.5244 9.76499 19.5006L8.50499 19.3291C8.33699 19.306 8.21869 19.1268 8.24389 18.9329L8.39859 17.7359C8.40372 17.659 8.43668 17.5866 8.4913 17.5322C8.54592 17.4779 8.61848 17.4453 8.69539 17.4405H9.81539C9.97429 17.437 10.108 17.5875 10.1115 17.78Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M6.81029 20.0445L6.25729 19.6749L5.75609 20.1761C5.60909 20.1943 5.48309 20.0536 5.49359 19.8828L5.72389 16.2554C6.16559 16.2393 6.60169 16.2274 7.02169 16.219V19.7708C7.0253 19.8342 7.00591 19.8968 6.96707 19.9471C6.92824 19.9974 6.87257 20.032 6.81029 20.0445V20.0445Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M6.37839 19.4159C6.37831 19.4447 6.36739 19.4724 6.34781 19.4936C6.32823 19.5147 6.30141 19.5277 6.27269 19.53H6.26639C6.23615 19.5256 6.2088 19.5097 6.19011 19.4855C6.17143 19.4614 6.16289 19.4309 6.16629 19.4005L6.32519 16.2344L6.53519 16.2288L6.37839 19.4159Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.52701 18.9189C9.53666 18.9182 9.54567 18.9138 9.55219 18.9066C9.5587 18.8995 9.56221 18.8901 9.56201 18.8804L9.61661 17.8836C9.6173 17.8786 9.617 17.8735 9.61572 17.8686C9.61444 17.8637 9.61221 17.8591 9.60915 17.8551C9.60609 17.851 9.60228 17.8477 9.59791 17.8451C9.59354 17.8426 9.58872 17.8409 9.58371 17.8402C9.57872 17.84 9.57375 17.8408 9.56911 17.8427C9.56447 17.8445 9.56026 17.8473 9.55677 17.8509C9.55327 17.8544 9.55056 17.8587 9.54881 17.8633C9.54706 17.868 9.54631 17.873 9.54661 17.878L9.49201 18.8755C9.4908 18.8856 9.49355 18.8957 9.49969 18.9038C9.50583 18.9119 9.51487 18.9173 9.52491 18.9189H9.52701Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.41429 18.9189C9.42425 18.9182 9.43355 18.9136 9.44021 18.9062C9.44687 18.8987 9.45038 18.889 9.44999 18.879L9.47869 17.8633C9.47968 17.8531 9.47664 17.8429 9.47023 17.835C9.46382 17.827 9.45455 17.8218 9.44439 17.8206C9.4393 17.8206 9.43426 17.8216 9.4296 17.8237C9.42494 17.8257 9.42076 17.8287 9.41733 17.8325C9.4139 17.8362 9.4113 17.8407 9.40969 17.8455C9.40808 17.8503 9.4075 17.8554 9.40799 17.8605L9.37999 18.8762C9.379 18.8864 9.38204 18.8966 9.38845 18.9045C9.39486 18.9125 9.40413 18.9177 9.41429 18.9189V18.9189Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.26169 18.9189C9.25173 18.9173 9.24273 18.9121 9.23649 18.9042C9.23026 18.8962 9.22726 18.8862 9.22809 18.8762C9.24209 18.5346 9.26939 17.8836 9.26939 17.8612C9.26834 17.856 9.26847 17.8507 9.26974 17.8455C9.27102 17.8404 9.27342 17.8356 9.27677 17.8315C9.28012 17.8275 9.28433 17.8242 9.28911 17.8219C9.29388 17.8196 9.2991 17.8185 9.30439 17.8185C9.30967 17.8185 9.31489 17.8196 9.31967 17.8219C9.32444 17.8242 9.32866 17.8275 9.33201 17.8315C9.33535 17.8356 9.33775 17.8404 9.33903 17.8455C9.34031 17.8507 9.34043 17.856 9.33939 17.8612C9.33939 17.878 9.30509 18.7117 9.29809 18.879C9.29848 18.8888 9.29504 18.8984 9.28851 18.9057C9.28198 18.913 9.27286 18.9175 9.26309 18.9182L9.26169 18.9189Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.03002 18.9595C9.04963 18.9579 9.06787 18.9488 9.08092 18.934C9.09396 18.9193 9.1008 18.9001 9.10002 18.8804C9.13012 17.8962 9.12452 17.8738 9.12102 17.8591C9.11956 17.8494 9.11609 17.8401 9.11081 17.8318C9.10554 17.8236 9.09858 17.8165 9.0904 17.8111C9.08221 17.8057 9.07298 17.802 9.0633 17.8004C9.05362 17.7988 9.04371 17.7992 9.03422 17.8017C9.01666 17.8087 9.00202 17.8214 8.99272 17.8378C8.98342 17.8543 8.98003 17.8734 8.98312 17.892C8.98312 17.9508 8.96982 18.522 8.95862 18.872C8.95667 18.8925 8.96295 18.913 8.97607 18.9289C8.9892 18.9447 9.0081 18.9548 9.02862 18.9567L9.03002 18.9595Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.87528 18.9189C8.88538 18.918 8.89472 18.9132 8.90127 18.9054C8.90782 18.8977 8.91106 18.8877 8.91028 18.8776V17.8808C8.91133 17.8756 8.9112 17.8703 8.90993 17.8652C8.90865 17.86 8.90625 17.8552 8.9029 17.8512C8.89956 17.8471 8.89534 17.8438 8.89056 17.8415C8.88579 17.8392 8.88057 17.8381 8.87528 17.8381C8.87 17.8381 8.86478 17.8392 8.86 17.8415C8.85523 17.8438 8.85101 17.8471 8.84767 17.8512C8.84432 17.8552 8.84192 17.86 8.84064 17.8652C8.83936 17.8703 8.83924 17.8756 8.84028 17.8808V18.8776C8.83951 18.8877 8.84275 18.8977 8.8493 18.9054C8.85585 18.9132 8.86519 18.918 8.87528 18.9189V18.9189Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.74999 18.9189C8.75983 18.918 8.76895 18.9134 8.77547 18.9059C8.78198 18.8985 8.78539 18.8889 8.78499 18.879C8.79199 18.5325 8.80809 17.969 8.82209 17.899C8.82553 17.8925 8.82732 17.8853 8.82732 17.878C8.82732 17.8707 8.82553 17.8635 8.82209 17.857C8.82006 17.8526 8.81706 17.8487 8.81331 17.8456C8.80957 17.8426 8.80518 17.8404 8.80047 17.8392C8.79576 17.8381 8.79085 17.838 8.78611 17.839C8.78137 17.8401 8.77692 17.8421 8.77309 17.8451C8.75419 17.8598 8.73529 17.8731 8.71569 18.8776C8.71508 18.8877 8.71837 18.8977 8.72487 18.9055C8.73137 18.9133 8.74061 18.9184 8.75069 18.9196L8.74999 18.9189Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.71739 19.0092C9.7367 19.0078 9.75473 18.999 9.76775 18.9847C9.78077 18.9703 9.7878 18.9516 9.78739 18.9322L9.83499 17.8822C9.83696 17.8615 9.83072 17.8409 9.81762 17.8248C9.80453 17.8087 9.78562 17.7984 9.76499 17.7961C9.74494 17.7968 9.72596 17.8054 9.7121 17.8199C9.69824 17.8344 9.6906 17.8537 9.69079 17.8738L9.64389 18.9238C9.6417 18.9439 9.64741 18.964 9.65983 18.98C9.67224 18.9959 9.69038 19.0064 9.71039 19.0092H9.71739Z",
  fill: "#14B1A6"
}));

const AssociateShipment = props => /*#__PURE__*/React__namespace.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.80531 35.7805C8.80531 37.0979 15.0682 38.1661 22.7948 38.1661C30.5214 38.1661 36.7843 37.1 36.7843 35.7805C36.7843 34.461 30.52 33.3949 22.7948 33.3949C15.0696 33.3949 8.80531 34.4631 8.80531 35.7805Z",
  fill: "#F6F5F4"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M28.0294 27.93C29.2376 27.1397 33.9794 23.9113 36.0997 20.6164C36.2516 20.3812 36.0787 20.0263 35.8043 20.0746C34.2146 20.3546 29.1886 21.0679 27.7998 27.7746C27.7937 27.8037 27.7964 27.8339 27.8076 27.8615C27.8187 27.889 27.8378 27.9127 27.8625 27.9293C27.8871 27.946 27.9161 27.9549 27.9458 27.9551C27.9756 27.9552 28.0046 27.9465 28.0294 27.93V27.93Z",
  fill: "#B4D9B6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M27.9118 27.7144C27.9122 27.6987 27.9171 27.6834 27.9258 27.6703C29.5855 25.1545 31.2543 23.5571 32.3624 22.6604C33.5657 21.686 34.3644 21.3136 34.398 21.2982C34.4079 21.2935 34.4187 21.2908 34.4296 21.2903C34.4406 21.2898 34.4515 21.2915 34.4618 21.2953C34.4721 21.2991 34.4815 21.3049 34.4896 21.3123C34.4976 21.3198 34.5041 21.3288 34.5086 21.3388C34.5179 21.3589 34.5189 21.382 34.5113 21.4028C34.5037 21.4237 34.4881 21.4407 34.468 21.4501C34.4358 21.4648 31.2151 22.9901 28.0658 27.7627C28.0535 27.7812 28.0344 27.7941 28.0126 27.7986C27.9908 27.8031 27.9682 27.7987 27.9496 27.7865C27.9379 27.7784 27.9284 27.7677 27.9218 27.7551C27.9152 27.7426 27.9118 27.7286 27.9118 27.7144V27.7144Z",
  fill: "#6BA32F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M29.8739 26.8345C29.8625 26.8658 29.859 26.8994 29.8637 26.9324C29.8683 26.9654 29.881 26.9968 29.9007 27.0237C29.9203 27.0506 29.9463 27.0722 29.9763 27.0867C30.0063 27.1012 30.0394 27.1081 30.0727 27.1068C30.8679 27.0774 33.1079 26.7911 34.7627 24.5952C36.1592 22.7416 37.0923 21.8694 37.5431 21.5026C37.5639 21.4857 37.5788 21.4627 37.5858 21.4368C37.5927 21.4109 37.5913 21.3835 37.5818 21.3584C37.5722 21.3334 37.555 21.312 37.5326 21.2973C37.5102 21.2826 37.4838 21.2753 37.457 21.2765C36.1018 21.3395 31.682 21.9289 29.8739 26.8345Z",
  fill: "#8AC58D"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M30.0174 26.95C30.0167 26.9384 30.0193 26.9269 30.025 26.9168C30.0308 26.9068 30.0393 26.8986 30.0496 26.8933C30.0804 26.8772 33.1828 25.2539 35.2254 22.7822C35.2303 22.7762 35.2364 22.7712 35.2433 22.7676C35.2502 22.7639 35.2577 22.7617 35.2654 22.7609C35.2732 22.7602 35.281 22.7611 35.2884 22.7634C35.2959 22.7657 35.3027 22.7695 35.3087 22.7745C35.3208 22.7845 35.3285 22.7988 35.33 22.8144C35.3316 22.83 35.327 22.8456 35.3171 22.8578C33.2584 25.3484 30.1371 26.9822 30.1042 26.9983C30.0902 27.0055 30.0739 27.0069 30.0588 27.0022C30.0437 26.9974 30.0311 26.987 30.0237 26.9731C30.0203 26.9658 30.0182 26.958 30.0174 26.95V26.95Z",
  fill: "#6BA32F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.09129 27.2496C6.97829 27.013 6.29999 25.8111 6.58979 24.584L8.88019 14.8288C9.18049 13.5471 10.3551 12.7225 11.515 12.9801C14.9961 13.7501 22.155 15.4301 27.8859 17.3544C28.6678 17.6169 29.1193 18.4891 28.9401 19.3844L27.2734 28.9436C27.0207 30.2036 25.886 31.0338 24.7534 30.793L8.09129 27.2496Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.64 16.3562C10.43 17.1829 10.143 18.5052 9.9617 19.3606C9.8672 19.8051 10.1388 20.2251 10.5476 20.2664L13.4918 20.5667C13.8838 20.6066 14.2436 20.2804 14.2849 19.8471L14.5432 17.1731C14.5796 16.7937 14.3584 16.4542 14.0224 16.3751L11.4905 15.7808C11.1244 15.694 10.7457 15.9495 10.64 16.3562Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.9554 23.0216L18.3694 22.6128L19.2717 23.8658C19.5958 23.9841 19.9521 23.7461 20.0144 23.3695L21.3374 15.3895C20.3469 15.12 19.3669 14.8631 18.4205 14.6195L16.6145 22.3118C16.5431 22.6212 16.6901 22.925 16.9554 23.0216Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.2518 21.8897C18.2369 21.9541 18.2473 22.0218 18.2809 22.0788C18.3146 22.1357 18.3688 22.1775 18.4324 22.1956H18.4464C18.515 22.2032 18.5839 22.1836 18.6383 22.1411C18.6927 22.0986 18.7283 22.0365 18.7376 21.9681L19.9878 15.0283L19.5097 14.903L18.2518 21.8897Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.3827 19.1408C11.3616 19.1347 11.3437 19.1209 11.3325 19.102C11.3213 19.0831 11.3177 19.0607 11.3225 19.0393L11.7061 16.8511C11.7089 16.8282 11.7206 16.8074 11.7387 16.7931C11.7568 16.7788 11.7798 16.7722 11.8027 16.7748C11.8139 16.7769 11.8246 16.7814 11.8341 16.7878C11.8436 16.7942 11.8516 16.8024 11.8578 16.8121C11.8639 16.8217 11.8681 16.8325 11.8699 16.8438C11.8718 16.8551 11.8713 16.8666 11.8685 16.8777L11.4849 19.0659C11.4819 19.0887 11.4702 19.1094 11.4521 19.1237C11.4341 19.1379 11.4112 19.1446 11.3883 19.1422L11.3827 19.1408Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.6375 19.201C11.616 19.1946 11.5978 19.1803 11.5866 19.1608C11.5754 19.1414 11.5721 19.1185 11.5773 19.0967L12.0295 16.8805C12.0331 16.8578 12.0455 16.8374 12.0639 16.8237C12.0824 16.81 12.1054 16.804 12.1282 16.807C12.1396 16.8091 12.1503 16.8136 12.1598 16.8203C12.1693 16.8269 12.1772 16.8354 12.1831 16.8454C12.189 16.8553 12.1927 16.8664 12.194 16.8779C12.1953 16.8894 12.1941 16.901 12.1905 16.912L11.739 19.1282C11.7352 19.1508 11.7228 19.1711 11.7044 19.1848C11.686 19.1985 11.6631 19.2045 11.6403 19.2017L11.6375 19.201Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.9784 19.2808C11.9572 19.2746 11.9391 19.2604 11.928 19.2413C11.917 19.2221 11.9137 19.1994 11.9189 19.1779C11.9889 18.8125 12.334 16.9876 12.3431 16.9512C12.3442 16.9395 12.3477 16.9281 12.3535 16.9178C12.3593 16.9076 12.3673 16.8987 12.3768 16.8918C12.3863 16.8848 12.3972 16.88 12.4088 16.8777C12.4203 16.8753 12.4322 16.8754 12.4437 16.878C12.4552 16.8807 12.466 16.8857 12.4754 16.8929C12.4848 16.9 12.4925 16.9091 12.4981 16.9194C12.5037 16.9298 12.507 16.9413 12.5078 16.953C12.5086 16.9648 12.5068 16.9766 12.5027 16.9876C12.4929 17.0359 12.2227 18.4576 12.0827 19.2066C12.0812 19.2179 12.0776 19.2288 12.0719 19.2387C12.0662 19.2486 12.0586 19.2573 12.0496 19.2642C12.0405 19.2712 12.0302 19.2763 12.0192 19.2792C12.0082 19.2822 11.9967 19.283 11.9854 19.2815L11.9784 19.2808Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.4901 19.4943C12.4468 19.4817 12.4101 19.4527 12.3879 19.4135C12.3657 19.3743 12.3596 19.3279 12.3711 19.2843C12.8037 17.136 12.8275 17.0905 12.8422 17.0611C12.8512 17.0406 12.8644 17.0222 12.8808 17.0071C12.8973 16.9919 12.9167 16.9802 12.9378 16.9729C12.959 16.9655 12.9814 16.9626 13.0037 16.9643C13.0261 16.966 13.0478 16.9723 13.0676 16.9827C13.1033 17.0056 13.1298 17.0402 13.1426 17.0807C13.1554 17.1211 13.1536 17.1647 13.1376 17.2039C13.1026 17.3313 12.8471 18.5801 12.6924 19.3466C12.6856 19.3921 12.6612 19.4331 12.6243 19.4606C12.5875 19.4882 12.5412 19.5 12.4957 19.4936L12.4901 19.4943Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.8576 19.4873C12.8356 19.4808 12.8171 19.4659 12.806 19.4459C12.7949 19.4259 12.792 19.4023 12.7981 19.3802L13.3056 17.22C13.3068 17.2083 13.3104 17.197 13.3163 17.1869C13.3222 17.1767 13.3302 17.1679 13.3397 17.1611C13.3493 17.1543 13.3602 17.1496 13.3717 17.1473C13.3832 17.145 13.3951 17.1452 13.4065 17.1479C13.4179 17.1505 13.4286 17.1556 13.438 17.1627C13.4473 17.1698 13.455 17.1789 13.4605 17.1892C13.4661 17.1995 13.4694 17.2109 13.4702 17.2226C13.471 17.2344 13.4693 17.2461 13.4652 17.2571L12.9584 19.4166C12.9543 19.4393 12.9414 19.4594 12.9225 19.4727C12.9037 19.4859 12.8803 19.4912 12.8576 19.4873V19.4873Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.1369 19.5531C13.1151 19.5467 13.0967 19.5321 13.0856 19.5124C13.0745 19.4926 13.0716 19.4693 13.0774 19.4474C13.2384 18.6935 13.4904 17.4601 13.4932 17.3047C13.4894 17.2887 13.4896 17.272 13.4939 17.2561C13.4982 17.2402 13.5064 17.2256 13.5177 17.2137C13.5249 17.2054 13.5339 17.1987 13.5439 17.1942C13.5539 17.1896 13.5648 17.1872 13.5758 17.1872C13.5868 17.1872 13.5977 17.1896 13.6077 17.1942C13.6177 17.1987 13.6267 17.2054 13.6339 17.2137C13.6703 17.2557 13.7039 17.2949 13.2384 19.4803C13.2341 19.5026 13.2214 19.5223 13.2028 19.5354C13.1843 19.5484 13.1614 19.5538 13.139 19.5503L13.1369 19.5531Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.9067 19.2367C10.8642 19.2244 10.8281 19.1963 10.8058 19.1581C10.7836 19.1199 10.7768 19.0746 10.787 19.0316L11.2126 16.7391C11.2194 16.6933 11.2439 16.652 11.2808 16.6241C11.3177 16.5963 11.3641 16.584 11.41 16.59C11.4322 16.5953 11.4532 16.605 11.4716 16.6185C11.4901 16.6319 11.5058 16.6489 11.5177 16.6684C11.5296 16.6879 11.5375 16.7096 11.541 16.7322C11.5445 16.7547 11.5435 16.7778 11.5381 16.8L11.1125 19.0925C11.1061 19.1381 11.082 19.1794 11.0455 19.2075C11.009 19.2357 10.963 19.2484 10.9172 19.243L10.9067 19.2367Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.2241 12.2983L14.28 3.5343C14.5502 2.3828 15.5694 1.6338 16.5676 1.8543C19.565 2.52 25.725 3.9627 30.6495 5.6371C31.3208 5.866 31.6995 6.6437 31.5406 7.4473L30.0223 16.03C29.7941 17.1584 28.8085 17.9151 27.8348 17.71L13.4967 14.6748C12.5391 14.4725 11.9651 13.4008 12.2241 12.2983Z",
  fill: "#F8B272"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.9406 11.8671L14 3.1031C14.2702 1.9516 15.2894 1.2026 16.2876 1.4231C19.2829 2.0867 25.4429 3.5308 30.3674 5.2031C31.0387 5.4313 31.4209 6.209 31.2585 7.0133L29.7388 15.5995C29.5106 16.7286 28.525 17.4853 27.5513 17.2795L13.2132 14.2436C12.2556 14.0406 11.6816 12.9696 11.9406 11.8671Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.5057 4.45689C15.3174 5.20029 15.0591 6.38749 14.8953 7.15609C14.8099 7.55509 15.0402 7.92609 15.393 7.96319L17.9291 8.20679C18.2665 8.23969 18.5794 7.94429 18.6193 7.55579L18.8643 5.15619C18.8986 4.81529 18.711 4.51359 18.4219 4.44569L16.2442 3.93399C15.9264 3.85979 15.5981 4.09149 15.5057 4.45689Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.8922 10.3782L22.1277 9.94699L22.8823 11.1153C23.1623 11.2189 23.4696 11.0026 23.527 10.6645L24.7352 3.5C23.8833 3.2662 23.0412 3.0443 22.2271 2.8364L20.6045 9.74679C20.5401 10.0226 20.664 10.2942 20.8922 10.3782Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.0199 9.35269C22.0056 9.40907 22.0135 9.46879 22.0418 9.51957C22.0702 9.57034 22.117 9.60832 22.1725 9.62569H22.1844C22.2452 9.63101 22.3057 9.61243 22.353 9.57387C22.4003 9.53531 22.4307 9.47982 22.4378 9.41919L23.5746 3.18919L23.1637 3.07999L22.0199 9.35269Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.1203 6.9468C16.1018 6.94126 16.0861 6.92876 16.0766 6.91193C16.0671 6.8951 16.0644 6.87524 16.0692 6.8565L16.4192 4.8916C16.4215 4.87123 16.4316 4.85255 16.4474 4.83949C16.4632 4.82644 16.4835 4.82002 16.5039 4.8216C16.514 4.8232 16.5236 4.82698 16.532 4.83268C16.5405 4.83837 16.5476 4.84585 16.5529 4.85459C16.5581 4.86332 16.5614 4.8731 16.5625 4.88325C16.5636 4.89339 16.5625 4.90365 16.5592 4.9133L16.2092 6.8782C16.2069 6.89844 16.1969 6.91701 16.1812 6.93005C16.1656 6.94309 16.1455 6.94959 16.1252 6.9482L16.1203 6.9468Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.3387 7.00001C16.32 6.99387 16.3043 6.98081 16.295 6.96349C16.2856 6.94618 16.2832 6.92593 16.2883 6.90691L16.6964 4.91681C16.6974 4.90652 16.7004 4.89652 16.7052 4.88741C16.7101 4.87829 16.7167 4.87024 16.7247 4.86372C16.7328 4.85721 16.742 4.85235 16.7519 4.84945C16.7618 4.84654 16.7722 4.84564 16.7825 4.84681C16.7926 4.84863 16.8021 4.85263 16.8104 4.85853C16.8188 4.86443 16.8257 4.87208 16.8308 4.88096C16.8359 4.88983 16.8389 4.8997 16.8398 4.90989C16.8406 4.92007 16.8392 4.93032 16.8357 4.93991L16.4269 6.93001C16.4248 6.95058 16.4146 6.96948 16.3986 6.98259C16.3826 6.9957 16.3621 7.00196 16.3415 7.00001H16.3387Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.6327 7.07001C16.6139 7.06447 16.598 7.05176 16.5884 7.03461C16.5788 7.01746 16.5764 6.99724 16.5816 6.97831C16.6446 6.65001 16.9589 5.01131 16.9666 4.97841C16.9687 4.96922 16.9725 4.96052 16.978 4.95282C16.9834 4.94512 16.9903 4.93856 16.9982 4.93352C17.0062 4.92849 17.0151 4.92507 17.0244 4.92346C17.0336 4.92185 17.0432 4.92209 17.0524 4.92416C17.0615 4.92623 17.0702 4.93009 17.0779 4.93551C17.0856 4.94094 17.0922 4.94784 17.0972 4.9558C17.1023 4.96376 17.1057 4.97264 17.1073 4.98192C17.1089 4.99121 17.1087 5.00072 17.1066 5.00991C17.0975 5.05331 16.8518 6.33221 16.7237 7.00281C16.7216 7.02338 16.7114 7.04228 16.6954 7.05539C16.6794 7.06851 16.6589 7.07477 16.6383 7.07281L16.6327 7.07001Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.0723 7.2548C17.0345 7.24297 17.0029 7.21695 16.9839 7.18221C16.965 7.14747 16.9603 7.10674 16.9708 7.0686C17.3621 5.1394 17.3824 5.0988 17.3964 5.0715C17.4039 5.05353 17.415 5.03732 17.4291 5.02391C17.4432 5.01049 17.4599 5.00016 17.4783 4.99357C17.4966 4.98698 17.516 4.98429 17.5355 4.98565C17.5549 4.98702 17.5738 4.99241 17.591 5.0015C17.622 5.02293 17.6448 5.05431 17.6557 5.09044C17.6665 5.12658 17.6647 5.16533 17.6505 5.2003C17.619 5.3137 17.388 6.4358 17.248 7.1239C17.2427 7.16413 17.2219 7.20069 17.19 7.22569C17.158 7.2507 17.1175 7.26216 17.0772 7.2576L17.0723 7.2548Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.3887 7.245C17.3695 7.23872 17.3534 7.22519 17.344 7.20728C17.3346 7.18937 17.3326 7.1685 17.3383 7.1491L17.794 5.2094C17.7983 5.19083 17.8097 5.17473 17.8259 5.16462C17.842 5.15451 17.8615 5.15123 17.8801 5.1555C17.8987 5.15977 17.9148 5.17124 17.9249 5.18739C17.935 5.20353 17.9383 5.22303 17.934 5.2416L17.479 7.1813C17.4774 7.19148 17.4738 7.20123 17.4683 7.20998C17.4629 7.21874 17.4557 7.22631 17.4473 7.23225C17.4389 7.23819 17.4294 7.24238 17.4193 7.24457C17.4092 7.24676 17.3988 7.2469 17.3887 7.245V7.245Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.6295 7.30171C17.6105 7.29572 17.5946 7.2826 17.585 7.26511C17.5755 7.24762 17.5731 7.22711 17.5784 7.20791C17.724 6.53031 17.9515 5.42221 17.955 5.28361C17.9519 5.26921 17.9522 5.25428 17.956 5.24004C17.9598 5.22581 17.9669 5.21267 17.9767 5.20171C17.9828 5.19424 17.9905 5.18822 17.9992 5.18409C18.0079 5.17995 18.0175 5.17781 18.0271 5.17781C18.0367 5.17781 18.0463 5.17995 18.055 5.18409C18.0637 5.18822 18.0714 5.19424 18.0775 5.20171C18.1083 5.23881 18.1377 5.27171 17.717 7.23661C17.714 7.25663 17.7034 7.2747 17.6873 7.28699C17.6712 7.29928 17.651 7.30481 17.6309 7.30241L17.6295 7.30171Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.7087 7.03711C15.6721 7.02473 15.6415 6.99891 15.6232 6.96487C15.6049 6.93082 15.6002 6.8911 15.61 6.85371L15.9964 4.79501C16.0007 4.75413 16.0208 4.71655 16.0525 4.69037C16.0842 4.66419 16.1248 4.65149 16.1658 4.65501C16.2046 4.66539 16.2377 4.69056 16.2581 4.72511C16.2786 4.75966 16.2846 4.80085 16.275 4.83981L15.8858 6.90201C15.8814 6.94295 15.8611 6.98053 15.8293 7.0067C15.7975 7.03287 15.7567 7.04554 15.7157 7.04201L15.7087 7.03711Z",
  fill: "#14B1A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M26.6987 27.0263C26.6987 27.0263 30.3107 8.17951 30.5697 7.93941C32.3778 8.23621 37.3947 9.25051 39.5423 9.68941C40.1975 9.82171 39.9469 11.9224 39.0572 11.7621C37.0272 11.396 33.3928 10.6071 32.2938 10.3817C31.9305 10.3068 28.8169 27.4575 28.8169 27.4575C28.6769 28.147 28.091 28.6097 27.5051 28.4914C26.9192 28.3731 26.5594 27.7151 26.6987 27.0263Z",
  fill: "#8E877F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M2.10561 26.4894C1.99151 27.0753 2.45911 27.6598 3.14931 27.7935L20.8656 31.241C21.5558 31.3754 22.2075 31.0093 22.3216 30.4234C22.435 29.8375 21.9681 29.2537 21.2772 29.1193L3.56161 25.6718C2.87211 25.5381 2.21971 25.9035 2.10561 26.4894V26.4894Z",
  fill: "#8E877F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M31.8045 30.7825C31.8045 31.9479 31.4589 33.0872 30.8114 34.0562C30.1639 35.0253 29.2436 35.7805 28.1669 36.2265C27.0902 36.6725 25.9054 36.7892 24.7623 36.5619C23.6193 36.3345 22.5693 35.7733 21.7452 34.9492C20.9211 34.1251 20.3599 33.0751 20.1325 31.9321C19.9052 30.789 20.0218 29.6042 20.4678 28.5275C20.9138 27.4508 21.6691 26.5305 22.6381 25.883C23.6072 25.2355 24.7465 24.8899 25.9119 24.8899C27.4747 24.8901 28.9734 25.511 30.0784 26.616C31.1834 27.721 31.8043 29.2197 31.8045 30.7825V30.7825Z",
  fill: "url(#paint0_linear_692_667)"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M25.9119 24.8899C24.7465 24.8899 23.6072 25.2355 22.6381 25.883C21.6691 26.5305 20.9138 27.4508 20.4678 28.5275C20.0218 29.6042 19.9052 30.789 20.1325 31.9321C20.3599 33.0751 20.9211 34.1251 21.7452 34.9492C22.5693 35.7733 23.6193 36.3345 24.7623 36.5619C25.9054 36.7892 27.0902 36.6725 28.1669 36.2265C29.2436 35.7805 30.1639 35.0253 30.8114 34.0562C31.4589 33.0872 31.8045 31.9479 31.8045 30.7825C31.8045 29.2197 31.1837 27.7209 30.0786 26.6158C28.9735 25.5107 27.4747 24.8899 25.9119 24.8899V24.8899Z",
  fill: "#DBD6D3"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M25.9119 24.8892C24.7463 24.8891 23.6068 25.2346 22.6376 25.8821C21.6683 26.5295 20.9129 27.4499 20.4667 28.5267C20.0205 29.6036 19.9037 30.7886 20.1311 31.9318C20.3584 33.075 20.9196 34.1252 21.7438 34.9494C22.5679 35.7737 23.618 36.3351 24.7612 36.5625C25.9044 36.79 27.0894 36.6733 28.1663 36.2273C29.2432 35.7812 30.1637 35.0259 30.8113 34.0567C31.4588 33.0875 31.8045 31.9481 31.8045 30.7825C31.8046 30.0086 31.6522 29.2423 31.3562 28.5273C31.0601 27.8123 30.626 27.1626 30.0788 26.6153C29.5317 26.0681 28.882 25.634 28.1671 25.3378C27.4521 25.0416 26.6858 24.8892 25.9119 24.8892V24.8892ZM25.9119 34.7172C25.1335 34.7173 24.3725 34.4866 23.7252 34.0542C23.078 33.6219 22.5734 33.0073 22.2755 32.2881C21.9776 31.569 21.8996 30.7777 22.0514 30.0142C22.2032 29.2507 22.578 28.5495 23.1285 27.999C23.6789 27.4486 24.3802 27.0738 25.1436 26.922C25.9071 26.7701 26.6984 26.8481 27.4175 27.1461C28.1367 27.444 28.7513 27.9486 29.1837 28.5958C29.616 29.2431 29.8467 30.0041 29.8466 30.7825C29.8469 31.2994 29.7453 31.8113 29.5477 32.289C29.3501 32.7666 29.0603 33.2007 28.6949 33.5663C28.3296 33.932 27.8957 34.2221 27.4182 34.42C26.9407 34.618 26.4288 34.7199 25.9119 34.72V34.7172Z",
  fill: "#645B55"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M27.8026 30.7825C27.8026 31.1563 27.6918 31.5217 27.4841 31.8325C27.2764 32.1433 26.9812 32.3856 26.6359 32.5286C26.2905 32.6717 25.9105 32.7091 25.5439 32.6362C25.1773 32.5633 24.8405 32.3833 24.5762 32.1189C24.3118 31.8546 24.1318 31.5178 24.0589 31.1512C23.986 30.7846 24.0234 30.4046 24.1665 30.0592C24.3095 29.7139 24.5518 29.4187 24.8626 29.211C25.1734 29.0033 25.5388 28.8925 25.9126 28.8925C26.4139 28.8925 26.8946 29.0916 27.249 29.4461C27.6035 29.8005 27.8026 30.2812 27.8026 30.7825V30.7825Z",
  fill: "#423C38"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M32.837 8.3531C35.077 8.7822 38.024 9.3779 39.5423 9.6831C40.1975 9.8154 39.9469 11.9161 39.0572 11.7558C37.0797 11.3988 33.5846 10.6421 32.3897 10.395L32.837 8.3531Z",
  fill: "#645B55"
}), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("linearGradient", {
  id: "paint0_linear_692_667",
  x1: "25.9119",
  y1: "25.2266",
  x2: "25.9119",
  y2: "35.3171",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React__namespace.createElement("stop", {
  "stop-color": "#595959"
}), /*#__PURE__*/React__namespace.createElement("stop", {
  offset: "1"
}))));

const FinishDeclaration = props => /*#__PURE__*/React__namespace.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M36.2544 22.3811C36.9992 21.7681 37.5582 20.9596 37.8687 20.0463C38.1791 19.133 38.2287 18.1513 38.0119 17.2114C37.795 16.2715 37.3203 15.4107 36.6411 14.7258C35.9618 14.0409 35.1051 13.559 34.167 13.3343C34.513 12.3219 34.5373 11.2273 34.2368 10.2006C33.9362 9.1738 33.3254 8.26514 32.4881 7.59914C31.6509 6.93313 30.6281 6.5424 29.56 6.48051C28.492 6.41861 27.4309 6.68858 26.5223 7.2534C26.1693 6.20655 25.4913 5.29975 24.587 4.66508C23.6828 4.03042 22.5995 3.70105 21.495 3.72495C20.3905 3.74886 19.3224 4.12479 18.4465 4.79798C17.5705 5.47117 16.9324 6.40646 16.625 7.4676C15.7271 6.8143 14.6432 6.46637 13.5328 6.47497C12.4224 6.48357 11.344 6.84825 10.4563 7.51539C9.56859 8.18252 8.91837 9.11689 8.60127 10.1811C8.28417 11.2453 8.31692 12.3832 8.6947 13.4274C7.48508 13.5089 6.34224 14.0116 5.46474 14.8481C4.58724 15.6847 4.03054 16.8022 3.89135 18.0065C3.75216 19.2109 4.03929 20.4259 4.70285 21.4406C5.36641 22.4552 6.36446 23.2053 7.5236 23.5606C6.44712 24.2633 5.66998 25.3408 5.34294 26.5841C5.01589 27.8273 5.16223 29.1477 5.75358 30.2892C6.34493 31.4306 7.33915 32.3118 8.54338 32.7617C9.74762 33.2117 11.076 33.1983 12.271 32.7243C12.2626 32.8454 12.2563 32.9672 12.2563 33.0904C12.2563 34.2931 12.6743 35.4585 13.4387 36.387C14.2032 37.3156 15.2665 37.9496 16.4468 38.1807C17.6272 38.4117 18.8511 38.2254 19.9092 37.6536C20.9673 37.0819 21.7939 36.1601 22.2474 35.0462C22.8469 36.1387 23.8196 36.9787 24.9877 37.4128C26.1558 37.8468 27.4412 37.8457 28.6085 37.4098C29.7759 36.9738 30.7473 36.1321 31.345 35.0387C31.9426 33.9453 32.1266 32.6732 31.8633 31.4552C32.9999 31.7002 34.1858 31.5563 35.2307 31.0466C36.2757 30.5368 37.1191 29.6907 37.6256 28.6441C38.132 27.5976 38.2722 26.4112 38.0235 25.2754C37.7749 24.1396 37.1518 23.1203 36.2544 22.3811V22.3811Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21 33.4488C27.8753 33.4488 33.4488 27.8753 33.4488 21C33.4488 14.1247 27.8753 8.55121 21 8.55121C14.1247 8.55121 8.5512 14.1247 8.5512 21C8.5512 27.8753 14.1247 33.4488 21 33.4488Z",
  stroke: "#FFFCFA",
  "stroke-width": "0.98",
  "stroke-miterlimit": "10"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21 33.4488C27.8753 33.4488 33.4488 27.8753 33.4488 21C33.4488 14.1247 27.8753 8.55121 21 8.55121C14.1247 8.55121 8.5512 14.1247 8.5512 21C8.5512 27.8753 14.1247 33.4488 21 33.4488Z",
  stroke: "#EDEBE9",
  "stroke-width": "0.98",
  "stroke-miterlimit": "10"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M29.0479 17.1458H25.3932C24.9053 17.1458 24.5098 17.5413 24.5098 18.0292V18.8524C24.5098 19.3403 24.9053 19.7358 25.3932 19.7358H29.0479C29.5358 19.7358 29.9313 19.3403 29.9313 18.8524V18.0292C29.9313 17.5413 29.5358 17.1458 29.0479 17.1458Z",
  fill: "#F8B272"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M29.9313 18.0292V19.1492C29.9301 19.3671 29.8523 19.5777 29.7115 19.744C29.5708 19.9104 29.376 20.0219 29.1613 20.0592C29.2938 20.1356 29.4039 20.2454 29.4806 20.3777C29.5572 20.51 29.5978 20.6602 29.5981 20.8131V21.3864C29.5974 21.5689 29.5398 21.7465 29.4332 21.8946C29.3267 22.0427 29.1766 22.1538 29.0038 22.2124C29.086 22.2878 29.1517 22.3794 29.1966 22.4814C29.2416 22.5835 29.2648 22.6938 29.2649 22.8053V23.1777C29.2643 23.3915 29.1792 23.5963 29.0281 23.7476C28.877 23.8988 28.6723 23.9841 28.4585 23.9848H28.3885C28.4779 24.0619 28.5496 24.1573 28.5987 24.2646C28.6479 24.3718 28.6734 24.4884 28.6734 24.6064V25.0341C28.6727 25.2529 28.5854 25.4625 28.4306 25.6171C28.2758 25.7718 28.0662 25.8589 27.8474 25.8594H24.521C24.4629 25.8594 24.4049 25.8533 24.3481 25.8412H21.1085C20.8074 25.841 20.5175 25.7272 20.2965 25.5227C19.9969 25.2462 19.5685 24.3866 19.348 24.3698H17.598V18.4898H19.6C19.6 18.4898 21.4592 16.408 21.7091 15.5204C21.8946 14.861 21.8813 13.9265 21.8617 13.4904C21.8589 13.4175 21.882 13.346 21.927 13.2885C21.972 13.2311 22.0359 13.1915 22.1074 13.1768C22.8956 13.013 25.1769 12.9283 24.6232 17.6316H28.2219C28.3225 17.6316 28.419 17.5916 28.4902 17.5205C28.5613 17.4493 28.6013 17.3528 28.6013 17.2522V17.1507H29.05C29.2829 17.1518 29.506 17.2446 29.671 17.4091C29.8359 17.5735 29.9295 17.7963 29.9313 18.0292V18.0292Z",
  fill: "#FEE9D7"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.4745 17.2704C23.4703 17.3155 23.4756 17.361 23.49 17.404C23.5043 17.447 23.5275 17.4865 23.558 17.52C23.5885 17.5535 23.6256 17.5803 23.6671 17.5987C23.7085 17.6171 23.7533 17.6266 23.7986 17.6267H24.6211C25.1741 12.9241 22.8942 13.0067 22.1053 13.1712C22.0765 13.1774 22.0487 13.1876 22.0227 13.2013C22.8648 13.4554 23.7391 14.3871 23.4745 17.2704Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M29.05 17.1458H28.6013V17.2473C28.6012 17.3221 28.5791 17.3951 28.5376 17.4573C28.6736 17.6168 28.7481 17.8196 28.7476 18.0292V19.1492C28.7465 19.3672 28.6688 19.5778 28.528 19.7442C28.3872 19.9106 28.1924 20.0221 27.9776 20.0592C28.11 20.1356 28.22 20.2455 28.2966 20.3778C28.3731 20.5101 28.4135 20.6603 28.4137 20.8131V21.3864C28.4131 21.5689 28.3555 21.7466 28.249 21.8947C28.1424 22.0428 27.9922 22.1539 27.8194 22.2124C27.9017 22.2877 27.9675 22.3793 28.0125 22.4814C28.0576 22.5835 28.081 22.6938 28.0812 22.8053V23.1777C28.0805 23.3916 27.9952 23.5964 27.844 23.7476C27.6928 23.8988 27.4879 23.9841 27.2741 23.9848H27.2041C27.2932 24.062 27.3647 24.1575 27.4138 24.2647C27.4628 24.372 27.4882 24.4885 27.4883 24.6064V25.0341C27.4876 25.2528 27.4004 25.4623 27.2458 25.6169C27.0911 25.7715 26.8817 25.8587 26.663 25.8594H27.8474C28.0661 25.8587 28.2755 25.7715 28.4302 25.6169C28.5848 25.4623 28.672 25.2528 28.6727 25.0341V24.6064C28.6727 24.4884 28.6472 24.3718 28.598 24.2646C28.5489 24.1573 28.4772 24.0619 28.3878 23.9848H28.4578C28.6716 23.9841 28.8764 23.8988 29.0274 23.7476C29.1785 23.5964 29.2636 23.3915 29.2642 23.1777V22.806C29.2641 22.6945 29.2409 22.5842 29.1959 22.4822C29.151 22.3801 29.0853 22.2885 29.0031 22.2131C29.1759 22.1546 29.3261 22.0435 29.4327 21.8954C29.5392 21.7473 29.5968 21.5696 29.5974 21.3871V20.8138C29.5971 20.6609 29.5565 20.5107 29.4799 20.3784C29.4032 20.2461 29.2931 20.1363 29.1606 20.0599C29.3753 20.0227 29.5701 19.9111 29.7108 19.7447C29.8516 19.5784 29.9294 19.3678 29.9306 19.1499V18.0299C29.9302 17.7962 29.8374 17.572 29.6725 17.4064C29.5075 17.2408 29.2838 17.1471 29.05 17.1458V17.1458Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19.5419 18.487H17.5994V24.367H18.4877V19.7099C18.4877 19.5799 18.5177 19.4516 18.5753 19.335C18.633 19.2185 18.7168 19.1168 18.8202 19.0379L19.5419 18.487Z",
  fill: "#FBC89A"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.9326 18.4653V25.55C17.9326 25.6327 17.8998 25.712 17.8414 25.7705C17.783 25.8291 17.7038 25.862 17.6211 25.8622H13.4855C13.4027 25.8622 13.3233 25.8293 13.2647 25.7708C13.2062 25.7122 13.1733 25.6328 13.1733 25.55V18.4653C13.1735 18.3826 13.2065 18.3034 13.265 18.245C13.3235 18.1866 13.4028 18.1538 13.4855 18.1538H17.6211C17.7037 18.154 17.7828 18.1869 17.8412 18.2453C17.8995 18.3036 17.9324 18.3828 17.9326 18.4653Z",
  fill: "#FFFCFA"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.9326 18.4653V25.55C17.9326 25.6327 17.8998 25.712 17.8414 25.7705C17.783 25.8291 17.7038 25.862 17.6211 25.8622H13.4855C13.4027 25.8622 13.3233 25.8293 13.2647 25.7708C13.2062 25.7122 13.1733 25.6328 13.1733 25.55V18.4653C13.1735 18.3826 13.2065 18.3034 13.265 18.245C13.3235 18.1866 13.4028 18.1538 13.4855 18.1538H17.6211C17.7037 18.154 17.7828 18.1869 17.8412 18.2453C17.8995 18.3036 17.9324 18.3828 17.9326 18.4653Z",
  fill: "#EDEBE9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.9326 24.3705V25.55C17.9326 25.6327 17.8998 25.712 17.8414 25.7705C17.783 25.8291 17.7038 25.862 17.6211 25.8622H13.4855C13.4027 25.8622 13.3233 25.8293 13.2647 25.7708C13.2062 25.7122 13.1733 25.6328 13.1733 25.55V24.3705H17.9326Z",
  fill: "#8AC58D"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.2848 25.0194C16.6621 25.0194 16.968 24.7135 16.968 24.3362C16.968 23.9589 16.6621 23.653 16.2848 23.653C15.9075 23.653 15.6016 23.9589 15.6016 24.3362C15.6016 24.7135 15.9075 25.0194 16.2848 25.0194Z",
  fill: "#655B53"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.2848 25.0194C16.6621 25.0194 16.968 24.7135 16.968 24.3362C16.968 23.9589 16.6621 23.653 16.2848 23.653C15.9075 23.653 15.6016 23.9589 15.6016 24.3362C15.6016 24.7135 15.9075 25.0194 16.2848 25.0194Z",
  fill: "#4F4740"
}));

const MonitorStatus = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  fill: "none"
}, props), /*#__PURE__*/React__namespace.createElement("path", {
  width: 42,
  height: 42,
  d: "M0 0H100V100H0V0z"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M28.267 16.544L27.333 47.05L28.543 61.252L31.303 63.906L58.901 64.904L76.585 63.375C76.585 63.375 85.989 64.055 86.584 64.055C87.178 64.055 86.18 42.974 86.18 42.974L86.456 18.009C86.248 16.745 85.701 15.561 84.876 14.582C84.05 13.603 82.975 12.866 81.765 12.447C77.413 10.685 30.518 12.808 30.518 12.808L28.267 16.544Z",
  fill: "#1DB2A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M79.811 18.2H34.976C33.85 18.2 32.938 19.112 32.938 20.238V55.436C32.938 56.561 33.85 57.474 34.976 57.474H79.811C80.937 57.474 81.85 56.561 81.85 55.436V20.238C81.85 19.112 80.937 18.2 79.811 18.2Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M83.866 14.931C84.009 14.831 84.123 14.696 84.196 14.538C84.269 14.38 84.298 14.205 84.281 14.032C84.263 13.858 84.2 13.693 84.097 13.553C83.995 13.412 83.856 13.302 83.696 13.232C75.927 11.11 67.032 11.11 59.028 11.11C50.822 10.974 42.619 11.543 34.509 12.808C34.296 12.808 34.36 13.211 34.509 13.211C42.661 13.487 50.834 13.551 58.986 13.869C66.522 14.188 74.313 15.377 81.85 15.207C84.524 17.584 84.291 23.337 84.44 26.777C84.588 29.685 84.715 32.593 85.119 35.48C85.119 35.565 85.152 35.646 85.212 35.706C85.272 35.765 85.353 35.799 85.437 35.799C85.522 35.799 85.603 35.765 85.662 35.706C85.722 35.646 85.756 35.565 85.756 35.48C86.414 32.806 87.242 17.521 83.866 14.931Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M31.43 13.508C30.369 13.784 29.626 15.079 29.117 16.077C28.554 17.139 28.304 18.339 28.395 19.537C28.405 19.581 28.426 19.622 28.457 19.655C28.488 19.688 28.527 19.712 28.57 19.725C28.613 19.738 28.659 19.739 28.703 19.728C28.747 19.718 28.787 19.696 28.819 19.665C29.414 18.816 29.817 17.818 30.348 16.905C30.997 16.059 31.546 15.14 31.982 14.166C32.015 14.085 32.025 13.996 32.01 13.909C31.996 13.822 31.959 13.74 31.903 13.673C31.846 13.606 31.772 13.555 31.689 13.526C31.606 13.497 31.517 13.491 31.43 13.508V13.508Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M32.492 25.545C32.547 22.699 32.32 19.855 31.813 17.054C31.813 16.926 31.643 17.054 31.6 17.054C30.973 20.061 30.801 23.145 31.091 26.203C31.038 29.3 31.351 32.393 32.025 35.417C32.174 35.99 32.853 35.841 32.895 35.289C32.972 32.036 32.837 28.781 32.492 25.545V25.545Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M32.662 36.16C32.645 36.097 32.607 36.042 32.555 36.002C32.504 35.963 32.44 35.941 32.375 35.941C32.31 35.941 32.247 35.963 32.195 36.002C32.143 36.042 32.106 36.097 32.089 36.16C32.089 36.542 31.94 36.945 31.876 37.349C31.31 39.465 31.173 41.674 31.473 43.845C31.496 45.405 31.696 46.957 32.067 48.473C32.085 48.535 32.122 48.591 32.174 48.63C32.225 48.67 32.289 48.691 32.354 48.691C32.419 48.691 32.482 48.67 32.534 48.63C32.586 48.591 32.623 48.535 32.641 48.473C33.52 44.416 33.527 40.219 32.662 36.16V36.16Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M63.656 59.958C59.027 58.915 54.304 58.345 49.56 58.259C44.875 57.605 40.129 57.512 35.422 57.983C35.188 57.983 35.188 58.493 35.422 58.556C39.771 59.358 44.183 59.77 48.605 59.788C53.566 60.437 58.568 60.727 63.571 60.658C63.654 60.651 63.731 60.615 63.79 60.558C63.849 60.5 63.887 60.424 63.897 60.342C63.907 60.26 63.888 60.177 63.845 60.107C63.801 60.037 63.734 59.985 63.656 59.958V59.958Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M40.644 45.649C39.359 45.209 37.997 45.036 36.642 45.142C35.288 45.248 33.969 45.63 32.768 46.265C32.027 46.087 31.254 46.091 30.515 46.275C29.776 46.46 29.092 46.821 28.522 47.326C28.677 46.977 28.727 46.591 28.667 46.215C28.606 45.838 28.438 45.486 28.182 45.203C28.033 45.029 27.847 44.888 27.639 44.792C27.43 44.696 27.202 44.646 26.972 44.646C26.742 44.646 26.515 44.696 26.306 44.792C26.097 44.888 25.912 45.029 25.762 45.203C25.453 45.589 25.255 46.051 25.189 46.541H24.977C23.023 48.027 21.685 50.181 21.219 52.591C20.943 53.674 20.561 54.926 20.37 56.179C20.37 56.455 20.179 56.71 20.115 56.922C19.588 58.529 19.191 60.176 18.927 61.847C18.741 62.013 18.601 62.225 18.523 62.463L18.099 63.715C17.728 63.837 17.392 64.048 17.122 64.331C16.871 64.618 16.714 64.976 16.672 65.355C16.63 65.735 16.706 66.118 16.889 66.454C17.019 66.724 17.23 66.946 17.492 67.091C17.755 67.235 18.056 67.295 18.353 67.26C18.68 67.62 19.06 67.927 19.479 68.173C20.88 69.086 22.323 69.956 23.724 70.784C24.327 71.185 24.967 71.526 25.635 71.803C25.822 72.268 26.168 72.652 26.611 72.886C26.968 73.05 27.368 73.092 27.751 73.008C28.134 72.924 28.48 72.717 28.735 72.419V72.419C29.626 71.57 30.22 70.296 31.048 69.447C31.876 68.598 33.065 67.834 33.405 66.496C33.532 66.079 33.497 65.629 33.309 65.236C33.12 64.843 32.791 64.535 32.386 64.373C32.071 64.309 31.746 64.309 31.43 64.373C30.964 64.097 30.518 63.715 30.051 63.503C29.366 63.21 28.718 62.84 28.119 62.399C29.121 60.434 29.555 58.228 29.371 56.03C30.616 53.872 32.036 51.82 33.617 49.895C34.442 50.066 35.298 50.022 36.101 49.768C37.031 49.721 37.929 49.412 38.691 48.876C39.484 48.722 40.25 48.45 40.962 48.069C41.981 47.602 41.599 46.074 40.644 45.649Z",
  fill: "#EEF7F9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M27.588 73.862C23.947 72.582 20.694 70.389 18.141 67.494C17.796 67.264 17.391 67.14 16.977 67.138C16.562 67.136 16.156 67.255 15.809 67.48C15.461 67.706 15.187 68.029 15.021 68.408C14.854 68.788 14.802 69.208 14.872 69.617V69.786C14.314 70.063 13.866 70.52 13.598 71.081C12.786 72.632 12.076 74.235 11.475 75.879H11.327C10.286 76.304 9.968 78.469 11.327 78.681H11.539C11.697 78.877 11.912 79.018 12.155 79.085C12.597 79.159 13.049 79.159 13.492 79.085C15.329 79.551 17.05 80.391 18.548 81.553C20.046 82.714 21.287 84.172 22.196 85.836C22.437 86.224 22.811 86.511 23.247 86.645C23.684 86.779 24.155 86.75 24.572 86.563C24.989 86.376 25.324 86.045 25.516 85.63C25.707 85.216 25.742 84.746 25.614 84.307C26.155 83.535 26.451 82.618 26.463 81.675C26.68 80.22 27.438 78.901 28.586 77.981C28.851 77.665 29.038 77.291 29.132 76.89C29.226 76.488 29.224 76.07 29.127 75.67C29.03 75.269 28.84 74.897 28.573 74.583C28.305 74.269 27.968 74.022 27.588 73.862V73.862Z",
  fill: "#056667"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.13 77.429C21.517 75.816 19.755 74.308 18.035 72.865C16.952 71.973 15.424 70.487 14.256 71.782C14.241 71.804 14.232 71.83 14.232 71.856C14.232 71.883 14.241 71.909 14.256 71.931C14.872 73.056 16.103 73.565 17.016 74.415C17.929 75.264 19.245 76.686 20.37 77.811C21.065 78.309 21.652 78.941 22.097 79.671C22.542 80.4 22.835 81.212 22.96 82.057C22.856 83.11 22.935 84.173 23.194 85.199C23.243 85.311 23.323 85.406 23.424 85.474C23.526 85.542 23.645 85.579 23.767 85.581C25.295 85.708 25.996 83.968 25.89 82.418C25.572 80.487 24.597 78.724 23.13 77.429Z",
  fill: "#1DB2A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M33.638 65.095C33.316 64.852 32.935 64.698 32.534 64.649C32.025 64.225 31.685 64.394 31.006 64.267C29.881 64.055 29.456 63.121 29.138 61.974C29.138 61.693 29.026 61.423 28.827 61.224C28.628 61.025 28.358 60.913 28.076 60.913C27.795 60.913 27.525 61.025 27.326 61.224C27.127 61.423 27.015 61.693 27.015 61.974C27.015 62.25 27.015 62.569 27.015 62.823C26.845 63.503 27.44 62.569 26.739 63.503C26.63 63.66 26.51 63.81 26.378 63.949V63.949C25.975 63.949 25.635 64.394 25.635 64.798C25.511 64.943 25.376 65.078 25.232 65.201L25.338 65.371L25.677 65.159C25.677 65.498 26.102 65.795 26.42 65.711C27.583 66.259 28.834 66.597 30.114 66.708C31.303 66.815 32.895 67.005 33.787 65.965C33.88 65.829 33.916 65.662 33.888 65.5C33.86 65.338 33.771 65.193 33.638 65.095V65.095Z",
  fill: "#94D1D0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M72.785 62.654H72.657H72.275H71.702H70.874C70.266 62.696 69.656 62.696 69.048 62.654C68.292 62.707 67.533 62.707 66.777 62.654H65.885C65.425 62.77 64.944 62.77 64.484 62.654H64.335C64.019 62.707 63.696 62.707 63.38 62.654C63.38 62.654 63.38 62.654 63.38 62.654H62.361H61.894H61.47C61.195 62.742 60.909 62.792 60.62 62.802C60.557 62.802 60.494 62.789 60.435 62.763C60.377 62.737 60.324 62.7 60.281 62.654V62.654H58.986L59.113 62.547C57.413 62.865 55.678 62.951 53.955 62.802C51.911 62.806 49.87 62.927 47.84 63.163C47.77 63.173 47.699 63.163 47.635 63.133C47.57 63.102 47.516 63.054 47.48 62.993H46.524C46.093 63.025 45.66 63.025 45.23 62.993H44.359C44.078 63.036 43.791 63.036 43.51 62.993H41.981H40.856C40.673 63.015 40.488 63.015 40.304 62.993H37.184H37.014H36.589H35.528C35.197 63.046 34.86 63.046 34.53 62.993H33.32H33.214H32.874C32.812 63.025 32.743 63.041 32.672 63.041C32.602 63.041 32.533 63.025 32.471 62.993C32.08 62.972 31.69 62.929 31.303 62.866C31.221 62.887 31.135 62.886 31.053 62.864C30.971 62.842 30.896 62.799 30.836 62.739V62.739L30.22 62.505C30.146 62.513 30.071 62.503 30.002 62.477C29.932 62.452 29.869 62.41 29.817 62.356V62.356C29.69 62.298 29.569 62.227 29.456 62.144C29.333 62.104 29.228 62.021 29.159 61.91V61.91C28.987 61.756 28.831 61.585 28.692 61.401C28.626 61.373 28.568 61.329 28.522 61.274C28.455 61.187 28.411 61.085 28.395 60.976V60.976C28.253 60.699 28.139 60.407 28.055 60.106V60.106C28.034 60.001 28.034 59.893 28.055 59.788C28.079 59.675 28.122 59.567 28.182 59.469V59.469C28.682 58.554 29.115 57.603 29.477 56.625V56.476C29.69 55.881 29.86 55.287 30.051 54.735V54.459C30.205 54.002 30.404 53.561 30.645 53.143C30.979 52.543 31.461 52.039 32.046 51.678L32.747 51.254V52.081C32.768 52.165 32.768 52.253 32.747 52.336V52.336C32.747 53.907 32.747 55.478 32.747 57.07C32.741 57.163 32.77 57.254 32.83 57.325C32.889 57.396 32.973 57.442 33.065 57.452C39.561 57.835 46.142 57.665 52.638 57.771C59.135 57.877 65.567 58.153 72.042 58.153L71.553 58.726C71.591 58.758 71.621 58.797 71.643 58.84C71.665 58.884 71.678 58.932 71.681 58.981V59.087C71.914 58.79 72.169 58.493 72.424 58.217L72.679 59.342L72.233 59.809L72.53 60.021L72.785 59.745L72.891 60.149C72.966 60.096 73.055 60.069 73.146 60.069C73.237 60.069 73.326 60.096 73.4 60.149L73.443 59.639C73.461 59.612 73.472 59.582 73.476 59.55C73.479 59.517 73.474 59.485 73.461 59.455C73.448 59.426 73.428 59.4 73.403 59.38C73.377 59.36 73.347 59.347 73.315 59.342L73.061 58.11L73.252 57.686H72.891V57.389L72.211 57.155C72.211 57.346 72.211 57.537 72.36 57.729C65.864 57.389 59.325 57.389 52.787 57.389C46.248 57.389 39.922 56.858 33.511 56.985C33.384 55.096 33.362 53.207 33.193 51.317C33.779 50.978 34.263 50.487 34.594 49.895C34.7 49.661 34.403 49.449 34.275 49.661C33.97 50.115 33.572 50.498 33.108 50.787C33.08 50.768 33.047 50.757 33.013 50.755C32.98 50.752 32.946 50.759 32.916 50.774C32.885 50.79 32.86 50.812 32.841 50.84C32.823 50.869 32.812 50.901 32.81 50.935V50.935C32.169 51.241 31.563 51.619 31.006 52.06C30.21 52.881 29.684 53.925 29.499 55.054C29.483 55.09 29.475 55.13 29.475 55.17C29.475 55.21 29.483 55.25 29.499 55.287C28.495 58.65 26.755 61.747 24.404 64.352C24.298 64.479 24.404 64.692 24.595 64.564C25.75 63.355 26.762 62.015 27.609 60.573C27.681 60.932 27.795 61.281 27.949 61.613C27.949 61.762 27.949 61.974 28.098 61.932C28.535 62.568 29.117 63.092 29.796 63.461C30.475 63.83 31.231 64.034 32.004 64.055C32.471 64.055 32.917 64.055 33.362 64.055C31.728 67.366 29.117 69.51 26.994 72.44L25.635 71.612C24.616 70.933 23.3 70.126 22.047 69.383C19.924 68.046 17.674 66.666 15.424 65.456C15.427 65.406 15.413 65.358 15.385 65.317C15.356 65.277 15.314 65.248 15.266 65.236C15.218 65.223 15.168 65.228 15.123 65.249C15.078 65.269 15.042 65.305 15.02 65.35C14.426 66.56 13.938 67.834 13.365 69.065C13.301 69.147 13.266 69.248 13.266 69.351C13.266 69.455 13.301 69.556 13.365 69.638C11.751 71.973 9.947 74.223 8.333 76.622H8.991C9.48 75.922 9.989 75.221 10.499 74.5C10.509 74.513 10.521 74.523 10.536 74.531C10.551 74.538 10.567 74.542 10.584 74.542C10.6 74.542 10.616 74.538 10.631 74.531C10.646 74.523 10.659 74.513 10.669 74.5L14.384 71.527C14.575 71.379 14.384 71.018 14.214 71.166L11.178 73.799L11.772 72.95C11.786 72.972 11.804 72.99 11.827 73.002C11.849 73.015 11.874 73.022 11.9 73.022C11.925 73.022 11.951 73.015 11.973 73.002C11.995 72.99 12.014 72.972 12.027 72.95L14.511 70.36C16.91 72.164 19.351 73.863 21.771 75.582L18.396 77.96C18.371 77.998 18.358 78.042 18.358 78.087C18.358 78.132 18.371 78.177 18.396 78.215V78.215C18.162 78.215 18.162 78.618 18.396 78.618C18.428 78.618 18.46 78.609 18.488 78.593C18.517 78.577 18.54 78.555 18.557 78.527C18.574 78.499 18.584 78.468 18.585 78.435C18.587 78.403 18.58 78.371 18.566 78.342C18.576 78.355 18.588 78.366 18.603 78.373C18.618 78.38 18.634 78.384 18.651 78.384C18.667 78.384 18.683 78.38 18.698 78.373C18.713 78.366 18.726 78.355 18.736 78.342L22.09 76.028C22.103 75.998 22.11 75.965 22.11 75.932C22.11 75.9 22.103 75.867 22.09 75.837L22.684 76.261L19.457 78.894C19.288 79.042 19.457 79.34 19.712 79.17L22.918 76.495L23.597 76.983L20.37 79.467C20.179 79.616 20.37 79.976 20.54 79.828L23.852 77.174H23.979C24.547 77.68 25.222 78.05 25.953 78.257V78.257C25.671 80.657 24.997 82.995 23.958 85.178H24.382C25.463 83.022 26.126 80.681 26.335 78.278V78.278C26.469 78.3 26.605 78.3 26.739 78.278C27.182 78.09 27.535 77.736 27.721 77.292C27.908 76.848 27.913 76.349 27.737 75.9C27.609 75.603 27.227 75.9 27.27 76.113C27.482 77.238 26.23 77.641 25.529 77.344C25.34 77.259 25.162 77.152 24.998 77.026C24.998 77.026 24.998 77.026 24.998 77.026L24.319 76.495C23.342 75.752 22.366 75.051 21.368 74.372C18.948 72.652 16.57 70.848 14.129 69.213C14.511 68.11 14.957 67.09 15.318 65.902C17.441 67.536 19.564 68.959 21.814 70.381L25.147 72.504C26.154 73.263 27.227 73.931 28.352 74.5C28.692 74.627 29.01 74.075 28.735 73.799C28.338 73.439 27.912 73.112 27.461 72.822C30.139 70.489 32.264 67.588 33.681 64.331C33.702 64.276 33.702 64.215 33.681 64.161H36.08H36.186L47.119 63.949C55.504 63.758 63.911 63.8 72.296 63.397C72.423 63.332 72.559 63.289 72.7 63.269C72.784 63.25 72.871 63.25 72.955 63.269C72.955 63.015 72.955 62.781 72.955 62.526C72.97 62.5 72.977 62.471 72.977 62.441C72.977 62.411 72.97 62.382 72.955 62.356C72.95 62.415 72.932 62.473 72.903 62.524C72.873 62.575 72.833 62.62 72.785 62.654V62.654ZM14.214 70.126C13.577 70.763 12.961 71.421 12.324 72.079C12.834 71.336 13.301 70.572 13.747 69.787L14.214 70.126Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M87.22 34.61C87.22 30.555 87.348 26.5 87.369 22.446C87.667 19.688 86.999 16.912 85.48 14.591C84.639 13.767 83.643 13.118 82.55 12.68C81.457 12.243 80.288 12.027 79.111 12.043C75.672 11.768 72.212 11.683 68.751 11.555C61.675 11.3 54.542 11.208 47.352 11.279C43.552 11.279 39.731 11.279 35.974 11.576C34.547 11.562 33.134 11.853 31.83 12.432C30.526 13.011 29.362 13.863 28.416 14.931C28.289 15.1 28.416 15.334 28.607 15.164L29.223 14.591C28.316 15.631 27.792 16.949 27.737 18.327C27.418 21.384 27.609 24.696 27.588 27.668V30.746C27.555 30.785 27.537 30.834 27.537 30.884C27.537 30.935 27.555 30.984 27.588 31.022C27.588 31.786 27.588 32.551 27.588 33.294C27.567 33.363 27.567 33.437 27.588 33.506C27.588 34.865 27.588 36.223 27.588 37.603V42.528C27.588 43.208 27.588 43.908 27.588 44.651C27.559 44.636 27.526 44.629 27.493 44.629C27.459 44.629 27.427 44.636 27.397 44.651C24.255 45.692 22.387 49.492 21.241 52.697C19.674 57.286 18.356 61.956 17.292 66.687C17.292 66.878 17.462 66.942 17.526 66.687C18.905 62.717 20.052 58.663 21.283 54.629C21.777 52.627 22.534 50.7 23.533 48.897C24.517 47.33 25.874 46.032 27.482 45.118V45.118C27.47 45.828 27.506 46.537 27.588 47.241L26.442 47.899C26.314 47.899 26.442 48.197 26.548 48.133L27.673 47.623C27.693 47.669 27.725 47.708 27.767 47.735C27.809 47.762 27.857 47.776 27.907 47.776C27.956 47.776 28.005 47.762 28.046 47.735C28.088 47.708 28.12 47.669 28.14 47.623V47.496C30.067 46.7 32.085 46.144 34.148 45.84C35.09 45.71 36.041 45.653 36.993 45.67C36.589 48.494 40.219 47.581 41.684 47.793C40.943 48.621 40.085 49.336 39.137 49.916C37.978 50.483 36.681 50.704 35.4 50.553C35.294 50.553 35.252 50.744 35.4 50.765C36.705 51.11 38.088 51.016 39.335 50.499C40.581 49.981 41.623 49.067 42.3 47.899C42.31 47.857 42.31 47.814 42.3 47.772V47.623C42.384 47.374 42.404 47.108 42.36 46.848C42.315 46.589 42.207 46.345 42.045 46.137C42.279 46.031 42.3 45.564 42.045 45.479C39.386 44.672 36.564 44.562 33.851 45.161C33.967 42.919 33.967 40.673 33.851 38.431C33.851 36.139 33.745 33.846 33.681 31.553C33.554 27.307 33.681 22.785 33.235 18.455C33.245 18.498 33.269 18.536 33.304 18.563C33.339 18.59 33.382 18.604 33.426 18.603C41.387 19.007 49.39 18.773 57.372 18.964C61.321 18.964 65.27 19.176 69.218 19.325C73.167 19.474 77.243 19.877 81.234 19.835C81.234 21.448 81.34 23.083 81.383 24.696L81.255 24.845C81.227 24.873 81.207 24.909 81.198 24.948C81.19 24.987 81.192 25.027 81.205 25.065C81.219 25.103 81.242 25.136 81.274 25.161C81.305 25.186 81.343 25.201 81.383 25.205L81.828 41L82.147 51.615C82.147 52.549 82.147 53.461 82.147 54.374C82.114 54.413 82.096 54.462 82.096 54.512C82.096 54.563 82.114 54.612 82.147 54.65C82.147 54.947 82.147 55.266 82.147 55.584V55.733C82.147 55.881 82.147 56.009 82.147 56.03C82.147 56.051 82.147 56.455 82.147 56.667C82.147 57.92 82.019 57.92 81.043 58.089C80.066 58.259 79.514 58.323 78.771 58.514C78.746 58.384 78.71 58.256 78.665 58.132C78.514 58.381 78.292 58.58 78.028 58.705C78.388 60.239 78.842 61.749 79.387 63.227C79.387 63.439 79.727 63.227 79.705 63.078L79.451 61.592C79.605 61.319 79.799 61.068 80.024 60.849V60.849C79.833 60.849 79.663 60.679 79.472 60.594L79.323 60.849C79.323 60.722 79.323 60.573 79.323 60.425C79.323 60.276 79.323 60.425 79.323 60.425C79.281 60.293 79.281 60.152 79.323 60.021C79.323 60.021 79.323 60.021 79.323 60.021C79.312 60.04 79.306 60.062 79.306 60.085C79.306 60.107 79.312 60.129 79.323 60.149C79.323 60.149 79.323 60.042 79.323 59.979C79.26 59.904 79.215 59.814 79.192 59.718C79.17 59.622 79.171 59.522 79.196 59.427V59.13H79.451C79.877 58.893 80.372 58.811 80.852 58.896C81.26 58.929 81.67 58.885 82.062 58.769V58.769L82.699 57.389C82.722 57.32 82.767 57.26 82.826 57.219C82.974 56.369 82.974 55.5 82.826 54.65C82.838 54.068 82.88 53.487 82.954 52.91V52.91C82.91 52.585 82.91 52.257 82.954 51.933C82.922 51.615 82.922 51.295 82.954 50.978C82.954 50.659 82.954 50.341 82.954 50.022C82.954 50.022 82.954 50.022 82.954 49.916C82.954 49.81 82.954 49.279 82.954 48.961C82.964 48.763 82.964 48.565 82.954 48.366C82.865 47.811 82.809 47.251 82.784 46.689C82.752 46.216 82.752 45.74 82.784 45.267C82.687 44.892 82.63 44.508 82.614 44.121C82.6 43.487 82.65 42.855 82.762 42.231V41.679C82.773 41.503 82.773 41.325 82.762 41.149C82.762 39.854 82.762 38.559 82.762 37.264L82.932 36.903C82.872 36.723 82.829 36.538 82.805 36.351V36.521C82.805 36.266 82.805 36.032 82.805 35.799V35.31C82.805 35.31 82.805 35.183 82.805 35.141V34.44C82.677 33.06 82.805 31.68 82.529 30.3C82.21 29.22 82.21 28.07 82.529 26.989V26.989V26.861C82.529 26.713 82.529 26.585 82.529 26.437V25.312C82.434 24.444 82.434 23.568 82.529 22.7V22.552V21.957C82.529 21.639 82.529 21.321 82.529 21.002C82.529 20.684 82.529 21.002 82.529 21.002C82.508 20.748 82.508 20.492 82.529 20.238L81.935 20.429C81.935 20.068 81.935 19.686 81.935 19.325C81.932 19.257 81.909 19.192 81.867 19.138C81.825 19.085 81.766 19.046 81.701 19.028V19.028L81.383 18.837C80.342 18.837 79.26 18.646 78.219 18.582C78.161 18.614 78.095 18.63 78.028 18.63C77.962 18.63 77.896 18.614 77.837 18.582H77.54H75.672C74.618 18.635 73.562 18.635 72.509 18.582H71.256H70.768H69.728H69.24L69.112 18.709H68.072H67.541H66.904C65.169 18.766 63.432 18.716 61.703 18.561H61.385H60.939H59.432H58.455C57.56 18.656 56.66 18.699 55.759 18.688C55.609 18.671 55.471 18.594 55.377 18.476H55.186C54.645 18.616 54.089 18.694 53.53 18.709C52.65 18.738 51.77 18.638 50.919 18.412H50.155C50.077 18.425 49.998 18.425 49.921 18.412H49.709C48.669 18.412 47.586 18.412 46.609 18.412C46.543 18.414 46.478 18.399 46.418 18.37C46.359 18.34 46.308 18.296 46.27 18.242H45.994L45.845 17.69C45.117 17.903 44.344 17.903 43.616 17.69H41.705H41.132H39.774C39.035 17.807 38.283 17.807 37.545 17.69H36.61H36.25C35.634 17.69 34.997 17.69 34.36 17.69H33.384H33.129C33.11 17.719 33.1 17.752 33.1 17.786C33.1 17.82 33.11 17.853 33.129 17.881C33.095 17.881 33.063 17.895 33.039 17.919C33.015 17.943 33.001 17.975 33.001 18.009C32.747 22.552 33.001 27.201 33.001 31.765C33.001 33.888 33.001 36.16 33.001 38.346C32.93 40.541 32.987 42.739 33.171 44.927C31.711 45.274 30.289 45.765 28.925 46.392V46.392C28.849 46.458 28.751 46.494 28.65 46.494C28.548 46.494 28.45 46.458 28.374 46.392L28.161 46.562C28.152 46.399 28.152 46.236 28.161 46.074C28.161 46.074 28.161 46.074 28.161 45.968C28.129 45.473 28.129 44.976 28.161 44.481C28.161 43.972 28.161 43.463 28.161 42.932C28.13 42.43 28.13 41.926 28.161 41.425C27.895 40.575 27.895 39.663 28.161 38.813C28.14 38.602 28.14 38.388 28.161 38.176V37.094C28.13 36.748 28.13 36.4 28.161 36.054V35.671C28.151 35.565 28.151 35.459 28.161 35.353C28.003 34.654 28.003 33.929 28.161 33.23C28.129 33.126 28.129 33.015 28.161 32.912C28.151 32.841 28.151 32.77 28.161 32.699V32.147C28.161 32.041 28.161 31.935 28.161 31.829C28.161 31.723 28.161 31.574 28.161 31.447V30.683C28.151 30.527 28.151 30.371 28.161 30.215V30.215V29.154C28.076 28.208 28.076 27.256 28.161 26.31V26.31V25.375C28.151 25.312 28.151 25.248 28.161 25.184V24.887V24.335C28.151 24.18 28.151 24.024 28.161 23.868V23.868V23.528C28.151 23.366 28.151 23.203 28.161 23.04V23.04V21.766C28.11 21.615 28.11 21.451 28.161 21.299V21.299V20.684C28.161 20.684 28.161 20.684 28.161 20.556C28.011 20.167 28.011 19.736 28.161 19.346C28.15 19.148 28.15 18.95 28.161 18.752V18.752C28.125 18.672 28.106 18.585 28.106 18.497C28.106 18.409 28.125 18.322 28.161 18.242C28.161 18.242 28.161 18.242 28.161 18.115C28.196 17.649 28.274 17.187 28.395 16.735C28.465 16.369 28.625 16.026 28.862 15.737C29.075 15.208 29.427 14.746 29.881 14.4V14.166C31.787 12.956 33.991 12.294 36.25 12.256C39.391 12.065 42.618 12.086 45.675 12.043C52.277 11.937 58.901 12.043 65.525 12.171L75.184 12.553C77.922 12.68 81.17 12.553 83.675 14.018C86.18 15.483 86.69 19.24 86.669 22.509C86.669 26.267 86.669 30.025 86.541 33.761C86.541 34.759 86.541 35.756 86.541 36.754C86.27 36.474 85.936 36.263 85.567 36.138C85.198 36.012 84.804 35.976 84.418 36.032V36.032C84.239 36.011 84.058 36.041 83.896 36.12C83.734 36.199 83.598 36.324 83.505 36.478V36.478V36.627C83.495 36.725 83.495 36.825 83.505 36.924V37.051C83.505 37.051 83.505 37.242 83.505 37.051C83.495 37.143 83.495 37.236 83.505 37.327C83.505 37.327 83.505 37.434 83.505 37.497C83.505 37.561 83.505 37.625 83.505 37.667C83.326 38.204 83.326 38.785 83.505 39.323V39.471L83.378 39.641C83.427 39.643 83.474 39.658 83.515 39.684C83.556 39.71 83.589 39.747 83.612 39.79V39.79C83.858 40.225 84.259 40.551 84.735 40.704C85.21 40.857 85.726 40.826 86.18 40.618L86.435 40.405C86.435 45.564 86.308 50.702 86.265 55.86C86.431 55.693 86.635 55.57 86.86 55.499C86.945 50.079 87.015 44.673 87.072 39.28C87.21 38.787 87.21 38.266 87.072 37.773C87.199 36.712 87.199 35.65 87.22 34.61ZM41.727 45.798C41.706 45.86 41.706 45.927 41.727 45.989C41.748 46.257 41.748 46.527 41.727 46.795C40.177 46.795 37.481 47.708 37.269 45.458C38.755 45.479 40.219 45.649 41.727 45.798ZM86.541 38.983C86.473 39.246 86.35 39.492 86.18 39.705C86.05 39.871 85.881 40.004 85.69 40.092C85.498 40.181 85.288 40.223 85.076 40.215C85.076 39.684 84.864 39.174 84.885 38.644V38.431C84.885 38.155 84.885 37.879 85.034 37.603C85.092 37.35 85.17 37.101 85.267 36.86V36.86C85.522 36.913 85.761 37.022 85.968 37.179C86.254 37.412 86.456 37.732 86.541 38.092V38.983Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M83.08 38.58C83.061 38.634 83.061 38.693 83.08 38.747V38.58Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M83.293 38.813H83.46C83.451 38.855 83.451 38.897 83.46 38.938L83.293 38.813Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M62.977 53.737L58.285 43.569C58.44 45.637 58.766 47.69 59.262 49.704C59.827 50.873 60.541 51.965 61.385 52.952C62.19 53.852 63.063 54.689 63.996 55.457L64.357 55.605L65.079 55.903C65.609 56.051 66.204 56.094 66.756 56.2H67.35C67.491 56.22 67.634 56.22 67.775 56.2H68.305H68.539H68.9C69.168 56.168 69.439 56.168 69.706 56.2H69.876C69.97 56.123 70.079 56.065 70.195 56.03L62.977 53.737Z",
  fill: "#96D0C7"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M66.692 56.2H67.286C67.427 56.22 67.57 56.22 67.711 56.2L68.369 56.073H68.496L65.63 55.924L66.692 56.2Z",
  fill: "#38B49F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M75.566 45.925C75.948 39.684 69.77 35.714 65.1 38.41C63.149 39.679 61.761 41.65 61.224 43.915C60.686 46.179 61.04 48.564 62.213 50.574C62.26 51.619 62.665 52.616 63.359 53.398C64.288 54.366 65.558 54.932 66.899 54.976C68.24 55.02 69.545 54.537 70.534 53.631C70.896 53.276 71.19 52.859 71.405 52.4C72.62 51.8 73.65 50.88 74.383 49.739C75.116 48.599 75.525 47.28 75.566 45.925Z",
  fill: "#EEF7F9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M59.262 49.704C59.827 50.873 60.541 51.965 61.385 52.952C61.618 53.207 62.022 53.653 62.531 54.141C63.524 54.908 64.666 55.458 65.885 55.754C67.805 56.31 69.866 56.081 71.617 55.117C77.052 53.695 78.219 44.842 75.46 40.045C73.082 36.16 68.008 34.037 64.463 36.16C60.514 36.839 58.413 41.106 58.455 45.479C58.639 46.902 58.909 48.313 59.262 49.704V49.704ZM64.145 38.686C67.52 37.54 71.171 37.434 73.57 41.064C76.542 45.543 74.504 49.555 71.702 52.888C70.245 53.375 68.733 53.682 67.201 53.801C65.92 53.614 64.715 53.08 63.715 52.257C62.716 51.434 61.962 50.353 61.533 49.131C60.908 47.324 60.822 45.375 61.286 43.52C61.749 41.665 62.743 39.986 64.145 38.686V38.686Z",
  fill: "#EEF7F9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M74.037 39.45C73.496 38.64 72.788 37.954 71.96 37.438C71.133 36.923 70.205 36.59 69.239 36.461C68.273 36.332 67.29 36.411 66.357 36.692C65.423 36.974 64.56 37.451 63.826 38.092C63.699 38.198 63.826 38.431 63.975 38.368C65.419 37.512 67.122 37.2 68.776 37.488C70.43 37.776 71.927 38.645 72.997 39.939C76.011 43.611 74.929 47.602 72.997 51.466C72.827 51.806 73.145 52.188 73.422 51.954C76.882 49.152 76.606 42.89 74.037 39.45Z",
  fill: "#1DB2A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M59.432 50.022C59.946 51.069 60.58 52.052 61.321 52.952C61.64 53.292 62.298 54.013 63.104 54.756C63.926 55.289 64.841 55.663 65.8 55.86C67.923 56.242 70.768 56.242 72.042 54.013C72.082 53.958 72.109 53.893 72.117 53.825C72.126 53.757 72.117 53.688 72.092 53.624C72.066 53.56 72.025 53.504 71.971 53.461C71.918 53.417 71.855 53.388 71.787 53.376C70.216 53.249 68.794 54.077 67.201 53.801C66.242 53.601 65.334 53.207 64.531 52.645C63.728 52.084 63.048 51.365 62.531 50.532C59.984 46.583 60.981 42.168 63.38 38.559C63.508 38.346 63.38 38.049 63.083 38.155C59.177 40.215 57.861 45.734 59.432 50.022Z",
  fill: "#1DB2A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M86.456 74.223C85.039 73.979 83.683 73.46 82.465 72.695C80.973 71.371 79.741 69.78 78.835 68.003C77.349 65.307 76.861 62.144 75.46 59.512C75.42 59.455 75.368 59.408 75.307 59.376C75.246 59.344 75.178 59.327 75.109 59.327C75.04 59.327 74.972 59.344 74.911 59.376C74.85 59.408 74.798 59.455 74.759 59.512V59.512C74.632 58.535 73.825 58.132 73.315 57.389C73.061 57.049 72.827 56.71 72.551 56.391C72.192 56.071 71.903 55.681 71.702 55.245C71.702 55.177 71.675 55.112 71.627 55.065C71.58 55.017 71.515 54.99 71.447 54.99C71.38 54.99 71.315 55.017 71.267 55.065C71.219 55.112 71.193 55.177 71.193 55.245C71.193 55.627 71.086 55.988 71.044 56.37C71.13 56.581 71.13 56.817 71.044 57.028C71.054 57.084 71.054 57.142 71.044 57.198V57.325C71.135 57.8 71.315 58.254 71.575 58.662C72.169 59.681 73.124 60.785 74.271 60.34C74.382 60.287 74.477 60.207 74.547 60.106C73.867 63.885 75.948 68.3 77.965 71.124C79.981 73.947 83.378 77.684 86.456 75.837C87.072 75.688 87.22 74.478 86.456 74.223Z",
  fill: "#1DB2A6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M86.945 71.846L86.393 71.081C86.315 70.312 86.029 69.578 85.565 68.959C85.209 68.45 84.736 68.035 84.185 67.749C82.995 65.81 81.569 64.027 79.939 62.441C79.394 61.254 78.679 60.153 77.816 59.172C77.807 58.94 77.725 58.718 77.582 58.535C77.385 58.304 77.148 58.109 76.882 57.962C76.749 57.93 76.611 57.93 76.479 57.962C76.667 56.823 76.417 55.655 75.778 54.693C75.664 54.498 75.509 54.33 75.323 54.202C75.138 54.073 74.927 53.987 74.704 53.948C74.482 53.91 74.254 53.92 74.036 53.979C73.818 54.038 73.615 54.144 73.443 54.289L73.273 54.183C73.594 53.988 73.899 53.768 74.186 53.525C74.921 52.953 75.402 52.114 75.523 51.19C75.53 51.133 75.522 51.075 75.5 51.023C75.479 50.97 75.444 50.923 75.4 50.887C75.355 50.851 75.302 50.827 75.246 50.817C75.19 50.806 75.132 50.811 75.077 50.829C74.377 51.144 73.748 51.599 73.23 52.166C72.612 52.647 72.055 53.204 71.575 53.822C71.384 54.12 71.575 54.608 71.872 54.608H72.063C71.953 54.747 71.874 54.908 71.83 55.08C71.786 55.252 71.779 55.431 71.808 55.605C71.827 55.774 71.896 55.932 72.006 56.06C72.115 56.189 72.261 56.282 72.424 56.327C72.424 56.327 72.424 56.434 72.424 56.497C72.512 56.861 72.713 57.188 72.997 57.431C73.027 57.597 73.07 57.76 73.124 57.92C73.236 58.379 73.516 58.781 73.909 59.044C74.302 59.307 74.78 59.414 75.247 59.342C75.234 59.6 75.298 59.857 75.43 60.08C75.562 60.303 75.757 60.482 75.99 60.594C76.075 60.604 76.16 60.604 76.245 60.594C76.297 61.026 76.411 61.448 76.585 61.847C77.285 63.779 78.05 65.774 78.856 67.664C80.172 70.678 81.404 73.714 84.1 75.349C84.266 75.465 84.455 75.546 84.654 75.587C84.853 75.628 85.059 75.628 85.258 75.586C85.457 75.544 85.645 75.462 85.811 75.344C85.977 75.227 86.117 75.077 86.223 74.903C86.481 74.759 86.707 74.564 86.886 74.328C87.064 74.092 87.192 73.822 87.26 73.534C87.327 73.246 87.335 72.947 87.28 72.656C87.226 72.366 87.112 72.09 86.945 71.846Z",
  fill: "#94D1D0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M66.352 36.16C65.826 36.042 65.28 36.044 64.755 36.165C64.23 36.287 63.738 36.524 63.317 36.86C62.453 37.469 61.776 38.307 61.364 39.28C61.364 39.429 61.512 39.599 61.618 39.493C62.23 38.9 62.951 38.431 63.741 38.113C64.532 37.916 65.333 37.76 66.14 37.646C66.798 37.561 67.074 36.436 66.352 36.16Z",
  fill: "#94D1D0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M84.843 68.3C82.956 65.023 80.455 62.14 77.476 59.809C77.306 59.681 77.052 59.936 77.2 60.127C78.835 62.42 80.618 64.564 82.189 66.921C82.89 67.961 83.548 69.044 84.142 70.169C84.776 71.536 85.288 72.957 85.671 74.415C85.682 74.47 85.708 74.522 85.745 74.565C85.783 74.607 85.832 74.639 85.886 74.656C85.94 74.673 85.998 74.676 86.054 74.663C86.109 74.65 86.16 74.623 86.201 74.584C87.9 72.716 85.883 69.999 84.843 68.3Z",
  fill: "#EEF7F9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M75.99 55.797C75.789 55.317 75.501 54.878 75.141 54.502C74.796 54.165 74.347 53.955 73.867 53.907C73.634 53.907 73.528 54.226 73.698 54.374C73.984 54.655 74.228 54.977 74.419 55.33C74.619 55.655 74.756 56.015 74.823 56.391C74.971 57.176 74.632 57.941 74.823 58.684C74.823 58.814 74.861 58.941 74.932 59.05C75.003 59.159 75.103 59.246 75.222 59.3C75.34 59.353 75.472 59.372 75.6 59.353C75.729 59.334 75.85 59.279 75.948 59.193C76.268 58.686 76.441 58.1 76.449 57.501C76.456 56.901 76.297 56.312 75.99 55.797Z",
  fill: "#EEF7F9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M71.447 44.651C71.447 44.354 71.171 44.206 71.001 44.439L70.619 44.97C71.134 43.954 71.492 42.866 71.681 41.743C71.681 41.488 71.405 41.297 71.235 41.467C70.819 41.922 70.442 42.412 70.11 42.932C70.065 42.822 69.992 42.727 69.898 42.656C69.112 41.977 68.348 43.356 67.987 43.951C67.188 45.26 66.478 46.622 65.864 48.027C65.694 48.43 66.225 48.876 66.501 48.558L66.819 48.218C66.701 48.515 66.636 48.832 66.628 49.152C66.628 49.428 66.819 49.704 67.074 49.64C67.898 49.349 68.576 48.747 68.963 47.963C69.002 48.105 69.093 48.226 69.218 48.303C69.876 48.727 70.513 47.73 70.81 47.199C71.243 46.42 71.462 45.542 71.447 44.651V44.651Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M65.164 49.661C64.93 47.857 63.21 45.692 64.208 43.845C64.357 43.569 64.017 43.25 63.826 43.526C63.115 44.451 62.795 45.617 62.935 46.774C63.079 48.041 63.692 49.207 64.654 50.044C64.712 50.081 64.781 50.1 64.85 50.097C64.919 50.095 64.986 50.071 65.042 50.03C65.097 49.988 65.139 49.93 65.16 49.865C65.182 49.799 65.183 49.728 65.164 49.661Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M69.813 37.773C69.771 37.767 69.728 37.776 69.692 37.8C69.657 37.823 69.632 37.859 69.622 37.9C68.3 37.528 66.897 37.568 65.599 38.016C64.301 38.463 63.171 39.297 62.361 40.406C61.322 41.853 60.696 43.557 60.55 45.333C60.404 47.109 60.744 48.891 61.533 50.49C62.269 52.028 63.524 53.259 65.076 53.966C66.629 54.672 68.381 54.809 70.025 54.353C71.616 53.722 72.985 52.633 73.956 51.223C74.928 49.813 75.458 48.147 75.481 46.435C75.566 42.656 73.188 38.495 69.813 37.773ZM74.738 44.651C75.054 46.261 74.884 47.928 74.248 49.441C73.613 50.953 72.542 52.242 71.171 53.143C69.848 53.921 68.287 54.195 66.778 53.915C65.268 53.634 63.911 52.817 62.956 51.615C61.909 50.29 61.258 48.696 61.077 47.017C60.897 45.338 61.195 43.642 61.937 42.125C62.611 40.675 63.765 39.502 65.203 38.802C66.641 38.102 68.276 37.919 69.834 38.283C71.093 38.886 72.192 39.777 73.044 40.883C73.896 41.989 74.476 43.28 74.738 44.651V44.651Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M87.348 74.521C88.07 71.527 86.074 68.98 84.503 66.9C82.113 63.693 79.51 60.65 76.712 57.792V57.792C76.918 56.934 76.841 56.032 76.493 55.221C76.145 54.41 75.544 53.734 74.78 53.292C76.105 51.601 76.974 49.599 77.305 47.477C77.635 45.355 77.417 43.183 76.67 41.17C75.95 39.029 74.476 37.222 72.524 36.085C70.571 34.949 68.273 34.56 66.055 34.992C66.055 34.992 66.055 35.226 66.055 35.205C67.948 34.933 69.879 35.254 71.582 36.125C73.285 36.995 74.677 38.372 75.566 40.066C76.506 41.923 76.949 43.993 76.853 46.072C76.756 48.152 76.122 50.171 75.014 51.933C74.01 53.467 72.55 54.646 70.84 55.305C69.129 55.964 67.255 56.069 65.482 55.605C63.643 54.922 62.037 53.728 60.853 52.164C59.668 50.599 58.954 48.73 58.795 46.774C58.534 44.498 58.986 42.198 60.089 40.19C61.192 38.182 62.891 36.566 64.951 35.565C65.164 35.459 64.951 35.141 64.803 35.183C63.162 35.809 61.713 36.85 60.596 38.205C59.48 39.559 58.735 41.181 58.434 42.911C58.434 43.526 58.434 44.142 58.328 44.758C58.501 46.425 58.791 48.078 59.198 49.704C59.764 50.873 60.477 51.965 61.321 52.952C62.119 53.845 62.985 54.675 63.911 55.436L64.293 55.605L65.015 55.903C65.582 56.035 66.156 56.134 66.735 56.2H67.286C67.427 56.221 67.57 56.221 67.711 56.2L68.624 56.03C68.962 55.988 69.305 55.988 69.643 56.03H69.813C69.914 55.937 70.042 55.877 70.178 55.858C70.315 55.839 70.454 55.862 70.577 55.924V55.924C70.682 55.986 70.77 56.074 70.832 56.179C70.966 56.331 71.042 56.527 71.044 56.731C71.315 57.233 71.495 57.779 71.575 58.344C71.575 58.578 71.575 58.811 71.575 59.045C71.766 59.414 72.04 59.734 72.375 59.98C72.71 60.227 73.097 60.394 73.506 60.467C73.506 60.849 73.676 61.231 73.782 61.613C73.756 61.628 73.734 61.65 73.718 61.676C73.703 61.702 73.695 61.732 73.695 61.762C73.695 61.792 73.703 61.822 73.718 61.848C73.734 61.874 73.756 61.896 73.782 61.911C73.773 62.059 73.773 62.208 73.782 62.356C73.764 62.389 73.754 62.425 73.754 62.463C73.754 62.5 73.764 62.536 73.782 62.569C73.974 63.184 74.165 63.8 74.377 64.416C74.347 64.447 74.33 64.489 74.33 64.532C74.33 64.576 74.347 64.618 74.377 64.649C74.971 66.31 75.68 67.927 76.5 69.489C77.816 72.058 79.557 75.497 82.083 76.644C82.537 76.994 83.075 77.22 83.644 77.298C84.212 77.376 84.791 77.305 85.323 77.09C85.856 76.875 86.322 76.525 86.678 76.075C87.033 75.624 87.264 75.088 87.348 74.521V74.521ZM76.457 58.514C78.793 61.019 81.064 63.566 83.208 66.305C84.365 67.611 85.382 69.034 86.244 70.551C86.674 71.452 86.892 72.44 86.881 73.438C86.252 73.688 85.583 73.824 84.906 73.841C84.244 73.785 83.604 73.574 83.038 73.226C81.704 72.265 80.667 70.948 80.045 69.426C78.495 66.241 77.391 62.802 75.799 59.639C76.09 59.311 76.314 58.929 76.457 58.514V58.514ZM72.933 59.83C72.482 59.489 72.118 59.045 71.872 58.535C71.676 58.19 71.533 57.818 71.447 57.431V57.24C71.322 57.099 71.247 56.92 71.235 56.731V56.731C71.226 56.696 71.226 56.659 71.235 56.625V56.476V56.158C72.545 55.65 73.726 54.86 74.695 53.844C75.353 54.693 76.118 55.181 76.415 56.37C76.492 56.959 76.415 57.558 76.192 58.109C75.969 58.659 75.607 59.143 75.141 59.512V59.512C75.033 59.707 74.88 59.875 74.695 60C74.416 60.144 74.102 60.204 73.789 60.174C73.477 60.144 73.18 60.025 72.933 59.83V59.83ZM85.671 76.028C85.558 76.11 85.437 76.181 85.31 76.24C84.987 76.412 84.632 76.518 84.268 76.551C83.903 76.584 83.536 76.543 83.187 76.431V76.431C82.79 76.366 82.416 76.198 82.104 75.943V75.943H81.998C81.803 75.901 81.621 75.814 81.466 75.688C81.312 75.563 81.188 75.403 81.106 75.221C80.621 74.71 80.174 74.163 79.769 73.587C79.359 73.193 79.053 72.705 78.877 72.164C78.877 72.037 78.729 71.931 78.665 71.825C78.535 71.671 78.428 71.499 78.347 71.315V71.315C78.356 71.28 78.356 71.244 78.347 71.209V71.209L78.198 70.954C78.028 70.678 77.901 70.36 77.71 70.084C77.561 69.833 77.434 69.57 77.328 69.298V69.171L77.2 68.874C77.135 68.758 77.078 68.637 77.03 68.513L76.882 68.237C76.597 67.837 76.402 67.381 76.309 66.9L75.927 65.88C75.76 65.619 75.639 65.332 75.566 65.031L75.438 64.713V64.607C75.427 64.551 75.427 64.493 75.438 64.437L75.247 63.885V63.736C75.153 63.542 75.088 63.335 75.056 63.121L74.908 62.654C74.908 62.654 74.908 62.654 74.908 62.526C74.898 62.477 74.898 62.427 74.908 62.378V62.378V62.08C74.844 62.008 74.801 61.92 74.78 61.826C74.77 61.77 74.77 61.712 74.78 61.656C74.771 61.564 74.771 61.472 74.78 61.38V61.38C74.756 61.29 74.756 61.194 74.78 61.104C74.78 61.104 74.78 61.104 74.78 60.998C74.78 60.892 74.78 60.785 74.78 60.679C75.23 60.615 75.655 60.431 76.011 60.149C76.091 60.104 76.163 60.047 76.224 59.979C76.755 61.507 77.349 62.993 77.965 64.458C78.1 64.628 78.201 64.823 78.262 65.031C78.328 65.219 78.385 65.411 78.432 65.605C78.559 65.88 78.686 66.178 78.793 66.475C78.899 66.772 79.069 67.112 79.196 67.451C79.477 67.873 79.685 68.34 79.811 68.831C79.821 68.873 79.821 68.917 79.811 68.959C79.898 69.204 79.997 69.445 80.109 69.68V69.68C80.213 69.794 80.299 69.923 80.364 70.063L79.811 70.126L80.066 70.466C80.264 70.738 80.402 71.049 80.47 71.379V71.379C80.465 71.435 80.465 71.492 80.47 71.549C80.514 71.623 80.564 71.694 80.618 71.761V71.761C80.684 71.837 80.755 71.908 80.83 71.973C80.83 71.973 80.83 71.973 80.83 71.973C80.979 72.143 81.106 72.313 81.255 72.461C81.404 72.61 81.743 72.886 81.977 73.098C82.086 73.216 82.207 73.323 82.338 73.417C82.451 73.493 82.572 73.557 82.699 73.608L83.06 73.884C83.247 73.997 83.446 74.09 83.654 74.16C84.144 74.363 84.673 74.454 85.202 74.424C85.731 74.395 86.247 74.246 86.711 73.99C86.623 74.575 86.365 75.121 85.968 75.561C85.929 75.733 85.849 75.893 85.735 76.028H85.671Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M65.843 40.066C66.836 39.576 67.961 39.423 69.049 39.63C70.137 39.836 71.128 40.392 71.872 41.212C72.676 42.172 73.212 43.328 73.424 44.563C73.637 45.797 73.519 47.065 73.082 48.239C73.082 48.43 73.273 48.579 73.337 48.388C73.784 47.184 73.913 45.886 73.712 44.618C73.511 43.35 72.987 42.155 72.19 41.149C71.431 40.246 70.394 39.621 69.241 39.372C68.089 39.122 66.886 39.262 65.822 39.769C65.609 39.854 65.694 40.151 65.843 40.066Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M63.699 42.529C63.805 42.38 63.593 42.168 63.508 42.316C62.698 43.557 62.331 45.035 62.466 46.511C62.601 47.986 63.23 49.373 64.251 50.447C64.378 50.574 64.569 50.447 64.442 50.213C63.47 49.203 62.868 47.895 62.734 46.5C62.599 45.105 62.939 43.706 63.699 42.529V42.529Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M68.39 44.397L66.925 46.307C66.819 46.456 66.925 46.668 67.138 46.52C67.626 45.883 68.114 45.246 68.581 44.588C68.709 44.439 68.518 44.248 68.39 44.397Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M70.046 42.529L67.074 47.687C66.968 47.836 67.223 47.984 67.308 47.815L70.301 42.529C70.288 42.506 70.269 42.488 70.247 42.476C70.224 42.463 70.199 42.456 70.174 42.456C70.148 42.456 70.123 42.463 70.1 42.476C70.078 42.488 70.059 42.506 70.046 42.529V42.529Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M69.558 45.819L68.709 47.39C68.709 47.56 68.857 47.708 68.942 47.538C69.24 47.008 69.515 46.477 69.813 45.967C69.827 45.934 69.829 45.897 69.817 45.862C69.806 45.828 69.782 45.799 69.751 45.781C69.72 45.762 69.683 45.756 69.647 45.763C69.612 45.77 69.58 45.79 69.558 45.819V45.819Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M81.531 70.339C82.401 71.676 83.972 73.65 85.48 72.164C85.628 72.037 85.48 71.825 85.289 71.952C83.569 73.65 81.743 70.211 81.043 68.852C80.097 67.171 79.301 65.409 78.665 63.588C78.665 63.571 78.662 63.554 78.655 63.539C78.649 63.524 78.64 63.51 78.628 63.498C78.616 63.486 78.602 63.476 78.586 63.47C78.571 63.464 78.555 63.46 78.538 63.46C78.521 63.46 78.505 63.464 78.489 63.47C78.474 63.476 78.46 63.486 78.448 63.498C78.436 63.51 78.426 63.524 78.42 63.539C78.414 63.554 78.41 63.571 78.41 63.588C79.169 65.958 80.217 68.225 81.531 70.339Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M63.444 38.283C62.3 39.108 61.355 40.179 60.68 41.417C60.004 42.655 59.614 44.028 59.538 45.437C59.452 46.781 59.639 48.128 60.088 49.398C60.537 50.667 61.238 51.833 62.149 52.825C62.276 52.973 62.446 52.825 62.319 52.612C61.46 51.672 60.795 50.57 60.365 49.371C59.935 48.172 59.748 46.9 59.814 45.628C59.859 44.238 60.22 42.876 60.872 41.648C61.523 40.419 62.446 39.355 63.571 38.537C63.72 38.452 63.593 38.283 63.444 38.283Z",
  fill: "#008B8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M71.065 54.268C70.917 54.268 71.065 54.65 71.065 54.565C72.271 53.944 73.329 53.071 74.167 52.005C75.006 50.939 75.606 49.705 75.927 48.388C76.586 45.688 76.207 42.839 74.865 40.405C74.865 40.236 74.547 40.405 74.653 40.575C75.979 42.87 76.345 45.595 75.674 48.159C75.002 50.723 73.346 52.918 71.065 54.268Z",
  fill: "#008B8E"
}));

var addDocument = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2229px%22%20height%3D%2225px%22%20viewBox%3D%220%200%2029%2025%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3E798D8125-FFC3-4FE7-86DF-CFF0D794B4E7%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%223C.-Customer-Admin%3A-Add--Broker%22%20transform%3D%22translate%28-1160.000000%2C%20-247.000000%29%22%20fill%3D%22%23267678%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22add-document%22%20transform%3D%22translate%281160.000000%2C%20247.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20points%3D%222.44508718%202.45428082%2021.5550765%202.45428082%2021.5550765%2010.5000822%2024%2010.5000822%2024%200%200%200%200%2021%2012%2021%2012%2018.5458835%202.44508718%2018.5458835%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20points%3D%2229%2017.723886%2024.2760467%2017.723886%2024.2760467%2013%2021.7239533%2013%2021.7239533%2017.723886%2017%2017.723886%2017%2020.276114%2021.7239533%2020.276114%2021.7239533%2025%2024.2760467%2025%2024.2760467%2020.276114%2029%2020.276114%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%226%22%20y%3D%226%22%20width%3D%2211%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%226%22%20y%3D%2211%22%20width%3D%228%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var transit = "data:image/svg+xml,%3Csvg%20width%3D%2223%22%20height%3D%2217%22%20viewBox%3D%220%200%2023%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.07143%201.07619C4.20807%201.07619%201.07619%204.20807%201.07619%208.07143C1.07619%2011.9348%204.20807%2015.0667%208.07143%2015.0667C11.7446%2015.0667%2014.7565%2012.2356%2015.0442%208.63643H11.865V7.50643H15.0442C14.7565%203.90728%2011.7446%201.07619%208.07143%201.07619ZM16.1234%208.63643H17.846L16.5505%209.93191L17.3495%2010.7309L20.009%208.07143L17.3495%205.41191L16.5505%206.21094L17.846%207.50643H16.1234C15.9461%204.94247%2014.5714%202.70806%2012.5545%201.35847C13.1802%201.17479%2013.8425%201.07619%2014.5286%201.07619C18.3919%201.07619%2021.5238%204.20807%2021.5238%208.07143C21.5238%2011.9348%2018.3919%2015.0667%2014.5286%2015.0667C13.8425%2015.0667%2013.1802%2014.9681%2012.5545%2014.7844C14.5714%2013.4348%2015.9461%2011.2004%2016.1234%208.63643ZM0%208.07143C0%203.6137%203.6137%200%208.07143%200C9.21942%200%2010.3114%200.239665%2011.3002%200.671689C12.2894%200.239527%2013.3817%200%2014.5286%200C18.9863%200%2022.6%203.6137%2022.6%208.07143C22.6%2012.5292%2018.9863%2016.1429%2014.5286%2016.1429C13.3817%2016.1429%2012.2894%2015.9033%2011.3002%2015.4712C10.3114%2015.9032%209.21942%2016.1429%208.07143%2016.1429C3.6137%2016.1429%200%2012.5292%200%208.07143Z%22%20fill%3D%22%23008C8E%22%2F%3E%3C%2Fsvg%3E";

var OCEAN = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3E9A3429DC-D05C-43F2-9258-0132D2674FE2%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221A.-Landing-page-%22%20transform%3D%22translate%28-39.000000%2C%20-437.000000%29%22%20fill%3D%22%23008B8F%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%20transform%3D%22translate%2836.000000%2C%20435.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ship%22%20transform%3D%22translate%283.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%225.64705882%22%20y%3D%227.05882353%22%20width%3D%2212.7058824%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2216.9411765%22%20y%3D%229.88235294%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%225.64705882%22%20y%3D%229.88235294%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2211.2941176%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2212.7058824%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%229.88235294%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%228.47058824%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2214.1176471%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M21.7490551%2C22.4961123%20C21.2810986%2C22.7402837%2020.8753861%2C22.9511739%2020.0292213%2C22.9560489%20L23.1727145%2C13.7301763%20C23.2592045%2C13.4762081%2023.1351477%2C13.199318%2022.8855964%2C13.0894432%20L20.0000399%2C11.8192269%20L20.0000399%2C6.78261175%20C20.0000399%2C5.91955094%2019.2822925%2C5.21741168%2018.4000463%2C5.21741168%20L17.6000256%2C5.21741168%20L17.6000256%2C2.6086824%20C17.6000256%2C2.32054234%2017.3612556%2C2.08696467%2017.0667103%2C2.08696467%20L12.5332913%2C2.08696467%20L12.5332913%2C0%20L11.4666608%2C0%20L11.4666608%2C2.08696467%20L6.93328968%2C2.08696467%20C6.63874442%2C2.08696467%206.39997444%2C2.32054234%206.39997444%2C2.6086824%20L6.39997444%2C5.21736481%20L5.59995368%2C5.21736481%20C4.7177075%2C5.21736481%203.99996007%2C5.91950406%203.99996007%2C6.78256488%20L3.99996007%2C11.8188519%20L1.11435571%2C13.0893963%20C0.864756512%2C13.1992711%200.740747544%2C13.4761612%200.827333404%2C13.7301294%20L3.97082659%2C22.9559552%20C3.12461392%2C22.9510802%202.71894934%2C22.7402368%202.25099278%2C22.4960654%20C1.72711718%2C22.2227847%201.1333308%2C21.9129885%200%2C21.9129885%20L0%2C22.9564708%20C0.866673189%2C22.9564708%201.27559612%2C23.1697985%201.74901521%2C23.4168293%20C2.27284289%2C23.6901569%202.86658135%2C24%203.99996007%2C24%20C4.29996786%2C24%204.55589208%2C23.9805469%204.78205991%2C23.9407501%20C5.43650909%2C23.8400159%205.86905506%2C23.6145945%206.25076118%2C23.4156105%20C6.7234136%2C23.169236%207.13156986%2C22.9564708%207.99484095%2C22.9564708%20C8.86151413%2C22.9564708%209.27038915%2C23.1697985%209.74385615%2C23.4168293%20C10.2676838%2C23.6901569%2010.8614702%2C24%2011.994801%2C24%20C13.1281318%2C24%2013.7219182%2C23.6901569%2014.2457938%2C23.4168761%20C14.7192129%2C23.1698454%2015.1281358%2C22.9565177%2015.994809%2C22.9565177%20C16.8610989%2C22.9565177%2017.2705489%2C23.1692829%2017.7446388%2C23.4157043%20C18.1275428%2C23.6146414%2018.5612867%2C23.8400628%2019.2180838%2C23.940797%20C19.4441558%2C23.9806407%2019.6999842%2C24%2020%2C24%20C21.1333228%2C24%2021.7271092%2C23.6902037%2022.2509848%2C23.416923%20C22.7244518%2C23.1698922%2023.1333268%2C22.9565645%2024%2C22.9565645%20L24%2C21.9130822%20C22.8667171%2C21.9129885%2022.2729307%2C22.2227847%2021.7490551%2C22.4961123%20Z%20M22.0083335%2C13.8474573%20L21.6259087%2C14.9697833%20L12.5332913%2C10.8829006%20L12.5332913%2C9.67643423%20L22.0083335%2C13.8474573%20Z%20M7.46660491%2C3.13044701%20L16.5332993%2C3.13044701%20L16.5332993%2C5.21741168%20L7.46660491%2C5.21741168%20L7.46660491%2C3.13044701%20Z%20M5.0664947%2C6.78261175%20C5.0664947%2C6.49494044%205.30583967%2C6.26089402%205.59990576%2C6.26089402%20L6.93324176%2C6.26089402%20L17.0666145%2C6.26089402%20L18.3999505%2C6.26089402%20C18.6940166%2C6.26089402%2018.9332657%2C6.49494044%2018.9332657%2C6.78261175%20L18.9332657%2C11.3495872%20L12.2187167%2C8.39379611%20C12.0795181%2C8.33248373%2011.9201465%2C8.33243685%2011.7809958%2C8.39379611%20L5.0664947%2C11.3493528%20L5.0664947%2C6.78261175%20L5.0664947%2C6.78261175%20Z%20M1.99166645%2C13.8474573%20L11.4666608%2C9.6764811%20L11.4666608%2C10.8829475%20L2.37404341%2C14.9697833%20L1.99166645%2C13.8474573%20Z%20M18.954445%2C22.8103617%20C18.6953582%2C22.7279087%2018.4807384%2C22.6166746%2018.2449872%2C22.4941904%20C17.720872%2C22.2218003%2017.1267502%2C21.9130353%2015.9947611%2C21.9130353%20C14.8614303%2C21.9130353%2014.2676439%2C22.2228316%2013.7437683%2C22.4961123%20C13.2702534%2C22.7431431%2012.8614263%2C22.9565177%2011.9947531%2C22.9565177%20C11.1280799%2C22.9565177%2010.719157%2C22.74319%2010.2457379%2C22.4961123%20C9.72191021%2C22.2228316%209.12807592%2C21.9130353%207.99474511%2C21.9130353%20C6.86505599%2C21.9130353%206.27218004%2C22.2220816%205.74911903%2C22.4947061%20C5.51509283%2C22.6166746%205.3019584%2C22.72744%205.04526751%2C22.8096586%20L2.71329515%2C15.9655938%20L11.4666129%2C12.031289%20L11.4666129%2C18.2608237%20L12.5332913%2C18.2608237%20L12.5332913%2C12.031289%20L21.286609%2C15.9656407%20L18.954445%2C22.8103617%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var AIR = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2221px%22%20height%3D%2221px%22%20viewBox%3D%220%200%2021%2021%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EC6994A8C-0162-4F4D-989C-C8897DC3538C%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.-Air-Shipment---Landing-page-%22%20transform%3D%22translate%28-42.000000%2C%20-512.000000%29%22%20fill%3D%22%230A86B8%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-8%22%20transform%3D%22translate%2823.000000%2C%20494.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22AIR_with_circle%22%20transform%3D%22translate%2815.000000%2C%2012.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22plane%22%20transform%3D%22translate%284.000000%2C%206.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.7327007%2C7.42018415%20L19.3086329%2C6.01905701%20L19.3146315%2C6.01408661%20C20.5817186%2C4.84022485%2021.1916961%2C3.11910939%2020.9467796%2C1.40913433%20L20.8895353%2C1.00310739%20C20.8208078%2C0.541549547%2020.4584891%2C0.179056084%2019.9969356%2C0.110156597%20L19.5939974%2C0.0532545953%20C17.8806104%2C-0.192178324%2016.156083%2C0.420375602%2014.9810324%2C1.69141647%20L13.5799182%2C3.26753458%20L12.8227167%2C2.83185685%20C10.8292782%2C1.68850283%208.57069931%2C1.08863186%206.27270064%2C1.09188827%20L5.6210754%2C1.09428778%20C4.99635843%2C1.09720143%204.41997346%2C1.43124389%204.10684371%2C1.9718133%20L3.98412843%2C2.18502458%20C3.88746436%2C2.35281707%203.94488006%2C2.56722806%204.11249962%2C2.6640644%20L10.7999706%2C6.5251767%20L5.57411453%2C12.4460745%20L5.17391859%2C12.9605924%20C4.08867638%2C12.3660346%202.87129237%2C12.0537589%201.63368436%2C12.0525591%20L1.10511724%2C12.0501596%20C0.730972605%2C12.0544444%200.386135691%2C12.2541158%200.196406822%2C12.576675%20L0.0471260638%2C12.83222%20C0.000507943508%2C12.9127741%20-0.0121749382%2C13.0087534%200.011991101%2C13.0987341%20C0.0359856734%2C13.1887147%200.0949438733%2C13.2654982%200.175668629%2C13.3119453%20L3.58033327%2C15.2776368%20C3.48384067%2C15.4642824%203.39231833%2C15.6514421%203.30902275%2C15.8437436%20C3.12597811%2C16.2773646%203.1708823%2C16.773715%203.42882445%2C17.1674017%20C3.68676657%2C17.5610885%204.12381134%2C17.8005227%204.59444862%2C17.8060072%20C4.78760529%2C17.8056644%204.97870524%2C17.7659016%205.15609402%2C17.6894608%20C5.16500631%2C17.6858616%205.17391859%2C17.6817482%205.1823167%2C17.6771206%20C5.35782018%2C17.6017083%205.53863676%2C17.5129274%205.72219559%2C17.4181478%20L7.68786882%2C20.822844%20C7.73414417%2C20.9039122%207.81075552%2C20.9633852%207.90090674%2C20.9877228%20C7.99105792%2C21.0122318%208.08720776%2C20.9997202%208.1681039%2C20.9531017%20L8.42604606%2C20.8039909%20L8.42810274%2C20.8039909%20C8.75048754%2C20.6125463%208.94930007%2C20.2661637%208.95187093%2C19.8913301%20L8.94947145%2C19.3692709%20C8.94792895%2C18.1306231%208.6347992%2C16.9121995%208.03887577%2C15.8262617%20L8.54601914%2C15.4317179%20L14.4714896%2C10.1996434%20L18.3346228%2C16.8880333%20C18.4316297%2C17.0556543%2018.6460387%2C17.1132419%2018.8138296%2C17.016577%20L19.0268675%2C16.8940319%20C19.5676033%2C16.5807279%2019.9016427%2C16.0041662%2019.9043849%2C15.3791007%20L19.9064416%2C14.7283264%20C19.915868%2C12.4296209%2019.3156598%2C10.1693071%2018.1671747%2C8.17807828%20L17.7327007%2C7.42018415%20Z%20M5.62364626%2C1.7963082%20L6.27510008%2C1.79387634%20C8.44952649%2C1.78893834%2010.5867612%2C2.35675909%2012.4720525%2C3.44012603%20L13.112366%2C3.80844679%20L11.2682083%2C5.98752093%20L4.77132322%2C2.23541372%20C4.96893602%2C1.96135842%205.28566495%2C1.79819352%205.62364626%2C1.7963082%20Z%20M1.10683112%2C12.7521801%20L1.63334155%2C12.7545795%20C2.71584157%2C12.7547509%203.78205947%2C13.0176658%204.740473%2C13.5208718%20L4.52006529%2C13.8048679%20C4.39255104%2C13.9659761%204.27154964%2C14.1361681%204.15363324%2C14.3109876%20C4.11849828%2C14.3615481%204.0869625%2C14.4131371%204.05354142%2C14.464726%20C4.01035111%2C14.5317401%203.96510412%2C14.5963548%203.92328493%2C14.6650829%20L0.834492235%2C12.8829519%20C0.901334402%2C12.8010267%201.00108343%2C12.753037%201.10683112%2C12.7521801%20L1.10683112%2C12.7521801%20Z%20M8.24557228%2C19.3697851%20L8.24814309%2C19.8884164%20C8.24814309%2C19.995879%208.1998111%2C20.0975143%208.11685829%2C20.1653854%20L6.33508664%2C17.0765641%20C6.40312851%2C17.0350873%206.46705701%2C16.9908683%206.53338499%2C16.9480203%20C6.58565897%2C16.9130564%206.63878993%2C16.8810062%206.69003554%2C16.8462136%20C6.86022596%2C16.7318954%207.02561741%2C16.6143207%207.18141101%2C16.4917757%20L7.1918658%2C16.484063%20L7.47980119%2C16.2600541%20C7.983174%2C17.2193334%208.24591503%2C18.2864181%208.24557228%2C19.3697851%20Z%20M8.09783397%2C14.8911485%20L7.37542462%2C15.4527991%20C7.37371074%2C15.4527991%207.37131126%2C15.4527991%207.36959738%2C15.4558842%20L6.75739189%2C15.9333815%20C6.41906778%2C16.1985244%206.06017689%2C16.4365875%205.68397558%2C16.6448284%20C5.42414816%2C16.7920539%205.1566082%2C16.9253966%204.88272678%2C17.0443425%20C4.87484285%2C17.0474275%204.86747307%2C17.0508554%204.85976052%2C17.0547974%20C4.59564836%2C17.1567755%204.2960584%2C17.0907896%204.09913117%2C16.8875191%20C3.90203255%2C16.6840771%203.84564522%2C16.3825991%203.95602041%2C16.121741%20C4.07565073%2C15.8458003%204.20967778%2C15.5763725%204.35793026%2C15.314486%20C4.56651202%2C14.9365673%204.80491569%2C14.5759592%205.07108452%2C14.2362608%20L5.54497818%2C13.628163%20C5.54497818%2C13.628163%205.54497818%2C13.6243924%205.54772043%2C13.6226785%20L6.11467893%2C12.8925499%20L15.5006872%2C2.16325782%20C16.3634651%2C1.23242951%2017.5746791%2C0.702657748%2018.8439942%2C0.701286615%20C19.0613169%2C0.701286615%2019.2782968%2C0.716883271%2019.4933914%2C0.74824792%20L19.8963296%2C0.805149965%20C20.0502379%2C0.827945095%2020.1715821%2C0.948433429%2020.1948912%2C1.10251458%20L20.2521354%2C1.50819875%20C20.4636309%2C2.98885169%2019.9354065%2C4.47910252%2018.8386811%2C5.49596948%20L8.09783397%2C14.8911485%20Z%20M19.2037421%2C15.377044%20C19.2018568%2C15.7146856%2019.038522%2C16.0312461%2018.7642979%2C16.228518%20L15.0127396%2C9.72985874%20L17.1924791%2C7.88739795%20L17.5613106%2C8.52840292%20C18.647924%2C10.4130261%2019.2153966%2C12.5521659%2019.2057988%2C14.7276408%20L19.2037421%2C15.377044%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.5657305%2C1.90221571%20C18.0054532%2C1.64188439%2018.5657127%2C1.71275134%2018.9267769%2C2.07437326%20C19.2878412%2C2.4361773%2019.3583061%2C2.9965546%2019.0975678%2C3.43633051%20C18.9925077%2C3.61358903%2019.0509554%2C3.84240368%2019.2279369%2C3.94770213%20C19.4051006%2C4.0528184%2019.6339748%2C3.99452167%2019.7390349%2C3.8172632%20C20.1734773%2C3.08454623%2020.056582%2C2.15034117%2019.4548083%2C1.54733438%20C18.8530346%2C0.944509795%2017.9195115%2C0.826094544%2017.1864583%2C1.2596765%20C17.0702914%2C1.32671774%2016.9990982%2C1.45114478%2017%2C1.58522725%20C17.0007369%2C1.71949189%2017.0735688%2C1.84282594%2017.1906461%2C1.90840976%20C17.3077234%2C1.97399357%2017.4510203%2C1.97162524%2017.5657305%2C1.90221571%20L17.5657305%2C1.90221571%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var TRUCK = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2233px%22%20height%3D%2225px%22%20viewBox%3D%220%200%2033%2025%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3E157D3F60-14D3-4564-BEE7-18D44150BE3F%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%224a.-Cross-border-Detail-page%22%20transform%3D%22translate%28-417.000000%2C%20-115.000000%29%22%20fill%3D%22%236E66D2%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-17%22%20transform%3D%22translate%28393.000000%2C%2040.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22truck-copy-11%22%20transform%3D%22translate%2824.000000%2C%2075.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.5%2C18%20C5.56973633%2C18%204%2C19.5697363%204%2C21.5%20C4%2C23.4302637%205.56973633%2C25%207.5%2C25%20C9.43026367%2C25%2011%2C23.4302637%2011%2C21.5%20C11%2C19.5697363%209.43019531%2C18%207.5%2C18%20Z%20M7.5%2C23.8333105%20C6.21313477%2C23.8333105%205.16668945%2C22.7867969%205.16668945%2C21.5%20C5.16668945%2C20.2131348%206.21320312%2C19.1666895%207.5%2C19.1666895%20C8.78679688%2C19.1666895%209.83331055%2C20.2132031%209.83331055%2C21.5%20C9.83331055%2C22.7867969%208.78679688%2C23.8333105%207.5%2C23.8333105%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M26.5%2C18%20C24.5697363%2C18%2023%2C19.5697363%2023%2C21.5%20C23%2C23.4302637%2024.5697363%2C25%2026.5%2C25%20C28.4302637%2C25%2030%2C23.4302637%2030%2C21.5%20C30%2C19.5697363%2028.4302637%2C18%2026.5%2C18%20Z%20M26.5%2C23.8333105%20C25.2131348%2C23.8333105%2024.1666895%2C22.7867969%2024.1666895%2C21.5%20C24.1666895%2C20.2131348%2025.2132031%2C19.1666895%2026.5%2C19.1666895%20C27.7868652%2C19.1666895%2028.8333105%2C20.2132031%2028.8333105%2C21.5%20C28.8333105%2C22.7867969%2027.7868652%2C23.8333105%2026.5%2C23.8333105%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M32.9133231%2C15.5683333%20L28.0041974%2C7.27201389%20C27.9038416%2C7.1025%2027.7309355%2C7%2027.5454371%2C7%20L21.5454371%2C7%20C21.2437943%2C7%2021%2C7.26548611%2021%2C7.59256944%20L21%2C22.4073611%20C21%2C22.7350694%2021.2437943%2C23%2021.5454371%2C23%20L23.7272495%2C23%20L23.7272495%2C21.8147222%20L22.0908742%2C21.8147222%20L22.0908742%2C8.18520833%20L27.2476295%2C8.18520833%20L31.9091257%2C16.063125%20L31.9091257%2C21.8148611%20L29.1818123%2C21.8148611%20L29.1818123%2C23%20L32.4545628%2C23%20C32.7562056%2C23%2033%2C22.7351389%2033%2C22.4074306%20L33%2C15.8888889%20C33%2C15.7756944%2032.9700849%2C15.6636806%2032.9133231%2C15.5683333%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M24.1249588%2C13.7273134%20L24.1249588%2C9.27276117%20L28.6249918%2C9.27276117%20L28.6249918%2C8%20L23.5624794%2C8%20C23.2514117%2C8%2023%2C8.28509791%2023%2C8.6363433%20L23%2C14.3636567%20C23%2C14.7155733%2023.2514117%2C15%2023.5624794%2C15%20L32%2C15%20L32%2C13.7272388%20L24.1249588%2C13.7272388%20L24.1249588%2C13.7273134%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M21.4500209%2C2%20L0.549979053%2C2%20C0.246404538%2C2%200%2C2.25035759%200%2C2.55880234%20L0%2C20.4411977%20C0%2C20.7502318%200.246404538%2C21%200.549979053%2C21%20L4.95000483%2C21%20L4.95000483%2C19.8823298%20L1.10002256%2C19.8823298%20L1.10002256%2C3.11760468%20L20.9000419%2C3.11760468%20L20.9000419%2C19.8823298%20L10.4499887%2C19.8823298%20L10.4499887%2C21%20L21.4500209%2C21%20C21.7541755%2C21%2022%2C20.7502318%2022%2C20.4411977%20L22%2C2.55880234%20C22%2C2.25035759%2021.7541755%2C2%2021.4500209%2C2%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%2218%22%20width%3D%223%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2211%22%20y%3D%2218%22%20width%3D%2210%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2230%22%20y%3D%2218%22%20width%3D%222%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%222%22%20y%3D%225%22%20width%3D%2220%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%227%22%20y%3D%2221%22%20width%3D%221%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2226%22%20y%3D%2221%22%20width%3D%221%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%222%22%20y%3D%220%22%20width%3D%228%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%221%22%20height%3D%221%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var RAIL = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2212px%22%20height%3D%2215px%22%20viewBox%3D%220%200%2012%2015%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3E4C6E4388-9B02-46CC-9004-0FC5F11418D1%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%224.-C88-NEW---VALUE-BUILD-UP%22%20transform%3D%22translate%28-154.000000%2C%20-85.000000%29%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-14%22%20transform%3D%22translate%2814.000000%2C%2080.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%28147.000000%2C%2012.500000%29%20scale%28-1%2C%201%29%20translate%28-147.000000%2C%20-12.500000%29%20translate%28127.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22train%22%20transform%3D%22translate%2815.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.2764455%2C1.13744076%20C8.11947867%2C1.13744076%207.99208531%2C1.26483412%207.99208531%2C1.42180095%20C7.99208531%2C1.57876777%208.11947867%2C1.70616114%208.2764455%2C1.70616114%20C8.43341232%2C1.70616114%208.56080569%2C1.57876777%208.56080569%2C1.42180095%20C8.56080569%2C1.26483412%208.43341232%2C1.13744076%208.2764455%2C1.13744076%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.72668246%2C1.13744076%20C3.56971564%2C1.13744076%203.44232227%2C1.26483412%203.44232227%2C1.42180095%20C3.44232227%2C1.57876777%203.56971564%2C1.70616114%203.72668246%2C1.70616114%20C3.88364929%2C1.70616114%204.01104265%2C1.57876777%204.01104265%2C1.42180095%20C4.01104265%2C1.26483412%203.88364929%2C1.13744076%203.72668246%2C1.13744076%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.9157725%2C14.0782464%20L10.0341043%2C12.112436%20C10.7942844%2C12.0851943%2011.4044076%2C11.4586635%2011.4044076%2C10.6919431%20L11.4044076%2C2.25412322%20C11.4044076%2C1.79468246%2011.2438294%2C1.34601896%2010.9521896%2C0.990767773%20C10.6603507%2C0.635601896%2010.2514976%2C0.390853081%209.80109953%2C0.301763033%20C8.79184834%2C0.101516588%207.75854028%2C0%206.72983886%2C0%20L5.22756398%2C0%20C4.24916588%2C0%203.23004739%2C0.0937251185%202.19878673%2C0.299829384%20C1.27163033%2C0.485317536%200.598720379%2C1.30629384%200.598720379%2C2.25184834%20L0.598720379%2C10.6919431%20C0.598720379%2C11.4651185%201.21919431%2C12.0956872%201.98830332%2C12.1129194%20L0.0853933649%2C14.0770237%20C0.00591469194%2C14.1590332%20-0.0167772512%2C14.2806256%200.0277819905%2C14.3857536%20C0.0722843602%2C14.49091%200.175421801%2C14.5592417%200.289620853%2C14.5592417%20L2.32279621%2C14.5592417%20C2.41396209%2C14.5592417%202.49958294%2C14.5155355%202.55307109%2C14.4417156%20L3.41564929%2C13.2511848%20L8.61278673%2C13.2511848%20L9.47536493%2C14.4417441%20C9.52885308%2C14.5155355%209.61450237%2C14.5592417%209.70563981%2C14.5592417%20L11.7103791%2C14.5592417%20C11.8242654%2C14.5592417%2011.9271469%2C14.4912796%2011.9718768%2C14.3865782%20C12.0166066%2C14.2818199%2011.9945403%2C14.1605403%2011.9157725%2C14.0782464%20Z%20M1.16744076%2C10.6919431%20L1.16744076%2C2.25184834%20C1.16744076%2C1.57640758%201.64809479%2C0.99%202.31028436%2C0.857488152%20C3.23852133%2C0.671971564%204.21936493%2C0.568720379%205.22753555%2C0.568720379%20L6.72981043%2C0.568720379%20C7.72145972%2C0.568720379%208.71751659%2C0.66656872%209.69051185%2C0.859592417%20C10.012237%2C0.923260664%2010.3042749%2C1.09808531%2010.512654%2C1.35170616%20C10.7209479%2C1.60544076%2010.8356588%2C1.92591469%2010.8356588%2C2.25409479%20L10.8356588%2C10.6919431%20C10.8356588%2C11.1623318%2010.4529668%2C11.5450237%209.9825782%2C11.5450237%20L2.02049289%2C11.5450237%20C1.5501327%2C11.5450237%201.16744076%2C11.1623318%201.16744076%2C10.6919431%20Z%20M2.1776872%2C13.9905213%20L0.961052133%2C13.9905213%20L2.77933649%2C12.1137441%20L3.53749763%2C12.1137441%20L2.1776872%2C13.9905213%20Z%20M3.82771564%2C12.6824645%20L4.23978199%2C12.1137441%20L7.78868246%2C12.1137441%20L8.20072038%2C12.6824645%20L3.82771564%2C12.6824645%20Z%20M9.85074882%2C13.9905213%20L8.49099526%2C12.1137441%20L9.24810427%2C12.1137441%20L11.0445498%2C13.9905213%20L9.85074882%2C13.9905213%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.98260664%2C2.27488152%20L2.02052133%2C2.27488152%20C1.86349763%2C2.27488152%201.73616114%2C2.40221801%201.73616114%2C2.55924171%20L1.73616114%2C7.27962085%20C1.73616114%2C7.43664455%201.86349763%2C7.56398104%202.02052133%2C7.56398104%20L9.98260664%2C7.56398104%20C10.1396303%2C7.56398104%2010.2669668%2C7.43664455%2010.2669668%2C7.27962085%20L10.2669668%2C2.55924171%20C10.2669668%2C2.40221801%2010.1396303%2C2.27488152%209.98260664%2C2.27488152%20Z%20M5.71720379%2C6.99526066%20L2.30488152%2C6.99526066%20L2.30488152%2C2.8436019%20L5.71720379%2C2.8436019%20L5.71720379%2C6.99526066%20Z%20M9.69824645%2C6.99526066%20L6.28592417%2C6.99526066%20L6.28592417%2C2.8436019%20L9.69824645%2C2.8436019%20L9.69824645%2C6.99526066%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.13900474%2C1.13744076%20L4.86412322%2C1.13744076%20C4.70709953%2C1.13744076%204.57976303%2C1.26477725%204.57976303%2C1.42180095%20C4.57976303%2C1.57882464%204.70709953%2C1.70616114%204.86412322%2C1.70616114%20L7.13900474%2C1.70616114%20C7.29602844%2C1.70616114%207.42336493%2C1.57882464%207.42336493%2C1.42180095%20C7.42336493%2C1.26477725%207.29602844%2C1.13744076%207.13900474%2C1.13744076%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.12952607%2C8.41706161%20C8.50234123%2C8.41706161%207.99208531%2C8.92731754%207.99208531%2C9.55450237%20C7.99208531%2C10.1816872%208.50234123%2C10.6919431%209.12952607%2C10.6919431%20C9.7567109%2C10.6919431%2010.2669668%2C10.1816872%2010.2669668%2C9.55450237%20C10.2669668%2C8.92731754%209.7567109%2C8.41706161%209.12952607%2C8.41706161%20Z%20M9.12952607%2C10.1232227%20C8.81593365%2C10.1232227%208.56080569%2C9.86809479%208.56080569%2C9.55450237%20C8.56080569%2C9.24090995%208.81593365%2C8.98578199%209.12952607%2C8.98578199%20C9.44311848%2C8.98578199%209.69824645%2C9.24090995%209.69824645%2C9.55450237%20C9.69824645%2C9.86809479%209.44311848%2C10.1232227%209.12952607%2C10.1232227%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.8736019%2C8.41706161%20C2.24641706%2C8.41706161%201.73616114%2C8.92731754%201.73616114%2C9.55450237%20C1.73616114%2C10.1816872%202.2464455%2C10.6919431%202.8736019%2C10.6919431%20C3.50078673%2C10.6919431%204.01104265%2C10.1816872%204.01104265%2C9.55450237%20C4.01104265%2C8.92731754%203.50078673%2C8.41706161%202.8736019%2C8.41706161%20Z%20M2.8736019%2C10.1232227%20C2.56000948%2C10.1232227%202.30488152%2C9.86809479%202.30488152%2C9.55450237%20C2.30488152%2C9.24090995%202.56000948%2C8.98578199%202.8736019%2C8.98578199%20C3.18719431%2C8.98578199%203.44232227%2C9.24090995%203.44232227%2C9.55450237%20C3.44232227%2C9.86809479%203.18719431%2C10.1232227%202.8736019%2C10.1232227%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.13900474%2C8.7014218%20L4.86412322%2C8.7014218%20C4.70709953%2C8.7014218%204.57976303%2C8.82875829%204.57976303%2C8.98578199%20C4.57976303%2C9.14280569%204.70709953%2C9.27014218%204.86412322%2C9.27014218%20L7.13900474%2C9.27014218%20C7.29602844%2C9.27014218%207.42336493%2C9.14280569%207.42336493%2C8.98578199%20C7.42336493%2C8.82875829%207.29605687%2C8.7014218%207.13900474%2C8.7014218%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.13900474%2C9.83886256%20L4.86412322%2C9.83886256%20C4.70709953%2C9.83886256%204.57976303%2C9.96619905%204.57976303%2C10.1232227%20C4.57976303%2C10.2802464%204.70709953%2C10.4075829%204.86412322%2C10.4075829%20L7.13900474%2C10.4075829%20C7.29602844%2C10.4075829%207.42336493%2C10.2802464%207.42336493%2C10.1232227%20C7.42336493%2C9.96619905%207.29605687%2C9.83886256%207.13900474%2C9.83886256%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const CompleteTransit = props => /*#__PURE__*/React__namespace.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M1.8557 36.5904C1.84869 36.5918 1.8414 36.5912 1.83478 36.5884C1.82816 36.5857 1.82253 36.581 1.8186 36.575C1.81602 36.5711 1.81423 36.5667 1.81336 36.5622C1.81249 36.5576 1.81254 36.5529 1.81352 36.5483C1.8145 36.5437 1.81638 36.5394 1.81906 36.5356C1.82173 36.5317 1.82515 36.5285 1.8291 36.526L1.981 36.428C1.98884 36.4242 1.9978 36.4234 2.0062 36.4257C2.01459 36.4281 2.02184 36.4334 2.02658 36.4407C2.03131 36.448 2.03321 36.4568 2.0319 36.4654C2.0306 36.4741 2.02619 36.4819 2.0195 36.4875L1.8676 36.5855C1.86413 36.5881 1.86002 36.5898 1.8557 36.5904V36.5904Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19.7959 31.673C19.7959 31.673 20.8361 13.3609 27.7577 2.24096C27.8628 2.07106 28.0118 1.93261 28.1889 1.84019C28.366 1.74778 28.5648 1.7048 28.7643 1.71579C28.9638 1.72678 29.1566 1.79133 29.3225 1.90265C29.4884 2.01396 29.6212 2.16793 29.707 2.34836C32.2314 7.66738 38.1824 24.1043 19.7959 31.673Z",
  fill: "#B4D9B6"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.3451 30.2283C21.3384 30.2384 21.3356 30.2506 21.3373 30.2626C21.3391 30.2746 21.3452 30.2855 21.3545 30.2932C21.3639 30.3009 21.3757 30.3049 21.3878 30.3044C21.4 30.3038 21.4114 30.2988 21.42 30.2903C22.961 28.6562 28.6693 20.95 28.9057 7.57612C28.906 7.5716 28.9054 7.56706 28.904 7.56276C28.9026 7.55846 28.9003 7.55449 28.8973 7.55107C28.8944 7.54764 28.8907 7.54484 28.8867 7.54281C28.8826 7.54079 28.8782 7.53958 28.8737 7.53926C28.8646 7.53861 28.8556 7.54161 28.8487 7.54761C28.8417 7.5536 28.8375 7.56209 28.8368 7.57122C28.5086 10.7178 26.95 22.3923 21.3451 30.2283Z",
  fill: "#6BA32F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.244 35.063C22.244 35.063 19.4142 26.0831 27.7458 21.1101C32.953 18.0019 35.0386 15.5038 35.8711 14.0663C36.1472 13.5936 36.8192 13.5859 36.9715 14.0493C38.1113 17.5096 39.3313 27.094 22.244 35.063Z",
  fill: "#8AC58D"
}), /*#__PURE__*/React__namespace.createElement("path", {
  opacity: "0.5",
  d: "M34.368 19.2133C34.3856 19.1739 34.4415 19.1871 34.4305 19.2271C33.9894 20.7217 31.3777 26.9493 23.5022 32.6658C23.4765 32.684 23.4513 32.6529 23.4756 32.6327C25.2354 31.1424 31.6419 25.441 34.368 19.2133Z",
  fill: "#6BA32F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.0063 7.46666C16.018 7.46463 16.0292 7.4603 16.0393 7.45392C16.0493 7.44754 16.058 7.43923 16.0648 7.42948C16.0716 7.41973 16.0764 7.40873 16.0789 7.39711C16.0815 7.38549 16.0817 7.37348 16.0795 7.36178L16.0311 7.09761C16.029 7.08592 16.0246 7.07475 16.0182 7.06474C16.0118 7.05473 16.0035 7.04608 15.9938 7.03928C15.984 7.03248 15.9731 7.02767 15.9615 7.02511C15.9499 7.02256 15.9379 7.02232 15.9262 7.02439C15.9145 7.02647 15.9033 7.03084 15.8933 7.03723C15.8833 7.04363 15.8746 7.05193 15.8679 7.06167C15.8611 7.07141 15.8562 7.08239 15.8537 7.09399C15.8511 7.10559 15.8509 7.11758 15.853 7.12927L15.9005 7.39443C15.9037 7.41132 15.9117 7.42694 15.9234 7.43953C15.9351 7.45212 15.9501 7.46118 15.9667 7.46567C15.9797 7.469 15.9932 7.46934 16.0063 7.46666V7.46666ZM15.9123 6.9492C15.9357 6.94463 15.9563 6.9311 15.9698 6.91149C15.9833 6.89189 15.9886 6.86778 15.9846 6.84432L15.9479 6.64644C15.9255 6.52282 15.9464 6.39524 16.0071 6.28526C16.0679 6.17528 16.1648 6.08967 16.2814 6.0429C16.4718 5.96808 16.6777 5.94123 16.881 5.96474C16.8927 5.96611 16.9045 5.96515 16.9159 5.9619C16.9272 5.95865 16.9378 5.95319 16.947 5.94583C16.9562 5.93847 16.9638 5.92935 16.9695 5.91901C16.9751 5.90867 16.9787 5.8973 16.9799 5.88558C16.9819 5.86209 16.9748 5.83873 16.9601 5.82032C16.9453 5.80191 16.9241 5.78985 16.9008 5.78664C16.6679 5.7596 16.4321 5.79053 16.2141 5.87668C16.0585 5.93881 15.9291 6.05284 15.848 6.19945C15.7668 6.34605 15.7389 6.51621 15.7689 6.68107L15.8055 6.87895C15.8082 6.8959 15.8159 6.91167 15.8275 6.92433C15.8391 6.93698 15.8541 6.94597 15.8708 6.95019C15.8845 6.95352 15.8988 6.95318 15.9123 6.9492V6.9492Z",
  fill: "#B7DFDF"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.32909 9.61857L24.4561 9.12907C24.8844 9.11587 25.3014 9.26778 25.6208 9.55338C25.9402 9.83898 26.1376 10.2364 26.1722 10.6635L28.0724 34.0089C28.0859 34.1736 28.0661 34.3393 28.0143 34.4962C27.9625 34.6531 27.8796 34.7979 27.7706 34.9221C27.6616 35.0463 27.5288 35.1473 27.38 35.2191C27.2311 35.2909 27.0694 35.3321 26.9044 35.3401L8.43039 36.2365C8.27549 36.2434 8.12077 36.2195 7.97519 36.1662C7.82962 36.1128 7.6961 36.031 7.58239 35.9256C7.46868 35.8202 7.37704 35.6933 7.3128 35.5522C7.24856 35.4111 7.213 35.2586 7.20818 35.1036L6.49432 11.5728C6.47854 11.0704 6.66298 10.5823 7.00705 10.2158C7.35112 9.8493 7.82666 9.63449 8.32909 9.61857Z",
  fill: "#B9ADA2"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.32909 9.61857L24.4561 9.12907C24.8844 9.11587 25.3014 9.26778 25.6208 9.55338C25.9402 9.83898 26.1376 10.2364 26.1722 10.6635L28.0724 34.0089C28.0859 34.1736 28.0661 34.3393 28.0143 34.4962C27.9625 34.6531 27.8796 34.7979 27.7706 34.9221C27.6616 35.0463 27.5288 35.1473 27.38 35.2191C27.2311 35.2909 27.0694 35.3321 26.9044 35.3401L8.43039 36.2365C8.27549 36.2434 8.12077 36.2195 7.97519 36.1662C7.82962 36.1128 7.6961 36.031 7.58239 35.9256C7.46868 35.8202 7.37704 35.6933 7.3128 35.5522C7.24856 35.4111 7.213 35.2586 7.20818 35.1036L6.49432 11.5728C6.47854 11.0704 6.66298 10.5823 7.00705 10.2158C7.35112 9.8493 7.82666 9.63449 8.32909 9.61857Z",
  fill: "#8E877F"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.12 35.7653L9.05044 35.802C8.7145 35.8061 8.39029 35.6786 8.14713 35.4467C7.90398 35.2149 7.76118 34.8971 7.74929 34.5614L7.6543 31.4388C7.6538 31.4248 7.65887 31.4113 7.66838 31.401C7.6779 31.3908 7.6911 31.3848 7.70506 31.3843C7.71197 31.384 7.71886 31.3852 7.72534 31.3876C7.73182 31.39 7.73776 31.3937 7.74283 31.3984C7.75305 31.4079 7.75907 31.4211 7.75957 31.4351L7.85456 34.5576C7.8648 34.866 7.99561 35.1581 8.21889 35.3711C8.44217 35.5842 8.7401 35.7011 9.04866 35.6968L11.1182 35.6602C11.1321 35.6602 11.1455 35.6656 11.1554 35.6752C11.1654 35.6848 11.1713 35.698 11.1717 35.7119C11.1718 35.7188 11.1706 35.7257 11.1681 35.7321C11.1656 35.7385 11.1618 35.7444 11.157 35.7494C11.1522 35.7543 11.1464 35.7583 11.1401 35.761C11.1337 35.7638 11.1269 35.7652 11.12 35.7653V35.7653Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7.67911 30.5225C7.6652 30.5228 7.65173 30.5177 7.64155 30.5082C7.63137 30.4987 7.62528 30.4856 7.62459 30.4717L7.60959 29.9654C7.60929 29.9515 7.61442 29.938 7.6239 29.9278C7.63338 29.9177 7.64646 29.9116 7.66035 29.9109V29.9109C7.67423 29.9109 7.68757 29.9163 7.69755 29.9259C7.70753 29.9355 7.71337 29.9487 7.71382 29.9626L7.72987 30.468C7.73015 30.482 7.72487 30.4957 7.71518 30.5058C7.7055 30.516 7.69218 30.522 7.67812 30.5224L7.67911 30.5225Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.373 9.42686C10.5847 9.65525 18.1853 10.3522 24.4318 9.68164C24.4997 9.67377 24.5685 9.67962 24.6342 9.69886C24.6998 9.7181 24.7609 9.75033 24.8138 9.79364C24.8668 9.83695 24.9105 9.89045 24.9423 9.95097C24.9742 10.0115 24.9935 10.0778 24.9993 10.1459L26.9559 33.5928C26.9687 33.7472 26.9199 33.9005 26.8202 34.019C26.7204 34.1376 26.5777 34.2119 26.4234 34.2257C23.7941 34.4615 12.9673 35.3936 9.08719 35.1054C8.97314 35.097 8.86619 35.0468 8.78687 34.9645C8.70754 34.8821 8.66143 34.7733 8.65737 34.659L7.76391 9.99583C7.76091 9.91683 7.77494 9.8381 7.80505 9.76499C7.83516 9.69188 7.88064 9.62611 7.93842 9.57214C7.99619 9.51817 8.06491 9.47726 8.1399 9.45219C8.21488 9.42713 8.29438 9.41849 8.373 9.42686V9.42686Z",
  fill: "#BEB7B0"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.62718 10.0295C10.7549 10.2529 18.0698 10.9203 24.0819 10.2747C24.1468 10.2682 24.2124 10.2746 24.2748 10.2935C24.3372 10.3124 24.3952 10.3435 24.4456 10.385C24.496 10.4264 24.5376 10.4774 24.5682 10.535C24.5988 10.5926 24.6177 10.6557 24.6238 10.7207L26.5111 33.2853C26.5234 33.4339 26.4764 33.5814 26.3804 33.6955C26.2845 33.8097 26.1473 33.8813 25.9987 33.8946C23.4691 34.1214 13.0486 35.0208 9.31562 34.7411C9.20589 34.7328 9.10309 34.6842 9.02691 34.6048C8.95073 34.5254 8.90652 34.4206 8.90272 34.3107L8.04237 10.5731C8.03991 10.4975 8.05369 10.4222 8.08278 10.3523C8.11188 10.2825 8.15561 10.2197 8.21103 10.1682C8.26645 10.1166 8.33227 10.0776 8.40406 10.0537C8.47585 10.0297 8.55193 10.0215 8.62718 10.0295V10.0295Z",
  fill: "#FFFCFA"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.62718 10.0295C10.7549 10.2529 18.0698 10.9203 24.0819 10.2747C24.1468 10.2682 24.2124 10.2746 24.2748 10.2935C24.3372 10.3124 24.3952 10.3435 24.4456 10.385C24.496 10.4264 24.5376 10.4774 24.5682 10.535C24.5988 10.5926 24.6177 10.6557 24.6238 10.7207L26.5111 33.2853C26.5234 33.4339 26.4764 33.5814 26.3804 33.6955C26.2845 33.8097 26.1473 33.8813 25.9987 33.8946C23.4691 34.1214 13.0486 35.0208 9.31562 34.7411C9.20589 34.7328 9.10309 34.6842 9.02691 34.6048C8.95073 34.5254 8.90652 34.4206 8.90272 34.3107L8.04237 10.5731C8.03991 10.4975 8.05369 10.4222 8.08278 10.3523C8.11188 10.2825 8.15561 10.2197 8.21103 10.1682C8.26645 10.1166 8.33227 10.0776 8.40406 10.0537C8.47585 10.0297 8.55193 10.0215 8.62718 10.0295V10.0295Z",
  fill: "#EDEBE9"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.9695 12.2652C23.9898 12.2649 24.0097 12.2603 24.0281 12.2519C24.0464 12.2434 24.0629 12.2312 24.0762 12.216C24.0896 12.2009 24.0997 12.1831 24.1058 12.1638C24.1119 12.1445 24.114 12.1242 24.1118 12.104L24.1124 12.0932C24.1076 12.0506 24.0873 12.0114 24.0553 11.983C24.0232 11.9546 23.9818 11.939 23.939 11.9393L10.2439 12.2469C10.1575 12.2488 10.1325 12.3048 10.1881 12.3705L10.3448 12.5551C10.4126 12.6259 10.5057 12.667 10.6037 12.6693L23.9695 12.2652Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.2733 13.1505C10.187 13.1524 10.1619 13.2084 10.2176 13.2741L10.3743 13.4587C10.4077 13.494 10.4478 13.5222 10.4922 13.5418C10.5367 13.5615 10.5846 13.572 10.6332 13.5729L23.9939 13.1715C24.0141 13.1712 24.034 13.1666 24.0524 13.1581C24.0708 13.1497 24.0872 13.1375 24.1006 13.1223C24.114 13.1071 24.124 13.0893 24.1302 13.0701C24.1363 13.0508 24.1383 13.0304 24.1361 13.0103L24.1368 12.9994C24.132 12.9569 24.1116 12.9177 24.0796 12.8892C24.0476 12.8608 24.0062 12.8453 23.9634 12.8456L10.2733 13.1505Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.3254 20.8414C13.2992 20.1362 13.2655 19.4752 13.1488 19.1314C13.1093 19.0266 13.0364 18.9377 12.9413 18.8784C12.8463 18.8191 12.7344 18.7927 12.6229 18.8033L12.615 18.8028C12.2795 18.8278 11.7106 18.9125 11.2097 18.9873C10.9788 19.0214 10.7698 19.0528 10.617 19.0726C10.5636 19.0794 10.5121 19.0968 10.4654 19.1237C10.4188 19.1505 10.3779 19.1864 10.3452 19.2291C10.3178 19.2653 10.2981 19.3066 10.2874 19.3507C10.2766 19.3947 10.275 19.4405 10.2827 19.4852L10.5372 20.9966C10.5631 21.1142 10.6309 21.2183 10.728 21.2895C10.8251 21.3607 10.9448 21.394 11.0647 21.3832L12.8781 21.2861L12.8831 21.2863C12.9999 21.2833 13.111 21.2354 13.1934 21.1525C13.2758 21.0697 13.323 20.9582 13.3254 20.8414ZM10.636 19.2214C10.7888 19.2016 10.9998 19.1703 11.2307 19.1362C11.7057 19.0649 12.2955 18.9774 12.629 18.9533C12.7087 18.944 12.7893 18.9609 12.8585 19.0017C12.9277 19.0424 12.9817 19.1046 13.0122 19.1789C13.1221 19.5034 13.1535 20.1535 13.1803 20.8468C13.1781 20.9266 13.1448 21.0024 13.0875 21.0579C13.0301 21.1134 12.9534 21.1444 12.8736 21.1441V21.1441L11.0604 21.2363C10.9767 21.2456 10.8926 21.2238 10.8238 21.1753C10.7551 21.1267 10.7065 21.0546 10.6873 20.9727L10.4327 19.4622C10.4284 19.4371 10.4294 19.4113 10.4356 19.3866C10.4418 19.3619 10.4531 19.3387 10.4688 19.3186C10.4894 19.2917 10.5151 19.2692 10.5445 19.2523C10.5739 19.2355 10.6064 19.2247 10.6401 19.2206L10.636 19.2214Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.8409 19.3622C11.2195 19.312 12.0411 19.1766 12.4343 19.1471C12.5109 19.1381 12.5884 19.1548 12.6546 19.1945C12.7208 19.2343 12.7719 19.2948 12.8 19.3667C12.894 19.6418 12.9188 20.2002 12.9382 20.7167C12.9363 20.7956 12.9037 20.8706 12.8474 20.9258C12.791 20.981 12.7153 21.012 12.6365 21.0123L11.1879 21.0891C11.1065 21.0973 11.0249 21.0753 10.9585 21.0274C10.8921 20.9796 10.8455 20.9091 10.8275 20.8292L10.6233 19.625C10.6197 19.5933 10.6225 19.5613 10.6316 19.5307C10.6406 19.5002 10.6558 19.4718 10.6761 19.4472C10.6964 19.4227 10.7215 19.4025 10.7498 19.3879C10.7781 19.3733 10.8091 19.3645 10.8409 19.3622V19.3622Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.3835 19.6099C14.3645 19.6092 14.3458 19.6133 14.3288 19.6217C14.3119 19.6302 14.2974 19.6428 14.2866 19.6584C14.2758 19.6739 14.2691 19.692 14.2671 19.7108C14.2651 19.7296 14.2679 19.7486 14.2752 19.7661L14.4716 20.3574C14.4877 20.399 14.5161 20.4348 14.5531 20.4598C14.5901 20.4848 14.6338 20.4979 14.6785 20.4973L23.7865 19.9246C23.807 19.9234 23.827 19.918 23.8454 19.9089C23.8638 19.8998 23.8802 19.8871 23.8936 19.8715C23.907 19.8559 23.9171 19.8378 23.9234 19.8182C23.9296 19.7987 23.9319 19.778 23.93 19.7576L23.8996 19.397C23.8956 19.3549 23.8758 19.3159 23.8441 19.2879C23.8124 19.2599 23.7713 19.245 23.729 19.2463L14.3835 19.6099Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.2386 16.7639C13.2124 16.0587 13.1787 15.3977 13.062 15.0539C13.0225 14.9489 12.9494 14.8599 12.8542 14.8005C12.7589 14.7412 12.6468 14.715 12.5351 14.7258L12.5282 14.7254C12.1927 14.7513 11.6238 14.836 11.1219 14.9098C10.8919 14.9449 10.682 14.9752 10.5302 14.9961C10.4768 15.0026 10.4252 15.0197 10.3786 15.0464C10.3319 15.0731 10.291 15.1089 10.2584 15.1517C10.2311 15.188 10.2114 15.2295 10.2005 15.2737C10.1896 15.3178 10.1876 15.3637 10.1949 15.4086L10.4505 16.9191C10.4763 17.0367 10.5441 17.1409 10.6412 17.212C10.7383 17.2832 10.858 17.3165 10.9779 17.3058L12.7911 17.2135C12.9096 17.2118 13.0227 17.1638 13.1063 17.0798C13.19 16.9958 13.2374 16.8825 13.2386 16.7639V16.7639ZM10.5492 15.1449C10.7021 15.1241 10.913 15.0928 11.144 15.0587C11.6189 14.9874 12.2088 14.8999 12.5422 14.8758C12.622 14.8661 12.7027 14.883 12.772 14.9238C12.8413 14.9645 12.8952 15.0269 12.9255 15.1014C13.0363 15.426 13.0667 16.076 13.0945 16.7704C13.0913 16.8489 13.058 16.9231 13.0015 16.9776C12.9449 17.0321 12.8695 17.0626 12.791 17.0629V17.0629L10.9778 17.1551C10.8942 17.1644 10.81 17.1427 10.7413 17.0941C10.6725 17.0455 10.6239 16.9734 10.6047 16.8915L10.3491 15.381C10.3452 15.3558 10.3465 15.33 10.3528 15.3054C10.3592 15.2807 10.3706 15.2576 10.3862 15.2374C10.4067 15.2105 10.4325 15.1881 10.4619 15.1714C10.4913 15.1547 10.5238 15.1442 10.5574 15.1404L10.5492 15.1449Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.7532 15.2846C11.1327 15.2355 11.9533 15.0991 12.3515 15.0698C12.4282 15.0613 12.5056 15.0782 12.5719 15.1179C12.6381 15.1575 12.6895 15.2178 12.7182 15.2895C12.8112 15.5645 12.837 16.123 12.8564 16.6395C12.8545 16.7184 12.8219 16.7934 12.7656 16.8486C12.7092 16.9038 12.6335 16.9348 12.5547 16.9351L11.1051 17.0119C11.0239 17.0202 10.9424 16.9985 10.8762 16.9508C10.8099 16.9031 10.7635 16.8327 10.7456 16.753L10.5417 15.5458C10.5382 15.5148 10.541 15.4833 10.5498 15.4533C10.5586 15.4234 10.5733 15.3954 10.5929 15.3711C10.6126 15.3468 10.6369 15.3267 10.6644 15.3118C10.6919 15.297 10.7221 15.2878 10.7532 15.2846V15.2846Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.2957 15.5323C14.2767 15.5314 14.2578 15.5353 14.2407 15.5437C14.2236 15.5521 14.209 15.5647 14.1981 15.5803C14.1873 15.596 14.1806 15.6141 14.1788 15.6331C14.1769 15.652 14.1799 15.6711 14.1875 15.6886L14.385 16.2769C14.401 16.3187 14.4294 16.3545 14.4664 16.3795C14.5034 16.4046 14.5472 16.4176 14.5919 16.4169L23.6998 15.8451C23.7203 15.8438 23.7403 15.8384 23.7586 15.8292C23.777 15.82 23.7933 15.8073 23.8067 15.7917C23.82 15.7762 23.8302 15.7581 23.8365 15.7386C23.8428 15.7191 23.8451 15.6985 23.8434 15.6781L23.813 15.3166C23.8091 15.2745 23.7893 15.2354 23.7576 15.2074C23.7259 15.1794 23.6847 15.1646 23.6424 15.1659L14.2957 15.5323Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.5691 24.7259C13.5429 24.0207 13.5092 23.3587 13.3936 23.015C13.354 22.91 13.2809 22.8209 13.1857 22.7616C13.0904 22.7023 12.9783 22.676 12.8666 22.6868L12.8587 22.6864C12.5233 22.7114 11.9544 22.796 11.4535 22.8708C11.2225 22.9049 11.0136 22.9363 10.8608 22.9561C10.8074 22.9627 10.7559 22.9798 10.7092 23.0065C10.6626 23.0333 10.6217 23.069 10.589 23.1117C10.5619 23.1481 10.5423 23.1897 10.5316 23.2338C10.5208 23.278 10.5191 23.3238 10.5264 23.3687L10.7806 24.887C10.8064 25.0046 10.8742 25.1088 10.9713 25.1799C11.0684 25.2511 11.1882 25.2844 11.3081 25.2737L13.1212 25.1814L13.1262 25.1817C13.245 25.179 13.3581 25.1298 13.4409 25.0445C13.5238 24.9592 13.5698 24.8448 13.5691 24.7259V24.7259ZM10.8806 23.1089C11.0334 23.0891 11.2433 23.0578 11.4743 23.0227C11.9493 22.9513 12.5401 22.865 12.8726 22.8398C12.9523 22.8308 13.0327 22.8479 13.1019 22.8886C13.171 22.9293 13.225 22.9913 13.2558 23.0654C13.3656 23.3909 13.3971 24.04 13.4239 24.7343C13.4207 24.8129 13.3874 24.8872 13.3309 24.9419C13.2744 24.9965 13.1989 25.0273 13.1203 25.0278V25.0278L11.3081 25.1201C11.2245 25.1294 11.1403 25.1079 11.0714 25.0595C11.0025 25.0111 10.9536 24.9392 10.934 24.8574L10.6794 23.3469C10.675 23.3216 10.676 23.2957 10.6823 23.2708C10.6885 23.2459 10.6998 23.2226 10.7156 23.2023C10.7362 23.1754 10.7622 23.1529 10.7918 23.1363C10.8213 23.1196 10.854 23.1091 10.8877 23.1054L10.8806 23.1089Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.0846 23.2467C11.4632 23.1965 12.2848 23.0602 12.6781 23.0306C12.7547 23.022 12.832 23.0388 12.8981 23.0785C12.9642 23.1182 13.0154 23.1785 13.0438 23.2502C13.1378 23.5253 13.1625 24.0847 13.182 24.6002C13.1803 24.6793 13.1479 24.7545 13.0915 24.81C13.0351 24.8654 12.9592 24.8965 12.8802 24.8968L11.4317 24.9737C11.3502 24.9818 11.2686 24.9598 11.2022 24.9119C11.1358 24.8641 11.0892 24.7936 11.0712 24.7137L10.8674 23.5046C10.8643 23.4733 10.8675 23.4417 10.8768 23.4117C10.8862 23.3817 10.9014 23.3539 10.9216 23.3298C10.9419 23.3058 10.9667 23.2861 10.9947 23.2718C11.0227 23.2575 11.0533 23.249 11.0846 23.2467Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.6272 23.4944C14.6083 23.4935 14.5895 23.4974 14.5726 23.5058C14.5556 23.5141 14.5411 23.5266 14.5303 23.5421C14.5195 23.5576 14.5128 23.5756 14.5108 23.5944C14.5088 23.6132 14.5117 23.6322 14.519 23.6496L14.7154 24.2409C14.7311 24.2828 14.7594 24.3188 14.7965 24.3438C14.8336 24.3689 14.8775 24.3818 14.9223 24.3808L24.0302 23.8091C24.0507 23.8079 24.0708 23.8025 24.0893 23.7934C24.1077 23.7843 24.1242 23.7716 24.1376 23.756C24.1511 23.7405 24.1613 23.7224 24.1677 23.7028C24.1741 23.6833 24.1765 23.6626 24.1747 23.6421L24.1434 23.2805C24.1392 23.2385 24.1193 23.1996 24.0877 23.1717C24.056 23.1437 24.015 23.1287 23.9728 23.1298L14.6272 23.4944Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.6339 28.4662C13.6077 27.7609 13.5741 27.0989 13.4574 26.7551C13.4169 26.6493 13.3427 26.5598 13.2462 26.5004C13.1497 26.441 13.0363 26.4151 12.9236 26.4266C12.5881 26.4516 11.9942 26.5398 11.5173 26.611C11.2874 26.6451 11.0774 26.6765 10.9256 26.6963C10.8722 26.7028 10.8207 26.7199 10.774 26.7466C10.7273 26.7733 10.6865 26.8091 10.6539 26.8519C10.6265 26.8882 10.6068 26.9297 10.596 26.9739C10.5852 27.0181 10.5836 27.0641 10.5913 27.1089L10.8459 28.6194C10.8717 28.7369 10.9395 28.8411 11.0366 28.9123C11.1337 28.9834 11.2535 29.0168 11.3734 29.006L13.1865 28.9138L13.1915 28.914C13.3089 28.9113 13.4206 28.863 13.5032 28.7795C13.5857 28.6959 13.6326 28.5836 13.6339 28.4662V28.4662ZM10.9446 26.8461C11.0974 26.8263 11.3074 26.795 11.5443 26.7602C12.0182 26.6888 12.609 26.6025 12.9425 26.5773C13.0222 26.5687 13.1025 26.5859 13.1716 26.6266C13.2406 26.6672 13.2947 26.7291 13.3258 26.8029C13.4356 27.1285 13.467 27.7775 13.4938 28.4718C13.4889 28.5505 13.4546 28.6244 13.3975 28.6787C13.3405 28.7331 13.2651 28.7639 13.1863 28.7651L11.3731 28.8573C11.2896 28.8666 11.2055 28.8451 11.1368 28.7967C11.0681 28.7483 11.0194 28.6764 11 28.5947L10.7453 27.0842C10.741 27.0589 10.742 27.033 10.7482 27.0081C10.7545 26.9832 10.7658 26.9599 10.7815 26.9396C10.8021 26.9128 10.8279 26.8904 10.8573 26.8738C10.8867 26.8571 10.9192 26.8465 10.9527 26.8426L10.9446 26.8461Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.1493 26.9899C11.5279 26.9397 12.3495 26.8034 12.7427 26.7738C12.8193 26.7652 12.8967 26.782 12.9628 26.8217C13.0289 26.8614 13.0801 26.9217 13.1085 26.9934C13.2024 27.2685 13.2272 27.8279 13.2466 28.3434C13.245 28.4225 13.2125 28.4978 13.1561 28.5532C13.0997 28.6086 13.0239 28.6397 12.9449 28.64L11.4963 28.7169C11.4149 28.725 11.3333 28.703 11.2669 28.6552C11.2005 28.6073 11.1539 28.5368 11.1359 28.4569L10.9319 27.2498C10.9286 27.2183 10.9316 27.1865 10.9408 27.1563C10.95 27.126 10.9652 27.0979 10.9855 27.0737C11.0057 27.0494 11.0307 27.0295 11.0588 27.0151C11.087 27.0007 11.1178 26.9922 11.1493 26.9899V26.9899Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.692 27.2346C14.6732 27.2338 14.6544 27.2377 14.6374 27.246C14.6205 27.2544 14.6059 27.2669 14.5951 27.2824C14.5843 27.2979 14.5776 27.3159 14.5756 27.3347C14.5737 27.3535 14.5765 27.3725 14.5839 27.3899L14.7802 27.9811C14.7959 28.023 14.8243 28.059 14.8614 28.0841C14.8984 28.1092 14.9424 28.1221 14.9871 28.1211L24.0951 27.5484C24.1156 27.5471 24.1357 27.5418 24.1541 27.5327C24.1725 27.5236 24.1889 27.5108 24.2022 27.4952C24.2156 27.4797 24.2258 27.4616 24.232 27.442C24.2383 27.4224 24.2405 27.4018 24.2387 27.3813L24.2083 27.0198C24.2041 26.9778 24.1842 26.9389 24.1526 26.9109C24.1209 26.883 24.0799 26.868 24.0377 26.8691L14.692 27.2346Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.7497 31.0299C15.731 31.0297 15.7124 31.0341 15.6958 31.0427C15.6791 31.0513 15.6648 31.0639 15.6542 31.0793C15.6435 31.0947 15.6367 31.1125 15.6345 31.1311C15.6323 31.1498 15.6347 31.1686 15.6415 31.1861L15.82 31.7773C15.8348 31.8191 15.8624 31.8551 15.8988 31.8803C15.9352 31.9056 15.9786 31.9188 16.0229 31.9181L24.1341 31.409C24.1545 31.4076 24.1745 31.4022 24.1928 31.393C24.2112 31.3839 24.2275 31.3711 24.2409 31.3556C24.2542 31.34 24.2644 31.322 24.2707 31.3025C24.277 31.283 24.2793 31.2624 24.2776 31.2419L24.2482 30.8805C24.2443 30.8383 24.2245 30.7992 24.1928 30.771C24.1612 30.7428 24.12 30.7277 24.0777 30.7288L15.7497 31.0299Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.3072 31.4938C11.2876 31.4932 11.2681 31.497 11.2502 31.505C11.2323 31.513 11.2164 31.5249 11.2037 31.5399C11.191 31.5548 11.1819 31.5725 11.177 31.5915C11.172 31.6105 11.1714 31.6303 11.1752 31.6496L11.2479 32.1018C11.2561 32.144 11.2792 32.1819 11.3129 32.2086C11.3466 32.2352 11.3887 32.249 11.4317 32.2473L14.3085 32.0666C14.329 32.0652 14.3491 32.0598 14.3675 32.0507C14.386 32.0416 14.4024 32.0289 14.4159 32.0134C14.4294 31.9979 14.4398 31.9798 14.4463 31.9603C14.4529 31.9408 14.4555 31.9202 14.454 31.8997L14.4355 31.6409C14.4318 31.5984 14.4125 31.5588 14.3812 31.5299C14.3499 31.5009 14.3089 31.4847 14.2662 31.4843L11.3072 31.4938Z",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.3985 8.45091L15.5633 8.34364L15.3638 6.6699C15.3433 6.50627 15.3803 6.34059 15.4683 6.20115C15.5563 6.0617 15.69 5.95712 15.8466 5.90524C16.2002 5.78914 16.7061 5.76618 17.3009 6.15377C18.4625 6.91544 17.3985 8.45091 17.3985 8.45091ZM16.9751 7.0634C16.9724 6.97325 16.943 6.88593 16.8907 6.81248C16.8384 6.73903 16.7654 6.68274 16.6811 6.65072C16.5968 6.61871 16.5049 6.61241 16.417 6.63263C16.3291 6.65284 16.2492 6.69865 16.1873 6.76428C16.1255 6.82991 16.0844 6.9124 16.0695 7.00134C16.0545 7.09027 16.0662 7.18165 16.1031 7.26393C16.14 7.34621 16.2005 7.41569 16.277 7.4636C16.3534 7.5115 16.4423 7.53568 16.5324 7.53307C16.6533 7.52905 16.7676 7.47743 16.8505 7.38944C16.9335 7.30146 16.9783 7.18426 16.9751 7.0634Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.099 9.50389L13.074 8.65999C13.0719 8.59093 13.0838 8.52215 13.1089 8.45776C13.1339 8.39336 13.1717 8.33466 13.2199 8.28515C13.2681 8.23564 13.3257 8.19632 13.3894 8.16953C13.4531 8.14275 13.5216 8.12904 13.5907 8.12923L19.415 8.15251C19.5397 8.15324 19.6596 8.20037 19.7514 8.2847C19.8432 8.36904 19.9003 8.48455 19.9116 8.6087L19.9852 9.41778L13.099 9.50389Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.9863 8.414C14.9725 8.4143 14.9592 8.40914 14.9492 8.39965C14.9391 8.39015 14.9333 8.3771 14.9328 8.3633C14.9324 8.35635 14.9334 8.34938 14.9358 8.34283C14.9381 8.33627 14.9418 8.33027 14.9465 8.32517C14.9513 8.32007 14.957 8.31599 14.9634 8.31317C14.9697 8.31036 14.9766 8.30886 14.9836 8.30878L15.2338 8.30061C15.2408 8.30034 15.2478 8.30148 15.2543 8.30395C15.2609 8.30642 15.2669 8.31018 15.272 8.315C15.277 8.31982 15.2811 8.32561 15.2839 8.33203C15.2867 8.33845 15.2882 8.34536 15.2883 8.35236C15.2886 8.36627 15.2834 8.37974 15.274 8.38992C15.2645 8.4001 15.2514 8.40619 15.2375 8.40688L14.9873 8.41406L14.9863 8.414Z",
  fill: "#B7DFDF"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.3762 9.27134C13.3586 9.26563 13.3433 9.25458 13.3322 9.23973C13.3212 9.22487 13.3151 9.20695 13.3147 9.18845L13.3039 8.84688C13.3002 8.70772 13.3517 8.57274 13.4471 8.47138C13.5425 8.37001 13.6741 8.31049 13.8133 8.30578L14.7326 8.27825C14.7559 8.27891 14.778 8.28843 14.7944 8.30486C14.8108 8.32129 14.8204 8.34338 14.821 8.36661C14.8217 8.38984 14.8135 8.41245 14.798 8.4298C14.7825 8.44715 14.761 8.45793 14.7379 8.45992L13.8185 8.48746C13.7274 8.49044 13.6413 8.52939 13.5789 8.59578C13.5165 8.66216 13.4829 8.75057 13.4856 8.84164L13.4954 9.18315C13.4959 9.19511 13.494 9.20706 13.4899 9.21829C13.4857 9.22953 13.4794 9.23982 13.4712 9.24857C13.4631 9.25732 13.4532 9.26436 13.4423 9.26926C13.4314 9.27417 13.4196 9.27684 13.4076 9.27713C13.3969 9.27722 13.3862 9.27525 13.3762 9.27134V9.27134Z",
  fill: "#B7DFDF"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.2671 9.25608L21.44 8.94681C21.6168 8.94207 21.7896 8.99973 21.9282 9.10967C22.0667 9.21962 22.1621 9.37483 22.1977 9.54809L22.2077 9.59724C22.2265 9.68946 22.2249 9.78468 22.2031 9.87623C22.1813 9.96779 22.1397 10.0535 22.0813 10.1273C22.0229 10.2011 21.9491 10.2612 21.865 10.3035C21.7809 10.3458 21.6886 10.3692 21.5945 10.3721L11.1559 10.6837C11.0991 10.6855 11.0425 10.6758 10.9895 10.6551C10.9366 10.6344 10.8884 10.6031 10.8479 10.5632C10.8074 10.5233 10.7755 10.4756 10.754 10.4229C10.7325 10.3703 10.7219 10.3138 10.7229 10.257L10.7315 9.78871C10.7354 9.64818 10.7932 9.51454 10.8929 9.41541C10.9926 9.31628 11.1265 9.25924 11.2671 9.25608Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.8982 19.874C10.9227 19.8526 10.9512 19.8363 10.9821 19.826C11.013 19.8158 11.0456 19.8118 11.0781 19.8144C11.1105 19.8169 11.1421 19.8259 11.171 19.8408C11.1999 19.8558 11.2256 19.8763 11.2465 19.9013L11.6604 20.3982C11.6698 20.4095 11.6821 20.4179 11.696 20.4226C11.7098 20.4272 11.7247 20.428 11.739 20.4247C11.7532 20.4214 11.7663 20.4143 11.7767 20.404C11.7872 20.3938 11.7945 20.3808 11.7981 20.3666L12.2446 18.5096C12.2499 18.4905 12.2617 18.4737 12.2778 18.4622C12.294 18.4506 12.3137 18.4449 12.3335 18.4461C12.3534 18.4473 12.3722 18.4552 12.387 18.4685C12.4017 18.4819 12.4114 18.4999 12.4145 18.5196C12.5706 19.4023 12.3752 20.3111 11.87 21.0517C11.87 21.0517 11.3799 20.9596 10.8525 20.2152C10.8166 20.1627 10.8014 20.0988 10.8098 20.0358C10.8183 19.9728 10.8498 19.9151 10.8982 19.874V19.874Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.8358 15.5333C10.8604 15.5119 10.889 15.4955 10.9199 15.4853C10.9509 15.4751 10.9836 15.4711 11.0161 15.4736C11.0486 15.4762 11.0803 15.4852 11.1093 15.5001C11.1383 15.5151 11.1641 15.5356 11.185 15.5606L11.599 16.0576C11.6084 16.069 11.6209 16.0774 11.6349 16.082C11.649 16.0866 11.664 16.0871 11.6783 16.0835C11.6926 16.0798 11.7056 16.0722 11.7158 16.0615C11.726 16.0508 11.7329 16.0375 11.7358 16.023L12.1823 14.166C12.1872 14.1463 12.1988 14.1289 12.2152 14.1168C12.2316 14.1048 12.2516 14.0988 12.2719 14.1C12.2922 14.1012 12.3114 14.1095 12.3262 14.1233C12.3411 14.1372 12.3506 14.1558 12.3532 14.176C12.5094 15.0587 12.3139 15.9676 11.8087 16.7081C11.8087 16.7081 11.3186 16.616 10.7912 15.8716C10.7558 15.8196 10.7408 15.7564 10.749 15.694C10.7572 15.6316 10.7881 15.5744 10.8358 15.5333V15.5333Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.2825 23.6091C11.3071 23.5876 11.3357 23.5713 11.3667 23.561C11.3977 23.5508 11.4305 23.5469 11.4631 23.5495C11.4956 23.5522 11.5273 23.5613 11.5563 23.5764C11.5852 23.5915 11.6109 23.6123 11.6317 23.6374L12.0457 24.1334C12.0549 24.1447 12.0672 24.1532 12.081 24.1579C12.0948 24.1626 12.1096 24.1634 12.1239 24.1601C12.1381 24.1568 12.1511 24.1496 12.1614 24.1393C12.1718 24.129 12.179 24.116 12.1823 24.1017L12.6288 22.2448C12.6337 22.225 12.6454 22.2076 12.6617 22.1956C12.6781 22.1836 12.6981 22.1776 12.7184 22.1788C12.7387 22.18 12.7579 22.1882 12.7728 22.2021C12.7876 22.216 12.7972 22.2346 12.7997 22.2547C12.956 23.1375 12.7606 24.0464 12.2553 24.7869C12.2553 24.7869 11.7651 24.6948 11.2377 23.9504C11.2017 23.898 11.1864 23.8342 11.1946 23.7712C11.2029 23.7081 11.2342 23.6504 11.2825 23.6091V23.6091Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.2898 27.1805C11.3144 27.1591 11.343 27.1427 11.374 27.1325C11.4049 27.1223 11.4376 27.1183 11.4701 27.1208C11.5027 27.1234 11.5344 27.1324 11.5633 27.1473C11.5923 27.1623 11.6181 27.1828 11.639 27.2078L12.053 27.7048C12.0622 27.7161 12.0745 27.7246 12.0883 27.7293C12.1021 27.734 12.117 27.7348 12.1312 27.7315C12.1454 27.7282 12.1584 27.721 12.1687 27.7107C12.1791 27.7003 12.1863 27.6873 12.1896 27.6731L12.6361 25.8161C12.641 25.7964 12.6527 25.779 12.669 25.767C12.6854 25.7549 12.7055 25.749 12.7257 25.7502C12.746 25.7514 12.7652 25.7596 12.7801 25.7735C12.7949 25.7873 12.8045 25.806 12.807 25.8261C12.9632 26.7089 12.7678 27.6177 12.2626 28.3583C12.2626 28.3583 11.7724 28.2662 11.2451 27.5218C11.2088 27.4695 11.1933 27.4056 11.2016 27.3425C11.2098 27.2794 11.2413 27.2217 11.2898 27.1805V27.1805Z",
  fill: "#008C8E"
}), /*#__PURE__*/React__namespace.createElement("g", {
  style: "mix-blend-mode:multiply"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M0.699999 36.1191C0.699999 36.5702 9.04217 36.9358 19.3294 36.9358C29.6167 36.9358 37.9613 36.5702 37.9613 36.1191C37.9613 35.6681 29.6191 35.3023 19.3294 35.3023C9.03977 35.3023 0.699999 35.6681 0.699999 36.1191Z",
  fill: "#EDF2CB"
})));

const Images = {
  pulseCircle,
  pluseWhite,
  whiteChecked,
  close,
  search,
  info_icon,
  info_more_icon,
  calender_icon,
  external_link,
  print,
  checkCircle,
  createMovement: CreateMovement,
  associateShipment: AssociateShipment,
  finishDeclaration: FinishDeclaration,
  monitorStatus: MonitorStatus,
  CompleteTransit,
  addDocument,
  transit,
  OCEAN,
  AIR,
  TRUCK,
  RAIL
};

function Heading(props) {
  const {
    translate
  } = props;
  let headTitle = translate("CUSTOM_CLEARANCE_FORM");
  let title = `${headTitle} (${window.shipmentCountry})`;
  const mot = lodash_2(props, "currentJobData.modeOfTransport", null);
  const serviceType = lodash_2(props, "currentJobData.serviceType", null);
  const formType = lodash_2(props, "currentJobData.formType", null);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-section-heading"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "header-ship1"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: Images[mot],
    className: "ui image"
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "header-label"
  }, title, " ", serviceType ? `(${serviceType.toUpperCase()})` : "", " ", formType ? `(${formType})` : "")));
}

function HeaderInfo(props) {
  var _props$currentJobData, _props$currentJobData2, _props$kxEngineUserIn, _headerInfo$states, _headerInfo$states$st, _headerInfo$states$st2, _headerInfo$states$st3, _headerInfo$states$st4, _headerInfo$states2, _headerInfo$states2$s, _headerInfo$states2$s2, _headerInfo$states2$s3, _headerInfo$states2$s4;
  let headerInfo = get_1(props, 'currentJobData', {});
  let serviceType = headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.serviceType;
  let etdDate = get_1(headerInfo, 'etd.epochs', '');
  let etaDate = get_1(headerInfo, 'eta.epochs', '');
  let acceptanceDate = get_1(headerInfo, 'dateOfAcceptance.epochs', '');
  let releaseDate = get_1(headerInfo, 'releaseDate.epochs', '');
  let receivedDate = get_1(headerInfo, 'receivedDate.epochs', '');
  let dateOFExit = get_1(headerInfo, 'exitDate.epochs', '');
  let clearanceDate = get_1(headerInfo, 'clearanceDate.epochs', '');
  let presentationDate = get_1(headerInfo, 'presentationDate.epochs', '');
  // let timeZone = 'Europe/Madrid';
  let countryCodes = ["ES", "NL"];
  let countryCode = headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.countryCode;
  let countryCodeCheck = countryCodes.includes(countryCode);
  const formType = (_props$currentJobData = props.currentJobData) === null || _props$currentJobData === void 0 ? void 0 : _props$currentJobData.formType;
  const modeOfTransport = (_props$currentJobData2 = props.currentJobData) === null || _props$currentJobData2 === void 0 ? void 0 : _props$currentJobData2.modeOfTransport;
  const bolLabel = BolGenerator(modeOfTransport);
  const emergencyProcedure = (props === null || props === void 0 ? void 0 : props.emergencyProcedure) || '';
  const isEngineUser = (props === null || props === void 0 ? void 0 : (_props$kxEngineUserIn = props.kxEngineUserInfo) === null || _props$kxEngineUserIn === void 0 ? void 0 : _props$kxEngineUserIn.isEngineUser) == 'true';
  let daysLeft = {
    days: 'Unknown'
  };
  let estimatedData = serviceType === 'IMPORT' ? etaDate : etdDate;
  if (estimatedData) {
    daysLeft = millisecondsToTime(estimatedData - Date.now());
  }
  useDispatch();
  let circuit = headerInfo === null || headerInfo === void 0 ? void 0 : (_headerInfo$states = headerInfo.states) === null || _headerInfo$states === void 0 ? void 0 : (_headerInfo$states$st = _headerInfo$states.states) === null || _headerInfo$states$st === void 0 ? void 0 : (_headerInfo$states$st2 = _headerInfo$states$st.find(obj => obj.key === 'CUSTOM_RELEASE_PROCESS')) === null || _headerInfo$states$st2 === void 0 ? void 0 : (_headerInfo$states$st3 = _headerInfo$states$st2.value) === null || _headerInfo$states$st3 === void 0 ? void 0 : (_headerInfo$states$st4 = _headerInfo$states$st3.state) === null || _headerInfo$states$st4 === void 0 ? void 0 : _headerInfo$states$st4.replace('STATE_RELEASE_', '').toLowerCase();
  let exitCircuit = headerInfo === null || headerInfo === void 0 ? void 0 : (_headerInfo$states2 = headerInfo.states) === null || _headerInfo$states2 === void 0 ? void 0 : (_headerInfo$states2$s = _headerInfo$states2.states) === null || _headerInfo$states2$s === void 0 ? void 0 : (_headerInfo$states2$s2 = _headerInfo$states2$s.find(obj => obj.key === 'SHIPMENT_EXIT_PROCESS')) === null || _headerInfo$states2$s2 === void 0 ? void 0 : (_headerInfo$states2$s3 = _headerInfo$states2$s2.value) === null || _headerInfo$states2$s3 === void 0 ? void 0 : (_headerInfo$states2$s4 = _headerInfo$states2$s3.state) === null || _headerInfo$states2$s4 === void 0 ? void 0 : _headerInfo$states2$s4.replace('STATE_EXIT_', '').toLowerCase();
  const {
    translate
  } = props;
  let customReleaseStatus = state => {
    const {
      color,
      icon,
      text
    } = selectedCircuit(state);
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: text,
      inverted: true,
      style: {
        borderRadius: 0
      },
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: icon,
        color: color
      }),
      position: "right center"
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-left-gb"
  }, (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.lrn) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, "LRN:"), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.lrn) || translate('NOT_ASSIGNED'),
    fieldInfo: (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.lrn) || translate('NOT_ASSIGNED')
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, "MRN:"), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: ((headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn) == 'EMERGENCY_PROCEDURE' ? translate(`${headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn}`) : headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn) || translate('NOT_ASSIGNED'),
    fieldInfo: ((headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn) == 'EMERGENCY_PROCEDURE' ? translate(`${headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn}`) : headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mrn) || translate('NOT_ASSIGNED')
  })), (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.custRef) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "Customer Ref:"), /*#__PURE__*/React__default["default"].createElement("span", null, headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.custRef)), (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.ducr) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "DUCR:"), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.ducr,
    fieldInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.ducr
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, isEngineUser ? translate('TRANSACTION_ID') : translate('SHIPMENT_ID'), ':'), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    id: "shipmentIdInHeaderx",
    value: props.shipId
  }), /*#__PURE__*/React__default["default"].createElement("span", null, props.shipId, /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    fieldInfo: props.shipId
  }))), formType === 'AGS' && serviceType === 'EXPORT' && !!bolLabel ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.masterBolNumber) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item",
    title: "Bill of Lading"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, `${bolLabel[0]}:`), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.masterBolNumber,
    fieldInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.masterBolNumber
  })), (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol) && bolLabel[1] && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item",
    title: "Bill of Lading"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, `${bolLabel[1]}:`), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol,
    fieldInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol
  }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item",
    title: "Bill of Lading"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, "BOL:"), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol,
    fieldInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.bol
  })))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-center-gb"
  }, (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mucr) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "MUCR:"), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
    label: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mucr,
    fieldInfo: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.mucr
  })), (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.badge) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "BADGE:"), /*#__PURE__*/React__default["default"].createElement("span", null, headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.badge)), acceptanceDate && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, !!countryCodeCheck ? translate('DATE OF ACCEPTANCE') : 'ACCEPTED DATE', ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(acceptanceDate, true))), etdDate && !countryCodeCheck && serviceType === 'EXPORT' && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "GOODS DEPARTURE :"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(etdDate, true))), receivedDate && !countryCodeCheck && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, "RECEIVED DATE:"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(receivedDate, true))), releaseDate && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, !!countryCodeCheck ? translate('DATE OF RELEASE') : "CLEARED DATE", ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(releaseDate, true))), countryCodeCheck && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, daysLeft && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('TIME TO CLEAR'), ":"), /*#__PURE__*/React__default["default"].createElement("span", null, translate('PATTERN_TTC', {
    days: daysLeft.days.split(' ')[0]
  }))), etaDate && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('DATE OF ARRIVAL'), ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(etaDate))), emergencyProcedure && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('EMERGENCY_PROCEDURE')), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: 'check circle',
    style: {
      color: '#008B8F'
    }
  }))), dateOFExit && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('DATE OF EXIT'), ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(dateOFExit))))), /*#__PURE__*/React__default["default"].createElement("div", null, circuit !== 'none' && circuit && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item-associated-shipment"
  }, customReleaseStatus(circuit), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, translate('CIRCUIT'), ":"), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: `${selectedCircuit(circuit).color}`
    }
  }, translate(circuit.toUpperCase()).toUpperCase())), exitCircuit !== 'none' && exitCircuit && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "overview-info-item-associated-shipment"
  }, customReleaseStatus(exitCircuit), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "overview-info-label"
  }, translate('EXIT CIRCUIT'), ":"), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: `${selectedCircuit(exitCircuit).color}`
    }
  }, translate(exitCircuit.toUpperCase()).toUpperCase())), clearanceDate && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('DATE OF CLEARED'), ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(clearanceDate))), presentationDate && countryCode === "ES" && /*#__PURE__*/React__default["default"].createElement("div", {
    className: `overview-info-item`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: `overview-info-label`
  }, translate('DATE OF PRESENTATION OF GOODS'), ":"), /*#__PURE__*/React__default["default"].createElement("span", null, chooseDateAndTime(presentationDate))))));
}

var css_248z$1 = ".loader-popup .ui.inverted.dimmer {\n  background-color: rgba(158, 150, 150, 0.85) !important;\n}\n\n.todo-validation-error {\n  z-index: auto;\n}\n\n.cancelNcts .fileWithES label {\n  min-width: fit-content;\n}\n\n.emergencyPopup .emergencyActions {\n  display: flex;\n  margin-left: 15rem;\n  gap: 4rem;\n}\n.emergencyPopup .emergencyActions > .button {\n  background-color: white !important;\n  box-shadow: 2px 2px lightgrey !important;\n  color: black !important;\n}\n.emergencyPopup .emergencyheader {\n  margin-left: 15rem;\n  font-size: 0.9rem;\n}\n.emergencyPopup .emergencyheader .field {\n  display: flex;\n}\n.emergencyPopup .emergencyheader .field > .label {\n  flex: 1;\n}\n.emergencyPopup .emergencyheader .field > .value {\n  flex: 4;\n}\n.emergencyPopup .description {\n  margin-left: 15rem;\n}\n.emergencyPopup .description > div {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n#EUHeaderWrapper {\n  /***\n       padding: 6px;\n      font-size: 11px;\n      height: 26px;\n      border-radius: 3px;\n      color: #fff !important;\n      background-color: rgb(49, 129, 146) !important;\n      border-color: rgb(49, 129, 146) !important;\n  }\n      **/\n}\n#EUHeaderWrapper .todo-button-container {\n  position: relative;\n}\n#EUHeaderWrapper .todo-button-container .emergency, #EUHeaderWrapper .todo-button-container #exchangeRatesContainer .exchangeRates, #EUHeaderWrapper .todo-button-container #refreshData .exchangeRates {\n  position: absolute;\n  right: 0.7rem;\n  top: 50%;\n}\n#EUHeaderWrapper .todo-button-container .emergency > .button, #EUHeaderWrapper .todo-button-container #exchangeRatesContainer .exchangeRates > .button, #EUHeaderWrapper .todo-button-container #refreshData .exchangeRates > .button {\n  border: 1px solid rgb(38, 118, 120) !important;\n  color: rgb(38, 118, 120) !important;\n}\n#EUHeaderWrapper .todo-button-container #exchangeRatesContainer, #EUHeaderWrapper .todo-button-container #refreshData {\n  position: absolute;\n  top: 10px;\n  right: 0px;\n  z-index: 1;\n}\n#EUHeaderWrapper .header-alert {\n  padding: 5px 5px;\n}\n#EUHeaderWrapper .overview-info {\n  margin-top: 5px !important;\n}\n#EUHeaderWrapper .overview-info .overview-info-item {\n  margin: 0px !important;\n}\n#EUHeaderWrapper .ace.header-container {\n  padding: 5px;\n}\n#EUHeaderWrapper .overview-section-heading .header-ship {\n  width: 20px !important;\n  height: 20px !important;\n}\n#EUHeaderWrapper .overview-section-heading .header-ship img {\n  top: 0px !important;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button, #EUHeaderWrapper .ResponseRowStyle button.todo-button {\n  font-size: 10px;\n  font-weight: bold;\n  font-family: \"Roboto\";\n  height: 25px;\n  padding: 4px 7px;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n  width: fit-content;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button.expdClps:hover, #EUHeaderWrapper .ResponseRowStyle button.todo-button.expdClps:hover {\n  background-color: rgb(38, 118, 120) !important;\n  border: 1px solid #fff !important;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button.expdClps:hover svg, #EUHeaderWrapper .ResponseRowStyle button.todo-button.expdClps:hover svg {\n  color: #fff !important;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button.primaryBtn, #EUHeaderWrapper .ResponseRowStyle button.todo-button.primaryBtn {\n  border: 1px solid rgb(38, 118, 120) !important;\n  color: rgb(38, 118, 120) !important;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button.secondaryBtn, #EUHeaderWrapper .ResponseRowStyle button.todo-button.secondaryBtn {\n  border: 1px solid rgb(38, 118, 120) !important;\n  color: #fff !important;\n  background-color: rgb(38, 118, 120) !important;\n}\n#EUHeaderWrapper .dv-todo-isfheader button.todo-button i.icon, #EUHeaderWrapper .ResponseRowStyle button.todo-button i.icon {\n  color: rgb(38, 118, 120) !important;\n  font-size: 10px !important;\n}\n#EUHeaderWrapper .ui.checkbox.fileWithES {\n  border: 1px solid #267678 !important;\n  background-color: #fff;\n  border-radius: 3px;\n  padding: 3px 7px 0px 7px;\n  margin-left: 10px;\n  margin-top: 4px;\n}\n#EUHeaderWrapper .ui.checkbox.fileWithES label {\n  font-size: 10px;\n  color: rgb(38, 118, 120) !important;\n}\n#EUHeaderWrapper .ui.checkbox.fileWithES label:before {\n  border: 1px solid rgb(38, 118, 120) !important;\n}\n#EUHeaderWrapper .ui.checkbox.fileWithES label[for=filwWithHmrc] {\n  margin-bottom: 3px;\n}\n#EUHeaderWrapper #serviceType {\n  border: 1px solid rgb(38, 118, 120);\n  color: rgb(38, 118, 120);\n  font-size: \"10px\";\n  font-weight: \"bold\";\n  padding: \"1px\";\n  margin-top: \"4px\";\n  margin-left: \"-2px\";\n  border-radius: \"2px\";\n  width: \"fit-content\";\n}\n#EUHeaderWrapper .overview-info-left-gb {\n  margin: 0 60px 0 0;\n}\n#EUHeaderWrapper .overview-info-right-gb {\n  margin: 0 60px 0 0;\n}\n#EUHeaderWrapper .overview-info-center-gb {\n  margin: 0 60px 0 0;\n}\n#EUHeaderWrapper .header-container {\n  padding: 5px 10px 3px 10px !important;\n}\n#EUHeaderWrapper .leftSideLinee::before {\n  top: 4px;\n}\n#EUHeaderWrapper .topDiv {\n  width: 100%;\n  background: white;\n  padding: 0.5rem;\n  border-top: 1px solid #008b8f;\n  overflow: auto !important;\n  height: 300px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 10px;\n}\n#EUHeaderWrapper .shresponse {\n  margin-bottom: 10px;\n  padding: 5px;\n  display: flex;\n  background: rgb(231, 229, 229);\n  justify-content: space-between;\n}\n#EUHeaderWrapper .sh {\n  margin-bottom: 10px;\n  padding: 5px;\n  display: flex;\n  background: rgb(231, 229, 229);\n  justify-content: space-between;\n}\n#EUHeaderWrapper .shrequest {\n  background: #c3e7ee;\n}\n#EUHeaderWrapper .dvxml {\n  width: 100%;\n  background: white;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  overflow: auto !important;\n  height: 300px;\n  margin-left: 20px;\n}\n#EUHeaderWrapper .overview-info-item-associated-shipment {\n  font-size: 12px;\n}\n#EUHeaderWrapper .overview-info-item-associated-shipment .overview-info-label {\n  font-weight: bold;\n  padding-right: 3px;\n}\n#EUHeaderWrapper .overview-info-item-associated-shipment .imgclasss {\n  border: 1px solid #008B8F;\n  border-radius: 10px;\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  padding: 4px;\n  position: relative;\n  left: -30px;\n  bottom: -50px;\n}\n\n.leftSideLinee {\n  position: relative;\n  padding-left: 2rem;\n}\n.leftSideLinee::before {\n  content: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2211px%22%20height%3D%227px%22%20viewBox%3D%220%200%2011%207%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EE79DEE2B-14B3-4FA2-82E9-8116471A55AB%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Broker%2FACE%22%20transform%3D%22translate%28-1181.000000%2C%20-594.000000%29%22%20fill%3D%22%23008B8F%22%20fill-rule%3D%22nonzero%22%20%20%20%20%20%20%20%20%20%20%20stroke%3D%22%23008B8F%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22expanded%22%20transform%3D%22translate%281176.000000%2C%20586.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22down-arrow%22%20transform%3D%22translate%286.000000%2C%209.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.90791402%2C0.0966183575%20C8.78386996%2C-0.0322061192%208.58229837%2C-0.0322061192%208.45825431%2C0.0966183575%20L4.50434991%2C4.21095008%20L0.54269276%2C0.0966183575%20C0.418648701%2C-0.0322061192%200.217077104%2C-0.0322061192%200.0930330446%2C0.0966183575%20C-0.0310110149%2C0.225442834%20-0.0310110149%2C0.434782609%200.0930330446%2C0.563607085%20L4.2717673%2C4.90338164%20C4.33378933%2C4.96779388%204.41131687%2C5%204.49659716%2C5%20C4.57412469%2C5%204.65940498%2C4.96779388%204.72142701%2C4.90338164%20L8.90016127%2C0.563607085%20C9.03195808%2C0.434782609%209.03195808%2C0.225442834%208.90791402%2C0.0966183575%20Z%22%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E\");\n  position: absolute;\n  background-color: #fff;\n  width: 21px;\n  height: 21px;\n  border-radius: 30px;\n  border: 1px solid #008b8f;\n  left: -5px;\n  z-index: 1;\n  top: 23px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.leftSideLinee::after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  background: #ddd;\n  left: 4px;\n  z-index: 0;\n}\n\n.warning-msg {\n  color: #e67800;\n}\n\n.fail-msg {\n  color: #b12e06;\n}\n\n.success-msg {\n  color: rgba(10, 123, 12, 0.569);\n}\n\n.EUStatusDetail .title {\n  display: flex;\n  align-items: baseline;\n}\n.EUStatusDetail .title .belowTitleClass {\n  display: flex;\n  gap: 0.3rem;\n}\n.EUStatusDetail .title .width30 {\n  width: 30%;\n}\n.EUStatusDetail .title .width20 {\n  width: 20%;\n}\n.EUStatusDetail .title .width0 {\n  width: 0;\n}\n.EUStatusDetail .title .stepNumber {\n  margin-bottom: 0;\n}\n.EUStatusDetail .title .statusDetail {\n  margin-bottom: 0;\n  background-color: inherit;\n  border: 0;\n}\n.EUStatusDetail .title .sequenceNumeric {\n  margin-bottom: 0;\n  margin-left: 2px;\n}\n.EUStatusDetail .title .statusDetailIcon {\n  color: rgb(38, 118, 120);\n  cursor: pointer;\n  border: 1px solid rgb(38, 118, 120);\n}\n.EUStatusDetail .title .titleValue {\n  flex: 1;\n}\n.EUStatusDetail .title .titleValueStatusDetail {\n  width: calc(100% - 30px);\n}\n.EUStatusDetail .title .activeTitle {\n  text-transform: uppercase !important;\n  color: black;\n  align-items: inherit;\n}\n.EUStatusDetail .title .markedDeletespan label {\n  font-size: 0.8em;\n  margin: auto;\n}\n.EUStatusDetail .title .markedDeletespan .checkbox label:before {\n  border-color: #334d4d;\n  transform: scale(0.8);\n}\n.EUStatusDetail .title .markedDeletespan .checkbox label:after {\n  border-color: #334d4d;\n  transform: scale(0.8);\n}";
styleInject(css_248z$1);

const DeleteIcon = ({
  id,
  onClick,
  disabled,
  isDisabled,
  spanStyle,
  iconName = 'trash alternate outline',
  ...rest
}) => {
  return /*#__PURE__*/React__default["default"].createElement("span", {
    style: spanStyle
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, _extends$1({
    id: id,
    name: iconName,
    disabled: isDisabled || disabled,
    onClick: onClick
  }, rest)));
};
var DeleteIcon$1 = ShipmentDataHOC$1(DeleteIcon);

const InvoiceToggleContext = /*#__PURE__*/React$1.createContext();
const reducer$1 = (state, action) => {
  switch (action.type) {
    case "TOGGLE_ALL":
      return {
        ...state,
        ...action.ids
      };
    case "TOGGLE_BY_ID":
      const {
        toggleId
      } = action;
      return {
        ...state,
        [`${toggleId}`]: !state[toggleId]
      };
    default:
      throw new Error();
  }
};
const AccordionInvoice = ({
  children,
  initialiState = {},
  keyName = '',
  invoiceId = '',
  expandTitle,
  collapseTitle
}) => {
  let toggleIds = JSON.parse(sessionStorage.getItem(keyName));
  if (keyName == 'toggleLineItems') {
    var _toggleIds;
    toggleIds = (_toggleIds = toggleIds) === null || _toggleIds === void 0 ? void 0 : _toggleIds[invoiceId];
  }
  const [state, dispatch] = React__default["default"].useReducer(reducer$1, toggleIds != null ? toggleIds : initialiState);
  const translate = React__default["default"].useContext(TranslateContext).translate;
  const ToggleAccordion = React$1.useCallback(value => {
    const state = {};
    React$1.Children.toArray(children).forEach(({
      props
    } = item) => {
      if (!props.id && props.children) {
        React$1.Children.toArray(props.children).forEach(({
          props
        } = item) => {
          state[props.id] = value;
        });
      } else {
        if (props.id) state[props.id] = value;
      }
    });
    dispatch({
      type: "TOGGLE_ALL",
      ids: state
    });
  }, [children.length]);
  React$1.useEffect(() => {
    if (keyName === 'toggleInvoices') {
      sessionStorage.setItem(keyName, JSON.stringify(state));
    } else {
      const toggeleLineItemsData = JSON.parse(sessionStorage.getItem(keyName));
      sessionStorage.setItem(keyName, JSON.stringify({
        ...toggeleLineItemsData,
        [invoiceId]: state
      }));
    }
  }, [state]);
  const isAllExpanded = React$1.useMemo(() => {
    const values = Object.values(state);
    const ExpandedList = values.length == 0 ? false : values.every(c => c);
    return ExpandedList;
  }, [state]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "kn__accordion"
  }, /*#__PURE__*/React__default["default"].createElement(InvoiceToggleContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "action-btns"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    basic: true,
    color: "blue",
    className: "btn-toggle",
    id: "expandCollapseAll",
    onClick: () => ToggleAccordion(!isAllExpanded),
    style: {
      marginTop: keyName === 'toggleLineItems' ? '10px' : 0,
      marginBottom: keyName === 'toggleLineItems' ? '-12px' : 0
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: `${!isAllExpanded ? "plus" : "minus"} circle`
  }), !isAllExpanded ? translate(`${expandTitle}`) : translate(`${collapseTitle}`))), children));
};

const ToggleInvoices = props => {
  const {
    lineNumber,
    isActive,
    onClick,
    titleValue,
    onDelete,
    expandCollapseId,
    deleteItemId,
    containerStyle = {},
    titleWidthClass = "width20",
    stepNumberClass = "stepNumber",
    title,
    activeIcon = "minus circle",
    inactiveIcon = "plus circle",
    iconClass = "",
    titleValueContainer = "titleValue",
    showDeleteIcon = true,
    confirmationMsg,
    sequenceNumeric,
    titleAlwaysShow = false,
    markDeletedUI,
    insertUpdateUI,
    toggleId
  } = props;
  const deleteHandle = () => {
    if (!window.confirm(`Are you sure ? Remove ${confirmationMsg} ` + counter)) return;
    onDelete();
  };
  let isToggleActive;
  const toggleContext = React$1.useContext(InvoiceToggleContext);
  if (toggleContext) {
    var _toggleContext$state;
    isToggleActive = (_toggleContext$state = toggleContext.state) === null || _toggleContext$state === void 0 ? void 0 : _toggleContext$state[`${toggleId}`];
  } else {
    isToggleActive = isActive;
  }
  let counter = lineNumber < 10 ? `00${lineNumber}` : lineNumber < 99 ? `0${lineNumber}` : lineNumber;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "EUStatusDetail"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "title",
    style: {
      ...containerStyle
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: expandCollapseId,
    className: "belowTitleClass",
    style: {
      flex: isToggleActive ? 1 : .4
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      height: 'fit-content'
    },
    id: (isToggleActive ? 'active-' : 'inActive-') + expandCollapseId,
    className: stepNumberClass,
    onClick: () => {
      if (typeof onClick === 'function') {
        onClick();
      } else {
        toggleContext.dispatch({
          type: "TOGGLE_BY_ID",
          toggleId
        });
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    className: iconClass,
    name: isToggleActive ? activeIcon : inactiveIcon
  }), /*#__PURE__*/React__default["default"].createElement("span", null, counter), " ", ' '), sequenceNumeric && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      height: 'fit-content'
    },
    className: "stepNumber sequenceNumeric"
  }, /*#__PURE__*/React__default["default"].createElement("span", null, "SEQ-", sequenceNumeric)), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      alignSelf: 'center'
    },
    className: "markedDeletespan"
  }, isToggleActive && !markDeletedUI && !insertUpdateUI && showDeleteIcon && /*#__PURE__*/React__default["default"].createElement(DeleteIcon$1, {
    id: deleteItemId,
    onClick: deleteHandle
  }), isToggleActive && markDeletedUI && markDeletedUI(), isToggleActive && insertUpdateUI && insertUpdateUI())), /*#__PURE__*/React__default["default"].createElement("div", {
    className: titleValueContainer
  }, isToggleActive && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "activeTitle"
  }, /*#__PURE__*/React__default["default"].createElement("strong", null, title)), /*#__PURE__*/React__default["default"].createElement("div", null, (!isToggleActive || titleAlwaysShow) && titleValue && titleValue))));
};
var ToggleInvoices$1 = /*#__PURE__*/React__default["default"].memo(ToggleInvoices);

let options = {
  timeZone: 'Europe/Madrid',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
};
const StatusDetailItemTitle = ({
  enableRawXml,
  item,
  index,
  translate,
  kxEngineUserInfo,
  lowerEnv
}) => {
  var _item$creationDate, _item$creationDate2, _item$type, _item$type2, _item$status, _item$status2, _item$status3, _item$status4;
  let lang = instance.language || window.localStorage.i18nextLng || 'en';
  let formatter = new Intl.DateTimeFormat([], options);
  let ES_TZ = (item === null || item === void 0 ? void 0 : (_item$creationDate = item.creationDate) === null || _item$creationDate === void 0 ? void 0 : _item$creationDate.epochs) && formatter.format(new Date((_item$creationDate2 = item.creationDate) === null || _item$creationDate2 === void 0 ? void 0 : _item$creationDate2.epochs));
  let status = item.status;
  if (window.shipmentCountry === "NL") {
    if (statusMap[item.type]) {
      status = statusMap[item.type]['code'] + " - " + statusMap[item.type][`text_${lang}`];
    }
  }
  const isEngineUser = (kxEngineUserInfo === null || kxEngineUserInfo === void 0 ? void 0 : kxEngineUserInfo.isEngineUser) == 'true';
  let pathXmlSent = `/broker-panel/xml-request/${window.shipmentCountry}/${item.shipmentId}/${item.id}`;
  let pathXmlRaw = `/broker-panel/xml-preview/${window.shipmentCountry}/${item.shipmentId}/${item.type}/${item.id}`;
  if (isEngineUser) {
    const env = window.location.ancestorOrigins[0];
    pathXmlSent = `${env}/xml/xml-preview/${window.shipmentCountry}/${item.shipmentId}/${item.id}`;
    pathXmlRaw = `${env}/xml/xml-preview/${window.shipmentCountry}/${item.shipmentId}/${item.type}/${item.id}`;
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: `sh sh${item.transactionType || ''}`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "23%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("b", null, translate("SHIP ID") + ": "), item.shipmentId), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "30%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("b", null, translate("CREATION_DATE") + ": "), ['ES', 'NL'].includes(window.shipmentCountry) ? ES_TZ : moment.utc(item.creationDate.epochs).format('MMM DD YYYY HH:mm:ss')), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "15%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("b", null, translate("TYPE") + ": ", " "), ((_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.toLowerCase().includes("error")) && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "warning circle",
    color: "red",
    style: {
      "display": "inline"
    }
  }), /*#__PURE__*/React__default["default"].createElement("b", {
    style: {
      color: (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.toLowerCase().includes("error") ? "red" : "green"
    }
  }, item.type)), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "25%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("b", null, translate("STATUS") + ": "), (_item$status = item.status) !== null && _item$status !== void 0 && _item$status.toLowerCase().includes("fail") || (_item$status2 = item.status) !== null && _item$status2 !== void 0 && _item$status2.toLowerCase().includes("error") ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "warning circle",
    color: "red",
    style: {
      "display": "inline"
    }
  }) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "check circle",
    color: "green",
    style: {
      "display": "inline"
    }
  }), /*#__PURE__*/React__default["default"].createElement("b", {
    style: {
      color: (_item$status3 = item.status) !== null && _item$status3 !== void 0 && _item$status3.toLowerCase().includes("fail") || (_item$status4 = item.status) !== null && _item$status4 !== void 0 && _item$status4.toLowerCase().includes("error") ? "red" : "green"
    }
  }, status)), enableRawXml && item.transactionType === "request" && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "7%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    target: "_blank",
    href: pathXmlSent
  }, /*#__PURE__*/React__default["default"].createElement("b", null, "XML Sent"))), enableRawXml && item.transactionType !== "request" && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      "width": "7%"
    }
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    target: "_blank",
    href: pathXmlRaw
  }, /*#__PURE__*/React__default["default"].createElement("b", null, "Raw XML")))));
};

const StatusDetailItem = ({
  responseJson,
  setResponseJson,
  enableRawXml,
  item,
  index,
  translate,
  kxEngineUserInfo,
  lowerEnv
}) => {
  var _responseJson$item$id, _responseJson$item$id2, _responseJson$item$id3, _responseJson$item$id4, _responseJson$item$id5, _responseJson$item$id6, _responseJson$item$id7, _responseJson$item$id8, _responseJson$item$id9;
  const [isExpanded, setIsExapnded] = React$1.useState(false);
  const [isLoading, setIsLoading] = React$1.useState(false);
  let newResponseJson = {
    ...responseJson
  };
  const expandedToggle = () => setIsExapnded(!isExpanded);
  React$1.useEffect(() => {
    if (index === 0) {
      !isExpanded && expandedToggle();
    }
  }, []);
  React$1.useEffect(() => {
    if (isExpanded) {
      setIsLoading(true);
      if (item.transactionType === "request") {
        getTransactionByRequestId(window.shipmentCountry, item.id).then(res => {
          newResponseJson[item.id] = {
            "responsePayload": JSON.parse(res.data.eventMessage.payload)
          };
          setResponseJson(newResponseJson);
        });
      } else {
        getTransactionByResponseId(window.shipmentCountry, item.id).then(response => {
          newResponseJson[item.id] = {
            "responsePayload": JSON.parse(response.data.eventMessage.responseJsonString)
          };
          setResponseJson(newResponseJson);
          setIsLoading(false);
        });
      }
    }
  }, [isExpanded]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      paddingBottom: "3px",
      "backgroundColor": (index + 1) % 2 == 0 ? "rgb(238 244 251)" : "#fff"
    }
  }, /*#__PURE__*/React__default["default"].createElement(ToggleInvoices$1, {
    onClick: expandedToggle,
    titleAlwaysShow: true,
    isActive: isExpanded,
    showDeleteIcon: false,
    activeIcon: "chevron up",
    inactiveIcon: "chevron down",
    iconClass: "statusDetailIcon circular",
    stepNumberClass: "statusDetail",
    titleValueContainer: "titleValueStatusDetail",
    titleWidthClass: "width0",
    titleValue: /*#__PURE__*/React__default["default"].createElement(StatusDetailItemTitle, {
      enableRawXml: enableRawXml,
      item: item,
      index: index,
      translate: translate,
      kxEngineUserInfo: kxEngineUserInfo,
      lowerEnv: lowerEnv
    })
  }), isExpanded && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      paddingLeft: "30px"
    }
  }, (_responseJson$item$id = responseJson[item.id]) !== null && _responseJson$item$id !== void 0 && _responseJson$item$id.responsePayload ? (_responseJson$item$id2 = responseJson[item.id]) !== null && _responseJson$item$id2 !== void 0 && (_responseJson$item$id3 = _responseJson$item$id2.responsePayload) !== null && _responseJson$item$id3 !== void 0 && _responseJson$item$id3.errors ? JSONDisplayer(responseJson[item.id]['responsePayload'], false) : (_responseJson$item$id4 = responseJson[item.id]['responsePayload']) !== null && _responseJson$item$id4 !== void 0 && _responseJson$item$id4.payload ? (_responseJson$item$id5 = responseJson[item.id]['responsePayload']) !== null && _responseJson$item$id5 !== void 0 && _responseJson$item$id5.payload && (_responseJson$item$id6 = responseJson[item.id]['responsePayload']) !== null && _responseJson$item$id6 !== void 0 && _responseJson$item$id6.comments ? JSONDisplayer({
    comments: (_responseJson$item$id7 = responseJson[item.id]['responsePayload']) === null || _responseJson$item$id7 === void 0 ? void 0 : _responseJson$item$id7.comments,
    ...((_responseJson$item$id8 = responseJson[item.id]['responsePayload']) === null || _responseJson$item$id8 === void 0 ? void 0 : _responseJson$item$id8.payload)
  }) : JSONDisplayer((_responseJson$item$id9 = responseJson[item.id]['responsePayload']) === null || _responseJson$item$id9 === void 0 ? void 0 : _responseJson$item$id9.payload) : JSONDisplayer(responseJson[item.id]['responsePayload']) : /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      "margin": "20px",
      "textAlign": "center"
    }
  }, "Please wait..."), /*#__PURE__*/React__default["default"].createElement("hr", null)));
};

function StatusDetail(props) {
  var _jobWheels$ES_ENTRY_J, _jobWheels$ES_ENTRY_J2, _jobWheels, _jobWheels$value, _jobWheels$CUSTOM_REL, _jobWheels$CUSTOM_REL2, _jobWheels$NL_DMS_CUS, _jobWheels$NL_DMS_CUS2, _props$currentJobData;
  const jobWheels = getJobWheels(props.currentJobData);
  const esEntryWorkflowState = ((_jobWheels$ES_ENTRY_J = jobWheels['ES_ENTRY_JOB_WHEEL']) === null || _jobWheels$ES_ENTRY_J === void 0 ? void 0 : (_jobWheels$ES_ENTRY_J2 = _jobWheels$ES_ENTRY_J.value) === null || _jobWheels$ES_ENTRY_J2 === void 0 ? void 0 : _jobWheels$ES_ENTRY_J2.state) || '';
  const esCustomWorkflowState = ((_jobWheels = jobWheels[`${window.shipmentCountry}_CUSTOM_JOB_WHEEL`]) === null || _jobWheels === void 0 ? void 0 : (_jobWheels$value = _jobWheels.value) === null || _jobWheels$value === void 0 ? void 0 : _jobWheels$value.state) || '';
  ((_jobWheels$CUSTOM_REL = jobWheels['CUSTOM_RELEASE_WHEEL']) === null || _jobWheels$CUSTOM_REL === void 0 ? void 0 : (_jobWheels$CUSTOM_REL2 = _jobWheels$CUSTOM_REL.value) === null || _jobWheels$CUSTOM_REL2 === void 0 ? void 0 : _jobWheels$CUSTOM_REL2.state) || '';
  const nlDmsSubState = ((_jobWheels$NL_DMS_CUS = jobWheels['NL_DMS_CUSTOM_SUB_PROCES_WHEEL']) === null || _jobWheels$NL_DMS_CUS === void 0 ? void 0 : (_jobWheels$NL_DMS_CUS2 = _jobWheels$NL_DMS_CUS.value) === null || _jobWheels$NL_DMS_CUS2 === void 0 ? void 0 : _jobWheels$NL_DMS_CUS2.state) || '';
  const [showStatusDetail, setShowStatusDetail] = React$1.useState(false);
  const [statusDetailResponse, setStatusDetailResponse] = React$1.useState([]);
  const [loading, setLoading] = React$1.useState(false);
  const {
    translate
  } = props;
  const [responseJson, setResponseJson] = React$1.useState({});
  let headerInfo = get_1(props, 'currentJobData', {});
  headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.countryCode;
  const formTypeCheck = headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.formType;
  let aesStatus = get_1(headerInfo, 'aesStatus', '');
  let lang = instance.language || window.localStorage.i18nextLng || "en";
  let textKey = lang !== "en" ? `text_${lang}` : `text`;
  let textValue = AesStatusMappings[aesStatus];
  let isDeclarationStartDateInBroker = ['NL'].includes(window.shipmentCountry) && ['DMS'].includes(props === null || props === void 0 ? void 0 : props.version);

  //partitionCriteria is for NL
  async function fetchStatusDetailData(countryCode, eventType) {
    let response = await statusDetailapi(props.shipId, countryCode, eventType);
    setLoading(false);
    let txResponse = (await response.data.eventMessage.transactionResponse) || [];
    setStatusDetailResponse(txResponse);
  }
  async function _fetchAuditTrail(shipId, countryCode) {
    let response = await fetchAuditTrail(shipId, countryCode);
    setLoading(false);
    let txResponse = (await response.data.eventMessage.transaction) || [];
    setStatusDetailResponse(txResponse);
  }
  React$1.useEffect(() => {
    setStatusDetailResponse([]);
    setShowStatusDetail(false);
  }, [props.shipId]);
  let entryState = esEntryStatusMap(esEntryWorkflowState);
  let _entryState = entryState === "STATE_ENTRY_NONE" ? 'PENDING_FILING' : entryState;
  let customState = esCustomStatusMap(esCustomWorkflowState);
  let _customState = customState === "STATE_CUSTOMS_NONE" || customState === "STATE_CDS_NONE" ? 'PENDING_FILING' : customState;
  let customReleaseStatus = state => {
    // let color = customReleaseState.replace('STATE_RELEASE_', '').toLowerCase()
    let status = state.replace('STATE', '').replaceAll('_', ' ');
    const {
      color,
      icon,
      text
    } = selectedStatusTag(status);
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: text,
      inverted: true,
      style: {
        borderRadius: 0
      },
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: icon,
        color: color,
        style: {
          marginLeft: '5px'
        }
      }),
      position: "right center"
    });
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ace header-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "jobstatus"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ResponseRowStyle",
    style: {
      width: '40%',
      paddingTop: '7px'
    }
  }, esEntryWorkflowState && /*#__PURE__*/React__default["default"].createElement("div", {
    className: ""
  }, customReleaseStatus(esEntryWorkflowState), "\xA0", /*#__PURE__*/React__default["default"].createElement("strong", null, `${window.shipmentCountry} ` + translate(`ENTRY`) + `: `), /*#__PURE__*/React__default["default"].createElement("span", null, translate(_entryState.replace('STATE_', ''), {
    ns: "state_text"
  }).replaceAll('_', ' ')))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ResponseRowStyle",
    style: {
      width: '40%',
      paddingTop: '7px'
    }
  }, esCustomWorkflowState && /*#__PURE__*/React__default["default"].createElement("div", {
    className: ""
  }, customReleaseStatus(esCustomWorkflowState), "\xA0", /*#__PURE__*/React__default["default"].createElement("strong", null, `${window.shipmentCountry} ` + translate(`CUSTOMS`) + `: `), /*#__PURE__*/React__default["default"].createElement("span", null, translate(_customState.replace('STATE_', ''), {
    ns: "state_text"
  }).replaceAll('_', ' ')))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ResponseRowStyle",
    style: {
      width: '40%',
      paddingTop: '7px'
    }
  }, aesStatus && formTypeCheck === 'AES' && /*#__PURE__*/React__default["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    content: textValue[textKey],
    inverted: true,
    style: {
      borderRadius: 0
    },
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "info circle",
      style: {
        marginLeft: '5px'
      }
    }),
    position: "right center"
  }), /*#__PURE__*/React__default["default"].createElement("strong", null, translate(`AES_STATUS`), ": "), /*#__PURE__*/React__default["default"].createElement("span", null, aesStatus)), formTypeCheck === 'DMS' && nlDmsSubState && /*#__PURE__*/React__default["default"].createElement("div", {
    className: ""
  }, "\xA0", /*#__PURE__*/React__default["default"].createElement("strong", null, translate(`DMS_SUB`) + `: `), /*#__PURE__*/React__default["default"].createElement("span", null, nlDmsSubState === 'STATE_DMS_SUB_PROCESS_NONE' ? 'NONE' : nlDmsSubState.replace("STATE_", "")))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ResponseRowStyle",
    style: {
      width: '20%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    size: "mini",
    key: "STATUS_DETAIL",
    disabled: false,
    className: "sv todo-button primaryBtn",
    style: {
      float: 'right'
    },
    onClick: e => {
      e.stopPropagation();
      if (showStatusDetail === false) {
        setLoading(true);
        if (window.shipmentCountry === "NL") {
          _fetchAuditTrail(props.shipId, "nl");
        } else {
          fetchStatusDetailData(window.shipmentCountry.toLowerCase(), 'GET_ALL_TRANSACTION_RESPONSES_EU');
        }
      }
      // !showStatusDetail && setLoading(true)
      // !showStatusDetail && statusDetailapi(window.shipmentId);
      setShowStatusDetail(showStatusDetail ? false : true);
    }
  }, showStatusDetail ? translate('HIDE_STATUS_DETAIL') : translate('STATUS_DETAIL'))))), showStatusDetail && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "topDiv"
  }, loading ? /*#__PURE__*/React__default["default"].createElement(CustomLoader, null, translate('LOADING')) : statusDetailResponse && statusDetailResponse.length > 0 && statusDetailResponse.map((item, index) => /*#__PURE__*/React__default["default"].createElement(StatusDetailItem, {
    responseJson: responseJson,
    setResponseJson: setResponseJson,
    enableRawXml: props.enableRawXml,
    item: item,
    index: index,
    translate: translate,
    currentJobData: props.currentJobData,
    kxEngineUserInfo: props === null || props === void 0 ? void 0 : props.kxEngineUserInfo,
    lowerEnv: props === null || props === void 0 ? void 0 : props.lowerEnv[0]
  })), /*#__PURE__*/React__default["default"].createElement(StatusDetailItemTitle, {
    enableRawXml: false,
    item: {
      shipmentId: props.shipId,
      "creationDate": isDeclarationStartDateInBroker ? props === null || props === void 0 ? void 0 : (_props$currentJobData = props.currentJobData) === null || _props$currentJobData === void 0 ? void 0 : _props$currentJobData.declarationStartDateInBroker : props.createdDate,
      "status": "Pending",
      "type": "Created"
    },
    translate: translate
  })));
}

const initialState$x = {
  billingsList: [],
  billingDataSource: {
    isLoading: true,
    isAddButton: true,
    grandTotal: 0,
    isBillable: true
  }
};
function BillingReducer(state = initialState$x, action) {
  switch (action.type) {
    case ADD_ITEM_BILLINGS:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          billingsList: [...state.billingsList, payload],
          billingDataSource: {
            ...state.billingDataSource,
            isAddButton: false
          }
        };
      }
    case DELETE_ITEM_BILLINGS:
      {
        const {
          id
        } = action;
        let total = 0;
        const index = state.billingsList.findIndex(c => c.chargeId == id);
        const temp = [...state.billingsList];
        let tempObj = {
          ...temp[index]
        };
        const {
          totalRate
        } = tempObj;
        if (totalRate) {
          total = state.billingDataSource.grandTotal - totalRate;
        } else {
          total = state.billingDataSource.grandTotal;
        }
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            grandTotal: Number(total),
            isAddButton: true,
            isLoading: false
          },
          billingsList: state.billingsList.filter(c => c.chargeId != id)
        };
      }
    case UPDATE_ITEM_BILLINGS:
      {
        const {
          payload: {
            chargeId,
            fieldName,
            value
          }
        } = action;
        const index = state.billingsList.findIndex(c => c.chargeId == chargeId);
        const temp = [...state["billingsList"]];
        temp[index] = {
          ...temp[index],
          [fieldName]: value
        };
        return {
          ...state,
          billingsList: temp
        };
      }
    case UPDATE_ITEM_BILLINGS_TOTAL:
      {
        const {
          payload: {
            chargeId,
            fieldName,
            value
          }
        } = action;
        const index = state.billingsList.findIndex(c => c.chargeId == chargeId);
        const temp = [...state.billingsList];
        temp[index] = {
          ...temp[index],
          [fieldName]: value
        };
        const {
          quantity,
          unitPrice
        } = temp[index];
        let total = 0;
        let prevTotal = 0;
        let res = 0;
        if (temp[index].totalRate) {
          prevTotal = temp[index].totalRate;
        }
        if (quantity && unitPrice) {
          res = quantity * unitPrice;
          temp[index] = {
            ...temp[index],
            ["totalRate"]: `${res}`
          };
          total = res - prevTotal;
        } else if (quantity && !unitPrice || !quantity && unitPrice) {
          temp[index] = {
            ...temp[index],
            ["totalRate"]: ''
          };
          total = -prevTotal;
        }
        total = total ? state.billingDataSource.grandTotal + total : state.billingDataSource.grandTotal;
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            grandTotal: state.billingDataSource.isBillable ? total : state.billingDataSource.grandTotal
          },
          billingsList: temp
        };
      }
    case GET_BILLINGS_LIST:
      {
        const {
          payload: {
            billingsList,
            totalAmount
          }
        } = action;
        return {
          ...state,
          billingsList: [...state["billingsList"], ...billingsList],
          billingDataSource: {
            ...state.billingDataSource,
            grandTotal: Number(totalAmount),
            isLoading: false
          }
        };
      }
    case HANDLE_BILLABLE:
      {
        let billingsList = [...state.billingsList];
        let currentGrandTotal = state.billingDataSource.grandTotal;
        let currentIsBillable = state.billingDataSource.isBillable;
        let index = billingsList.findIndex(item => item.isNewlyAddedRow);
        let temp = {
          ...billingsList[index]
        };
        let currentTotal = temp === null || temp === void 0 ? void 0 : temp.totalRate;
        if (currentTotal) {
          if (currentIsBillable) {
            currentGrandTotal = currentGrandTotal - parseInt(currentTotal);
          } else {
            currentGrandTotal = currentGrandTotal + parseInt(currentTotal);
          }
        }
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            isBillable: !state.billingDataSource.isBillable,
            grandTotal: Number(currentGrandTotal)
          }
        };
      }
    case INITIALIZE_ISBILLABLE:
      {
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            isBillable: true,
            grandTotal: 0
          }
        };
      }
    case REFRESH_BILLINGS_LIST:
      {
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            isAddButton: true,
            isLoading: true
          },
          billingsList: []
        };
      }
    case HANDLE_ISLOADING:
      {
        var _state$billingDataSou;
        return {
          ...state,
          billingDataSource: {
            ...state.billingDataSource,
            isLoading: !(state !== null && state !== void 0 && (_state$billingDataSou = state.billingDataSource) !== null && _state$billingDataSou !== void 0 && _state$billingDataSou.isLoading)
          }
        };
      }
    default:
      return state;
  }
}

const INITIALIZE_ALL_VALUES = 'INITIALIZE_ALL_VALUES';
const INITIALIZE_DROPDOWNS = 'INITIALIZE_DROPDOWNS';
const UPDATE_ACTOR_FIELD_VALUE = 'UPDATE_ACTOR_FIELD_VALUE';
const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
const DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER = 'DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER';
const ADD_ADDITONAL_INFO = 'ADD_ADDITONAL_INFO';
const UPDATE_SHIPMENT_FIELD_VALUE = 'UPDATE_SHIPMENT_FIELD_VALUE';
const UPDATE_AI_STATEMENT_INFO_FIELDS = 'UPDATE_AI_STATEMENT_INFO_FIELDS';
const ADD_AI_CODES_AND_STATEMENT_INFO = 'ADD_AI_CODES_AND_STATEMENT_INFO';
const UPDATE_ITEM_AI_INFO_FIELD = 'UPDATE_ITEM_AI_INFO_FIELD';
const ADD_AI_CODES_AND_STATEMENT_INFO_M = 'ADD_AI_CODES_AND_STATEMENT_INFO_M';
const UPDATE_SHIP_DUTY_FIELD = 'UPDATE_SHIP_DUTY_FIELD';
const UPDATE_MERCH_DUTY_FIELD = 'UPDATE_MERCH_DUTY_FIELD';
const REMOVE_DUTY_ITEM = 'REMOVE_DUTY_ITEM';
const UPDATE_INVOICE_LINE_ITEM_FIELD = 'UPDATE_INVOICE_LINE_ITEM_FIELD';
const UPDATE_ITEM_SUMMARY_INFO_FIELD = 'UPDATE_ITEM_SUMMARY_INFO_FIELD';
const UPDATE_ITEM_INFO_FIELD = 'UPDATE_ITEM_INFO_FIELD';
const REMOVE_ITEM_INFO = 'REMOVE_ITEM_INFO';
const FORM_VALUES = 'FORM_VALUES';
const SET_ANY_FORM_VALUES = 'SET_ANY_FORM_VALUES';
const DELETE_SUMMARY = 'DELETE_SUMMARY';
const UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD = 'UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD';
const REMOVE_CONTAINER = 'REMOVE_CONTAINER';
const ADD_NEW_CONTAINER = 'ADD_NEW_CONTAINER';
const ADD_DOC_CODE_STATEMENT = 'ADD_DOC_CODE_STATEMENT';
const UPDATE_ITEM_DOC_CODE_STMT_FIELD = 'UPDATE_ITEM_DOC_CODE_STMT_FIELD';
const REMOVE_DOC_CODE_STMT_ITEM_INFO = 'REMOVE_DOC_CODE_STMT_ITEM_INFO';
const INITIALIZE_VALUES_NOTES = 'INITIALIZE_VALUES_NOTES';
const UPDATE_NOTES_ITEM_STATUS = 'UPDATE_NOTES_ITEM_STATUS';
const ADD_NOTES_ITEM = 'ADD_NOTES_ITEM';
const WHEN_SHIPMENT_CHANGED = 'WHEN_SHIPMENT_CHANGED';
const COLLAPSE_LINE_ITEMS = 'COLLAPSE_LINE_ITEMS';
const EXPAND_LINE_ITEMS = 'EXPAND_LINE_ITEMS';
const UPDATE_MERCHANDISE_COUNT = 'UPDATE_MERCHANDISE_COUNT';
const EXPAND_ALL_LINE_ITEMS = 'EXPAND_ALL_LINE_ITEMS';
const EXPAND_LINE_ITEM = 'EXPAND_LINE_ITEM';
const DELETE_ITEM_HEADER = 'DELETE_ITEM_HEADER';
const UPDATE_ITEM_HEADER = 'UPDATE_ITEM_HEADER';
const ADD_ITEM_PARTIES = 'ADD_ITEM_PARTIES';
const ADD_ITEM_MULTI_PARTIES = 'ADD_ITEM_MULTI_PARTIES';
const DELETE_ITEM_MULTI_PARTIES = 'DELETE_ITEM_MULTI_PARTIES';
const UPDATE_ITEM_PARTIES = 'UPDATE_ITEM_PARTIES';
const DELETE_ITEM_PARTIES = 'DELETE_ITEM_PARTIES';
const UPDATE_TRANSPORT_DETAILS = 'UPDATE_TRANSPORT_DETAILS';
const UPDATE_TRANSPORT_HEADER_INFO = 'UPDATE_TRANSPORT_HEADER_INFO';
const INITIALIZE_PARTIES_FORM = 'INITIALIZE_PARTIES_FORM';
const INITIALIZE_HEADER_FORM = 'INITIALIZE_HEADER_FORM';
const CLEAR_FORM = 'CLEAR_FORM';
const UPDATE_ACTOR_CONTACT_INFO = 'UPDATE_ACTOR_CONTACT_INFO';
const INITIALIZE_ITEMS_FORM = 'INITIALIZE_ITEMS_FORM';
const COPY_ACTOR_INFO = 'COPY_ACTOR_INFO';
const ACTOR_COPIED_STATUS = 'ACTOR_COPIED_STATUS';
const SAVE_INVOICE_DATA = 'SAVE_INVOICE_DATA';
const UPDATE_MULTIPLE_TAB_VALUE = 'UPDATE_MULTIPLE_TAB_VALUE';
const ADD_MULTIPLE_TAB = 'ADD_MULTIPLE_TAB';
const DELETE_MULTIPLE_TAB = 'DELETE_MULTIPLE_TAB';
const ADD_CONTAINER_FIELDS = 'ADD_CONTAINER_FIELDS';
const DELETE_CONTAINER_FIELDS = 'DELETE_CONTAINER_FIELDS';
const UPDATE_CONTAINER_FIELDS = 'UPDATE_CONTAINER_FIELDS';
const INITIALIZE_VALUE_BUILD_UP_FORM = 'INITIALIZE_VALUE_BUILD_UP_FORM';
const ADD_ITEM_VALUE_BUILD_UP$1 = 'ADD_ITEM_VALUE_BUILD_UP';
const DELETE_ITEM_VALUE_BUILD_UP = 'DELETE_ITEM_VALUE_BUILD_UP';
const UPDATE_ITEM_VALUE_BUILD_UP = 'UPDATE_ITEM_VALUE_BUILD_UP';
const UPDATE_INPUT_FILEDS = 'UPDATE_INPUT_FILEDS';

// Container tab
const ADD_ITEM_CONTAINER_TAB$1 = "ADD_ITEM_CONTAINER_TAB";
const DELETE_ITEM_CONTAINER_TAB$1 = "DELETE_ITEM_CONTAINER_TAB";
const UPDATE_ITEM_CONTAINER_TAB$1 = "UPDATE_ITEM_CONTAINER_TAB";
const GET_ITEM_CONTAINER_TAB$1 = "GET_ITEM_CONTAINER_TAB";
// 

// Items Tab
const CREATE_INVOICE = 'CREATE_INVOICE';
const DELETE_INVOICE = 'DELETE_INVOICE';
const UPDATE_ITEM_FIELD_VALUE = 'UPDATE_ITEM_FIELD_VALUE';
const CREATE_MERCHANDISE_ITEM = 'CREATE_MERCHANDISE_ITEM';
const DELETE_MERCHANDISE_ITEM = 'DELETE_MERCHANDISE_ITEM';
const UPDATE_MERCHANDISE_ITEM_BY_ID = 'UPDATE_MERCHANDISE_ITEM_BY_ID';
const ADD_MERCHANDISE_DOC_BY_ID = 'ADD_MERCHANDISE_DOC_BY_ID';
const ADD_MULTI_DOC_BY_MERCHANDISE_ID = 'ADD_MULTI_DOC_BY_MERCHANDISE_ID';
const DELETE_MULTI_DOC_BY_MERCHANDISE_ID = 'DELETE_MULTI_DOC_BY_MERCHANDISE_ID';
const DELETE_MERCHANDISE_DOC_BY_ID = 'DELETE_MERCHANDISE_DOC_BY_ID';
const UPDATE_MERCHANDISE_DOC_BY_ID = 'UPDATE_MERCHANDISE_DOC_BY_ID';
const UPDATE_MERCHANDISE_DOC_BY_ID_COPY = 'UPDATE_MERCHANDISE_DOC_BY_ID_COPY';
const ADD_EMPTY_ROW = 'ADD_EMPTY_ROW';
const UPDATE_ITEM_ACTOR_FIELD_VALUE = 'UPDATE_ITEM_ACTOR_FIELD_VALUE';
const UPDATE_ITEM_ACTOR_CONTACT_INFO = 'UPDATE_ITEM_ACTOR_CONTACT_INFO';
const ADD_INVOICE_DOC_BY_ID = 'ADD_INVOICE_DOC_BY_ID';
const DELETE_INVOICE_DOC_BY_ID = 'DELETE_INVOICE_DOC_BY_ID';
const UPDATE_INVOICE_DOC_BY_ID = 'UPDATE_INVOICE_DOC_BY_ID';
const UPDATE_INVOICE_HEADER = 'UPDATE_INVOICE_HEADER';
const UPDATE_AFTER_SAVE = 'UPDATE_AFTER_SAVE';
const DELETE_ITEM_PARTIES_ACTOR = 'DELETE_ITEM_PARTIES_ACTOR';
const UPDATE_EXPORTER_FOR_ALL_INVOICES = 'UPDATE_EXPORTER_FOR_ALL_INVOICES';

// end

// parties

const UPDATE_DAFFERED_PAYMENT = 'UPDATE_DAFFERED_PAYMENT';
//CDS HEADER ITEMS
const ADD_ITEM_CDS_HEADER = 'ADD_ITEM_CDS_HEADER';
const DELETE_ITEM_CDS_HEADER = 'DELETE_ITEM_CDS_HEADER';
const UPDATE_ITEM_CDS_HEADER = 'UPDATE_ITEM_CDS_HEADER';
const UPDATE_ARRIVAL_TRANSPORT_FIELDS = 'UPDATE_ARRIVAL_TRANSPORT_FIELDS';
const UPDATE_DELIVERY_TRANSPORT_FIELDS = 'UPDATE_DELIVERY_TRANSPORT_FIELDS';
const UPDATE_HEADER_TRADE_TERM = 'UPDATE_HEADER_TRADE_TERM';
const UPDATE_EIDR_EORI_NUMBER = 'UPDATE_EIDR_EORI_NUMBER';
const DELETE_ACTOR = 'DELETE_ACTOR';
const HANDLE_DND = "HANDLE_DND";
const ADD_AFTER_EXITING_ROUTING_COUNTRY = "ADD_AFTER_EXITING_ROUTING_COUNTRY";
const UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER = "UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER";
// end

//containers
const CREATE_ITEM_CONTAINER = 'CREATE_ITEM_CONTAINER';
const DELETE_ITEM_CONTAINER = 'DELETE_ITEM_CONTAINER';

// errorValidationActions

const INIT_HEADER_TAB_WARNINGS = 'INIT_HEADER_TAB_WARNINGS';
const ADD_HEADER_TAB_WARNINGS = 'ADD_HEADER_TAB_WARNINGS';
const DELETE_HEADER_TAB_WARNINGS = 'DELETE_HEADER_TAB_WARNINGS';
const INIT_PARTIES_TAB_WARNINGS = 'INIT_PARTIES_TAB_WARNINGS';
const ADD_PARTIES_TAB_WARNINGS = 'ADD_PARTIES_TAB_WARNINGS';
const DELETE_PARTIES_TAB_WARNINGS = 'DELETE_PARTIES_TAB_WARNINGS';
const INIT_VALUEBUILDUP_TAB_WARNINGS = 'INIT_VALUEBUILDUP_TAB_WARNINGS';
const ADD_VALUEBUILDUP_TAB_WARNINGS = 'ADD_VALUEBUILDUP_TAB_WARNINGS';
const DELETE_VALUEBUILDUP_TAB_WARNINGS = 'DELETE_VALUEBUILDUP_TAB_WARNINGS';
const INIT_CONTAINER_TAB_WARNINGS = 'INIT_CONTAINER_TAB_WARNINGS';
const ADD_CONTAINER_TAB_WARNINGS = 'ADD_CONTAINER_TAB_WARNINGS';
const DELETE_CONTAINER_TAB_WARNINGS = 'DELETE_CONTAINER_TAB_WARNINGS';
const INIT_ITEMS_TAB_WARNINGS = 'INIT_ITEMS_TAB_WARNINGS';
const ADD_ITEMS_TAB_WARNINGS = 'ADD_ITEMS_TAB_WARNINGS';
const DELETE_ITEMS_TAB_WARNINGS = 'DELETE_ITEMS_TAB_WARNINGS';
const COPY_TO_MASS_UPDATE_CDS = 'COPY_TO_MASS_UPDATE_CDS';

var ActionTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  INITIALIZE_ALL_VALUES: INITIALIZE_ALL_VALUES,
  INITIALIZE_DROPDOWNS: INITIALIZE_DROPDOWNS,
  UPDATE_ACTOR_FIELD_VALUE: UPDATE_ACTOR_FIELD_VALUE,
  SET_ERROR_MESSAGE: SET_ERROR_MESSAGE,
  DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER: DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER,
  ADD_ADDITONAL_INFO: ADD_ADDITONAL_INFO,
  UPDATE_SHIPMENT_FIELD_VALUE: UPDATE_SHIPMENT_FIELD_VALUE,
  UPDATE_AI_STATEMENT_INFO_FIELDS: UPDATE_AI_STATEMENT_INFO_FIELDS,
  ADD_AI_CODES_AND_STATEMENT_INFO: ADD_AI_CODES_AND_STATEMENT_INFO,
  UPDATE_ITEM_AI_INFO_FIELD: UPDATE_ITEM_AI_INFO_FIELD,
  ADD_AI_CODES_AND_STATEMENT_INFO_M: ADD_AI_CODES_AND_STATEMENT_INFO_M,
  UPDATE_SHIP_DUTY_FIELD: UPDATE_SHIP_DUTY_FIELD,
  UPDATE_MERCH_DUTY_FIELD: UPDATE_MERCH_DUTY_FIELD,
  REMOVE_DUTY_ITEM: REMOVE_DUTY_ITEM,
  UPDATE_INVOICE_LINE_ITEM_FIELD: UPDATE_INVOICE_LINE_ITEM_FIELD,
  UPDATE_ITEM_SUMMARY_INFO_FIELD: UPDATE_ITEM_SUMMARY_INFO_FIELD,
  UPDATE_ITEM_INFO_FIELD: UPDATE_ITEM_INFO_FIELD,
  REMOVE_ITEM_INFO: REMOVE_ITEM_INFO,
  FORM_VALUES: FORM_VALUES,
  SET_ANY_FORM_VALUES: SET_ANY_FORM_VALUES,
  DELETE_SUMMARY: DELETE_SUMMARY,
  UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD: UPDATE_MERCH_LINE_ITEM_CONTAINER_FIELD,
  REMOVE_CONTAINER: REMOVE_CONTAINER,
  ADD_NEW_CONTAINER: ADD_NEW_CONTAINER,
  ADD_DOC_CODE_STATEMENT: ADD_DOC_CODE_STATEMENT,
  UPDATE_ITEM_DOC_CODE_STMT_FIELD: UPDATE_ITEM_DOC_CODE_STMT_FIELD,
  REMOVE_DOC_CODE_STMT_ITEM_INFO: REMOVE_DOC_CODE_STMT_ITEM_INFO,
  INITIALIZE_VALUES_NOTES: INITIALIZE_VALUES_NOTES,
  UPDATE_NOTES_ITEM_STATUS: UPDATE_NOTES_ITEM_STATUS,
  ADD_NOTES_ITEM: ADD_NOTES_ITEM,
  WHEN_SHIPMENT_CHANGED: WHEN_SHIPMENT_CHANGED,
  COLLAPSE_LINE_ITEMS: COLLAPSE_LINE_ITEMS,
  EXPAND_LINE_ITEMS: EXPAND_LINE_ITEMS,
  UPDATE_MERCHANDISE_COUNT: UPDATE_MERCHANDISE_COUNT,
  EXPAND_ALL_LINE_ITEMS: EXPAND_ALL_LINE_ITEMS,
  EXPAND_LINE_ITEM: EXPAND_LINE_ITEM,
  DELETE_ITEM_HEADER: DELETE_ITEM_HEADER,
  UPDATE_ITEM_HEADER: UPDATE_ITEM_HEADER,
  ADD_ITEM_PARTIES: ADD_ITEM_PARTIES,
  ADD_ITEM_MULTI_PARTIES: ADD_ITEM_MULTI_PARTIES,
  DELETE_ITEM_MULTI_PARTIES: DELETE_ITEM_MULTI_PARTIES,
  UPDATE_ITEM_PARTIES: UPDATE_ITEM_PARTIES,
  DELETE_ITEM_PARTIES: DELETE_ITEM_PARTIES,
  UPDATE_TRANSPORT_DETAILS: UPDATE_TRANSPORT_DETAILS,
  UPDATE_TRANSPORT_HEADER_INFO: UPDATE_TRANSPORT_HEADER_INFO,
  INITIALIZE_PARTIES_FORM: INITIALIZE_PARTIES_FORM,
  INITIALIZE_HEADER_FORM: INITIALIZE_HEADER_FORM,
  CLEAR_FORM: CLEAR_FORM,
  UPDATE_ACTOR_CONTACT_INFO: UPDATE_ACTOR_CONTACT_INFO,
  INITIALIZE_ITEMS_FORM: INITIALIZE_ITEMS_FORM,
  COPY_ACTOR_INFO: COPY_ACTOR_INFO,
  ACTOR_COPIED_STATUS: ACTOR_COPIED_STATUS,
  SAVE_INVOICE_DATA: SAVE_INVOICE_DATA,
  UPDATE_MULTIPLE_TAB_VALUE: UPDATE_MULTIPLE_TAB_VALUE,
  ADD_MULTIPLE_TAB: ADD_MULTIPLE_TAB,
  DELETE_MULTIPLE_TAB: DELETE_MULTIPLE_TAB,
  ADD_CONTAINER_FIELDS: ADD_CONTAINER_FIELDS,
  DELETE_CONTAINER_FIELDS: DELETE_CONTAINER_FIELDS,
  UPDATE_CONTAINER_FIELDS: UPDATE_CONTAINER_FIELDS,
  INITIALIZE_VALUE_BUILD_UP_FORM: INITIALIZE_VALUE_BUILD_UP_FORM,
  ADD_ITEM_VALUE_BUILD_UP: ADD_ITEM_VALUE_BUILD_UP$1,
  DELETE_ITEM_VALUE_BUILD_UP: DELETE_ITEM_VALUE_BUILD_UP,
  UPDATE_ITEM_VALUE_BUILD_UP: UPDATE_ITEM_VALUE_BUILD_UP,
  UPDATE_INPUT_FILEDS: UPDATE_INPUT_FILEDS,
  ADD_ITEM_CONTAINER_TAB: ADD_ITEM_CONTAINER_TAB$1,
  DELETE_ITEM_CONTAINER_TAB: DELETE_ITEM_CONTAINER_TAB$1,
  UPDATE_ITEM_CONTAINER_TAB: UPDATE_ITEM_CONTAINER_TAB$1,
  GET_ITEM_CONTAINER_TAB: GET_ITEM_CONTAINER_TAB$1,
  CREATE_INVOICE: CREATE_INVOICE,
  DELETE_INVOICE: DELETE_INVOICE,
  UPDATE_ITEM_FIELD_VALUE: UPDATE_ITEM_FIELD_VALUE,
  CREATE_MERCHANDISE_ITEM: CREATE_MERCHANDISE_ITEM,
  DELETE_MERCHANDISE_ITEM: DELETE_MERCHANDISE_ITEM,
  UPDATE_MERCHANDISE_ITEM_BY_ID: UPDATE_MERCHANDISE_ITEM_BY_ID,
  ADD_MERCHANDISE_DOC_BY_ID: ADD_MERCHANDISE_DOC_BY_ID,
  ADD_MULTI_DOC_BY_MERCHANDISE_ID: ADD_MULTI_DOC_BY_MERCHANDISE_ID,
  DELETE_MULTI_DOC_BY_MERCHANDISE_ID: DELETE_MULTI_DOC_BY_MERCHANDISE_ID,
  DELETE_MERCHANDISE_DOC_BY_ID: DELETE_MERCHANDISE_DOC_BY_ID,
  UPDATE_MERCHANDISE_DOC_BY_ID: UPDATE_MERCHANDISE_DOC_BY_ID,
  UPDATE_MERCHANDISE_DOC_BY_ID_COPY: UPDATE_MERCHANDISE_DOC_BY_ID_COPY,
  ADD_EMPTY_ROW: ADD_EMPTY_ROW,
  UPDATE_ITEM_ACTOR_FIELD_VALUE: UPDATE_ITEM_ACTOR_FIELD_VALUE,
  UPDATE_ITEM_ACTOR_CONTACT_INFO: UPDATE_ITEM_ACTOR_CONTACT_INFO,
  ADD_INVOICE_DOC_BY_ID: ADD_INVOICE_DOC_BY_ID,
  DELETE_INVOICE_DOC_BY_ID: DELETE_INVOICE_DOC_BY_ID,
  UPDATE_INVOICE_DOC_BY_ID: UPDATE_INVOICE_DOC_BY_ID,
  UPDATE_INVOICE_HEADER: UPDATE_INVOICE_HEADER,
  UPDATE_AFTER_SAVE: UPDATE_AFTER_SAVE,
  DELETE_ITEM_PARTIES_ACTOR: DELETE_ITEM_PARTIES_ACTOR,
  UPDATE_EXPORTER_FOR_ALL_INVOICES: UPDATE_EXPORTER_FOR_ALL_INVOICES,
  UPDATE_DAFFERED_PAYMENT: UPDATE_DAFFERED_PAYMENT,
  ADD_ITEM_CDS_HEADER: ADD_ITEM_CDS_HEADER,
  DELETE_ITEM_CDS_HEADER: DELETE_ITEM_CDS_HEADER,
  UPDATE_ITEM_CDS_HEADER: UPDATE_ITEM_CDS_HEADER,
  UPDATE_ARRIVAL_TRANSPORT_FIELDS: UPDATE_ARRIVAL_TRANSPORT_FIELDS,
  UPDATE_DELIVERY_TRANSPORT_FIELDS: UPDATE_DELIVERY_TRANSPORT_FIELDS,
  UPDATE_HEADER_TRADE_TERM: UPDATE_HEADER_TRADE_TERM,
  UPDATE_EIDR_EORI_NUMBER: UPDATE_EIDR_EORI_NUMBER,
  DELETE_ACTOR: DELETE_ACTOR,
  HANDLE_DND: HANDLE_DND,
  ADD_AFTER_EXITING_ROUTING_COUNTRY: ADD_AFTER_EXITING_ROUTING_COUNTRY,
  UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER: UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER,
  CREATE_ITEM_CONTAINER: CREATE_ITEM_CONTAINER,
  DELETE_ITEM_CONTAINER: DELETE_ITEM_CONTAINER,
  INIT_HEADER_TAB_WARNINGS: INIT_HEADER_TAB_WARNINGS,
  ADD_HEADER_TAB_WARNINGS: ADD_HEADER_TAB_WARNINGS,
  DELETE_HEADER_TAB_WARNINGS: DELETE_HEADER_TAB_WARNINGS,
  INIT_PARTIES_TAB_WARNINGS: INIT_PARTIES_TAB_WARNINGS,
  ADD_PARTIES_TAB_WARNINGS: ADD_PARTIES_TAB_WARNINGS,
  DELETE_PARTIES_TAB_WARNINGS: DELETE_PARTIES_TAB_WARNINGS,
  INIT_VALUEBUILDUP_TAB_WARNINGS: INIT_VALUEBUILDUP_TAB_WARNINGS,
  ADD_VALUEBUILDUP_TAB_WARNINGS: ADD_VALUEBUILDUP_TAB_WARNINGS,
  DELETE_VALUEBUILDUP_TAB_WARNINGS: DELETE_VALUEBUILDUP_TAB_WARNINGS,
  INIT_CONTAINER_TAB_WARNINGS: INIT_CONTAINER_TAB_WARNINGS,
  ADD_CONTAINER_TAB_WARNINGS: ADD_CONTAINER_TAB_WARNINGS,
  DELETE_CONTAINER_TAB_WARNINGS: DELETE_CONTAINER_TAB_WARNINGS,
  INIT_ITEMS_TAB_WARNINGS: INIT_ITEMS_TAB_WARNINGS,
  ADD_ITEMS_TAB_WARNINGS: ADD_ITEMS_TAB_WARNINGS,
  DELETE_ITEMS_TAB_WARNINGS: DELETE_ITEMS_TAB_WARNINGS,
  COPY_TO_MASS_UPDATE_CDS: COPY_TO_MASS_UPDATE_CDS
});

const actorList$1 = {
  consignee: {},
  declarant: {},
  consignor: {},
  agent: {},
  exporter: {},
  importer: {},
  surety: {},
  carrier: {},
  fiscal: {},
  buyer: {},
  seller: {},
  representative: {}
};

const initialState$w = {
  ...actorList$1,
  authorization: [],
  additionalSupplyChainActor: [],
  deferredPaymentList: [],
  guarantee: [],
  additionalFiscalReferences: [],
  representative: [],
  den1: '',
  den2: '',
  copyToexporter: {
    seller: false
  }
};
function ActorReducer$1(state = initialState$w, action) {
  switch (action.type) {
    case INITIALIZE_PARTIES_FORM:
      {
        for (let actor in actorList$1) {
          var _$get$concat;
          if (action.payload[actor]) action.payload[actor].addressLine1 = (_$get$concat = _.get(action.payload[actor], 'streetNumber', '').concat(' ', _.get(action.payload[actor], 'streetName', ''))) === null || _$get$concat === void 0 ? void 0 : _$get$concat.trim();
        }
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_ACTOR_FIELD_VALUE:
      {
        const {
          actorType,
          payload
        } = action;
        return {
          ...state,
          [`${actorType}`]: {
            ...state[actorType],
            ...payload
          }
        };
      }
    case DELETE_ACTOR:
      {
        const {
          actorType
        } = action;
        return {
          ...state,
          [`${actorType}`]: {}
        };
      }
    case UPDATE_ACTOR_CONTACT_INFO:
      {
        const {
          actorType,
          payload
        } = action;
        return {
          ...state,
          [`${actorType}`]: {
            ...state[actorType],
            contact: {
              ...state[actorType].contact,
              ...payload
            }
          }
        };
      }
    case ADD_ITEM_PARTIES:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], payload.parties[`${tableName}`][0]]
        };
      }
    case ADD_ITEM_MULTI_PARTIES:
      {
        const {
          meta: {
            tableName
          },
          payload = []
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], ...payload]
        };
      }
    case DELETE_ITEM_MULTI_PARTIES:
      {
        const {
          meta: {
            tableName
          },
          payload = []
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName].filter(item => !payload.includes(item.id))]
        };
      }
    case UPDATE_ITEM_PARTIES:
      {
        const {
          id,
          payload,
          meta: {
            tableName
          }
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case DELETE_ITEM_PARTIES:
      {
        const {
          id,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          [`${tableName}`]: state[tableName].filter(c => c.id != id)
        };
      }
    case ACTOR_COPIED_STATUS:
      {
        const {
          copyTo,
          copyFrom,
          isChecked
        } = action;
        const copyToLisT = Array.isArray(copyTo) ? copyTo : [copyTo];
        const updatedState = copyToLisT.reduce((prev, curr) => {
          return {
            ...prev,
            [`${curr}`]: isChecked
          };
        }, {});
        return {
          ...state,
          [`copyTo${copyFrom}`]: {
            ...state[`copyTo${copyFrom}`],
            ...updatedState
          }
        };
      }
    case COPY_ACTOR_INFO:
      {
        const {
          copyFrom,
          copyTo
        } = action;
        const selectedActor = state[`copyTo${copyFrom}`];
        const copyToLisT = copyTo ? [copyTo] : Object.keys(selectedActor).filter(key => selectedActor[key]); //Array.isArray(copyTo) ? copyTo:[copyTo]
        const {
          name,
          eoriNo,
          addressLine1,
          addressLine2,
          city,
          state: state1,
          postalCode,
          country
        } = state[copyFrom];
        const updatedState = copyToLisT.reduce((prev, curr) => {
          return {
            ...prev,
            [`${curr}`]: {
              ...state[`${curr}`],
              name,
              eoriNo,
              addressLine1,
              addressLine2,
              city,
              state: state1,
              postalCode,
              country
            }
          };
        }, {});
        return {
          ...state,
          ...updatedState
        };
      }
    case UPDATE_DAFFERED_PAYMENT:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    case UPDATE_EIDR_EORI_NUMBER:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    case UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ['exporter']: payload
        };
      }
    case CLEAR_FORM:
      {
        return initialState$w;
      }
    default:
      return state;
  }
}

const initialState$v = {
  declarationCategories: null,
  declarationDropdown: [],
  declarationTypes: null,
  declarationCat: null,
  arrivalDate: {
    epochs: null
  },
  declaration: null,
  ducr: null,
  ucn: null,
  lrn: null,
  mucr: null,
  acceptanceDate: {
    epochs: null
  },
  departureDate: {
    epochs: null
  },
  exitEuDate: {
    epochs: null
  },
  releaseDate: {
    epochs: null
  },
  specificCircumstanceIndicator: null,
  referenceNumber: null,
  declarationType: null,
  cancellationReason: null,
  eidrEoriNumber: null,
  exitInfo: {},
  additionalInfo: [],
  declarationPreviousDoc: [],
  routingCountry: [],
  transportation: {
    dispatchCountry: '',
    placeOfLoading: '',
    countryOfDestination: '',
    locationOfGoods: '',
    arrivalTransportIDType: '',
    arrivalTransportIDNumber: '',
    container: '',
    borderTransportNationality: '',
    borderTransportMode: '',
    inlandTransportMode: '',
    customsOfficeOfPresentation: '',
    supervisingCustomOffice: '',
    natureOfTransaction: '',
    finalDestinationTransportCost: '',
    idTransportType: {},
    idTransportNumber: '',
    transportChargesMop: {},
    wareHouseType: '',
    deliveryIncoterms: '',
    wareHouseId: '',
    deliveryCountryAndLocation: '',
    deliveryUnlocode: '',
    customsOfficeOfExit: '',
    goodsLocation: {},
    warehoueDetails: {},
    BorderTransitMode: {},
    ArrivalTransitMode: {},
    DepartureTransitMode: {},
    tradeTerms: {},
    transport: {
      id: '',
      idType: '',
      idNumber: '',
      borderTransportMode: ''
    },
    deliveryTerms: {
      id: '',
      incoterms: '',
      unlocode: '',
      countryAndLocation: ''
    },
    finalDestinationTransport: {
      id: '',
      costCurrency: '',
      cost: ''
    }
    // dispatchCountry:{},
    // borderTransportNationality:{}
  },
  customOfficeList: [],
  supportingDocList: [],
  previousDocList: [],
  existInfoList: [],
  additionalInfoList: [],
  headerContainer: [],
  unlocode: [],
  amendmentReason: []
};
function ShipmentReducer$1(state = initialState$v, action) {
  switch (action.type) {
    case INITIALIZE_HEADER_FORM:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_SHIPMENT_FIELD_VALUE:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    case UPDATE_TRANSPORT_DETAILS:
      {
        const {
          key,
          fieldName,
          value
        } = action.payload;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            [`${key}`]: {
              ...state.transportation[key],
              [`${fieldName}`]: value
            }
          }
        };
      }
    case UPDATE_TRANSPORT_HEADER_INFO:
      {
        const {
          fieldName,
          value
        } = action.payload;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            [`${fieldName}`]: value
          }
        };
      }
    case UPDATE_ARRIVAL_TRANSPORT_FIELDS:
      {
        const {
          fieldName,
          value
        } = action.payload;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            transport: {
              ...state.transportation.transport,
              [`${fieldName}`]: value
            }
          }
        };
      }
    case UPDATE_DELIVERY_TRANSPORT_FIELDS:
      {
        const {
          fieldName,
          value
        } = action.payload;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            deliveryTerms: {
              ...state.transportation.deliveryTerms,
              [`${fieldName}`]: value
            }
          }
        };
      }
    case ADD_ITEM_CDS_HEADER:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], action.payload]
        };
      }
    case UPDATE_ITEM_CDS_HEADER:
      {
        const {
          id,
          payload,
          meta: {
            tableName
          }
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case DELETE_ITEM_CDS_HEADER:
      {
        var _payload$tableName$;
        const {
          payload,
          meta: {
            tableName
          }
        } = action;
        let id = (_payload$tableName$ = payload[tableName][0]) === null || _payload$tableName$ === void 0 ? void 0 : _payload$tableName$.id;
        let currentItemState = [...state[tableName]];
        let updatedItemState = currentItemState.filter(item => item.id !== id);
        return {
          ...state,
          [`${tableName}`]: updatedItemState
        };
      }
    case UPDATE_EIDR_EORI_NUMBER:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    case HANDLE_DND:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          routingCountry: payload
        };
      }
    case ADD_AFTER_EXITING_ROUTING_COUNTRY:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          routingCountry: payload
        };
      }
    case CLEAR_FORM:
      {
        return initialState$v;
      }
    default:
      return state;
  }
}

const initialState$u = {
  invoice: {
    invoiceHeader: {
      totalInvoices: 0
    },
    invoiceIds: [],
    invoiceList: {},
    merchandise: {},
    containers: []
  }
};
function InvoicesReducer$1(state = initialState$u, action) {
  switch (action.type) {
    case INITIALIZE_ITEMS_FORM:
      {
        return {
          ...state,
          invoice: {
            ...state.invoice,
            ...action.payload
          }
        };
      }
    case UPDATE_ITEM_FIELD_VALUE:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              ...payload
            }
          }
        };
      }
    case UPDATE_INVOICE_HEADER:
      {
        const {
          payload: {
            invoiceId,
            ...rest
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                header: {
                  ...state.invoice.invoiceList[invoiceId].header,
                  ...rest
                }
              }
            }
          }
        };
      }
    case CREATE_INVOICE:
      {
        const {
          invoiceId,
          payload
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              totalInvoices: +state.invoice.invoiceHeader.totalInvoices + 1
            },
            invoiceIds: [...state.invoice.invoiceIds, invoiceId],
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                header: payload,
                additionalFiscalReferences: [],
                procedures: [],
                merchandiseIds: []
              }
            }
          }
        };
      }
    case DELETE_INVOICE:
      {
        var _state$invoice$invoic, _state$invoice$invoic2;
        const {
          invoiceId,
          payload
        } = action;
        (_state$invoice$invoic = state.invoice.invoiceList[invoiceId]) === null || _state$invoice$invoic === void 0 ? void 0 : (_state$invoice$invoic2 = _state$invoice$invoic.merchandiseIds) === null || _state$invoice$invoic2 === void 0 ? void 0 : _state$invoice$invoic2.forEach(e => delete state.invoice.merchandise[e]);
        delete state.invoice.invoiceList[invoiceId];
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              totalInvoices: +state.invoice.invoiceHeader.totalInvoices - 1,
              ...payload.invoiceHeader
            },
            invoiceIds: state.invoice.invoiceIds.filter(c => c != invoiceId),
            invoiceList: state.invoice.invoiceList,
            merchandise: {
              ...state.invoice.merchandise,
              ...payload.merchandise
            }
          }
        };
      }
    case CREATE_MERCHANDISE_ITEM:
      {
        const {
          invoiceId,
          update,
          payload: {
            merchandiseId,
            ...rest
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              ...update.invoiceHeader
            },
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                header: {
                  ...state.invoice.invoiceList[invoiceId].header,
                  ...update.header
                },
                merchandiseIds: [...(state.invoice.invoiceList[invoiceId].merchandiseIds || []), merchandiseId]
              }
            },
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                merchandiseId,
                ...rest
              }
            }
          }
        };
      }
    case DELETE_MERCHANDISE_ITEM:
      {
        const {
          invoiceId,
          merchandiseId,
          update
        } = action;
        delete state.invoice.merchandise[merchandiseId];
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              ...update.invoiceHeader
            },
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                header: {
                  ...state.invoice.invoiceList[invoiceId].header,
                  ...update.header
                },
                merchandiseIds: state.invoice.invoiceList[invoiceId].merchandiseIds.filter(c => c != merchandiseId)
              }
            },
            merchandise: {
              ...state.invoice.merchandise,
              ...update.merchandise
            }
          }
        };
      }
    case UPDATE_MERCHANDISE_ITEM_BY_ID:
      {
        const {
          merchandiseId,
          payload
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                ...state.invoice.merchandise[merchandiseId],
                ...payload
              }
            }
          }
        };
      }
    case ADD_MERCHANDISE_DOC_BY_ID:
      {
        const {
          payload = {},
          ids,
          meta: {
            tableName
          }
        } = action;
        const updatedData = ids.reduce((prev, {
          merchandiseId,
          invoiceId,
          ...rest
        }) => {
          var _state$invoice;
          prev = {
            ...prev,
            [`${merchandiseId}`]: {
              ...state.invoice.merchandise[merchandiseId],
              [`${tableName}`]: [...(((_state$invoice = state.invoice) === null || _state$invoice === void 0 ? void 0 : _state$invoice.merchandise[merchandiseId][tableName]) || []), {
                ...rest,
                ...payload
              }]
            }
          };
          return prev;
        }, {});
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              ...updatedData
            }
          }
        };
      }
    case ADD_MULTI_DOC_BY_MERCHANDISE_ID:
      {
        const {
          payload = [],
          ids,
          meta: {
            tableName
          }
        } = action;
        const updatedData = ids.reduce((prev, {
          merchandiseId,
          invoiceId,
          ...rest
        }) => {
          var _state$invoice2;
          prev = {
            ...prev,
            [`${merchandiseId}`]: {
              ...state.invoice.merchandise[merchandiseId],
              [`${tableName}`]: [...(((_state$invoice2 = state.invoice) === null || _state$invoice2 === void 0 ? void 0 : _state$invoice2.merchandise[merchandiseId][tableName]) || []), ...payload]
            }
          };
          return prev;
        }, {});
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              ...updatedData
            }
          }
        };
      }
    case DELETE_MULTI_DOC_BY_MERCHANDISE_ID:
      {
        const {
          payload = [],
          ids,
          meta: {
            tableName
          }
        } = action;
        const updatedData = ids.reduce((prev, {
          merchandiseId,
          invoiceId,
          ...rest
        }) => {
          prev = {
            ...prev,
            [`${merchandiseId}`]: {
              ...state.invoice.merchandise[merchandiseId],
              [`${tableName}`]: [...state.invoice.merchandise[merchandiseId][tableName].filter(item => !payload.includes(item.id))]
            }
          };
          return prev;
        }, {});
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              ...updatedData
            }
          }
        };
      }
    case DELETE_MERCHANDISE_DOC_BY_ID:
      {
        const {
          payload: {
            merchandiseId,
            id
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                ...state.invoice.merchandise[merchandiseId],
                [`${tableName}`]: state.invoice.merchandise[merchandiseId][tableName].filter(c => c.id != id)
              }
            }
          }
        };
      }
    case UPDATE_MERCHANDISE_DOC_BY_ID:
      {
        const {
          id,
          payload: {
            merchandiseId,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                ...state.invoice.merchandise[merchandiseId],
                [`${tableName}`]: state.invoice.merchandise[merchandiseId][tableName].map(item => item.id == id ? {
                  ...item,
                  ...rest
                } : item)
              }
            }
          }
        };
      }
    case UPDATE_MERCHANDISE_DOC_BY_ID_COPY:
      {
        const {
          type,
          payload: {
            generatedIds,
            attributes
          },
          meta: {
            tableName
          }
        } = action;
        let tempState = state;
        generatedIds.forEach(itm => {
          var _tempState, _tempState$invoice;
          tempState = {
            ...tempState,
            invoice: {
              ...tempState.invoice,
              merchandise: {
                ...tempState.invoice.merchandise,
                [`${itm === null || itm === void 0 ? void 0 : itm.merchandiseId}`]: {
                  ...tempState.invoice.merchandise[itm === null || itm === void 0 ? void 0 : itm.merchandiseId],
                  [`${tableName}`]: [...(((_tempState = tempState) === null || _tempState === void 0 ? void 0 : (_tempState$invoice = _tempState.invoice) === null || _tempState$invoice === void 0 ? void 0 : _tempState$invoice.merchandise[itm === null || itm === void 0 ? void 0 : itm.merchandiseId][tableName]) || []), {
                    ...itm,
                    ...attributes
                  }]
                }
              }
            }
          };
        });
        return tempState;
      }
    case CREATE_ITEM_CONTAINER:
      {
        var _state$invoice$mercha;
        const {
          merchandiseId,
          payload
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                ...state.invoice.merchandise[merchandiseId],
                containerNumberList: {
                  ...state.invoice.merchandise[merchandiseId].containerNumberList,
                  containerList: (_state$invoice$mercha = state.invoice.merchandise[merchandiseId]) !== null && _state$invoice$mercha !== void 0 && _state$invoice$mercha.containerNumberList.containerList ? [...state.invoice.merchandise[merchandiseId].containerNumberList.containerList, payload] : [payload]
                }
              }
            }
          }
        };
      }
    case DELETE_ITEM_CONTAINER:
      {
        var _state$invoice$mercha2, _state$invoice$mercha3;
        const {
          merchandiseId,
          containerAssociationId
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              [`${merchandiseId}`]: {
                ...state.invoice.merchandise[merchandiseId],
                containerNumberList: {
                  ...state.invoice.merchandise[merchandiseId].containerNumberList,
                  containerList: (_state$invoice$mercha2 = state.invoice.merchandise[merchandiseId]) === null || _state$invoice$mercha2 === void 0 ? void 0 : (_state$invoice$mercha3 = _state$invoice$mercha2.containerNumberList) === null || _state$invoice$mercha3 === void 0 ? void 0 : _state$invoice$mercha3.containerList.filter(c => c.containerAssociationId != containerAssociationId)
                }
              }
            }
          }
        };
      }

    // For invoice Item

    case ADD_INVOICE_DOC_BY_ID:
      {
        var _state$invoice3;
        const {
          payload: {
            response,
            invoiceId
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${tableName}`]: [...(((_state$invoice3 = state.invoice) === null || _state$invoice3 === void 0 ? void 0 : _state$invoice3.invoiceList[invoiceId][tableName]) || []), response]
              }
            }
          }
        };
      }
    case DELETE_INVOICE_DOC_BY_ID:
      {
        const {
          payload: {
            invoiceId,
            id
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${tableName}`]: state.invoice.invoiceList[invoiceId][tableName].filter(c => c.id != id)
              }
            }
          }
        };
      }
    case UPDATE_INVOICE_DOC_BY_ID:
      {
        const {
          id,
          payload: {
            invoiceId,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${tableName}`]: state.invoice.invoiceList[invoiceId][tableName].map(item => item.id == id ? {
                  ...item,
                  ...rest
                } : item)
              }
            }
          }
        };
      }
    case UPDATE_AFTER_SAVE:
      {
        const {
          invoiceId,
          update
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceHeader: {
              ...state.invoice.invoiceHeader,
              ...update.invoiceHeader
            },
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                header: {
                  ...state.invoice.invoiceList[invoiceId].header,
                  ...update.header
                }
              }
            }
          }
        };
      }

    // for item parties

    case UPDATE_ITEM_ACTOR_FIELD_VALUE:
      {
        var _state$invoice4;
        const {
          actorType,
          payload,
          invoiceId
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${actorType}`]: {
                  ...(((_state$invoice4 = state.invoice) === null || _state$invoice4 === void 0 ? void 0 : _state$invoice4.invoiceList[invoiceId][actorType]) || {}),
                  ...payload
                }
              }
            }
          }
        };
      }
    case DELETE_ITEM_PARTIES_ACTOR:
      {
        const {
          actorType,
          payload,
          invoiceId
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${actorType}`]: {}
              }
            }
          }
        };
      }
    case COPY_TO_MASS_UPDATE_CDS:
      {
        var _Object$values;
        const {
          ids,
          meta: {
            tableName
          }
        } = action;
        const updatedData = (_Object$values = Object.values(ids)) === null || _Object$values === void 0 ? void 0 : _Object$values.reduce((prev, {
          merchandiseId,
          ...rest
        }) => {
          var _state$invoice5;
          prev = {
            ...prev,
            [`${merchandiseId}`]: {
              ...state.invoice.merchandise[merchandiseId],
              [`${tableName}`]: [...(((_state$invoice5 = state.invoice) === null || _state$invoice5 === void 0 ? void 0 : _state$invoice5.merchandise[merchandiseId][tableName]) || []), {
                ...rest[`${tableName}`][0]
              }]
            }
          };
          return prev;
        }, {});
        return {
          ...state,
          invoice: {
            ...state.invoice,
            merchandise: {
              ...state.invoice.merchandise,
              ...updatedData
            }
          }
        };
      }
    case UPDATE_EXPORTER_FOR_ALL_INVOICES:
      {
        const {
          invoiceId,
          payload,
          actorType
        } = action;
        return {
          ...state,
          invoice: {
            ...state.invoice,
            invoiceList: {
              ...state.invoice.invoiceList,
              [`${invoiceId}`]: {
                ...state.invoice.invoiceList[invoiceId],
                [`${actorType}`]: {
                  ...payload
                }
              }
            }
          }
        };
      }
    case CLEAR_FORM:
      {
        return initialState$u;
      }
    default:
      return state;
  }
}

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */
const initialState$t = {
  formLoaded: false,
  shipmentId: null,
  userType: null,
  newValue: null,
  setINPUTID: null,
  penClicked: null,
  fieldName: null,
  errorMessage: null
};
function FormReducer$1(state = initialState$t, action) {
  switch (action.type) {
    case undefined:
      {
        return Object.assign({}, state, {
          formLoaded: action.formLoaded,
          shipmentId: action.shipmentId,
          shipmentCountry: action.shipmentCountry,
          userType: action.userType,
          error: action.error
        });
      }
    case FORM_VALUES:
      {
        return Object.assign({}, state, {
          newValue: action.newValue,
          setINPUTID: action.setINPUTID,
          penClicked: action.penClicked,
          fieldName: action.fieldName,
          rbCounterID: action.rbCounterID
        });
      }
    case SET_ANY_FORM_VALUES:
      {
        return Object.assign({}, state, {
          [action.valueName]: action.value
        });
      }
    case SET_ERROR_MESSAGE:
      {
        return Object.assign({}, state, {
          errorMessage: action.errorMessage
        });
      }
    default:
      return state;
  }
}

const initialState$s = {
  countryTypes: [],
  packageTypes: [],
  taxType: [],
  mop: [],
  previousDocumentsType: [],
  documentCategories: [],
  additionsAndDeductionsType: [],
  currencyTypes: [],
  procedure: [],
  additionalProcedure: [],
  documentStatusCode: [],
  unitAndQualifier: [],
  preference: [],
  valuationMethod: [],
  additionalInfoExportCodeDesc: [],
  additionalInfoDetails: [],
  additionalInfoImportCodeDesc: [],
  declarationCategories: [],
  declaration: []
};
function DropDownReducer$1(state = initialState$s, action) {
  switch (action.type) {
    case INITIALIZE_DROPDOWNS:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case 'CLEAR_DROPDOWN':
      {
        return initialState$s;
      }
    default:
      return state;
  }
}

const initialState$r = {
  shipmentNotesNodes: []
};
function NotesReducer$1(state = initialState$r, action) {
  switch (action.type) {
    case INITIALIZE_VALUES_NOTES:
      let newState = {
        ...state
      };
      newState.shipmentNotesNodes = action.payload.hasOwnProperty("shipmentNotesNodes") === true ? action.payload.shipmentNotesNodes : [];
      newState.notesLoaded = action.notesLoaded;
      return newState;
    case UPDATE_NOTES_ITEM_STATUS:
      {
        let newState = {
          ...state
        };
        newState.shipmentNotesNodes[action.index][action.field] = action.payload;
        return newState;
      }
    case "DONT_SHOW_NOTES_ITEM":
      {
        let newState = {
          ...state
        };
        newState.notesLoaded = action.value;
        return newState;
      }
    case ADD_NOTES_ITEM:
      {
        let newshipmentNotesNodes = state.shipmentNotesNodes.slice();
        if (action.payload) {
          newshipmentNotesNodes.unshift(action.payload);
        }
        return Object.assign({}, state, {
          shipmentNotesNodes: newshipmentNotesNodes
        });
      }
    default:
      return state;
  }
}

const initialState$q = {
  valueBuildUpList: []
};
const valueBuildUpReducer = (state = initialState$q, action) => {
  switch (action.type) {
    case INITIALIZE_VALUE_BUILD_UP_FORM:
      {
        const {
          valueBuildUpList
        } = action.payload;
        return {
          ...state,
          valueBuildUpList: valueBuildUpList || []
        };
      }
    case ADD_ITEM_VALUE_BUILD_UP$1:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], payload.valueBuildUp.valueBuildUpList[0]]
        };
      }
    case DELETE_ITEM_VALUE_BUILD_UP:
      {
        const {
          meta: {
            tableName
          },
          id
        } = action;
        let updatedData = state[tableName].filter(item => item.id != id);
        return {
          ...state,
          [`${tableName}`]: updatedData
        };
      }
    case UPDATE_ITEM_VALUE_BUILD_UP:
      {
        const {
          meta: {
            tableName
          },
          id,
          payload
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case UPDATE_INPUT_FILEDS:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    default:
      return {
        ...state
      };
  }
};

const ADD_ITEM_CONTAINER_TAB = "ADD_ITEM_CONTAINER_TAB";
const DELETE_ITEM_CONTAINER_TAB = "DELETE_ITEM_CONTAINER_TAB";
const UPDATE_ITEM_CONTAINER_TAB = "UPDATE_ITEM_CONTAINER_TAB";
const GET_ITEM_CONTAINER_TAB = "GET_ITEM_CONTAINER_TAB";
const HANDLE_LOADING_CONTAINER_TAB = "HANDLE_LOADING_CONTAINER_TAB";
const SAVE_FORM_CDS = "SAVE_FORM_CDS";
const ADD_ITEM_VALUE_BUILD_UP = "ADD_ITEM_VALUE_BUILD_UP";

var ActionTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ADD_ITEM_CONTAINER_TAB: ADD_ITEM_CONTAINER_TAB,
  DELETE_ITEM_CONTAINER_TAB: DELETE_ITEM_CONTAINER_TAB,
  UPDATE_ITEM_CONTAINER_TAB: UPDATE_ITEM_CONTAINER_TAB,
  GET_ITEM_CONTAINER_TAB: GET_ITEM_CONTAINER_TAB,
  HANDLE_LOADING_CONTAINER_TAB: HANDLE_LOADING_CONTAINER_TAB,
  SAVE_FORM_CDS: SAVE_FORM_CDS,
  ADD_ITEM_VALUE_BUILD_UP: ADD_ITEM_VALUE_BUILD_UP
});

const initialState$p = {
  containerList: []
};
function containerReducer$2(state = initialState$p, action) {
  switch (action.type) {
    case GET_ITEM_CONTAINER_TAB:
      {
        const {
          meta: {
            tableName
          },
          payload: {
            containerList
          }
        } = action;
        return {
          ...state,
          containerList: containerList || []
        };
      }
    case ADD_ITEM_CONTAINER_TAB:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[`${tableName}`], payload.container.containerList[0]]
        };
      }
    case DELETE_ITEM_CONTAINER_TAB:
      {
        const {
          meta: {
            tableName
          },
          id
        } = action;
        let table = state[tableName].filter(Item => Item.id != id);
        return {
          ...state,
          [`${tableName}`]: table
        };
      }
    case UPDATE_ITEM_CONTAINER_TAB:
      {
        const {
          meta: {
            tableName
          },
          id,
          payload
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    default:
      return {
        ...state
      };
  }
}

const getValidationError = (field, value, Level, onlyMandatoryCheck, fieldPatterns) => {
  if (value === "_BLANK_" || value == "-999" || value == " ") {
    value = "";
  }
  //let fieldPatterns = CDS_fieldPatterns;
  let fieldDetails = fieldPatterns[Level][field];
  let errors = [];
  if (onlyMandatoryCheck == true) {
    if (!value && !(fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional)) {
      errors.push(`${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
      return errors;
    }
    return false;
  }
  if (!value && !(fieldDetails !== null && fieldDetails !== void 0 && fieldDetails.optional)) {
    errors.push(`${fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName} is mandatory`);
    return errors;
  }
  if (fieldDetails && fieldDetails.pattern && !fieldDetails.pattern.test(value)) {
    errors.push(fieldDetails.fieldName + ' can only contain ' + fieldDetails.description + ' characters');
  } else {
    if (value && value.length > 0 && !(value.replace(/\./g, '').length >= fieldDetails.minLength && value.replace(/\./g, '').length <= fieldDetails.maxLength)) {
      let numberOdChars = fieldDetails.minLength === fieldDetails.maxLength ? fieldDetails.minLength : fieldDetails.minLength + ' to ' + fieldDetails.maxLength;
      errors.push('Length of ' + fieldDetails.fieldName + ' should be ' + numberOdChars + '.');
    }
  }
  return errors;
};

const lrn = {
  ...validationPatterns.V,
  optional: false,
  minLength: 1,
  maxLength: 22,
  fieldName: 'SHIPMENT NUMBER /LRN'
  // mandatory for all
};
const declaration = {
  ...validationPatterns.A,
  optional: false,
  minLength: 2,
  maxLength: 2,
  fieldName: 'DECLARATION'
  // mandatory for all
};
const declarationType = {
  ...validationPatterns.A,
  optional: false,
  minLength: 1,
  maxLength: 1,
  fieldName: 'DECLARATION TYPE'
  // mandatory for all
};
const ducr = {
  ...validationPatterns.V,
  optional: false,
  minLength: 1,
  maxLength: 45,
  fieldName: 'DUCR'
  // mandatory for all
};
const referenceNumber = {
  ...validationPatterns.V,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'REFERENCE NUMBER/UCR'
  // optional for all
};
const finalDestinationTransportCost = {
  ...validationPatterns.N16D2,
  optional: true,
  minLength: 1,
  maxLength: 19,
  fieldName: 'FINAL DESTINATION TRANSPORT COST'
  // optional for all
};
const ucn = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 19,
  fieldName: 'UCN'
  // optional for all
};
const dispatchCountry = {
  ...validationPatterns.A,
  optional: true,
  minLength: 2,
  maxLength: 2,
  fieldName: 'DISPATCH COUNTRY'
};
const countryOfDestination = {
  ...validationPatterns.A,
  optional: true,
  minLength: 2,
  maxLength: 2,
  fieldName: 'COUNTRY OF DESTINATION'
};
const locationOfGoods = {
  optional: false,
  minLength: 1,
  maxLength: 50,
  fieldName: 'LOCATION OF GOODS'
};
const arrivalTransportIDNumber = {
  ...validationPatterns.ATN,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'ARRIVAL TRANSPORT NUMBER'
};
const container = {
  ...validationPatterns.N,
  optional: false,
  minLength: 1,
  maxLength: 1,
  fieldName: 'CONTAINER INDICATOR'
};
const borderTransportNationality = {
  ...validationPatterns.A,
  optional: true,
  minLength: 2,
  maxLength: 2,
  fieldName: 'BORDER TRANSPORT NATIONALITY'
};
const borderTransportMode = {
  ...validationPatterns.N,
  optional: false,
  minLength: 1,
  maxLength: 1,
  fieldName: 'BORDER TRANSPORT MODE'
};

// const supervisingCustomOffice = {
//   ...validationPatterns.AN,
//   optional: false,
//   minLength: 8,
//   maxLength: 8,
//   fieldName: 'SUPERVISING CUSTOMS OFFICE'

// }

const natureOfTransaction = {
  ...validationPatterns.N,
  optional: true,
  minLength: 1,
  maxLength: 2,
  fieldName: 'NATURE OF TRANSACTION'
};
const wareHouseId = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'WAREHOUSE ID'
};
const countryAndLocation = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 37,
  fieldName: 'LOCATION AND COUNTRY'
};
const declarationPreviousDocCode = {
  ...validationPatterns.A,
  optional: true,
  minLength: 1,
  maxLength: 1,
  fieldName: 'DOC CATEGORY'
};
const declarationPreviousDocType = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 3,
  fieldName: 'DOC TYPE'
};

// const goodsItemIdentifier = {
//   ...validationPatterns.NeverBeZero,
//   optional: true,
//   minLength: 1,
//   maxLength: 3,
//   fieldName: 'GOODS ITEM IDENTIFIER'

// }

const exportername = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'EXPORTER NAME'
};
const exportereoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'EXPORTER EORI NUMBER'
};
const exporterpostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'EXPORTER POSTAL CODE'
};
const importername = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'IMPPORTER NAME'
};
const importereoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'IMPPORTER EORI NUMBER'
};
const importerpostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'IMPPORTER POSTAL CODE'
};
const declarantname = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'DECLARENT NAME'
};
const declaranteoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'DECLARENT EORI NUMBER'
};
const declarantpostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'DECLARENT POSTAL CODE'
};
const eidrEoriNumber = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'EIDR EORI NUMBER'
};
const sellername = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'SELLER NAME'
};
const sellereoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'SELLER EORI NUMBER'
};
const sellerpostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'SELLER POSTAL CODE'
};
const sellercontactname = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT NAME'
};
const sellercontactemail = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT EMAIL'
};
const sellercontactphone = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT PHONE'
};
const buyername = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'BUYER NAME'
};
const buyereoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'BUYER EORI NUMBER'
};
const buyerpostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'BUYER POSTAL CODE'
};
const buyercontactname = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT NAME'
};
const buyercontactemail = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT EMAIL'
};
const buyercontactphone = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'CONTACT PHONE'
};
const representativename = {
  ...validationPatterns.P,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'REPRESENTATIVE NAME'
};
const representativeeoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'REPRESENTATIVE EORI NUMBER'
};
const representativepostalCode = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'REPRESENTATIVE POSTAL CODE'
};

// valueBuilUp 

const type = {
  ...validationPatterns.A,
  optional: true,
  minLength: 2,
  maxLength: 2,
  fieldName: 'TYPE/CODE'
};
const valueBuildUpListCurrency = {
  ...validationPatterns.A,
  optional: true,
  minLength: 3,
  maxLength: 3,
  fieldName: 'CURRENCY'
};
const value = {
  ...validationPatterns.N16D2,
  optional: true,
  minLength: 1,
  maxLength: 19,
  fieldName: 'VALUE'
};
const containerNumber = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 18,
  fieldName: 'NUMBER'
};
const sealNumber = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 35,
  fieldName: 'SEAL NO.'
};
const guaranteeref = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 24,
  fieldName: 'GUARANTEE REFERENCE'
};
const guaranteeamount = {
  ...validationPatterns.N16D2,
  optional: true,
  minLength: 1,
  maxLength: 19,
  fieldName: 'GUARANTEE AMOUNT'
};
const authorizationeoriNo = {
  ...validationPatterns.AN,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'AUTHORIZATION IDENTIFICATION'
};

// itemsTab

// const invoiceNumber = {
//   ...validationPatterns.Alpha,
//   optional: true,
//   minLength: 1,
//   maxLength: 17,
//   fieldName: 'INVOICE NUMBER'
// }

const currency = {
  ...validationPatterns.Alpha,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'INVOICE CURRENCY'
};
const eoriNo = {
  ...validationPatterns.Alpha,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'IDENTIFICATION'
};
const totalInvoices = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'TOTAL INVOICES'
};
const totalItems = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'TOTAL ITEMS'
};
const totalInvoiceAmount = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'TOTAL INVOICE AMOUNT'
};
const totalGrossMass = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'TOTAL GROSS MASS'
};
const exchangeRate = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'EXCHANGE RATE'
};
const invoiceNumber = {
  ...validationPatterns.Alpha,
  optional: true,
  minLength: 1,
  maxLength: 17,
  fieldName: 'INVOICE NUMBER'
};
const commercialDescription = {
  ...validationPatterns.Alpha,
  optional: false,
  minLength: 1,
  maxLength: 512,
  fieldName: 'DESCRIPTION OF GOODS'
};
const sku = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'SKU/PART'
};
const euAdditionalCode = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'EU ADDITIONAL CODE'
};
const ukAdditionalCode = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 1,
  maxLength: 17,
  fieldName: 'UK ADDITIONAL CODE'
};
const destinationCountry = {
  ...validationPatterns.A,
  optional: true,
  minLength: 5,
  maxLength: 5,
  fieldName: 'DESTINATION COUNTRY'
};
const preference = {
  ...validationPatterns.N,
  optional: false,
  minLength: 3,
  maxLength: 3,
  fieldName: 'PREFERENCE'
};
const packageCount = {
  ...validationPatterns.N,
  optional: false,
  minLength: 1,
  maxLength: 8,
  fieldName: 'NUMBER OF PACKAGES'
};
const packageType = {
  ...validationPatterns.AN,
  optional: false,
  minLength: 2,
  maxLength: 2,
  fieldName: 'TYPE OF PACKAGES'
};
const grossMass = {
  ...validationPatterns.N16D6,
  optional: false,
  minLength: 1,
  maxLength: 23,
  fieldName: 'GROSS MASS'
};
const netMass = {
  ...validationPatterns.N16D6,
  optional: false,
  minLength: 1,
  maxLength: 23,
  fieldName: 'NET MASS'
};
const shippingMarks = {
  ...validationPatterns.Alpha,
  optional: false,
  minLength: 1,
  maxLength: 512,
  fieldName: 'SHIPPING MARKS'
};
const valuationMethod = {
  ...validationPatterns.N,
  optional: false,
  minLength: 1,
  maxLength: 1,
  fieldName: 'VALUATION METHOD'
};
const procedures = {
  ...validationPatterns.N,
  optional: false,
  minLength: 4,
  maxLength: 4,
  fieldName: 'PROCEDURE'
};
const fieldPattern = {
  H1: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      destinationCountry: {
        ...destinationCountry
      },
      preference: {
        ...preference
      },
      packageCount: {
        ...packageCount
      },
      packageType: {
        ...packageType
      },
      grossMass: {
        ...grossMass
      },
      netMass: {
        ...netMass
      },
      shippingMarks: {
        ...shippingMarks
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      }
    }
  },
  H2: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      destinationCountry: {
        ...destinationCountry
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      preference: {
        ...validationPatterns.N,
        optional: true,
        minLength: 3,
        maxLength: 3,
        fieldName: 'PREFERENCE'
      },
      packageCount: {
        ...packageCount
      },
      packageType: {
        ...packageType
      },
      grossMass: {
        ...grossMass
      },
      netMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'NET MASS'
      },
      shippingMarks: {
        ...shippingMarks
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      }
    }
  },
  H3: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      }

      //goodsItemIdentifier:{...goodsItemIdentifier},
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      destinationCountry: {
        ...destinationCountry
      },
      preference: {
        ...preference
      },
      packageCount: {
        ...packageCount
      },
      packageType: {
        ...packageType
      },
      grossMass: {
        ...grossMass
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      netMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'NET MASS'
      },
      shippingMarks: {
        ...shippingMarks
      },
      valuationMethod: {
        ...valuationMethod
      },
      procedures: {
        ...procedures
      }
    }
  },
  H4: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      destinationCountry: {
        ...destinationCountry
      },
      preference: {
        ...preference
      },
      packageCount: {
        ...packageCount
      },
      packageType: {
        ...packageType
      },
      grossMass: {
        ...grossMass
      },
      netMass: {
        ...netMass
      },
      shippingMarks: {
        ...shippingMarks
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      }
    }
  },
  H5: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      destinationCountry: {
        ...destinationCountry
      },
      preference: {
        ...preference
      },
      packageCount: {
        ...packageCount
      },
      packageType: {
        ...packageType
      },
      grossMass: {
        ...grossMass
      },
      netMass: {
        ...netMass
      },
      shippingMarks: {
        ...shippingMarks
      },
      valuationMethod: {
        ...valuationMethod
      },
      natureOfTransaction: {
        ...natureOfTransaction
      },
      procedures: {
        ...procedures
      }
    }
  },
  H7: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'DISPATCH COUNTRY'
      },
      destinationCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 5,
        maxLength: 5,
        fieldName: 'DESTINATION COUNTRY'
      },
      preference: {
        ...validationPatterns.N,
        optional: true,
        minLength: 3,
        maxLength: 3,
        fieldName: 'PREFERENCE'
      },
      packageCount: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 8,
        fieldName: 'NUMBER OF PACKAGES'
      },
      packageType: {
        ...validationPatterns.AN,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'TYPE OF PACKAGES'
      },
      grossMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'GROSS MASS'
      },
      netMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'NET MASS'
      },
      shippingMarks: {
        ...validationPatterns.Alpha,
        optional: true,
        minLength: 1,
        maxLength: 512,
        fieldName: 'SHIPPING MARKS'
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      }
    }
  },
  I1CF: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'DISPATCH COUNTRY'
      },
      destinationCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 5,
        maxLength: 5,
        fieldName: 'DESTINATION COUNTRY'
      },
      preference: {
        ...validationPatterns.N,
        optional: true,
        minLength: 3,
        maxLength: 3,
        fieldName: 'PREFERENCE'
      },
      packageCount: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 8,
        fieldName: 'NUMBER OF PACKAGES'
      },
      packageType: {
        ...validationPatterns.AN,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'TYPE OF PACKAGES'
      },
      grossMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'GROSS MASS'
      },
      netMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'NET MASS'
      },
      shippingMarks: {
        ...validationPatterns.Alpha,
        optional: true,
        minLength: 1,
        maxLength: 512,
        fieldName: 'SHIPPING MARKS'
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      }
    }
  },
  I1BE: {
    headerTab: {
      lrn: {
        ...lrn
      },
      declaration: {
        ...declaration
      },
      declarationType: {
        ...declarationType
      },
      ducr: {
        ...ducr
      },
      referenceNumber: {
        ...referenceNumber
      },
      finalDestinationTransportCost: {
        ...finalDestinationTransportCost
      },
      ucn: {
        ...ucn
      },
      dispatchCountry: {
        ...dispatchCountry
      },
      countryOfDestination: {
        ...countryOfDestination
      },
      locationOfGoods: {
        ...locationOfGoods
      },
      arrivalTransportIDNumber: {
        ...arrivalTransportIDNumber
      },
      container: {
        ...container
      },
      borderTransportNationality: {
        ...borderTransportNationality
      },
      borderTransportMode: {
        ...borderTransportMode
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      },
      wareHouseId: {
        ...wareHouseId
      },
      countryAndLocation: {
        ...countryAndLocation
      },
      declarationPreviousDocCode: {
        ...declarationPreviousDocCode
      },
      declarationPreviousDocType: {
        ...declarationPreviousDocType
      }

      //goodsItemIdentifier:{...goodsItemIdentifier}
    },
    partiesTab: {
      exportername: {
        ...exportername
      },
      exportereoriNo: {
        ...exportereoriNo
      },
      exporterpostalCode: {
        ...exporterpostalCode
      },
      importername: {
        ...importername
      },
      importereoriNo: {
        ...importereoriNo
      },
      importerpostalCode: {
        ...importerpostalCode
      },
      declarantname: {
        ...declarantname
      },
      declaranteoriNo: {
        ...declaranteoriNo
      },
      declarantpostalCode: {
        ...declarantpostalCode
      },
      eidrEoriNumber: {
        ...eidrEoriNumber
      },
      sellername: {
        ...sellername
      },
      sellereoriNo: {
        ...sellereoriNo
      },
      sellerpostalCode: {
        ...sellerpostalCode
      },
      sellercontactname: {
        ...sellercontactname
      },
      sellercontactemail: {
        ...sellercontactemail
      },
      sellercontactphone: {
        ...sellercontactphone
      },
      buyername: {
        ...buyername
      },
      buyereoriNo: {
        ...buyereoriNo
      },
      buyerpostalCode: {
        ...buyerpostalCode
      },
      buyercontactname: {
        ...buyercontactname
      },
      buyercontactemail: {
        ...buyercontactemail
      },
      buyercontactphone: {
        ...buyercontactphone
      },
      representativename: {
        ...representativename
      },
      representativeeoriNo: {
        ...representativeeoriNo
      },
      representativepostalCode: {
        ...representativepostalCode
      },
      guaranteeref: {
        ...guaranteeref
      },
      guaranteeamount: {
        ...guaranteeamount
      },
      authorizationeoriNo: {
        ...authorizationeoriNo
      }
    },
    valueBuildUpTab: {
      type: {
        ...type
      },
      valueBuildUpListCurrency: {
        ...valueBuildUpListCurrency
      },
      value: {
        ...value
      }
    },
    containersTab: {
      containerNumber: {
        ...containerNumber
      },
      sealNumber: {
        ...sealNumber
      }
    },
    itemsTab: {
      invoiceNumber: {
        ...invoiceNumber
      },
      currency: {
        ...currency
      },
      ukAdditionalCode: {
        ...ukAdditionalCode
      },
      euAdditionalCode: {
        ...euAdditionalCode
      },
      sku: {
        ...sku
      },
      commercialDescription: {
        ...commercialDescription
      },
      exchangeRate: {
        ...exchangeRate
      },
      totalGrossMass: {
        ...totalGrossMass
      },
      totalInvoiceAmount: {
        ...totalInvoiceAmount
      },
      totalItems: {
        ...totalItems
      },
      totalInvoices: {
        ...totalInvoices
      },
      eoriNo: {
        ...eoriNo
      },
      dispatchCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'DISPATCH COUNTRY'
      },
      destinationCountry: {
        ...validationPatterns.A,
        optional: true,
        minLength: 5,
        maxLength: 5,
        fieldName: 'DESTINATION COUNTRY'
      },
      preference: {
        ...validationPatterns.N,
        optional: true,
        minLength: 3,
        maxLength: 3,
        fieldName: 'PREFERENCE'
      },
      packageCount: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 8,
        fieldName: 'NUMBER OF PACKAGES'
      },
      packageType: {
        ...validationPatterns.AN,
        optional: true,
        minLength: 2,
        maxLength: 2,
        fieldName: 'TYPE OF PACKAGES'
      },
      grossMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'GROSS MASS'
      },
      netMass: {
        ...validationPatterns.N16D6,
        optional: true,
        minLength: 1,
        maxLength: 23,
        fieldName: 'NET MASS'
      },
      shippingMarks: {
        ...validationPatterns.Alpha,
        optional: true,
        minLength: 1,
        maxLength: 512,
        fieldName: 'SHIPPING MARKS'
      },
      valuationMethod: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 1,
        fieldName: 'VALUATION METHOD'
      },
      procedures: {
        ...procedures
      },
      natureOfTransaction: {
        ...validationPatterns.N,
        optional: true,
        minLength: 1,
        maxLength: 2,
        fieldName: 'NATURE OF TRANSACTION'
      }
    }
  }
};
const validation = (documentCat = '', Level) => {
  if (!documentCat || (documentCat === null || documentCat === void 0 ? void 0 : documentCat.trim().replace('&', '').replaceAll(' ', '').length) < 1 || window.currentServicetype === "EX") return () => [];
  const fieldPattern1 = fieldPattern[documentCat];
  return (field, value, onlyMandatoryCheck = false) => {
    return getValidationError(field, value, Level, onlyMandatoryCheck, fieldPattern1);
  };
};

const convertedDataHeaderTab = value => {
  let obj = {
    lrn: lodash_2(value, 'lrn', ''),
    referenceNumber: lodash_2(value, 'referenceNumber', ''),
    finalDestinationTransportCost: lodash_2(value, 'finalDestinationTransportCost', ''),
    declaration: lodash_2(value, 'declaration', ''),
    declarationType: lodash_2(value, 'declarationType', ''),
    ducr: lodash_2(value, 'ducr', ''),
    ucn: lodash_2(value, 'ucn', ''),
    dispatchCountry: lodash_2(value, 'transportation.dispatchCountry', ''),
    countryOfDestination: lodash_2(value, 'transportation.countryOfDestination', ''),
    locationOfGoods: lodash_2(value, 'transportation.locationOfGoods', ''),
    arrivalTransport: lodash_2(value, 'transportation.transport.idType', ''),
    arrivalTransportIDNumber: lodash_2(value, 'transportation.transport.IDNumber', ''),
    container: lodash_2(value, 'transportation.container', ''),
    borderTransportMode: lodash_2(value, 'transportation.transport.borderTransportMode', ''),
    natureOfTransaction: lodash_2(value, 'transportation.natureOfTransaction', '')
  };
  return obj;
};
const createHeaderTabWarningsList = (headerElements, level, declarationCat, badge) => {
  let errors = [];
  if (!headerElements || !declarationCat) {
    return [];
  }
  let headerPattern = Object.entries(fieldPattern[declarationCat][level]);
  let onlyMandatoryValues = ["dispatchCountry", "countryOfDestination", "declarationType", "transportation.locationOfGoods", "transportation.arrivalTransport.idType", "container", "borderTransportMode", "natureOfTransaction"];
  headerPattern.map(item => {
    let fieldName = item[0];
    let pattern = declarationCat ? fieldPattern[declarationCat] : {};
    let err = onlyMandatoryValues.includes(fieldName) ? getValidationError(fieldName, headerElements[fieldName], level, true, pattern) : getValidationError(fieldName, headerElements[fieldName], level, false, pattern);
    if (err[0]) {
      if (!badge && fieldName == "ucn") {
        return;
      }
      errors.push({
        fieldName: fieldName,
        msg: err + ' ' + '.'
      });
    }
  });
  return errors;
};

//partiesTab

const convertedDataPartiesTab = value => {
  let obj = {
    consigneeName: lodash_2(value, 'consignee.name', ''),
    consignorName: lodash_2(value, 'consignor.name', ''),
    brokerName: lodash_2(value, 'broker.name', ''),
    consigneeexternalIdentification: lodash_2(value, 'consignee.externalIdentification', ''),
    consignorexternalIdentification: lodash_2(value, 'consignor.externalIdentification', ''),
    brokerexternalIdentification: lodash_2(value, 'broker.externalIdentification', ''),
    consigneeAddress: lodash_2(value, 'consignee.streetName', ''),
    consignorAddress: lodash_2(value, 'consignor.streetName', ''),
    brokerAddress: lodash_2(value, 'broker.streetName', ''),
    consignorAddressLine2: lodash_2(value, 'consignor.address2', ''),
    consigneeAddressLine2: lodash_2(value, 'consignee.address2', ''),
    brokerAddressLine2: lodash_2(value, 'broker.address2', ''),
    consignorCity: lodash_2(value, 'consignor.city', ''),
    consigneeCity: lodash_2(value, 'consignee.city', ''),
    brokerCity: lodash_2(value, 'broker.city', ''),
    consignorState: lodash_2(value, 'consignor.state', ''),
    consigneeState: lodash_2(value, 'consignee.state', ''),
    brokerState: lodash_2(value, 'broker.state', ''),
    consignorPostalCode: lodash_2(value, 'consignor.postalCode', ''),
    consigneePostalCode: lodash_2(value, 'consignee.postalCode', ''),
    brokerPostalCode: lodash_2(value, 'broker.postalCode', ''),
    consignorCountry: lodash_2(value, 'consignor.countryCode', ''),
    consigneeCountry: lodash_2(value, 'consignee.countryCode', ''),
    brokerCountry: lodash_2(value, 'broker.countryCode', ''),
    warrantyReferences: lodash_2(value, 'warranties.warrantyReferences', ''),
    buyerName: lodash_2(value, 'buyer.name', ''),
    sellerName: lodash_2(value, 'seller.name', ''),
    buyerexternalIdentification: lodash_2(value, 'buyer.externalIdentification', ''),
    sellerexternalIdentification: lodash_2(value, 'seller.externalIdentification', ''),
    buyerAddress: lodash_2(value, 'buyer.streetName', ''),
    sellerAddress: lodash_2(value, 'seller.streetName', ''),
    buyerAddressLine2: lodash_2(value, 'buyer.address2', ''),
    sellerAddressLine2: lodash_2(value, 'seller.address2', ''),
    buyerCity: lodash_2(value, 'buyer.city', ''),
    sellerCity: lodash_2(value, 'seller.city', ''),
    sellerState: lodash_2(value, 'seller.state', ''),
    buyerState: lodash_2(value, 'buyer.state', ''),
    buyerPostalCode: lodash_2(value, 'buyer.postalCode', ''),
    sellerPostalCode: lodash_2(value, 'seller.postalCode', ''),
    brokerFormOfRepresentation: lodash_2(value, 'broker.formOfRepresentation', ''),
    //need additional changes
    guaranteeref: lodash_2(value, 'parties.guarantee[0].ref', ''),
    guaranteeamount: lodash_2(value, 'parties.guarantee[0].amount', ''),
    eidrEoriNumber: lodash_2(value, 'header.eidrEoriNumber', ''),
    authorizationeoriNo: lodash_2(value, 'parties.authorization[0].eoriNo', '')
  };
  return obj;
};
const createPartiesTabWarningsList = (headerElements, level, declarationCat) => {
  let errors = [];
  if (!headerElements || !declarationCat) {
    return [];
  }
  let headerPattern = Object.entries(fieldPattern[declarationCat][level]);
  let onlyMandatoryValues = [];
  headerPattern.map(item => {
    let fieldName = item[0];
    let err = onlyMandatoryValues.includes(fieldName) ? getValidationError(fieldName, headerElements[fieldName], level, true, fieldPattern[declarationCat]) : getValidationError(fieldName, headerElements[fieldName], level, false, fieldPattern[declarationCat]);
    if (err[0]) {
      errors.push({
        fieldName: fieldName,
        msg: err + ' ' + '.'
      });
    }
  });
  return errors;
};

// containersTab
const containersKeys = ["containerNumber", "sealNumber"];

// valueBuildUpTabTab
const valueBuildUpKeys = ["type", "value"];
const getMultipleFieldsInfo = (value, keys, keyName, level, declarationCat) => {
  let errors = [];
  keys.map(item => {
    let errrs = getMultipleErrors(`${item}`, value, keyName, level, declarationCat);
    if (errrs && errrs.length > 0) {
      errors = [...errors, errrs];
    }
  });
  return errors.flat();
};
const getMultipleErrors = (fieldName, payload, key, level, declarationCat) => {
  if (!declarationCat) {
    return ["Declaration Category required."];
  }
  let errors = [];
  let arrayMap = payload[`${key}`];
  if (arrayMap) {
    for (let i = 0; i < arrayMap.length; i++) {
      let err = getValidationError(fieldName, arrayMap[i][`${fieldName}`] || "", level, false, fieldPattern[declarationCat]);
      if (err[0]) {
        errors.push({
          fieldName: fieldName + arrayMap[i].id,
          msg: err
        });
      }
    }
  }
  return errors;
};

// iTemsTAb

const invoiceFieldsKeys = ['invoiceNumber'];
const merchandiseFieldsKeys = ['commercialDescription', 'dispatchCountry', 'destinationCountry', 'preference', 'packageCount', 'packageType', 'grossMass', 'netMass', 'valuationMethod', 'procedures', 'natureOfTransaction'];
const onlyMandatoryValues = ["dispatchCountry", "destinationCountry", "preference", "procedures"];
const convertedDataItemsTab = (value, declarationCat) => {
  let invoices = value.invoiceList;
  let errors = [];
  value.invoiceIds && value.invoiceIds.map((items, index) => {
    invoiceFieldsKeys.map(item => {
      let err = getValidationError(`${item}`, invoices[items]["header"][item] || '', 'itemsTab', false, fieldPattern[declarationCat]) || [];
      (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
        fieldName: `${item}-${items}`,
        msg: `invoice -00${index + 1}` + ' :: ' + err[0]
      });
    });
    if (value.invoiceList && value.invoiceList[items] && value.invoiceList[items].merchandiseIds) {
      value.invoiceList[items].merchandiseIds.map((merchId, ix) => {
        // let merch = value.merchandise

        merchandiseFieldsKeys.map(merchKey => {
          if (onlyMandatoryValues.includes(merchKey)) {
            let err = getValidationError(`${merchKey}`, value.merchandise[merchId][merchKey] || '', 'itemsTab', true, fieldPattern[declarationCat]) || [];
            (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
              fieldName: `${merchKey}-${merchId}`,
              msg: `invoice -00${index + 1} :: line ${ix + 1}` + ' :: ' + err[0]
            });
            return;
          }
          let err = getValidationError(`${merchKey}`, value.merchandise[merchId][merchKey] || '', 'itemsTab', false, fieldPattern[declarationCat]) || [];
          (err === null || err === void 0 ? void 0 : err.length) && err[0] !== 'undefined is mandatory' && errors.push({
            fieldName: `${merchKey}-${merchId}`,
            msg: `invoice -00${index + 1} :: line ${ix + 1}` + ' :: ' + err[0]
          });
        });
      });
    }
  });
  return errors;
};

const initialState$o = {
  headerTab: [],
  partiesTab: [],
  itemsTab: [],
  valueBuildUpTab: [],
  containersTab: []
};
function ErrorValidationReducer(state = initialState$o, action) {
  switch (action.type) {
    // Header Tab
    case 'INIT_HEADER_TAB_WARNINGS':
      {
        var _action$payload;
        let newState = {
          ...state
        };
        const completeData = convertedDataHeaderTab((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.header);
        let finalPayload = createHeaderTabWarningsList(completeData, action.level, action.declarationCat, action.badge);
        newState[`${action.level}`] = finalPayload;
        return newState;
      }
    case 'ADD_HEADER_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState ? currentState.filter(item => item.fieldName !== currentFieldName) : [];
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case 'DELETE_HEADER_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    //partiesTab

    case 'INIT_PARTIES_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        const completeData = convertedDataPartiesTab(action.payload);
        let finalPayload = createPartiesTabWarningsList(completeData, action.level, action.declarationCat);
        newState[`${action.level}`] = finalPayload;
        return newState;
      }
    case 'ADD_PARTIES_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState.filter(item => item.fieldName !== currentFieldName);
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case 'DELETE_PARTIES_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    // valueBuildUp reducer

    case 'INIT_VALUEBUILDUP_TAB_WARNINGS':
      {
        var _action$payload2;
        let newState = {
          ...state
        };
        let finalPayload = getMultipleFieldsInfo((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.valueBuildUp, valueBuildUpKeys, "valueBuildUpList", "valueBuildUpTab", action.declarationCat);
        newState[`${action.level}`] = finalPayload;
        return newState;
      }
    case 'ADD_VALUEBUILDUP_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState ? currentState.filter(item => item.fieldName !== currentFieldName) : [];
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case 'DELETE_VALUEBUILDUP_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    // containersTab

    case 'INIT_CONTAINER_TAB_WARNINGS':
      {
        var _action$payload3;
        let newState = {
          ...state
        };
        let finalPayload = getMultipleFieldsInfo((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.container, containersKeys, "containerList", "containersTab", action.declarationCat);
        newState[`${action.level}`] = finalPayload;
        return newState;
      }
    case 'ADD_CONTAINER_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState ? currentState.filter(item => item.fieldName !== currentFieldName) : [];
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case 'DELETE_CONTAINER_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }

    // itemsTab

    case 'INIT_ITEMS_TAB_WARNINGS':
      {
        var _action$payload4;
        let newState = {
          ...state
        };
        const completeData = convertedDataItemsTab((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.invoice, action.declarationCat);
        // let finalPayload = createHeaderTabWarningsList(completeData, action.level, action.declarationCat,action.badge) 
        newState[`${action.level}`] = completeData;
        return newState;
      }
    case 'ADD_ITEMS_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentErrorValue = action.value;
        let currentFieldName = action.fieldName;
        let currentState = state[`${action.level}`];
        let filteredState = currentState ? currentState.filter(item => item.fieldName !== currentFieldName) : [];
        let newUpdatedState = [...filteredState, {
          fieldName: currentFieldName,
          msg: currentErrorValue
        }];
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case 'DELETE_ITEMS_TAB_WARNINGS':
      {
        let newState = {
          ...state
        };
        let currentFieldName = action.fieldName;
        let newUpdatedState = state[`${action.level}`] && state[`${action.level}`].filter(item => item.fieldName !== currentFieldName);
        newState[`${action.level}`] = newUpdatedState;
        return newState;
      }
    case CLEAR_FORM:
      {
        return {
          ...initialState$o
        };
      }
    default:
      return state;
  }
}

const initialState$n = {
  header: {},
  parties: {},
  items: {},
  valueBuildUp: {},
  containers: {}
};
const errorReducer = (state = initialState$n, action) => {
  switch (action.type) {
    case INIT_VALIDATION_ERRORS$1:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_VALIDATION_ERRORS$1:
      {
        const {
          tabName,
          payload
        } = action;
        let errors = {
          ...state[tabName],
          ...payload
        };
        errors = Object.fromEntries(Object.entries(errors).filter(([_, v]) => v === null || v === void 0 ? void 0 : v.msg));
        return {
          ...state,
          [tabName]: {
            ...errors
          }
        };
      }
    case CLEAR_FORM$2:
      {
        return initialState$n;
      }
    default:
      return state;
  }
};

const initialState$m = {
  header: [],
  parties: [],
  items: [],
  valueBuildup: []
};
function serverErrorReducerCommon(state = initialState$m, action) {
  switch (action.type) {
    case "INITIALIZE_SERVER_ERRORS_TREE":
      {
        const {
          payload
        } = action;
        return {
          ...state,
          ...payload
        };
      }
    case 'RESET_SERVER_ERRORS':
      {
        return initialState$m;
      }
    default:
      return state;
  }
}

function createReducer$2(asyncReducers) {
  return redux.combineReducers({
    Actor: ActorReducer$1,
    Shipment: ShipmentReducer$1,
    FormValues: FormReducer$1,
    DropDownValues: DropDownReducer$1,
    InvoicesReducer: InvoicesReducer$1,
    NotesReducer: NotesReducer$1,
    Billings: BillingReducer,
    containerReducer: containerReducer$2,
    valueBuildUpReducer: valueBuildUpReducer,
    ErrorValidationReducer: ErrorValidationReducer,
    ValidationErrors: errorReducer,
    serverErrorReducerCommon,
    ServerErrorReducer,
    ...asyncReducers
  });
}

const composeEnhancers$1 = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : redux.compose;
const middleware$1 = [thunkMiddleware__default["default"]];

// process.env.NODE_ENV !== 'production' && middleware.push(logger)

const enhancer$1 = composeEnhancers$1(redux.applyMiddleware(...middleware$1)
// other store enhancers if any
);
// const store = createStore(rootReducer, enhancer)

function configureStore$2() {
  const store = redux.createStore(createReducer$2(), enhancer$1);
  store.asyncReducers = {};
  return store;
}
var store$3 = configureStore$2();

const initalizeActorValues = {
  name: "",
  addressLine1: "",
  city: "",
  state: "",
  postalCode: "",
  country: ""
};
const actorList = {
  consignee: {},
  declarant: {},
  consignor: {},
  agent: {},
  exporter: {},
  importer: {},
  surety: {},
  carrier: {},
  fiscal: {},
  buyer: {},
  seller: {}
};

const initialState$l = {
  ...actorList,
  authorization: [],
  additionalSupplyChainActor: [],
  paymentList: [],
  guaranteeDetails: [],
  additonalGuaranteeDetails: [],
  copyToconsignor: {
    exporter: false,
    declarant: false
  },
  copyToconsignee: {
    buyer: false,
    importer: false,
    declarant: false,
    surety: false
  }
};
function ActorReducer(state = initialState$l, action) {
  switch (action.type) {
    case INITIALIZE_PARTIES_FORM$1:
      {
        for (let actor in actorList) {
          var _$get$concat;
          if (action.payload[actor]) action.payload[actor].addressLine1 = (_$get$concat = _.get(action.payload[actor], 'streetNumber', '').concat(" ", _.get(action.payload[actor], 'streetName', ''))) === null || _$get$concat === void 0 ? void 0 : _$get$concat.trim();
        }
        return {
          ...state,
          ...action.payload
        };
      }
    case UPDATE_ACTOR_FIELD_VALUE$1:
      {
        const {
          actorType,
          payload
        } = action;
        return {
          ...state,
          [`${actorType}`]: {
            ...state[actorType],
            ...payload
          }
        };
      }
    case UPDATE_ACTOR_CONTACT_INFO$1:
      {
        const {
          actorType,
          payload
        } = action;
        return {
          ...state,
          [`${actorType}`]: {
            ...state[actorType],
            contact: {
              ...state[actorType].contact,
              ...payload
            }
          }
        };
      }
    case ADD_ITEM_PARTIES$1:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], payload]
        };
      }
    case UPDATE_ITEM_PARTIES$1:
      {
        const {
          id,
          payload,
          meta: {
            tableName
          }
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case DELETE_ITEM_PARTIES$1:
      {
        const {
          id,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          [`${tableName}`]: state[tableName].filter(c => c.id != id)
        };
      }
    case ACTOR_COPIED_STATUS$1:
      {
        const {
          copyTo,
          copyFrom,
          isChecked
        } = action;
        const copyToLisT = Array.isArray(copyTo) ? copyTo : [copyTo];
        const updatedState = copyToLisT.reduce((prev, curr) => {
          return {
            ...prev,
            [`${curr}`]: isChecked
          };
        }, {});
        return {
          ...state,
          [`copyTo${copyFrom}`]: {
            ...state[`copyTo${copyFrom}`],
            ...updatedState
          }
        };
      }
    case COPY_ACTOR_INFO$1:
      {
        const {
          copyFrom,
          copyTo
        } = action;
        const selectedActor = state[`copyTo${copyFrom}`];
        const copyToLisT = copyTo ? [copyTo] : Object.keys(selectedActor).filter(key => selectedActor[key]); //Array.isArray(copyTo) ? copyTo:[copyTo]
        const {
          name,
          eoriNo,
          addressLine1,
          addressLine2,
          city,
          state: state1,
          postalCode,
          country
        } = state[copyFrom];
        const updatedState = copyToLisT.reduce((prev, curr) => {
          return {
            ...prev,
            [`${curr}`]: {
              ...state[`${curr}`],
              name,
              eoriNo,
              addressLine1,
              addressLine2,
              city,
              state: state1,
              postalCode,
              country
            }
          };
        }, {});
        return {
          ...state,
          ...updatedState
        };
      }
    case CLEAR_FORM$1:
      {
        return initialState$l;
      }
    default:
      return state;
  }
}

const initialState$k = {
  exitInfo: {},
  transportation: {
    goodsLocation: {},
    warehoueDetails: {},
    borderTransitMode: {},
    ArrivalTransitMode: {},
    departureTransitMode: {},
    tradeTerms: {}
  },
  itinerary: [],
  customsOffice: [],
  supportingDoc: [],
  prevDoc: [],
  exitInformation: [],
  additionalDoc: [],
  headerContainer: [],
  amendmentReason: []
};
function ShipmentReducer(state = initialState$k, action) {
  switch (action.type) {
    case INITIALIZE_HEADER_FORM$1:
      {
        const {
          exitInfo,
          transportation,
          supportingDoc,
          additionalDoc,
          prevDoc,
          ...rest
        } = action.payload;
        return {
          ...state,
          exitInfo: exitInfo,
          supportingDoc: supportingDoc || [],
          additionalDoc: additionalDoc || [],
          prevDoc: prevDoc || [],
          transportation: {
            ...state.transportation,
            ...transportation
          },
          ...rest
        };
      }
    case UPDATE_SHIPMENT_FIELD_VALUE$1:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          exitInfo: {
            ...state.exitInfo,
            ...payload
          }
        };
      }
    case ADD_ADDITONAL_INFO$1:
      {
        return {
          ...state,
          additionalInfos: [...state.additionalInfos, action.payload]
        };
      }
    case ADD_AI_CODES_AND_STATEMENT_INFO$1:
      {
        return {
          ...state,
          aiStatementUkInfo: [...state.aiStatementUkInfo, action.payload]
        };
      }
    case UPDATE_AI_STATEMENT_INFO_FIELDS$1:
      {
        const aiStatementUkInfoTemp = [...state.aiStatementUkInfo];
        aiStatementUkInfoTemp[action.infoIndex] = {
          ...aiStatementUkInfoTemp[action.infoIndex],
          [action.infoField]: action.payload
        };
        return {
          ...state,
          aiStatementUkInfo: aiStatementUkInfoTemp
        };
      }
    case DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$1:
      {
        let newState = {
          ...state
        };
        let additionalInfo = newState.aiStatementUkInfo.slice(0, action.infoIndex).concat(newState.aiStatementUkInfo.slice(action.infoIndex + 1));
        newState.aiStatementUkInfo = additionalInfo;
        return newState;
      }
    case ADD_ITEM_HEADER:
      {
        const {
          meta: {
            tableName
          },
          payload
        } = action;
        return {
          ...state,
          [`${tableName}`]: [...state[tableName], payload]
        };
      }
    case UPDATE_ITEM_HEADER$1:
      {
        const {
          id,
          payload,
          meta: {
            tableName
          }
        } = action;
        const index = state[tableName].findIndex(c => c.id == id);
        const temp = [...state[tableName]];
        temp[index] = {
          ...temp[index],
          ...payload
        };
        return {
          ...state,
          [`${tableName}`]: temp
        };
      }
    case DELETE_ITEM_HEADER$1:
      {
        const {
          id,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          [`${tableName}`]: state[tableName].filter(c => c.id != id)
        };
      }
    case UPDATE_ALL_ITEMS_HEADER:
      {
        const {
          payload,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          [`${tableName}`]: state[tableName].map(item => ({
            ...item,
            ...payload
          }))
        };
      }
    case UPDATE_TRANSPORT_DETAILS$1:
      {
        const {
          key,
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            [`${key}`]: {
              ...state.transportation[key],
              ...payload
            }
          }
        };
      }
    case UPDATE_TRANSPORT_HEADER_INFO$1:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            ...payload
          }
        };
      }
    case CLEAR_FORM$1:
      {
        return initialState$k;
      }
    // container Reducers

    case ADD_HEADER_CONTAINER:
      {
        const {
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            containers: [...state.transportation.containers, {
              id: payload
            }]
          }
        };
      }
    case DELETE_HEADER_CONTAINER:
      {
        const {
          id
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            containers: state.transportation.containers.filter(itm => itm.id !== id)
          }
        };
      }
    case UPDATE_HEADER_CONTAINER:
      {
        var _state$transportation, _state$transportation2;
        const {
          id,
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            containers: (state === null || state === void 0 ? void 0 : (_state$transportation = state.transportation) === null || _state$transportation === void 0 ? void 0 : (_state$transportation2 = _state$transportation.containers) === null || _state$transportation2 === void 0 ? void 0 : _state$transportation2.map(itm => (itm === null || itm === void 0 ? void 0 : itm.id) === id ? {
              ...itm,
              ...payload
            } : itm)) || []
          }
        };
      }
    case 'ADD_TRANSPORTATION_ITENARIES':
      {
        const {
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            itenaries: [...state.transportation.itenaries, payload]
          }
        };
      }
    case 'UPDATE_TRANSPORTATION_ITENARIES':
      {
        var _state$transportation3;
        const {
          id,
          payload
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            itenaries: (_state$transportation3 = state.transportation.itenaries) === null || _state$transportation3 === void 0 ? void 0 : _state$transportation3.map(itm => (itm === null || itm === void 0 ? void 0 : itm.id) === id ? {
              ...itm,
              ...payload
            } : itm)
          }
        };
      }
    case 'DELETE_TRANSPORTATION_ITENARIES':
      {
        var _state$transportation4;
        const {
          id
        } = action;
        return {
          ...state,
          transportation: {
            ...state.transportation,
            itenaries: (_state$transportation4 = state.transportation.itenaries) === null || _state$transportation4 === void 0 ? void 0 : _state$transportation4.filter(itm => (itm === null || itm === void 0 ? void 0 : itm.id) !== id)
          }
        };
      }
    default:
      return state;
  }
}

const getMerchandiseAndInvoiceData = data => {
  if (data !== null && data !== void 0 && data.length) {
    return data.reduce((prev, curr, currentIndex) => {
      const {
        lineItems = [],
        ...rest
      } = curr;
      return {
        invoices: [...prev.invoices, {
          ...rest,
          isChecked: false
        }],
        // isChecked property for mass update
        lineItems: {
          ...prev.lineItems,
          [`${rest.invoiceId}`]: lineItems.map(itm => ({
            ...itm,
            isChecked: false
          }))
        }
      };
    }, {
      invoices: [],
      lineItems: {}
    });
  } else {
    return {
      invoices: [],
      lineItems: {}
    };
  }
};
const getUpdatedMerchList = (invoiceIDs, lineItem, params) => {
  return Object.entries(lineItem).reduce((prev, [key, value]) => {
    if (invoiceIDs.includes(key)) {
      return {
        ...prev,
        [`${key}`]: value.map(merch => ({
          ...merch,
          ...params
        }))
      };
    }
    return {
      ...prev,
      [`${key}`]: value
    };
  }, {});
};
const initialState$j = {
  invoiceHeader: {},
  invoices: [],
  lineItems: {}
};
function InvoicesReducer(state = initialState$j, action) {
  switch (action.type) {
    case INITIALIZE_ITEMS_FORM$1:
      {
        let {
          invoiceHeader,
          invoices
        } = action.payload;
        let completeData = getMerchandiseAndInvoiceData(invoices);
        return {
          ...state,
          ...completeData,
          invoiceHeader
        };
      }
    case CREATE_INVOICE$1:
      {
        const {
          invoiceId
        } = action;
        return {
          ...state,
          invoices: [...state.invoices, {
            invoiceId,
            isChecked: false
          }],
          // isChecked property for mass update
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: []
          }
        };
      }
    case DELETE_INVOICE$1:
      {
        const {
          invoiceId
        } = action;
        delete state.lineItems[invoiceId];
        return {
          ...state,
          invoices: state.invoices.filter(c => c.invoiceId != invoiceId)
        };
      }
    case CREATE_MERCHANDISE_ITEM$1:
      {
        const {
          invoiceId,
          merchandiseId,
          additionalParams
        } = action;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: [...(state.lineItems[invoiceId] || []), {
              invoiceId,
              merchandiseId,
              ...additionalParams,
              isChecked: false
            }]
          }
        };
      }
    case DELETE_MERCHANDISE_ITEM$1:
      {
        const {
          invoiceId,
          merchandiseId
        } = action;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: state.lineItems[invoiceId].filter(c => c.merchandiseId != merchandiseId)
          }
        };
      }
    case UPDATE_INVOICE_DATA:
      {
        var _state$invoices;
        const {
          type,
          invoiceId,
          ...rest
        } = action;
        return {
          ...state,
          invoices: state === null || state === void 0 ? void 0 : (_state$invoices = state.invoices) === null || _state$invoices === void 0 ? void 0 : _state$invoices.map(itm => itm.invoiceId == invoiceId ? {
            ...itm,
            ...rest
          } : itm)
        };
      }
    case UPDATE_MERCH_DATA:
      {
        let {
          invoiceId,
          merchandiseId,
          payload
        } = action;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: state.lineItems[invoiceId].map(item => item.merchandiseId == merchandiseId ? {
              ...item,
              ...payload
            } : item)
          }
        };
      }
    case ADD_MERCHANDISE_DOC_BY_ID$1:
      {
        const {
          payload: {
            invoiceId,
            merchandiseId,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        // const updatedData = 
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: state.lineItems[invoiceId].map(item => item.merchandiseId == merchandiseId ? {
              ...item,
              [`${tableName}`]: [...(item[tableName] || []), rest]
            } : item)
          }
        };
      }
    case DELETE_MERCHANDISE_DOC_BY_ID$1:
      {
        const {
          payload: {
            invoiceId,
            merchandiseId,
            id
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: state.lineItems[invoiceId].map(item => item.merchandiseId == merchandiseId ? {
              ...item,
              [`${tableName}`]: item[tableName].filter(c => c.id != id)
            } : item)
          }
        };
      }
    case UPDATE_MERCHANDISE_DOC_BY_ID$1:
      {
        const {
          payload: {
            invoiceId,
            merchandiseId,
            id,
            ...rest
          },
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: state.lineItems[invoiceId].map(item => item.merchandiseId == merchandiseId ? {
              ...item,
              [`${tableName}`]: item[tableName].map(c => c.id == id ? {
                ...c,
                ...rest
              } : c)
            } : item)
          }
        };
      }
    case UPDATE_EXCHANGE_RATE_AND_EUR_VAL:
      {
        var _state$lineItems$invo;
        const {
          invoiceHeader: {
            totalValue = ''
          } = {},
          invoices: [{
            invoiceId = '',
            exchRate = '',
            lineItems = []
          }] = [{}]
        } = (action === null || action === void 0 ? void 0 : action.payload) || {};
        return {
          ...state,
          invoiceHeader: {
            ...state.invoiceHeader,
            totalValue
          },
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: (_state$lineItems$invo = state.lineItems[invoiceId]) === null || _state$lineItems$invo === void 0 ? void 0 : _state$lineItems$invo.map(item => {
              const {
                eurVal
              } = lineItems === null || lineItems === void 0 ? void 0 : lineItems.find(itm => (itm === null || itm === void 0 ? void 0 : itm.merchandiseId) == item.merchandiseId);
              return {
                ...item,
                exchRate,
                eurVal
              };
            })
          }
        };
      }
    case UPDATE_INVOICE_HEADER_VALUE:
      {
        return {
          ...state,
          invoiceHeader: {
            ...state.invoiceHeader,
            ...action.payload
          }
        };
      }
    case MASS_UPDATE_AT_INVOICE_LEVEL:
      {
        var _state$lineItems$invo2;
        const {
          invoiceId,
          merchandiseIDs = [],
          params
        } = action.payload;
        return {
          ...state,
          lineItems: {
            ...state.lineItems,
            [`${invoiceId}`]: (_state$lineItems$invo2 = state.lineItems[invoiceId]) === null || _state$lineItems$invo2 === void 0 ? void 0 : _state$lineItems$invo2.map(merch => {
              if (merchandiseIDs !== null && merchandiseIDs !== void 0 && merchandiseIDs.includes(merch.merchandiseId)) {
                return {
                  ...merch,
                  ...params
                };
              } else return merch;
            })
          }
        };
      }
    case MASS_UPDATE_FOR_MULTIPLE_INVOICE:
      {
        const {
          invoiceIDs = [],
          params
        } = action.payload;
        return {
          ...state,
          lineItems: getUpdatedMerchList(invoiceIDs, state.lineItems, params)
        };
      }
    case MASS_UPDATE_REPEATABLE_ELEMENTS:
      {
        const {
          payload,
          meta: {
            tableName
          }
        } = action;
        return {
          ...state,
          lineItems: Object.entries(state === null || state === void 0 ? void 0 : state.lineItems).reduce((prev, [key, val]) => {
            return {
              ...prev,
              [`${key}`]: val === null || val === void 0 ? void 0 : val.map(itm => {
                const temp = payload === null || payload === void 0 ? void 0 : payload.find(i => (i === null || i === void 0 ? void 0 : i.merchandiseId) === (itm === null || itm === void 0 ? void 0 : itm.merchandiseId));
                if (temp) {
                  return {
                    ...itm,
                    [tableName]: itm !== null && itm !== void 0 && itm[tableName] ? [...(itm === null || itm === void 0 ? void 0 : itm[tableName]), temp] : [temp]
                  };
                } else {
                  return itm;
                }
              })
            };
          }, {})
        };
      }
    case CLEAR_FORM$1:
      {
        return initialState$j;
      }
    default:
      return state;
  }
}

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */
const initialState$i = {
  formLoaded: false,
  shipmentId: null,
  userType: null,
  newValue: null,
  setINPUTID: null,
  penClicked: null,
  fieldName: null,
  errorMessage: null
};
function FormReducer(state = initialState$i, action) {
  switch (action.type) {
    case undefined:
      {
        return Object.assign({}, state, {
          formLoaded: action.formLoaded,
          shipmentId: action.shipmentId,
          shipmentCountry: action.shipmentCountry,
          userType: action.userType,
          error: action.error
        });
      }
    case FORM_VALUES$1:
      {
        return Object.assign({}, state, {
          newValue: action.newValue,
          setINPUTID: action.setINPUTID,
          penClicked: action.penClicked,
          fieldName: action.fieldName,
          rbCounterID: action.rbCounterID
        });
      }
    case SET_ANY_FORM_VALUES$1:
      {
        return Object.assign({}, state, {
          [action.valueName]: action.value
        });
      }
    case SET_ERROR_MESSAGE$1:
      {
        return Object.assign({}, state, {
          errorMessage: action.errorMessage
        });
      }
    default:
      return state;
  }
}

const initialState$h = {
  expProcedures: [],
  impProcedures: [],
  expDeclarations: [],
  impDeclarations: [],
  expDeclarationTypes: [],
  impDeclarationTypes: [],
  expTransmissionTypes: [],
  impTransmissionTypes: [],
  headerMOT: [],
  headerMOTTypes: [],
  MOTNationalities: [],
  incoTerms: [],
  expWaysOfPayment: [],
  exitInfo: [],
  prevDocTypes: [],
  locationTypes: [],
  wareHouseTypes: [],
  securities: [],
  CountryList008: [],
  CountryList010: [],
  CountryList199: [],
  CountryList208: [],
  currencyCodes: [],
  expOwner: [],
  impOwner: [],
  partiesAuthorisationRoles: [],
  valuationMethods: [],
  partiesGuaranteeType: [],
  partiesPaymentTypesDuties: [],
  partiesPaymentRolesVAT: [],
  partiesPaymentTypes: [],
  transactionNature: [],
  partiesGuaranteeOffices: [],
  supportingDocuments: [],
  additionalDocs: [],
  Representations: [],
  specialCircumstances: [],
  supplyChainOwnerImport: [],
  supplyChainOwnerExport: [],
  additionalSupplyChainRoles: [],
  expCustomOfficeTypes: [],
  impCustomOfficeTypes: [],
  reasonCodes: [],
  relationshipCodes: [],
  agsExpAddInfo: [],
  agsExpPrevDocument: [],
  addProcedure110: []
};
function DropDownReducer(state = initialState$h, action) {
  switch (action.type) {
    case INITIALIZE_DROPDOWNS$1:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    default:
      return state;
  }
}

const initialState$g = {
  shipmentNotesNodes: []
};
function NotesReducer(state = initialState$g, action) {
  switch (action.type) {
    case INITIALIZE_VALUES_NOTES$1:
      let newState = {
        ...state
      };
      newState.shipmentNotesNodes = action.payload.hasOwnProperty("shipmentNotesNodes") === true ? action.payload.shipmentNotesNodes : [];
      newState.notesLoaded = action.notesLoaded;
      return newState;
    case UPDATE_NOTES_ITEM_STATUS$1:
      {
        let newState = {
          ...state
        };
        newState.shipmentNotesNodes[action.index][action.field] = action.payload;
        return newState;
      }
    case "DONT_SHOW_NOTES_ITEM":
      {
        let newState = {
          ...state
        };
        newState.notesLoaded = action.value;
        return newState;
      }
    case ADD_NOTES_ITEM$1:
      {
        let newshipmentNotesNodes = state.shipmentNotesNodes.slice();
        if (action.payload) {
          newshipmentNotesNodes.unshift(action.payload);
        }
        return Object.assign({}, state, {
          shipmentNotesNodes: newshipmentNotesNodes
        });
      }
    default:
      return state;
  }
}

function createReducer$1(asyncReducers) {
  return redux.combineReducers({
    Actor: ActorReducer,
    Shipment: ShipmentReducer,
    FormValues: FormReducer,
    DropDownValues: DropDownReducer,
    InvoicesReducer: InvoicesReducer,
    NotesReducer: NotesReducer,
    ValueBuildUpReducer,
    ServerErrorReducer,
    ValidationErrors: errorReducer,
    ...asyncReducers
  });
}

const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : redux.compose;
const middleware = [thunkMiddleware__default["default"]];

// process.env.NODE_ENV !== 'production' && middleware.push(logger)

const enhancer = composeEnhancers(redux.applyMiddleware(...middleware)
// other store enhancers if any
);
// const store = createStore(rootReducer, enhancer)

function configureStore$1() {
  const store = redux.createStore(createReducer$1(), enhancer);
  store.asyncReducers = {};
  return store;
}
var store$2 = configureStore$1();

function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,t):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){var r;return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r);}function _$1(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s,v){if("production"!==process.env.NODE_ENV&&c===o&&n(5),r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1;}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_$1(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_$1()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1;}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return "production"!==process.env.NODE_ENV&&f(r),en.get(r,n)},set:function(r){var t=this[Q];"production"!==process.env.NODE_ENV&&f(t),en.set(t,n,r);}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t);}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return !0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return !0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return !0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return !0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return !0;return !1}function f(r){r.g&&n(3,JSON.stringify(p(r)));}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable);}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_$1(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)));})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t));}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l]);}}}}(n.p[0]),e(n.p));},K:function(n){return 4===n.i?o(n):a(n)}});}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(t))&&n(13),on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return "production"!==process.env.NODE_ENV&&"length"!==t&&isNaN(parseInt(t))&&n(14),en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?g(c):O(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l);}return f}n(21,r);},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r;}));return "undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return [n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n;},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);an.createDraft.bind(an);an.finishDraft.bind(an);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux.compose;
    return redux.compose.apply(null, arguments);
};
// src/isPlainObject.ts
function isPlainObject$1(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (process.env.NODE_ENV === "production") {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isActionCreator, isActionCreator2 = _c === void 0 ? isActionCreator : _c;
    return function () { return function (next) { return function (action) {
        if (isActionCreator2(action)) {
            console.warn(getMessage(action.type));
        }
        return next(action);
    }; }; };
}
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
var EnhancerArray = /** @class */ (function (_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function () {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array));
function freezeDraftable(val) {
    return t(val) ? fn(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = process.env.NODE_ENV === "production";
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    if (checkedObjects === void 0) { checkedObjects = new Set(); }
    var tracked = { value: obj };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function (key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) {
            return { value: result };
        }
    };
    for (var key in keysToDetect) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (process.env.NODE_ENV === "production") {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$1(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    if (cache == null ? void 0 : cache.has(value))
        return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function (key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        if (!isSerializable(nestedValue)) {
            return { value: {
                    keyPath: nestedPath,
                    value: nestedValue
                } };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) {
                return { value: foundNestedSerializable };
            }
        }
    };
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object")
            return state_2.value;
    }
    if (cache && isNestedFrozen(value))
        cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value))
        return false;
    for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null)
            continue;
        if (!isNestedFrozen(nestedValue))
            return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (process.env.NODE_ENV === "production") {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(thunkMiddleware__default["default"]);
        }
        else {
            middlewareArray.push(thunkMiddleware__default["default"].withExtraArgument(thunk.extraArgument));
        }
    }
    if (process.env.NODE_ENV !== "production") {
        if (immutableCheck) {
            var immutableOptions = {};
            if (!isBoolean(immutableCheck)) {
                immutableOptions = immutableCheck;
            }
            middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
        }
        if (serializableCheck) {
            var serializableOptions = {};
            if (!isBoolean(serializableCheck)) {
                serializableOptions = serializableCheck;
            }
            middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
        }
        if (actionCreatorCheck) {
            var actionCreatorOptions = {};
            if (!isBoolean(actionCreatorCheck)) {
                actionCreatorOptions = actionCreatorCheck;
            }
            middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
        }
    }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = process.env.NODE_ENV === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject$1(reducer)) {
        rootReducer = redux.combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = redux.applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = redux.compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(defaultEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return redux.createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (process.env.NODE_ENV !== "production") {
                if (actionMatchers.length > 0) {
                    throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
                }
                if (defaultCaseReducer) {
                    throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
                }
            }
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) {
                throw new Error("`builder.addCase` cannot be called with an empty action type");
            }
            if (type in actionsMap) {
                throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (process.env.NODE_ENV !== "production") {
                if (defaultCaseReducer) {
                    throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
                }
            }
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (process.env.NODE_ENV !== "production") {
                if (defaultCaseReducer) {
                    throw new Error("`builder.addDefaultCase` can only be called once");
                }
            }
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (process.env.NODE_ENV !== "production") {
        if (typeof mapOrBuilderCallback === "object") {
            if (!hasWarnedAboutObjectNotation) {
                hasWarnedAboutObjectNotation = true;
                console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
            }
        }
    }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return fn(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
        if (options.initialState === void 0) {
            console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
        }
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (process.env.NODE_ENV !== "production") {
            if (typeof options.extraReducers === "object") {
                if (!hasWarnedAboutObjectNotation2) {
                    hasWarnedAboutObjectNotation2 = true;
                    console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
                }
            }
        }
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
((function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (process.env.NODE_ENV !== "production") {
                    if (!displayedWarning) {
                        displayedWarning = true;
                        console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.");
                    }
                }
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
}))();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
var alm = "listenerMiddleware";
createAction(alm + "/add");
createAction(alm + "/removeAll");
createAction(alm + "/remove");
var promise;
typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
// src/index.ts
F();

const initialState$f = {
  consignorsList: [],
  exportersList: [],
  consigneeList: [],
  representativesList: [],
  declarantsList: [],
  carriersList: [],
  authorizationsList: [],
  additionalSupplyChainActorsList: [],
  economicOperatorsList: [],
  exitCarriersList: []
};
const actorSlice$1 = createSlice({
  name: 'actorReducer',
  initialState: initialState$f,
  reducers: {
    initializeParties: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    addItemParties: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      state[tableName].push(data);
    },
    updateItemParties: (state, {
      payload: {
        id,
        meta: {
          tableName
        },
        data
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    delteItemParties: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    updatePartiesContactInfo: (state, {
      payload: {
        id,
        data,
        meta: {
          tableName
        }
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id).contact, data);
    },
    clearForm: () => initialState$f
  }
});
const actorActions$1 = actorSlice$1.actions;
var actorReducer$1 = actorSlice$1.reducer;

const initialState$e = {
  containersList: []
};
const containerSlice$1 = createSlice({
  name: 'containerReducer',
  initialState: initialState$e,
  reducers: {
    inititalizeContainerForm: (state, {
      payload
    }) => {
      var _payload$containersLi;
      let data = {
        ...payload,
        containersList: (payload === null || payload === void 0 ? void 0 : (_payload$containersLi = payload.containersList) === null || _payload$containersLi === void 0 ? void 0 : _payload$containersLi.map(i => ({
          ...i,
          sealsList: (i === null || i === void 0 ? void 0 : i.sealsList) || []
        }))) || []
      };
      Object.assign(state, data);
    },
    updateContainerField: (state, {
      payload
    }) => {
      const {
        id,
        data
      } = payload;
      Object.assign(state.containersList.find(c => c.id === id), data);
    },
    addContainerField: (state, {
      payload
    }) => {
      const {
        data
      } = payload;
      state.containersList.push({
        ...data,
        sealsList: []
      });
    },
    deleteContainerField: (state, {
      payload
    }) => {
      const {
        id
      } = payload;
      state.containersList = state.containersList.filter(c => c.id !== id);
    },
    addContainerFieldSealNumber: (state, {
      payload
    }) => {
      var _state$containersList, _state$containersList2, _state$containersList3;
      const {
        data,
        meta: {
          tableName
        }
      } = payload;
      (_state$containersList = state.containersList) === null || _state$containersList === void 0 ? void 0 : (_state$containersList2 = _state$containersList.find(container => (container === null || container === void 0 ? void 0 : container.id) == (data === null || data === void 0 ? void 0 : data.containerId))) === null || _state$containersList2 === void 0 ? void 0 : (_state$containersList3 = _state$containersList2.sealsList) === null || _state$containersList3 === void 0 ? void 0 : _state$containersList3.push(data);
    },
    updateContainerFieldSealNumber: (state, {
      payload
    }) => {
      var _state$containersList4, _state$containersList5;
      const {
        listId,
        id,
        data,
        meta: {
          tableName
        }
      } = payload;
      Object.assign((_state$containersList4 = state.containersList.find(container => (container === null || container === void 0 ? void 0 : container.id) == listId)) === null || _state$containersList4 === void 0 ? void 0 : (_state$containersList5 = _state$containersList4.sealsList) === null || _state$containersList5 === void 0 ? void 0 : _state$containersList5.find(sealNumber => (sealNumber === null || sealNumber === void 0 ? void 0 : sealNumber.id) == id), data);
    },
    deleteContainerFieldSealNumber: (state, {
      payload
    }) => {
      const {
        listId,
        id,
        meta: {
          tableName
        }
      } = payload;
      state.containersList = state.containersList.map(container => {
        var _container$sealsList;
        return container.id == listId ? {
          ...container,
          sealsList: container === null || container === void 0 ? void 0 : (_container$sealsList = container.sealsList) === null || _container$sealsList === void 0 ? void 0 : _container$sealsList.filter(sealNumber => (sealNumber === null || sealNumber === void 0 ? void 0 : sealNumber.id) !== id)
        } : container;
      });
    },
    clearForm: () => initialState$e
  }
});
const containerTabActions$1 = containerSlice$1.actions;
var containerReducer$1 = containerSlice$1.reducer;

const initialState$d = {
  invoice: {
    invoiceUpperHeader: {
      totalInvoices: 0
    },
    invoiceIdList: [],
    invoiceMap: {},
    merchandiseMap: {},
    merchandiseIdList: [],
    containers: []
  }
};
const itemSlice$1 = createSlice({
  name: 'invoiceReducer',
  initialState: initialState$d,
  reducers: {
    initializeItemsForm: (state, {
      payload
    }) => {
      state.invoice = {
        ...state.invoice,
        ...payload
      };
    },
    updateInvoiceUpperHeader: (state, {
      payload
    }) => {
      state.invoice.invoiceUpperHeader = {
        ...state.invoice.invoiceUpperHeader,
        ...payload
      };
    },
    updateInvoiceHeader: (state, {
      payload: {
        invoiceId,
        data
      }
    }) => {
      if (data.deliveryTerms) state.invoice.invoiceMap[invoiceId].invoiceHeader.deliveryTerms = {
        ...state.invoice.invoiceMap[invoiceId].invoiceHeader.deliveryTerms,
        ...data.deliveryTerms
      };else state.invoice.invoiceMap[invoiceId].invoiceHeader = {
        ...state.invoice.invoiceMap[invoiceId].invoiceHeader,
        ...data
      };
    },
    createInvoice: (state, {
      payload: {
        invoiceId
      }
    }) => {
      state.invoice.invoiceUpperHeader.totalInvoices = +state.invoice.invoiceUpperHeader.totalInvoices + 1;
      state.invoice.invoiceIdList.push(invoiceId);
      state.invoice.invoiceMap[invoiceId] = {
        ...state.invoice.invoiceMap[invoiceId],
        invoiceHeader: {},
        merchandiseIdList: []
      };
    },
    deleteInvoice: (state, {
      payload: {
        invoiceId
      }
    }) => {
      var _state$invoice$invoic, _state$invoice$invoic2;
      (_state$invoice$invoic = state.invoice.invoiceMap[invoiceId]) === null || _state$invoice$invoic === void 0 ? void 0 : (_state$invoice$invoic2 = _state$invoice$invoic.merchandiseIdList) === null || _state$invoice$invoic2 === void 0 ? void 0 : _state$invoice$invoic2.forEach(merch => delete state.invoice.merchandiseMap[merch]);
      delete state.invoice.invoiceMap[invoiceId];
      // Object.assign(state.invoice.invoiceUpperHeader, {
      //   totalInvoices: +state.invoice.invoiceUpperHeader.totalInvoices - 1,
      //   ...invoiceUpperHeader,
      // })
      state.invoice.invoiceIdList = state.invoice.invoiceIdList.filter(Id => Id != invoiceId);
    },
    createMerchandiseItem: (state, {
      payload: {
        invoiceId,
        merchandiseId
      }
    }) => {
      var _state$invoice$invoic3;
      (_state$invoice$invoic3 = state.invoice.invoiceMap[invoiceId].merchandiseIdList) === null || _state$invoice$invoic3 === void 0 ? void 0 : _state$invoice$invoic3.push(merchandiseId);
      state.invoice.merchandiseMap[merchandiseId] = {
        id: merchandiseId
      };
    },
    deleteMerchandiseItem: (state, {
      payload
    }) => {
      const {
        invoiceId,
        merchandiseId
      } = payload;
      delete state.invoice.merchandiseMap[merchandiseId];
      state.invoice.invoiceMap[invoiceId].merchandiseIdList = state.invoice.invoiceMap[invoiceId].merchandiseIdList.filter(id => id !== merchandiseId);
    },
    updateMerchandiseItem: (state, {
      payload: {
        merchandiseId,
        data
      }
    }) => {
      state.invoice.merchandiseMap[merchandiseId] = {
        ...state.invoice.merchandiseMap[merchandiseId],
        ...data
      };
    },
    addMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      let doc = state.invoice.merchandiseMap[merchandiseId][tableName];
      if (!Array.isArray(doc)) state.invoice.merchandiseMap[merchandiseId][tableName] = [data];else state.invoice.merchandiseMap[merchandiseId][tableName].push(data);
    },
    deleteMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      state.invoice.merchandiseMap[merchandiseId][tableName] = state.invoice.merchandiseMap[merchandiseId][tableName].filter(c => tableName == "containersList" ? c.containerAssociationId !== id : c.id !== id);
    },
    updateMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      Object.assign(state.invoice.merchandiseMap[merchandiseId][tableName].find(c => c.id === id), data);
    },
    addInvoiceDocById: (state, {
      payload: {
        invoiceId
      },
      meta: {
        tableName
      }
    }) => {
      let doc = state.invoice.invoiceMap[invoiceId][tableName];
      if (!Array.isArray(doc)) state.invoice.invoiceMap[invoiceId][tableName] = [payload];else state.invoice.invoiceMap[invoiceId][tableName].push(payload);
    },
    deleteInvoiceDocById: (state, {
      payload: {
        invoiceId,
        Id
      },
      meta: {
        tableName
      }
    }) => {
      state.invoice.invoiceMap[invoiceId][tableName] = state.invoice.invoiceMap[invoiceId][tableName].filter(c => c.id !== Id);
    },
    massUpdateAtInvoiceLevel: (state, {
      payload
    }) => {
      const {
        merchandiseIds,
        data
      } = payload;
      merchandiseIds.forEach(merchandiseId => {
        state.invoice.merchandiseMap[merchandiseId] = {
          ...state.invoice.merchandiseMap[merchandiseId],
          ...data
        };
      });
    },
    massUpdateAtMultiInvoiceLevel: (state, {
      payload
    }) => {
      const {
        invoiceIds = [],
        data
      } = payload;
      const merchIdList = invoiceIds.reduce((prev, invoiceId) => {
        var _state$invoice$invoic4;
        const merchandiseIdList = ((_state$invoice$invoic4 = state.invoice.invoiceMap[invoiceId]) === null || _state$invoice$invoic4 === void 0 ? void 0 : _state$invoice$invoic4.merchandiseIdList) || [];
        return [...prev, ...merchandiseIdList];
      }, []);
      merchIdList.forEach(merchandiseId => {
        state.invoice.merchandiseMap[merchandiseId] = {
          ...state.invoice.merchandiseMap[merchandiseId],
          ...data
        };
      });
    },
    massUpdateDocument: (state, {
      payload
    }) => {
      const {
        merchIdList,
        meta: {
          tableName
        }
      } = payload;
      Object.entries(merchIdList).forEach(([merchandiseId, value]) => {
        state.invoice.merchandiseMap[merchandiseId][tableName] = Array.isArray(state.invoice.merchandiseMap[merchandiseId][tableName]) ? [...state.invoice.merchandiseMap[merchandiseId][tableName], value[tableName][0]] : [value[tableName][0]];
      });
    },
    addMerchandiseParties: (state, {
      payload
    }) => {
      var _state$invoice$mercha, _state$invoice$mercha2;
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      let doc = ((_state$invoice$mercha = state.invoice.merchandiseMap[merchandiseId]) === null || _state$invoice$mercha === void 0 ? void 0 : (_state$invoice$mercha2 = _state$invoice$mercha[containerKey]) === null || _state$invoice$mercha2 === void 0 ? void 0 : _state$invoice$mercha2[tableName]) || '';
      if (!Array.isArray(doc)) {
        if (!state.invoice.merchandiseMap[merchandiseId][containerKey]) state.invoice.merchandiseMap[merchandiseId][containerKey] = {};
        state.invoice.merchandiseMap[merchandiseId][containerKey][tableName] = [data];
      } else {
        state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].push(data);
      }
    },
    updateMerchandiseParties: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      Object.assign(state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].find(c => c.id === id), data);
    },
    deleteMerchandiseParties: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      state.invoice.merchandiseMap[merchandiseId][containerKey][tableName] = state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].filter(c => c.id !== id);
    },
    clearForm: () => initialState$d
  }
});
const itemActions$1 = itemSlice$1.actions;
var invoiceReducer$1 = itemSlice$1.reducer;

// import {ADD_ITEM_TRANSPORT,UPDATE_ITEM_TRANSPORT,DELETE_ITEM_TRANSPORT,UPDATE_TRANSPORT_DETAILS,UPDATE_TRANSPORT_HEADER_INFO,CLEAR_FORM} from '@commonActionTypes'
const initialState$c = {
  customOfficesList: [],
  additionalDocumentsList: [],
  previousDocumentsList: [],
  supportingDocumentsList: [],
  departureTransportMeansList: [],
  exitInfoList: [],
  locationOfGoods: {},
  borderTransportMode: {},
  countryInfo: {},
  activeTransportMeansList: [],
  routingCountriesList: []
};
const transportSlice$1 = createSlice({
  name: 'transportReducer',
  initialState: initialState$c,
  reducers: {
    updateTransportHeaderInfo: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    updateTransportDetails: (state, {
      payload: {
        key,
        data
      }
    }) => {
      // const {key,data} = payload
      Object.assign(state[key], data);
    },
    addItemTransport: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      state[tableName].push(data);
    },
    updateItemTransport: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        tableName
      } = meta;
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    deleteItemTransport: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    clearForm: () => initialState$c
  }
});
const transportTabActions$1 = transportSlice$1.actions;
var transportReducer$1 = transportSlice$1.reducer;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$5] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$5] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$6;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$4 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$4) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$4) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$4;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$4;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$1:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$2;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$2 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$2;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
cloneableTags[numberTag] = cloneableTags[objectTag$1] =
cloneableTags[regexpTag] = cloneableTags[setTag$1] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(last_1(path))];
}

var _baseUnset = baseUnset;

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$1 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$1.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject_1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone;

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? identity_1 : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
_flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = _arrayMap(paths, function(path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  _copyObject(object, _getAllKeysIn(object), result);
  if (isDeep) {
    result = _baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, _customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    _baseUnset(result, paths[length]);
  }
  return result;
});

const initialState$b = {
  headerTab: {},
  parties: {},
  itemsTab: {},
  transportTab: {}
};
const checkIfStringStartsWith$1 = (str, substrs) => {
  return substrs.some(substr => str.startsWith(substr));
};
const validationSlice$1 = createSlice({
  name: 'ValidationErrors',
  initialState: initialState$b,
  reducers: {
    initializeErrors: (state, {
      payload
    }) => ({
      ...state,
      ...payload
    }),
    updateValidationErrors: (state, {
      payload: {
        tabName,
        errors,
        errorKeys
      }
    }) => {
      state[tabName] = _.omit(state[tabName], Object.keys(state[tabName]).filter(k => checkIfStringStartsWith$1(k, errorKeys)));
      state[tabName] = {
        ...state[tabName],
        ...errors
      };
    },
    clearForm: () => initialState$b
  }
});
const {
  initializeErrors: initializeErrors$1,
  updateValidationErrors: updateValidationErrors$1
} = validationSlice$1.actions;
const validationActions = validationSlice$1.actions;
var ValidationReducer$1 = validationSlice$1.reducer;

const resetForm$1 = () => dispatch => {
  dispatch(itemActions$1.clearForm()), dispatch(containerTabActions$1.clearForm()), dispatch(clearForm$1()), dispatch(transportTabActions$1.clearForm());
  dispatch(actorActions$1.clearForm());
  dispatch(validationActions.clearForm());
};
const initialState$a = {
  headerTab: {},
  ccDocumentsList: []
};
const headerSlice$1 = createSlice({
  name: 'headerReducer',
  initialState: initialState$a,
  reducers: {
    initializeHeaderForm: (state, {
      payload
    }) => {
      state.headerTab = {
        ...state.headerTab,
        ...payload
      };
      payload.ccDocumentsList ? state.ccDocumentsList = [...state.ccDocumentsList, ...(payload === null || payload === void 0 ? void 0 : payload.ccDocumentsList)] : null;
    },
    updateShipmentFieldValue: (state, {
      payload
    }) => {
      state.headerTab = {
        ...state.headerTab,
        ...payload
      };
    },
    addShipmentRow: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      state[tableName].push(data.headerTab[tableName][0]);
    },
    updateShipmentRow: (state, {
      payload: {
        id,
        meta: {
          tableName
        },
        data
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    deleteShipmentRow: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    clearForm: () => initialState$a
  }
});
const {
  initializeHeaderForm: initializeHeaderForm$1,
  updateShipmentFieldValue: updateShipmentFieldValue$1,
  addShipmentRow,
  updateShipmentRow,
  deleteShipmentRow,
  clearForm: clearForm$1
} = headerSlice$1.actions;
var headerReducer$1 = headerSlice$1.reducer;

const initialState$9 = {
  declaration: [],
  declarationType: [],
  authorisationType: [],
  headerAuthorisationType: [],
  goodsLocationType: [],
  warehouseType: [],
  methodOfPayment: [],
  transmissionType: [],
  countryCodes: [],
  supplyChainActorRole: [],
  transportMean: [],
  security: [],
  customOffice: [],
  customOfficeType: []
};
const dropDownSlice$1 = createSlice({
  name: 'dropDownReducer',
  initialState: initialState$9,
  reducers: {
    initializeDropDownValues: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    updateDropDown: () => {}
  }
});
const {
  initializeDropDownValues
} = dropDownSlice$1.actions;
var dropDownReducer$1 = dropDownSlice$1.reducer;

const initialState$8 = {
  header: [],
  transport: [],
  items: []
};
const serverErrorSlice$1 = createSlice({
  name: 'serverErrorReducer',
  initialState: initialState$8,
  reducers: {
    initServerError: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    resetServerError: () => initialState$8
  }
});
const {
  initServerError: initServerError$1,
  resetServerError: resetServerError$1
} = serverErrorSlice$1.actions;
var serverErrorReducer$1 = serverErrorSlice$1.reducer;

const combinedReducers$1 = {
  headerReducer: headerReducer$1,
  actorReducer: actorReducer$1,
  transportReducer: transportReducer$1,
  invoiceReducer: invoiceReducer$1,
  dropDownReducer: dropDownReducer$1,
  containerReducer: containerReducer$1,
  ValueBuildUpReducer,
  serverErrorReducer: serverErrorReducer$1,
  ValidationErrors: ValidationReducer$1
};

const store$1 = configureStore({
  reducer: combinedReducers$1,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false
  }).concat(logger__default["default"]),
  //other way middleware:[logger]
  devTools: process.env.NODE_ENV !== 'production'
});

const initialState$7 = {
  authorizationsList: [],
  additionalSupplyChainActorsList: [],
  economicOperatorsList: [],
  paymentDetails: [],
  guaranteeDetailList: [],
  addGuaranteeDetailList: [],
  consignorsList: [],
  consigneeList: [],
  representativesList: [],
  declarantsList: [],
  importersList: [],
  exportersList: [],
  forwardersList: [],
  location4plsList: [],
  buyersList: [],
  sellersList: [],
  suritiesList: [],
  carriersList: []
};
const actorSlice = createSlice({
  name: 'actorReducer',
  initialState: initialState$7,
  reducers: {
    initializeParties: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    addItemParties: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      state[tableName].push(data);
    },
    updateItemParties: (state, {
      payload: {
        id,
        meta: {
          tableName
        },
        data
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    delteItemParties: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    updatePartiesContactInfo: (state, {
      payload: {
        id,
        data,
        meta: {
          tableName
        }
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id).contact, data);
    },
    clearForm: () => initialState$7
  }
});
const actorActions = actorSlice.actions;
var actorReducer = actorSlice.reducer;

const initialState$6 = {
  containersList: []
};
const containerSlice = createSlice({
  name: 'containerReducer',
  initialState: initialState$6,
  reducers: {
    inititalizeContainerForm: (state, {
      payload
    }) => {
      var _payload$containersLi;
      let data = {
        ...payload,
        containersList: (payload === null || payload === void 0 ? void 0 : (_payload$containersLi = payload.containersList) === null || _payload$containersLi === void 0 ? void 0 : _payload$containersLi.map(i => ({
          ...i,
          sealsList: (i === null || i === void 0 ? void 0 : i.sealsList) || []
        }))) || []
      };
      Object.assign(state, data);
    },
    updateContainerField: (state, {
      payload
    }) => {
      const {
        id,
        data
      } = payload;
      Object.assign(state.containersList.find(c => c.id === id), data);
    },
    addContainerField: (state, {
      payload
    }) => {
      const {
        data
      } = payload;
      state.containersList.push({
        ...data,
        sealsList: []
      });
    },
    deleteContainerField: (state, {
      payload
    }) => {
      const {
        id
      } = payload;
      state.containersList = state.containersList.filter(c => c.id !== id);
    },
    addContainerFieldSealNumber: (state, {
      payload
    }) => {
      var _state$containersList, _state$containersList2, _state$containersList3;
      const {
        data,
        meta: {
          tableName
        }
      } = payload;
      (_state$containersList = state.containersList) === null || _state$containersList === void 0 ? void 0 : (_state$containersList2 = _state$containersList.find(container => (container === null || container === void 0 ? void 0 : container.id) == (data === null || data === void 0 ? void 0 : data.containerId))) === null || _state$containersList2 === void 0 ? void 0 : (_state$containersList3 = _state$containersList2.sealsList) === null || _state$containersList3 === void 0 ? void 0 : _state$containersList3.push(data);
    },
    updateContainerFieldSealNumber: (state, {
      payload
    }) => {
      var _state$containersList4, _state$containersList5;
      const {
        listId,
        id,
        data,
        meta: {
          tableName
        }
      } = payload;
      Object.assign((_state$containersList4 = state.containersList.find(container => (container === null || container === void 0 ? void 0 : container.id) == listId)) === null || _state$containersList4 === void 0 ? void 0 : (_state$containersList5 = _state$containersList4.sealsList) === null || _state$containersList5 === void 0 ? void 0 : _state$containersList5.find(sealNumber => (sealNumber === null || sealNumber === void 0 ? void 0 : sealNumber.id) == id), data);
    },
    deleteContainerFieldSealNumber: (state, {
      payload
    }) => {
      const {
        listId,
        id,
        meta: {
          tableName
        }
      } = payload;
      state.containersList = state.containersList.map(container => {
        var _container$sealsList;
        return container.id == listId ? {
          ...container,
          sealsList: container === null || container === void 0 ? void 0 : (_container$sealsList = container.sealsList) === null || _container$sealsList === void 0 ? void 0 : _container$sealsList.filter(sealNumber => (sealNumber === null || sealNumber === void 0 ? void 0 : sealNumber.id) !== id)
        } : container;
      });
    },
    updateContainerHierarchy: (state, {
      payload: {
        containerId,
        data
      }
    }) => {
      var _containerData$sealsL;
      let containerData = state.containersList.find(container => container.id === containerId);
      containerData.markDelete = data === null || data === void 0 ? void 0 : data.markDelete;
      containerData.sealsList = (_containerData$sealsL = containerData.sealsList) === null || _containerData$sealsL === void 0 ? void 0 : _containerData$sealsL.map(item => ({
        ...item,
        ...data
      }));
      Object.assign(state.containersList.find(container => container.id === containerId), containerData);
    },
    clearForm: () => initialState$6
  }
});
const containerTabActions = containerSlice.actions;
var containerReducer = containerSlice.reducer;

const initialState$5 = {
  invoice: {
    invoiceUpperHeader: {
      totalInvoices: 0
    },
    invoiceIdList: [],
    invoiceMap: {},
    merchandiseMap: {},
    merchandiseIdList: [],
    containers: []
  }
};
const itemSlice = createSlice({
  name: 'invoiceReducer',
  initialState: initialState$5,
  reducers: {
    initializeItemsForm: (state, {
      payload
    }) => {
      state.invoice = {
        ...state.invoice,
        ...payload
      };
    },
    updateInvoiceUpperHeader: (state, {
      payload
    }) => {
      state.invoice.invoiceUpperHeader = {
        ...state.invoice.invoiceUpperHeader,
        ...payload
      };
    },
    updateInvoiceHeader: (state, {
      payload: {
        invoiceId,
        data
      }
    }) => {
      state.invoice.invoiceMap[invoiceId].invoiceHeader = {
        ...state.invoice.invoiceMap[invoiceId].invoiceHeader,
        ...data
      };
    },
    createInvoice: (state, {
      payload: {
        invoiceId
      }
    }) => {
      state.invoice.invoiceUpperHeader.totalInvoices = +state.invoice.invoiceUpperHeader.totalInvoices + 1;
      state.invoice.invoiceIdList.push(invoiceId);
      state.invoice.invoiceMap[invoiceId] = {
        ...state.invoice.invoiceMap[invoiceId],
        invoiceId,
        invoiceHeader: {
          invoiceId
        },
        merchandiseIdList: []
      };
    },
    deleteInvoice: (state, {
      payload: {
        invoiceId
      }
    }) => {
      var _state$invoice$invoic, _state$invoice$invoic2;
      (_state$invoice$invoic = state.invoice.invoiceMap[invoiceId]) === null || _state$invoice$invoic === void 0 ? void 0 : (_state$invoice$invoic2 = _state$invoice$invoic.merchandiseIdList) === null || _state$invoice$invoic2 === void 0 ? void 0 : _state$invoice$invoic2.forEach(merch => delete state.invoice.merchandiseMap[merch]);
      delete state.invoice.invoiceMap[invoiceId];
      // Object.assign(state.invoice.invoiceUpperHeader, {
      //   totalInvoices: +state.invoice.invoiceUpperHeader.totalInvoices - 1,
      //   ...invoiceUpperHeader,
      // })
      state.invoice.invoiceIdList = state.invoice.invoiceIdList.filter(Id => Id != invoiceId);
    },
    createMerchandiseItem: (state, {
      payload: {
        invoiceId,
        merchandiseId,
        ...rest
      }
    }) => {
      var _state$invoice$invoic3;
      if (!Array.isArray(state.invoice.invoiceMap[invoiceId].merchandiseIdList)) {
        state.invoice.invoiceMap[invoiceId].merchandiseIdList = [];
      }
      (_state$invoice$invoic3 = state.invoice.invoiceMap[invoiceId].merchandiseIdList) === null || _state$invoice$invoic3 === void 0 ? void 0 : _state$invoice$invoic3.push(merchandiseId);
      state.invoice.merchandiseMap[merchandiseId] = {
        id: merchandiseId,
        ...rest
      };
    },
    deleteMerchandiseItem: (state, {
      payload
    }) => {
      const {
        invoiceId,
        merchandiseId
      } = payload;
      delete state.invoice.merchandiseMap[merchandiseId];
      state.invoice.invoiceMap[invoiceId].merchandiseIdList = state.invoice.invoiceMap[invoiceId].merchandiseIdList.filter(id => id !== merchandiseId);
    },
    updateMerchandiseItem: (state, {
      payload: {
        merchandiseId,
        data
      }
    }) => {
      state.invoice.merchandiseMap[merchandiseId] = {
        ...state.invoice.merchandiseMap[merchandiseId],
        ...data
      };
    },
    addMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      let doc = state.invoice.merchandiseMap[merchandiseId][tableName];
      if (!Array.isArray(doc)) state.invoice.merchandiseMap[merchandiseId][tableName] = [data];else state.invoice.merchandiseMap[merchandiseId][tableName].push(data);
    },
    deleteMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      state.invoice.merchandiseMap[merchandiseId][tableName] = state.invoice.merchandiseMap[merchandiseId][tableName].filter(c => tableName == 'containersList' ? c.containerAssociationId !== id : c.id !== id);
    },
    updateMerchanidseDocById: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        tableName
      } = meta;
      Object.assign(state.invoice.merchandiseMap[merchandiseId][tableName].find(c => c.id === id), data);
    },
    addInvoiceDocById: (state, {
      payload: {
        invoiceId
      },
      meta: {
        tableName
      }
    }) => {
      let doc = state.invoice.invoiceMap[invoiceId][tableName];
      if (!Array.isArray(doc)) state.invoice.invoiceMap[invoiceId][tableName] = [payload];else state.invoice.invoiceMap[invoiceId][tableName].push(payload);
    },
    deleteInvoiceDocById: (state, {
      payload: {
        invoiceId,
        Id
      },
      meta: {
        tableName
      }
    }) => {
      state.invoice.invoiceMap[invoiceId][tableName] = state.invoice.invoiceMap[invoiceId][tableName].filter(c => c.id !== Id);
    },
    massUpdateAtInvoiceLevel: (state, {
      payload
    }) => {
      const {
        merchandiseIds,
        data
      } = payload;
      merchandiseIds.forEach(merchandiseId => {
        state.invoice.merchandiseMap[merchandiseId] = {
          ...state.invoice.merchandiseMap[merchandiseId],
          ...data
        };
      });
    },
    massUpdateAtMultiInvoiceLevel: (state, {
      payload
    }) => {
      const {
        invoiceIds = [],
        data
      } = payload;
      const merchIdList = invoiceIds.reduce((prev, invoiceId) => {
        var _state$invoice$invoic4;
        const merchandiseIdList = ((_state$invoice$invoic4 = state.invoice.invoiceMap[invoiceId]) === null || _state$invoice$invoic4 === void 0 ? void 0 : _state$invoice$invoic4.merchandiseIdList) || [];
        return [...prev, ...merchandiseIdList];
      }, []);
      merchIdList.forEach(merchandiseId => {
        state.invoice.merchandiseMap[merchandiseId] = {
          ...state.invoice.merchandiseMap[merchandiseId],
          ...data
        };
      });
    },
    massUpdateDocument: (state, {
      payload
    }) => {
      const {
        merchIdList,
        meta: {
          tableName
        }
      } = payload;
      Object.entries(merchIdList).forEach(([merchandiseId, value]) => {
        state.invoice.merchandiseMap[merchandiseId][tableName] = Array.isArray(state.invoice.merchandiseMap[merchandiseId][tableName]) ? [...state.invoice.merchandiseMap[merchandiseId][tableName], value[tableName][0]] : [value[tableName][0]];
      });
    },
    massUpdateMerchDocsAtInvoiceLevel: (state, {
      payload
    }) => {
      const {
        merchandiseIds = [],
        meta: {
          tableName
        },
        data
      } = payload;
      merchandiseIds.forEach(merchandiseId => {
        var _state$invoice$mercha;
        state.invoice.merchandiseMap[merchandiseId][tableName] = (_state$invoice$mercha = state.invoice.merchandiseMap[merchandiseId][tableName]) === null || _state$invoice$mercha === void 0 ? void 0 : _state$invoice$mercha.map(item => ({
          ...item,
          ...data
        }));
      });
    },
    massUpdateMerchDocsAtMultiInvoiceLevel: (state, {
      payload
    }) => {
      const {
        invoiceIds = [],
        meta: {
          tableName
        },
        data
      } = payload;
      const merchIdList = invoiceIds.reduce((prev, invoiceId) => {
        var _state$invoice$invoic5;
        const merchandiseIdList = ((_state$invoice$invoic5 = state.invoice.invoiceMap[invoiceId]) === null || _state$invoice$invoic5 === void 0 ? void 0 : _state$invoice$invoic5.merchandiseIdList) || [];
        return [...prev, ...merchandiseIdList];
      }, []);
      merchIdList.forEach(merchandiseId => {
        var _state$invoice$mercha2;
        state.invoice.merchandiseMap[merchandiseId][tableName] = (_state$invoice$mercha2 = state.invoice.merchandiseMap[merchandiseId][tableName]) === null || _state$invoice$mercha2 === void 0 ? void 0 : _state$invoice$mercha2.map(item => ({
          ...item,
          ...data
        }));
      });
    },
    // associateItemContainer: (state, {payload:{ merchandiseId, data} }) => {
    //   let containerList = state.invoice.merchandiseMap[merchandiseId].containersList
    //   if (!Array.isArray(containerList))
    //     state.invoice.merchandiseMap[merchandiseId].containersList = [data]
    //   else state.invoice.merchandiseMap[merchandiseId].containersList.push(data)
    // },
    // disassociateItemContainer: ({ merchandiseId, containerAssociationId }) => {
    //   state.invoice.merchandiseMap[merchandiseId].containersList = state.invoice.merchandiseMap[
    //     merchandiseId
    //   ].containersList.filter((c) => c.containerAssociationId !== containerAssociationId)
    // },
    addMerchandiseParties: (state, {
      payload
    }) => {
      var _state$invoice$mercha3, _state$invoice$mercha4;
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      let doc = ((_state$invoice$mercha3 = state.invoice.merchandiseMap[merchandiseId]) === null || _state$invoice$mercha3 === void 0 ? void 0 : (_state$invoice$mercha4 = _state$invoice$mercha3[containerKey]) === null || _state$invoice$mercha4 === void 0 ? void 0 : _state$invoice$mercha4[tableName]) || '';
      if (!Array.isArray(doc)) {
        if (!state.invoice.merchandiseMap[merchandiseId][containerKey]) state.invoice.merchandiseMap[merchandiseId][containerKey] = {};
        state.invoice.merchandiseMap[merchandiseId][containerKey][tableName] = [data];
      } else {
        state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].push(data);
      }
    },
    updateMerchandiseParties: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      Object.assign(state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].find(c => c.id === id), data);
    },
    deleteMerchandiseParties: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        merchandiseId
      } = data;
      const {
        containerKey,
        tableName
      } = meta;
      state.invoice.merchandiseMap[merchandiseId][containerKey][tableName] = state.invoice.merchandiseMap[merchandiseId][containerKey][tableName].filter(c => c.id !== id);
    },
    updateInvoiceHierarchy: (state, {
      payload: {
        invoiceId,
        data
      }
    }) => {
      var _state$invoice$invoic6;
      state.invoice.invoiceMap[invoiceId].invoiceHeader.markDelete = data === null || data === void 0 ? void 0 : data.markDelete;
      if (!!((_state$invoice$invoic6 = state.invoice.invoiceMap[invoiceId]['merchandiseIdList']) !== null && _state$invoice$invoic6 !== void 0 && _state$invoice$invoic6.length)) {
        state.invoice.invoiceMap[invoiceId]['merchandiseIdList'].forEach(merchandiseId => {
          state.invoice.merchandiseMap[merchandiseId].markDelete = data === null || data === void 0 ? void 0 : data.markDelete;
          if (state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList']) {
            var _state$invoice$mercha5;
            state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList'] = (_state$invoice$mercha5 = state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList']) === null || _state$invoice$mercha5 === void 0 ? void 0 : _state$invoice$mercha5.map(item => ({
              ...item,
              ...data
            }));
          }
          const tableNames = ['packagesList', 'dangerousGoodsCodesList', 'taricAdditionalCodesList', 'nationalAdditionalCodesList', 'additionalProceduresList', 'additionalDocumentsList', 'previousDocumentsList', 'supportingDocumentsList'];
          tableNames.forEach(tableName => {
            if (state.invoice.merchandiseMap[merchandiseId][tableName]) {
              var _state$invoice$mercha6;
              state.invoice.merchandiseMap[merchandiseId][tableName] = (_state$invoice$mercha6 = state.invoice.merchandiseMap[merchandiseId][tableName]) === null || _state$invoice$mercha6 === void 0 ? void 0 : _state$invoice$mercha6.map(item => ({
                ...item,
                ...data
              }));
            }
          });
        });
      }
    },
    updateMerchandiseHierarchy: (state, {
      payload: {
        merchandiseId,
        data
      }
    }) => {
      state.invoice.merchandiseMap[merchandiseId].markDelete = data === null || data === void 0 ? void 0 : data.markDelete;
      if (state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList']) {
        var _state$invoice$mercha7;
        state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList'] = (_state$invoice$mercha7 = state.invoice.merchandiseMap[merchandiseId]['merchandiseParties']['authorizationsList']) === null || _state$invoice$mercha7 === void 0 ? void 0 : _state$invoice$mercha7.map(item => ({
          ...item,
          ...data
        }));
      }
      const tableNames = ['packagesList', 'dangerousGoodsCodesList', 'taricAdditionalCodesList', 'nationalAdditionalCodesList', 'additionalProceduresList', 'additionalDocumentsList', 'previousDocumentsList', 'supportingDocumentsList'];
      tableNames.forEach(tableName => {
        if (state.invoice.merchandiseMap[merchandiseId][tableName]) {
          var _state$invoice$mercha8;
          state.invoice.merchandiseMap[merchandiseId][tableName] = (_state$invoice$mercha8 = state.invoice.merchandiseMap[merchandiseId][tableName]) === null || _state$invoice$mercha8 === void 0 ? void 0 : _state$invoice$mercha8.map(item => ({
            ...item,
            ...data
          }));
        }
      });
    },
    clearForm: () => initialState$5
  }
});
const itemActions = itemSlice.actions;
var invoiceReducer = itemSlice.reducer;

// import {ADD_ITEM_TRANSPORT,UPDATE_ITEM_TRANSPORT,DELETE_ITEM_TRANSPORT,UPDATE_TRANSPORT_DETAILS,UPDATE_TRANSPORT_HEADER_INFO,CLEAR_FORM} from '@commonActionTypes'
const initialState$4 = {
  customOfficesList: [],
  additionalDocumentsList: [],
  borderTransportMeansList: [],
  arrivalTransportMeansList: [],
  departureTransportMeansList: [],
  locationOfGoods: {},
  warehouse: {},
  countryInfo: {},
  routingCountriesList: []
};
const transportSlice = createSlice({
  name: 'transportReducer',
  initialState: initialState$4,
  reducers: {
    updateTransportHeaderInfo: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    updateTransportDetails: (state, {
      payload: {
        key,
        data
      }
    }) => {
      // const {key,data} = payload
      Object.assign(state[key], data);
    },
    addItemTransport: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      state[tableName].push(data);
    },
    updateItemTransport: (state, {
      payload
    }) => {
      const {
        id,
        data,
        meta
      } = payload;
      const {
        tableName
      } = meta;
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    deleteItemTransport: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    clearForm: () => initialState$4
  }
});
const transportTabActions = transportSlice.actions;
var transportReducer = transportSlice.reducer;

const resetForm = () => dispatch => {
  dispatch(itemActions.clearForm()), dispatch(containerTabActions.clearForm()), dispatch(clearForm()), dispatch(transportTabActions.clearForm());
  dispatch(actorActions.clearForm());
};
const initialState$3 = {
  headerTab: {},
  exitInformation: []
};
const headerSlice = createSlice({
  name: 'headerReducer',
  initialState: initialState$3,
  reducers: {
    initializeHeaderForm: (state, {
      payload
    }) => {
      const {
        exitInformation,
        ...rest
      } = payload;
      state.headerTab = rest;
      state.exitInformation = exitInformation;
    },
    updateShipmentFieldValue: (state, {
      payload
    }) => {
      state.headerTab = {
        ...state.headerTab,
        ...payload
      };
    },
    addItemHeader: (state, {
      payload: {
        meta: {
          tableName
        },
        data
      }
    }) => {
      if (!Array.isArray(state[tableName])) {
        state[tableName] = [];
      }
      state[tableName].push(data);
    },
    updateItemHeader: (state, {
      payload: {
        id,
        meta: {
          tableName
        },
        data
      }
    }) => {
      Object.assign(state[tableName].find(c => c.id === id), data);
    },
    deleteItemHeader: (state, {
      payload: {
        id,
        meta: {
          tableName
        }
      }
    }) => {
      state[tableName] = state[tableName].filter(c => c.id !== id);
    },
    clearForm: () => initialState$3
  }
});
const {
  initializeHeaderForm,
  updateShipmentFieldValue,
  clearForm,
  addItemHeader,
  updateItemHeader,
  deleteItemHeader
} = headerSlice.actions;
var headerReducer = headerSlice.reducer;

const initialState$2 = {
  declaration: [],
  declarationType: [],
  headerAuthorisationType: [],
  warehouseType: [],
  transmissionType: [],
  countryList: [],
  supplyChainActorRole: [],
  transportMean: [],
  customOffice: [],
  representations: [],
  customOfficeType: [],
  customOfficeDms: []
};
const dropDownSlice = createSlice({
  name: 'dropDownReducer',
  initialState: initialState$2,
  reducers: {
    initializeDropDownValues: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    updateDropDown: () => {}
  }
});
var dropDownReducer = dropDownSlice.reducer;

const initialState$1 = {
  headerTab: {},
  parties: {}
};
const checkIfStringStartsWith = (str, substrs) => {
  return substrs.some(substr => str.startsWith(substr));
};
const validationSlice = createSlice({
  name: 'ValidationErrors',
  initialState: initialState$1,
  reducers: {
    initializeErrors: (state, {
      payload
    }) => ({
      ...state,
      ...payload
    }),
    updateValidationErrors: (state, {
      payload: {
        tabName,
        errors,
        errorKeys
      }
    }) => {
      state[tabName] = _.omit(state[tabName], Object.keys(state[tabName]).filter(k => checkIfStringStartsWith(k, errorKeys)));
      state[tabName] = {
        ...state[tabName],
        ...errors
      };
    },
    clearForm: () => initialState$1
  }
});
const {
  initializeErrors,
  updateValidationErrors
} = validationSlice.actions;
var ValidationReducer = validationSlice.reducer;

const initialState = {
  header: [],
  transport: [],
  items: []
};
const serverErrorSlice = createSlice({
  name: 'serverErrorReducer',
  initialState,
  reducers: {
    initServerError: (state, {
      payload
    }) => {
      Object.assign(state, payload);
    },
    resetServerError: () => initialState
  }
});
const {
  initServerError,
  resetServerError
} = serverErrorSlice.actions;
var serverErrorReducer = serverErrorSlice.reducer;

const combinedReducers = {
  headerReducer,
  actorReducer,
  transportReducer,
  invoiceReducer,
  dropDownReducer,
  containerReducer,
  ValueBuildUpReducer,
  serverErrorReducer,
  ValidationErrors: ValidationReducer
};

const store = configureStore({
  reducer: combinedReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false
  }).concat(logger__default["default"]),
  //other way middleware:[logger]
  devTools: process.env.NODE_ENV !== 'production'
});

function LoaderPopup(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "sv loader-popup",
    style: {
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dimmer, {
    active: true,
    inverted: true
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      color: props.color || 'black'
    }
  }, props.loaderMsg || 'Processing...')));
}

const CDSButtonMapper = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./CDSButtonMapper-99f1abe6.js'); });
});
const NLButtonMapper = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./NLButtonMapper-93e3ded7.js'); });
});
const NLDMSButtonMapper = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./NLDMSButtonMapper-bf6f4be5.js'); });
});
const ButtonMapper = /*#__PURE__*/React__default["default"].lazy(() => {
  return Promise.resolve().then(function () { return require('./index-7356b084.js'); });
});
function EUHeader(props) {
  var _props$currentJobData, _props$currentJobData2;
  const [toggleLoader, setToggleLoader] = React$1.useState(false);
  const [loaderMsg, setLoaderMessage] = React$1.useState('Processing...');
  const [loaderMsgClr, setLoaderMsgClr] = React$1.useState('black');
  let EU_STORE = store$4;
  if (props.shipmentCountry === "ES") {
    if (props.version === "AES") {
      EU_STORE = store$1;
    }
  }
  if (props.shipmentCountry === "NL") {
    EU_STORE = store$2;
    if (props.version === "DMS") {
      EU_STORE = store;
    }
  }
  if (props.shipmentCountry === "GB") {
    if (props.version === "CDS") {
      EU_STORE = store$3;
    }
  }
  const toggleLoaderFunc = (msg, timer, color) => {
    //
    var time = timer || 3000;
    setToggleLoader(true);
    setLoaderMessage(msg);
    setLoaderMsgClr(color);
    setTimeout(() => {
      setToggleLoader(false);
      setLoaderMessage('Loading...');
    }, time);
  };
  const enableRawXml = shipmentCountry === "ES" && ((_props$currentJobData = props.currentJobData) === null || _props$currentJobData === void 0 ? void 0 : _props$currentJobData.serviceType) === "EXPORT" && props.version !== "AES" ? false : true;
  let buttonMapperContent = null;
  if (props.shipmentCountry === "GB") {
    buttonMapperContent = /*#__PURE__*/React__default["default"].createElement(CDSButtonMapper, _extends$1({}, props, {
      translate: props.translate,
      toggleLoaderFunc: toggleLoaderFunc,
      serviceType: lodash_2(props, "currentJobData.serviceType", null)
    }));
  } else if (props.shipmentCountry === "NL") {
    if (props.version === "DMS") {
      buttonMapperContent = /*#__PURE__*/React__default["default"].createElement(NLDMSButtonMapper, _extends$1({}, props, {
        translate: props.translate,
        toggleLoaderFunc: toggleLoaderFunc,
        serviceType: lodash_2(props, "currentJobData.serviceType", null)
      }));
    } else {
      buttonMapperContent = /*#__PURE__*/React__default["default"].createElement(NLButtonMapper, _extends$1({}, props, {
        translate: props.translate,
        toggleLoaderFunc: toggleLoaderFunc,
        serviceType: lodash_2(props, "currentJobData.serviceType", null)
      }));
    }
  } else {
    buttonMapperContent = /*#__PURE__*/React__default["default"].createElement(ButtonMapper, _extends$1({}, props, {
      translate: props.translate,
      toggleLoaderFunc: toggleLoaderFunc,
      serviceType: lodash_2(props, "currentJobData.serviceType", null)
    }));
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "EUHeaderWrapper",
    className: "sv header-button-container EUHeaderWrapper"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "todo-button-container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "emergencyDocumentContainer"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "exchangeRatesContainer"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "refreshData"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "divHeader",
    className: "header-alert"
  }, /*#__PURE__*/React__default["default"].createElement(Heading, props), /*#__PURE__*/React__default["default"].createElement(HeaderInfo, _extends$1({}, props, {
    translate: props.translate,
    kxEngineUserInfo: props === null || props === void 0 ? void 0 : props.kxEngineUserInfo
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "emergencyContainer"
  })), canUserFile(props === null || props === void 0 ? void 0 : props.kxUser, props === null || props === void 0 ? void 0 : props.kxEngineUserInfo) && /*#__PURE__*/React__default["default"].createElement("div", null, canUserFile(props.kxUser, props === null || props === void 0 ? void 0 : props.kxEngineUserInfo) && /*#__PURE__*/React__default["default"].createElement(Provider, {
    store: EU_STORE
  }, /*#__PURE__*/React__default["default"].createElement(React$1.Suspense, {
    fallback: ""
  }, buttonMapperContent), /*#__PURE__*/React__default["default"].createElement(StatusDetail, _extends$1({}, props, {
    enableRawXml: enableRawXml,
    translate: props.translate,
    createdDate: (_props$currentJobData2 = props.currentJobData) === null || _props$currentJobData2 === void 0 ? void 0 : _props$currentJobData2.createdDate,
    kxEngineUserInfo: props === null || props === void 0 ? void 0 : props.kxEngineUserInfo
  }))))), toggleLoader && /*#__PURE__*/React__default["default"].createElement(LoaderPopup, {
    loaderMsg: loaderMsg,
    color: loaderMsgClr
  }));
}

function ESApp(props) {
  var _props$currentJobData;
  return /*#__PURE__*/React__default["default"].createElement(Provider, {
    store: store$4
  }, /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(EUHeader, _extends$1({
    translate: props.translate,
    shipId: props.shipId,
    EUData: props.EUData,
    setEUData: props.setEUData,
    shipmentCountry: props.countryCode,
    kxUser: props.kxUser
  }, props.headerProps, {
    version: props.version,
    kxEngineUserInfo: props === null || props === void 0 ? void 0 : props.kxEngineUserInfo
  })), props.finalReview ? /*#__PURE__*/React__default["default"].createElement(EUAcknowledgementPage$1, {
    euPdf: props.euPdf,
    key: "finalReview",
    handleLegalAcknowledgement: props.handleLegalAcknowledgement,
    loadShipment: props.loadShipment,
    translate: props.translate,
    countryCheck: (_props$currentJobData = props.currentJobData) === null || _props$currentJobData === void 0 ? void 0 : _props$currentJobData.countryCode
  }) : /*#__PURE__*/React__default["default"].createElement(ESForm$1, props)));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': ESApp
});

var css_248z = "body.react-confirm-alert-body-element {\n  overflow: hidden;\n}\n\n.react-confirm-alert-blur {\n  filter: url(#gaussian-blur);\n  filter: blur(2px);\n  -webkit-filter: blur(2px);\n}\n\n.react-confirm-alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: rgba(255, 255, 255, 0.9);\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: center;\n  -ms-align-items: center;\n  align-items: center;\n  opacity: 0;\n  -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n}\n\n.react-confirm-alert-body {\n  font-family: Arial, Helvetica, sans-serif;\n  width: 400px;\n  padding: 30px;\n  text-align: left;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n  color: #666;\n}\n\n.react-confirm-alert-svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.react-confirm-alert-body > h1 {\n  margin-top: 0;\n}\n\n.react-confirm-alert-body > h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.react-confirm-alert-button-group {\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 20px;\n}\n\n.react-confirm-alert-button-group > button {\n  outline: none;\n  background: #333;\n  border: none;\n  display: inline-block;\n  padding: 6px 18px;\n  color: #eee;\n  margin-right: 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n@-webkit-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n";
styleInject(css_248z);

const AdBtn = ({
  text,
  onClick,
  disabled,
  isDisabled,
  iconClass = 'add circle',
  size = 'small',
  ...rest
}) => {
  const translate = useTranslation();
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, _extends$1({
    disabled: isDisabled || disabled,
    onClick: onClick,
    basic: true,
    color: "blue",
    className: "btn-add-item",
    size: size
  }, rest), iconClass && /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: iconClass
  })), " ", translate(text));
};
const AddBtn = ShipmentDataHOC$1(AdBtn);

const FormTitle = ({
  id,
  title,
  boxNumber,
  errors,
  className = '',
  textAlign = "center",
  titleContainer = "strong",
  containerStyle = {},
  additionalComponent = null
}) => {
  const TitleContainer = titleContainer;
  const translate = useTranslation();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: className,
    style: {
      textTransform: "uppercase",
      textAlign,
      //width:'100%',
      ...containerStyle
    }
  }, additionalComponent && additionalComponent(), boxNumber && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      verticalAlign: "middle"
    },
    className: "ui black label input-box-number"
  }, boxNumber), /*#__PURE__*/React__default["default"].createElement(TitleContainer, null, translate(title)), errors && errors);
};

const List = ({
  renderItem,
  dataSource,
  title,
  className = 'grid-container',
  boxNumber,
  containerStyle
}) => {
  if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) == 0 && !title)
    // added title condition so that existing code will not break because previously title was not a part of it
    return null;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    className: className
  }, title && /*#__PURE__*/React__default["default"].createElement(FormTitle, {
    boxNumber: boxNumber,
    title: title,
    containerStyle: containerStyle
  }), dataSource && dataSource.map(renderItem));
};
var List$1 = /*#__PURE__*/React__default["default"].memo(List);

const Mailto = ({
  email,
  subject = '',
  body = [],
  cc = [],
  bcc = [],
  children
}) => {
  let params = subject || body ? '&' : '';
  if (subject) params += `subject=${encodeURIComponent(subject)}`;
  let bodyString = '';
  body.forEach(item => {
    bodyString += `${item}%0D%0A`;
  });
  if (body) params += `${subject ? '&' : ''}body=${bodyString}`;
  return /*#__PURE__*/React__default["default"].createElement("a", {
    style: {
      paddingLeft: "15px"
    },
    href: `mailto:${email.toString()}?cc=${cc.toString()}&bcc=${bcc.toString()}${params}`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
const MailHandler = ({
  email,
  subject,
  body,
  cc,
  bcc
}) => {
  return /*#__PURE__*/React__default["default"].createElement(Mailto, {
    email: email,
    subject: subject,
    body: body,
    cc: cc,
    bcc: bcc
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "mail"
  }));
};

const BillingDetails = ({
  item,
  isFormDisabled,
  deleteData,
  updateData,
  chargeCodeList,
  updateTotal,
  handleBillable,
  recipientEmails,
  ccEmails,
  bccEmails,
  isDisabled
}) => {
  const [isRemoving, setIsRemoving] = React$1.useState(false);
  const billingDataSource = useSelector(state => {
    var _state$Billings;
    return (_state$Billings = state.Billings) === null || _state$Billings === void 0 ? void 0 : _state$Billings.billingDataSource;
  }) || {};
  // const [isLoading, setIsLoading] = useState(false)
  const {
    isBillable
  } = billingDataSource;
  const {
    chargeId
  } = item;
  const deleteHandle = async () => {
    var _response$data, _response$data$eventM;
    setIsRemoving(true);
    let response = await deleteData(chargeId, item.isNewlyAddedRow ? item.isNewlyAddedRow : false);
    if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$eventM = _response$data.eventMessage) !== null && _response$data$eventM !== void 0 && _response$data$eventM.msg) {
      var _response$data2, _response$data2$event;
      showToast$1(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$event = _response$data2.eventMessage) === null || _response$data2$event === void 0 ? void 0 : _response$data2$event.msg);
      setIsRemoving(false);
      //  setIsLoading(true)
    }
  };
  const messageArray = ['Dear Customer,', ' ', 'Greetings from KlearNow.', ' ', `GMR number for KN Shipment ID - ${window.shipmentId} is ${item.brokerReferenceNumber}`];
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild border-bottom  b-rw-0"
  }, item.isNewlyAddedRow ? /*#__PURE__*/React__default["default"].createElement(DropDown$2, {
    id: `${chargeId}-chargeCode`,
    label: "Charge Code Name",
    isDisabled: isFormDisabled,
    className: "field-bg dropdown100",
    labelClass: "text-none",
    isLabel: true,
    data: chargeCodeList,
    value: item.chargeName,
    errors: !item.chargeName ? ["Charge Code Name is mandatory."] : [],
    onChange: value => updateData({
      chargeId,
      fieldName: 'chargeName',
      value
    })
  }) : /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-chargeCode`,
    isLabel: false,
    type: "text",
    value: item.chargeName,
    label: "Charge Code Name",
    className: 'field-bg',
    clearInput: false,
    disabled: true
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild  border-bottom datepicker1"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-date`,
    width: "3",
    value: convertDateToUTC(item.referenceDate),
    type: "date",
    label: "Date",
    className: "field-bg",
    clearInput: false,
    onChange: value => updateData({
      chargeId,
      fieldName: 'createdDate',
      value
    }),
    isDisabled: isFormDisabled
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "2",
    className: "divFormFeild  border-bottom  b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-brokerReferenceNumber`,
    isLabel: false,
    type: "text",
    value: item.brokerReferenceNumber,
    label: "REFERENCE",
    className: 'field-bg',
    clearInput: false,
    isDisabled: isFormDisabled,
    onChange: value => updateData({
      chargeId,
      fieldName: 'reference',
      value
    }),
    copyToFeature: true
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "2",
    className: "divFormFeild  border-bottom  b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-quantity`,
    isLabel: false,
    type: "text",
    label: "Quantity",
    className: 'field-bg',
    clearInput: false,
    isDisabled: isFormDisabled,
    value: item.quantity,
    errors: !item.quantity ? ["Quantity is mandatory."] : [],
    onChange: value => {
      let val = value !== '' ? value.replace(/[^0-9]/g, '') : '';
      updateTotal({
        chargeId,
        fieldName: 'quantity',
        value: val
      });
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "1",
    className: "divFormFeild  border-bottom  b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-unitPrice`,
    isLabel: false,
    type: "text",
    label: "Unit Price",
    className: 'field-bg',
    clearInput: false,
    isDisabled: isFormDisabled,
    value: item.unitPrice,
    errors: !item.unitPrice ? ["Unit Price is mandatory."] : [],
    onChange: value => {
      updateTotal({
        chargeId,
        fieldName: 'unitPrice',
        value
      });
    }
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "2",
    className: "divFormFeild  border-bottom  b-rw-0 "
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    id: `${chargeId}-total`,
    isLabel: false,
    type: "text",
    label: "Total",
    className: 'field-bg',
    clearInput: false,
    isDisabled: true,
    value: item.quantity && item.unitPrice && (Number(item.quantity) * Number(item.unitPrice)).toFixed(2)
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "2",
    className: "divFormFeild  border-bottom"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "billable-label"
  }, /*#__PURE__*/React__default["default"].createElement("label", null, "Billable"), " ", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      marginLeft: '10px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    disabled: isFormDisabled,
    style: {
      marginBottom: '13px'
    },
    size: "large",
    name: "check circle",
    color: item.isNewlyAddedRow ? isBillable ? 'green' : 'grey' : item.isNonBillable ? 'grey' : 'green',
    onClick: () => {
      handleBillable();
    }
  })))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "1",
    className: "icon-delete-add-info",
    style: item.glCode === '40112' ? {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    } : {
      display: "flex",
      justifyContent: "end"
    }
  }, item.glCode === '40112' && /*#__PURE__*/React__default["default"].createElement(MailHandler, {
    subject: `Shipment ID - ${window.shipmentId}, ${item.brokerReferenceNumber}`,
    body: messageArray,
    email: recipientEmails,
    cc: ccEmails,
    bcc: bccEmails
  }), !isRemoving ? /*#__PURE__*/React__default["default"].createElement(DeleteIcon$1, {
    isDisabled: item.isNewlyAddedRow == true ? false : isDisabled || window.typeOfUser === 'BROKER_KN_ADMIN',
    id: `${chargeId}-deleteBilling`,
    onClick: () => {
      if (!window.confirm('Are you sure ? Remove Charge ' + (item === null || item === void 0 ? void 0 : item.chargeName))) return;
      deleteHandle();
    }
  }) : /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, {
    active: true,
    inline: true,
    size: "mini",
    style: {
      marginRight: '10px'
    }
  }))));
};
var BillingDetails$1 = /*#__PURE__*/React__default["default"].memo(BillingDetails);

const getChargeFinace = (countryCode, customerEmail) => {
  const data = {
    "eventMessage": {
      "customerEmail": customerEmail,
      "countryName": countryCode
    },
    "eventType": GET_CHARGES_FINANCE,
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getBillingsListApi = shipmentId => {
  const data = {
    "eventMessage": {
      shipmentId
    },
    "eventType": GET_CHARGES_LIST,
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const saveCharge = dataObj => {
  const data = {
    "eventMessage": {
      "chargeDesc": [dataObj]
    },
    "eventType": UPSERT_CHARGE_LIST,
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getEmailGroup = email => {
  const data = {
    "eventMessage": {
      "kxEmail": email
    },
    "eventType": GET_EMAIL_GROUP,
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const deleteChargeRow = id => {
  const data = {
    "eventMessage": {
      "chargeId": id,
      "entityId": window.shipmentId
    },
    "eventType": REMOVE_CHARGE_FROM_LIST,
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getDeclarationStatusApi = shipmentId => {
  const data = {
    "eventMessage": {
      shipmentId,
      "formType": "GET_DECLARATION_STATUS",
      "formType": "GET_DECLARATION_STATUS",
      "countryCode": "GB",
      "language": "GB",
      "mockRequest": false
    },
    "eventType": "FILE_FORM_GB",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};

// For file upload

const getShipmentDocuments = id => {
  const data = {
    "eventMessage": {
      id
    },
    "eventType": "GET_SHIPMENT_DOCUMENTS",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getDocumentsType = () => {
  const data = {
    "eventMessage": "",
    "eventType": "GET_DOCUMENT_TYPES",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getSignedUrls = ({
  bucket,
  files
}) => {
  const eventMessage = bucket ? bucket + ":" + files.join(",") : files.join(",");
  const data = {
    eventMessage,
    eventType: "GET_SIGNED_URLS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const uploadDcoumentToHRMC = payload => {
  const data = {
    "eventMessage": {
      "shipmentId": window.shipmentId,
      "countryCode": "GB",
      payload: JSON.stringify(payload)
    },
    "eventType": "CDS_FILE_UPLOAD",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getStatus = shipmentId => {
  const data = {
    "eventMessage": {
      shipmentId
    },
    "eventType": "GET_JOB_STATUS",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getHistoryDocuments = shipmentId => {
  const data = {
    "eventMessage": {
      shipmentId
    },
    "eventType": "CDS_FILE_UPLOAD_HISTORY",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const retryJob = jobId => {
  const data = {
    "eventMessage": {
      jobId
    },
    "eventType": "RETRY_JOB",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data
  });
};

const useBillingActions = () => {
  const dispatch = useDispatch();
  const AddItem = React$1.useCallback(async () => {
    try {
      dispatch({
        type: ADD_ITEM_BILLINGS,
        payload: {
          chargeId: Date.now(),
          isNewlyAddedRow: true
        }
      });
    } catch (e) {}
  }, []);
  const deleteFunction = id => {
    try {
      dispatch({
        type: DELETE_ITEM_BILLINGS,
        id
      });
    } catch (e) {}
  };
  const deleteItem = React$1.useCallback(async (id, deleteFlag) => {
    let response;
    if (!deleteFlag) {
      response = await deleteChargeRow(id).catch(err => console.log(err));
      if (response.data.eventMessage.msg === 'Charge archived successfully') {
        deleteFunction(id);
      }
    } else {
      deleteFunction(id);
    }
    return response;
  }, []);
  const updateItem = React$1.useCallback(payload => {
    try {
      dispatch({
        type: ActionTypes$3[`UPDATE_ITEM_BILLINGS`],
        payload
      });
    } catch {}
  }, []);

  //  for total field
  const updateTotal = React$1.useCallback(payload => {
    try {
      dispatch({
        type: UPDATE_ITEM_BILLINGS_TOTAL,
        payload
      });
    } catch {}
  }, []);
  const getBillingsList = React$1.useCallback((billingsList, totalAmount) => {
    try {
      dispatch({
        type: GET_BILLINGS_LIST,
        payload: {
          billingsList,
          totalAmount
        }
      });
    } catch {}
  }, []);
  const handleIsLoading = React$1.useCallback(() => {
    try {
      dispatch({
        type: HANDLE_ISLOADING
      });
    } catch {}
  });
  const refreshBillingsList = React$1.useCallback(() => {
    try {
      dispatch({
        type: REFRESH_BILLINGS_LIST
      });
    } catch {}
  });
  const handleBillable = React$1.useCallback(() => {
    try {
      dispatch({
        type: HANDLE_BILLABLE
      });
    } catch {}
  });
  const initalizeBillable = React$1.useCallback(() => {
    try {
      dispatch({
        type: INITIALIZE_ISBILLABLE
      });
    } catch {}
  });
  return React__default["default"].useMemo(() => ({
    AddItem,
    deleteItem,
    updateItem,
    updateTotal,
    getBillingsList,
    handleIsLoading,
    refreshBillingsList,
    handleBillable,
    initalizeBillable
  }), [AddItem, deleteItem, updateItem, updateTotal, getBillingsList, handleIsLoading, refreshBillingsList, handleBillable, initalizeBillable]);
};

const changeListMapper = {
  GB: "ukBuildUp",
  ES: "esBuildUp",
  NL: "nlBuildUp"
};
const BillingForm$1 = props => {
  const isFormEnabled = false;
  const [isModalOpen, setIsModalOpen] = React$1.useState(false);
  const [chargeCodeList, setChargeCodeList] = React$1.useState([]);
  const [isButtonActive, setIsButtonActive] = React$1.useState(false);
  const [isFormDisabled, setIsFormDisabled] = React$1.useState(true);
  const [userBasicInfo, setUserBasicInfo] = React$1.useState({});
  const [glCode, setGlCode] = React$1.useState({});
  const [recipientEmails, setRecipientEmails] = React$1.useState([]);
  const [ccEmails, setCcEmails] = React$1.useState([]);
  const [bccEmails, setBccEmails] = React$1.useState([]);
  const {
    AddItem,
    deleteItem,
    updateItem,
    updateTotal,
    getBillingsList,
    handleIsLoading,
    refreshBillingsList,
    handleBillable,
    initalizeBillable
  } = useBillingActions();
  const billingsList = useSelector(state => {
    var _state$Billings;
    return (_state$Billings = state.Billings) === null || _state$Billings === void 0 ? void 0 : _state$Billings.billingsList;
  }) || [];
  const billingDataSource = useSelector(state => {
    var _state$Billings2;
    return (_state$Billings2 = state.Billings) === null || _state$Billings2 === void 0 ? void 0 : _state$Billings2.billingDataSource;
  }) || {};
  const {
    isAddButton,
    grandTotal,
    isBillable,
    isLoading
  } = billingDataSource;
  const getBillingsListHelper = async () => {
    try {
      const response = await getBillingsListApi(props.currentJobData.shipmentId).catch(err => console.log(err));
      if (response.data.eventMessage && !lodash.isEmpty(response.data.eventMessage)) {
        let res = response.data.eventMessage.chargeListResponse[0].value;
        let newChargeDesc = res.chargeDesc.map(item => {
          if (item.unitPrice) {
            item.unitPrice = item.unitPrice / 100;
            item.totalRate = item.totalRate / 100;
          }
          return item;
        });
        let totalAmt = res.totalAmount ? res.totalAmount / 100 : "";
        getBillingsList(newChargeDesc, totalAmt);
        let basicInfo = {
          countryCode: res.countryCode,
          customerEmail: res.customerEmail,
          customerName: res.customerName,
          customerUserGuid: res.customerUserGuid,
          totalAmount: totalAmt
        };
        setUserBasicInfo(basicInfo);
      } else {
        handleIsLoading();
        showToast$1("No billings found.");
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  React$1.useEffect(() => {
    getBillingsListHelper();
    chargeListFinaceHandle();
    initalizeBillable();
    getEmailGroupHandler();
    return () => {
      refreshBillingsList();
    };
  }, []);
  const getEmailGroupHandler = async () => {
    try {
      const response = await getEmailGroup(props.currentJobData.customer);
      if (response) {
        let result = response.data.eventMessage.emailGroupEntry;
        let gmrIndex = result.findIndex(item => item.emailGroupName == 'GMR_GROUP');
        let gmrGroup = result[gmrIndex];
        setRecipientEmails(gmrGroup['recipientId']);
        setCcEmails(gmrGroup['cc']);
        setBccEmails(gmrGroup['bcc']);
      }
    } catch (err) {}
  };
  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const chargeListFinaceHandle = async () => {
    const {
      countryCode,
      customer
    } = props.currentJobData;
    try {
      const response = await getChargeFinace(countryCode, customer).catch(err => console.log(err));
      //debugger
      let res = response.data.eventMessage[changeListMapper[countryCode]];
      console.log({
        res
      });
      getGlcodes(res);
      getChargeList(res);
    } catch (err) {}
  };
  const handleAdd = async () => {
    setIsButtonActive(true);
    AddItem();
    await chargeListFinaceHandle();
    setIsButtonActive(false);
    setIsFormDisabled(false);
  };
  const getGlcodes = data => {
    let obj = {};
    for (const item of data) {
      obj[`${item.chargeType}`] = item.glCode;
    }
    setGlCode(obj);
  };
  const getChargeList = data => {
    let res = data.filter(o => billingsList.every(c => c.chargeName != o.chargeType));
    let response = res.map(({
      glCode,
      chargeType
    }) => ({
      id: glCode,
      text: glCode,
      value: chargeType
    }));
    setChargeCodeList(response);
  };
  const handleSaveApi = async () => {
    setIsModalOpen(false);
    let findNewelyAddedRow = billingsList.findIndex(item => item.isNewlyAddedRow);
    let item = billingsList[findNewelyAddedRow];
    let glcode = glCode[`${item.chargeName}`];
    let epochDate = convertDateToUTCEpoch(item.createdDate);
    let data = {
      entityId: props.currentJobData.shipmentId,
      customerUserGuid: userBasicInfo.customerUserGuid,
      customerKxEmail: userBasicInfo.customerEmail,
      countryCode: userBasicInfo.countryCode,
      entityType: 'SHIPMENT',
      glCode: glcode,
      addedBy: 'BROKER',
      status: 'BROKER GENERATED',
      chargeName: item.chargeName,
      quantity: item.quantity,
      unitPrice: item.unitPrice && item.unitPrice * 100,
      totalRate: item.totalRate && item.totalRate * 100,
      brokerReferenceNumber: item.reference,
      referenceDate: epochDate
    };
    if (!isBillable) {
      data = {
        ...data,
        isNonBillable: true
      };
      handleBillable();
    }
    try {
      const response = await saveCharge(data).catch(err => console.log(err));
      if (response.data.eventMessage.msg === 'Updated Successfully') {
        refreshBillingsList();
        getBillingsListHelper();
      }
    } catch (err) {}
  };
  const handleCancel = () => {
    let findNewelyAddedRow = billingsList.findIndex(item => item.isNewlyAddedRow);
    let item = billingsList[findNewelyAddedRow];
    let rowId = item.chargeId;
    deleteItem(rowId, item.isNewlyAddedRow);
  };
  let findNewelyAddedRow = billingsList.findIndex(item => item.isNewlyAddedRow);
  let item = billingsList[findNewelyAddedRow];
  const existFlag = item !== null && item !== void 0 && item.chargeName && item !== null && item !== void 0 && item.quantity && item !== null && item !== void 0 && item.unitPrice ? false : true;
  const renderItem = React$1.useCallback(item => {
    return /*#__PURE__*/React__default["default"].createElement(BillingDetails$1, {
      key: item.chargeId,
      item: item,
      isFormDisabled: item.isNewlyAddedRow ? false : true,
      updateData: updateItem,
      deleteData: deleteItem,
      chargeCodeList: chargeCodeList,
      updateTotal: updateTotal,
      handleBillable: handleBillable,
      recipientEmails: recipientEmails,
      ccEmails: ccEmails,
      bccEmails: bccEmails,
      isDisabled: props.isDisabled
    });
  }, [isFormDisabled, updateItem, deleteItem, updateTotal, getBillingsList, handleBillable, recipientEmails, ccEmails]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, isLoading && /*#__PURE__*/React__default["default"].createElement(CustomLoader, null), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    className: "float-container"
  }, isButtonActive ? /*#__PURE__*/React__default["default"].createElement("center", {
    style: {
      position: 'relative',
      top: '0px'
    }
  }, "Adding... ", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, {
    indeterminate: true,
    active: true,
    inline: true,
    size: "small"
  })) : null, /*#__PURE__*/React__default["default"].createElement(List$1, {
    renderItem: renderItem,
    dataSource: billingsList
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    className: "grid-container"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4"
  }, isAddButton ? /*#__PURE__*/React__default["default"].createElement(AddBtn, {
    disabled: window.typeOfUser === 'BROKER_KN_ADMIN',
    isDisabled: false,
    id: "addBilling",
    onClick: handleAdd,
    text: "Add"
  }) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    disabled: isFormEnabled,
    basic: true,
    color: "blue",
    className: "btn-add-item",
    id: "cancelBilling",
    onClick: handleCancel
  }, /*#__PURE__*/React__default["default"].createElement("span", null, "CANCEL")), !isAddButton && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    disabled: existFlag,
    basic: true,
    color: "blue",
    className: "btn-add-item",
    id: "saveBilling",
    onClick: handleModal
  }, /*#__PURE__*/React__default["default"].createElement("span", null, "SAVE"))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4"
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "4"
  }), billingsList.length ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: "3",
    className: "divFormFeild  border-bottom"
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    type: "text",
    label: "Grand Total",
    id: "grandTotal",
    className: 'field-bg',
    clearInput: false,
    disabled: true,
    value: grandTotal && Number(grandTotal).toFixed(2)
  })) : null))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
    size: "tiny",
    open: isModalOpen,
    onClose: handleModal
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, {
    style: {
      textAlign: 'center',
      color: 'red'
    }
  }, "WARNING"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, null, /*#__PURE__*/React__default["default"].createElement("p", null, "Are you sure you want to save?"), /*#__PURE__*/React__default["default"].createElement("p", null, "Once you save you will not be able to edit")), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    negative: true,
    id: "saveConfirmationNo",
    onClick: handleModal
  }, "No"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    positive: true,
    id: "saveConfirmationYes",
    onClick: handleSaveApi
  }, "Yes"))));
};
var BillingForm$2 = /*#__PURE__*/React__default["default"].memo(BillingForm$1);

const BillingModule = props => {
  return /*#__PURE__*/React__default["default"].createElement(Provider, {
    store: store$3
  }, /*#__PURE__*/React__default["default"].createElement(BillingForm$2, props));
};
var BillingForm = /*#__PURE__*/React__default["default"].memo(BillingModule);

const CustomDatePicker = props => {
  const {
    id,
    label,
    isLabel,
    format = 'DD-MM-YYYY',
    onChange,
    onBlur,
    value: selectedValue,
    labelClassName = "",
    labelIcon,
    errors,
    isDisabled,
    name,
    minDate,
    maxDate,
    clearable = true
  } = props;
  if (errors && errors.length) ;
  const customLabelClassName = `name-label es ${labelClassName}`;
  const value = convertDateToUTC(selectedValue);
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    className: 'date-field'
  }, isLabel && /*#__PURE__*/React__default["default"].createElement(CustomLabel, {
    label: label,
    className: customLabelClassName,
    id: `${id}label`,
    labelIcon: labelIcon
  }), /*#__PURE__*/React__default["default"].createElement(SemanticDatepicker__default["default"], {
    name: name,
    id: id,
    clearable: value ? clearable : false,
    minDate: minDate,
    maxDate: maxDate,
    style: {
      width: "100%"
    },
    onDateChange: value => {
      value = String(convertDateToUTCEpoch(value));
      onChange && onChange(null, {
        value,
        name
      });
    },
    selected: value !== -999 && value > 0 && value !== undefined ? new Date(new Date(value)) : false,
    onBlur: event => onBlur && onBlur({
      target: {
        value,
        name
      }
    }),
    pointing: 'left',
    label: /*#__PURE__*/React__default["default"].createElement(CustomLabel, {
      id: `${id}label`,
      className: customLabelClassName,
      label: label,
      labelIcon: labelIcon,
      errors: errors
    }),
    icon: "calendar outline",
    format: format,
    disabled: isDisabled,
    clearOnSameDateClick: false
  }));
};
var DatePicker = ShipmentDataHOC(CustomDatePicker);

const GET_DROPDOWN_VALUES_NL = 'GET_DROPDOWN_VALUES_NL';
const GET_FORM_NL = 'GET_FORM_NL';
const SAVE_FORM_NL = 'SAVE_FORM_NL';
const SAVE_C88_ITEM = 'SAVE_C88_ITEM';
const GET_SHIPMENT_NOTES = 'GET_SHIPMENT_NOTES';
const SAVE_SHIPMENT_NOTES = 'SAVE_SHIPMENT_NOTES';
const SEARCH_DROPDOWN_VALUES_NL = 'SEARCH_DROPDOWN_VALUES_NL';
const DELETE_NL_ENTITY = 'DELETE_NL_ENTITY';
const GET_MOCK_RESPONSE = 'GET_MOCK_RESPONSE';

const getFormData = (shipmentId, declarationType) => {
  const data = {
    eventMessage: {
      shipmentId,
      formType: declarationType == 'IM' ? 'import' : 'export'
    },
    eventType: GET_FORM_NL,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getDropdownValues = isDMS => {
  const data = {
    eventMessage: {
      "fields": "",
      "system": isDMS ? "dms" : "ags"
    },
    eventType: GET_DROPDOWN_VALUES_NL,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getShipmentNotes = shipmentId => {
  const data = {
    eventMessage: {
      shipmentId
    },
    eventType: GET_SHIPMENT_NOTES,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getsearchcDropdownValuesNL = (dropdownType, searchFilter) => {
  const data = {
    eventMessage: {
      dropdownType: dropdownType,
      searchText: searchFilter,
      countryCode: 'nl'
    },
    eventType: SEARCH_DROPDOWN_VALUES_NL,
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getHTSData = (htsCode, country, eta) => {
  const data = {
    eventMessage: {
      htsCode,
      country,
      eta
    },
    eventType: 'GET_HTS_TREE',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getArtNumByHTSCode = htsCode => {
  const data = {
    eventMessage: {
      shipmentType: "EX",
      fromCountry: "CN",
      toCountry: "ES",
      inputCode: htsCode,
      nomenclatureType: "CN"
    },
    eventType: 'GET_HTS_METADATA_EU',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data
  });
};
const getNLHts = (payload, shipmentType = 'EX') => {
  const data = {
    eventMessage: {
      toCountry: 'EU',
      language: 'EN',
      inputCode: payload,
      nomenclatureType: shipmentType == 'EX' ? 'CN' : 'TARIC'
    },
    eventType: 'GET_HTS_TREE_EU',
    eventTime: Date.now()
  };
  if (payload.tariffTreatments) {
    data.eventMessage.tariffTreatments = payload.tariffTreatments;
  }
  return HttpClient.custom({
    data
  });
};

class HTSCodePopup extends React$1.Component {
  constructor() {
    super();
    _defineProperty$2(this, "lastnode_GB", null);
    _defineProperty$2(this, "uponeLevel", () => {
      let splitroot = this.state.root.split('.');
      if (splitroot.length > 1) {
        splitroot.pop();
        this.setState({
          root: splitroot.join('')
        });
      }
      this.getCodes();
    });
    _defineProperty$2(this, "getCodes", async () => {
      const {
        country
      } = this.props;
      const response = country == "GB" || country == 'US' ? await getHTSData(this.state.root.split('.').join('').substr(0, 6) || '', country == "GB" ? "UK" : country, Date.now()) : await getNLHts(this.state.root.split('.').join('').substr(0, 6) || '', this.props.shipmentType);
      //console.log('htsdata!response: ', response);
      let htsCodeLen = this.state.root.length;
      let htsCode = this.state.root;
      let selected = [this.state.root.substring(0, 4), ...(htsCodeLen > 4 ? [htsCode.substring(0, 6)] : []), ...(htsCodeLen > 6 ? [htsCode.substring(0, 8)] : []), ...(htsCodeLen > 8 ? [htsCode.substring(0, 10)] : [])];
      let treehts_lk = lodash.get(response, 'data.eventMessage', {});
      this.setState({
        treehts_lk: treehts_lk,
        selectedNode: treehts_lk,
        selectedCodes_pg: selected
      });
    });
    _defineProperty$2(this, "isLeafNode", mynode => {
      if (!mynode) return false;
      if (mynode.htsCode.length < 6) return false;
      if (this.props.country === 'UK' && this.props.declarationTypeValue === 'EX' && mynode.htsCode.replace(/\./g, '').length === 8) return true;
      return !mynode.htsNodes || mynode.htsNodes.length == 0;
    });
    _defineProperty$2(this, "isCompleteCode", code => {
      if (!code) return false;
      let codecleaned = code.split('.').join('').trim();
      if (this.props.country !== 'UK' && codecleaned.length > 10) return true;
      let firsttwo = parseInt(codecleaned.substr(0, 2));
      if (firsttwo > 97 && firsttwo < 100) {
        if (codecleaned.length === 8) return true;
      }
      if (this.props.country === 'UK' && this.props.hasOwnProperty('declarationTypeValue') === true && this.props.declarationTypeValue === 'EX' && codecleaned.replace(/\./g, '').length > 10) return true;
      if (this.props.country === 'UK' && this.props.hasOwnProperty('declarationTypeValue') === true && this.props.declarationTypeValue === 'IM' && codecleaned.replace(/\./g, '').length > 10) return true;
      return false;
    });
    _defineProperty$2(this, "debouncehts", null);
    _defineProperty$2(this, "getRoot", (rootCode, iconClick) => {
      let code = rootCode.replace(/[.]/g, '');
      if (!iconClick && this.isCompleteCode(code)) {
        return this.setState({
          toggle: false
        }, this.props.hidehtspopup());
      }
      clearTimeout(this.debouncehts);
      this.debouncehts = setTimeout(() => {
        if (code !== undefined) {
          //console.log('rootcode', res)
          this.setState({
            root: code.trim()
            // nextCodes: [],
            // selectedFirst: '',
            // selectedLast: '',
            // show: [],
            // showLast: [],
            // clickedIndex: '',
          }, () => this.getCodes());
        }
      }, 500);
    });
    _defineProperty$2(this, "closePane", () => {
      this.setState({
        treehts_lk: null
      }, this.props.hidehtspopup());
      this.props.country === 'UK' && this.props.nextFieldTOFocus != '' && document.getElementById(this.props.nextFieldTOFocus).focus();
    });
    _defineProperty$2(this, "handleHTSNodeSelectAndPossiblyClose", (e, node_xz) => {
      this.setState({
        selectedNode: node_xz
      });
      setTimeout(() => {
        if (this.isLeafNode(node_xz)) {
          this.handleHTSNodeSelect({
            keyCode: '13'
          }, node_xz);
        } else {
          this.handleHTSNodeSelect(e, node_xz);
        }
      }, 10);
    });
    _defineProperty$2(this, "handleHTSNodeSelect", (e, node_xz) => {
      //console.log('kethrhtr: ', e.keyCode  );
      if (e.keyCode == '38' || e.keyCode == '39' || e.keyCode == '40' || e.keyCode == '37' || e.keyCode == '13' || e.keyCode == '32' || e.keyCode == '8') {
        this.handleHTSNodeKeydown(e, node_xz);
        return;
      }
      if (e.keyCode == '27') {
        //esc
        this.closePane();
      }
      if (!e.keyCode) {
        ///Onclick
        this.setState({
          selectedNode: node_xz
        });
        if (node_xz.htsNodes) {
          if (this.state.selectedCodes_pg.indexOf(node_xz.htsCode) == -1) {
            this.setState({
              selectedCodes_pg: this.state.selectedCodes_pg.concat(node_xz.htsCode)
            });
          } else {
            this.setState({
              selectedCode_pg: this.state.selectedCodes_pg.splice(this.state.selectedCodes_pg.indexOf(node_xz.htsCode), 1)
            });
          }
        }
        if (this.isLeafNode(node_xz) || node_xz.htsCode.length == 4) {
          this.props.callbackwhenChanged(node_xz.htsCode);
        }
      }
    });
    _defineProperty$2(this, "openNode_kl", (e, node_xz) => {
      var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
      if (nodeindex >= 0) {
        this.setState({
          selectedCode_pg: this.state.selectedCodes_pg.splice(nodeindex, 1)
        });
      } else {
        if (node_xz.htsNodes) {
          this.setState({
            selectedCodes_pg: this.state.selectedCodes_pg.concat(node_xz.htsCode)
          });
        }
      }
    });
    _defineProperty$2(this, "handleHTSNodeHighlight", (e, node_xz) => {
      this.setState({
        selectedNode: node_xz
      });
    });
    _defineProperty$2(this, "handleHTSNodeKeydown", e => {
      const node_xz = this.state.selectedNode;
      if (!node_xz) node_xz = this.state.treehts_lk;
      //console.log('e,node_xz: ', e,node_xz);
      //console.log('ethrhtr: ', e.keyCode  );
      if (e.keyCode == '38') {
        //up
        this.setState({
          selectedNode: node_xz.prev || node_xz
        });
        //   document.getElementById((node_xz.prev || node_xz)+"HTSBYID")&&document.getElementById((node_xz.prev || node_xz)+"HTSBYID").focus()
      } else if (e.keyCode == '40') {
        //down
        this.setState({
          selectedNode: node_xz.next || node_xz
        });
        //  document.getElementById((node_xz.next || node_xz)+"HTSBYID")&&document.getElementById((node_xz.next || node_xz)+"HTSBYID").focus()
      } else if (e.keyCode == '37') {
        //left
        var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
        if (nodeindex >= 0) {
          if (nodeindex > 0) {
            this.setState({
              selectedCode_pg: this.state.selectedCodes_pg.splice(nodeindex, 1)
            });
          }
        } else {
          this.setState({
            selectedNode: node_xz.parentnode || node_xz
          });
        }
      } else if (e.keyCode == '8') {
        //backspace
        this.uponeLevel();
      } else if (e.keyCode == '39') {
        //right
        var nodeindex = this.state.selectedCodes_pg.indexOf(node_xz.htsCode);
        if (nodeindex < 0 && node_xz.htsNodes) {
          this.setState({
            selectedCodes_pg: this.state.selectedCodes_pg.concat(node_xz.htsCode)
          });
        } else {
          if (node_xz.htsNodes) {
            this.setState({
              selectedNode: node_xz.htsNodes[0]
            });
            //   document.getElementById(node_xz.htsNodes[0].htsCode+"HTSBYID")&& document.getElementById(node_xz.htsNodes[0].htsCode+"HTSBYID").focus();
          }
        }
      } else if (e.keyCode == '13' || e.keyCode == '32') {
        this.props.callbackwhenChanged(node_xz.htsCode);
        this.setState({
          pickedforui_sendtoparent: node_xz
        });
        if (this.props.country !== 'UK' && !node_xz.htsNodes) {
          // no children? You've come to a leaf. close the pane
          this.closePane();
        } else if (this.props.country === 'UK' && this.props.declarationTypeValue === 'EX' && node_xz.htsCode.replace(/\./g, '').length === 8) {
          this.closePane();
        } else if (this.props.country === 'UK' && this.props.declarationTypeValue === 'IM' && node_xz.htsCode.replace(/\./g, '').length === 10) {
          this.closePane();
        }
      }
      e.preventDefault && e.preventDefault();
    });
    _defineProperty$2(this, "HTSCodeWithDots", htsCode => {
      if (htsCode) return htsCode.substr(0, 4) + (htsCode.substr(4, 2) && '.' + htsCode.substr(4, 2)) + (htsCode.substr(6, 2) && '.' + htsCode.substr(6, 2)) + (htsCode.substr(8, 2) && '.' + htsCode.substr(8, 2));
      return '';
    });
    _defineProperty$2(this, "renderOneNode", (node_xz, parentnode, depthvv) => {
      if (!node_xz || !node_xz.htsCode) return /*#__PURE__*/React__default["default"].createElement("div", null);
      node_xz.prev = this.lastnode_GB;
      if (node_xz.prev) {
        node_xz.prev.next = node_xz;
      }
      this.lastnode_GB = node_xz;
      node_xz.parentnode = parentnode;
      return /*#__PURE__*/React__default["default"].createElement("li", {
        className: 'lihtslength' + node_xz.htsCode.length
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        type: "text",
        href: "#",
        style: {
          paddingLeft: depthvv * 16 + 'px'
        },
        id: node_xz.htsCode + 'HTSBYID',
        className: 'htsnode ' + (this.state.selectedNode == node_xz ? ' selected ' : ' ') + (node_xz.htsNodes ? ' haschildren ' : ' nochildren ') + (this.state.selectedCodes_pg.indexOf(node_xz.htsCode) >= 0 ? ' highlightedrow ' : ' ') + ('htslength' + node_xz.htsCode.replace(/[.]/g, '').length),
        onKeyDown: e => {
          this.handleHTSNodeSelect(e, node_xz);
        }

        // onDoubleClick={(e) => {

        // }}
      }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
        className: 'htsicon ' + (this.state.selectedCodes_pg.indexOf(node_xz.htsCode) >= 0 ? ' rotated ' : ' '),
        icon: "angle right",
        style: {
          visibility: node_xz.htsNodes ? 'visible' : 'hidden'
        },
        onClick: e => {
          this.handleHTSNodeSelect(e, node_xz);
        }
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
        className: 'htsicon greencheck',
        icon: "check",
        style: {
          display: node_xz == this.state.pickedforui_sendtoparent ? 'inline' : 'none'
        }
      }), /*#__PURE__*/React__default["default"].createElement("span", {
        onClick: e => {
          this.handleHTSNodeSelectAndPossiblyClose(e, node_xz);
        }
      }, node_xz.htsCode.substr(0, 4), /*#__PURE__*/React__default["default"].createElement("b", null, node_xz.htsCode.substr(4)), "\xA0\xA0", node_xz.htsScheduleDescription && node_xz.htsScheduleDescription.substring(0, 60) || ''), "\xA0\xA0", parentnode && parentnode.tariff && parentnode.tariff.usTariff && /*#__PURE__*/React__default["default"].createElement("span", {
        onClick: e => {
          this.handleHTSNodeHighlight(e, node_xz);
        },
        style: {
          color: 'blue'
        }
      }, this.state.selectedNode && this.state.selectedNode.htsCode && this.state.selectedNode.htsCode == node_xz.htsCode ? '( - )' : '( + )')), this.state.selectedNode && this.state.selectedNode.htsCode && this.state.selectedNode.htsCode == node_xz.htsCode && parentnode && parentnode.tariff && parentnode.tariff.usTariff && /*#__PURE__*/React__default["default"].createElement("ul", null, /*#__PURE__*/React__default["default"].createElement("li", {
        className: "showtariffs"
      }, "General Tax Rate:", ' ', parentnode.tariff && parentnode.tariff.usTariff && parentnode.tariff.usTariff.generalTaxRate, /*#__PURE__*/React__default["default"].createElement("br", null), "Other Tax Rate:", ' ', parentnode.tariff && parentnode.tariff.usTariff && parentnode.tariff.usTariff.otherTaxRate, /*#__PURE__*/React__default["default"].createElement("br", null), "Special Tax Rate:", ' ', parentnode.tariff && parentnode.tariff.usTariff && parentnode.tariff.usTariff.specialTaxRate, /*#__PURE__*/React__default["default"].createElement("br", null)))), node_xz.htsNodes && this.state.selectedCodes_pg.indexOf(node_xz.htsCode) >= 0 && node_xz.htsNodes.map((onenode, iiiibi) => {
        return /*#__PURE__*/React__default["default"].createElement("ul", {
          key: iiiibi
        }, this.renderOneNode(onenode, node_xz, depthvv + 1));
      }));
    });
    this.state = {
      root: '',
      codes: [],
      nextCodes: [],
      selectedNode: null,
      selectedCodes_pg: [],
      pickedforui_sendtoparent: null,
      toggle: false,
      selectedFirst: '',
      selectedLast: '',
      show: [],
      showLast: [],
      clickedIndex: '',
      htsEllipses: true
    };
    this.getRoot = this.getRoot.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  componentDidMount() {
    if (this.props.country === 'UK') {
      this.getRoot(this.props.code.split('.').join(''));
    }
  }
  componentWillReceiveProps(nextProps) {
    // if(nextProps.code && nextProps.code.length>8){
    //   return;

    // }
    if (nextProps.code !== this.state.root) {
      this.getRoot(nextProps.code);
      return;
    }
    let useCode = this.props.code;
    if (this.props.code !== this.props.mapCode) {
      useCode = this.props.mapCode.split('.');
      useCode = useCode[0].concat(useCode[1]);
      this.getRoot(useCode);
    }
  }
  render() {
    //console.log('this.state.treehts_lk: ', this.state.treehts_lk);
    if (!this.state.treehts_lk) return null;
    if (this.props.disabled) return null;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      tabIndex: "0",
      className: 'hts-popup-container-es text-align-start',
      ref: this.setWrapperRef
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        marginBottom: '15px'
      }
    }, ' ', /*#__PURE__*/React__default["default"].createElement("b", null, ' ', "HTS Selector codes for ", this.state.root.substr(0, 4), this.state.root.substr(4, 2) && '.' + this.state.root.substr(4, 2), this.state.root.substr(6, 2) && '.' + this.state.root.substr(6, 2), this.state.root.substr(8, 2) && '.' + this.state.root.substr(8, 2), ' '), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      className: 'htsiconclose',
      icon: "close",
      onClick: () => this.closePane()
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "legendholder"
    }, "?", /*#__PURE__*/React__default["default"].createElement("div", null, "Keys:", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Left:"), " Close HTS/Go to higher HTSes", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Right:"), " Open HTS/Go to lower HTSes", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Up:"), " Navigate Upward", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Down:"), " Navigate Downward", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Enter/Spacebar:"), " Select HTS", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Esc:"), " Close pane", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Backspace:"), " Search on a more general HTS", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Single-click:"), " Focus an HTS", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("b", null, "Double-click:"), " Select and close", /*#__PURE__*/React__default["default"].createElement("br", null)))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: 'hts-popup-list'
    }, this.state.root.split('.').length > 1 && /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        cursor: 'pointer'
      },
      title: "Hotkey: backspace",
      onClick: () => this.uponeLevel()
    }, "..[Up one level]"), /*#__PURE__*/React__default["default"].createElement("ul", null, this.renderOneNode(this.state.treehts_lk, null, 0))));
  }
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike_1(value) &&
      (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

function HtsMetadataModal(props) {
  var _props$htsMetaData, _props$htsMetaData2, _props$htsMetaData3, _props$htsMetaData4, _props$htsMetaData5, _props$htsMetaData5$d, _props$htsMetaData6, _props$htsMetaData6$d, _props$htsMetaData7, _props$htsMetaData7$a, _props$htsMetaData8, _props$htsMetaData8$a, _props$htsMetaData9, _props$htsMetaData9$a, _props$htsMetaData10, _props$htsMetaData10$, _props$htsMetaData11, _props$htsMetaData11$, _props$htsMetaData12, _props$htsMetaData12$, _props$htsMetaData13, _props$htsMetaData13$, _props$htsMetaData14, _props$htsMetaData14$, _props$htsMetaData15, _props$htsMetaData15$, _props$htsMetaData16, _props$htsMetaData16$, _props$htsMetaData17, _props$htsMetaData17$, _props$htsMetaData18, _props$htsMetaData18$, _Array, _props$htsMetaData19, _props$htsMetaData19$;
  const {
    preferences,
    reduction,
    translate
  } = props;
  const [reason, setReason] = React$1.useState(props.cancelReason);
  const [loading, setLoadingState] = React$1.useState(false);
  const htsMetaData = (props === null || props === void 0 ? void 0 : props.htsMetaData) || {};
  const additionalDocs = ((_props$htsMetaData = props.htsMetaData) === null || _props$htsMetaData === void 0 ? void 0 : _props$htsMetaData.additionalCodes) || [];
  const antiDumpingAdditionalCodes = ((_props$htsMetaData2 = props.htsMetaData) === null || _props$htsMetaData2 === void 0 ? void 0 : _props$htsMetaData2.antiDumpingAdditionalCodes) || [];
  const supplementaryUnits = ((_props$htsMetaData3 = props.htsMetaData) === null || _props$htsMetaData3 === void 0 ? void 0 : _props$htsMetaData3.supplementaryUnits) || [];
  let [payload, setPayload] = React$1.useState({
    description: (_props$htsMetaData4 = props.htsMetaData) === null || _props$htsMetaData4 === void 0 ? void 0 : _props$htsMetaData4.description,
    dutyRate: ((_props$htsMetaData5 = props.htsMetaData) === null || _props$htsMetaData5 === void 0 ? void 0 : (_props$htsMetaData5$d = _props$htsMetaData5.duty) === null || _props$htsMetaData5$d === void 0 ? void 0 : _props$htsMetaData5$d.length) === 1 && ((_props$htsMetaData6 = props.htsMetaData) === null || _props$htsMetaData6 === void 0 ? void 0 : (_props$htsMetaData6$d = _props$htsMetaData6.duty[0]) === null || _props$htsMetaData6$d === void 0 ? void 0 : _props$htsMetaData6$d.duty) || '',
    additionalCode1: ((_props$htsMetaData7 = props.htsMetaData) === null || _props$htsMetaData7 === void 0 ? void 0 : (_props$htsMetaData7$a = _props$htsMetaData7.additionalDocs) === null || _props$htsMetaData7$a === void 0 ? void 0 : _props$htsMetaData7$a.length) === 1 && ((_props$htsMetaData8 = props.htsMetaData) === null || _props$htsMetaData8 === void 0 ? void 0 : (_props$htsMetaData8$a = _props$htsMetaData8.additionalDocs[0]) === null || _props$htsMetaData8$a === void 0 ? void 0 : _props$htsMetaData8$a.code) || '',
    additionalCode2: ((_props$htsMetaData9 = props.htsMetaData) === null || _props$htsMetaData9 === void 0 ? void 0 : (_props$htsMetaData9$a = _props$htsMetaData9.antiDumpingAdditionalCodes) === null || _props$htsMetaData9$a === void 0 ? void 0 : _props$htsMetaData9$a.length) === 1 && ((_props$htsMetaData10 = props.htsMetaData) === null || _props$htsMetaData10 === void 0 ? void 0 : (_props$htsMetaData10$ = _props$htsMetaData10.antiDumpingAdditionalCodes[0]) === null || _props$htsMetaData10$ === void 0 ? void 0 : _props$htsMetaData10$.code) || '',
    preference: ((_props$htsMetaData11 = props.htsMetaData) === null || _props$htsMetaData11 === void 0 ? void 0 : (_props$htsMetaData11$ = _props$htsMetaData11.preferences) === null || _props$htsMetaData11$ === void 0 ? void 0 : _props$htsMetaData11$.length) === 1 && ((_props$htsMetaData12 = props.htsMetaData) === null || _props$htsMetaData12 === void 0 ? void 0 : (_props$htsMetaData12$ = _props$htsMetaData12.preferences[0]) === null || _props$htsMetaData12$ === void 0 ? void 0 : _props$htsMetaData12$.slice(0, 1)) || '',
    reduction: ((_props$htsMetaData13 = props.htsMetaData) === null || _props$htsMetaData13 === void 0 ? void 0 : (_props$htsMetaData13$ = _props$htsMetaData13.preferences) === null || _props$htsMetaData13$ === void 0 ? void 0 : _props$htsMetaData13$.length) === 1 && ((_props$htsMetaData14 = props.htsMetaData) === null || _props$htsMetaData14 === void 0 ? void 0 : (_props$htsMetaData14$ = _props$htsMetaData14.preferences[0]) === null || _props$htsMetaData14$ === void 0 ? void 0 : _props$htsMetaData14$.slice(1)) || '',
    unitType: ((_props$htsMetaData15 = props.htsMetaData) === null || _props$htsMetaData15 === void 0 ? void 0 : (_props$htsMetaData15$ = _props$htsMetaData15.measureUnits) === null || _props$htsMetaData15$ === void 0 ? void 0 : _props$htsMetaData15$.length) === 1 && ((_props$htsMetaData16 = props.htsMetaData) === null || _props$htsMetaData16 === void 0 ? void 0 : (_props$htsMetaData16$ = _props$htsMetaData16.measureUnits[0]) === null || _props$htsMetaData16$ === void 0 ? void 0 : _props$htsMetaData16$.code) || '',
    supUnitType: ((_props$htsMetaData17 = props.htsMetaData) === null || _props$htsMetaData17 === void 0 ? void 0 : (_props$htsMetaData17$ = _props$htsMetaData17.supplementaryUnits) === null || _props$htsMetaData17$ === void 0 ? void 0 : _props$htsMetaData17$.length) === 1 && ((_props$htsMetaData18 = props.htsMetaData) === null || _props$htsMetaData18 === void 0 ? void 0 : (_props$htsMetaData18$ = _props$htsMetaData18.supplementaryUnits[0]) === null || _props$htsMetaData18$ === void 0 ? void 0 : _props$htsMetaData18$.code) || '',
    doc: ((_Array = new Array((_props$htsMetaData19 = props.htsMetaData) === null || _props$htsMetaData19 === void 0 ? void 0 : (_props$htsMetaData19$ = _props$htsMetaData19.conditions) === null || _props$htsMetaData19$ === void 0 ? void 0 : _props$htsMetaData19$.length)) === null || _Array === void 0 ? void 0 : _Array.fill('')) || []
  });
  let lang = instance.language || window.localStorage.i18nextLng || "en";
  let textKey = lang !== "en" ? `text_${lang}` : `text`;
  React$1.useEffect(() => {
    var _props$htsMetaData20, _props$htsMetaData21, _props$htsMetaData21$, _props$htsMetaData22, _props$htsMetaData23, _props$htsMetaData23$, _props$htsMetaData24, _props$htsMetaData24$, _props$htsMetaData25, _props$htsMetaData25$, _props$htsMetaData26, _props$htsMetaData26$, _props$htsMetaData27, _props$htsMetaData27$, _props$htsMetaData28, _props$htsMetaData28$, _props$htsMetaData29, _props$htsMetaData29$, _props$htsMetaData30, _props$htsMetaData30$, _props$htsMetaData31, _props$htsMetaData31$, _props$htsMetaData32, _props$htsMetaData32$, _props$htsMetaData33, _props$htsMetaData33$, _props$htsMetaData34, _props$htsMetaData34$, _Array2, _props$htsMetaData35, _props$htsMetaData35$;
    setPayload({
      description: (_props$htsMetaData20 = props.htsMetaData) === null || _props$htsMetaData20 === void 0 ? void 0 : _props$htsMetaData20.description,
      dutyRate: ((_props$htsMetaData21 = props.htsMetaData) === null || _props$htsMetaData21 === void 0 ? void 0 : (_props$htsMetaData21$ = _props$htsMetaData21.duty) === null || _props$htsMetaData21$ === void 0 ? void 0 : _props$htsMetaData21$.length) === 1 && ((_props$htsMetaData22 = props.htsMetaData) === null || _props$htsMetaData22 === void 0 ? void 0 : _props$htsMetaData22.duty[0]) || {},
      additionalCode1: ((_props$htsMetaData23 = props.htsMetaData) === null || _props$htsMetaData23 === void 0 ? void 0 : (_props$htsMetaData23$ = _props$htsMetaData23.additionalDocs) === null || _props$htsMetaData23$ === void 0 ? void 0 : _props$htsMetaData23$.length) === 1 && ((_props$htsMetaData24 = props.htsMetaData) === null || _props$htsMetaData24 === void 0 ? void 0 : (_props$htsMetaData24$ = _props$htsMetaData24.additionalDocs[0]) === null || _props$htsMetaData24$ === void 0 ? void 0 : _props$htsMetaData24$.code) || '',
      additionalCode2: ((_props$htsMetaData25 = props.htsMetaData) === null || _props$htsMetaData25 === void 0 ? void 0 : (_props$htsMetaData25$ = _props$htsMetaData25.antiDumpingAdditionalCodes) === null || _props$htsMetaData25$ === void 0 ? void 0 : _props$htsMetaData25$.length) === 1 && ((_props$htsMetaData26 = props.htsMetaData) === null || _props$htsMetaData26 === void 0 ? void 0 : (_props$htsMetaData26$ = _props$htsMetaData26.antiDumpingAdditionalCodes[0]) === null || _props$htsMetaData26$ === void 0 ? void 0 : _props$htsMetaData26$.code) || '',
      preference: ((_props$htsMetaData27 = props.htsMetaData) === null || _props$htsMetaData27 === void 0 ? void 0 : (_props$htsMetaData27$ = _props$htsMetaData27.preferences) === null || _props$htsMetaData27$ === void 0 ? void 0 : _props$htsMetaData27$.length) === 1 && ((_props$htsMetaData28 = props.htsMetaData) === null || _props$htsMetaData28 === void 0 ? void 0 : (_props$htsMetaData28$ = _props$htsMetaData28.preferences[0]) === null || _props$htsMetaData28$ === void 0 ? void 0 : _props$htsMetaData28$.slice(0, 1)) || '',
      reduction: ((_props$htsMetaData29 = props.htsMetaData) === null || _props$htsMetaData29 === void 0 ? void 0 : (_props$htsMetaData29$ = _props$htsMetaData29.preferences) === null || _props$htsMetaData29$ === void 0 ? void 0 : _props$htsMetaData29$.length) === 1 && ((_props$htsMetaData30 = props.htsMetaData) === null || _props$htsMetaData30 === void 0 ? void 0 : (_props$htsMetaData30$ = _props$htsMetaData30.preferences[0]) === null || _props$htsMetaData30$ === void 0 ? void 0 : _props$htsMetaData30$.slice(1)) || '',
      unitType: ((_props$htsMetaData31 = props.htsMetaData) === null || _props$htsMetaData31 === void 0 ? void 0 : (_props$htsMetaData31$ = _props$htsMetaData31.measureUnits) === null || _props$htsMetaData31$ === void 0 ? void 0 : _props$htsMetaData31$.length) === 1 && ((_props$htsMetaData32 = props.htsMetaData) === null || _props$htsMetaData32 === void 0 ? void 0 : (_props$htsMetaData32$ = _props$htsMetaData32.measureUnits[0]) === null || _props$htsMetaData32$ === void 0 ? void 0 : _props$htsMetaData32$.code) || '',
      supUnitType: ((_props$htsMetaData33 = props.htsMetaData) === null || _props$htsMetaData33 === void 0 ? void 0 : (_props$htsMetaData33$ = _props$htsMetaData33.supplementaryUnits) === null || _props$htsMetaData33$ === void 0 ? void 0 : _props$htsMetaData33$.length) === 1 && ((_props$htsMetaData34 = props.htsMetaData) === null || _props$htsMetaData34 === void 0 ? void 0 : (_props$htsMetaData34$ = _props$htsMetaData34.supplementaryUnits[0]) === null || _props$htsMetaData34$ === void 0 ? void 0 : _props$htsMetaData34$.code) || '',
      doc: ((_Array2 = new Array((_props$htsMetaData35 = props.htsMetaData) === null || _props$htsMetaData35 === void 0 ? void 0 : (_props$htsMetaData35$ = _props$htsMetaData35.conditions) === null || _props$htsMetaData35$ === void 0 ? void 0 : _props$htsMetaData35$.length)) === null || _Array2 === void 0 ? void 0 : _Array2.fill('')) || []
    });
  }, [props.htsMetaData]);
  const handleSubmit = async () => {
    setLoadingState(true);
    try {
      props.submit(payload);
    } catch (err) {
      console.error(err);
      props.setShowModal(false);
      setLoadingState(false);
    } finally {
      setLoadingState(false);
      props.setShowModal(false);
    }
  };
  const modalContent = htsMetaData => {
    var _htsMetaData$rest, _htsMetaData$rest3, _htsMetaData$conditio;
    if ((htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest = htsMetaData.rest) === null || _htsMetaData$rest === void 0 ? void 0 : _htsMetaData$rest.code) === 400) {
      var _htsMetaData$rest2;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest2 = htsMetaData.rest) === null || _htsMetaData$rest2 === void 0 ? void 0 : _htsMetaData$rest2.msg))));
    }
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
      width: "equal"
    }, !isEmpty_1(htsMetaData) || (htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest3 = htsMetaData.rest) === null || _htsMetaData$rest3 === void 0 ? void 0 : _htsMetaData$rest3.code) !== 400 ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, htsMetaData.description && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'duties'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('DESCRIPTION'), ":"), " ", htsMetaData.description)), Object.keys(htsMetaData).length === 2 && 'description' in htsMetaData ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      style: {
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        fontStyle: 'italic',
        fontWeight: 'bold'
      }
    }, translate('No action required for this HTS code.')), ' ') : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, htsMetaData.duty && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'dutiesRate'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('DUTY_RATE'), ":"))), htsMetaData.duty && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.duty.map((item, index) => {
      var _payload$dutyRate, _htsMetaData$duty;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        key: `duty-${index}`,
        width: "4"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
        label: `${item.duty} - ${item.description}`,
        name: "dutyRate",
        value: item,
        checked: (payload === null || payload === void 0 ? void 0 : (_payload$dutyRate = payload.dutyRate) === null || _payload$dutyRate === void 0 ? void 0 : _payload$dutyRate.duty) === item.duty || (htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$duty = htsMetaData.duty) === null || _htsMetaData$duty === void 0 ? void 0 : _htsMetaData$duty.length) === 1
        // defaultChecked={}
        ,
        onChange: (e, {
          value
        }) => {
          setPayload(prev => {
            return {
              ...prev,
              dutyRate: value
            };
          });
          // payload.dutyRate = data.value
        }
      }));
    })), htsMetaData.measureUnits && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'measureUnits'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('MEASURE_UNIT'), ":"))), htsMetaData.measureUnits && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.measureUnits.map((item, index) => {
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        key: `unitTypes-${index}`,
        width: "4"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
        type: "radio",
        label: `${item.code} - ${item.description}`,
        name: "unitTypes",
        checked: payload.unitType === item.code || htsMetaData.measureUnits.length === 1
        // defaultChecked=}
        ,
        value: item.code,
        onClick: (e, {
          value
        }) => {
          // data.checked &&= false
          setPayload(prev => {
            return {
              ...prev,
              unitType: value
            };
          });

          // payload.unitType = data.value
        }
      }));
    })), supplementaryUnits.length > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'supplementaryUnits'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('SUPP_UNIT'), ":"))), supplementaryUnits.length > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.supplementaryUnits.map((item, index) => {
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        key: `unitTypes-${index}`
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
        type: "radio",
        label: `${item.code} - ${item.description}`,
        name: "supplementaryUnits",
        checked: payload.supUnitType === item.code || htsMetaData.supplementaryUnits.length === 1
        // defaultChecked=}
        ,
        value: item.code,
        onChange: (e, {
          value
        }) => {
          // data.checked &&= false
          setPayload(prev => {
            return {
              ...prev,
              supUnitType: value
            };
          });
          payload.supUnitType = value;
        }
      }));
    })), ((_htsMetaData$conditio = htsMetaData.conditions) === null || _htsMetaData$conditio === void 0 ? void 0 : _htsMetaData$conditio.length) > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      key: 'conditions',
      style: {
        marginBottom: '-1em'
      }
    }, /*#__PURE__*/React__default["default"].createElement("strong", null, "CONDITIONS:")), htsMetaData.conditions.map((condition, i) => {
      var _condition$certificat;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
        width: "16"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        width: "12",
        style: {
          color: '#1765ae',
          fontSize: '1.2em',
          marginLeft: '.5em'
        }
      }, condition.conditionDescription), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        width: "2"
      }, `(${condition === null || condition === void 0 ? void 0 : (_condition$certificat = condition.certificate[0]) === null || _condition$certificat === void 0 ? void 0 : _condition$certificat.id})`), condition.certificate.map((certs, index) => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
        key: `certificates-${index}`,
        width: "12",
        style: {
          marginLeft: '1em'
        }
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
        label: certs.code ? `${certs === null || certs === void 0 ? void 0 : certs.code}- ${certs === null || certs === void 0 ? void 0 : certs.codeDescription}` : `${certs === null || certs === void 0 ? void 0 : certs.idDescription} -> if id = ${certs.id}`,
        name: `condition-${i}`,
        style: {
          marginLeft: '1.8em'
        },
        checked: payload.doc[i] == certs.code,
        value: certs === null || certs === void 0 ? void 0 : certs.code,
        onChange: (e, {
          value
        }) => {
          let document = [...payload.doc];
          document.splice(i, 1, value);
          console.log({
            value,
            document
          });
          setPayload(prev => {
            return {
              ...prev,
              doc: document
            };
          });
        }
      }))));
    })), htsMetaData.additionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'additional-Codes'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('ADD_CODES_1'), ":"))), htsMetaData.additionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.additionalCodes.map((item, index) => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      key: `additonalCodes1-${index}`,
      width: "8"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      label: `${item === null || item === void 0 ? void 0 : item.code} - ${item.description}`,
      name: 'additonalCodes1',
      checked: item.code === payload.additionalCode1 || additionalDocs.length === 1,
      value: item.code,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            additionalCode1: value
          };
        });
      }
    })))), htsMetaData.antiDumpingAdditionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'additional-Codes2'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('ADD_CODES_2'), ":"))), htsMetaData.antiDumpingAdditionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.antiDumpingAdditionalCodes.map((item, index) => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      key: `additionalCodes2-${index}`,
      width: "8"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      label: `${item === null || item === void 0 ? void 0 : item.code} - ${item.description}`,
      name: 'additionalCodes2',
      checked: item.code === payload.additionalCode2 || antiDumpingAdditionalCodes.length === 1,
      value: item.code,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            additionalCode2: value
          };
        });
      }
    })))), htsMetaData.preferences && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
      key: 'Preferences'
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("strong", null, translate('PREFERENCES'), ":"))), htsMetaData.preferences && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, htsMetaData.preferences.map((item, index) => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      key: `preferences-${index}`,
      width: "14"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      style: {
        whiteSpace: 'pre-line'
      },
      label: `${translate('PREFERENCE')} :: ${item.substring(0, 1)} - ${preferences === null || preferences === void 0 ? void 0 : preferences.filter(e => e.value === item.substring(0, 1))[0][textKey]} 
                        ${translate('REDUCTION')} :: ${item.slice(1)} - ${reduction === null || reduction === void 0 ? void 0 : reduction.filter(e => e.value === item.slice(1))[0][textKey]}`,
      name: "preferences"
      // defaultChecked={htsMetaData.preferences.length === 1}
      ,
      value: item,
      checked: item === payload.preference + payload.reduction || htsMetaData.preferences.length === 1,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            preference: value.slice(0, 1),
            reduction: value.slice(1)
          };
        });
      }
    })))))) : /*#__PURE__*/React__default["default"].createElement("p1", null, translate('No action required for this HTS code'))));
  };
  const modalWindow = htsMetaData => {
    var _htsMetaData$rest4;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
      id: "htsMetadataModal",
      className: "htsMetadataModal",
      trigger: props.trigger,
      open: props.showModal,
      onOpen: () => {
        setReason('');
      }
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, null, translate("HTS_POPUP_HEADER")), modalContent(htsMetaData), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      basic: true,
      color: "blue",
      onClick: () => {
        props.setShowModal(false);
      }
    }, translate("CANCEL")), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      primary: true,
      loading: loading,
      disabled: isEmpty_1(htsMetaData) || (htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest4 = htsMetaData.rest) === null || _htsMetaData$rest4 === void 0 ? void 0 : _htsMetaData$rest4.code) === 400,
      onClick: () => {
        handleSubmit();
      }
    }, translate("SUBMIT"))));
  };
  return modalWindow(htsMetaData);
}

const ModalLoader = props => {
  const {
    loading,
    message = 'Data is Loading. Please wait ....'
  } = props;
  return loading && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
    open: loading
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Description, {
    style: {
      alignItems: 'center',
      justifyDescription: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(CustomLoader, null, /*#__PURE__*/React__default["default"].createElement("p", null, message))));
};

const DataList = ({
  data
}) => {
  return /*#__PURE__*/React__default["default"].createElement("ol", null, data.map((item, index) => /*#__PURE__*/React__default["default"].createElement("li", {
    key: index
  }, `${index + 1}. ${item.description}`)));
};
const RadioWithPopup = ({
  code,
  description,
  duties,
  footNotes,
  conditions,
  data,
  callback,
  valueKey,
  setDutyList
}) => {
  var _conditions$, _conditions$2;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: 7,
    style: {
      marginRight: '.5rem',
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
    label: `${code} - ${description === null || description === void 0 ? void 0 : description.slice(0, 30)}`,
    name: valueKey,
    style: {
      fontWeight: 'lighter'
    },
    checked: code === data[valueKey][0],
    value: code,
    onChange: (e, {
      value
    }) => {
      setDutyList && setDutyList(duties);
      callback(prev => {
        if (valueKey === 'preference') return {
          ...prev,
          [valueKey]: [value, '', ''],
          dutyRate: ''
        };else {
          return {
            ...prev,
            [valueKey]: [value, '', '']
          };
        }
      });
    }
  }), (description === null || description === void 0 ? void 0 : description.length) > 30 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    content: description,
    style: {
      zIndex: 10000,
      position: 'relative',
      left: '-1rem'
    },
    position: "bottom left",
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "add",
      color: "red",
      size: "tiny",
      style: {
        position: 'relative',
        top: '-.8rem'
      }
    })
  }), footNotes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    content: /*#__PURE__*/React__default["default"].createElement(DataList, {
      data: footNotes
    }),
    style: {
      zIndex: 10000,
      position: 'relative',
      left: '-1rem'
    },
    size: "tiny",
    wide: true,
    trigger: /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        position: 'relative',
        top: '-0.65rem',
        left: '1rem',
        color: '#2d8cd3'
      }
    }, "FootNotes")
  }), conditions && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    columns: 1,
    style: {
      marginLeft: '1.5rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement("h4", null, (_conditions$ = conditions[0]) === null || _conditions$ === void 0 ? void 0 : _conditions$.conditionDescription), (_conditions$2 = conditions[0]) === null || _conditions$2 === void 0 ? void 0 : _conditions$2.items.map((e, index) => {
    var _e$action, _e$action$amount, _e$certificate;
    let amount = (_e$action = e.action) === null || _e$action === void 0 ? void 0 : (_e$action$amount = _e$action.amount) === null || _e$action$amount === void 0 ? void 0 : _e$action$amount.split(',').join('.');
    let certCode = (_e$certificate = e.certificate) === null || _e$certificate === void 0 ? void 0 : _e$certificate.code;
    let label = '';
    if (amount && certCode) label = `Apply the duty amount ${amount} and certificate ${certCode}`;else if (amount && !certCode) label = `Apply the duty amount ${amount}`;else if (!amount && certCode) label = `Apply the certificate ${certCode}`;
    if (label) {
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
        key: index,
        label: label,
        name: `${label}-certs`,
        checked: data[valueKey][0] === code && data[valueKey][1] === amount,
        style: {
          fontWeight: 'lighter'
        },
        value: [code, amount, certCode],
        onChange: (e, {
          value
        }) => callback(prev => {
          return {
            ...prev,
            [valueKey]: value
          };
        })
      });
    }
  }))));
};
const ESHtsMetaDataModal = ({
  translate,
  showModal,
  setShowModal,
  htsMetaData,
  submit,
  taricCode
}) => {
  var _preferenceCodes$, _htsMetaData$rest, _htsMetaData$rest2;
  const {
    antiDumpingAdditionalCodes,
    preferenceCodes,
    htsCodeValidity,
    supplementaryUnits,
    conditions,
    additionalCodes,
    vatDuties,
    exciseDuties,
    unitPrice,
    rest
  } = htsMetaData;
  const hasError = (rest === null || rest === void 0 ? void 0 : rest.code) === 400 || htsCodeValidity === 2;
  const [dutyList, setDutyList] = React$1.useState(preferenceCodes ? (_preferenceCodes$ = preferenceCodes[0]) === null || _preferenceCodes$ === void 0 ? void 0 : _preferenceCodes$.duties : null);
  const [loading, setLoadingState] = React$1.useState(false);
  const controls = conditions ? convertedData(conditions) : null;
  const defaultPayload = {
    dutyRate: '',
    preference: ['', '', ''],
    antiDumping: ['', '', ''],
    controls: ['', '', ''],
    supUnitType: '',
    additionalCode1: '',
    vatDuty: '',
    exciseCodeVal: ''
  };
  let [payload, setPayload] = React$1.useState(defaultPayload);
  React$1.useEffect(() => {
    if (preferenceCodes) setDutyList(preferenceCodes[0].duties);
    setPayload(defaultPayload);
  }, [preferenceCodes]);
  const handleSubmit = async () => {
    setLoadingState(true);
    try {
      submit(payload);
    } catch (err) {
      console.error(err);
      setShowModal(false);
      setLoadingState(false);
    } finally {
      setLoadingState(false);
      setShowModal(false);
    }
  };
  if (!showModal) return null;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
    id: "htsMetadataModal",
    open: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, {
    style: {
      fontWeight: 'lighter',
      fontSize: 'small'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, "Please Check Always : "), /*#__PURE__*/React__default["default"].createElement("a", {
    href: "https://sede.agenciatributaria.gob.es/Sede/procedimientoini/DD09.shtml",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "https://sede.agenciatributaria.gob.es/Sede/procedimientoini/DD09.shtml")), ' ', "Taric Code = ", taricCode), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Description, null, hasError ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h4", null, htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest = htsMetaData.rest) === null || _htsMetaData$rest === void 0 ? void 0 : _htsMetaData$rest.msg))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, preferenceCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    style: {
      width: '170%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Preferences'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    columns: 2
  }, preferenceCodes.map((elem, index) => /*#__PURE__*/React__default["default"].createElement(RadioWithPopup, _extends$1({
    key: index
  }, elem, {
    data: payload,
    callback: setPayload,
    setDutyList: setDutyList,
    valueKey: "preference"
  }))))), dutyList && preferenceCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Divider, {
    style: {
      width: '150%',
      marginLeft: '-0.5rem'
    }
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    style: {
      justifyContent: 'space-between'
    }
  }, dutyList && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Duties'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, dutyList.map((duty, index) => {
    let rate = duty === null || duty === void 0 ? void 0 : duty.split(',').join('.');
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      key: index,
      label: rate,
      name: "duties",
      style: {
        fontWeight: 'lighter'
      },
      value: rate,
      checked: payload.dutyRate === rate,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            dutyRate: value
          };
        });
      }
    }));
  }))), vatDuties && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('VAT'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, vatDuties.map((unit, index) => {
    var _unit$duty;
    let vatRate = (_unit$duty = unit.duty) === null || _unit$duty === void 0 ? void 0 : _unit$duty.split(',').join('.');
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      key: index,
      label: vatRate,
      name: "vatDuties",
      style: {
        fontWeight: 'lighter'
      },
      checked: payload.vatDuty === (vatRate === null || vatRate === void 0 ? void 0 : vatRate.replace(/%/g, '')),
      value: vatRate === null || vatRate === void 0 ? void 0 : vatRate.replace(/%/g, ''),
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            vatDuty: value
          };
        });
      }
    }));
  }))), additionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Add. EU Code'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, additionalCodes.map((unit, index) => {
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      key: index,
      label: unit.code,
      name: "additionalCodes",
      style: {
        fontWeight: 'lighter'
      },
      checked: unit.code === payload.additionalCode1,
      value: unit.code,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            additionalCode1: value
          };
        });
      }
    }));
  })))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    style: {
      justifyContent: 'space-between'
    }
  }, exciseDuties && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Excise Code'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, exciseDuties.map((unit, index) => {
    var _unit$duty2;
    let exciseCodeRate = '0' + ((_unit$duty2 = unit.duty) === null || _unit$duty2 === void 0 ? void 0 : _unit$duty2.substring(1));
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      key: index,
      label: unit.duty,
      name: "exciseDuties",
      style: {
        fontWeight: 'lighter'
      },
      checked: payload.exciseCodeVal === exciseCodeRate,
      value: exciseCodeRate,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            exciseCodeVal: value
          };
        });
      }
    }));
  }))), supplementaryUnits && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Sup Unit'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, supplementaryUnits.map((unit, index) => {
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      key: index,
      label: unit.description,
      name: "supUnit",
      style: {
        fontWeight: 'lighter'
      },
      checked: unit.description.slice(-3, -1) === payload.supUnitType,
      value: unit.description.slice(-3, -1),
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            supUnitType: value
          };
        });
      }
    }));
  })))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    style: {
      justifyContent: 'space-between'
    }
  }, unitPrice && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Unit Price'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, unitPrice.map((unit, index) => {
    let unitPriceValue = unit.description;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      content: unitPriceValue
    }), unit.footNotes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: /*#__PURE__*/React__default["default"].createElement(DataList, {
        data: unit.footNotes
      }),
      style: {
        zIndex: 10000,
        position: 'relative',
        left: '-1rem'
      },
      size: "tiny",
      wide: true,
      trigger: /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          position: 'relative',
          top: '-0.65rem',
          left: '1rem',
          color: '#2d8cd3'
        }
      }, "FootNotes")
    }));
  })))), antiDumpingAdditionalCodes && dutyList && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Divider, {
    style: {
      width: '150%',
      marginLeft: '-0.5rem'
    }
  }), antiDumpingAdditionalCodes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    style: {
      width: '170%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Anti Dumping'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    columns: 2
  }, antiDumpingAdditionalCodes.map((elem, index) => /*#__PURE__*/React__default["default"].createElement(RadioWithPopup, _extends$1({
    key: index
  }, elem, {
    data: payload,
    callback: setPayload,
    valueKey: "antiDumping"
  }))))), controls && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, {
    style: {
      width: '175%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    style: {
      marginLeft: '1rem',
      marginTop: '1rem',
      marginBottom: '-1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement("h3", null, translate('Controls'))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
    columns: 2
  }, controls.map((elem, index) => {
    var _elem$codeDescription, _elem$conditions;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      width: 7,
      style: {
        marginRight: '.5rem',
        marginBottom: '1rem'
      }
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
      label: elem.codeDescription.slice(0, 30),
      name: "controls",
      style: {
        fontWeight: 'lighter'
      },
      checked: elem.codeDescription === payload.controls[0],
      value: elem.codeDescription,
      onChange: (e, {
        value
      }) => {
        setPayload(prev => {
          return {
            ...prev,
            controls: [value, '', '']
          };
        });
      }
    }), ((_elem$codeDescription = elem.codeDescription) === null || _elem$codeDescription === void 0 ? void 0 : _elem$codeDescription.length) > 30 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: elem.codeDescription,
      style: {
        zIndex: 10000,
        position: 'relative',
        left: '-1rem'
      },
      position: "bottom left",
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "add",
        color: "red",
        size: "tiny",
        style: {
          position: 'relative',
          top: '-0.7rem'
        }
      })
    }), elem.footNotes && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: /*#__PURE__*/React__default["default"].createElement(DataList, {
        data: elem.footNotes
      }),
      style: {
        zIndex: 10000,
        position: 'relative',
        left: '-1rem'
      },
      size: "tiny",
      wide: true,
      trigger: /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          position: 'relative',
          top: '-0.65rem',
          left: '3rem',
          color: '#2d8cd3'
        }
      }, "FootNotes")
    }), elem.conditions && ((_elem$conditions = elem.conditions) === null || _elem$conditions === void 0 ? void 0 : _elem$conditions.map((condition, index) => {
      var _condition$items;
      return /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          marginLeft: '2rem'
        }
      }, /*#__PURE__*/React__default["default"].createElement("h4", null, condition.conditionDescription), !!condition.items && ((_condition$items = condition.items) === null || _condition$items === void 0 ? void 0 : _condition$items.map((item, index) => {
        var _item$action$certific, _item$action, _item$action2, _item$action2$certifi, _item$action$certific2;
        let popupContent = item.action.amount ? ((_item$action$certific = item.action.certificate) === null || _item$action$certific === void 0 ? void 0 : _item$action$certific.description) + 'Amount: ' + ((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.amount) : (_item$action2 = item.action) === null || _item$action2 === void 0 ? void 0 : (_item$action2$certifi = _item$action2.certificate) === null || _item$action2$certifi === void 0 ? void 0 : _item$action2$certifi.description;
        return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, {
          columns: 1
        }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
          label: item.action.description,
          name: "condition1",
          style: {
            fontWeight: 'lighter'
          },
          checked: elem.codeDescription === payload.controls[0] && item.action.description + index === payload.controls[1],
          value: [elem.codeDescription, item.action.description + index, ''],
          onChange: (e, {
            value
          }) => {
            setPayload(prev => {
              return {
                ...prev,
                controls: value
              };
            });
          }
        }), item.action.certificate ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
          label: `${item.action.certificate.description.slice(0, 40)}- ${item.action.certificate.code}`,
          name: "condition2",
          style: {
            fontWeight: 'lighter',
            marginLeft: '1rem'
          },
          checked: elem.codeDescription === payload.controls[0] && item.action.description + index === payload.controls[1] && item.action.certificate.code === payload.controls[2],
          value: [elem.codeDescription, item.action.description + index, item.action.certificate.code],
          onChange: (e, {
            value
          }) => {
            setPayload(prev => {
              return {
                ...prev,
                controls: value
              };
            });
          }
        }), ((_item$action$certific2 = item.action.certificate.description) === null || _item$action$certific2 === void 0 ? void 0 : _item$action$certific2.length) > 30 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
          content: popupContent,
          style: {
            zIndex: 10000,
            position: 'relative',
            left: '-1rem'
          },
          position: "bottom left",
          trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
            name: "add",
            color: "red",
            size: "tiny",
            style: {
              position: 'relative',
              top: '0.5rem'
            }
          })
        })) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Row, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Radio, {
          label: item.action.amount,
          name: "condition2",
          style: {
            fontWeight: 'lighter',
            marginLeft: '1rem'
          },
          checked: elem.codeDescription === payload.controls[0] && item.action.description + index === payload.controls[1] && payload.controls[2] === null,
          value: [elem.codeDescription, item.action.description + index, null],
          onChange: (e, {
            value
          }) => {
            setPayload(prev => {
              return {
                ...prev,
                controls: value
              };
            });
          }
        }))));
      })));
    })));
  })))))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    basic: true,
    color: "blue",
    onClick: () => {
      setShowModal(false);
    }
  }, translate('CANCEL')), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    primary: true,
    loading: loading,
    disabled: isEmpty_1(htsMetaData) || (htsMetaData === null || htsMetaData === void 0 ? void 0 : (_htsMetaData$rest2 = htsMetaData.rest) === null || _htsMetaData$rest2 === void 0 ? void 0 : _htsMetaData$rest2.code) === 400,
    onClick: () => {
      handleSubmit();
    }
  }, translate('SUBMIT'))));
};
ESHtsMetaDataModal.defaultProps = {
  translate: value => value
};
var ESHtsMetaDataModal$1 = /*#__PURE__*/React__default["default"].memo(ESHtsMetaDataModal);

const CommodityField = ({
  id,
  translate,
  isFormDisabled,
  serviceType,
  isImportShipment,
  commodityCode,
  preferences,
  reduction,
  htsCode,
  taricCode,
  htsWidth,
  htsBoxNumber,
  label,
  taricWidth,
  taricBoxNumber,
  merchandiseId,
  invoiceId,
  onTaricChange,
  onHtsChange,
  onHtsPopupChange,
  onBlur,
  errors,
  addError,
  showModal,
  setShowModal,
  taricLabel = '',
  countryOfOrigin,
  destinationCountry,
  submit,
  htsEnabled = true,
  version
}) => {
  const country = window.shipmentCountry;
  let language = instance.language || window.localStorage.i18nextLng || 'en';
  const [showhtspopup, setshowhtspopup] = React$1.useState(false);
  const [htsLength, setHtsLength] = React$1.useState((htsCode === null || htsCode === void 0 ? void 0 : htsCode.length) || 0);
  const [htsMetaData, setHtsMetaData] = React$1.useState({});
  const [showModalLoader, setShowModalLoader] = React$1.useState(false);
  const htsInputRef = React$1.useRef(null);
  const taricInputRef = React$1.useRef(null);
  const HTS_LENGTH = 8;
  React$1.useEffect(() => {
    var _taricInputRef$curren;
    if (document.activeElement === htsInputRef.current && htsLength >= HTS_LENGTH) (_taricInputRef$curren = taricInputRef.current) === null || _taricInputRef$curren === void 0 ? void 0 : _taricInputRef$curren.focus();
    return () => {
      var _taricInputRef$curren2;
      (_taricInputRef$curren2 = taricInputRef.current) === null || _taricInputRef$curren2 === void 0 ? void 0 : _taricInputRef$curren2.blur();
    };
  }, [htsLength]);
  const hidehtspopup = () => {
    setshowhtspopup(false);
  };
  const createBoxNumber = () => {
    if (taricBoxNumber) {
      return `${htsBoxNumber} , ${taricBoxNumber}`;
    } else {
      return htsBoxNumber;
    }
  };
  const createLabelName = () => {
    if (taricBoxNumber) {
      return 'HTS / TARIC_CODE';
    } else {
      return 'HTS CODE';
    }
  };
  const setHts = React$1.useCallback(commodityCode => {
    if (htsEnabled) {
      if (serviceType == 'EX' && commodityCode.length == 8 || serviceType == 'IM' && commodityCode.length == 10) {
        getHtsMetaData(commodityCode, serviceType, countryOfOrigin, destinationCountry, country, language).then(response => {
          var _response$data, _response$data2, _response$data2$event;
          setHtsMetaData(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.eventMessage);
          setShowModalLoader(false);
          setShowModal(true);
          if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$event = _response$data2.eventMessage) === null || _response$data2$event === void 0 ? void 0 : _response$data2$event.htsCodeValidity) === 2) {
            var _response$data3;
            setHtsMetaData(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.eventMessage);
            addError && addError();
          }
        }).catch(error => {
          setShowModal(false);
          setShowModalLoader(false);
          console.log({
            error
          });
          showToast('Sorry !! Error Occured! Please try again.');
        });
      }
    }
  }, [countryOfOrigin, destinationCountry]);
  const getURL = () => {
    let url = '';
    if (serviceType === 'IM') {
      if (countryOfOrigin) {
        url = `https://www.trade-tariff.service.gov.uk/commodities/${htsCode.replace(/\./g, '')}?country=${countryOfOrigin}#import`;
      } else {
        url = `https://www.trade-tariff.service.gov.uk/commodities/${htsCode.replace(/\./g, '')}`;
      }
    } else {
      let code = htsCode.slice(0, 4);
      url = `https://www.trade-tariff.service.gov.uk/headings/${code}`;
    }
    return url;
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: country === 'GB' ? htsWidth + taricWidth : htsWidth
    // width={htsWidth}
    ,
    className: `${!version && 'divFormFeild'} b-rw-0`,
    style: {
      position: 'relative'
    }
  }, ' ', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, htsEnabled && country === 'ES' ? /*#__PURE__*/React__default["default"].createElement(ESHtsMetaDataModal$1, {
    showModal: showModal,
    setShowModal: setShowModal,
    submit: submit,
    htsMetaData: htsMetaData,
    taricCode: commodityCode,
    translate: translate
  }) : htsEnabled && /*#__PURE__*/React__default["default"].createElement(HtsMetadataModal, {
    translate: translate,
    key: "htsMeta",
    shipmentId: window.shipmentId,
    showModal: showModal,
    setShowModal: setShowModal,
    htsMetaData: htsMetaData,
    submit: submit,
    preferences: preferences,
    reduction: reduction
  }), htsEnabled && /*#__PURE__*/React__default["default"].createElement(ModalLoader, {
    loading: showModalLoader
  }), /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    isLabel: false,
    id: id ? id : `HTSCode-${invoiceId}-${merchandiseId}`,
    type: "text",
    tabIndex: "0",
    mandatory: false,
    maxlength: country != 'GB' ? HTS_LENGTH : country == 'GB' && serviceType == 'IM' ? 10 : 8,
    boxNumber: country != 'GB' ? htsBoxNumber : createBoxNumber(),
    label: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(PopUpIcon$1, {
      icon: "info circle",
      popupText: `Commodity code field requires "Country of Origin"/"Country of Export" and "Country of Destination".`
    }), /*#__PURE__*/React__default["default"].createElement(CopyLabelWithIcon$1, {
      label: translate(country != 'GB' ? label : createLabelName()),
      fieldInfo: htsCode
    }), country === 'GB' && htsCode && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        style: {
          cursor: 'pointer'
        },
        color: "blue",
        name: "external alternate",
        onClick: () => {
          window.open(getURL());
        }
      }),
      position: "top center",
      content: 'Go to Tariff Details'
    })),
    errors: errors,
    value: htsCode,
    className: 'field-bg',
    clearInput: false,
    innerRef: htsInputRef,
    disabled: isFormDisabled,
    onChange: value => {
      setshowhtspopup(true);
      setHtsLength(value.length);
      onHtsChange(value);
    },
    onBlur: value => {
      onBlur({
        htsCode: value
      });
      if (serviceType === 'EX' && htsEnabled) {
        value.length >= 8 && country !== 'GB' && (setShowModalLoader(true), setHts(commodityCode), setshowhtspopup(false));
      }
    }
  }), showhtspopup && /*#__PURE__*/React__default["default"].createElement(HTSCodePopup, {
    country: country,
    disabled: isFormDisabled,
    shipmentType: serviceType,
    code: commodityCode,
    mapCode: commodityCode,
    hidehtspopup: hidehtspopup,
    callbackwhenChanged: value => {
      var _value;
      value = (_value = value) === null || _value === void 0 ? void 0 : _value.replaceAll('.', '');
      let hts = value.length > 8 ? value.slice(0, 8) : value;
      let taric = value.length > 8 ? value.slice(8) : '';
      let commodity = hts + taric;
      onHtsPopupChange({
        htsCode: hts,
        taricCode: taric,
        commodityCode: commodity
      });
      htsEnabled && country !== 'GB' && ((serviceType == 'EX' && value.length === 8 && setShowModalLoader(true), setHts(commodity)) || (serviceType == 'IM' && value.length === 10 && setShowModalLoader(true), setHts(commodity)));
    }
  }))), isImportShipment && taricWidth && country != 'GB' && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
    width: taricWidth,
    className: `${!version && 'divFormFeild taricCode'} b-rw-0 b-lw-0`
  }, /*#__PURE__*/React__default["default"].createElement(InputField$1, {
    label: taricLabel,
    isLabel: false,
    id: `taricCode-${invoiceId}-${merchandiseId}`,
    type: "text",
    boxNumber: taricBoxNumber,
    tabIndex: "0",
    mandatory: false,
    maxlength: "2",
    value: taricCode,
    innerRef: taricInputRef
    // autoFocus={htsLength >= 8 && true}
    ,
    className: 'field-bg half-border',
    clearInput: false,
    disabled: isImportShipment ? isFormDisabled : true,
    onChange: value => {
      setshowhtspopup(true);
      onTaricChange(value);
    },
    onBlur: value => {
      onBlur({
        taricCode: value
      });
      htsEnabled && country !== 'GB' && commodityCode.length >= 10 && (setShowModalLoader(true), setHts(commodityCode));
      value.length >= 2 && setshowhtspopup(false);
    }
  })));
};
CommodityField.defaultProps = {
  htsWidth: '3',
  htsBoxNumber: '33.1',
  taricWidth: '1',
  label: 'HTS_CODE',
  taricBoxNumber: '33.2'
};

const ToggleContext = /*#__PURE__*/React$1.createContext();
const reducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_ALL":
      return {
        ...state,
        ...action.ids
      };
    case "TOGGLE_BY_ID":
      const {
        id
      } = action;
      return {
        ...state,
        [`${id}`]: !state[id]
      };
    default:
      throw new Error();
  }
};
const Accordion = ({
  children,
  initialiState = {}
}) => {
  const [state, dispatch] = React__default["default"].useReducer(reducer, initialiState);
  const translate = React__default["default"].useContext(TranslateContext).translate;
  const ToggleAccordion = React$1.useCallback(value => {
    const state = {};
    React$1.Children.toArray(children).forEach(({
      props
    } = item) => {
      if (!props.id && props.children) {
        React$1.Children.toArray(props.children).forEach(({
          props
        } = item) => {
          state[props.id] = value;
        });
      } else {
        if (props.id) state[props.id] = value;
      }
    });
    dispatch({
      type: "TOGGLE_ALL",
      ids: state
    });
  }, [children.length]);
  const isAllExpanded = React$1.useMemo(() => {
    const values = Object.values(state);
    const ExpandedList = values.length == 0 ? false : values.every(c => c);
    return ExpandedList;
  }, [state]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "kn__accordion"
  }, /*#__PURE__*/React__default["default"].createElement(ToggleContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "action-btns"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    basic: true,
    color: "blue",
    className: "btn-toggle",
    id: "expandCollapseAll",
    onClick: () => ToggleAccordion(!isAllExpanded)
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: `${!isAllExpanded ? "plus" : "minus"} circle`
  }), !isAllExpanded ? translate("EXPAND_ALL") : translate("COLLAPSE_ALL"))), children));
};

const AccordionItem = ({
  title,
  boxNumber,
  rightHeader,
  id,
  children
}) => {
  const {
    state,
    dispatch
  } = React$1.useContext(ToggleContext);
  const toggleValue = state[id];
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: `kn__accordion__item ${!toggleValue ? 'inactive' : ''}`
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "kn__accordion__header"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "titleContainer"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    className: "toggleIcon",
    id: (!toggleValue ? 'inActive-' : 'active-') + `${id}`,
    color: "blue",
    name: `${!toggleValue ? "plus" : "minus"} circle`,
    onClick: () => dispatch({
      type: "TOGGLE_BY_ID",
      id
    })
  }), boxNumber && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "ui black label box-number"
  }, boxNumber), typeof title == "function" ? title({
    isExpanded: toggleValue
  }) : title), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "action-btns"
  }, toggleValue ? rightHeader : null)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "accordion-content"
  }, toggleValue ? children : null, " "));
};

const CommonActorDetailHeader = ({
  title,
  boxNumber,
  isExpanded,
  name,
  errors
}) => {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "actorDetailHeader row"
  }, errors && /*#__PURE__*/React__default["default"].createElement(ErrorPopup, {
    errors: errors
  }), /*#__PURE__*/React__default["default"].createElement(FormTitle, {
    titleContainer: "span",
    title: title,
    boxNumber: boxNumber
  }), !isExpanded && /*#__PURE__*/React__default["default"].createElement("strong", null, "\xA0", name));
};
var CommonActorDetailHeader$1 = /*#__PURE__*/React__default["default"].memo(CommonActorDetailHeader);
const ErrorPopup = ({
  errors
}) => {
  var _errors;
  errors = Array.isArray(errors) ? errors : errors ? [errors] : [];
  if (!((_errors = errors) !== null && _errors !== void 0 && _errors.length)) return '';
  const error = errors.map((info, index) => {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "error",
      key: index
    }, "* ", info);
  });
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
    trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "warning sign",
      color: "red"
    }),
    content: error || ""
  });
};

if (window._env_.REACT_APP_ES_ENV === 'TEST_ENV') {
  ReactDOM.render(/*#__PURE__*/React.createElement("div", {
    id: "pusher"
  }, /*#__PURE__*/React.createElement(ESApp, props)), document.getElementById('es-root'));

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  registerServiceWorker();
}

exports.ACTOR_COPIED_STATUS = ACTOR_COPIED_STATUS$1;
exports.ACTOR_COPIED_STATUS$1 = ACTOR_COPIED_STATUS;
exports.ADD_ADDITONAL_INFO = ADD_ADDITONAL_INFO;
exports.ADD_ADDITONAL_INFO$1 = ADD_ADDITONAL_INFO$1;
exports.ADD_AI_CODES_AND_STATEMENT_INFO = ADD_AI_CODES_AND_STATEMENT_INFO;
exports.ADD_AI_CODES_AND_STATEMENT_INFO$1 = ADD_AI_CODES_AND_STATEMENT_INFO$1;
exports.ADD_CONTAINER_TAB_WARNINGS = ADD_CONTAINER_TAB_WARNINGS;
exports.ADD_HEADER_CONTAINER = ADD_HEADER_CONTAINER;
exports.ADD_HEADER_TAB_WARNINGS = ADD_HEADER_TAB_WARNINGS;
exports.ADD_INVOICE_DOC_BY_ID = ADD_INVOICE_DOC_BY_ID;
exports.ADD_ITEMS_TAB_WARNINGS = ADD_ITEMS_TAB_WARNINGS;
exports.ADD_ITEM_CDS_HEADER = ADD_ITEM_CDS_HEADER;
exports.ADD_ITEM_HEADER = ADD_ITEM_HEADER;
exports.ADD_MERCHANDISE_DOC_BY_ID = ADD_MERCHANDISE_DOC_BY_ID;
exports.ADD_MERCHANDISE_DOC_BY_ID$1 = ADD_MERCHANDISE_DOC_BY_ID$2;
exports.ADD_MERCHANDISE_DOC_BY_ID$2 = ADD_MERCHANDISE_DOC_BY_ID$1;
exports.ADD_MULTIPLE_TAB = ADD_MULTIPLE_TAB$1;
exports.ADD_NOTES_ITEM = ADD_NOTES_ITEM$2;
exports.ADD_NOTES_ITEM$1 = ADD_NOTES_ITEM$3;
exports.ADD_NOTES_ITEM$2 = ADD_NOTES_ITEM$1;
exports.ADD_PARTIES_TAB_WARNINGS = ADD_PARTIES_TAB_WARNINGS;
exports.ADD_VALUEBUILDUP_TAB_WARNINGS = ADD_VALUEBUILDUP_TAB_WARNINGS;
exports.Accordion = Accordion;
exports.AccordionInvoice = AccordionInvoice;
exports.AccordionItem = AccordionItem;
exports.ActionTypes = ActionTypes$2;
exports.ActionTypes$1 = ActionTypes$1;
exports.ActionTypes$2 = ActionTypes;
exports.ActorContext = ActorContext;
exports.AddBtn = AddBtn;
exports.AesStatusMappings = AesStatusMappings;
exports.AutoComplete = AutoComplete$1;
exports.BillingForm = BillingForm;
exports.BillingReducer = BillingReducer;
exports.CLEAR_DROPDOWN = CLEAR_DROPDOWN;
exports.CLEAR_FORM = CLEAR_FORM$2;
exports.CLEAR_FORM$1 = CLEAR_FORM;
exports.COMP_REGIME_CODES = COMP_REGIME_CODES;
exports.CONVERTED_VALUE = CONVERTED_VALUE;
exports.COPY_ACTOR_INFO = COPY_ACTOR_INFO$1;
exports.COPY_ACTOR_INFO$1 = COPY_ACTOR_INFO;
exports.COPY_TO_MASS_UPDATE_CDS = COPY_TO_MASS_UPDATE_CDS;
exports.COUNTRY_ORIGIN = COUNTRY_ORIGIN;
exports.CREATE_INVOICE = CREATE_INVOICE$1;
exports.CREATE_INVOICE$1 = CREATE_INVOICE;
exports.CREATE_ITEM_CONTAINER = CREATE_ITEM_CONTAINER;
exports.CREATE_MERCHANDISE_ITEM = CREATE_MERCHANDISE_ITEM$1;
exports.CREATE_MERCHANDISE_ITEM$1 = CREATE_MERCHANDISE_ITEM;
exports.CURRENCY_CODE = CURRENCY_CODE;
exports.CUSTOMS_VALUE = CUSTOMS_VALUE;
exports.CancelEntryModal = CancelEntryModal;
exports.Choices = Choices;
exports.CommodityField = CommodityField;
exports.CommonActorDetailHeader = CommonActorDetailHeader$1;
exports.CommonActorDetailHeader$1 = CommonActorDetailHeader;
exports.CopyLabelWithIcon = CopyLabelWithIcon$1;
exports.CustomLoader = CustomLoader;
exports.DELETE_ACTOR = DELETE_ACTOR;
exports.DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER = DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER$1;
exports.DELETE_CONTAINER_TAB_WARNINGS = DELETE_CONTAINER_TAB_WARNINGS;
exports.DELETE_ENTITY_ES = DELETE_ENTITY_ES;
exports.DELETE_HEADER_CONTAINER = DELETE_HEADER_CONTAINER;
exports.DELETE_HEADER_TAB_WARNINGS = DELETE_HEADER_TAB_WARNINGS;
exports.DELETE_INVOICE = DELETE_INVOICE$1;
exports.DELETE_INVOICE$1 = DELETE_INVOICE;
exports.DELETE_INVOICE_DOC_BY_ID = DELETE_INVOICE_DOC_BY_ID;
exports.DELETE_ITEMS_TAB_WARNINGS = DELETE_ITEMS_TAB_WARNINGS;
exports.DELETE_ITEM_CDS_HEADER = DELETE_ITEM_CDS_HEADER;
exports.DELETE_ITEM_CONTAINER = DELETE_ITEM_CONTAINER;
exports.DELETE_ITEM_HEADER = DELETE_ITEM_HEADER$1;
exports.DELETE_ITEM_PARTIES_ACTOR = DELETE_ITEM_PARTIES_ACTOR;
exports.DELETE_MERCHANDISE_DOC_BY_ID = DELETE_MERCHANDISE_DOC_BY_ID;
exports.DELETE_MERCHANDISE_DOC_BY_ID$1 = DELETE_MERCHANDISE_DOC_BY_ID$2;
exports.DELETE_MERCHANDISE_DOC_BY_ID$2 = DELETE_MERCHANDISE_DOC_BY_ID$1;
exports.DELETE_MERCHANDISE_ITEM = DELETE_MERCHANDISE_ITEM$1;
exports.DELETE_MERCHANDISE_ITEM$1 = DELETE_MERCHANDISE_ITEM;
exports.DELETE_MULTIPLE_TAB = DELETE_MULTIPLE_TAB$1;
exports.DELETE_NL_ENTITY = DELETE_NL_ENTITY;
exports.DELETE_PARTIES_TAB_WARNINGS = DELETE_PARTIES_TAB_WARNINGS;
exports.DELETE_VALUEBUILDUP_TAB_WARNINGS = DELETE_VALUEBUILDUP_TAB_WARNINGS;
exports.DatePicker = DatePicker;
exports.DeleteIcon = DeleteIcon$1;
exports.DisplayErrorServer = DisplayErrorServer;
exports.DropDown = DropDown;
exports.DropDown$1 = DropDown$2;
exports.DropDown$2 = DropDown$1;
exports.DutyMenuItems = DutyMenuItems;
exports.EUAcknowledgementPage = EUAcknowledgementPage$1;
exports.EUApp = EUApp$1;
exports.EUHeader = EUHeader;
exports.ErrorBoundary = ErrorBoundary;
exports.ErrorMessage = ErrorMessage;
exports.ErrorMessagesWindow = ErrorMessagesWindow;
exports.FORM_VALUES = FORM_VALUES;
exports.FORM_VALUES$1 = FORM_VALUES$1;
exports.FormTitle = FormTitle;
exports.GET_MOCK_RESPONSE = GET_MOCK_RESPONSE;
exports.GET_SHIPMENT_NOTES = GET_SHIPMENT_NOTES$1;
exports.GOODS_DESCRIPTION = GOODS_DESCRIPTION;
exports.GROSS_WEIGHT = GROSS_WEIGHT;
exports.HttpClient = HttpClient;
exports.HttpClient$1 = HttpClient$1;
exports.INCO_TERMS = INCO_TERMS;
exports.INITIALIZE_DROPDOWNS = INITIALIZE_DROPDOWNS$1;
exports.INITIALIZE_DROPDOWNS$1 = INITIALIZE_DROPDOWNS$2;
exports.INITIALIZE_HEADER_FORM = INITIALIZE_HEADER_FORM$2;
exports.INITIALIZE_HEADER_FORM$1 = INITIALIZE_HEADER_FORM;
exports.INITIALIZE_ITEMS_FORM = INITIALIZE_ITEMS_FORM$1;
exports.INITIALIZE_ITEMS_FORM$1 = INITIALIZE_ITEMS_FORM;
exports.INITIALIZE_PARTIES_FORM = INITIALIZE_PARTIES_FORM$1;
exports.INITIALIZE_PARTIES_FORM$1 = INITIALIZE_PARTIES_FORM;
exports.INITIALIZE_VALUES_NOTES = INITIALIZE_VALUES_NOTES;
exports.INITIALIZE_VALUES_NOTES$1 = INITIALIZE_VALUES_NOTES$1;
exports.INITIALIZE_VALUE_BUILD_UP_FORM = INITIALIZE_VALUE_BUILD_UP_FORM;
exports.INIT_CONTAINER_TAB_WARNINGS = INIT_CONTAINER_TAB_WARNINGS;
exports.INIT_HEADER_TAB_WARNINGS = INIT_HEADER_TAB_WARNINGS;
exports.INIT_ITEMS_TAB_WARNINGS = INIT_ITEMS_TAB_WARNINGS;
exports.INIT_PARTIES_TAB_WARNINGS = INIT_PARTIES_TAB_WARNINGS;
exports.INIT_VALIDATION_ERRORS = INIT_VALIDATION_ERRORS$1;
exports.INIT_VALUEBUILDUP_TAB_WARNINGS = INIT_VALUEBUILDUP_TAB_WARNINGS;
exports.INVOICE_NUMBER = INVOICE_NUMBER;
exports.InputField = InputField$1;
exports.InputField$1 = InputField$2;
exports.InputField$2 = InputField;
exports.InvoiceToggleContext = InvoiceToggleContext;
exports.List = List$1;
exports.LoaderPopup = LoaderPopup;
exports.LongText = LongText;
exports.MASS_UPDATE_AT_INVOICE_LEVEL = MASS_UPDATE_AT_INVOICE_LEVEL;
exports.MASS_UPDATE_FOR_MULTIPLE_INVOICE = MASS_UPDATE_FOR_MULTIPLE_INVOICE;
exports.MASS_UPDATE_REPEATABLE_ELEMENTS = MASS_UPDATE_REPEATABLE_ELEMENTS$1;
exports.MASS_UPDATE_REPEATABLE_ELEMENTS$1 = MASS_UPDATE_REPEATABLE_ELEMENTS;
exports.MOCK_AES = MOCK_AES;
exports.MOCK_BOX_40 = MOCK_BOX_40;
exports.MOCK_BOX_44 = MOCK_BOX_44;
exports.MOCK_CANCEL = MOCK_CANCEL;
exports.MOCK_EXPORT_TYPE = MOCK_EXPORT_TYPE;
exports.MOCK_FULL_SAD = MOCK_FULL_SAD;
exports.MOCK_PDC = MOCK_PDC;
exports.MOCK_PDC_AMEND = MOCK_PDC_AMEND;
exports.ModalLoader = ModalLoader;
exports.ModeOfPayment = ModeOfPayment;
exports.NET_MASS = NET_MASS;
exports.PKG_COUNT = PKG_COUNT;
exports.PKG_TYPE = PKG_TYPE;
exports.PREFERENCE = PREFERENCE;
exports.PopUpIcon = PopUpIcon$1;
exports.Provider = Provider;
exports.QUOTA = QUOTA;
exports.RATE = RATE;
exports.REDUCTION = REDUCTION;
exports.REGIME_CODE = REGIME_CODE;
exports.RubberBindingInfoProvider = RubberBindingInfoProvider;
exports.SAVE_C88_ITEM = SAVE_C88_ITEM;
exports.SAVE_FORM_ES = SAVE_FORM_ES;
exports.SAVE_FORM_NL = SAVE_FORM_NL;
exports.SAVE_INVOICE_DATA = SAVE_INVOICE_DATA$1;
exports.SAVE_ITEM_ES = SAVE_ITEM_ES;
exports.SAVE_SHIPMENT_NOTES = SAVE_SHIPMENT_NOTES$1;
exports.SAVE_SHIPMENT_NOTES$1 = SAVE_SHIPMENT_NOTES;
exports.SET_ERROR_MESSAGE = SET_ERROR_MESSAGE;
exports.SET_ERROR_MESSAGE$1 = SET_ERROR_MESSAGE$1;
exports.STAT_VALUE = STAT_VALUE;
exports.SUP_UNIT_COUNT = SUP_UNIT_COUNT;
exports.SearchPort = SearchPort;
exports.SetDeleteEvent = SetDeleteEvent;
exports.SetSaveEvent = SetSaveEvent;
exports.ShipmentInfoContext = ShipmentInfoContext;
exports.ShipmentInfoProvider = ShipmentInfoProvider;
exports.TAXABLE_BASE = TAXABLE_BASE;
exports.TAX_TYPE = TAX_TYPE;
exports.Tab = Tab;
exports.TabItem = TabItem;
exports.ToggleInvoices = ToggleInvoices$1;
exports.TranslateContext = TranslateContext;
exports.TranslateContextProvider = TranslateContextProvider;
exports.UPDATE_ACTOR_CONTACT_INFO = UPDATE_ACTOR_CONTACT_INFO$1;
exports.UPDATE_ACTOR_CONTACT_INFO$1 = UPDATE_ACTOR_CONTACT_INFO;
exports.UPDATE_ACTOR_FIELD_VALUE = UPDATE_ACTOR_FIELD_VALUE$1;
exports.UPDATE_ACTOR_FIELD_VALUE$1 = UPDATE_ACTOR_FIELD_VALUE;
exports.UPDATE_AFTER_SAVE = UPDATE_AFTER_SAVE;
exports.UPDATE_AI_STATEMENT_INFO_FIELDS = UPDATE_AI_STATEMENT_INFO_FIELDS;
exports.UPDATE_AI_STATEMENT_INFO_FIELDS$1 = UPDATE_AI_STATEMENT_INFO_FIELDS$1;
exports.UPDATE_ARRIVAL_TRANSPORT_FIELDS = UPDATE_ARRIVAL_TRANSPORT_FIELDS;
exports.UPDATE_DAFFERED_PAYMENT = UPDATE_DAFFERED_PAYMENT;
exports.UPDATE_DELIVERY_TRANSPORT_FIELDS = UPDATE_DELIVERY_TRANSPORT_FIELDS;
exports.UPDATE_DROPDOWNS = UPDATE_DROPDOWNS;
exports.UPDATE_EIDR_EORI_NUMBER = UPDATE_EIDR_EORI_NUMBER;
exports.UPDATE_EXCHANGE_RATE_AND_EUR_VAL = UPDATE_EXCHANGE_RATE_AND_EUR_VAL;
exports.UPDATE_EXPORTER_FOR_ALL_INVOICES = UPDATE_EXPORTER_FOR_ALL_INVOICES;
exports.UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER = UPDATE_EXPORTER_FOR_MULTIPLE_EXPORTER;
exports.UPDATE_HEADER_CONTAINER = UPDATE_HEADER_CONTAINER;
exports.UPDATE_INPUT_FILEDS = UPDATE_INPUT_FILEDS;
exports.UPDATE_INVOICE_DATA = UPDATE_INVOICE_DATA;
exports.UPDATE_INVOICE_DOC_BY_ID = UPDATE_INVOICE_DOC_BY_ID;
exports.UPDATE_INVOICE_HEADER = UPDATE_INVOICE_HEADER;
exports.UPDATE_INVOICE_HEADER_VALUE = UPDATE_INVOICE_HEADER_VALUE;
exports.UPDATE_ITEM_ACTOR_FIELD_VALUE = UPDATE_ITEM_ACTOR_FIELD_VALUE;
exports.UPDATE_ITEM_CDS_HEADER = UPDATE_ITEM_CDS_HEADER;
exports.UPDATE_ITEM_FIELD_VALUE = UPDATE_ITEM_FIELD_VALUE;
exports.UPDATE_ITEM_HEADER = UPDATE_ITEM_HEADER$1;
exports.UPDATE_MERCHANDISE_AFTER_SAVE = UPDATE_MERCHANDISE_AFTER_SAVE;
exports.UPDATE_MERCHANDISE_DOC_BY_ID = UPDATE_MERCHANDISE_DOC_BY_ID;
exports.UPDATE_MERCHANDISE_DOC_BY_ID$1 = UPDATE_MERCHANDISE_DOC_BY_ID$2;
exports.UPDATE_MERCHANDISE_DOC_BY_ID$2 = UPDATE_MERCHANDISE_DOC_BY_ID$1;
exports.UPDATE_MERCHANDISE_ITEM_BY_ID = UPDATE_MERCHANDISE_ITEM_BY_ID;
exports.UPDATE_MERCH_DATA = UPDATE_MERCH_DATA;
exports.UPDATE_MULTIPLE_TAB_VALUE = UPDATE_MULTIPLE_TAB_VALUE$1;
exports.UPDATE_NOTES_ITEM_STATUS = UPDATE_NOTES_ITEM_STATUS$2;
exports.UPDATE_NOTES_ITEM_STATUS$1 = UPDATE_NOTES_ITEM_STATUS$3;
exports.UPDATE_NOTES_ITEM_STATUS$2 = UPDATE_NOTES_ITEM_STATUS$1;
exports.UPDATE_SHIPMENT_FIELD_VALUE = UPDATE_SHIPMENT_FIELD_VALUE$2;
exports.UPDATE_SHIPMENT_FIELD_VALUE$1 = UPDATE_SHIPMENT_FIELD_VALUE;
exports.UPDATE_TRANSPORT_DETAILS = UPDATE_TRANSPORT_DETAILS$2;
exports.UPDATE_TRANSPORT_DETAILS$1 = UPDATE_TRANSPORT_DETAILS;
exports.UPDATE_TRANSPORT_HEADER_INFO = UPDATE_TRANSPORT_HEADER_INFO$2;
exports.UPDATE_TRANSPORT_HEADER_INFO$1 = UPDATE_TRANSPORT_HEADER_INFO;
exports.UPDATE_VALIDATION_ERRORS = UPDATE_VALIDATION_ERRORS;
exports._extends = _extends$1;
exports._root = _root;
exports.actorActions = actorActions$1;
exports.actorActions$1 = actorActions;
exports.actorNames = actorNames;
exports.addItemHeader = addItemHeader;
exports.addItemsTabWarnings = addItemsTabWarnings;
exports.addNotesItem = addNotesItem;
exports.addPartiesTabWarnings = addPartiesTabWarnings;
exports.addShipmentRow = addShipmentRow;
exports.amendReasonValues = amendReasonValues;
exports.bhSurrender = bhSurrender;
exports.blockDecimal = blockDecimal;
exports.canUserFile = canUserFile;
exports.cancelReasonValues = cancelReasonValues;
exports.chooseDateAndTime = chooseDateAndTime;
exports.clearForm = clearForm$2;
exports.collapseLineItems = collapseLineItems;
exports.commonjsGlobal = commonjsGlobal;
exports.configuration = configuration;
exports.connect = connect;
exports.containerTabActions = containerTabActions$1;
exports.containerTabActions$1 = containerTabActions;
exports.convertDateToUTC = convertDateToUTC;
exports.convertDateToUTCEpoch = convertDateToUTCEpoch;
exports.convertEpochToUTC = convertEpochToUTC;
exports.convertedDataItemsTab = convertedDataItemsTab$1;
exports.createCommonjsModule = createCommonjsModule;
exports.createContainerAtLineLevel = createContainerAtLineLevel;
exports.createCostType = createCostType;
exports.createErrorMsgStructure = createErrorMsgStructure;
exports.createGauranteeInfo = createGauranteeInfo;
exports.createInvoiceItem = createInvoiceItem;
exports.createLineItem = createLineItem;
exports.createLineItemDuty = createLineItemDuty;
exports.createSpecialMentionLineItemInfo = createSpecialMentionLineItemInfo;
exports.createSupportingDocsInfo = createSupportingDocsInfo;
exports.createValidationStructure = createValidationStructure;
exports.customFunction = customFunction;
exports.dateString = dateString;
exports.deleteCostType = deleteCostType;
exports.deleteGuaranteeInfo = deleteGuaranteeInfo;
exports.deleteItemHeader = deleteItemHeader;
exports.deleteItemsTabWarnings = deleteItemsTabWarnings;
exports.deletePartiesTabWarnings = deletePartiesTabWarnings;
exports.deleteShipmentRow = deleteShipmentRow;
exports.expandAllLineItem = expandAllLineItem;
exports.expandLineItem = expandLineItem;
exports.expandLineItems = expandLineItems;
exports.extractFileNameFromUrl = extractFileNameFromUrl;
exports.fileJob = fileJob;
exports.formatDate = formatDate;
exports.generatePDF = generatePDF;
exports.generatePdfManually = generatePdfManually;
exports.genrateDV1FormPDF = genrateDV1FormPDF;
exports.getArtNumByHTSCode = getArtNumByHTSCode;
exports.getDeclarationStatusApi = getDeclarationStatusApi;
exports.getDocumentsType = getDocumentsType;
exports.getDropDownInputText = getDropDownInputText;
exports.getDropdownValues = getDropdownValues;
exports.getEntryStateChecks = getEntryStateChecks;
exports.getFormData = getFormData;
exports.getHistoryDocuments = getHistoryDocuments;
exports.getJobStates = getJobStates;
exports.getJobWheels = getJobWheels;
exports.getShipmentDocuments = getShipmentDocuments;
exports.getShipmentNotes = getShipmentNotes$1;
exports.getShipmentNotes$1 = getShipmentNotes;
exports.getSignedUrls = getSignedUrls;
exports.getStatus = getStatus;
exports.getSum = getSum;
exports.getValidationError = getValidationError$1;
exports.getWarehouseDetails = getWarehouseDetails;
exports.get_1 = get_1;
exports.getsearchcDropdownValuesNL = getsearchcDropdownValuesNL;
exports.groupDocumentsByType = groupDocumentsByType;
exports.holdTheShipment = holdTheShipment;
exports.initServerErrors = initServerErrors;
exports.initalizeActorValues = initalizeActorValues;
exports.initializeAllValues = initializeAllValues;
exports.initializeDropDownValues = initializeDropDownValues;
exports.initializeDropDownValues$1 = initializeDropDownValues$1;
exports.initializeErrors = initializeErrors$1;
exports.initializeErrors$1 = initializeErrors;
exports.initializeFormLoaded = initializeFormLoaded;
exports.initializeFormValues = initializeFormValues;
exports.initializeHeaderForm = initializeHeaderForm$1;
exports.initializeShipmentNotes = initializeShipmentNotes;
exports.initializeValueBuildUp = initializeValueBuildUp;
exports.initializeValuesBroker = initializeValuesBroker;
exports.initializeValuesConsignee = initializeValuesConsignee;
exports.initializeValuesConsignor = initializeValuesConsignor;
exports.initializeValuesInvoice = initializeValuesInvoice;
exports.initializeValuesShipment = initializeValuesShipment;
exports.intializeItemsTabWarnings = intializeItemsTabWarnings;
exports.isEmpty_1 = isEmpty_1;
exports.isObject_1 = isObject_1;
exports.isOperator = isOperator;
exports.isShipmentDisabled = isShipmentDisabled;
exports.isSymbol_1 = isSymbol_1;
exports.itemActions = itemActions$1;
exports.itemActions$1 = itemActions;
exports.lodash = lodash;
exports.lodash_2 = lodash_2;
exports.lodash_3 = lodash_3;
exports.moment = moment;
exports.prorateCostType = prorateCostType;
exports.removeContainer = removeContainer;
exports.removeContainerItem = removeContainerItem;
exports.removeInvoiceLineItem = removeInvoiceLineItem;
exports.removeLineItem = removeLineItem;
exports.removeLineItemDuty = removeLineItemDuty;
exports.removeSupportingDocLineInfo = removeSupportingDocLineInfo;
exports.resetForm = resetForm$1;
exports.resetForm$1 = resetForm;
exports.resetServerError = resetServerError$1;
exports.resetServerError$1 = resetServerError;
exports.resetServerErrors = resetServerErrors;
exports.restrictDecimal = restrictDecimal;
exports.retryJob = retryJob;
exports.reviewJob = reviewJob;
exports.roundToTwo = roundToTwo;
exports.saveActorDetails = saveActorDetails;
exports.saveContainerHeader = saveContainerHeader;
exports.saveContainerLineItemFeild = saveContainerLineItemFeild;
exports.saveCostTypeField = saveCostTypeField;
exports.saveGuaranteeInfoFeild = saveGuaranteeInfoFeild;
exports.saveInvoiceLineItemFeild = saveInvoiceLineItemFeild;
exports.saveLineItemFeild = saveLineItemFeild;
exports.saveNotes = saveNotes;
exports.savePartyDependency = savePartyDependency;
exports.saveShipmentDutyValue = saveShipmentDutyValue;
exports.saveShipmentFieldValue = saveShipmentFieldValue;
exports.saveValueBuildUpField = saveValueBuildUpField;
exports.sendMsgToRocketChat = sendMsgToRocketChat;
exports.setErrorMessage = setErrorMessage;
exports.setServerErrors = setServerErrors;
exports.showToast = showToast$1;
exports.showToast$1 = showToast;
exports.startBhHouseJob = startBhHouseJob;
exports.startJob = startJob;
exports.store = store$1;
exports.store$1 = store$2;
exports.store$2 = store;
exports.store$3 = store$3;
exports.styleInject = styleInject;
exports.taricDuty = taricDuty;
exports.transportTabActions = transportTabActions$1;
exports.transportTabActions$1 = transportTabActions;
exports.unwrapExports = unwrapExports;
exports.updateActorFieldValue = updateActorFieldValue;
exports.updateContainer = updateContainer;
exports.updateContainerLineItemFeild = updateContainerLineItemFeild;
exports.updateCostType = updateCostType;
exports.updateGuaranteeInfoFeild = updateGuaranteeInfoFeild;
exports.updateInvoiceLineItemFeild = updateInvoiceLineItemFeild;
exports.updateItemHeader = updateItemHeader;
exports.updateLineItemFeild = updateLineItemFeild;
exports.updateShipmentCountry = updateShipmentCountry;
exports.updateShipmentDuty = updateShipmentDuty;
exports.updateShipmentFieldValue = updateShipmentFieldValue$1;
exports.updateShipmentFieldValue$1 = updateShipmentFieldValue$2;
exports.updateShipmentFieldValue$2 = updateShipmentFieldValue;
exports.updateShipmentRow = updateShipmentRow;
exports.updateValidationErrors = updateValidationErrors$1;
exports.updateValidationErrors$1 = updateValidationErrors;
exports.updateValueBuildUp = updateValueBuildUp;
exports.updateWorkFlow = updateWorkFlow;
exports.uploadDcoumentToHRMC = uploadDcoumentToHRMC;
exports.useCurrentShipmentType = useCurrentShipmentType;
exports.useDispatch = useDispatch;
exports.useForm = useForm;
exports.useHttp = useHttp;
exports.usePdiEnable = usePdiEnable;
exports.useSelector = useSelector;
exports.useTranslation = useTranslation;
exports.useUpdateEffect = useUpdateEffect;
exports.validate = validate;
exports.validateArray = validateArray;
exports.validateArrayCustom = validateArrayCustom;
exports.validateError = validateError;
exports.validation = validation;
exports.validationPatterns = validationPatterns;
//# sourceMappingURL=index-012e579f.js.map
